export interface ISpecFields {
    id: number;
    type: string;
    name: string;
    description?: string;
    abbrName?: string;
    added?: string;
    addedEP?: string;
    updated?: string;
    updatedEP?: string;
    deprecated?: string;
    deprecatedEP?: string;
    baseCategory?: string;
    baseCategoryAbbrName?: string;
    unionDataType?: string;
    lengthId?: string;
    discriminatorId?: string;
}
const batch1: ISpecFields[] = [
    {
        name: 'Account',
        abbrName: 'Acct',
        added: 'FIX.2.7',
        type: 'String',
        id: 1,
        description:
            'Account mnemonic as agreed between buy and sell sides, e.g. broker and institution or investor/intermediary and fund manager.',
    },
    {
        name: 'AdvId',
        abbrName: 'AdvId',
        added: 'FIX.2.7',
        type: 'String',
        id: 2,
        description: 'Unique identifier of advertisement message.\n\n(Prior to FIX 4.1 this field was of type int)',
    },
    {
        name: 'AdvRefID',
        abbrName: 'AdvRefID',
        added: 'FIX.2.7',
        type: 'String',
        id: 3,
        description:
            'Reference identifier used with CANCEL and REPLACE transaction types.\n\n(Prior to FIX 4.1 this field was of type int)',
    },
    {
        name: 'AdvSide',
        abbrName: 'AdvSide',
        added: 'FIX.2.7',
        type: 'AdvSideCodeSet',
        id: 4,
        description: "Broker's side of advertised trade",
    },
    {
        name: 'AdvTransType',
        abbrName: 'AdvTransTyp',
        added: 'FIX.2.7',
        type: 'AdvTransTypeCodeSet',
        id: 5,
        description: 'Identifies advertisement message transaction type',
    },
    {
        name: 'AvgPx',
        abbrName: 'AvgPx',
        added: 'FIX.2.7',
        type: 'Price',
        id: 6,
        description:
            'Calculated average price of all fills on this order.\n\nFor Fixed Income trades AvgPx is always expressed as percent-of-par, regardless of the PriceType (423) of LastPx (31). I.e., AvgPx will contain an average of percent-of-par values (see LastParPx (669)) for issues traded in Yield, Spread or Discount.',
    },
    {
        name: 'BeginSeqNo',
        abbrName: 'BeginSeqNo',
        added: 'FIX.2.7',
        type: 'SeqNum',
        id: 7,
        description: 'Message sequence number of first message in range to be resent',
    },
    {
        name: 'BeginString',
        abbrName: 'BeginString',
        updated: 'FIX.Latest',
        added: 'FIX.2.7',
        type: 'BeginStringCodeSet',
        updatedEP: '270',
        id: 8,
        description:
            'Identifies beginning of new message and session protocol version by means of a session profile identifier (see FIX Session Layer for details). ALWAYS FIRST FIELD IN MESSAGE. (Always unencrypted).',
    },
    {
        name: 'BodyLength',
        abbrName: 'BodyLength',
        added: 'FIX.2.7',
        type: 'Length',
        id: 9,
        description:
            'Message length, in bytes, forward to the CheckSum field. ALWAYS SECOND FIELD IN MESSAGE. (Always unencrypted)',
    },
    {
        name: 'CheckSum',
        abbrName: 'CheckSum',
        added: 'FIX.2.7',
        type: 'String',
        id: 10,
        description:
            'Three byte, simple checksum (see Volume 2: "Checksum Calculation" for description). ALWAYS LAST FIELD IN MESSAGE; i.e. serves, with the trailing <SOH>, as the end-of-message delimiter. Always defined as three characters. (Always unencrypted)',
    },
    {
        baseCategory: 'SingleGeneralOrderHandling',
        name: 'ClOrdID',
        abbrName: 'ClOrdID',
        updated: 'FIX.Latest',
        added: 'FIX.2.7',
        type: 'String',
        updatedEP: '282',
        baseCategoryAbbrName: 'ID',
        id: 11,
        description:
            'Unique identifier for Order as assigned by the buy-side (institution, broker, intermediary etc.) (identified by SenderCompID(49) or OnBehalfOfCompID(115) as appropriate). Uniqueness must be guaranteed within a single trading day. Firms, particularly those which electronically submit multi-day orders, trade globally or throughout market close periods, should ensure uniqueness across days, for example by embedding a date within the ClOrdID(11) field.',
    },
    {
        name: 'Commission',
        abbrName: 'Comm',
        added: 'FIX.2.7',
        type: 'Amt',
        id: 12,
        description: 'Commission. Note if CommType (13) is percentage, Commission of 5% should be represented as .05.',
    },
    {
        name: 'CommType',
        abbrName: 'CommTyp',
        updated: 'FIX.5.0SP2',
        added: 'FIX.2.7',
        type: 'CommTypeCodeSet',
        updatedEP: '204',
        id: 13,
        description: 'Specifies the basis or unit used to calculate the total commission based on the rate.',
    },
    {
        name: 'CumQty',
        abbrName: 'CumQty',
        added: 'FIX.2.7',
        type: 'Qty',
        id: 14,
        description: 'Total quantity (e.g. number of shares) filled.\n\n(Prior to FIX 4.2 this field was of type int)',
    },
    {
        name: 'Currency',
        abbrName: 'Ccy',
        updated: 'FIX.Latest',
        added: 'FIX.2.7',
        type: 'Currency',
        updatedEP: '273',
        id: 15,
        description:
            'Identifies currency used for price or quantity fields, depending on the asset class being traded. CurrencyCodeSource(2897) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.\n\nAbsence of this field is interpreted as the default currency for the security as defined by the respective reference data. It is recommended that systems provide the currency value whenever possible.\n\nFor securities trading and digital assets traded securities-style, identifies the currency used to denote the price. Absence of this field is interpreted as the default for the security. For Foreign Exchange (FX) and digital assets traded FX-style, identifies the dealt currency used to denominate the quantity related field(s).',
    },
    {
        name: 'EndSeqNo',
        abbrName: 'EndSeqNo',
        added: 'FIX.2.7',
        type: 'SeqNum',
        id: 16,
        description:
            'Message sequence number of last message in range to be resent. If request is for a single message BeginSeqNo (7) = EndSeqNo. If request is for all messages subsequent to a particular message, EndSeqNo = "0" (representing infinity).',
    },
    {
        name: 'ExecID',
        abbrName: 'ExecID',
        updated: 'FIX.5.0SP1',
        added: 'FIX.2.7',
        type: 'String',
        updatedEP: '95',
        id: 17,
        description:
            'Unique identifier of execution message as assigned by sell-side (broker, exchange, ECN) (will be 0 (zero) for ExecType (150)=I (Order Status)).\n\nUniqueness must be guaranteed within a single trading day or the life of a multi-day order. Firms which accept multi-day orders should consider embedding a date within the ExecID field to assure uniqueness across days.\n\n(Prior to FIX 4.1 this field was of type int).',
    },
    {
        name: 'ExecInst',
        abbrName: 'ExecInst',
        added: 'FIX.2.7',
        type: 'ExecInstCodeSet',
        id: 18,
        description:
            'Instructions for order handling on exchange trading floor. If more than one instruction is applicable to an order, this field can contain multiple instructions separated by space. *** SOME VALUES HAVE BEEN REPLACED - See "Replaced Features and Supported Approach" *** (see Volume : "Glossary" for value definitions)',
    },
    {
        name: 'ExecRefID',
        abbrName: 'ExecRefID',
        added: 'FIX.2.7',
        type: 'String',
        id: 19,
        description:
            'Reference identifier used with Trade, Trade Cancel and Trade Correct execution types.\n\n(Prior to FIX 4.1 this field was of type int)',
    },
    {
        name: 'HandlInst',
        abbrName: 'HandlInst',
        added: 'FIX.2.7',
        type: 'HandlInstCodeSet',
        id: 21,
        description: 'Instructions for order handling on Broker trading floor',
    },
    {
        name: 'SecurityIDSource',
        abbrName: 'Src',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.5.0SP2',
        added: 'FIX.2.7',
        type: 'SecurityIDSourceCodeSet',
        updatedEP: '161',
        id: 22,
        description: 'Identifies class or source of the SecurityID(48) value.',
    },
    {
        baseCategory: 'Indication',
        name: 'IOIID',
        abbrName: 'IOIID',
        added: 'FIX.2.7',
        type: 'String',
        baseCategoryAbbrName: 'ID',
        id: 23,
        description: 'Unique identifier of IOI message.\n\n(Prior to FIX 4.1 this field was of type int)',
    },
    {
        name: 'IOIQltyInd',
        abbrName: 'QltyInd',
        added: 'FIX.2.7',
        type: 'IOIQltyIndCodeSet',
        id: 25,
        description: 'Relative quality of indication',
    },
    {
        name: 'IOIRefID',
        abbrName: 'RefID',
        added: 'FIX.2.7',
        type: 'String',
        id: 26,
        description:
            'Reference identifier used with CANCEL and REPLACE, transaction types.\n\n(Prior to FIX 4.1 this field was of type int)',
    },
    {
        name: 'IOIQty',
        abbrName: 'Qty',
        unionDataType: 'Qty',
        added: 'FIX.2.7',
        type: 'IOIQtyCodeSet',
        id: 27,
        description: 'Quantity (e.g. number of shares) in numeric form or relative size.',
    },
    {
        name: 'IOITransType',
        abbrName: 'TransTyp',
        added: 'FIX.2.7',
        type: 'IOITransTypeCodeSet',
        id: 28,
        description: 'Identifies IOI message transaction type',
    },
    {
        name: 'LastCapacity',
        abbrName: 'LastCpcty',
        added: 'FIX.2.7',
        type: 'LastCapacityCodeSet',
        id: 29,
        description: 'Broker capacity in order execution',
    },
    {
        name: 'LastMkt',
        abbrName: 'LastMkt',
        updated: 'FIX.5.0SP2',
        added: 'FIX.2.7',
        type: 'Exchange',
        updatedEP: '228',
        id: 30,
        description:
            'Market of execution for last fill, or an indication of the market where an order was routed\n\nValid values:\n\nSee "Appendix 6-C"\n\nIn the context of ESMA RTS 1 Annex I, Table 3, Field 6 "Venue of Execution" it is required that the "venue where the transaction was executed" be identified using ISO 10383 (MIC). Additionally, ESMA requires the use of "MIC code \'XOFF\' for financial instruments admitted to trading or traded on a trading venue, where the transaction on that financial instrument is not executed on a trading venue, systematic internaliser or organized trading platform outside of the Union. Use \'SINT\' for financial instruments admitted to trading or traded on a trading venue, where the transaction is executed on a systematic internaliser."',
    },
    {
        name: 'LastPx',
        abbrName: 'LastPx',
        added: 'FIX.2.7',
        type: 'Price',
        id: 31,
        description: 'Price of this (last) fill.',
    },
    {
        name: 'LastQty',
        abbrName: 'LastQty',
        added: 'FIX.2.7',
        type: 'Qty',
        id: 32,
        description:
            'Quantity (e.g. shares) bought/sold on this (last) fill.\n\n(Prior to FIX 4.2 this field was of type int)',
    },
    {
        name: 'NoLinesOfText',
        updated: 'FIX.Latest',
        added: 'FIX.2.7',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 33,
        description: 'Identifies number of lines of text body',
    },
    {
        name: 'MsgSeqNum',
        abbrName: 'SeqNum',
        added: 'FIX.2.7',
        type: 'SeqNum',
        id: 34,
        description: 'Integer message sequence number.',
    },
    {
        name: 'MsgType',
        abbrName: 'MsgTyp',
        added: 'FIX.2.7',
        type: 'MsgTypeCodeSet',
        id: 35,
        description:
            'Defines message type ALWAYS THIRD FIELD IN MESSAGE. (Always unencrypted)\n\nNote: A "U" as the first character in the MsgType field (i.e. U, U2, etc) indicates that the message format is privately defined between the sender and receiver.\n\n*** Note the use of lower case letters ***',
    },
    {
        name: 'NewSeqNo',
        abbrName: 'NewSeqNo',
        added: 'FIX.2.7',
        type: 'SeqNum',
        id: 36,
        description: 'New sequence number',
    },
    {
        name: 'OrderID',
        abbrName: 'OrdID',
        added: 'FIX.2.7',
        type: 'String',
        id: 37,
        description:
            'Unique identifier for Order as assigned by sell-side (broker, exchange, ECN). Uniqueness must be guaranteed within a single trading day. Firms which accept multi-day orders should consider embedding a date within the OrderID field to assure uniqueness across days.',
    },
    {
        name: 'OrderQty',
        abbrName: 'Qty',
        added: 'FIX.2.7',
        type: 'Qty',
        id: 38,
        description:
            'Quantity ordered. This represents the number of shares for equities or par, face or nominal value for FI instruments.\n\n(Prior to FIX 4.2 this field was of type int)',
    },
    {
        baseCategory: 'SingleGeneralOrderHandling',
        name: 'OrdStatus',
        abbrName: 'OrdStat',
        added: 'FIX.2.7',
        type: 'OrdStatusCodeSet',
        baseCategoryAbbrName: 'Stat',
        id: 39,
        description:
            'Identifies current status of order. *** SOME VALUES HAVE BEEN REPLACED - See "Replaced Features and Supported Approach" *** (see Volume : "Glossary" for value definitions)',
    },
    {
        baseCategory: 'SingleGeneralOrderHandling',
        name: 'OrdType',
        abbrName: 'OrdTyp',
        added: 'FIX.2.7',
        type: 'OrdTypeCodeSet',
        baseCategoryAbbrName: 'Typ',
        id: 40,
        description:
            'Order type. *** SOME VALUES ARE NO LONGER USED - See "Deprecated (Phased-out) Features and Supported Approach" *** (see Volume : "Glossary" for value definitions)',
    },
    {
        baseCategory: 'SingleGeneralOrderHandling',
        name: 'OrigClOrdID',
        abbrName: 'OrigClOrdID',
        added: 'FIX.2.7',
        type: 'String',
        baseCategoryAbbrName: 'OrigID',
        id: 41,
        description:
            'ClOrdID (11) of the previous order (NOT the initial order of the day) as assigned by the institution, used to identify the previous order in cancel and cancel/replace requests.',
    },
    {
        name: 'OrigTime',
        abbrName: 'OrigTm',
        added: 'FIX.2.7',
        type: 'UTCTimestamp',
        id: 42,
        description:
            'Time of message origination (always expressed in UTC (Universal Time Coordinated, also known as "GMT"))',
    },
    {
        name: 'PossDupFlag',
        abbrName: 'PosDup',
        added: 'FIX.2.7',
        type: 'PossDupFlagCodeSet',
        id: 43,
        description: 'Indicates possible retransmission of message with this sequence number',
    },
    {
        name: 'Price',
        abbrName: 'Px',
        added: 'FIX.2.7',
        type: 'Price',
        id: 44,
        description: 'Price per unit of quantity (e.g. per share)',
    },
    {
        name: 'RefSeqNum',
        abbrName: 'RefSeqNum',
        added: 'FIX.2.7',
        type: 'SeqNum',
        id: 45,
        description: 'Reference message sequence number',
    },
    {
        name: 'SecurityID',
        abbrName: 'ID',
        added: 'FIX.2.7',
        type: 'String',
        id: 48,
        discriminatorId: '22',
        description:
            'Security identifier value of SecurityIDSource (22) type (e.g. CUSIP, SEDOL, ISIN, etc). Requires SecurityIDSource.',
    },
    {
        name: 'SenderCompID',
        abbrName: 'SID',
        added: 'FIX.2.7',
        type: 'String',
        id: 49,
        description: 'Assigned value used to identify firm sending message.',
    },
    {
        name: 'SenderSubID',
        abbrName: 'SSub',
        added: 'FIX.2.7',
        type: 'String',
        id: 50,
        description: 'Assigned value used to identify specific message originator (desk, trader, etc.)',
    },
    {
        name: 'SendingTime',
        abbrName: 'Snt',
        added: 'FIX.2.7',
        type: 'UTCTimestamp',
        id: 52,
        description:
            'Time of message transmission (always expressed in UTC (Universal Time Coordinated, also known as "GMT")',
    },
    {
        name: 'Quantity',
        abbrName: 'Qty',
        added: 'FIX.2.7',
        type: 'Qty',
        id: 53,
        description: 'Overall/total quantity (e.g. number of shares)\n\n(Prior to FIX 4.2 this field was of type int)',
    },
    {
        name: 'Side',
        abbrName: 'Side',
        added: 'FIX.2.7',
        type: 'SideCodeSet',
        id: 54,
        description: 'Side of order (see Volume : "Glossary" for value definitions)',
    },
    {
        name: 'Symbol',
        abbrName: 'Sym',
        added: 'FIX.2.7',
        type: 'String',
        id: 55,
        description:
            'Ticker symbol. Common, "human understood" representation of the security. SecurityID (48) value can be specified if no symbol exists (e.g. non-exchange traded Collective Investment Vehicles)\n\nUse "[N/A]" for products which do not have a symbol.',
    },
    {
        name: 'TargetCompID',
        abbrName: 'TID',
        added: 'FIX.2.7',
        type: 'String',
        id: 56,
        description: 'Assigned value used to identify receiving firm.',
    },
    {
        name: 'TargetSubID',
        abbrName: 'TSub',
        added: 'FIX.2.7',
        type: 'String',
        id: 57,
        description:
            'Assigned value used to identify specific individual or unit intended to receive message. "ADMIN" reserved for administrative messages not intended for a specific user.',
    },
    {
        name: 'Text',
        abbrName: 'Txt',
        added: 'FIX.2.7',
        type: 'String',
        id: 58,
        description: 'Free format text string\n\n(Note: this field does not have a specified maximum length)',
    },
    {
        name: 'TimeInForce',
        abbrName: 'TmInForce',
        updated: 'FIX.5.0SP2',
        added: 'FIX.2.7',
        type: 'TimeInForceCodeSet',
        updatedEP: '253',
        id: 59,
        description:
            'Specifies how long the order remains in effect. Absence of this field is interpreted as DAY. NOTE not applicable to CIV Orders.',
    },
    {
        name: 'TransactTime',
        abbrName: 'TxnTm',
        updated: 'FIX.5.0SP1',
        added: 'FIX.2.7',
        type: 'UTCTimestamp',
        updatedEP: '94',
        id: 60,
        description: 'Timestamp when the business transaction represented by the message occurred.',
    },
    {
        name: 'Urgency',
        abbrName: 'Urgency',
        added: 'FIX.2.7',
        type: 'UrgencyCodeSet',
        id: 61,
        description: 'Urgency flag',
    },
    {
        name: 'ValidUntilTime',
        abbrName: 'ValidUntilTm',
        added: 'FIX.2.7',
        type: 'UTCTimestamp',
        id: 62,
        description:
            'Indicates expiration time of indication message (always expressed in UTC (Universal Time Coordinated, also known as "GMT")',
    },
    {
        name: 'SettlType',
        abbrName: 'SettlTyp',
        unionDataType: 'Tenor',
        added: 'FIX.2.7',
        type: 'SettlTypeCodeSet',
        id: 63,
        description:
            'Indicates order settlement period. If present, SettlDate (64) overrides this field. If both SettlType (63) and SettDate (64) are omitted, the default for SettlType (63) is 0 (Regular)\n\nRegular is defined as the default settlement period for the particular security on the exchange of execution.\n\nIn Fixed Income the contents of this field may influence the instrument definition if the SecurityID (48) is ambiguous. In the US an active Treasury offering may be re-opened, and for a time one CUSIP will apply to both the current and "when-issued" securities. Supplying a value of "7" clarifies the instrument description; any other value or the absence of this field should cause the respondent to default to the active issue.\n\nAdditionally the following patterns may be uses as well as enum values\n\nDx = FX tenor expression for "days", e.g. "D5", where "x" is any integer > 0\n\nMx = FX tenor expression for "months", e.g. "M3", where "x" is any integer > 0\n\nWx = FX tenor expression for "weeks", e.g. "W13", where "x" is any integer > 0\n\nYx = FX tenor expression for "years", e.g. "Y1", where "x" is any integer > 0\n\nNoted that for FX the tenors expressed using Dx, Mx, Wx, and Yx values do not denote business days, but calendar days.',
    },
    {
        name: 'SettlDate',
        abbrName: 'SettlDt',
        added: 'FIX.2.7',
        type: 'LocalMktDate',
        id: 64,
        description:
            'Specific date of trade settlement (SettlementDate) in YYYYMMDD format.\n\nIf present, this field overrides SettlType (63). This field is required if the value of SettlType (63) is 6 (Future) or 8 (Sellers Option). This field must be omitted if the value of SettlType (63) is 7 (When and If Issued)\n\n(expressed in local time at place of settlement)',
    },
    {
        name: 'SymbolSfx',
        abbrName: 'Sfx',
        added: 'FIX.2.7',
        type: 'SymbolSfxCodeSet',
        id: 65,
        description:
            'Additional information about the security (e.g. preferred, warrants, etc.). Note also see SecurityType (167).\n\nAs defined in the NYSE Stock and bond Symbol Directory and in the AMEX Fitch Directory.',
    },
    {
        baseCategory: 'ProgramTrading',
        name: 'ListID',
        abbrName: 'ListID',
        added: 'FIX.2.7',
        type: 'String',
        baseCategoryAbbrName: 'ID',
        id: 66,
        description:
            'Unique identifier for list as assigned by institution, used to associate multiple individual orders. Uniqueness must be guaranteed within a single trading day. Firms which generate multi-day orders should consider embedding a date within the ListID field to assure uniqueness across days.',
    },
    {
        baseCategory: 'ProgramTrading',
        name: 'ListSeqNo',
        abbrName: 'ListSeqNo',
        added: 'FIX.2.7',
        type: 'int',
        baseCategoryAbbrName: 'SeqNo',
        id: 67,
        description:
            'Sequence of individual order within list (i.e. ListSeqNo of TotNoOrders (68), 2 of 25, 3 of 25, . . . )',
    },
    {
        name: 'TotNoOrders',
        abbrName: 'TotNoOrds',
        added: 'FIX.2.7',
        type: 'int',
        id: 68,
        description:
            'Total number of list order entries across all messages. Should be the sum of all NoOrders (73) in each message that has repeating list order entries related to the same ListID (66). Used to support fragmentation.\n\n(Prior to FIX 4.2 this field was named "ListNoOrds")',
    },
    {
        name: 'ListExecInst',
        abbrName: 'ListExecInst',
        added: 'FIX.2.7',
        type: 'String',
        id: 69,
        description: 'Free format text message containing list handling and execution instructions.',
    },
    {
        baseCategory: 'Allocation',
        name: 'AllocID',
        abbrName: 'AllocID',
        added: 'FIX.2.7',
        type: 'String',
        baseCategoryAbbrName: 'ID',
        id: 70,
        description: 'Unique identifier for allocation message.\n\n(Prior to FIX 4.1 this field was of type int)',
    },
    {
        name: 'AllocTransType',
        abbrName: 'TransTyp',
        added: 'FIX.2.7',
        type: 'AllocTransTypeCodeSet',
        id: 71,
        description:
            'Identifies allocation transaction type *** SOME VALUES HAVE BEEN REPLACED - See "Replaced Features and Supported Approach" ***',
    },
    {
        baseCategory: 'Allocation',
        name: 'RefAllocID',
        abbrName: 'RefAllocID',
        added: 'FIX.2.7',
        type: 'String',
        baseCategoryAbbrName: 'RefID',
        id: 72,
        description:
            'Reference identifier to be used with AllocTransType (71) = Replace or Cancel.\n\n(Prior to FIX 4.1 this field was of type int)',
    },
    {
        name: 'NoOrders',
        updated: 'FIX.Latest',
        added: 'FIX.2.7',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 73,
        description: 'Indicates number of orders to be combined for average pricing and allocation.',
    },
    {
        name: 'AvgPxPrecision',
        abbrName: 'AvgPxPrcsn',
        added: 'FIX.2.7',
        type: 'int',
        id: 74,
        description:
            'Indicates number of decimal places to be used for average pricing. Absence of this field indicates that default precision arranged by the broker/institution is to be used.',
    },
    {
        name: 'TradeDate',
        abbrName: 'TrdDt',
        updated: 'FIX.5.0SP2',
        added: 'FIX.2.7',
        type: 'LocalMktDate',
        updatedEP: '190',
        id: 75,
        description:
            'Indicates date of trading day. Absence of this field indicates current day (expressed in local time at place of trade).',
    },
    {
        name: 'PositionEffect',
        abbrName: 'PosEfct',
        added: 'FIX.2.7',
        type: 'PositionEffectCodeSet',
        id: 77,
        description:
            'Indicates whether the resulting position after a trade should be an opening position or closing position. Used for omnibus accounting - where accounts are held on a gross basis instead of being netted together.',
    },
    {
        name: 'NoAllocs',
        updated: 'FIX.Latest',
        added: 'FIX.2.7',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 78,
        description: 'Number of repeating AllocAccount (79)/AllocPrice (366) entries.',
    },
    {
        name: 'AllocAccount',
        abbrName: 'Acct',
        added: 'FIX.2.7',
        type: 'String',
        id: 79,
        description: 'Sub-account mnemonic',
    },
    {
        name: 'AllocQty',
        abbrName: 'Qty',
        added: 'FIX.2.7',
        type: 'Qty',
        id: 80,
        description:
            'Quantity to be allocated to specific sub-account\n\n(Prior to FIX 4.2 this field was of type int)',
    },
    {
        name: 'ProcessCode',
        abbrName: 'ProcCode',
        added: 'FIX.2.7',
        type: 'ProcessCodeCodeSet',
        id: 81,
        description:
            'Processing code for sub-account. Absence of this field in AllocAccount (79) / AllocPrice (366) /AllocQty (80) / ProcessCode instance indicates regular trade.',
    },
    {
        name: 'NoRpts',
        abbrName: 'NoRpts',
        added: 'FIX.2.7',
        type: 'int',
        id: 82,
        description: 'Total number of reports within series.',
    },
    {
        name: 'RptSeq',
        abbrName: 'RptSeq',
        added: 'FIX.2.7',
        type: 'int',
        id: 83,
        description:
            'Sequence number of message within report series. Used to carry reporting sequence number of the fill as represented on the Trade Report Side.',
    },
    {
        name: 'CxlQty',
        abbrName: 'CxlQty',
        added: 'FIX.2.7',
        type: 'Qty',
        id: 84,
        description: 'Total quantity canceled for this order.\n\n(Prior to FIX 4.2 this field was of type int)',
    },
    {
        name: 'NoDlvyInst',
        updated: 'FIX.Latest',
        added: 'FIX.2.7',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 85,
        description:
            'Number of delivery instruction fields in repeating group.\n\nNote this field was removed in FIX 4.1 and reinstated in FIX 4.4.',
    },
    {
        baseCategory: 'Allocation',
        name: 'AllocStatus',
        abbrName: 'Stat',
        added: 'FIX.2.7',
        type: 'AllocStatusCodeSet',
        baseCategoryAbbrName: 'Stat',
        id: 87,
        description: 'Identifies status of allocation.',
    },
    {
        name: 'AllocRejCode',
        abbrName: 'RejCode',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.5.0SP1',
        added: 'FIX.2.7',
        type: 'AllocRejCodeCodeSet',
        updatedEP: '95',
        id: 88,
        description: 'Identifies reason for rejection.',
    },
    {
        name: 'Signature',
        abbrName: 'Signature',
        added: 'FIX.2.7',
        type: 'data',
        deprecated: 'FIXT.1.1',
        id: 89,
        lengthId: '93',
        description: 'Electronic signature',
    },
    {
        name: 'SecureDataLen',
        abbrName: 'SecureDataLen',
        added: 'FIX.2.7',
        type: 'Length',
        deprecated: 'FIXT.1.1',
        id: 90,
        description: 'Length of encrypted message',
    },
    {
        name: 'SecureData',
        abbrName: 'SecureData',
        added: 'FIX.2.7',
        type: 'data',
        deprecated: 'FIXT.1.1',
        id: 91,
        lengthId: '90',
        description: 'Actual encrypted data stream',
    },
    {
        name: 'SignatureLength',
        abbrName: 'SignatureLength',
        added: 'FIX.2.7',
        type: 'Length',
        deprecated: 'FIXT.1.1',
        id: 93,
        description: 'Number of bytes in signature field',
    },
    {
        name: 'EmailType',
        abbrName: 'EmailTyp',
        added: 'FIX.2.7',
        type: 'EmailTypeCodeSet',
        id: 94,
        description: 'Email message type.',
    },
    {
        name: 'RawDataLength',
        abbrName: 'RawDataLength',
        added: 'FIX.2.7',
        type: 'Length',
        id: 95,
        description: 'Number of bytes in raw data field.',
    },
    {
        name: 'RawData',
        abbrName: 'RawData',
        added: 'FIX.2.7',
        type: 'data',
        id: 96,
        lengthId: '95',
        description: 'Unformatted raw data, can include bitmaps, word processor documents, etc.',
    },
    {
        name: 'PossResend',
        abbrName: 'PosRsnd',
        added: 'FIX.2.7',
        type: 'PossResendCodeSet',
        id: 97,
        description: 'Indicates that message may contain information that has been sent under another sequence number.',
    },
    {
        name: 'EncryptMethod',
        abbrName: 'EncryptMethod',
        added: 'FIX.2.7',
        type: 'EncryptMethodCodeSet',
        id: 98,
        description: 'Method of encryption.',
    },
    {
        name: 'StopPx',
        abbrName: 'StopPx',
        added: 'FIX.2.7',
        type: 'Price',
        id: 99,
        description: 'Price per unit of quantity (e.g. per share)',
    },
    {
        name: 'ExDestination',
        abbrName: 'ExDest',
        added: 'FIX.2.7',
        type: 'Exchange',
        id: 100,
        description:
            'Execution destination as defined by institution when order is entered.\n\nValid values:\n\nSee "Appendix 6-C"',
    },
    {
        name: 'CxlRejReason',
        abbrName: 'CxlRejRsn',
        unionDataType: 'Reserved100Plus',
        added: 'FIX.2.7',
        type: 'CxlRejReasonCodeSet',
        id: 102,
        description: 'Code to identify reason for cancel rejection.',
    },
    {
        name: 'OrdRejReason',
        abbrName: 'RejRsn',
        unionDataType: 'Reserved100Plus',
        added: 'FIX.2.7',
        type: 'OrdRejReasonCodeSet',
        id: 103,
        description:
            'Code to identify reason for order rejection. Note: Values 3, 4, and 5 will be used when rejecting an order due to pre-allocation information errors.',
    },
    {
        name: 'IOIQualifier',
        abbrName: 'Qual',
        added: 'FIX.3.0',
        type: 'IOIQualifierCodeSet',
        id: 104,
        description: 'Code to qualify IOI use. (see Volume : "Glossary" for value definitions)',
    },
    {
        name: 'Issuer',
        abbrName: 'Issr',
        added: 'FIX.3.0',
        type: 'String',
        id: 106,
        description:
            'Name of security issuer (e.g. International Business Machines, GNMA).\n\nsee also Volume 7: "PRODUCT: FIXED INCOME - Euro Issuer Values"',
    },
    {
        name: 'SecurityDesc',
        abbrName: 'Desc',
        updated: 'FIX.5.0SP2',
        added: 'FIX.3.0',
        type: 'String',
        updatedEP: '232',
        id: 107,
        description:
            'Can be used by the venue or one of the trading parties to provide a non-normative textual description for the financial instrument.',
    },
    {
        name: 'HeartBtInt',
        abbrName: 'HeartBtInt',
        added: 'FIX.3.0',
        type: 'int',
        id: 108,
        description: 'Heartbeat interval (seconds)',
    },
    {
        name: 'MinQty',
        abbrName: 'MinQty',
        added: 'FIX.3.0',
        type: 'Qty',
        id: 110,
        description: 'Minimum quantity of an order to be executed.\n\n(Prior to FIX 4.2 this field was of type int)',
    },
    {
        name: 'MaxFloor',
        abbrName: 'MaxFloor',
        added: 'FIX.3.0',
        type: 'Qty',
        deprecated: 'FIX.5.0',
        id: 111,
        description:
            'The quantity to be displayed . Required for reserve orders. On orders specifies the qty to be displayed, on execution reports the currently displayed quantity.',
    },
    {
        name: 'TestReqID',
        abbrName: 'TestReqID',
        added: 'FIX.3.0',
        type: 'String',
        id: 112,
        description: 'Identifier included in Test Request message to be returned in resulting Heartbeat',
    },
    {
        name: 'ReportToExch',
        abbrName: 'RptToExch',
        added: 'FIX.3.0',
        type: 'ReportToExchCodeSet',
        id: 113,
        description: 'Identifies party of trade responsible for exchange reporting.',
    },
    {
        name: 'LocateReqd',
        abbrName: 'LocReqd',
        added: 'FIX.4.0',
        type: 'LocateReqdCodeSet',
        id: 114,
        description: 'Indicates whether the broker is to locate the stock in conjunction with a short sell order.',
    },
    {
        name: 'OnBehalfOfCompID',
        abbrName: 'OBID',
        added: 'FIX.4.0',
        type: 'String',
        id: 115,
        description:
            'Assigned value used to identify firm originating message if the message was delivered by a third party i.e. the third party firm identifier would be delivered in the SenderCompID field and the firm originating the message in this field.',
    },
    {
        name: 'OnBehalfOfSubID',
        abbrName: 'OBSub',
        added: 'FIX.4.0',
        type: 'String',
        id: 116,
        description:
            'Assigned value used to identify specific message originator (i.e. trader) if the message was delivered by a third party',
    },
    {
        name: 'QuoteID',
        abbrName: 'QID',
        added: 'FIX.4.0',
        type: 'String',
        id: 117,
        description: 'Unique identifier for quote',
    },
    {
        name: 'NetMoney',
        abbrName: 'NetMny',
        added: 'FIX.4.0',
        type: 'Amt',
        id: 118,
        description:
            'Total amount due as the result of the transaction (e.g. for Buy order - principal + commission + fees) reported in currency of execution.',
    },
    {
        name: 'SettlCurrAmt',
        abbrName: 'SettlCurrAmt',
        added: 'FIX.4.0',
        type: 'Amt',
        id: 119,
        description: 'Total amount due expressed in settlement currency (includes the effect of the forex transaction)',
    },
    {
        name: 'SettlCurrency',
        abbrName: 'SettlCcy',
        added: 'FIX.4.0',
        type: 'Currency',
        id: 120,
        description: 'Currency code of settlement denomination.',
    },
    {
        name: 'ForexReq',
        abbrName: 'ForexReq',
        added: 'FIX.4.0',
        type: 'ForexReqCodeSet',
        id: 121,
        description: 'Indicates request for forex accommodation trade to be executed along with security transaction.',
    },
    {
        name: 'OrigSendingTime',
        abbrName: 'OrigSnt',
        added: 'FIX.4.0',
        type: 'UTCTimestamp',
        id: 122,
        description:
            'Original time of message transmission (always expressed in UTC (Universal Time Coordinated, also known as "GMT") when transmitting orders as the result of a resend request.',
    },
    {
        name: 'GapFillFlag',
        abbrName: 'GapFillFlag',
        added: 'FIX.4.0',
        type: 'GapFillFlagCodeSet',
        id: 123,
        description:
            'Indicates that the Sequence Reset message is replacing administrative or application messages which will not be resent.',
    },
    {
        name: 'NoExecs',
        updated: 'FIX.Latest',
        added: 'FIX.4.0',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 124,
        description: 'Number of executions or trades.',
    },
    {
        name: 'ExpireTime',
        abbrName: 'ExpireTm',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.0',
        type: 'UTCTimestamp',
        updatedEP: '171',
        id: 126,
        description:
            'Time/Date of order expiration (always expressed in UTC (Universal Time Coordinated, also known as "GMT")\n\nThe meaning of expiration is specific to the context where the field is used.\n\nFor orders, this is the expiration time of a Good Til Date TimeInForce.\n\nFor Quotes - this is the expiration of the quote.\n\nExpiration time is provided across the quote message dialog to control the length of time of the overall quoting process.\n\nFor collateral requests, this is the time by which collateral must be assigned.\n\nFor collateral assignments, this is the time by which a response to the assignment is expected.\n\nFor credit/risk limit checks, this is the time when the reserved credit limit will expire for the requested transaction.',
    },
    {
        name: 'DKReason',
        abbrName: 'DkRsn',
        added: 'FIX.4.0',
        type: 'DKReasonCodeSet',
        id: 127,
        description: 'Reason for execution rejection.',
    },
    {
        name: 'DeliverToCompID',
        abbrName: 'D2ID',
        added: 'FIX.4.0',
        type: 'String',
        id: 128,
        description:
            'Assigned value used to identify the firm targeted to receive the message if the message is delivered by a third party i.e. the third party firm identifier would be delivered in the TargetCompID (56) field and the ultimate receiver firm ID in this field.',
    },
    {
        name: 'DeliverToSubID',
        abbrName: 'D2Sub',
        added: 'FIX.4.0',
        type: 'String',
        id: 129,
        description:
            'Assigned value used to identify specific message recipient (i.e. trader) if the message is delivered by a third party',
    },
    {
        name: 'IOINaturalFlag',
        abbrName: 'NatFlag',
        added: 'FIX.4.0',
        type: 'IOINaturalFlagCodeSet',
        id: 130,
        description:
            'Indicates that IOI is the result of an existing agency order or a facilitation position resulting from an agency order, not from principal trading or order solicitation activity.',
    },
    {
        name: 'QuoteReqID',
        abbrName: 'ReqID',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.0',
        type: 'String',
        updatedEP: '143',
        id: 131,
        description: 'Unique identifier for a QuoteRequest(35=R).',
    },
    { name: 'BidPx', abbrName: 'BidPx', added: 'FIX.4.0', type: 'Price', id: 132, description: 'Bid price/rate' },
    { name: 'OfferPx', abbrName: 'OfrPx', added: 'FIX.4.0', type: 'Price', id: 133, description: 'Offer price/rate' },
    {
        name: 'BidSize',
        abbrName: 'BidSz',
        added: 'FIX.4.0',
        type: 'Qty',
        id: 134,
        description: 'Quantity of bid\n\n(Prior to FIX 4.2 this field was of type int)',
    },
    {
        name: 'OfferSize',
        abbrName: 'OfrSz',
        added: 'FIX.4.0',
        type: 'Qty',
        id: 135,
        description: 'Quantity of offer\n\n(Prior to FIX 4.2 this field was of type int)',
    },
    {
        name: 'NoMiscFees',
        updated: 'FIX.Latest',
        added: 'FIX.4.0',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 136,
        description: 'Number of repeating groups of miscellaneous fees',
    },
    {
        name: 'MiscFeeAmt',
        abbrName: 'Amt',
        added: 'FIX.4.0',
        type: 'Amt',
        id: 137,
        description: 'Miscellaneous fee value',
    },
    {
        name: 'MiscFeeCurr',
        abbrName: 'Curr',
        added: 'FIX.4.0',
        type: 'Currency',
        id: 138,
        description: 'Currency of miscellaneous fee',
    },
    {
        name: 'MiscFeeType',
        abbrName: 'Typ',
        added: 'FIX.4.0',
        type: 'MiscFeeTypeCodeSet',
        id: 139,
        description: 'Indicates type of miscellaneous fee.',
    },
    {
        name: 'PrevClosePx',
        abbrName: 'PrevClsPx',
        added: 'FIX.4.0',
        type: 'Price',
        id: 140,
        description: 'Previous closing price of security.',
    },
    {
        name: 'ResetSeqNumFlag',
        abbrName: 'ResetSeqNumFlag',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.1',
        type: 'ResetSeqNumFlagCodeSet',
        updatedEP: '204',
        id: 141,
        description: 'Indicates that both sides of the FIX session should reset sequence numbers.',
    },
    {
        name: 'SenderLocationID',
        abbrName: 'SLoc',
        added: 'FIX.4.1',
        type: 'String',
        id: 142,
        description:
            "Assigned value used to identify specific message originator's location (i.e. geographic location and/or desk, trader)",
    },
    {
        name: 'TargetLocationID',
        abbrName: 'TLoc',
        added: 'FIX.4.1',
        type: 'String',
        id: 143,
        description:
            "Assigned value used to identify specific message destination's location (i.e. geographic location and/or desk, trader)",
    },
    {
        name: 'OnBehalfOfLocationID',
        abbrName: 'OBLoc',
        added: 'FIX.4.1',
        type: 'String',
        id: 144,
        description:
            "Assigned value used to identify specific message originator's location (i.e. geographic location and/or desk, trader) if the message was delivered by a third party",
    },
    {
        name: 'DeliverToLocationID',
        abbrName: 'D2Loc',
        added: 'FIX.4.1',
        type: 'String',
        id: 145,
        description:
            "Assigned value used to identify specific message recipient's location (i.e. geographic location and/or desk, trader) if the message was delivered by a third party",
    },
    {
        name: 'NoRelatedSym',
        updated: 'FIX.Latest',
        added: 'FIX.4.1',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 146,
        description: 'Specifies the number of repeating symbols specified.',
    },
    {
        name: 'Subject',
        abbrName: 'Subject',
        added: 'FIX.4.1',
        type: 'String',
        id: 147,
        description: 'The subject of an Email message',
    },
    {
        name: 'Headline',
        abbrName: 'Headline',
        added: 'FIX.4.1',
        type: 'String',
        id: 148,
        description: 'The headline of a News message',
    },
    {
        name: 'URLLink',
        abbrName: 'URL',
        added: 'FIX.4.1',
        type: 'String',
        id: 149,
        description:
            'A URI (Uniform Resource Identifier) or URL (Uniform Resource Locator) link to additional information (i.e. http://www.XYZ.com/research.html)\n\nSee "Appendix 6-B FIX Fields Based Upon Other Standards"',
    },
    {
        name: 'ExecType',
        abbrName: 'ExecTyp',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.1',
        type: 'ExecTypeCodeSet',
        updatedEP: '131',
        id: 150,
        description:
            'Describes the specific ExecutionRpt (e.g. Pending Cancel) while OrdStatus(39) will always identify the current order status (e.g. Partially Filled).',
    },
    {
        name: 'LeavesQty',
        abbrName: 'LeavesQty',
        added: 'FIX.4.1',
        type: 'Qty',
        id: 151,
        description:
            'Quantity open for further execution. If the OrdStatus (39) is Canceled, DoneForTheDay, Expired, Calculated, or Rejected (in which case the order is no longer active) then LeavesQty could be 0, otherwise LeavesQty = OrderQty (38) - CumQty (14).\n\n(Prior to FIX 4.2 this field was of type int)',
    },
    {
        name: 'CashOrderQty',
        abbrName: 'Cash',
        added: 'FIX.4.1',
        type: 'Qty',
        id: 152,
        description:
            'Specifies the approximate order quantity desired in total monetary units vs. as tradeable units (e.g. number of shares). The broker or fund manager (for CIV orders) would be responsible for converting and calculating a tradeable unit (e.g. share) quantity (OrderQty (38)) based upon this amount to be used for the actual order and subsequent messages.',
    },
    {
        name: 'AllocAvgPx',
        abbrName: 'AvgPx',
        added: 'FIX.4.1',
        type: 'Price',
        id: 153,
        description:
            'AvgPx (6) for a specific AllocAccount (79)\n\nFor Fixed Income this is always expressed as "percent of par" price type.',
    },
    {
        name: 'AllocNetMoney',
        abbrName: 'NetMny',
        updated: 'FIX.Latest',
        added: 'FIX.4.1',
        type: 'Amt',
        updatedEP: '282',
        id: 154,
        description: 'NetMoney(118) for a specific AllocAccount(79).',
    },
    {
        name: 'SettlCurrFxRate',
        abbrName: 'SettlCurrFxRt',
        updated: 'FIX.Latest',
        added: 'FIX.4.1',
        type: 'float',
        updatedEP: '282',
        id: 155,
        description: 'Foreign exchange rate used to compute SettlCurrAmt(119) from Currency(15) to SettlCurrency(120).',
    },
    {
        name: 'SettlCurrFxRateCalc',
        abbrName: 'SettlCurrFxRtCalc',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.1',
        type: 'SettlCurrFxRateCalcCodeSet',
        updatedEP: '179',
        id: 156,
        description: 'Specifies whether or not SettlCurrFxRate (155) should be multiplied or divided.',
    },
    {
        name: 'NumDaysInterest',
        abbrName: 'NumDaysInt',
        added: 'FIX.4.1',
        type: 'int',
        id: 157,
        description: 'Number of Days of Interest for convertible bonds and fixed income. Note value may be negative.',
    },
    {
        name: 'AccruedInterestRate',
        abbrName: 'AcrdIntRt',
        added: 'FIX.4.1',
        type: 'Percentage',
        id: 158,
        description:
            'The amount the buyer compensates the seller for the portion of the next coupon interest payment the seller has earned but will not receive from the issuer because the issuer will send the next coupon payment to the buyer. Accrued Interest Rate is the annualized Accrued Interest amount divided by the purchase price of the bond.',
    },
    {
        name: 'AccruedInterestAmt',
        abbrName: 'AcrdIntAmt',
        added: 'FIX.4.1',
        type: 'Amt',
        id: 159,
        description: 'Amount of Accrued Interest for convertible bonds and fixed income',
    },
    {
        name: 'SettlInstMode',
        abbrName: 'SettlInstMode',
        added: 'FIX.4.1',
        type: 'SettlInstModeCodeSet',
        id: 160,
        description:
            'Indicates mode used for Settlement Instructions message. *** SOME VALUES HAVE BEEN REPLACED - See "Replaced Features and Supported Approach" ***',
    },
    {
        name: 'AllocText',
        abbrName: 'Txt',
        added: 'FIX.4.1',
        type: 'String',
        id: 161,
        description: 'Free format text related to a specific AllocAccount (79).',
    },
    {
        name: 'SettlInstID',
        abbrName: 'SettlInstID',
        added: 'FIX.4.1',
        type: 'String',
        id: 162,
        description: 'Unique identifier for Settlement Instruction.',
    },
    {
        name: 'SettlInstTransType',
        abbrName: 'SettlInstTransTyp',
        added: 'FIX.4.1',
        type: 'SettlInstTransTypeCodeSet',
        id: 163,
        description: 'Settlement Instructions message transaction type',
    },
    {
        name: 'EmailThreadID',
        abbrName: 'EmailThreadID',
        added: 'FIX.4.1',
        type: 'String',
        id: 164,
        description: 'Unique identifier for an email thread (new and chain of replies)',
    },
    {
        name: 'SettlInstSource',
        abbrName: 'InstSrc',
        added: 'FIX.4.1',
        type: 'SettlInstSourceCodeSet',
        id: 165,
        description: 'Indicates source of Settlement Instructions',
    },
    {
        name: 'SecurityType',
        abbrName: 'SecTyp',
        added: 'FIX.4.1',
        type: 'SecurityTypeCodeSet',
        id: 167,
        description:
            'Indicates type of security. Security type enumerations are grouped by Product(460) field value. NOTE: Additional values may be used by mutual agreement of the counterparties.',
    },
    {
        name: 'EffectiveTime',
        abbrName: 'EfctvTm',
        added: 'FIX.4.1',
        type: 'UTCTimestamp',
        id: 168,
        description:
            'Time the details within the message should take effect (always expressed in UTC (Universal Time Coordinated, also known as "GMT")',
    },
    {
        name: 'StandInstDbType',
        abbrName: 'StandInstDbTyp',
        added: 'FIX.4.1',
        type: 'StandInstDbTypeCodeSet',
        id: 169,
        description: 'Identifies the Standing Instruction database used',
    },
    {
        name: 'StandInstDbName',
        abbrName: 'StandInstDbName',
        added: 'FIX.4.1',
        type: 'String',
        id: 170,
        description:
            "Name of the Standing Instruction database represented with StandInstDbType (169) (i.e. the Global Custodian's name).",
    },
    {
        name: 'StandInstDbID',
        abbrName: 'StandInstDbID',
        added: 'FIX.4.1',
        type: 'String',
        id: 171,
        description:
            'Unique identifier used on the Standing Instructions database for the Standing Instructions to be referenced.',
    },
    {
        name: 'SettlDeliveryType',
        abbrName: 'DlvryTyp',
        added: 'FIX.4.1',
        type: 'SettlDeliveryTypeCodeSet',
        id: 172,
        description: 'Identifies type of settlement',
    },
    {
        name: 'BidSpotRate',
        abbrName: 'BidSpotRt',
        added: 'FIX.4.1',
        type: 'Price',
        id: 188,
        description: 'Bid F/X spot rate.',
    },
    {
        name: 'BidForwardPoints',
        abbrName: 'BidFwdPnts',
        added: 'FIX.4.1',
        type: 'PriceOffset',
        id: 189,
        description: 'Bid F/X forward points added to spot rate. May be a negative value.',
    },
    {
        name: 'OfferSpotRate',
        abbrName: 'OfrSpotRt',
        added: 'FIX.4.1',
        type: 'Price',
        id: 190,
        description: 'Offer F/X spot rate.',
    },
    {
        name: 'OfferForwardPoints',
        abbrName: 'OfrFwdPnts',
        added: 'FIX.4.1',
        type: 'PriceOffset',
        id: 191,
        description: 'Offer F/X forward points added to spot rate. May be a negative value.',
    },
    {
        name: 'OrderQty2',
        abbrName: 'Qty2',
        added: 'FIX.4.1',
        type: 'Qty',
        deprecated: 'FIX.5.0',
        id: 192,
        description: 'OrderQty (38) of the future part of a F/X swap order.',
    },
    {
        name: 'SettlDate2',
        abbrName: 'SettlDt2',
        added: 'FIX.4.1',
        type: 'LocalMktDate',
        deprecated: 'FIX.5.0',
        id: 193,
        description: 'SettDate (64) of the future part of a F/X swap order.',
    },
    {
        name: 'LastSpotRate',
        abbrName: 'LastSpotRt',
        added: 'FIX.4.1',
        type: 'Price',
        id: 194,
        description: 'F/X spot rate.',
    },
    {
        name: 'LastForwardPoints',
        abbrName: 'LastFwdPnts',
        updated: 'FIX.Latest',
        added: 'FIX.4.1',
        type: 'PriceOffset',
        updatedEP: '282',
        id: 195,
        description:
            'F/X forward points added to LastSpotRate(194). May be a negative value. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199.',
    },
    {
        baseCategory: 'Allocation',
        name: 'AllocLinkID',
        abbrName: 'LinkID',
        added: 'FIX.4.1',
        type: 'String',
        baseCategoryAbbrName: 'LinkID',
        id: 196,
        description:
            'Can be used to link two different Allocation messages (each with unique AllocID (70)) together, i.e. for F/X "Netting" or "Swaps". Should be unique.',
    },
    {
        name: 'AllocLinkType',
        abbrName: 'LinkTyp',
        updated: 'FIX.Latest',
        added: 'FIX.4.1',
        type: 'AllocLinkTypeCodeSet',
        updatedEP: '282',
        id: 197,
        description: 'Identifies the type of Allocation linkage when AllocLinkID(196) is used.',
    },
    {
        name: 'SecondaryOrderID',
        abbrName: 'OrdID2',
        added: 'FIX.4.1',
        type: 'String',
        id: 198,
        description:
            'Assigned by the party which accepts the order. Can be used to provide the OrderID (37) used by an exchange or executing system.',
    },
    {
        name: 'NoIOIQualifiers',
        updated: 'FIX.Latest',
        added: 'FIX.4.1',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 199,
        description: 'Number of repeating groups of IOIQualifiers (04).',
    },
    {
        name: 'MaturityMonthYear',
        abbrName: 'MMY',
        updated: 'FIX.Latest',
        added: 'FIX.4.1',
        type: 'MonthYear',
        updatedEP: '282',
        id: 200,
        description:
            'Can be used with standardized derivatives vs. the MaturityDate (541) field. Month and Year of the maturity (used for standardized futures and options).\n\nFormat:\n\nYYYYMM (e.g. 199903)\n\nYYYYMMDD (e.g. 20030323)\n\nYYYYMMwN (e.g. 200303w) for week\n\nA specific date or can be appended to the MaturityMonthYear. For instance, if multiple standard products exist that mature in the same Year and Month, but actually mature at a different time, a value can be appended, such as "w" or "w2" to indicate week as opposed to week 2 expiration. Likewise, the date (0-3) can be appended to indicate a specific expiration (maturity date).',
    },
    {
        name: 'PutOrCall',
        abbrName: 'PutCall',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.1',
        type: 'PutOrCallCodeSet',
        updatedEP: '238',
        id: 201,
        description: 'Indicates whether an option contract is a put, call, chooser or undetermined.',
    },
    {
        name: 'StrikePrice',
        abbrName: 'StrkPx',
        added: 'FIX.4.1',
        type: 'Price',
        id: 202,
        description: 'Strike Price for an Option.',
    },
    {
        name: 'CoveredOrUncovered',
        abbrName: 'Covered',
        added: 'FIX.4.1',
        type: 'CoveredOrUncoveredCodeSet',
        id: 203,
        description: 'Used for derivative products, such as options',
    },
    {
        name: 'OptAttribute',
        abbrName: 'OptAt',
        added: 'FIX.4.1',
        type: 'char',
        id: 206,
        description:
            'Provided to support versioning of option contracts as a result of corporate actions or events. Use of this field is defined by counterparty agreement or market conventions.',
    },
    {
        name: 'SecurityExchange',
        abbrName: 'Exch',
        added: 'FIX.4.1',
        type: 'Exchange',
        id: 207,
        description: 'Market used to help identify a security.\n\nValid values:\n\nSee "Appendix 6-C"',
    },
    {
        name: 'NotifyBrokerOfCredit',
        abbrName: 'NotifyBrkrOfCredit',
        added: 'FIX.4.1',
        type: 'NotifyBrokerOfCreditCodeSet',
        id: 208,
        description: 'Indicates whether or not details should be communicated to BrokerOfCredit (i.e. step-in broker).',
    },
    {
        baseCategory: 'SingleGeneralOrderHandling',
        name: 'AllocHandlInst',
        abbrName: 'HandlInst',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.1',
        type: 'AllocHandlInstCodeSet',
        updatedEP: '245',
        baseCategoryAbbrName: 'HndInst',
        id: 209,
        description:
            'Indicates how the receiver (i.e. third party) of allocation information should handle/process the account details.',
    },
    {
        name: 'MaxShow',
        abbrName: 'MaxShow',
        added: 'FIX.4.1',
        type: 'Qty',
        deprecated: 'FIX.5.0',
        id: 210,
        description:
            'Maximum quantity (e.g. number of shares) within an order to be shown to other customers (i.e. sent via an IOI).\n\n(Prior to FIX 4.2 this field was of type int)',
    },
    {
        name: 'PegOffsetValue',
        abbrName: 'OfstVal',
        added: 'FIX.4.1',
        type: 'float',
        id: 211,
        description:
            'Amount (signed) added to the peg for a pegged order in the context of the PegOffsetType (836)\n\n(Prior to FIX 4.4 this field was of type PriceOffset)',
    },
    {
        name: 'XmlDataLen',
        abbrName: 'XmlDataLen',
        added: 'FIX.4.2',
        type: 'Length',
        id: 212,
        description: 'Length of the XmlData data block.',
    },
    {
        name: 'XmlData',
        abbrName: 'XmlData',
        updated: 'FIX.Latest',
        added: 'FIX.4.2',
        type: 'XMLData',
        updatedEP: '271',
        id: 213,
        lengthId: '212',
        description:
            'Actual XML data stream (e.g. FIXML). See appropriate XML reference (e.g. FIXML). Note: may contain embedded SOH characters.',
    },
    {
        name: 'SettlInstRefID',
        abbrName: 'SettlInstRefID',
        added: 'FIX.4.2',
        type: 'String',
        id: 214,
        description:
            'Reference identifier for the SettlInstID (162) with Cancel and Replace SettlInstTransType (163) transaction types.',
    },
    {
        name: 'NoRoutingIDs',
        updated: 'FIX.Latest',
        added: 'FIX.4.2',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 215,
        description:
            'Number of repeating groups of RoutingID (217) and RoutingType (216) values.\n\nSee Volume 3: "Pre-Trade Message Targeting/Routing"',
    },
    {
        name: 'RoutingType',
        abbrName: 'RtgTyp',
        added: 'FIX.4.2',
        type: 'RoutingTypeCodeSet',
        id: 216,
        description: 'Indicates the type of RoutingID (217) specified.',
    },
    {
        name: 'RoutingID',
        abbrName: 'RtgID',
        added: 'FIX.4.2',
        type: 'String',
        id: 217,
        description: 'Assigned value used to identify a specific routing destination.',
    },
    {
        name: 'Spread',
        abbrName: 'Spread',
        updated: 'FIX.Latest',
        added: 'FIX.4.2',
        type: 'PriceOffset',
        updatedEP: '282',
        id: 218,
        description:
            'For Fixed Income. Either Swap Spread or Spread to Benchmark depending upon the order type.\n\nSpread to Benchmark: Basis points relative to a benchmark. To be expressed as count of basis points (vs. an absolute value). E.g. High Grade Corporate Bonds may express price as basis points relative to benchmark (the BenchmarkCurveName(221) field). Note: Basis points can be negative.\n\nSwap Spread: Target spread for a swap.',
    },
    {
        name: 'BenchmarkCurveCurrency',
        abbrName: 'Ccy',
        updated: 'FIX.Latest',
        added: 'FIX.4.2',
        type: 'Currency',
        updatedEP: '273',
        id: 220,
        description:
            'Specifies currency used for benchmark curve.\n\nBenchmarkCurveCurrencyCodeSource(2950) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.',
    },
    {
        name: 'BenchmarkCurveName',
        abbrName: 'Name',
        added: 'FIX.4.2',
        type: 'BenchmarkCurveNameCodeSet',
        id: 221,
        description: 'Name of benchmark curve.\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
    },
    {
        name: 'BenchmarkCurvePoint',
        abbrName: 'Point',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.2',
        type: 'String',
        updatedEP: '187',
        id: 222,
        description:
            'Point on benchmark curve. Free form values: e.g. "Y", "7Y", "INTERPOLATED".\n\nSample values:\n\nM = combination of a number between 1-12 and a "M" for month\n\nY = combination of number between 1-100 and a "Y" for year}\n\n10Y-OLD = see above, then add "-OLD" when appropriate\n\nINTERPOLATED = the point is mathematically derived\n\n2/2031 5 3/8 = the point is stated via a combination of maturity month / year and coupon\n\nSee Fixed Income-specific documentation at http://www.fixtradingcommunity.org for additional values.\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
    },
    {
        name: 'CouponRate',
        abbrName: 'CpnRt',
        added: 'FIX.4.2',
        type: 'Percentage',
        id: 223,
        description:
            "The rate of interest that, when multiplied by the principal, par value, or face value of a bond, provides the currency amount of the periodic interest payment. The coupon is always cited, along with maturity, in any quotation of a bond's price.",
    },
    {
        name: 'CouponPaymentDate',
        abbrName: 'CpnPmt',
        added: 'FIX.4.2',
        type: 'LocalMktDate',
        id: 224,
        description:
            'Date interest is to be paid. Used in identifying Corporate Bond issues.\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n\n(prior to FIX 4.4 field was of type UTCDate)',
    },
    {
        name: 'IssueDate',
        abbrName: 'Issued',
        added: 'FIX.4.2',
        type: 'LocalMktDate',
        id: 225,
        description:
            'The date on which a bond or stock offering is issued. It may or may not be the same as the effective date ("Dated Date") or the date on which interest begins to accrue ("Interest Accrual Date")\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n\n(prior to FIX 4.4 field was of type UTCDate)',
    },
    {
        name: 'RepurchaseTerm',
        abbrName: 'RepoTrm',
        added: 'FIX.4.2',
        type: 'int',
        deprecated: 'FIX.4.4',
        id: 226,
        description:
            'Number of business days before repurchase of a repo. (Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
    },
    {
        name: 'RepurchaseRate',
        abbrName: 'RepoRt',
        added: 'FIX.4.2',
        type: 'Percentage',
        deprecated: 'FIX.4.4',
        id: 227,
        description:
            'Percent of par at which a Repo will be repaid. Represented as a percent, e.g. .9525 represents 95-/4 percent of par. (Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
    },
    {
        name: 'Factor',
        abbrName: 'Fctr',
        added: 'FIX.4.2',
        type: 'float',
        id: 228,
        description:
            'For Fixed Income: Amorization Factor for deriving Current face from Original face for ABS or MBS securities, note the fraction may be greater than, equal to or less than . In TIPS securities this is the Inflation index.\n\nQty * Factor * Price = Gross Trade Amount\n\nFor Derivatives: Contract Value Factor by which price must be adjusted to determine the true nominal value of one futures/options contract.\n\n(Qty * Price) * Factor = Nominal Value\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
    },
    {
        name: 'TradeOriginationDate',
        abbrName: 'OrignDt',
        added: 'FIX.4.2',
        type: 'LocalMktDate',
        id: 229,
        description:
            'Used with Fixed Income for Muncipal New Issue Market. Agreement in principal between counter-parties prior to actual trade date.\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n\n(prior to FIX 4.4 field was of type UTCDate)',
    },
    {
        name: 'ExDate',
        abbrName: 'ExDt',
        added: 'FIX.4.2',
        type: 'LocalMktDate',
        id: 230,
        description:
            'The date when a distribution of interest is deducted from a securities assets or set aside for payment to bondholders. On the ex-date, the securities price drops by the amount of the distribution (plus or minus any market activity).\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n\n(prior to FIX 4.4 field was of type UTCDate)',
    },
    {
        name: 'ContractMultiplier',
        abbrName: 'Mult',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.2',
        type: 'float',
        updatedEP: '204',
        id: 231,
        description:
            'Specifies the ratio or multiply factor to convert from "nominal" units (e.g. contracts) to total units (e.g. shares) (e.g. 1.0, 100, 1000, etc). Applicable For Fixed Income, Convertible Bonds, Derivatives, etc.\n\nIn general quantities for all classes should be expressed in the basic unit of the instrument, e.g. shares for equities, nominal or par amount for bonds, currency for foreign exchange. When quantity is expressed in contracts, e.g. financing transactions and bond trade reporting, ContractMultiplier(231) should contain the number of units in one contract and can be omitted if the multiplier is the default amount for the instrument, i.e. 1,000 par of bonds, 1,000,000 par for financing transactions.',
    },
    {
        name: 'NoStipulations',
        updated: 'FIX.Latest',
        added: 'FIX.4.2',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 232,
        description: 'Number of stipulation entries\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3).',
    },
    {
        name: 'StipulationType',
        abbrName: 'Typ',
        added: 'FIX.4.2',
        type: 'StipulationTypeCodeSet',
        id: 233,
        description:
            'For Fixed Income.\n\nType of Stipulation.\n\nOther types may be used by mutual agreement of the counterparties.\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
    },
    {
        name: 'StipulationValue',
        abbrName: 'Val',
        added: 'FIX.4.2',
        type: 'String',
        id: 234,
        description:
            'For Fixed Income. Value of stipulation.\n\nThe expression can be an absolute single value or a combination of values and logical operators:\n\n< value\n\n> value\n\n<= value\n\n>= value\n\nvalue\n\nvalue - value2\n\nvalue OR value2\n\nvalue AND value2\n\nYES\n\nNO\n\nBargain conditions recognized by the London Stock Exchange - to be used when StipulationType is "BGNCON".\n\nCD = Special cum Dividend\n\nXD = Special ex Dividend\n\nCC = Special cum Coupon\n\nXC = Special ex Coupon\n\nCB = Special cum Bonus\n\nXB = Special ex Bonus\n\nCR = Special cum Rights\n\nXR = Special ex Rights\n\nCP = Special cum Capital Repayments\n\nXP = Special ex Capital Repayments\n\nCS = Cash Settlement\n\nSP = Special Price\n\nTR = Report for European Equity Market Securities in accordance with Chapter 8 of the Rules.\n\nGD = Guaranteed Delivery\n\nValues for StipulationType = "PXSOURCE":\n\nBB GENERIC\n\nBB FAIRVALUE\n\nBROKERTEC\n\nESPEED\n\nGOVPX\n\nHILLIARD FARBER\n\nICAP\n\nTRADEWEB\n\nTULLETT LIBERTY\n\nIf a particular side of the market is wanted append /BID /OFFER or /MID.\n\nplus appropriate combinations of the above and other expressions by mutual agreement of the counterparties.\n\nExamples: ">=60", ".25", "ORANGE OR CONTRACOSTA", etc.\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
    },
    {
        name: 'YieldType',
        abbrName: 'Typ',
        added: 'FIX.4.2',
        type: 'YieldTypeCodeSet',
        id: 235,
        description: 'Type of yield. (Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
    },
    {
        name: 'Yield',
        abbrName: 'Yld',
        added: 'FIX.4.2',
        type: 'Percentage',
        id: 236,
        description: 'Yield percentage.\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
    },
    {
        name: 'TotalTakedown',
        abbrName: 'TotTakedown',
        added: 'FIX.4.2',
        type: 'Amt',
        id: 237,
        description:
            "The price at which the securities are distributed to the different members of an underwriting group for the primary market in Municipals, total gross underwriter's spread.\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
    },
    {
        name: 'Concession',
        abbrName: 'Concession',
        added: 'FIX.4.2',
        type: 'Amt',
        id: 238,
        description:
            'Provides the reduction in price for the secondary market in Muncipals.\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
    },
    {
        name: 'RepoCollateralSecurityType',
        abbrName: 'RepoCollSecTyp',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.3',
        type: 'String',
        updatedEP: '208',
        deprecated: 'FIX.4.4',
        id: 239,
        description:
            'Identifies the collateral used in the transaction.\n\nValid values: see SecurityType (167) field (Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
    },
    {
        name: 'RedemptionDate',
        abbrName: 'Redeem',
        added: 'FIX.4.2',
        type: 'LocalMktDate',
        deprecated: 'FIX.4.4',
        id: 240,
        description:
            "Return of investor's principal in a security. Bond redemption can occur before maturity date.(Note tag # was reserved in FIX 4.1, added in FIX 4.3) (prior to FIX 4.4 field was of type UTCDate)",
    },
    {
        name: 'UnderlyingCouponPaymentDate',
        abbrName: 'CpnPmt',
        added: 'FIX.4.2',
        type: 'LocalMktDate',
        id: 241,
        description:
            "Underlying security's CouponPaymentDate.\n\nSee CouponPaymentDate (224) field for description\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n\n(prior to FIX 4.4 field was of type UTCDate)",
    },
    {
        name: 'UnderlyingIssueDate',
        abbrName: 'Issued',
        added: 'FIX.4.2',
        type: 'LocalMktDate',
        id: 242,
        description:
            "Underlying security's IssueDate.\n\nSee IssueDate (225) field for description\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n\n(prior to FIX 4.4 field was of type UTCDate)",
    },
    {
        name: 'UnderlyingRepoCollateralSecurityType',
        abbrName: 'RepoCollSecTyp',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.3',
        type: 'String',
        updatedEP: '208',
        deprecated: 'FIX.4.4',
        id: 243,
        description:
            "Underlying security's RepoCollateralSecurityType. See RepoCollateralSecurityType (239) field for description.(Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
    },
    {
        name: 'UnderlyingRepurchaseTerm',
        abbrName: 'RepoTrm',
        added: 'FIX.4.2',
        type: 'int',
        deprecated: 'FIX.4.4',
        id: 244,
        description:
            "Underlying security's RepurchaseTerm. See RepurchaseTerm (226) field for description (Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
    },
    {
        name: 'UnderlyingRepurchaseRate',
        abbrName: 'RepoRt',
        added: 'FIX.4.2',
        type: 'Percentage',
        deprecated: 'FIX.4.4',
        id: 245,
        description:
            "Underlying security's RepurchaseRate. See RepurchaseRate (227) field for description (Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
    },
    {
        name: 'UnderlyingFactor',
        abbrName: 'Fctr',
        added: 'FIX.4.2',
        type: 'float',
        id: 246,
        description:
            "Underlying security's Factor.\n\nSee Factor (228) field for description\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
    },
    {
        name: 'UnderlyingRedemptionDate',
        abbrName: 'Redeem',
        added: 'FIX.4.2',
        type: 'LocalMktDate',
        deprecated: 'FIX.4.4',
        id: 247,
        description:
            "Underlying security's RedemptionDate. See RedemptionDate (240) field for description (Note tag # was reserved in FIX 4.1, added in FIX 4.3) (prior to FIX 4.4 field was of type UTCDate)",
    },
    {
        name: 'LegCouponPaymentDate',
        abbrName: 'CpnPmt',
        added: 'FIX.4.2',
        type: 'LocalMktDate',
        id: 248,
        description:
            "Multileg instrument's individual leg security's CouponPaymentDate.\n\nSee CouponPaymentDate (224) field for description\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n\n(prior to FIX 4.4 field was of type UTCDate)",
    },
    {
        name: 'LegIssueDate',
        abbrName: 'Issued',
        added: 'FIX.4.2',
        type: 'LocalMktDate',
        id: 249,
        description:
            "Multileg instrument's individual leg security's IssueDate.\n\nSee IssueDate (225) field for description\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n\n(prior to FIX 4.4 field was of type UTCDate)",
    },
    {
        name: 'LegRepoCollateralSecurityType',
        abbrName: 'RepoCollSecTyp',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.3',
        type: 'String',
        updatedEP: '208',
        deprecated: 'FIX.4.4',
        id: 250,
        description:
            "Multileg instrument's individual leg security's RepoCollateralSecurityType. See RepoCollateralSecurityType (239) field for description (Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
    },
    {
        name: 'LegRepurchaseTerm',
        abbrName: 'RepoTrm',
        added: 'FIX.4.2',
        type: 'int',
        deprecated: 'FIX.4.4',
        id: 251,
        description:
            "Multileg instrument's individual leg security's RepurchaseTerm. See RepurchaseTerm (226) field for description (Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
    },
    {
        name: 'LegRepurchaseRate',
        abbrName: 'RepoRt',
        added: 'FIX.4.2',
        type: 'Percentage',
        deprecated: 'FIX.4.4',
        id: 252,
        description:
            "Multileg instrument's individual leg security's RepurchaseRate. See RepurchaseRate (227) field for description (Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
    },
    {
        name: 'LegFactor',
        abbrName: 'Fctr',
        added: 'FIX.4.2',
        type: 'float',
        id: 253,
        description:
            "Multileg instrument's individual leg security's Factor.\n\nSee Factor (228) field for description\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
    },
    {
        name: 'LegRedemptionDate',
        abbrName: 'Redeem',
        added: 'FIX.4.2',
        type: 'LocalMktDate',
        deprecated: 'FIX.4.4',
        id: 254,
        description:
            "Multileg instrument's individual leg security's RedemptionDate. See RedemptionDate (240) field for description (Note tag # was reserved in FIX 4.1, added in FIX 4.3) (prior to FIX 4.4 field was of type UTCDate)",
    },
    {
        name: 'CreditRating',
        abbrName: 'CrdRtg',
        added: 'FIX.4.2',
        type: 'String',
        id: 255,
        description:
            "An evaluation of a company's ability to repay obligations or its likelihood of not defaulting. These evaluation are provided by Credit Rating Agencies, i.e. S&P, Moody's.\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
    },
    {
        name: 'UnderlyingCreditRating',
        abbrName: 'CrdRtg',
        added: 'FIX.4.2',
        type: 'String',
        id: 256,
        description:
            "Underlying security's CreditRating.\n\nSee CreditRating (255) field for description\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
    },
    {
        name: 'LegCreditRating',
        abbrName: 'CrdRtg',
        added: 'FIX.4.2',
        type: 'String',
        id: 257,
        description:
            "Multileg instrument's individual leg security's CreditRating.\n\nSee CreditRating (255) field for description\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
    },
    {
        name: 'TradedFlatSwitch',
        abbrName: 'TrddFlatSwitch',
        added: 'FIX.4.2',
        type: 'TradedFlatSwitchCodeSet',
        id: 258,
        description:
            'Driver and part of trade in the event that the Security Master file was wrong at the point of entry(Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
    },
    {
        name: 'BasisFeatureDate',
        abbrName: 'BasisFeatureDt',
        added: 'FIX.4.2',
        type: 'LocalMktDate',
        id: 259,
        description:
            'BasisFeatureDate allows requesting firms within fixed income the ability to request an alternative yield-to-worst, -maturity, -extended or other call. This flows through the confirm process.\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n\n(prior to FIX 4.4 field was of type UTCDate)',
    },
    {
        name: 'BasisFeaturePrice',
        abbrName: 'BasisFeaturePx',
        added: 'FIX.4.2',
        type: 'Price',
        id: 260,
        description:
            'Price for BasisFeatureDate.\n\nSee BasisFeatureDate (259)\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
    },
    {
        name: 'MDReqID',
        abbrName: 'ReqID',
        added: 'FIX.4.2',
        type: 'String',
        id: 262,
        description: 'Unique identifier for Market Data Request',
    },
    {
        name: 'SubscriptionRequestType',
        abbrName: 'SubReqTyp',
        added: 'FIX.4.2',
        type: 'SubscriptionRequestTypeCodeSet',
        id: 263,
        description: 'Subscription Request Type',
    },
    {
        name: 'MarketDepth',
        abbrName: 'MktDepth',
        added: 'FIX.4.2',
        type: 'int',
        id: 264,
        description:
            'Depth of market for Book Snapshot / Incremental updates\n\n0 - full book depth\n\n1 - top of book\n\n2 and above - book depth (number of levels)',
    },
    {
        name: 'MDUpdateType',
        abbrName: 'UpdtTyp',
        added: 'FIX.4.2',
        type: 'MDUpdateTypeCodeSet',
        id: 265,
        description: 'Specifies the type of Market Data update.',
    },
    {
        name: 'AggregatedBook',
        abbrName: 'AggBook',
        added: 'FIX.4.2',
        type: 'AggregatedBookCodeSet',
        id: 266,
        description: 'Specifies whether or not book entries should be aggregated. (Not specified) = broker option',
    },
    {
        name: 'NoMDEntryTypes',
        updated: 'FIX.Latest',
        added: 'FIX.4.2',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 267,
        description: 'Number of MDEntryType (269) fields requested.',
    },
    {
        name: 'NoMDEntries',
        updated: 'FIX.Latest',
        added: 'FIX.4.2',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 268,
        description: 'Number of entries in Market Data message.',
    },
    {
        name: 'MDEntryType',
        abbrName: 'Typ',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.2',
        type: 'MDEntryTypeCodeSet',
        updatedEP: '174',
        id: 269,
        description: 'Type of market data entry.',
    },
    {
        name: 'MDEntryPx',
        abbrName: 'Px',
        added: 'FIX.4.2',
        type: 'Price',
        id: 270,
        description: 'Price of the Market Data Entry.',
    },
    {
        name: 'MDEntrySize',
        abbrName: 'Sz',
        added: 'FIX.4.2',
        type: 'Qty',
        id: 271,
        description: 'Quantity or volume represented by the Market Data Entry.',
    },
    {
        name: 'MDEntryDate',
        abbrName: 'Dt',
        added: 'FIX.4.2',
        type: 'UTCDateOnly',
        id: 272,
        description: 'Date of Market Data Entry.\n\n(prior to FIX 4.4 field was of type UTCDate)',
    },
    {
        name: 'MDEntryTime',
        abbrName: 'Tm',
        added: 'FIX.4.2',
        type: 'UTCTimeOnly',
        id: 273,
        description: 'Time of Market Data Entry.',
    },
    {
        name: 'TickDirection',
        abbrName: 'TickDirctn',
        added: 'FIX.4.2',
        type: 'TickDirectionCodeSet',
        id: 274,
        description: 'Direction of the "tick".',
    },
    {
        name: 'MDMkt',
        abbrName: 'Mkt',
        added: 'FIX.4.2',
        type: 'Exchange',
        deprecated: 'FIX.5.0',
        id: 275,
        description: 'Market posting quote / trade.\n\nValid values:\n\nSee "Appendix 6-C"',
    },
    {
        name: 'QuoteCondition',
        abbrName: 'QCond',
        added: 'FIX.4.2',
        type: 'QuoteConditionCodeSet',
        id: 276,
        description: 'Space-delimited list of conditions describing a quote.',
    },
    {
        name: 'TradeCondition',
        abbrName: 'TrdCond',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.2',
        type: 'TradeConditionCodeSet',
        updatedEP: '190',
        id: 277,
        description: 'Type of market data entry.',
    },
    {
        baseCategory: 'MarketData',
        name: 'MDEntryID',
        abbrName: 'MDID',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.2',
        type: 'String',
        updatedEP: '125',
        baseCategoryAbbrName: 'ID',
        id: 278,
        description: 'Unique Market Data Entry identifier.',
    },
    {
        name: 'MDUpdateAction',
        abbrName: 'UpdtAct',
        added: 'FIX.4.2',
        type: 'MDUpdateActionCodeSet',
        id: 279,
        description: 'Type of Market Data update action.',
    },
    {
        name: 'MDEntryRefID',
        abbrName: 'RefID',
        added: 'FIX.4.2',
        type: 'String',
        id: 280,
        description: 'Refers to a previous MDEntryID (278).',
    },
    {
        name: 'MDReqRejReason',
        abbrName: 'ReqRejResn',
        added: 'FIX.4.2',
        type: 'MDReqRejReasonCodeSet',
        id: 281,
        description: 'Reason for the rejection of a Market Data request.',
    },
    {
        name: 'MDEntryOriginator',
        abbrName: 'Orig',
        added: 'FIX.4.2',
        type: 'String',
        deprecated: 'FIX.5.0',
        id: 282,
        description: 'Originator of a Market Data Entry',
    },
    {
        name: 'LocationID',
        abbrName: 'LctnID',
        added: 'FIX.4.2',
        type: 'String',
        id: 283,
        description: "Identification of a Market Maker's location",
    },
    {
        name: 'DeskID',
        abbrName: 'DeskID',
        added: 'FIX.4.2',
        type: 'String',
        id: 284,
        description: "Identification of a Market Maker's desk",
    },
    {
        name: 'DeleteReason',
        abbrName: 'DelRsn',
        added: 'FIX.4.2',
        type: 'DeleteReasonCodeSet',
        id: 285,
        description: 'Reason for deletion.',
    },
    {
        name: 'OpenCloseSettlFlag',
        abbrName: 'OpenClsSettlFlag',
        added: 'FIX.4.2',
        type: 'OpenCloseSettlFlagCodeSet',
        id: 286,
        description: 'Flag that identifies a market data entry. (Prior to FIX 4.3 this field was of type char)',
    },
    {
        name: 'SellerDays',
        abbrName: 'SellerDays',
        added: 'FIX.4.2',
        type: 'int',
        id: 287,
        description: 'Specifies the number of days that may elapse before delivery of the security',
    },
    {
        name: 'MDEntryBuyer',
        abbrName: 'Buyer',
        added: 'FIX.4.2',
        type: 'String',
        id: 288,
        description: 'Buying party in a trade',
    },
    {
        name: 'MDEntrySeller',
        abbrName: 'Seller',
        added: 'FIX.4.2',
        type: 'String',
        id: 289,
        description: 'Selling party in a trade',
    },
    {
        name: 'MDEntryPositionNo',
        abbrName: 'PosNo',
        updated: 'FIX.Latest',
        added: 'FIX.4.2',
        type: 'int',
        updatedEP: '271',
        id: 290,
        description:
            'Display position of a bid or offer, numbered from most competitive to least competitive, per market side, beginning with 1.',
    },
    {
        name: 'FinancialStatus',
        abbrName: 'FinclStat',
        added: 'FIX.4.2',
        type: 'FinancialStatusCodeSet',
        id: 291,
        description: "Identifies a firm's or a security's financial status",
    },
    {
        name: 'CorporateAction',
        abbrName: 'CorpActn',
        added: 'FIX.4.2',
        type: 'CorporateActionCodeSet',
        id: 292,
        description: 'Identifies the type of Corporate Action.',
    },
    {
        name: 'DefBidSize',
        abbrName: 'DefBidSz',
        added: 'FIX.4.2',
        type: 'Qty',
        id: 293,
        description: 'Default Bid Size.',
    },
    {
        name: 'DefOfferSize',
        abbrName: 'DefOfrSz',
        added: 'FIX.4.2',
        type: 'Qty',
        id: 294,
        description: 'Default Offer Size.',
    },
    {
        name: 'NoQuoteEntries',
        updated: 'FIX.Latest',
        added: 'FIX.4.2',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 295,
        description: 'The number of quote entries for a QuoteSet.',
    },
    {
        name: 'NoQuoteSets',
        updated: 'FIX.Latest',
        added: 'FIX.4.2',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 296,
        description: 'The number of sets of quotes in the message.',
    },
    {
        name: 'QuoteStatus',
        abbrName: 'Stat',
        added: 'FIX.4.2',
        type: 'QuoteStatusCodeSet',
        id: 297,
        description: 'Identifies the status of the quote acknowledgement.',
    },
    {
        name: 'QuoteCancelType',
        abbrName: 'CxlTyp',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.5.0SP1',
        added: 'FIX.4.2',
        type: 'QuoteCancelTypeCodeSet',
        updatedEP: '85',
        id: 298,
        description: 'Identifies the type of quote cancel.',
    },
    {
        name: 'QuoteEntryID',
        abbrName: 'EntryID',
        added: 'FIX.4.2',
        type: 'String',
        id: 299,
        description:
            'Unique identifier for a quote. The QuoteEntryID stays with the quote as a static identifier even if the quote is updated.',
    },
    {
        name: 'QuoteRejectReason',
        abbrName: 'RejRsn',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.Latest',
        added: 'FIX.4.2',
        type: 'QuoteRejectReasonCodeSet',
        updatedEP: '290',
        id: 300,
        description: 'Reason quote was rejected.',
    },
    {
        name: 'QuoteResponseLevel',
        abbrName: 'RspLvl',
        added: 'FIX.4.2',
        type: 'QuoteResponseLevelCodeSet',
        id: 301,
        description:
            'Level of Response requested from receiver of quote messages. A default value should be bilaterally agreed.',
    },
    {
        name: 'QuoteSetID',
        abbrName: 'SetID',
        added: 'FIX.4.2',
        type: 'String',
        id: 302,
        description: 'Unique id for the Quote Set.',
    },
    {
        name: 'QuoteRequestType',
        abbrName: 'ReqTyp',
        added: 'FIX.4.2',
        type: 'QuoteRequestTypeCodeSet',
        id: 303,
        description: 'Indicates the type of Quote Request being generated',
    },
    {
        name: 'TotNoQuoteEntries',
        abbrName: 'TotNoQuotEntries',
        updated: 'FIX.5.0SP1',
        added: 'FIX.4.2',
        type: 'int',
        updatedEP: '95',
        id: 304,
        description: 'Total number of quotes for the quote set.',
    },
    {
        name: 'UnderlyingSecurityIDSource',
        abbrName: 'Src',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.Latest',
        added: 'FIX.4.2',
        type: 'SecurityIDSourceCodeSet',
        updatedEP: '271',
        id: 305,
        description: 'Identifies class or source of the UnderlyingSecurityID(309) value.',
    },
    {
        name: 'UnderlyingIssuer',
        abbrName: 'Issr',
        updated: 'FIX.Latest',
        added: 'FIX.4.2',
        type: 'String',
        updatedEP: '282',
        id: 306,
        description: "Underlying security's Issuer.\n\nSee Issuer(106) field for description.",
    },
    {
        name: 'UnderlyingSecurityDesc',
        abbrName: 'Desc',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.2',
        type: 'String',
        updatedEP: '232',
        id: 307,
        description:
            'Description of the underlying security.\n\nCan be used by the venue or one of the trading parties to provide an optional non-normative textual description of the financial instrument.',
    },
    {
        name: 'UnderlyingSecurityExchange',
        abbrName: 'Exch',
        added: 'FIX.4.2',
        type: 'Exchange',
        id: 308,
        description:
            "Underlying security's SecurityExchange. Can be used to identify the underlying security.\n\nValid values: see SecurityExchange (207)",
    },
    {
        name: 'UnderlyingSecurityID',
        abbrName: 'ID',
        added: 'FIX.4.2',
        type: 'String',
        id: 309,
        discriminatorId: '305',
        description: "Underlying security's SecurityID.\n\nSee SecurityID (48) field for description",
    },
    {
        name: 'UnderlyingSecurityType',
        abbrName: 'SecTyp',
        added: 'FIX.4.2',
        type: 'SecurityTypeCodeSet',
        id: 310,
        description:
            "Underlying security's SecurityType.\n\nValid values: see SecurityType (167) field\n\n(see below for details concerning this fields use in conjunction with SecurityType=REPO)\n\nThe following applies when used in conjunction with SecurityType=REPO\n\nRepresents the general or specific type of security that underlies a financing agreement\n\nValid values for SecurityType=REPO:\n\nIf bonds of a particular issuer or country are wanted in an Order or are in the basket of an Execution and the SecurityType is not granular enough, include the UnderlyingIssuer (306), UnderlyingCountryOfIssue (592), UnderlyingProgram, UnderlyingRegType and/or < UnderlyingStipulations > block e.g.:",
    },
    {
        name: 'UnderlyingSymbol',
        abbrName: 'Sym',
        added: 'FIX.4.2',
        type: 'String',
        id: 311,
        description: "Underlying security's Symbol.\n\nSee Symbol (55) field for description",
    },
    {
        name: 'UnderlyingSymbolSfx',
        abbrName: 'Sfx',
        added: 'FIX.4.2',
        type: 'SymbolSfxCodeSet',
        id: 312,
        description: "Underlying security's SymbolSfx.\n\nSee SymbolSfx (65) field for description",
    },
    {
        name: 'UnderlyingMaturityMonthYear',
        abbrName: 'MMY',
        added: 'FIX.4.2',
        type: 'MonthYear',
        id: 313,
        description:
            "Underlying security's MaturityMonthYear. Can be used with standardized derivatives vs. the UnderlyingMaturityDate (542) field.\n\nSee MaturityMonthYear (200) field for description",
    },
    {
        name: 'UnderlyingPutOrCall',
        abbrName: 'PutCall',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.2',
        type: 'PutOrCallCodeSet',
        updatedEP: '238',
        id: 315,
        description: 'Indicates whether an underlying option contract is a put, call, chooser or undetermined.',
    },
    {
        name: 'UnderlyingStrikePrice',
        abbrName: 'StrkPx',
        added: 'FIX.4.2',
        type: 'Price',
        id: 316,
        description: "Underlying security's StrikePrice.\n\nSee StrikePrice (202) field for description",
    },
    {
        name: 'UnderlyingOptAttribute',
        abbrName: 'OptA',
        added: 'FIX.4.2',
        type: 'char',
        id: 317,
        description: "Underlying security's OptAttribute.\n\nSee OptAttribute (206) field for description",
    },
    {
        name: 'UnderlyingCurrency',
        abbrName: 'Ccy',
        updated: 'FIX.Latest',
        added: 'FIX.4.2',
        type: 'Currency',
        updatedEP: '273',
        id: 318,
        description: "Underlying security's currency.",
    },
    {
        name: 'SecurityReqID',
        abbrName: 'ReqID',
        added: 'FIX.4.2',
        type: 'String',
        id: 320,
        description: 'Unique ID of a Security Definition Request.',
    },
    {
        name: 'SecurityRequestType',
        abbrName: 'ReqTyp',
        added: 'FIX.4.2',
        type: 'SecurityRequestTypeCodeSet',
        id: 321,
        description: 'Type of Security Definition Request.',
    },
    {
        name: 'SecurityResponseID',
        abbrName: 'RspID',
        added: 'FIX.4.2',
        type: 'String',
        id: 322,
        description: 'Unique ID of a Security Definition message.',
    },
    {
        name: 'SecurityResponseType',
        abbrName: 'RspTyp',
        added: 'FIX.4.2',
        type: 'SecurityResponseTypeCodeSet',
        id: 323,
        description: 'Type of Security Definition message response.',
    },
    {
        name: 'SecurityStatusReqID',
        abbrName: 'StatReqID',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.2',
        type: 'String',
        updatedEP: '106',
        id: 324,
        description: 'Unique ID of a Security Status Request or a Security Mass Status Request message.',
    },
    {
        name: 'UnsolicitedIndicator',
        abbrName: 'Unsol',
        added: 'FIX.4.2',
        type: 'UnsolicitedIndicatorCodeSet',
        id: 325,
        description: 'Indicates whether or not message is being sent as a result of a subscription request or not.',
    },
    {
        name: 'SecurityTradingStatus',
        abbrName: 'TrdgStat',
        unionDataType: 'Reserved100Plus',
        added: 'FIX.4.2',
        type: 'SecurityTradingStatusCodeSet',
        id: 326,
        description: 'Identifies the trading status applicable to the transaction.',
    },
    {
        name: 'HaltReason',
        abbrName: 'HaltRsn',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.5.0SP1',
        added: 'FIX.4.2',
        type: 'HaltReasonCodeSet',
        updatedEP: '86',
        id: 327,
        description: 'Denotes the reason for the Opening Delay or Trading Halt.',
    },
    {
        name: 'InViewOfCommon',
        abbrName: 'InViewOfCmn',
        added: 'FIX.4.2',
        type: 'InViewOfCommonCodeSet',
        id: 328,
        description: 'Indicates whether or not the halt was due to Common Stock trading being halted.',
    },
    {
        name: 'DueToRelated',
        abbrName: 'DueToReltd',
        added: 'FIX.4.2',
        type: 'DueToRelatedCodeSet',
        id: 329,
        description: 'Indicates whether or not the halt was due to the Related Security being halted.',
    },
    { name: 'BuyVolume', abbrName: 'BuyVol', added: 'FIX.4.2', type: 'Qty', id: 330, description: 'Quantity bought.' },
    { name: 'SellVolume', abbrName: 'SellVol', added: 'FIX.4.2', type: 'Qty', id: 331, description: 'Quantity sold.' },
    {
        name: 'HighPx',
        abbrName: 'HighPx',
        added: 'FIX.4.2',
        type: 'Price',
        id: 332,
        description:
            'Represents an indication of the high end of the price range for a security prior to the open or reopen',
    },
    {
        name: 'LowPx',
        abbrName: 'LowPx',
        added: 'FIX.4.2',
        type: 'Price',
        id: 333,
        description:
            'Represents an indication of the low end of the price range for a security prior to the open or reopen',
    },
    {
        name: 'Adjustment',
        abbrName: 'Adjmt',
        added: 'FIX.4.2',
        type: 'AdjustmentCodeSet',
        id: 334,
        description: 'Identifies the type of adjustment.',
    },
    {
        name: 'TradSesReqID',
        abbrName: 'ReqID',
        added: 'FIX.4.2',
        type: 'String',
        id: 335,
        description: 'Unique ID of a Trading Session Status message.',
    },
    {
        name: 'TradingSessionID',
        abbrName: 'SesID',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.2',
        type: 'TradingSessionIDCodeSet',
        updatedEP: '190',
        id: 336,
        description:
            'Identifier for a trading session.\n\nA trading session spans an extended period of time that can also be expressed informally in terms of the trading day. Usage is determined by market or counterparties.\n\nTo specify good for session where session spans more than one calendar day, use TimeInForce = 0 (Day) in conjunction with TradingSessionID(336).\n\nBilaterally agreed values of data type "String" that start with a character can be used for backward compatibility.',
    },
    {
        baseCategory: 'SingleGeneralOrderHandling',
        name: 'ContraTrader',
        abbrName: 'CntraTrdr',
        added: 'FIX.4.2',
        type: 'String',
        baseCategoryAbbrName: 'Trdr',
        id: 337,
        description: 'Identifies the trader (e.g. "badge number") of the ContraBroker.',
    },
    {
        name: 'TradSesMethod',
        abbrName: 'Method',
        added: 'FIX.4.2',
        type: 'TradSesMethodCodeSet',
        id: 338,
        description: 'Method of trading',
    },
    {
        name: 'TradSesMode',
        abbrName: 'Mode',
        added: 'FIX.4.2',
        type: 'TradSesModeCodeSet',
        id: 339,
        description: 'Trading Session Mode',
    },
    {
        name: 'TradSesStatus',
        abbrName: 'Stat',
        unionDataType: 'Reserved100Plus',
        added: 'FIX.4.2',
        type: 'TradSesStatusCodeSet',
        id: 340,
        description: 'State of the trading session.',
    },
    {
        name: 'TradSesStartTime',
        abbrName: 'StartTm',
        added: 'FIX.4.2',
        type: 'UTCTimestamp',
        id: 341,
        description: 'Starting time of the trading session',
    },
    {
        name: 'TradSesOpenTime',
        abbrName: 'OpenTm',
        added: 'FIX.4.2',
        type: 'UTCTimestamp',
        id: 342,
        description: 'Time of the opening of the trading session',
    },
    {
        name: 'TradSesPreCloseTime',
        abbrName: 'PreClsTm',
        added: 'FIX.4.2',
        type: 'UTCTimestamp',
        id: 343,
        description: 'Time of the pre-closed of the trading session',
    },
    {
        name: 'TradSesCloseTime',
        abbrName: 'ClsTm',
        added: 'FIX.4.2',
        type: 'UTCTimestamp',
        id: 344,
        description: 'Closing time of the trading session',
    },
    {
        name: 'TradSesEndTime',
        abbrName: 'EndTm',
        added: 'FIX.4.2',
        type: 'UTCTimestamp',
        id: 345,
        description: 'End time of the trading session',
    },
    {
        name: 'NumberOfOrders',
        abbrName: 'NumOfOrds',
        added: 'FIX.4.2',
        type: 'int',
        id: 346,
        description: 'Number of orders in the market.',
    },
    {
        name: 'MessageEncoding',
        abbrName: 'MsgEncd',
        added: 'FIX.4.2',
        type: 'String',
        id: 347,
        description:
            'Type of message encoding (non-ASCII (non-English) characters) used in a message\'s "Encoded" fields.',
    },
    {
        name: 'EncodedIssuerLen',
        abbrName: 'EncIssrLen',
        added: 'FIX.4.2',
        type: 'Length',
        id: 348,
        description: 'Byte length of encoded (non-ASCII characters) EncodedIssuer (349) field.',
    },
    {
        name: 'EncodedIssuer',
        abbrName: 'EncIssr',
        added: 'FIX.4.2',
        type: 'data',
        id: 349,
        lengthId: '348',
        description:
            'Encoded (non-ASCII characters) representation of the Issuer field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the Issuer field.',
    },
    {
        name: 'EncodedSecurityDescLen',
        abbrName: 'EncSecDescLen',
        added: 'FIX.4.2',
        type: 'Length',
        id: 350,
        description: 'Byte length of encoded (non-ASCII characters) EncodedSecurityDesc (351) field.',
    },
    {
        name: 'EncodedSecurityDesc',
        abbrName: 'EncSecDesc',
        added: 'FIX.4.2',
        type: 'data',
        id: 351,
        lengthId: '350',
        description:
            'Encoded (non-ASCII characters) representation of the SecurityDesc (107) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the SecurityDesc field.',
    },
    {
        name: 'EncodedListExecInstLen',
        abbrName: 'EncListExecInstLen',
        added: 'FIX.4.2',
        type: 'Length',
        id: 352,
        description: 'Byte length of encoded (non-ASCII characters) EncodedListExecInst (353) field.',
    },
    {
        name: 'EncodedListExecInst',
        abbrName: 'EncListExecInst',
        added: 'FIX.4.2',
        type: 'data',
        id: 353,
        lengthId: '352',
        description:
            'Encoded (non-ASCII characters) representation of the ListExecInst (69) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the ListExecInst field.',
    },
    {
        name: 'EncodedTextLen',
        abbrName: 'EncTxtLen',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.2',
        type: 'Length',
        updatedEP: '192',
        id: 354,
        description: 'Byte length of encoded (non-ASCII characters) EncodedText (355) field.',
    },
    {
        name: 'EncodedText',
        abbrName: 'EncTxt',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.2',
        type: 'data',
        updatedEP: '192',
        id: 355,
        lengthId: '354',
        description:
            'Encoded (non-ASCII characters) representation of the Text (58) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the Text(58) field.',
    },
    {
        name: 'EncodedSubjectLen',
        abbrName: 'EncSubjectLen',
        added: 'FIX.4.2',
        type: 'Length',
        id: 356,
        description: 'Byte length of encoded (non-ASCII characters) EncodedSubject (357) field.',
    },
    {
        name: 'EncodedSubject',
        abbrName: 'EncSubject',
        added: 'FIX.4.2',
        type: 'data',
        id: 357,
        lengthId: '356',
        description:
            'Encoded (non-ASCII characters) representation of the Subject (147) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the Subject field.',
    },
    {
        name: 'EncodedHeadlineLen',
        abbrName: 'EncHeadlineLen',
        added: 'FIX.4.2',
        type: 'Length',
        id: 358,
        description: 'Byte length of encoded (non-ASCII characters) EncodedHeadline (359) field.',
    },
    {
        name: 'EncodedHeadline',
        abbrName: 'EncHeadline',
        added: 'FIX.4.2',
        type: 'data',
        id: 359,
        lengthId: '358',
        description:
            'Encoded (non-ASCII characters) representation of the Headline (148) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the Headline field.',
    },
    {
        name: 'EncodedAllocTextLen',
        abbrName: 'EncAllocTextLen',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.2',
        type: 'Length',
        updatedEP: '192',
        id: 360,
        description: 'Byte length of encoded (non-ASCII characters) EncodedAllocText (361) field.',
    },
    {
        name: 'EncodedAllocText',
        abbrName: 'EncAllocText',
        added: 'FIX.4.2',
        type: 'data',
        id: 361,
        lengthId: '360',
        description:
            'Encoded (non-ASCII characters) representation of the AllocText (161) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the AllocText field.',
    },
    {
        name: 'EncodedUnderlyingIssuerLen',
        abbrName: 'EncUndIssrLen',
        added: 'FIX.4.2',
        type: 'Length',
        id: 362,
        description: 'Byte length of encoded (non-ASCII characters) EncodedUnderlyingIssuer (363) field.',
    },
    {
        name: 'EncodedUnderlyingIssuer',
        abbrName: 'EncUndIssr',
        added: 'FIX.4.2',
        type: 'data',
        id: 363,
        lengthId: '362',
        description:
            'Encoded (non-ASCII characters) representation of the UnderlyingIssuer (306) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the UnderlyingIssuer field.',
    },
    {
        name: 'EncodedUnderlyingSecurityDescLen',
        abbrName: 'EncUndSecDescLen',
        added: 'FIX.4.2',
        type: 'Length',
        id: 364,
        description: 'Byte length of encoded (non-ASCII characters) EncodedUnderlyingSecurityDesc (365) field.',
    },
    {
        name: 'EncodedUnderlyingSecurityDesc',
        abbrName: 'EncUndSecDesc',
        added: 'FIX.4.2',
        type: 'data',
        id: 365,
        lengthId: '364',
        description:
            'Encoded (non-ASCII characters) representation of the UnderlyingSecurityDesc (307) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the UnderlyingSecurityeDesc field.',
    },
    {
        name: 'AllocPrice',
        abbrName: 'Px',
        added: 'FIX.4.2',
        type: 'Price',
        id: 366,
        description:
            'Executed price for an AllocAccount (79) entry used when using "executed price" vs. "average price" allocations (e.g. Japan).',
    },
    {
        name: 'QuoteSetValidUntilTime',
        abbrName: 'ValidTil',
        added: 'FIX.4.2',
        type: 'UTCTimestamp',
        id: 367,
        description:
            'Indicates expiration time of this particular QuoteSet (always expressed in UTC (Universal Time Coordinated, also known as "GMT")',
    },
    {
        name: 'QuoteEntryRejectReason',
        abbrName: 'EntryRejRsn',
        unionDataType: 'Reserved100Plus',
        added: 'FIX.4.2',
        type: 'QuoteRejectReasonCodeSet',
        id: 368,
        description: 'Reason Quote Entry was rejected:',
    },
    {
        name: 'LastMsgSeqNumProcessed',
        abbrName: 'LastMsgSeqNumProced',
        added: 'FIX.4.2',
        type: 'SeqNum',
        id: 369,
        description:
            'The last MsgSeqNum (34) value received by the FIX engine and processed by downstream application, such as trading engine or order routing system. Can be specified on every message sent. Useful for detecting a backlog with a counterparty.',
    },
    {
        name: 'RefTagID',
        abbrName: 'RefTagID',
        added: 'FIX.4.2',
        type: 'int',
        id: 371,
        description: 'The tag number of the FIX field being referenced.',
    },
    {
        name: 'RefMsgType',
        abbrName: 'RefMsgTyp',
        added: 'FIX.4.2',
        type: 'MsgTypeCodeSet',
        id: 372,
        description: 'The MsgType (35) of the FIX message being referenced.',
    },
    {
        name: 'SessionRejectReason',
        abbrName: 'SessRejRsn',
        unionDataType: 'Reserved100Plus',
        added: 'FIX.4.2',
        type: 'SessionRejectReasonCodeSet',
        id: 373,
        description: 'Code to identify reason for a session-level Reject message.',
    },
    {
        name: 'BidRequestTransType',
        abbrName: 'BidReqTransTyp',
        added: 'FIX.4.2',
        type: 'BidRequestTransTypeCodeSet',
        id: 374,
        description: 'Identifies the Bid Request message type.',
    },
    {
        name: 'ContraBroker',
        abbrName: 'CntraBrkr',
        added: 'FIX.4.2',
        type: 'String',
        id: 375,
        description: 'Identifies contra broker. Standard NASD market-maker mnemonic is preferred.',
    },
    {
        name: 'ComplianceID',
        abbrName: 'ComplianceID',
        added: 'FIX.4.2',
        type: 'String',
        id: 376,
        description: 'ID used to represent this transaction for compliance purposes (e.g. OATS reporting).',
    },
    {
        name: 'SolicitedFlag',
        abbrName: 'SolFlag',
        added: 'FIX.4.2',
        type: 'SolicitedFlagCodeSet',
        id: 377,
        description: 'Indicates whether or not the order was solicited.',
    },
    {
        name: 'ExecRestatementReason',
        abbrName: 'ExecRstmtRsn',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.2',
        type: 'ExecRestatementReasonCodeSet',
        updatedEP: '195',
        id: 378,
        description:
            'The reason for restatement when an ExecutionReport(35=8) or TradeCaptureReport(35=AE) message is sent with ExecType(150) = D (Restated) or used when communicating an unsolicited cancel.',
    },
    {
        name: 'BusinessRejectRefID',
        abbrName: 'BizRejRefID',
        added: 'FIX.4.2',
        type: 'String',
        id: 379,
        description: 'The value of the business-level "ID" field on the message being referenced.',
    },
    {
        name: 'BusinessRejectReason',
        abbrName: 'BizRejRsn',
        added: 'FIX.4.2',
        type: 'BusinessRejectReasonCodeSet',
        id: 380,
        description: 'Code to identify reason for a Business Message Reject message.',
    },
    {
        name: 'GrossTradeAmt',
        abbrName: 'GrossTrdAmt',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.2',
        type: 'Amt',
        updatedEP: '258',
        id: 381,
        description:
            'Total amount traded expressed in units of currency - usually quantity * price. For FX Futures this is used to express the notional value of a fill when quantity fields are expressed in terms of contract size (i.e. quantity * price * contract size).',
    },
    {
        name: 'NoContraBrokers',
        updated: 'FIX.Latest',
        added: 'FIX.4.2',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 382,
        description: 'The number of ContraBroker (375) entries.',
    },
    {
        name: 'MaxMessageSize',
        abbrName: 'MaxMsgSz',
        added: 'FIX.4.2',
        type: 'Length',
        id: 383,
        description: 'Maximum number of bytes supported for a single message.',
    },
    {
        name: 'NoMsgTypes',
        updated: 'FIX.Latest',
        added: 'FIX.4.2',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 384,
        description: 'Number of MsgTypes (35) in repeating group.',
    },
    {
        name: 'MsgDirection',
        abbrName: 'MsgDirctn',
        updated: 'FIX.Latest',
        added: 'FIX.4.2',
        type: 'MsgDirectionCodeSet',
        updatedEP: '275',
        id: 385,
        description: 'Specifies the direction of the message.',
    },
    {
        name: 'NoTradingSessions',
        updated: 'FIX.Latest',
        added: 'FIX.4.2',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 386,
        description: 'Number of TradingSessionIDs (336) in repeating group.',
    },
    {
        name: 'TotalVolumeTraded',
        abbrName: 'TotVolTrdd',
        added: 'FIX.4.2',
        type: 'Qty',
        id: 387,
        description: 'Total volume (quantity) traded.',
    },
    {
        name: 'DiscretionInst',
        abbrName: 'DsctnInst',
        added: 'FIX.4.2',
        type: 'DiscretionInstCodeSet',
        id: 388,
        description:
            'Code to identify the price a DiscretionOffsetValue (389) is related to and should be mathematically added to.',
    },
    {
        name: 'DiscretionOffsetValue',
        abbrName: 'OfstValu',
        added: 'FIX.4.2',
        type: 'float',
        id: 389,
        description:
            'Amount (signed) added to the "related to" price specified via DiscretionInst (388), in the context of DiscretionOffsetType (842)\n\n(Prior to FIX 4.4 this field was of type PriceOffset)',
    },
    {
        name: 'BidID',
        abbrName: 'BidID',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.2',
        type: 'String',
        updatedEP: '144',
        id: 390,
        description:
            'For bid lists, unique identifier for BidResponse(35=I) as assigned by sell-side (broker, exchange, ECN). Uniqueness must be guaranteed within a single trading day.\n\nFor quotes, unique identifier for the bid side of the quote assigned by the quote issuer.',
    },
    {
        name: 'ClientBidID',
        abbrName: 'ClBidID',
        added: 'FIX.4.2',
        type: 'String',
        id: 391,
        description:
            'Unique identifier for a Bid Request as assigned by institution. Uniqueness must be guaranteed within a single trading day.',
    },
    {
        name: 'ListName',
        abbrName: 'ListName',
        added: 'FIX.4.2',
        type: 'String',
        id: 392,
        description: 'Descriptive name for list order.',
    },
    {
        name: 'TotNoRelatedSym',
        abbrName: 'TotNoReltdSym',
        added: 'FIX.4.2',
        type: 'int',
        id: 393,
        description: 'Total number of securities.\n\n(Prior to FIX 4.4 this field was named TotalNumSecurities)',
    },
    {
        name: 'BidType',
        abbrName: 'BidTyp',
        added: 'FIX.4.2',
        type: 'BidTypeCodeSet',
        id: 394,
        description: 'Code to identify the type of Bid Request.',
    },
    {
        name: 'NumTickets',
        abbrName: 'NumTkts',
        added: 'FIX.4.2',
        type: 'int',
        id: 395,
        description: 'Total number of tickets.',
    },
    {
        name: 'SideValue1',
        abbrName: 'SideValu1',
        added: 'FIX.4.2',
        type: 'Amt',
        id: 396,
        description: 'Amounts in currency',
    },
    {
        name: 'SideValue2',
        abbrName: 'SideValu2',
        added: 'FIX.4.2',
        type: 'Amt',
        id: 397,
        description: 'Amounts in currency',
    },
    {
        name: 'NoBidDescriptors',
        updated: 'FIX.Latest',
        added: 'FIX.4.2',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 398,
        description: 'Number of BidDescriptor (400) entries.',
    },
    {
        name: 'BidDescriptorType',
        abbrName: 'BidDescptrTyp',
        added: 'FIX.4.2',
        type: 'BidDescriptorTypeCodeSet',
        id: 399,
        description: 'Code to identify the type of BidDescriptor (400).',
    },
    {
        name: 'BidDescriptor',
        abbrName: 'BidDescptr',
        added: 'FIX.4.2',
        type: 'String',
        id: 400,
        description:
            'BidDescriptor value. Usage depends upon BidDescriptorTyp (399).\n\nIf BidDescriptorType = 1\n\nIndustrials etc - Free text\n\nIf BidDescriptorType = 2\n\n"FR" etc - ISO Country Codes\n\nIf BidDescriptorType = 3\n\nFT00, FT250, STOX - Free text',
    },
    {
        name: 'SideValueInd',
        abbrName: 'SideValuInd',
        added: 'FIX.4.2',
        type: 'SideValueIndCodeSet',
        id: 401,
        description:
            'Code to identify which "SideValue" the value refers to. SideValue1 and SideValue2 are used as opposed to Buy or Sell so that the basket can be quoted either way as Buy or Sell.',
    },
    {
        name: 'LiquidityPctLow',
        abbrName: 'LqdtyPctLow',
        added: 'FIX.4.2',
        type: 'Percentage',
        id: 402,
        description: 'Liquidity indicator or lower limit if TotalNumSecurities (393) > 1. Represented as a percentage.',
    },
    {
        name: 'LiquidityPctHigh',
        abbrName: 'LqdtyPctHigh',
        added: 'FIX.4.2',
        type: 'Percentage',
        id: 403,
        description: 'Upper liquidity indicator if TotalNumSecurities (393) > 1. Represented as a percentage.',
    },
    {
        name: 'LiquidityValue',
        abbrName: 'LqdtyValu',
        added: 'FIX.4.2',
        type: 'Amt',
        id: 404,
        description: 'Value between LiquidityPctLow (402) and LiquidityPctHigh (403) in Currency',
    },
    {
        name: 'EFPTrackingError',
        abbrName: 'EFPTrkngErr',
        added: 'FIX.4.2',
        type: 'Percentage',
        id: 405,
        description: 'Eg Used in EFP trades 2% (EFP - Exchange for Physical ). Represented as a percentage.',
    },
    {
        name: 'FairValue',
        abbrName: 'FairValu',
        added: 'FIX.4.2',
        type: 'Amt',
        id: 406,
        description: 'Used in EFP trades',
    },
    {
        name: 'OutsideIndexPct',
        abbrName: 'OutsideNdxPct',
        added: 'FIX.4.2',
        type: 'Percentage',
        id: 407,
        description: 'Used in EFP trades. Represented as a percentage.',
    },
    {
        name: 'ValueOfFutures',
        abbrName: 'ValuOfFuts',
        added: 'FIX.4.2',
        type: 'Amt',
        id: 408,
        description: 'Used in EFP trades',
    },
    {
        name: 'LiquidityIndType',
        abbrName: 'LqdtyIndTyp',
        added: 'FIX.4.2',
        type: 'LiquidityIndTypeCodeSet',
        id: 409,
        description: 'Code to identify the type of liquidity indicator.',
    },
    {
        name: 'WtAverageLiquidity',
        abbrName: 'WtAvgLqdty',
        added: 'FIX.4.2',
        type: 'Percentage',
        id: 410,
        description:
            'Overall weighted average liquidity expressed as a % of average daily volume. Represented as a percentage.',
    },
    {
        name: 'ExchangeForPhysical',
        abbrName: 'EFP',
        added: 'FIX.4.2',
        type: 'ExchangeForPhysicalCodeSet',
        id: 411,
        description: 'Indicates whether or not to exchange for phsyical.',
    },
    {
        name: 'OutMainCntryUIndex',
        abbrName: 'OutMainCntryUNdx',
        added: 'FIX.4.2',
        type: 'Amt',
        id: 412,
        description: 'Value of stocks in Currency',
    },
    {
        baseCategory: 'CrossOrders',
        name: 'CrossPercent',
        abbrName: 'CrssPct',
        added: 'FIX.4.2',
        type: 'Percentage',
        baseCategoryAbbrName: 'Pct',
        id: 413,
        description: 'Percentage of program that crosses in Currency. Represented as a percentage.',
    },
    {
        name: 'ProgRptReqs',
        abbrName: 'ProgRptReqs',
        added: 'FIX.4.2',
        type: 'ProgRptReqsCodeSet',
        id: 414,
        description: 'Code to identify the desired frequency of progress reports.',
    },
    {
        name: 'ProgPeriodInterval',
        abbrName: 'ProgPeriodIntvl',
        added: 'FIX.4.2',
        type: 'int',
        id: 415,
        description: "Time in minutes between each ListStatus report sent by SellSide. Zero means don't send status.",
    },
    {
        name: 'IncTaxInd',
        abbrName: 'IncTaxInd',
        added: 'FIX.4.2',
        type: 'IncTaxIndCodeSet',
        id: 416,
        description: 'Code to represent whether value is net (inclusive of tax) or gross.',
    },
    {
        name: 'NumBidders',
        abbrName: 'NumBidders',
        added: 'FIX.4.2',
        type: 'int',
        id: 417,
        description: 'Indicates the total number of bidders on the list',
    },
    {
        name: 'BidTradeType',
        abbrName: 'BidTrdTyp',
        added: 'FIX.4.2',
        type: 'BidTradeTypeCodeSet',
        id: 418,
        description: 'Code to represent the type of trade.\n\n(Prior to FIX 4.4 this field was named "TradeType")',
    },
    {
        name: 'BasisPxType',
        abbrName: 'BasisPxTyp',
        added: 'FIX.4.2',
        type: 'BasisPxTypeCodeSet',
        id: 419,
        description: 'Code to represent the basis price type.',
    },
    {
        name: 'NoBidComponents',
        updated: 'FIX.Latest',
        added: 'FIX.4.2',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 420,
        description: 'Indicates the number of list entries.',
    },
    {
        name: 'Country',
        abbrName: 'Ctry',
        added: 'FIX.4.2',
        type: 'Country',
        id: 421,
        description: 'ISO Country Code in field',
    },
    {
        name: 'TotNoStrikes',
        abbrName: 'TotNoStrks',
        added: 'FIX.4.2',
        type: 'int',
        id: 422,
        description:
            'Total number of strike price entries across all messages. Should be the sum of all NoStrikes (428) in each message that has repeating strike price entries related to the same ListID (66). Used to support fragmentation.',
    },
    {
        name: 'PriceType',
        abbrName: 'PxTyp',
        updated: 'FIX.Latest',
        added: 'FIX.4.2',
        type: 'PriceTypeCodeSet',
        updatedEP: '271',
        id: 423,
        description: 'Code to represent the price type.\n\n',
    },
    {
        name: 'DayOrderQty',
        abbrName: 'DayOrdQty',
        added: 'FIX.4.2',
        type: 'Qty',
        id: 424,
        description:
            'For GT orders, the OrderQty (38) less all quantity (adjusted for stock splits) that traded on previous days. DayOrderQty (424) = OrderQty - (CumQty (14) - DayCumQty (425))',
    },
    {
        name: 'DayCumQty',
        abbrName: 'DayCumQty',
        added: 'FIX.4.2',
        type: 'Qty',
        id: 425,
        description: 'Quantity on a GT order that has traded today.',
    },
    {
        name: 'DayAvgPx',
        abbrName: 'DayAvgPx',
        added: 'FIX.4.2',
        type: 'Price',
        id: 426,
        description: 'The average price for quantity on a GT order that has traded today.',
    },
    {
        name: 'GTBookingInst',
        abbrName: 'GTBkngInst',
        added: 'FIX.4.2',
        type: 'GTBookingInstCodeSet',
        id: 427,
        description:
            'Code to identify whether to book out executions on a part-filled GT order on the day of execution or to accumulate.',
    },
    {
        name: 'NoStrikes',
        updated: 'FIX.Latest',
        added: 'FIX.4.2',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 428,
        description: 'Number of list strike price entries.',
    },
    {
        name: 'ListStatusType',
        abbrName: 'ListStatTyp',
        added: 'FIX.4.2',
        type: 'ListStatusTypeCodeSet',
        id: 429,
        description: 'Code to represent the status type.',
    },
    {
        name: 'NetGrossInd',
        abbrName: 'NetGrossInd',
        added: 'FIX.4.2',
        type: 'NetGrossIndCodeSet',
        id: 430,
        description: 'Code to represent whether value is net (inclusive of tax) or gross.',
    },
    {
        name: 'ListOrderStatus',
        abbrName: 'ListOrdStat',
        added: 'FIX.4.2',
        type: 'ListOrderStatusCodeSet',
        id: 431,
        description: 'Code to represent the status of a list order.',
    },
    {
        name: 'ExpireDate',
        abbrName: 'ExpireDt',
        added: 'FIX.4.2',
        type: 'LocalMktDate',
        id: 432,
        description:
            "Date of order expiration (last day the order can trade), always expressed in terms of the local market date. The time at which the order expires is determined by the local market's business practices",
    },
    {
        name: 'ListExecInstType',
        abbrName: 'ListExecInstTyp',
        added: 'FIX.4.2',
        type: 'ListExecInstTypeCodeSet',
        id: 433,
        description: 'Identifies the type of ListExecInst (69).',
    },
    {
        name: 'CxlRejResponseTo',
        abbrName: 'CxlRejRspTo',
        added: 'FIX.4.2',
        type: 'CxlRejResponseToCodeSet',
        id: 434,
        description: 'Identifies the type of request that a Cancel Reject is in response to.',
    },
    {
        name: 'UnderlyingCouponRate',
        abbrName: 'CpnRt',
        added: 'FIX.4.2',
        type: 'Percentage',
        id: 435,
        description: "Underlying security's CouponRate.\n\nSee CouponRate (223) field for description",
    },
    {
        name: 'UnderlyingContractMultiplier',
        abbrName: 'Mult',
        added: 'FIX.4.2',
        type: 'float',
        id: 436,
        description: "Underlying security's ContractMultiplier.\n\nSee ContractMultiplier (231) field for description",
    },
    {
        baseCategory: 'SingleGeneralOrderHandling',
        name: 'ContraTradeQty',
        abbrName: 'CntraTrdQty',
        added: 'FIX.4.2',
        type: 'Qty',
        baseCategoryAbbrName: 'TrdQty',
        id: 437,
        description: 'Quantity traded with the ContraBroker (375).',
    },
    {
        baseCategory: 'SingleGeneralOrderHandling',
        name: 'ContraTradeTime',
        abbrName: 'CntraTrdTm',
        added: 'FIX.4.2',
        type: 'UTCTimestamp',
        baseCategoryAbbrName: 'TrdTm',
        id: 438,
        description:
            'Identifes the time of the trade with the ContraBroker (375). (always expressed in UTC (Universal Time Coordinated, also known as "GMT")',
    },
    {
        name: 'LiquidityNumSecurities',
        abbrName: 'LqdtyNumSecurities',
        added: 'FIX.4.2',
        type: 'int',
        id: 441,
        description: 'Number of Securites between LiquidityPctLow (402) and LiquidityPctHigh (403) in Currency.',
    },
    {
        name: 'MultiLegReportingType',
        abbrName: 'MLegRptTyp',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.2',
        type: 'MultiLegReportingTypeCodeSet',
        updatedEP: '150',
        id: 442,
        description:
            'Used to indicate how the multi-legged security (e.g. option strategies, spreads, etc.) is being reported.',
    },
    {
        name: 'StrikeTime',
        abbrName: 'StrkTm',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.2',
        type: 'UTCTimestamp',
        updatedEP: '226',
        id: 443,
        description:
            'The time at which current market prices are used to determine the value of a basket.\n\nIn negotiation workflows where a spread-to-benchmark price is negotiated, this is the pre-determined time at which the benchmark is to be spotted.',
    },
    {
        name: 'ListStatusText',
        abbrName: 'ListStatText',
        added: 'FIX.4.2',
        type: 'String',
        id: 444,
        description: 'Free format text string related to List Status.',
    },
    {
        name: 'EncodedListStatusTextLen',
        abbrName: 'EncListStatTextLen',
        added: 'FIX.4.2',
        type: 'Length',
        id: 445,
        description: 'Byte length of encoded (non-ASCII characters) EncodedListStatusText (446) field.',
    },
    {
        name: 'EncodedListStatusText',
        abbrName: 'EncListStatText',
        added: 'FIX.4.2',
        type: 'data',
        id: 446,
        lengthId: '445',
        description:
            'Encoded (non-ASCII characters) representation of the ListStatusText (444) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the ListStatusText field.',
    },
    {
        name: 'PartyIDSource',
        abbrName: 'Src',
        added: 'FIX.4.3',
        type: 'PartyIDSourceCodeSet',
        id: 447,
        description:
            'Identifies class or source of the PartyID (448) value. Required if PartyID is specified. Note: applicable values depend upon PartyRole (452) specified.\n\nSee "Appendix 6-G - Use of <Parties> Component Block"',
    },
    {
        name: 'PartyID',
        abbrName: 'ID',
        added: 'FIX.4.3',
        type: 'String',
        id: 448,
        discriminatorId: '447',
        description:
            'Party identifier/code. See PartyIDSource (447) and PartyRole (452).\n\nSee "Appendix 6-G - Use of <Parties> Component Block"',
    },
    {
        name: 'NetChgPrevDay',
        abbrName: 'NetChgPrevDay',
        added: 'FIX.4.3',
        type: 'PriceOffset',
        id: 451,
        description: "Net change from previous day's closing price vs. last traded price.",
    },
    {
        name: 'PartyRole',
        abbrName: 'R',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.3',
        type: 'PartyRoleCodeSet',
        updatedEP: '256',
        id: 452,
        description: 'Identifies the type or role of the PartyID (448) specified.',
    },
    {
        name: 'NoPartyIDs',
        updated: 'FIX.Latest',
        added: 'FIX.4.3',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 453,
        description: 'Number of PartyID (448), PartyIDSource (447), and PartyRole (452) entries',
    },
    {
        name: 'NoSecurityAltID',
        updated: 'FIX.Latest',
        added: 'FIX.4.3',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 454,
        description: 'Number of SecurityAltID (455) entries.',
    },
    {
        name: 'SecurityAltID',
        abbrName: 'AltID',
        added: 'FIX.4.3',
        type: 'String',
        id: 455,
        discriminatorId: '456',
        description:
            'Alternate Security identifier value for this security of SecurityAltIDSource (456) type (e.g. CUSIP, SEDOL, ISIN, etc). Requires SecurityAltIDSource.',
    },
    {
        name: 'SecurityAltIDSource',
        abbrName: 'AltIDSrc',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.Latest',
        added: 'FIX.4.3',
        type: 'SecurityIDSourceCodeSet',
        updatedEP: '271',
        id: 456,
        description: 'Identifies class or source of the SecurityAltID(455) value.',
    },
    {
        name: 'NoUnderlyingSecurityAltID',
        updated: 'FIX.Latest',
        added: 'FIX.4.3',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 457,
        description: 'Number of UnderlyingSecurityAltID (458) entries.',
    },
    {
        name: 'UnderlyingSecurityAltID',
        abbrName: 'AltID',
        added: 'FIX.4.3',
        type: 'String',
        id: 458,
        discriminatorId: '459',
        description:
            'Alternate Security identifier value for this underlying security of UnderlyingSecurityAltIDSource (459) type (e.g. CUSIP, SEDOL, ISIN, etc). Requires UnderlyingSecurityAltIDSource.',
    },
    {
        name: 'UnderlyingSecurityAltIDSource',
        abbrName: 'AltIDSrc',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.Latest',
        added: 'FIX.4.3',
        type: 'SecurityIDSourceCodeSet',
        updatedEP: '271',
        id: 459,
        description:
            'Identifies class or source of the UnderlyingSecurityAltID(458) value.\n\nRequired if UnderlyingSecurityAltID is specified.',
    },
    {
        name: 'Product',
        abbrName: 'Prod',
        added: 'FIX.4.3',
        type: 'ProductCodeSet',
        id: 460,
        description:
            'Indicates the type of product the security is associated with. See also the CFICode (461) and SecurityType (167) fields.',
    },
    {
        name: 'CFICode',
        abbrName: 'CFI',
        added: 'FIX.4.3',
        type: 'String',
        id: 461,
        description:
            'Indicates the type of security using ISO 10962 standard, Classification of Financial Instruments (CFI code) values. ISO 10962 is maintained by ANNA (Association of National Numbering Agencies) acting as Registration Authority. See "Appendix 6-B FIX Fields Based Upon Other Standards". See also the Product (460) and SecurityType (167) fields. It is recommended that CFICode be used instead of SecurityType (167) for non-Fixed Income instruments.\n\nA subset of possible values applicable to FIX usage are identified in "Appendix 6-D CFICode Usage - ISO 10962 Classification of Financial Instruments (CFI code)"',
    },
    {
        name: 'UnderlyingProduct',
        abbrName: 'Prod',
        added: 'FIX.4.3',
        type: 'ProductCodeSet',
        id: 462,
        description: "Underlying security's Product.\n\nValid values: see Product(460) field",
    },
    {
        name: 'UnderlyingCFICode',
        abbrName: 'CFI',
        added: 'FIX.4.3',
        type: 'String',
        id: 463,
        description: "Underlying security's CFICode.\n\nValid values: see CFICode (461) field",
    },
    {
        name: 'TestMessageIndicator',
        abbrName: 'TestMsgInd',
        added: 'FIX.4.3',
        type: 'TestMessageIndicatorCodeSet',
        id: 464,
        description:
            'Indicates whether or not this FIX Session is a "test" vs. "production" connection. Useful for preventing "accidents".',
    },
    {
        name: 'BookingRefID',
        abbrName: 'BkngRefID',
        added: 'FIX.4.3',
        type: 'String',
        id: 466,
        description: 'Common reference passed to a post-trade booking process (e.g. industry matching utility).',
    },
    {
        name: 'IndividualAllocID',
        abbrName: 'IndAllocID',
        added: 'FIX.4.3',
        type: 'String',
        id: 467,
        description:
            'Unique identifier for a specific NoAllocs (78) repeating group instance (e.g. for an AllocAccount).',
    },
    {
        name: 'RoundingDirection',
        abbrName: 'RndDir',
        added: 'FIX.4.3',
        type: 'RoundingDirectionCodeSet',
        id: 468,
        description:
            'Specifies which direction to round For CIV - indicates whether or not the quantity of shares/units is to be rounded and in which direction where CashOrdQty (152) or (for CIV only) OrderPercent (516) are specified on an order.\n\nThe default is for rounding to be at the discretion of the executing broker or fund manager.\n\ne.g. for an order specifying CashOrdQty or OrderPercent if the calculated number of shares/units was 325.76 and RoundingModulus (469) was 0 - "round down" would give 320 units, 1 - "round up" would give 330 units and "round to nearest" would give 320 units.',
    },
    {
        name: 'RoundingModulus',
        abbrName: 'RndMod',
        added: 'FIX.4.3',
        type: 'float',
        id: 469,
        description:
            'For CIV - a float value indicating the value to which rounding is required.\n\ni.e. 0 means round to a multiple of 0 units/shares; 0.5 means round to a multiple of 0.5 units/shares.\n\nThe default, if RoundingDirection (468) is specified without RoundingModulus, is to round to a whole unit/share.',
    },
    {
        name: 'CountryOfIssue',
        abbrName: 'IssuCtry',
        added: 'FIX.4.3',
        type: 'Country',
        id: 470,
        description:
            'ISO Country code of instrument issue (e.g. the country portion typically used in ISIN). Can be used in conjunction with non-ISIN SecurityID (48) (e.g. CUSIP for Municipal Bonds without ISIN) to provide uniqueness.',
    },
    {
        name: 'StateOrProvinceOfIssue',
        abbrName: 'StPrv',
        added: 'FIX.4.3',
        type: 'String',
        id: 471,
        description: 'A two-character state or province abbreviation.',
    },
    {
        name: 'LocaleOfIssue',
        abbrName: 'Lcl',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.3',
        type: 'String',
        updatedEP: '192',
        id: 472,
        description:
            'Identifies the locale or region of issue.\n\nFor Municipal Security Issuers other than state or province. Refer to http://www.atmos.albany.edu/cgi/stagrep-cgi. Reference the IATA city codes for values. Note IATA (International Air Transport Association) maintains the codes at www.iata.org. For other securities the value may be a region of the issuer, e.g. North America.',
    },
    {
        name: 'NoRegistDtls',
        updated: 'FIX.Latest',
        added: 'FIX.4.3',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 473,
        description: 'The number of registration details on a Registration Instructions message',
    },
    {
        name: 'MailingDtls',
        abbrName: 'MailingDtls',
        added: 'FIX.4.3',
        type: 'String',
        id: 474,
        description: 'Set of Correspondence address details, possibly including phone, fax, etc.',
    },
    {
        name: 'InvestorCountryOfResidence',
        abbrName: 'InvestorCtryOfResidence',
        updated: 'FIX.Latest',
        added: 'FIX.4.3',
        type: 'Country',
        updatedEP: '271',
        id: 475,
        description:
            'The ISO 3166 Country code (2 character) identifying which country the beneficial investor is resident for tax purposes.',
    },
    {
        name: 'PaymentRef',
        abbrName: 'PmtRef',
        added: 'FIX.4.3',
        type: 'String',
        id: 476,
        description:
            '"Settlement Payment Reference" - A free format Payment reference to assist with reconciliation, e.g. a Client and/or Order ID number.',
    },
    {
        name: 'DistribPaymentMethod',
        abbrName: 'DistribPmtMethod',
        unionDataType: 'Reserved1000Plus',
        updated: 'FIX.Latest',
        added: 'FIX.4.3',
        type: 'DistribPaymentMethodCodeSet',
        updatedEP: '271',
        id: 477,
        description: 'Identifies the payment method for a (fractional) distribution. Used for CIV.',
    },
    {
        name: 'CashDistribCurr',
        abbrName: 'CshDistribCurr',
        added: 'FIX.4.3',
        type: 'Currency',
        id: 478,
        description: 'Specifies currency to be used for Cash Distributions see "Appendix 6-A Valid Currency Codes".',
    },
    {
        name: 'CommCurrency',
        abbrName: 'Ccy',
        updated: 'FIX.Latest',
        added: 'FIX.4.3',
        type: 'Currency',
        updatedEP: '273',
        id: 479,
        description:
            'Specifies currency to be used for Commission(12) if the commission currency is different from the deal currency.\n\nCommCurrencyCodeSource(2922) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.',
    },
    {
        name: 'CancellationRights',
        abbrName: 'CxllationRights',
        added: 'FIX.4.3',
        type: 'CancellationRightsCodeSet',
        id: 480,
        description:
            'For CIV - A one character code identifying whether Cancellation rights/Cooling off period applies.',
    },
    {
        name: 'MoneyLaunderingStatus',
        abbrName: 'MnyLaunderingStat',
        added: 'FIX.4.3',
        type: 'MoneyLaunderingStatusCodeSet',
        id: 481,
        description: 'A one character code identifying Money laundering status.',
    },
    {
        name: 'MailingInst',
        abbrName: 'MailingInst',
        added: 'FIX.4.3',
        type: 'String',
        id: 482,
        description: 'Free format text to specify mailing instruction requirements, e.g. "no third party mailings".',
    },
    {
        name: 'TransBkdTime',
        abbrName: 'TransBkdTm',
        added: 'FIX.4.3',
        type: 'UTCTimestamp',
        id: 483,
        description:
            'For CIV A date and time stamp to indicate the time a CIV order was booked by the fund manager.\n\nFor derivatives a date and time stamp to indicate when this order was booked with the agent prior to submission to the VMU. Indicates the time at which the order was finalized between the buyer and seller prior to submission.',
    },
    {
        name: 'ExecPriceType',
        abbrName: 'ExecPxTyp',
        added: 'FIX.4.3',
        type: 'ExecPriceTypeCodeSet',
        id: 484,
        description:
            'For CIV - Identifies how the execution price LastPx (31) was calculated from the fund unit/share price(s) calculated at the fund valuation point.',
    },
    {
        name: 'ExecPriceAdjustment',
        abbrName: 'ExecPxAdjment',
        added: 'FIX.4.3',
        type: 'float',
        id: 485,
        description:
            'For CIV the amount or percentage by which the fund unit/share price was adjusted, as indicated by ExecPriceType (484)',
    },
    {
        name: 'DateOfBirth',
        abbrName: 'DtOfBirth',
        added: 'FIX.4.3',
        type: 'LocalMktDate',
        id: 486,
        description:
            'The date of birth applicable to the individual, e.g. required to open some types of tax-exempt account.',
    },
    {
        name: 'TradeReportTransType',
        abbrName: 'TransTyp',
        added: 'FIX.4.3',
        type: 'TradeReportTransTypeCodeSet',
        id: 487,
        description:
            'Identifies Trade Report message transaction type\n\n(Prior to FIX 4.4 this field was of type char)',
    },
    {
        name: 'CardHolderName',
        abbrName: 'CardHolderName',
        added: 'FIX.4.3',
        type: 'String',
        id: 488,
        description: 'The name of the payment card holder as specified on the card being used for payment.',
    },
    {
        name: 'CardNumber',
        abbrName: 'CardNum',
        added: 'FIX.4.3',
        type: 'String',
        id: 489,
        description: 'The number of the payment card as specified on the card being used for payment.',
    },
    {
        name: 'CardExpDate',
        abbrName: 'CardExpDt',
        added: 'FIX.4.3',
        type: 'LocalMktDate',
        id: 490,
        description: 'The expiry date of the payment card as specified on the card being used for payment.',
    },
    {
        name: 'CardIssNum',
        abbrName: 'CardIssNum',
        added: 'FIX.4.3',
        type: 'String',
        id: 491,
        description:
            'The issue number of the payment card as specified on the card being used for payment. This is only applicable to certain types of card.',
    },
    {
        name: 'PaymentMethod',
        abbrName: 'PmtMethod',
        unionDataType: 'Reserved1000Plus',
        updated: 'FIX.Latest',
        added: 'FIX.4.3',
        type: 'PaymentMethodCodeSet',
        updatedEP: '271',
        id: 492,
        description: 'Identifies the settlement payment method.',
    },
    {
        baseCategory: 'RegistrationInstruction',
        name: 'RegistAcctType',
        abbrName: 'AcctTyp',
        added: 'FIX.4.3',
        type: 'String',
        baseCategoryAbbrName: 'AcctTyp',
        id: 493,
        description:
            "For CIV - a fund manager-defined code identifying which of the fund manager's account types is required.",
    },
    {
        name: 'Designation',
        abbrName: 'Designation',
        added: 'FIX.4.3',
        type: 'String',
        id: 494,
        description:
            "Free format text defining the designation to be associated with a holding on the register. Used to identify assets of a specific underlying investor using a common registration, e.g. a broker's nominee or street name.",
    },
    {
        name: 'TaxAdvantageType',
        abbrName: 'TaxAdvantageTyp',
        unionDataType: 'Reserved1000Plus',
        updated: 'FIX.Latest',
        added: 'FIX.4.3',
        type: 'TaxAdvantageTypeCodeSet',
        updatedEP: '271',
        id: 495,
        description:
            'Identifies the type of tax exempt account in which purchases shares/units are to be held. Used for CIV.',
    },
    {
        baseCategory: 'RegistrationInstruction',
        name: 'RegistRejReasonText',
        abbrName: 'RejRsnTxt',
        added: 'FIX.4.3',
        type: 'String',
        baseCategoryAbbrName: 'Dtls',
        id: 496,
        description: 'Text indicating reason(s) why a Registration Instruction has been rejected.',
    },
    {
        name: 'FundRenewWaiv',
        abbrName: 'FundRenewWaiv',
        added: 'FIX.4.3',
        type: 'FundRenewWaivCodeSet',
        id: 497,
        description: 'A one character code identifying whether the Fund based renewal commission is to be waived.',
    },
    {
        name: 'CashDistribAgentName',
        abbrName: 'CshDistribAgentName',
        added: 'FIX.4.3',
        type: 'String',
        id: 498,
        description: 'Name of local agent bank if for cash distributions',
    },
    {
        name: 'CashDistribAgentCode',
        abbrName: 'CshDistribAgentCode',
        added: 'FIX.4.3',
        type: 'String',
        id: 499,
        description: 'BIC (Bank Identification Code--Swift managed) code of agent bank for cash distributions',
    },
    {
        name: 'CashDistribAgentAcctNumber',
        abbrName: 'CshDistribAgentAcctNum',
        added: 'FIX.4.3',
        type: 'String',
        id: 500,
        description: 'Account number at agent bank for distributions.',
    },
    {
        name: 'CashDistribPayRef',
        abbrName: 'CshDistribPayRef',
        added: 'FIX.4.3',
        type: 'String',
        id: 501,
        description: 'Free format Payment reference to assist with reconciliation of distributions.',
    },
    {
        name: 'CashDistribAgentAcctName',
        abbrName: 'CshDistribAgentAcctName',
        added: 'FIX.4.3',
        type: 'String',
        id: 502,
        description: 'Name of account at agent bank for distributions.',
    },
    {
        name: 'CardStartDate',
        abbrName: 'CardStartDt',
        added: 'FIX.4.3',
        type: 'LocalMktDate',
        id: 503,
        description: 'The start date of the card as specified on the card being used for payment.',
    },
    {
        name: 'PaymentDate',
        abbrName: 'PmtDt',
        added: 'FIX.4.3',
        type: 'LocalMktDate',
        id: 504,
        description:
            'The date written on a cheque or date payment should be submitted to the relevant clearing system.',
    },
    {
        name: 'PaymentRemitterID',
        abbrName: 'PmtRemtrID',
        added: 'FIX.4.3',
        type: 'String',
        id: 505,
        description: 'Identifies sender of a payment, e.g. the payment remitter or a customer reference number.',
    },
    {
        name: 'RegistStatus',
        abbrName: 'RegStat',
        added: 'FIX.4.3',
        type: 'RegistStatusCodeSet',
        id: 506,
        description: 'Registration status as returned by the broker or (for CIV) the fund manager:',
    },
    {
        baseCategory: 'RegistrationInstruction',
        name: 'RegistRejReasonCode',
        abbrName: 'RejRsnCd',
        unionDataType: 'Reserved100Plus',
        added: 'FIX.4.3',
        type: 'RegistRejReasonCodeCodeSet',
        baseCategoryAbbrName: 'RejRsnCd',
        id: 507,
        description:
            'Reason(s) why Registration Instructions has been rejected.\n\nThe reason may be further amplified in the RegistRejReasonCode field.\n\nPossible values of reason code include:',
    },
    {
        baseCategory: 'RegistrationInstruction',
        name: 'RegistRefID',
        abbrName: 'RefID',
        updated: 'FIX.Latest',
        added: 'FIX.4.3',
        type: 'String',
        updatedEP: '282',
        baseCategoryAbbrName: 'RefID',
        id: 508,
        description:
            'Reference identifier for the RegistID(513) with Cancel and Replace RegistTransType(514) transaction types.',
    },
    {
        baseCategory: 'RegistrationInstruction',
        name: 'RegistDtls',
        abbrName: 'Dtls',
        added: 'FIX.4.3',
        type: 'String',
        baseCategoryAbbrName: 'RejRsnTxt',
        id: 509,
        description: 'Set of Registration name and address details, possibly including phone, fax etc.',
    },
    {
        name: 'NoDistribInsts',
        updated: 'FIX.Latest',
        added: 'FIX.4.3',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 510,
        description: 'The number of Distribution Instructions on a Registration Instructions message',
    },
    {
        baseCategory: 'RegistrationInstruction',
        name: 'RegistEmail',
        abbrName: 'Email',
        added: 'FIX.4.3',
        type: 'String',
        baseCategoryAbbrName: 'Email',
        id: 511,
        description: 'Email address relating to Registration name and address details',
    },
    {
        name: 'DistribPercentage',
        abbrName: 'DistribPctage',
        added: 'FIX.4.3',
        type: 'Percentage',
        id: 512,
        description: 'The amount of each distribution to go to this beneficiary, expressed as a percentage',
    },
    {
        baseCategory: 'RegistrationInstruction',
        name: 'RegistID',
        abbrName: 'RegistID',
        added: 'FIX.4.3',
        type: 'String',
        baseCategoryAbbrName: 'ID',
        id: 513,
        description: 'Unique identifier of the registration details as assigned by institution or intermediary.',
    },
    {
        name: 'RegistTransType',
        abbrName: 'TransTyp',
        added: 'FIX.4.3',
        type: 'RegistTransTypeCodeSet',
        id: 514,
        description: 'Identifies Registration Instructions transaction type',
    },
    {
        name: 'ExecValuationPoint',
        abbrName: 'ExecValuationPoint',
        added: 'FIX.4.3',
        type: 'UTCTimestamp',
        id: 515,
        description:
            'For CIV - a date and time stamp to indicate the fund valuation point with respect to which a order was priced by the fund manager.',
    },
    {
        name: 'OrderPercent',
        abbrName: 'Pct',
        added: 'FIX.4.3',
        type: 'Percentage',
        id: 516,
        description:
            "For CIV specifies the approximate order quantity desired. For a CIV Sale it specifies percentage of investor's total holding to be sold. For a CIV switch/exchange it specifies percentage of investor's cash realised from sales to be re-invested. The executing broker, intermediary or fund manager is responsible for converting and calculating OrderQty (38) in shares/units for subsequent messages.",
    },
    {
        name: 'OwnershipType',
        abbrName: 'OwnershipTyp',
        added: 'FIX.4.3',
        type: 'OwnershipTypeCodeSet',
        id: 517,
        description: 'The relationship between Registration parties.',
    },
    {
        name: 'NoContAmts',
        updated: 'FIX.Latest',
        added: 'FIX.4.3',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 518,
        description: 'The number of Contract Amount details on an Execution Report message',
    },
    {
        name: 'ContAmtType',
        abbrName: 'ContAmtTyp',
        added: 'FIX.4.3',
        type: 'ContAmtTypeCodeSet',
        id: 519,
        description:
            'Type of ContAmtValue (520).\n\nNOTE That Commission Amount / % in Contract Amounts is the commission actually charged, rather than the commission instructions given in Fields 2/3.',
    },
    {
        name: 'ContAmtValue',
        abbrName: 'ContAmtValu',
        added: 'FIX.4.3',
        type: 'float',
        id: 520,
        description:
            'Value of Contract Amount, e.g. a financial amount or percentage as indicated by ContAmtType (519).',
    },
    {
        name: 'ContAmtCurr',
        abbrName: 'ContAmtCurr',
        added: 'FIX.4.3',
        type: 'Currency',
        id: 521,
        description:
            'Specifies currency for the Contract amount if different from the Deal Currency - see "Appendix 6-A; Valid Currency Codes".',
    },
    {
        name: 'OwnerType',
        abbrName: 'OwnerTyp',
        added: 'FIX.4.3',
        type: 'OwnerTypeCodeSet',
        id: 522,
        description: 'Identifies the type of owner.',
    },
    {
        name: 'PartySubID',
        abbrName: 'ID',
        added: 'FIX.4.3',
        type: 'String',
        id: 523,
        description:
            'Sub-identifier (e.g. Clearing Account for PartyRole (452)=Clearing Firm, Locate ID # for PartyRole=Locate/Lending Firm, etc). Not required when using PartyID (448), PartyIDSource (447), and PartyRole.',
    },
    {
        name: 'NestedPartyID',
        abbrName: 'ID',
        added: 'FIX.4.3',
        type: 'String',
        id: 524,
        discriminatorId: '525',
        description: 'PartyID value within a nested repeating group.\n\nSame values as PartyID (448)',
    },
    {
        name: 'NestedPartyIDSource',
        abbrName: 'Src',
        added: 'FIX.4.3',
        type: 'PartyIDSourceCodeSet',
        id: 525,
        description: 'PartyIDSource value within a nested repeating group.\n\nSame values as PartyIDSource (447)',
    },
    {
        baseCategory: 'SingleGeneralOrderHandling',
        name: 'SecondaryClOrdID',
        abbrName: 'ClOrdID2',
        added: 'FIX.4.3',
        type: 'String',
        baseCategoryAbbrName: 'ID2',
        id: 526,
        description:
            'Assigned by the party which originates the order. Can be used to provide the ClOrdID (11) used by an exchange or executing system.',
    },
    {
        name: 'SecondaryExecID',
        abbrName: 'ExecID2',
        added: 'FIX.4.3',
        type: 'String',
        id: 527,
        description:
            'Assigned by the party which accepts the order. Can be used to provide the ExecID (17) used by an exchange or executing system.',
    },
    {
        name: 'OrderCapacity',
        abbrName: 'Cpcty',
        added: 'FIX.4.3',
        type: 'OrderCapacityCodeSet',
        id: 528,
        description:
            'Designates the capacity of the firm placing the order.\n\n(as of FIX 4.3, this field replaced Rule80A (tag 47) --used in conjunction with OrderRestrictions (529) field)\n\n(see Volume : "Glossary" for value definitions)',
    },
    {
        name: 'OrderRestrictions',
        abbrName: 'Rstctions',
        added: 'FIX.4.3',
        type: 'OrderRestrictionsCodeSet',
        id: 529,
        description:
            'Restrictions associated with an order. If more than one restriction is applicable to an order, this field can contain multiple instructions separated by space.',
    },
    {
        baseCategory: 'OrderMassHandling',
        name: 'MassCancelRequestType',
        abbrName: 'MassCxlReqTyp',
        added: 'FIX.4.3',
        type: 'MassCancelRequestTypeCodeSet',
        baseCategoryAbbrName: 'ReqTyp',
        id: 530,
        description: 'Specifies scope of Order Mass Cancel Request.',
    },
    {
        baseCategory: 'OrderMassHandling',
        name: 'MassCancelResponse',
        abbrName: 'MassCxlRsp',
        added: 'FIX.4.3',
        type: 'MassCancelResponseCodeSet',
        baseCategoryAbbrName: 'Rsp',
        id: 531,
        description:
            'Specifies the action taken by counterparty order handling system as a result of the Order Mass Cancel Request',
    },
    {
        name: 'MassCancelRejectReason',
        abbrName: 'MassCxlRejRsn',
        unionDataType: 'Reserved100Plus',
        added: 'FIX.4.3',
        type: 'MassCancelRejectReasonCodeSet',
        id: 532,
        description: 'Reason Order Mass Cancel Request was rejected',
    },
    {
        name: 'TotalAffectedOrders',
        abbrName: 'TotAffctdOrds',
        updated: 'FIX.5.0SP1',
        added: 'FIX.4.3',
        type: 'int',
        updatedEP: '95',
        id: 533,
        description:
            'Total number of orders affected by either the OrderMassActionRequest(MsgType=CA) or OrderMassCancelRequest(MsgType=Q).',
    },
    {
        name: 'NoAffectedOrders',
        updated: 'FIX.Latest',
        added: 'FIX.4.3',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 534,
        description: 'Number of affected orders in the repeating group of order ids.',
    },
    {
        name: 'AffectedOrderID',
        abbrName: 'OrdID',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.3',
        type: 'String',
        updatedEP: '131',
        id: 535,
        description: 'OrderID(37) of an order affected by a mass cancel or mass action request.',
    },
    {
        name: 'AffectedSecondaryOrderID',
        abbrName: 'OrdID2',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.3',
        type: 'String',
        updatedEP: '131',
        id: 536,
        description: 'SecondaryOrderID(198) of an order affected by a mass cancel or mass action request.',
    },
    {
        name: 'QuoteType',
        abbrName: 'Typ',
        added: 'FIX.4.3',
        type: 'QuoteTypeCodeSet',
        id: 537,
        description:
            'Identifies the type of quote.\n\nAn indicative quote is used to inform a counterparty of a market. An indicative quote does not result directly in a trade.\n\nA tradeable quote is submitted to a market and will result directly in a trade against other orders and quotes in a market.\n\nA restricted tradeable quote is submitted to a market and within a certain restriction (possibly based upon price or quantity) will automatically trade against orders. Order that do not comply with restrictions are sent to the quote issuer who can choose to accept or decline the order.\n\nA counter quote is used in the negotiation model. See Volume 7 - Product: Fixed Income for example usage.',
    },
    {
        name: 'NestedPartyRole',
        abbrName: 'R',
        added: 'FIX.4.3',
        type: 'PartyRoleCodeSet',
        id: 538,
        description: 'PartyRole value within a nested repeating group.\n\nSame values as PartyRole (452)',
    },
    {
        name: 'NoNestedPartyIDs',
        updated: 'FIX.Latest',
        added: 'FIX.4.3',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 539,
        description: 'Number of NestedPartyID (524), NestedPartyIDSource (525), and NestedPartyRole (538) entries',
    },
    {
        name: 'TotalAccruedInterestAmt',
        abbrName: 'TotAcrdIntAmt',
        added: 'FIX.4.3',
        type: 'Amt',
        deprecated: 'FIX.4.4',
        id: 540,
        description: 'Total Amount of Accrued Interest for convertible bonds and fixed income',
    },
    {
        name: 'MaturityDate',
        abbrName: 'MatDt',
        added: 'FIX.4.3',
        type: 'LocalMktDate',
        id: 541,
        description: 'Date of maturity.',
    },
    {
        name: 'UnderlyingMaturityDate',
        abbrName: 'Mat',
        added: 'FIX.4.3',
        type: 'LocalMktDate',
        id: 542,
        description: "Underlying security's maturity date.\n\nSee MaturityDate (541) field for description",
    },
    {
        name: 'InstrRegistry',
        abbrName: 'Rgstry',
        added: 'FIX.4.3',
        type: 'String',
        id: 543,
        description:
            'Values may include BIC for the depository or custodian who maintain ownership records, the ISO country code for the location of the record, or the value "ZZ" to specify physical ownership of the security (e.g. stock certificate).',
    },
    {
        name: 'CashMargin',
        abbrName: 'CshMgn',
        added: 'FIX.4.3',
        type: 'CashMarginCodeSet',
        id: 544,
        description:
            'Identifies whether an order is a margin order or a non-margin order. This is primarily used when sending orders to Japanese exchanges to indicate sell margin or buy to cover. The same tag could be assigned also by buy-side to indicate the intent to sell or buy margin and the sell-side to accept or reject (base on some validation criteria) the margin request.',
    },
    {
        name: 'NestedPartySubID',
        abbrName: 'ID',
        added: 'FIX.4.3',
        type: 'String',
        id: 545,
        description: 'PartySubID value within a nested repeating group.\n\nSame values as PartySubID (523)',
    },
    {
        name: 'Scope',
        abbrName: 'Scope',
        updated: 'FIX.5.0SP1',
        added: 'FIX.4.3',
        type: 'ScopeCodeSet',
        updatedEP: '95',
        id: 546,
        description: 'Specifies the market scope of the market data.',
    },
    {
        name: 'MDImplicitDelete',
        abbrName: 'ImplctDel',
        added: 'FIX.4.3',
        type: 'MDImplicitDeleteCodeSet',
        id: 547,
        description: 'Defines how a server handles distribution of a truncated book. Defaults to broker option.',
    },
    {
        baseCategory: 'CrossOrders',
        name: 'CrossID',
        abbrName: 'CrssID',
        added: 'FIX.4.3',
        type: 'String',
        baseCategoryAbbrName: 'ID',
        id: 548,
        description:
            'Identifier for a cross order. Must be unique during a given trading day. Recommend that firms use the order date as part of the CrossID for Good Till Cancel (GT) orders.',
    },
    {
        baseCategory: 'CrossOrders',
        name: 'CrossType',
        abbrName: 'CrssTyp',
        added: 'FIX.4.3',
        type: 'CrossTypeCodeSet',
        baseCategoryAbbrName: 'Typ',
        id: 549,
        description: 'Type of cross being submitted to a market',
    },
    {
        baseCategory: 'CrossOrders',
        name: 'CrossPrioritization',
        abbrName: 'CrssPriortstn',
        added: 'FIX.4.3',
        type: 'CrossPrioritizationCodeSet',
        baseCategoryAbbrName: 'Priorty',
        id: 550,
        description:
            'Indicates if one side or the other of a cross order should be prioritized.\n\nThe definition of prioritization is left to the market. In some markets prioritization means which side of the cross order is applied to the market first. In other markets - prioritization may mean that the prioritized side is fully executed (sometimes referred to as the side being protected).',
    },
    {
        baseCategory: 'CrossOrders',
        name: 'OrigCrossID',
        abbrName: 'OrigCrssID',
        added: 'FIX.4.3',
        type: 'String',
        baseCategoryAbbrName: 'OrigID',
        id: 551,
        description:
            'CrossID of the previous cross order (NOT the initial cross order of the day) as assigned by the institution, used to identify the previous cross order in Cross Cancel and Cross Cancel/Replace Requests.',
    },
    {
        name: 'NoSides',
        abbrName: 'NoSides',
        added: 'FIX.4.3',
        type: 'NoSidesCodeSet',
        id: 552,
        description: 'Number of Side repeating group instances.',
    },
    {
        name: 'Username',
        abbrName: 'Username',
        added: 'FIX.4.3',
        type: 'String',
        id: 553,
        description: 'Userid or username.',
    },
    {
        name: 'Password',
        abbrName: 'Password',
        added: 'FIX.4.3',
        type: 'String',
        id: 554,
        description: 'Password or passphrase.',
    },
    {
        name: 'NoLegs',
        updated: 'FIX.Latest',
        added: 'FIX.4.3',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 555,
        description: 'Number of InstrumentLeg repeating group instances.',
    },
    {
        name: 'LegCurrency',
        abbrName: 'Ccy',
        added: 'FIX.4.3',
        type: 'Currency',
        id: 556,
        description: "Currency associated with a particular Leg's quantity",
    },
    {
        name: 'TotNoSecurityTypes',
        abbrName: 'TotNoSecTyps',
        updated: 'FIX.5.0SP1',
        added: 'FIX.4.3',
        type: 'int',
        updatedEP: '95',
        id: 557,
        description:
            'Used to support fragmentation. Indicates total number of security types when multiple Security Type messages are used to return results.',
    },
    {
        name: 'NoSecurityTypes',
        updated: 'FIX.Latest',
        added: 'FIX.4.3',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 558,
        description: 'Number of Security Type repeating group instances.',
    },
    {
        name: 'SecurityListRequestType',
        abbrName: 'ListReqTyp',
        added: 'FIX.4.3',
        type: 'SecurityListRequestTypeCodeSet',
        id: 559,
        description: 'Identifies the type/criteria of Security List Request',
    },
    {
        name: 'SecurityRequestResult',
        abbrName: 'ReqRslt',
        added: 'FIX.4.3',
        type: 'SecurityRequestResultCodeSet',
        id: 560,
        description: 'The results returned to a Security Request message',
    },
    {
        name: 'RoundLot',
        abbrName: 'RndLot',
        added: 'FIX.4.3',
        type: 'Qty',
        id: 561,
        description: 'The trading lot size of a security',
    },
    {
        name: 'MinTradeVol',
        abbrName: 'MinTrdVol',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.3',
        type: 'Qty',
        updatedEP: '130',
        id: 562,
        description:
            'The minimum order quantity (as expressed by TradeVolType(1786)) that can be submitted for a security.',
    },
    {
        name: 'MultiLegRptTypeReq',
        abbrName: 'MLEGRptTypReq',
        added: 'FIX.4.3',
        type: 'MultiLegRptTypeReqCodeSet',
        id: 563,
        description: 'Indicates the method of execution reporting requested by issuer of the order.',
    },
    {
        name: 'LegPositionEffect',
        abbrName: 'PosEfct',
        added: 'FIX.4.3',
        type: 'PositionEffectCodeSet',
        id: 564,
        description: 'PositionEffect for leg of a multileg\n\nSee PositionEffect (77) field for description',
    },
    {
        name: 'LegCoveredOrUncovered',
        abbrName: 'Cover',
        added: 'FIX.4.3',
        type: 'CoveredOrUncoveredCodeSet',
        id: 565,
        description: 'CoveredOrUncovered for leg of a multileg\n\nSee CoveredOrUncovered (203) field for description',
    },
    {
        name: 'LegPrice',
        abbrName: 'Px',
        added: 'FIX.4.3',
        type: 'Price',
        id: 566,
        description: 'Price for leg of a multileg\n\nSee Price (44) field for description',
    },
    {
        name: 'TradSesStatusRejReason',
        abbrName: 'StatRejRsn',
        unionDataType: 'Reserved100Plus',
        added: 'FIX.4.3',
        type: 'TradSesStatusRejReasonCodeSet',
        id: 567,
        description: 'Indicates the reason a Trading Session Status Request was rejected.',
    },
    {
        name: 'TradeRequestID',
        abbrName: 'ReqID',
        added: 'FIX.4.3',
        type: 'String',
        id: 568,
        description: 'Trade Capture Report Request ID',
    },
    {
        name: 'TradeRequestType',
        abbrName: 'ReqTyp',
        added: 'FIX.4.3',
        type: 'TradeRequestTypeCodeSet',
        id: 569,
        description: 'Type of Trade Capture Report.',
    },
    {
        name: 'PreviouslyReported',
        abbrName: 'PrevlyRpted',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.3',
        type: 'PreviouslyReportedCodeSet',
        updatedEP: '229',
        id: 570,
        description: 'Indicates if the transaction was previously reported to the counterparty or market.',
    },
    {
        name: 'TradeReportID',
        abbrName: 'RptID',
        added: 'FIX.4.3',
        type: 'String',
        id: 571,
        description: 'Unique identifier of trade capture report',
    },
    {
        name: 'TradeReportRefID',
        abbrName: 'RptRefID',
        added: 'FIX.4.3',
        type: 'String',
        id: 572,
        description: 'Reference identifier used with CANCEL and REPLACE transaction types.',
    },
    {
        name: 'MatchStatus',
        abbrName: 'MtchStat',
        added: 'FIX.4.3',
        type: 'MatchStatusCodeSet',
        id: 573,
        description: 'The status of this trade with respect to matching or comparison.',
    },
    {
        name: 'MatchType',
        abbrName: 'MtchTyp',
        added: 'FIX.4.3',
        type: 'MatchTypeCodeSet',
        id: 574,
        description: 'The point in the matching process at which this trade was matched.',
    },
    {
        name: 'OddLot',
        abbrName: 'OddLot',
        added: 'FIX.4.3',
        type: 'OddLotCodeSet',
        deprecated: 'FIX.5.0',
        id: 575,
        description:
            'This trade is to be treated as an odd lot\n\nIf this field is not specified, the default will be "N"',
    },
    {
        name: 'NoClearingInstructions',
        updated: 'FIX.Latest',
        added: 'FIX.4.3',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 576,
        description: 'Number of clearing instructions',
    },
    {
        name: 'ClearingInstruction',
        abbrName: 'ClrngInstrctn',
        unionDataType: 'Reserved4000Plus',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.3',
        type: 'ClearingInstructionCodeSet',
        updatedEP: '204',
        id: 577,
        description: 'Eligibility of this trade for clearing and central counterparty processing.',
    },
    {
        name: 'TradeInputSource',
        abbrName: 'InptSrc',
        added: 'FIX.4.3',
        type: 'String',
        id: 578,
        description: 'Type of input device or system from which the trade was entered.',
    },
    {
        name: 'TradeInputDevice',
        abbrName: 'InptDev',
        added: 'FIX.4.3',
        type: 'String',
        id: 579,
        description: 'Specific device number, terminal number or station where trade was entered',
    },
    {
        name: 'NoDates',
        updated: 'FIX.Latest',
        added: 'FIX.4.3',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 580,
        description: 'Number of Date fields provided in date range',
    },
    {
        name: 'AccountType',
        abbrName: 'AcctTyp',
        added: 'FIX.4.3',
        type: 'AccountTypeCodeSet',
        id: 581,
        description: 'Type of account associated with an order',
    },
    {
        name: 'CustOrderCapacity',
        abbrName: 'CustCpcty',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.3',
        type: 'CustOrderCapacityCodeSet',
        updatedEP: '205',
        id: 582,
        description:
            'Capacity of customer placing the order.\n\nUsed by futures exchanges to indicate the CTICode (customer type indicator) as required by the US CFTC (Commodity Futures Trading Commission). May be used as required by other regulatory commissions for similar purposes.',
    },
    {
        baseCategory: 'SingleGeneralOrderHandling',
        name: 'ClOrdLinkID',
        abbrName: 'ClOrdLinkID',
        added: 'FIX.4.3',
        type: 'String',
        baseCategoryAbbrName: 'LnkID',
        id: 583,
        description:
            'Permits order originators to tie together groups of orders in which trades resulting from orders are associated for a specific purpose, for example the calculation of average execution price for a customer or to associate lists submitted to a broker as waves of a larger program trade.',
    },
    {
        baseCategory: 'OrderMassHandling',
        name: 'MassStatusReqID',
        abbrName: 'MassStatReqID',
        added: 'FIX.4.3',
        type: 'String',
        baseCategoryAbbrName: 'ReqID',
        id: 584,
        description: 'Value assigned by issuer of Mass Status Request to uniquely identify the request',
    },
    {
        baseCategory: 'OrderMassHandling',
        name: 'MassStatusReqType',
        abbrName: 'MassStatReqTyp',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.Latest',
        added: 'FIX.4.3',
        type: 'MassStatusReqTypeCodeSet',
        updatedEP: '271',
        baseCategoryAbbrName: 'ReqTyp',
        id: 585,
        description: 'Specifies the type or scope of the mass order status request.',
    },
    {
        name: 'OrigOrdModTime',
        abbrName: 'OrigOrdModTm',
        added: 'FIX.4.3',
        type: 'UTCTimestamp',
        id: 586,
        description:
            'The most recent (or current) modification TransactTime (tag 60) reported on an Execution Report for the order. The OrigOrdModTime is provided as an optional field on Order Cancel Request and Order Cancel Replace Requests to identify that the state of the order has not changed since the request was issued. The use of this approach is not recommended.',
    },
    {
        name: 'LegSettlType',
        abbrName: 'SettlTyp',
        unionDataType: 'Tenor',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.3',
        type: 'SettlTypeCodeSet',
        updatedEP: '187',
        id: 587,
        description:
            'Indicates order settlement period. If present, LegSettlDate (588) overrides this field. If both LegSettlType (587) and LegSettDate (588) are omitted, the default for LegSettlType (587) is 0 (Regular)\n\nRegular is defined as the default settlement period for the particular security on the exchange of execution.\n\nIn Fixed Income the contents of this field may influence the instrument definition if the LegSecurityID (602) is ambiguous. In the US an active Treasury offering may be re-opened, and for a time one CUSIP will apply to both the current and "when-issued" securities. Supplying a value of "7" clarifies the instrument description; any other value or the absence of this field should cause the respondent to default to the active issue.\n\nAdditionally the following patterns may be uses as well as enum values\n\nDx = FX tenor expression for "days", e.g. "D5", where "x" is any integer > 0\n\nMx = FX tenor expression for "months", e.g. "M3", where "x" is any integer > 0\n\nWx = FX tenor expression for "weeks", e.g. "W13", where "x" is any integer > 0\n\nYx = FX tenor expression for "years", e.g. "Y1", where "x" is any integer > 0.\n\nNote that for FX the tenors expressed using Dx, Mx, Wx, and Yx values do not denote business days, but calendar days.',
    },
    {
        name: 'LegSettlDate',
        abbrName: 'SettlDt',
        added: 'FIX.4.3',
        type: 'LocalMktDate',
        id: 588,
        description: 'Refer to description for SettlDate[64]',
    },
    {
        name: 'DayBookingInst',
        abbrName: 'DayBkngInst',
        added: 'FIX.4.3',
        type: 'DayBookingInstCodeSet',
        id: 589,
        description: 'Indicates whether or not automatic booking can occur.',
    },
    {
        name: 'BookingUnit',
        abbrName: 'BkngUnit',
        added: 'FIX.4.3',
        type: 'BookingUnitCodeSet',
        id: 590,
        description: 'Indicates what constitutes a bookable unit.',
    },
    {
        name: 'PreallocMethod',
        abbrName: 'PreallocMeth',
        added: 'FIX.4.3',
        type: 'PreallocMethodCodeSet',
        id: 591,
        description: 'Indicates the method of preallocation.',
    },
    {
        name: 'UnderlyingCountryOfIssue',
        abbrName: 'Ctry',
        added: 'FIX.4.3',
        type: 'Country',
        id: 592,
        description: "Underlying security's CountryOfIssue.\n\nSee CountryOfIssue (470) field for description",
    },
    {
        name: 'UnderlyingStateOrProvinceOfIssue',
        abbrName: 'StOrProvnc',
        added: 'FIX.4.3',
        type: 'String',
        id: 593,
        description:
            "Underlying security's StateOrProvinceOfIssue.\n\nSee StateOrProvinceOfIssue (471) field for description",
    },
    {
        name: 'UnderlyingLocaleOfIssue',
        abbrName: 'Lcl',
        added: 'FIX.4.3',
        type: 'String',
        id: 594,
        description: "Underlying security's LocaleOfIssue.\n\nSee LocaleOfIssue (472) field for description",
    },
    {
        name: 'UnderlyingInstrRegistry',
        abbrName: 'Rgstry',
        added: 'FIX.4.3',
        type: 'String',
        id: 595,
        description: "Underlying security's InstrRegistry.\n\nSee InstrRegistry (543) field for description",
    },
    {
        name: 'LegCountryOfIssue',
        abbrName: 'Ctry',
        added: 'FIX.4.3',
        type: 'Country',
        id: 596,
        description:
            "Multileg instrument's individual leg security's CountryOfIssue.\n\nSee CountryOfIssue (470) field for description",
    },
    {
        name: 'LegStateOrProvinceOfIssue',
        abbrName: 'StOrProvnc',
        added: 'FIX.4.3',
        type: 'String',
        id: 597,
        description:
            "Multileg instrument's individual leg security's StateOrProvinceOfIssue.\n\nSee StateOrProvinceOfIssue (471) field for description",
    },
    {
        name: 'LegLocaleOfIssue',
        abbrName: 'Lcl',
        added: 'FIX.4.3',
        type: 'String',
        id: 598,
        description:
            "Multileg instrument's individual leg security's LocaleOfIssue.\n\nSee LocaleOfIssue (472) field for description",
    },
    {
        name: 'LegInstrRegistry',
        abbrName: 'Rgstry',
        added: 'FIX.4.3',
        type: 'String',
        id: 599,
        description:
            "Multileg instrument's individual leg security's InstrRegistry.\n\nSee InstrRegistry (543) field for description",
    },
    {
        name: 'LegSymbol',
        abbrName: 'Sym',
        added: 'FIX.4.3',
        type: 'String',
        id: 600,
        description: "Multileg instrument's individual security's Symbol.\n\nSee Symbol (55) field for description",
    },
    {
        name: 'LegSymbolSfx',
        abbrName: 'Sfx',
        added: 'FIX.4.3',
        type: 'SymbolSfxCodeSet',
        id: 601,
        description:
            "Multileg instrument's individual security's SymbolSfx.\n\nSee SymbolSfx (65) field for description",
    },
    {
        name: 'LegSecurityID',
        abbrName: 'ID',
        added: 'FIX.4.3',
        type: 'String',
        id: 602,
        discriminatorId: '603',
        description:
            "Multileg instrument's individual security's SecurityID.\n\nSee SecurityID (48) field for description",
    },
    {
        name: 'LegSecurityIDSource',
        abbrName: 'Src',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.Latest',
        added: 'FIX.4.3',
        type: 'SecurityIDSourceCodeSet',
        updatedEP: '265',
        id: 603,
        description:
            "Multileg instrument's individual security's SecurityIDSource.\n\nSee SecurityIDSource (22) field for description",
    },
    {
        name: 'NoLegSecurityAltID',
        updated: 'FIX.Latest',
        added: 'FIX.4.3',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 604,
        description:
            "Multileg instrument's individual security's NoSecurityAltID.\n\nSee NoSecurityAltID (454) field for description",
    },
    {
        name: 'LegSecurityAltID',
        abbrName: 'SecAltID',
        added: 'FIX.4.3',
        type: 'String',
        id: 605,
        discriminatorId: '606',
        description:
            "Multileg instrument's individual security's SecurityAltID.\n\nSee SecurityAltID (455) field for description",
    },
    {
        name: 'LegSecurityAltIDSource',
        abbrName: 'SecAltIDSrc',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.Latest',
        added: 'FIX.4.3',
        type: 'SecurityIDSourceCodeSet',
        updatedEP: '271',
        id: 606,
        description:
            'Alternate identifier for individual leg security of a multileg instrument.\n\nSee SecurityAltIDSource(456) field for complete definition.',
    },
    {
        name: 'LegProduct',
        abbrName: 'Prod',
        added: 'FIX.4.3',
        type: 'ProductCodeSet',
        id: 607,
        description: "Multileg instrument's individual security's Product.\n\nSee Product (460) field for description",
    },
    {
        name: 'LegCFICode',
        abbrName: 'CFI',
        added: 'FIX.4.3',
        type: 'String',
        id: 608,
        description: "Multileg instrument's individual security's CFICode.\n\nSee CFICode (461) field for description",
    },
    {
        name: 'LegSecurityType',
        abbrName: 'SecTyp',
        added: 'FIX.4.3',
        type: 'SecurityTypeCodeSet',
        id: 609,
        description: 'Refer to definition of SecurityType(167)',
    },
    {
        name: 'LegMaturityMonthYear',
        abbrName: 'MMY',
        added: 'FIX.4.3',
        type: 'MonthYear',
        id: 610,
        description:
            "Multileg instrument's individual security's MaturityMonthYear.\n\nSee MaturityMonthYear (200) field for description",
    },
    {
        name: 'LegMaturityDate',
        abbrName: 'Mat',
        updated: 'FIX.Latest',
        added: 'FIX.4.3',
        type: 'LocalMktDate',
        updatedEP: '282',
        id: 611,
        description:
            "Multileg instrument's individual security's MaturityDate.\n\nSee MaturityDate(541) field for description.",
    },
    {
        name: 'LegStrikePrice',
        abbrName: 'Strk',
        added: 'FIX.4.3',
        type: 'Price',
        id: 612,
        description:
            "Multileg instrument's individual security's StrikePrice.\n\nSee StrikePrice (202) field for description",
    },
    {
        name: 'LegOptAttribute',
        abbrName: 'OptA',
        added: 'FIX.4.3',
        type: 'char',
        id: 613,
        description:
            "Multileg instrument's individual security's OptAttribute.\n\nSee OptAttribute (206) field for description",
    },
    {
        name: 'LegContractMultiplier',
        abbrName: 'Cmult',
        added: 'FIX.4.3',
        type: 'float',
        id: 614,
        description:
            "Multileg instrument's individual security's ContractMultiplier.\n\nSee ContractMultiplier (23) field for description",
    },
    {
        name: 'LegCouponRate',
        abbrName: 'CpnRt',
        added: 'FIX.4.3',
        type: 'Percentage',
        id: 615,
        description:
            "Multileg instrument's individual security's CouponRate.\n\nSee CouponRate (223) field for description",
    },
    {
        name: 'LegSecurityExchange',
        abbrName: 'Exch',
        added: 'FIX.4.3',
        type: 'Exchange',
        id: 616,
        description:
            "Multileg instrument's individual security's SecurityExchange.\n\nSee SecurityExchange (207) field for description",
    },
    {
        name: 'LegIssuer',
        abbrName: 'Issr',
        added: 'FIX.4.3',
        type: 'String',
        id: 617,
        description: "Multileg instrument's individual security's Issuer.\n\nSee Issuer (106) field for description",
    },
    {
        name: 'EncodedLegIssuerLen',
        abbrName: 'EncLegIssrLen',
        added: 'FIX.4.3',
        type: 'Length',
        id: 618,
        description:
            "Multileg instrument's individual security's EncodedIssuerLen.\n\nSee EncodedIssuerLen (348) field for description",
    },
    {
        name: 'EncodedLegIssuer',
        abbrName: 'EncLegIssr',
        added: 'FIX.4.3',
        type: 'data',
        id: 619,
        lengthId: '618',
        description:
            "Multileg instrument's individual security's EncodedIssuer.\n\nSee EncodedIssuer (349) field for description",
    },
    {
        name: 'LegSecurityDesc',
        abbrName: 'Desc',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.3',
        type: 'String',
        updatedEP: '232',
        id: 620,
        description:
            'Description of a multileg instrument.\n\nCan be used by the venue or one of the trading parties to provide an optional non-normative textual description of the financial instrument.',
    },
    {
        name: 'EncodedLegSecurityDescLen',
        abbrName: 'EncLegSecDescLen',
        added: 'FIX.4.3',
        type: 'Length',
        id: 621,
        description:
            "Multileg instrument's individual security's EncodedSecurityDescLen.\n\nSee EncodedSecurityDescLen (350) field for description",
    },
    {
        name: 'EncodedLegSecurityDesc',
        abbrName: 'EncLegSecDesc',
        added: 'FIX.4.3',
        type: 'data',
        id: 622,
        lengthId: '621',
        description:
            "Multileg instrument's individual security's EncodedSecurityDesc.\n\nSee EncodedSecurityDesc (35) field for description",
    },
    {
        name: 'LegRatioQty',
        abbrName: 'RatioQty',
        added: 'FIX.4.3',
        type: 'float',
        id: 623,
        description: 'The ratio of quantity for this individual leg relative to the entire multileg security.',
    },
    {
        name: 'LegSide',
        abbrName: 'Side',
        added: 'FIX.4.3',
        type: 'SideCodeSet',
        id: 624,
        description:
            'The side of this individual leg (multileg security).\n\nSee Side (54) field for description and values',
    },
    {
        name: 'TradingSessionSubID',
        abbrName: 'SesSub',
        unionDataType: 'Reserved100Plus',
        added: 'FIX.4.3',
        type: 'TradingSessionSubIDCodeSet',
        id: 625,
        description:
            'Optional market assigned sub identifier for a trading phase within a trading session. Usage is determined by market or counterparties. Used by US based futures markets to identify exchange specific execution time bracket codes as required by US market regulations. Bilaterally agreed values of data type "String" that start with a character can be used for backward compatibility',
    },
    {
        baseCategory: 'Allocation',
        name: 'AllocType',
        abbrName: 'AllocType',
        added: 'FIX.4.3',
        type: 'AllocTypeCodeSet',
        baseCategoryAbbrName: 'Typ',
        id: 626,
        description:
            'Describes the specific type or purpose of an Allocation message (i.e. "Buyside Calculated")\n\n(see Volume : "Glossary" for value definitions)\n\n*** SOME VALUES HAVE BEEN REPLACED - See "Replaced Features and Supported Approach" ***',
    },
    {
        name: 'NoHops',
        updated: 'FIX.Latest',
        added: 'FIX.4.3',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 627,
        description: 'Number of HopCompID entries in repeating group.',
    },
    {
        name: 'HopCompID',
        abbrName: 'ID',
        added: 'FIX.4.3',
        type: 'String',
        id: 628,
        description:
            'Assigned value used to identify the third party firm which delivered a specific message either from the firm which originated the message or from another third party (if multiple "hops" are performed). It is recommended that this value be the SenderCompID (49) of the third party.\n\nApplicable when messages are communicated/re-distributed via third parties which function as service bureaus or "hubs". Only applicable if OnBehalfOfCompID (115) is being used.',
    },
    {
        name: 'HopSendingTime',
        abbrName: 'Snt',
        added: 'FIX.4.3',
        type: 'UTCTimestamp',
        id: 629,
        description:
            'Time that HopCompID (628) sent the message. It is recommended that this value be the SendingTime (52) of the message sent by the third party.\n\nApplicable when messages are communicated/re-distributed via third parties which function as service bureaus or "hubs". Only applicable if OnBehalfOfCompID (115) is being used.',
    },
    {
        name: 'HopRefID',
        abbrName: 'Ref',
        added: 'FIX.4.3',
        type: 'SeqNum',
        id: 630,
        description:
            'Reference identifier assigned by HopCompID (628) associated with the message sent. It is recommended that this value be the MsgSeqNum (34) of the message sent by the third party.\n\nApplicable when messages are communicated/re-distributed via third parties which function as service bureaus or "hubs". Only applicable if OnBehalfOfCompID (115) is being used.',
    },
    {
        name: 'MidPx',
        abbrName: 'MidPx',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.3',
        type: 'Price',
        updatedEP: '175',
        id: 631,
        description:
            'Mid price/rate.\n\nFor OTC swaps this is the mid-market mark (for example, as defined by CFTC).\n\nFor uncleared OTC swaps, LegMidPx(2346) and the MidPx(631) fields are mutually exclusive.',
    },
    { name: 'BidYield', abbrName: 'BidYld', added: 'FIX.4.3', type: 'Percentage', id: 632, description: 'Bid yield' },
    { name: 'MidYield', abbrName: 'MidYld', added: 'FIX.4.3', type: 'Percentage', id: 633, description: 'Mid yield' },
    {
        name: 'OfferYield',
        abbrName: 'OfrYld',
        added: 'FIX.4.3',
        type: 'Percentage',
        id: 634,
        description: 'Offer yield',
    },
    {
        name: 'ClearingFeeIndicator',
        abbrName: 'ClrFeeInd',
        added: 'FIX.4.3',
        type: 'ClearingFeeIndicatorCodeSet',
        id: 635,
        description:
            'Indicates type of fee being assessed of the customer for trade executions at an exchange. Applicable for futures markets only at this time.\n\n(Values source CBOT, CME, NYBOT, and NYMEX):',
    },
    {
        name: 'WorkingIndicator',
        abbrName: 'WorkingInd',
        added: 'FIX.4.3',
        type: 'WorkingIndicatorCodeSet',
        id: 636,
        description:
            'Indicates if the order is currently being worked. Applicable only for OrdStatus = "New". For open outcry markets this indicates that the order is being worked in the crowd. For electronic markets it indicates that the order has transitioned from a contingent order to a market order.',
    },
    {
        name: 'LegLastPx',
        abbrName: 'LastPx',
        added: 'FIX.4.3',
        type: 'Price',
        id: 637,
        description:
            'Execution price assigned to a leg of a multileg instrument.\n\nSee LastPx (31) field for description and values',
    },
    {
        name: 'PriorityIndicator',
        abbrName: 'PriInd',
        added: 'FIX.4.3',
        type: 'PriorityIndicatorCodeSet',
        id: 638,
        description: 'Indicates if a Cancel/Replace has caused an order to lose book priority.',
    },
    {
        name: 'PriceImprovement',
        abbrName: 'PxImprvmnt',
        added: 'FIX.4.3',
        type: 'PriceOffset',
        id: 639,
        description: 'Amount of price improvement.',
    },
    {
        name: 'Price2',
        abbrName: 'Px2',
        added: 'FIX.4.3',
        type: 'Price',
        deprecated: 'FIX.5.0',
        id: 640,
        description: 'Price of the future part of a F/X swap order.\n\nSee Price (44) for description.',
    },
    {
        name: 'LastForwardPoints2',
        abbrName: 'LastFwdPnts2',
        updated: 'FIX.Latest',
        added: 'FIX.4.3',
        type: 'PriceOffset',
        updatedEP: '282',
        deprecated: 'FIX.5.0',
        id: 641,
        description:
            'F/X forward points of the future part of a F/X swap order added to LastSpotRate(194). May be a negative value.',
    },
    {
        name: 'BidForwardPoints2',
        abbrName: 'BidFwdPnts2',
        added: 'FIX.4.3',
        type: 'PriceOffset',
        deprecated: 'FIX.5.0',
        id: 642,
        description:
            'Bid F/X forward points of the future portion of a F/X swap quote added to spot rate. May be a negative value.',
    },
    {
        name: 'OfferForwardPoints2',
        abbrName: 'OfrFwdPnts2',
        added: 'FIX.4.3',
        type: 'PriceOffset',
        deprecated: 'FIX.5.0',
        id: 643,
        description:
            'Offer F/X forward points of the future portion of a F/X swap quote added to spot rate. May be a negative value.',
    },
    {
        name: 'RFQReqID',
        abbrName: 'RFQReqID',
        added: 'FIX.4.3',
        type: 'String',
        id: 644,
        description: 'RFQ Request ID - used to identify an RFQ Request.',
    },
    {
        name: 'MktBidPx',
        abbrName: 'MktBidPx',
        added: 'FIX.4.3',
        type: 'Price',
        id: 645,
        description: 'Used to indicate the best bid in a market',
    },
    {
        name: 'MktOfferPx',
        abbrName: 'MktOfrPx',
        added: 'FIX.4.3',
        type: 'Price',
        id: 646,
        description: 'Used to indicate the best offer in a market',
    },
    {
        name: 'MinBidSize',
        abbrName: 'MinBidSz',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.3',
        type: 'Qty',
        updatedEP: '208',
        id: 647,
        description: 'Used to indicate a minimum quantity for a bid.',
    },
    {
        name: 'MinOfferSize',
        abbrName: 'MinOfrSz',
        added: 'FIX.4.3',
        type: 'Qty',
        id: 648,
        description:
            'Used to indicate a minimum quantity for an offer. If this field is used the OfferSize (135) field is interpreted as the maximum offer size.',
    },
    {
        name: 'QuoteStatusReqID',
        abbrName: 'StatReqID',
        added: 'FIX.4.3',
        type: 'String',
        id: 649,
        description: 'Unique identifier for Quote Status Request.',
    },
    {
        name: 'LegalConfirm',
        abbrName: 'LegalCnfm',
        added: 'FIX.4.3',
        type: 'LegalConfirmCodeSet',
        id: 650,
        description: 'Indicates that this message is to serve as the final and legal confirmation.',
    },
    {
        name: 'UnderlyingLastPx',
        abbrName: 'UndLastPx',
        added: 'FIX.4.3',
        type: 'Price',
        id: 651,
        description:
            'The calculated or traded price for the underlying instrument that corresponds to a derivative. Used for transactions that include the cash instrument and the derivative.',
    },
    {
        name: 'UnderlyingLastQty',
        abbrName: 'UndLastQty',
        added: 'FIX.4.3',
        type: 'Qty',
        id: 652,
        description:
            'The calculated or traded quantity for the underlying instrument that corresponds to a derivative. Used for transactions that include the cash instrument and the derivative.',
    },
    {
        name: 'LegRefID',
        abbrName: 'RefID',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.3',
        type: 'String',
        updatedEP: '131',
        id: 654,
        description:
            'Unique identifier for a specific leg (uniqueness not defined as part of the FIX specification). LegRefID(654) be used to reference the value from LegID(1788).',
    },
    {
        baseCategory: 'SingleGeneralOrderHandling',
        name: 'ContraLegRefID',
        abbrName: 'CntraLegRefID',
        added: 'FIX.4.3',
        type: 'String',
        baseCategoryAbbrName: 'LegRefID',
        id: 655,
        description: 'Unique indicator for a specific leg for the ContraBroker (375).',
    },
    {
        name: 'SettlCurrBidFxRate',
        abbrName: 'SettlCurrBidFxRt',
        added: 'FIX.4.3',
        type: 'float',
        id: 656,
        description:
            'Foreign exchange rate used to compute the bid "SettlCurrAmt" (119) from Currency (15) to SettlCurrency (120)',
    },
    {
        name: 'SettlCurrOfferFxRate',
        abbrName: 'SettlCurrOfrFxRt',
        added: 'FIX.4.3',
        type: 'float',
        id: 657,
        description:
            'Foreign exchange rate used to compute the offer "SettlCurrAmt" (119) from Currency (15) to SettlCurrency (120)',
    },
    {
        name: 'QuoteRequestRejectReason',
        abbrName: 'ReqRejRsn',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.Latest',
        added: 'FIX.4.3',
        type: 'QuoteRequestRejectReasonCodeSet',
        updatedEP: '290',
        id: 658,
        description: 'Reason quote request was rejected.',
    },
    {
        name: 'SideComplianceID',
        abbrName: 'SideComplianceID',
        added: 'FIX.4.3',
        type: 'String',
        id: 659,
        description:
            'ID within repeating group of sides which is used to represent this transaction for compliance purposes (e.g. OATS reporting).',
    },
    {
        name: 'AcctIDSource',
        abbrName: 'AcctIDSrc',
        unionDataType: 'Reserved100Plus',
        added: 'FIX.4.4',
        type: 'AcctIDSourceCodeSet',
        id: 660,
        description:
            'Used to identify the source of the Account (1) code. This is especially useful if the account is a new account that the Respondent may not have setup yet in their system.',
    },
    {
        name: 'AllocAcctIDSource',
        abbrName: 'ActIDSrc',
        added: 'FIX.4.4',
        type: 'AcctIDSourceCodeSet',
        id: 661,
        description:
            'Used to identify the source of the AllocAccount (79) code.\n\nSee AcctIDSource (660) for valid values.',
    },
    {
        name: 'BenchmarkPrice',
        abbrName: 'Px',
        added: 'FIX.4.4',
        type: 'Price',
        id: 662,
        description: 'Specifies the price of the benchmark.',
    },
    {
        name: 'BenchmarkPriceType',
        abbrName: 'PxTyp',
        added: 'FIX.4.4',
        type: 'PriceTypeCodeSet',
        id: 663,
        description: 'Identifies type of BenchmarkPrice (662).\n\nSee PriceType (423) for valid values.',
    },
    {
        name: 'ConfirmID',
        abbrName: 'CnfmID',
        added: 'FIX.4.4',
        type: 'String',
        id: 664,
        description: 'Message reference for Confirmation',
    },
    {
        name: 'ConfirmStatus',
        abbrName: 'CnfmStat',
        added: 'FIX.4.4',
        type: 'ConfirmStatusCodeSet',
        id: 665,
        description: 'Identifies the status of the Confirmation.',
    },
    {
        name: 'ConfirmTransType',
        abbrName: 'CnfmTransTyp',
        added: 'FIX.4.4',
        type: 'ConfirmTransTypeCodeSet',
        id: 666,
        description: 'Identifies the Confirmation transaction type.',
    },
    {
        name: 'ContractSettlMonth',
        abbrName: 'CSetMo',
        added: 'FIX.4.4',
        type: 'MonthYear',
        id: 667,
        description: 'Specifies when the contract (i.e. MBS/TBA) will settle.',
    },
    {
        name: 'DeliveryForm',
        abbrName: 'DlvryForm',
        added: 'FIX.4.4',
        type: 'DeliveryFormCodeSet',
        id: 668,
        description: 'Identifies the form of delivery.',
    },
    {
        name: 'LastParPx',
        abbrName: 'LastParPx',
        added: 'FIX.4.4',
        type: 'Price',
        id: 669,
        description:
            'Last price expressed in percent-of-par. Conditionally required for Fixed Income trades when LastPx (31) is expressed in Yield, Spread, Discount or any other type.\n\nUsage: Execution Report and Allocation Report repeating executions block (from sellside).',
    },
    {
        name: 'NoLegAllocs',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 670,
        description: 'Number of Allocations for the leg',
    },
    {
        name: 'LegAllocAccount',
        abbrName: 'AllocAcct',
        added: 'FIX.4.4',
        type: 'String',
        id: 671,
        description: 'Allocation Account for the leg\n\nSee AllocAccount (79) for description and valid values.',
    },
    {
        name: 'LegIndividualAllocID',
        abbrName: 'IndAllocID',
        added: 'FIX.4.4',
        type: 'String',
        id: 672,
        description:
            'Reference for the individual allocation ticket\n\nSee IndividualAllocID (467) for description and valid values.',
    },
    {
        name: 'LegAllocQty',
        abbrName: 'AllocQty',
        added: 'FIX.4.4',
        type: 'Qty',
        id: 673,
        description: 'Leg allocation quantity.\n\nSee AllocQty (80) for description and valid values.',
    },
    {
        name: 'LegAllocAcctIDSource',
        abbrName: 'AllocAcctIDSrc',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'AcctIDSourceCodeSet',
        updatedEP: '271',
        id: 674,
        description: 'Identifies the source of the LegAllocAccount(671).',
    },
    {
        name: 'LegSettlCurrency',
        abbrName: 'SettlCcy',
        added: 'FIX.4.4',
        type: 'Currency',
        id: 675,
        description:
            'Identifies settlement currency for the Leg.\n\nSee SettlCurrency (20) for description and valid values',
    },
    {
        name: 'LegBenchmarkCurveCurrency',
        abbrName: 'Ccy',
        added: 'FIX.4.4',
        type: 'Currency',
        id: 676,
        description:
            'LegBenchmarkPrice (679) currency\n\nSee BenchmarkCurveCurrency (220) for description and valid values.',
    },
    {
        name: 'LegBenchmarkCurveName',
        abbrName: 'Name',
        added: 'FIX.4.4',
        type: 'BenchmarkCurveNameCodeSet',
        id: 677,
        description:
            'Name of the Leg Benchmark Curve.\n\nSee BenchmarkCurveName (22) for description and valid values.',
    },
    {
        name: 'LegBenchmarkCurvePoint',
        abbrName: 'Point',
        added: 'FIX.4.4',
        type: 'String',
        id: 678,
        description:
            'Identifies the point on the Leg Benchmark Curve.\n\nSee BenchmarkCurvePoint (222) for description and valid values.',
    },
    {
        name: 'LegBenchmarkPrice',
        abbrName: 'Px',
        added: 'FIX.4.4',
        type: 'Price',
        id: 679,
        description:
            'Used to identify the price of the benchmark security.\n\nSee BenchmarkPrice (662) for description and valid values.',
    },
    {
        name: 'LegBenchmarkPriceType',
        abbrName: 'PxTyp',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.4',
        type: 'PriceTypeCodeSet',
        updatedEP: '204',
        id: 680,
        description: 'The price type of the LegBenchmarkPrice(679).',
    },
    {
        name: 'LegBidPx',
        abbrName: 'BidPx',
        added: 'FIX.4.4',
        type: 'Price',
        id: 681,
        description: 'Bid price of this leg.\n\nSee BidPx (32) for description and valid values.',
    },
    {
        name: 'LegIOIQty',
        abbrName: 'IOIQty',
        unionDataType: 'Qty',
        added: 'FIX.4.4',
        type: 'IOIQtyCodeSet',
        id: 682,
        description: 'Leg-specific IOI quantity.\n\nSee IOIQty (27) for description and valid values',
    },
    {
        name: 'NoLegStipulations',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 683,
        description: 'Number of leg stipulation entries',
    },
    {
        name: 'LegOfferPx',
        abbrName: 'OfrPx',
        added: 'FIX.4.4',
        type: 'Price',
        id: 684,
        description: 'Offer price of this leg.\n\nSee OfferPx (133) for description and valid values',
    },
    {
        name: 'LegOrderQty',
        abbrName: 'OrdQty',
        added: 'FIX.4.4',
        type: 'Qty',
        id: 685,
        description: 'Quantity ordered of this leg.\n\nSee OrderQty (38) for description and valid values',
    },
    {
        name: 'LegPriceType',
        abbrName: 'PxTyp',
        added: 'FIX.4.4',
        type: 'PriceTypeCodeSet',
        id: 686,
        description:
            'The price type of the LegBidPx (681) and/or LegOfferPx (684).\n\nSee PriceType (423) for description and valid values',
    },
    {
        name: 'LegQty',
        abbrName: 'Qty',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'Qty',
        updatedEP: '271',
        deprecated: 'FIX.5.0SP1',
        id: 687,
        description:
            'This field is deprecated and has been replaced by LegOrderQty(685). This field will likely be removed from the FIX standard in a future version.',
    },
    {
        name: 'LegStipulationType',
        abbrName: 'StipTyp',
        added: 'FIX.4.4',
        type: 'StipulationTypeCodeSet',
        id: 688,
        description:
            'For Fixed Income, type of Stipulation for this leg.\n\nSee StipulationType (233) for description and valid values',
    },
    {
        name: 'LegStipulationValue',
        abbrName: 'StipVal',
        added: 'FIX.4.4',
        type: 'String',
        id: 689,
        description:
            'For Fixed Income, value of stipulation.\n\nSee StipulationValue (234) for description and valid values',
    },
    {
        name: 'LegSwapType',
        abbrName: 'SwapTyp',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.4',
        type: 'LegSwapTypeCodeSet',
        updatedEP: '131',
        id: 690,
        description:
            'For Fixed Income, used instead of LegOrderQty(685) to requests the respondent to calculate the quantity based on the quantity on the opposite side of the swap.',
    },
    {
        name: 'Pool',
        abbrName: 'Pool',
        added: 'FIX.4.4',
        type: 'String',
        id: 691,
        description: 'For Fixed Income, identifies MBS / ABS pool.',
    },
    {
        name: 'QuotePriceType',
        abbrName: 'QuotPxTyp',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.4',
        type: 'QuotePriceTypeCodeSet',
        updatedEP: '207',
        id: 692,
        description:
            'Code to represent price type requested in Quote.\n\nIf the Quote Request is for a Swap, values 1-8 apply to all legs.',
    },
    {
        name: 'QuoteRespID',
        abbrName: 'RspID',
        added: 'FIX.4.4',
        type: 'String',
        id: 693,
        description: 'Message reference for Quote Response',
    },
    {
        name: 'QuoteRespType',
        abbrName: 'RspTyp',
        added: 'FIX.4.4',
        type: 'QuoteRespTypeCodeSet',
        id: 694,
        description: 'Identifies the type of Quote Response.',
    },
    {
        name: 'QuoteQualifier',
        abbrName: 'Qual',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.4',
        type: 'IOIQualifierCodeSet',
        updatedEP: '226',
        id: 695,
        description: 'Code to qualify Quote use and other aspects of price negotiation.',
    },
    {
        name: 'YieldRedemptionDate',
        abbrName: 'RedDt',
        added: 'FIX.4.4',
        type: 'LocalMktDate',
        id: 696,
        description:
            'Date to which the yield has been calculated (i.e. maturity, par call or current call, pre-refunded date).',
    },
    {
        name: 'YieldRedemptionPrice',
        abbrName: 'RedPx',
        added: 'FIX.4.4',
        type: 'Price',
        id: 697,
        description: 'Price to which the yield has been calculated.',
    },
    {
        name: 'YieldRedemptionPriceType',
        abbrName: 'RedPxTyp',
        added: 'FIX.4.4',
        type: 'PriceTypeCodeSet',
        id: 698,
        description:
            'The price type of the YieldRedemptionPrice (697)\n\nSee PriceType (423) for description and valid values.',
    },
    {
        name: 'BenchmarkSecurityID',
        abbrName: 'SecID',
        added: 'FIX.4.4',
        type: 'String',
        id: 699,
        discriminatorId: '761',
        description:
            'The identifier of the benchmark security, e.g. Treasury against Corporate bond.\n\nSee SecurityID (tag 48) for description and valid values.',
    },
    {
        name: 'ReversalIndicator',
        abbrName: 'ReversalInd',
        added: 'FIX.4.4',
        type: 'Boolean',
        id: 700,
        description: 'Indicates a trade that reverses a previous trade.',
    },
    {
        name: 'YieldCalcDate',
        abbrName: 'CalcDt',
        added: 'FIX.4.4',
        type: 'LocalMktDate',
        id: 701,
        description:
            'Include as needed to clarify yield irregularities associated with date, e.g. when it falls on a non-business day.',
    },
    {
        name: 'NoPositions',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 702,
        description: 'Number of position entries.',
    },
    {
        name: 'PosType',
        abbrName: 'Typ',
        added: 'FIX.4.4',
        type: 'PosTypeCodeSet',
        id: 703,
        description: 'Used to identify the type of quantity that is being returned.',
    },
    {
        name: 'LongQty',
        abbrName: 'Long',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.4',
        type: 'Qty',
        updatedEP: '141',
        id: 704,
        description: 'Long quantity.',
    },
    {
        name: 'ShortQty',
        abbrName: 'Short',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.4',
        type: 'Qty',
        updatedEP: '141',
        id: 705,
        description: 'Short quantity.',
    },
    {
        name: 'PosQtyStatus',
        abbrName: 'Stat',
        added: 'FIX.4.4',
        type: 'PosQtyStatusCodeSet',
        id: 706,
        description: 'Status of this position.',
    },
    {
        name: 'PosAmtType',
        abbrName: 'Typ',
        added: 'FIX.4.4',
        type: 'PosAmtTypeCodeSet',
        id: 707,
        description: 'Type of Position amount',
    },
    { name: 'PosAmt', abbrName: 'Amt', added: 'FIX.4.4', type: 'Amt', id: 708, description: 'Position amount' },
    {
        name: 'PosTransType',
        abbrName: 'TxnTyp',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.4',
        type: 'PosTransTypeCodeSet',
        updatedEP: '199',
        id: 709,
        description: 'Identifies the type of position transaction.',
    },
    {
        name: 'PosReqID',
        abbrName: 'ReqID',
        added: 'FIX.4.4',
        type: 'String',
        id: 710,
        description: 'Unique identifier for the position maintenance request as assigned by the submitter',
    },
    {
        name: 'NoUnderlyings',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 711,
        description: 'Number of underlying legs that make up the security.',
    },
    {
        name: 'PosMaintAction',
        abbrName: 'Actn',
        added: 'FIX.4.4',
        type: 'PosMaintActionCodeSet',
        id: 712,
        description: 'Maintenance Action to be performed.',
    },
    {
        baseCategory: 'PositionMaintenance',
        name: 'OrigPosReqRefID',
        abbrName: 'OrigPosReqRefID',
        added: 'FIX.4.4',
        type: 'String',
        baseCategoryAbbrName: 'OrigReqRefID',
        id: 713,
        description:
            'Reference to the PosReqID (710) of a previous maintenance request that is being replaced or canceled.',
    },
    {
        name: 'PosMaintRptRefID',
        abbrName: 'RptRefID',
        added: 'FIX.4.4',
        type: 'String',
        id: 714,
        description:
            'Reference to a PosMaintRptID (721) from a previous Position Maintenance Report that is being replaced or canceled.',
    },
    {
        name: 'ClearingBusinessDate',
        abbrName: 'BizDt',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.4',
        type: 'LocalMktDate',
        updatedEP: '150',
        id: 715,
        description: 'The business date for which the trade is expected to be cleared.',
    },
    {
        name: 'SettlSessID',
        abbrName: 'SetSesID',
        added: 'FIX.4.4',
        type: 'SettlSessIDCodeSet',
        id: 716,
        description: 'Identifies a specific settlement session',
    },
    {
        name: 'SettlSessSubID',
        abbrName: 'SetSesSub',
        added: 'FIX.4.4',
        type: 'String',
        id: 717,
        description: 'SubID value associated with SettlSessID(716)',
    },
    {
        name: 'AdjustmentType',
        abbrName: 'AdjTyp',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.4',
        type: 'AdjustmentTypeCodeSet',
        updatedEP: '155',
        id: 718,
        description:
            'Type of adjustment to be applied. Used for Position Change Submission (PCS), Position Adjustment (PAJ), and Customer Gross Margin (CGM).',
    },
    {
        baseCategory: 'SingleGeneralOrderHandling',
        name: 'ContraryInstructionIndicator',
        abbrName: 'CntraryInstrctnInd',
        added: 'FIX.4.4',
        type: 'Boolean',
        baseCategoryAbbrName: 'InstrctnInd',
        id: 719,
        description: 'Used to indicate when a contrary instruction for exercise or abandonment is being submitted',
    },
    {
        name: 'PriorSpreadIndicator',
        abbrName: 'PriorSpreadInd',
        added: 'FIX.4.4',
        type: 'Boolean',
        id: 720,
        description: "Indicates if requesting a rollover of prior day's spread submissions.",
    },
    {
        name: 'PosMaintRptID',
        abbrName: 'RptID',
        added: 'FIX.4.4',
        type: 'String',
        id: 721,
        description: 'Unique identifier for this position report',
    },
    {
        name: 'PosMaintStatus',
        abbrName: 'Stat',
        added: 'FIX.4.4',
        type: 'PosMaintStatusCodeSet',
        id: 722,
        description: 'Status of Position Maintenance Request',
    },
    {
        name: 'PosMaintResult',
        abbrName: 'Rslt',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.4',
        type: 'PosMaintResultCodeSet',
        updatedEP: '204',
        id: 723,
        description: 'Result of Position Maintenance Request.',
    },
    {
        name: 'PosReqType',
        abbrName: 'ReqTyp',
        added: 'FIX.4.4',
        type: 'PosReqTypeCodeSet',
        id: 724,
        description: 'Used to specify the type of position request being made.',
    },
    {
        name: 'ResponseTransportType',
        abbrName: 'RspTransportTyp',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'ResponseTransportTypeCodeSet',
        updatedEP: '282',
        id: 725,
        description: 'Identifies how the response to the request should be transmitted.',
    },
    {
        name: 'ResponseDestination',
        abbrName: 'RspDest',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'String',
        updatedEP: '294',
        id: 726,
        description:
            'URI (Uniform Resource Identifier) for details or other pre-arranged value. Used in conjunction with ResponseTransportType (725) value of Out-of-Band to identify the out-of-band destination.\n\nSee Appendix 6-B FIX Fields Based Upon Other Standards',
    },
    {
        deprecatedEP: '102',
        name: 'TotalNumPosReports',
        abbrName: 'TotRpts',
        added: 'FIX.4.4',
        type: 'int',
        deprecated: 'FIX.5.0SP2',
        id: 727,
        description: 'Total number of Position Reports being returned.',
    },
    {
        name: 'PosReqResult',
        abbrName: 'Rslt',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.4',
        type: 'PosReqResultCodeSet',
        updatedEP: '204',
        id: 728,
        description: 'Result of Request for Positions.',
    },
    {
        name: 'PosReqStatus',
        abbrName: 'Stat',
        added: 'FIX.4.4',
        type: 'PosReqStatusCodeSet',
        id: 729,
        description: 'Status of Request for Positions',
    },
    {
        name: 'SettlPrice',
        abbrName: 'SetPx',
        added: 'FIX.4.4',
        type: 'Price',
        id: 730,
        description: 'Settlement price',
    },
    {
        name: 'SettlPriceType',
        abbrName: 'SetPxTyp',
        added: 'FIX.4.4',
        type: 'SettlPriceTypeCodeSet',
        id: 731,
        description: 'Type of settlement price',
    },
    {
        name: 'UnderlyingSettlPrice',
        abbrName: 'UndSetPx',
        added: 'FIX.4.4',
        type: 'Price',
        id: 732,
        description: "Underlying security's SettlPrice.\n\nSee SettlPrice (730) field for description",
    },
    {
        name: 'UnderlyingSettlPriceType',
        abbrName: 'UndSetPxTyp',
        added: 'FIX.4.4',
        type: 'SettlPriceTypeCodeSet',
        id: 733,
        description: "Underlying security's SettlPriceType.\n\nSee SettlPriceType (731) field for description",
    },
    {
        name: 'PriorSettlPrice',
        abbrName: 'PriSetPx',
        added: 'FIX.4.4',
        type: 'Price',
        id: 734,
        description: 'Previous settlement price',
    },
    {
        name: 'NoQuoteQualifiers',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 735,
        description: 'Number of repeating groups of QuoteQualifiers (695).',
    },
    {
        name: 'AllocSettlCurrency',
        abbrName: 'AllocSettlCcy',
        added: 'FIX.4.4',
        type: 'Currency',
        id: 736,
        description: 'Currency code of settlement denomination for a specific AllocAccount (79).',
    },
    {
        baseCategory: 'Allocation',
        name: 'AllocSettlCurrAmt',
        abbrName: 'AllocSettlCurrAmt',
        added: 'FIX.4.4',
        type: 'Amt',
        baseCategoryAbbrName: 'SettlCcyAmt',
        id: 737,
        description:
            'Total amount due expressed in settlement currency (includes the effect of the forex transaction) for a specific AllocAccount (79).',
    },
    {
        name: 'InterestAtMaturity',
        abbrName: 'IntAtMat',
        added: 'FIX.4.4',
        type: 'Amt',
        id: 738,
        description: 'Amount of interest (i.e. lump-sum) at maturity.',
    },
    {
        name: 'LegDatedDate',
        abbrName: 'Dated',
        added: 'FIX.4.4',
        type: 'LocalMktDate',
        id: 739,
        description:
            'The effective date of a new securities issue determined by its underwriters. Often but not always the same as the Issue Date and the Interest Accrual Date',
    },
    {
        name: 'LegPool',
        abbrName: 'Pool',
        added: 'FIX.4.4',
        type: 'String',
        id: 740,
        description:
            'For Fixed Income, identifies MBS / ABS pool for a specific leg of a multi-leg instrument.\n\nSee Pool (691) for description and valid values.',
    },
    {
        name: 'AllocInterestAtMaturity',
        abbrName: 'IntAtMat',
        added: 'FIX.4.4',
        type: 'Amt',
        id: 741,
        description: 'Amount of interest (i.e. lump-sum) at maturity at the account-level.',
    },
    {
        name: 'AllocAccruedInterestAmt',
        abbrName: 'AcrdIntAmt',
        added: 'FIX.4.4',
        type: 'Amt',
        id: 742,
        description: 'Amount of Accrued Interest for convertible bonds and fixed income at the allocation-level.',
    },
    {
        name: 'DeliveryDate',
        abbrName: 'DlvDt',
        added: 'FIX.4.4',
        type: 'LocalMktDate',
        id: 743,
        description: 'Date of delivery.',
    },
    {
        name: 'AssignmentMethod',
        abbrName: 'AsgnMeth',
        added: 'FIX.4.4',
        type: 'AssignmentMethodCodeSet',
        id: 744,
        description:
            'Method by which short positions are assigned to an exercise notice during exercise and assignment processing',
    },
    {
        name: 'AssignmentUnit',
        abbrName: 'Unit',
        added: 'FIX.4.4',
        type: 'Qty',
        id: 745,
        description: 'Quantity Increment used in performing assignment.',
    },
    {
        name: 'OpenInterest',
        abbrName: 'OpenInt',
        added: 'FIX.4.4',
        type: 'Amt',
        id: 746,
        description: 'Open interest that was eligible for assignment.',
    },
    {
        name: 'ExerciseMethod',
        abbrName: 'ExrMethod',
        added: 'FIX.4.4',
        type: 'ExerciseMethodCodeSet',
        id: 747,
        description: 'Exercise Method used to in performing assignment.',
    },
    {
        name: 'TotNumTradeReports',
        abbrName: 'TotNumTrdRpts',
        added: 'FIX.4.4',
        type: 'int',
        id: 748,
        description: 'Total number of trade reports returned.',
    },
    {
        name: 'TradeRequestResult',
        abbrName: 'ReqRslt',
        unionDataType: 'Reserved100Plus',
        added: 'FIX.4.4',
        type: 'TradeRequestResultCodeSet',
        id: 749,
        description: 'Result of Trade Request',
    },
    {
        name: 'TradeRequestStatus',
        abbrName: 'ReqStat',
        added: 'FIX.4.4',
        type: 'TradeRequestStatusCodeSet',
        id: 750,
        description: 'Status of Trade Request.',
    },
    {
        name: 'TradeReportRejectReason',
        abbrName: 'RejRsn',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.4',
        type: 'TradeReportRejectReasonCodeSet',
        updatedEP: '107',
        id: 751,
        description:
            'Reason Trade Capture Request was rejected.\n\n100+ Reserved and available for bi-laterally agreed upon user-defined values.',
    },
    {
        name: 'SideMultiLegReportingType',
        abbrName: 'MLegRptTyp',
        added: 'FIX.4.4',
        type: 'SideMultiLegReportingTypeCodeSet',
        id: 752,
        description:
            'Used to indicate if the side being reported on Trade Capture Report represents a leg of a multileg instrument or a single security.',
    },
    {
        name: 'NoPosAmt',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 753,
        description: 'Number of position amount entries.',
    },
    {
        name: 'AutoAcceptIndicator',
        abbrName: 'AutoAcceptInd',
        added: 'FIX.4.4',
        type: 'Boolean',
        id: 754,
        description:
            'Identifies whether or not an allocation has been automatically accepted on behalf of the Carry Firm by the Clearing House.',
    },
    {
        name: 'AllocReportID',
        abbrName: 'RptID',
        added: 'FIX.4.4',
        type: 'String',
        id: 755,
        description: 'Unique identifier for Allocation Report message.',
    },
    {
        name: 'NoNested2PartyIDs',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 756,
        description: 'Number of Nested2PartyID (757), Nested2PartyIDSource (758), and Nested2PartyRole (759) entries',
    },
    {
        name: 'Nested2PartyID',
        abbrName: 'ID',
        added: 'FIX.4.4',
        type: 'String',
        id: 757,
        discriminatorId: '758',
        description: 'PartyID value within a "second instance" Nested repeating group.\n\nSame values as PartyID (448)',
    },
    {
        name: 'Nested2PartyIDSource',
        abbrName: 'Src',
        added: 'FIX.4.4',
        type: 'PartyIDSourceCodeSet',
        id: 758,
        description:
            'PartyIDSource value within a "second instance" Nested repeating group.\n\nSame values as PartyIDSource (447)',
    },
    {
        name: 'Nested2PartyRole',
        abbrName: 'R',
        added: 'FIX.4.4',
        type: 'PartyRoleCodeSet',
        id: 759,
        description:
            'PartyRole value within a "second instance" Nested repeating group.\n\nSame values as PartyRole (452)',
    },
    {
        name: 'Nested2PartySubID',
        abbrName: 'ID',
        added: 'FIX.4.4',
        type: 'String',
        id: 760,
        description:
            'PartySubID value within a "second instance" Nested repeating group.\n\nSame values as PartySubID (523)',
    },
    {
        name: 'BenchmarkSecurityIDSource',
        abbrName: 'SecIDSrc',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'SecurityIDSourceCodeSet',
        updatedEP: '271',
        id: 761,
        description:
            'Identifies class or source of the BenchmarkSecurityID(699) value.\n\nRequired if BenchmarkSecurityID is specified.',
    },
    {
        name: 'SecuritySubType',
        abbrName: 'SubTyp',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.4',
        type: 'String',
        updatedEP: '254',
        id: 762,
        description:
            'Sub-type qualification/identification of the SecurityType. As an example for SecurityType(167)="REPO", the SecuritySubType="General Collateral" can be used to further specify the type of REPO.\n\nIf SecuritySubType is used, then SecurityType is required.\n\nFor SecurityType="MLEG" a name of the option or futures strategy name can be specified, such as "Calendar", "Vertical", "Butterfly".\n\nFor SecurityType(167)="OPT" the subclassification can be specified, such as "Asian".\n\nFor SecurityType(167)="SWAPTION" a value of "Straddle" is used to identify a straddle swaption.\n\nIn the context of EU SFTR reporting use the appropriate 4-character code noted in the regulations - "GENE" for general collateral or "SPEC" for specific collateral (without quote marks).',
    },
    {
        name: 'UnderlyingSecuritySubType',
        abbrName: 'SubTyp',
        added: 'FIX.4.4',
        type: 'String',
        id: 763,
        description: "Underlying security's SecuritySubType.\n\nSee SecuritySubType (762) field for description",
    },
    {
        name: 'LegSecuritySubType',
        abbrName: 'SecSubTyp',
        added: 'FIX.4.4',
        type: 'String',
        id: 764,
        description: 'SecuritySubType of the leg instrument.\n\nSee SecuritySubType (762) field for description',
    },
    {
        name: 'AllowableOneSidednessPct',
        abbrName: 'AOSPct',
        added: 'FIX.4.4',
        type: 'Percentage',
        id: 765,
        description:
            'The maximum percentage that execution of one side of a program trade can exceed execution of the other.',
    },
    {
        name: 'AllowableOneSidednessValue',
        abbrName: 'AOSValu',
        added: 'FIX.4.4',
        type: 'Amt',
        id: 766,
        description:
            'The maximum amount that execution of one side of a program trade can exceed execution of the other.',
    },
    {
        name: 'AllowableOneSidednessCurr',
        abbrName: 'AOSCurr',
        added: 'FIX.4.4',
        type: 'Currency',
        id: 767,
        description:
            'The currency that AllowableOneSidednessValue (766) is expressed in if AllowableOneSidednessValue is used.',
    },
    {
        name: 'NoTrdRegTimestamps',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 768,
        description: 'Number of timestamp entries.',
    },
    {
        name: 'TrdRegTimestamp',
        abbrName: 'TS',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'UTCTimestamp',
        updatedEP: '291',
        id: 769,
        description:
            'Traded / Regulatory timestamp value.\n\nUse to store time information required by government regulators or self-regulatory organizations (such as an exchange or clearing house).',
    },
    {
        name: 'TrdRegTimestampType',
        abbrName: 'Typ',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'TrdRegTimestampTypeCodeSet',
        updatedEP: '291',
        id: 770,
        description:
            'Trading / Regulatory timestamp type.\n\nNote of applicability: Values are required in various regulatory environments: required for US futures markets to support computerized trade reconstruction, required by MiFID II / MiFIR for transaction reporting and publication, required by FINRA for reporting to the Consolidated Audit Trail (CAT), and required by SEC for recordkeeping requirements in the context of T+1.',
    },
    {
        name: 'TrdRegTimestampOrigin',
        abbrName: 'Src',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'String',
        updatedEP: '291',
        id: 771,
        description:
            'Text which identifies the "origin" (i.e. system which was used to generate the timestamp) for the Traded / Regulatory timestamp value.',
    },
    {
        name: 'ConfirmRefID',
        abbrName: 'CnfmRefID',
        added: 'FIX.4.4',
        type: 'String',
        id: 772,
        description: 'Reference identifier to be used with ConfirmTransType (666) = Replace or Cancel',
    },
    {
        name: 'ConfirmType',
        abbrName: 'CnfmTyp',
        added: 'FIX.4.4',
        type: 'ConfirmTypeCodeSet',
        id: 773,
        description: 'Identifies the type of Confirmation message being sent.',
    },
    {
        name: 'ConfirmRejReason',
        abbrName: 'CnfmRejRsn',
        unionDataType: 'Reserved100Plus',
        added: 'FIX.4.4',
        type: 'ConfirmRejReasonCodeSet',
        id: 774,
        description: 'Identifies the reason for rejecting a Confirmation.',
    },
    {
        name: 'BookingType',
        abbrName: 'BkngTyp',
        added: 'FIX.4.4',
        type: 'BookingTypeCodeSet',
        id: 775,
        description:
            'Method for booking out this order. Used when notifying a broker that an order to be settled by that broker is to be booked out as an OTC derivative (e.g. CFD or similar).',
    },
    {
        name: 'IndividualAllocRejCode',
        abbrName: 'IndAllocRejCode',
        added: 'FIX.4.4',
        type: 'AllocRejCodeCodeSet',
        id: 776,
        description:
            'Identified reason for rejecting an individual AllocAccount (79) detail.\n\nSame values as AllocRejCode (88)',
    },
    {
        name: 'SettlInstMsgID',
        abbrName: 'SettlInstMsgID',
        added: 'FIX.4.4',
        type: 'String',
        id: 777,
        description: 'Unique identifier for Settlement Instruction message.',
    },
    {
        name: 'NoSettlInst',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 778,
        description: 'Number of settlement instructions within repeating group.',
    },
    {
        name: 'LastUpdateTime',
        abbrName: 'LastUpdateTm',
        added: 'FIX.4.4',
        type: 'UTCTimestamp',
        id: 779,
        description: 'Timestamp of last update to data item (or creation if no updates made since creation).',
    },
    {
        name: 'AllocSettlInstType',
        abbrName: 'SettlInstTyp',
        added: 'FIX.4.4',
        type: 'AllocSettlInstTypeCodeSet',
        id: 780,
        description:
            'Used to indicate whether settlement instructions are provided on an allocation instruction message, and if not, how they are to be derived.',
    },
    {
        name: 'NoSettlPartyIDs',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 781,
        description: 'Number of SettlPartyID (782), SettlPartyIDSource (783), and SettlPartyRole (784) entries',
    },
    {
        name: 'SettlPartyID',
        abbrName: 'ID',
        added: 'FIX.4.4',
        type: 'String',
        id: 782,
        discriminatorId: '783',
        description:
            'PartyID value within a settlement parties component. Nested repeating group.\n\nSame values as PartyID (448)',
    },
    {
        name: 'SettlPartyIDSource',
        abbrName: 'Src',
        added: 'FIX.4.4',
        type: 'PartyIDSourceCodeSet',
        id: 783,
        description: 'PartyIDSource value within a settlement parties component.\n\nSame values as PartyIDSource (447)',
    },
    {
        name: 'SettlPartyRole',
        abbrName: 'R',
        added: 'FIX.4.4',
        type: 'PartyRoleCodeSet',
        id: 784,
        description: 'PartyRole value within a settlement parties component.\n\nSame values as PartyRole (452)',
    },
    {
        name: 'SettlPartySubID',
        abbrName: 'ID',
        added: 'FIX.4.4',
        type: 'String',
        id: 785,
        description: 'PartySubID value within a settlement parties component.\n\nSame values as PartySubID (523)',
    },
    {
        name: 'SettlPartySubIDType',
        abbrName: 'Typ',
        unionDataType: 'Reserved4000Plus',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'PartySubIDTypeCodeSet',
        updatedEP: '294',
        id: 786,
        description: 'Type of SettlPartySubID (785) value.\n\nSame values as PartySubIDType (803)',
    },
    {
        name: 'DlvyInstType',
        abbrName: 'InstTyp',
        added: 'FIX.4.4',
        type: 'DlvyInstTypeCodeSet',
        id: 787,
        description: 'Used to indicate whether a delivery instruction is used for securities or cash settlement.',
    },
    {
        name: 'TerminationType',
        abbrName: 'TrmTyp',
        added: 'FIX.4.4',
        type: 'TerminationTypeCodeSet',
        id: 788,
        description: 'Type of financing termination.',
    },
    {
        name: 'NextExpectedMsgSeqNum',
        abbrName: 'NextExpectedMsgSeqNum',
        added: 'FIX.4.4',
        type: 'SeqNum',
        id: 789,
        description: 'Next expected MsgSeqNum value to be received.',
    },
    {
        name: 'OrdStatusReqID',
        abbrName: 'StatReqID',
        added: 'FIX.4.4',
        type: 'String',
        id: 790,
        description: 'Can be used to uniquely identify a specific Order Status Request message.',
    },
    {
        name: 'SettlInstReqID',
        abbrName: 'SettlInstReqID',
        added: 'FIX.4.4',
        type: 'String',
        id: 791,
        description: 'Unique ID of settlement instruction request message',
    },
    {
        name: 'SettlInstReqRejCode',
        abbrName: 'SettlInstReqRejCode',
        unionDataType: 'Reserved100Plus',
        added: 'FIX.4.4',
        type: 'SettlInstReqRejCodeCodeSet',
        id: 792,
        description: 'Identifies reason for rejection (of a settlement instruction request message).',
    },
    {
        baseCategory: 'Allocation',
        name: 'SecondaryAllocID',
        abbrName: 'AllocID2',
        added: 'FIX.4.4',
        type: 'String',
        baseCategoryAbbrName: 'ID2',
        id: 793,
        description:
            'Secondary allocation identifier. Unlike the AllocID (70), this can be shared across a number of allocation instruction or allocation report messages, thereby making it possible to pass an identifier for an original allocation message on multiple messages (e.g. from one party to a second to a third, across cancel and replace messages etc.).',
    },
    {
        name: 'AllocReportType',
        abbrName: 'RptTyp',
        added: 'FIX.4.4',
        type: 'AllocReportTypeCodeSet',
        id: 794,
        description: 'Describes the specific type or purpose of an Allocation Report message',
    },
    {
        name: 'AllocReportRefID',
        abbrName: 'RptRefID',
        added: 'FIX.4.4',
        type: 'String',
        id: 795,
        description: 'Reference identifier to be used with AllocTransType (7) = Replace or Cancel',
    },
    {
        baseCategory: 'Allocation',
        name: 'AllocCancReplaceReason',
        abbrName: 'CxlRplcRsn',
        unionDataType: 'Reserved100Plus',
        added: 'FIX.4.4',
        type: 'AllocCancReplaceReasonCodeSet',
        baseCategoryAbbrName: 'CxlRplcRsn',
        id: 796,
        description: 'Reason for cancelling or replacing an Allocation Instruction or Allocation Report message',
    },
    {
        name: 'CopyMsgIndicator',
        abbrName: 'CopyMsgInd',
        added: 'FIX.4.4',
        type: 'Boolean',
        id: 797,
        description: 'Indicates whether or not this message is a drop copy of another message.',
    },
    {
        name: 'AllocAccountType',
        abbrName: 'AcctTyp',
        added: 'FIX.4.4',
        type: 'AllocAccountTypeCodeSet',
        id: 798,
        description: 'Type of account associated with a confirmation or other trade-level message',
    },
    {
        name: 'OrderAvgPx',
        abbrName: 'AvgPx',
        added: 'FIX.4.4',
        type: 'Price',
        id: 799,
        description: 'Average price for a specific order',
    },
    {
        name: 'OrderBookingQty',
        abbrName: 'BkngQty',
        added: 'FIX.4.4',
        type: 'Qty',
        id: 800,
        description:
            'Quantity of the order that is being booked out as part of an Allocation Instruction or Allocation Report message',
    },
    {
        name: 'NoSettlPartySubIDs',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 801,
        description: 'Number of SettlPartySubID (785) and SettlPartySubIDType (786) entries',
    },
    {
        name: 'NoPartySubIDs',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 802,
        description: 'Number of PartySubID (523)and PartySubIDType (803) entries',
    },
    {
        name: 'PartySubIDType',
        abbrName: 'Typ',
        unionDataType: 'Reserved4000Plus',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.4',
        type: 'PartySubIDTypeCodeSet',
        updatedEP: '204',
        id: 803,
        description: 'Type of PartySubID(523) value.',
    },
    {
        name: 'NoNestedPartySubIDs',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 804,
        description: 'Number of NestedPartySubID (545) and NestedPartySubIDType (805) entries',
    },
    {
        name: 'NestedPartySubIDType',
        abbrName: 'Typ',
        unionDataType: 'Reserved4000Plus',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'PartySubIDTypeCodeSet',
        updatedEP: '294',
        id: 805,
        description: 'Type of NestedPartySubID (545) value.\n\nSame values as PartySubIDType (803)',
    },
    {
        name: 'NoNested2PartySubIDs',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 806,
        description:
            'Number of Nested2PartySubID (760) and Nested2PartySubIDType (807) entries. Second instance of <NestedParties>.',
    },
    {
        name: 'Nested2PartySubIDType',
        abbrName: 'Typ',
        unionDataType: 'Reserved4000Plus',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'PartySubIDTypeCodeSet',
        updatedEP: '294',
        id: 807,
        description:
            'Type of Nested2PartySubID (760) value. Second instance of <NestedParties>.\n\nSame values as PartySubIDType (803)',
    },
    {
        baseCategory: 'Allocation',
        name: 'AllocIntermedReqType',
        abbrName: 'IntermedReqTyp',
        added: 'FIX.4.4',
        type: 'AllocIntermedReqTypeCodeSet',
        baseCategoryAbbrName: 'ImReqTyp',
        id: 808,
        description:
            'Response to allocation to be communicated to a counterparty through an intermediary, i.e. clearing house. Used in conjunction with AllocType = "Request to Intermediary" and AllocReportType = "Request to Intermediary"',
    },
    {
        name: 'UnderlyingPx',
        abbrName: 'Px',
        added: 'FIX.4.4',
        type: 'Price',
        id: 810,
        description: 'Underlying price associate with a derivative instrument.',
    },
    {
        name: 'PriceDelta',
        abbrName: 'PxDelta',
        added: 'FIX.4.4',
        type: 'float',
        id: 811,
        description:
            'The rate of change in the price of a derivative with respect to the movement in the price of the underlying instrument(s) upon which the derivative instrument price is based.\n\nThis value is normally between -1.0 and 1.0.',
    },
    {
        name: 'ApplQueueMax',
        abbrName: 'ApplQuMax',
        added: 'FIX.4.4',
        type: 'int',
        id: 812,
        description:
            'Used to specify the maximum number of application messages that can be queued bedore a corrective action needs to take place to resolve the queuing issue.',
    },
];

const batch2: ISpecFields[] = [
    {
        name: 'ApplQueueDepth',
        abbrName: 'ApplQuDepth',
        added: 'FIX.4.4',
        type: 'int',
        id: 813,
        description:
            'Current number of application messages that were queued at the time that the message was created by the counterparty.',
    },
    {
        name: 'ApplQueueResolution',
        abbrName: 'ApplQuResolution',
        added: 'FIX.4.4',
        type: 'ApplQueueResolutionCodeSet',
        id: 814,
        description:
            'Resolution taken when ApplQueueDepth (813) exceeds ApplQueueMax (812) or system specified maximum queue size.',
    },
    {
        name: 'ApplQueueAction',
        abbrName: 'ApplQuActn',
        added: 'FIX.4.4',
        type: 'ApplQueueActionCodeSet',
        id: 815,
        description: 'Action to take to resolve an application message queue (backlog).',
    },
    {
        name: 'NoAltMDSource',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 816,
        description: 'Number of alternative market data sources',
    },
    {
        name: 'AltMDSourceID',
        abbrName: 'AltMDSrcID',
        added: 'FIX.4.4',
        type: 'String',
        id: 817,
        description:
            'Session layer source for market data\n\n(For the standard FIX session layer, this would be the TargetCompID (56) where market data can be obtained).',
    },
    {
        baseCategory: 'TradeCapture',
        name: 'SecondaryTradeReportID',
        abbrName: 'TrdRptID2',
        added: 'FIX.4.4',
        type: 'String',
        deprecated: 'FIX.5.0',
        baseCategoryAbbrName: 'RptID2',
        id: 818,
        description:
            'Secondary trade report identifier - can be used to associate an additional identifier with a trade.',
    },
    {
        name: 'AvgPxIndicator',
        abbrName: 'AvgPxInd',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.4',
        type: 'AvgPxIndicatorCodeSet',
        updatedEP: '239',
        id: 819,
        description: 'Average pricing indicator.',
    },
    {
        baseCategory: 'TradeCapture',
        name: 'TradeLinkID',
        abbrName: 'LinkID',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.4',
        type: 'String',
        updatedEP: '141',
        baseCategoryAbbrName: 'LinkID',
        id: 820,
        description: 'Used to link a group of trades together.',
    },
    {
        name: 'OrderInputDevice',
        abbrName: 'OrdInptDev',
        added: 'FIX.4.4',
        type: 'String',
        id: 821,
        description: 'Specific device number, terminal number or station where order was entered',
    },
    {
        name: 'UnderlyingTradingSessionID',
        abbrName: 'UndSesID',
        added: 'FIX.4.4',
        type: 'String',
        id: 822,
        description: 'Trading Session in which the underlying instrument trades',
    },
    {
        name: 'UnderlyingTradingSessionSubID',
        abbrName: 'UndSesSub',
        added: 'FIX.4.4',
        type: 'String',
        id: 823,
        description: 'Trading Session sub identifier in which the underlying instrument trades',
    },
    {
        name: 'TradeLegRefID',
        abbrName: 'TrdLegRefID',
        added: 'FIX.4.4',
        type: 'String',
        id: 824,
        description: 'Reference to the leg of a multileg instrument to which this trade refers',
    },
    {
        name: 'ExchangeRule',
        abbrName: 'ExchRule',
        added: 'FIX.4.4',
        type: 'String',
        id: 825,
        description:
            'Used to report any exchange rules that apply to this trade.\n\nPrimarily intended for US futures markets. Certain trading practices are permitted by the CFTC, such as large lot trading, block trading, all or none trades. If the rules are used, the exchanges are required to indicate these rules on the trade.',
    },
    {
        name: 'TradeAllocIndicator',
        abbrName: 'AllocInd',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.4',
        type: 'TradeAllocIndicatorCodeSet',
        updatedEP: '141',
        id: 826,
        description: 'Identifies if, and how, the trade is to be allocated or split.',
    },
    {
        name: 'ExpirationCycle',
        abbrName: 'ExpirationCycle',
        added: 'FIX.4.4',
        type: 'ExpirationCycleCodeSet',
        id: 827,
        description: 'Part of trading cycle when an instrument expires. Field is applicable for derivatives.',
    },
    {
        name: 'TrdType',
        abbrName: 'TrdTyp',
        unionDataType: 'Reserved1000Plus',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'TrdTypeCodeSet',
        updatedEP: '289',
        id: 828,
        description:
            'Type of trade assigned to a trade. SecondaryTrdType(855) and TertiaryTrdType(2896) may be used in addition to TrdType(828) to assign up to three different trade types to a single trade.\n\nNote: several enumerations of this field duplicate the enumerations in TradePriceCondition(1839) field. These may be deprecated from TrdType(828) in the future. TradePriceCondition(1839) is preferred in messages that support it.',
    },
    {
        name: 'TrdSubType',
        abbrName: 'TrdSubTyp',
        unionDataType: 'Reserved1000Plus',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'TrdSubTypeCodeSet',
        updatedEP: '289',
        id: 829,
        description: 'Further qualification to the trade type defined in TrdType(828).',
    },
    {
        name: 'TransferReason',
        abbrName: 'TrnsfrRsn',
        added: 'FIX.4.4',
        type: 'String',
        id: 830,
        description: 'Reason trade is being transferred',
    },
    {
        name: 'TotNumAssignmentReports',
        abbrName: 'TotNumAsgnRpts',
        added: 'FIX.4.4',
        type: 'int',
        id: 832,
        description: 'Total Number of Assignment Reports being returned to a firm',
    },
    {
        name: 'AsgnRptID',
        abbrName: 'RptID',
        added: 'FIX.4.4',
        type: 'String',
        id: 833,
        description: 'Unique identifier for the Assignment Report',
    },
    {
        name: 'ThresholdAmount',
        abbrName: 'ThresholdAmt',
        added: 'FIX.4.4',
        type: 'PriceOffset',
        id: 834,
        description: 'Amount that a position has to be in the money before it is exercised.',
    },
    {
        name: 'PegMoveType',
        abbrName: 'MoveTyp',
        added: 'FIX.4.4',
        type: 'PegMoveTypeCodeSet',
        id: 835,
        description: 'Describes whether peg is static or floats',
    },
    {
        name: 'PegOffsetType',
        abbrName: 'OfstTyp',
        added: 'FIX.4.4',
        type: 'PegOffsetTypeCodeSet',
        id: 836,
        description: 'Type of Peg Offset value',
    },
    {
        name: 'PegLimitType',
        abbrName: 'LmtTyp',
        added: 'FIX.4.4',
        type: 'PegLimitTypeCodeSet',
        id: 837,
        description: 'Type of Peg Limit',
    },
    {
        name: 'PegRoundDirection',
        abbrName: 'RndDir',
        added: 'FIX.4.4',
        type: 'PegRoundDirectionCodeSet',
        id: 838,
        description:
            'If the calculated peg price is not a valid tick price, specifies whether to round the price to be more or less aggressive',
    },
    {
        name: 'PeggedPrice',
        abbrName: 'PeggedPx',
        added: 'FIX.4.4',
        type: 'Price',
        id: 839,
        description: 'The price the order is currently pegged at',
    },
    {
        name: 'PegScope',
        abbrName: 'Scope',
        added: 'FIX.4.4',
        type: 'PegScopeCodeSet',
        id: 840,
        description: 'The scope of the peg',
    },
    {
        name: 'DiscretionMoveType',
        abbrName: 'MoveTyp',
        added: 'FIX.4.4',
        type: 'DiscretionMoveTypeCodeSet',
        id: 841,
        description: 'Describes whether discretionay price is static or floats',
    },
    {
        name: 'DiscretionOffsetType',
        abbrName: 'OfstTyp',
        added: 'FIX.4.4',
        type: 'DiscretionOffsetTypeCodeSet',
        id: 842,
        description: 'Type of Discretion Offset value',
    },
    {
        name: 'DiscretionLimitType',
        abbrName: 'LimitTyp',
        added: 'FIX.4.4',
        type: 'DiscretionLimitTypeCodeSet',
        id: 843,
        description: 'Type of Discretion Limit',
    },
    {
        name: 'DiscretionRoundDirection',
        abbrName: 'RndDir',
        added: 'FIX.4.4',
        type: 'DiscretionRoundDirectionCodeSet',
        id: 844,
        description:
            'If the calculated discretionary price is not a valid tick price, specifies whether to round the price to be more or less aggressive',
    },
    {
        name: 'DiscretionPrice',
        abbrName: 'DsctnPx',
        added: 'FIX.4.4',
        type: 'Price',
        id: 845,
        description: 'The current discretionary price of the order',
    },
    {
        name: 'DiscretionScope',
        abbrName: 'Scope',
        added: 'FIX.4.4',
        type: 'DiscretionScopeCodeSet',
        id: 846,
        description: 'The scope of the discretion',
    },
    {
        name: 'TargetStrategy',
        abbrName: 'TgtStrategy',
        unionDataType: 'Reserved1000Plus',
        added: 'FIX.4.4',
        type: 'TargetStrategyCodeSet',
        id: 847,
        description:
            'The target strategy of the order\n\n1000+ = Reserved and available for bi-laterally agreed upon user defined values',
    },
    {
        name: 'TargetStrategyParameters',
        abbrName: 'TgtStrategyParameters',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'String',
        updatedEP: '282',
        deprecated: 'FIX.5.0',
        id: 848,
        description:
            'Field to allow further specification of the TargetStrategy - usage to be agreed between counterparties\n\nThe StrategyParametersGrp repeating group is used instead to convey target strategy parameters and values.',
    },
    {
        name: 'ParticipationRate',
        abbrName: 'ParticipationRt',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'Percentage',
        updatedEP: '282',
        deprecated: 'FIX.5.0',
        id: 849,
        description:
            'For a TargetStrategy=Participate order specifies the target particpation rate. For other order types this is a volume limit (i.e. do not be more than this percent of the market volume)\n\nThe StrategyParametersGrp repeating group is used instead to convey target strategy parameters and values.',
    },
    {
        name: 'TargetStrategyPerformance',
        abbrName: 'TgtStrategyPerformance',
        added: 'FIX.4.4',
        type: 'float',
        id: 850,
        description: 'For communication of the performance of the order versus the target strategy',
    },
    {
        name: 'LastLiquidityInd',
        abbrName: 'LastLqdtyInd',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.4',
        type: 'LastLiquidityIndCodeSet',
        updatedEP: '223',
        id: 851,
        description:
            'Indicator to identify whether this fill was a result of a liquidity provider providing or liquidity taker taking the liquidity.',
    },
    {
        name: 'PublishTrdIndicator',
        abbrName: 'PubTrdInd',
        added: 'FIX.4.4',
        type: 'PublishTrdIndicatorCodeSet',
        deprecated: 'FIX.5.0',
        id: 852,
        description: 'Indicates if a trade should be reported via a market reporting service.',
    },
    {
        name: 'ShortSaleReason',
        abbrName: 'ShrtSaleRsn',
        added: 'FIX.4.4',
        type: 'ShortSaleReasonCodeSet',
        id: 853,
        description: 'Reason for short sale.',
    },
    {
        name: 'QtyType',
        abbrName: 'QtyTyp',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.4',
        type: 'QtyTypeCodeSet',
        updatedEP: '107',
        id: 854,
        description:
            'Type of quantity specified in quantity field. ContractMultiplier (tag 231) is required when QtyType = 1 (Contracts). UnitOfMeasure (tag 996) and TimeUnit (tag 997) are required when QtyType = 2 (Units of Measure per Time Unit).',
    },
    {
        name: 'SecondaryTrdType',
        abbrName: 'TrdTyp2',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'TrdTypeCodeSet',
        updatedEP: '268',
        id: 855,
        description:
            'Type of trade assigned to a trade. Used in addition to TrdType(828). Must not be used when only one trade type needs to be assigned.',
    },
    {
        name: 'TradeReportType',
        abbrName: 'RptTyp',
        added: 'FIX.4.4',
        type: 'TradeReportTypeCodeSet',
        id: 856,
        description: 'Type of Trade Report',
    },
    {
        name: 'AllocNoOrdersType',
        abbrName: 'NoOrdsTyp',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.4',
        type: 'AllocNoOrdersTypeCodeSet',
        updatedEP: '118',
        id: 857,
        description:
            'Indicates how the orders being booked and allocated by an AllocationInstruction or AllocationReport message are identified, e.g. by explicit definition in the OrdAllocGrp or ExecAllocGrp components, or not identified explicitly.',
    },
    {
        name: 'SharedCommission',
        abbrName: 'SharedComm',
        added: 'FIX.4.4',
        type: 'Amt',
        id: 858,
        description:
            'Commission to be shared with a third party, e.g. as part of a directed brokerage commission sharing arrangement.',
    },
    {
        name: 'ConfirmReqID',
        abbrName: 'CnfmReqID',
        added: 'FIX.4.4',
        type: 'String',
        id: 859,
        description: 'Unique identifier for a Confirmation Request message',
    },
    {
        name: 'AvgParPx',
        abbrName: 'AvgParPx',
        added: 'FIX.4.4',
        type: 'Price',
        id: 860,
        description:
            'Used to express average price as percent of par (used where AvgPx field is expressed in some other way)',
    },
    {
        name: 'ReportedPx',
        abbrName: 'RptedPx',
        added: 'FIX.4.4',
        type: 'Price',
        id: 861,
        description:
            'Reported price (used to differentiate from AvgPx on a confirmation of a marked-up or marked-down principal trade)',
    },
    {
        name: 'NoCapacities',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 862,
        description: 'Number of repeating OrderCapacity entries.',
    },
    {
        name: 'OrderCapacityQty',
        abbrName: 'CpctyQty',
        added: 'FIX.4.4',
        type: 'Qty',
        id: 863,
        description:
            'Quantity executed under a specific OrderCapacity (e.g. quantity executed as agent, quantity executed as principal)',
    },
    {
        name: 'NoEvents',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 864,
        description: 'Number of repeating EventType entries.',
    },
    {
        name: 'EventType',
        abbrName: 'EventTyp',
        unionDataType: 'Reserved100Plus',
        added: 'FIX.4.4',
        type: 'EventTypeCodeSet',
        id: 865,
        description: 'Code to represent the type of event',
    },
    {
        name: 'EventDate',
        abbrName: 'Dt',
        added: 'FIX.4.4',
        type: 'LocalMktDate',
        id: 866,
        description: 'Date of event',
    },
    {
        name: 'EventPx',
        abbrName: 'Px',
        added: 'FIX.4.4',
        type: 'Price',
        id: 867,
        description: 'Predetermined price of issue at event, if applicable',
    },
    {
        name: 'EventText',
        abbrName: 'Txt',
        added: 'FIX.4.4',
        type: 'String',
        id: 868,
        description: 'Comments related to the event.',
    },
    {
        name: 'PctAtRisk',
        abbrName: 'PctAtRisk',
        added: 'FIX.4.4',
        type: 'Percentage',
        id: 869,
        description: 'Percent at risk due to lowest possible call.',
    },
    {
        name: 'NoInstrAttrib',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 870,
        description: 'Number of repeating InstrAttribType entries.',
    },
    {
        name: 'InstrAttribType',
        abbrName: 'Typ',
        unionDataType: 'Reserved100Plus',
        added: 'FIX.4.4',
        type: 'InstrAttribTypeCodeSet',
        id: 871,
        description: 'Code to represent the type of instrument attribute',
    },
    {
        name: 'InstrAttribValue',
        abbrName: 'Val',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'String',
        updatedEP: '271',
        id: 872,
        description: 'Attribute value appropriate to the InstrAttribType (871) field.',
    },
    {
        name: 'DatedDate',
        abbrName: 'Dated',
        added: 'FIX.4.4',
        type: 'LocalMktDate',
        id: 873,
        description:
            'The effective date of a new securities issue determined by its underwriters. Often but not always the same as the Issue Date and the Interest Accrual Date',
    },
    {
        name: 'InterestAccrualDate',
        abbrName: 'IntAcrl',
        added: 'FIX.4.4',
        type: 'LocalMktDate',
        id: 874,
        description:
            'The start date used for calculating accrued interest on debt instruments which are being sold between interest payment dates. Often but not always the same as the Issue Date and the Dated Date',
    },
    {
        name: 'CPProgram',
        abbrName: 'CPPgm',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.4',
        type: 'CPProgramCodeSet',
        updatedEP: '201',
        id: 875,
        description:
            'The program under which a commercial paper offering is exempt from SEC registration identified by the paragraph number(s) within the US Securities Act of 1933 or as identified below.',
    },
    {
        name: 'CPRegType',
        abbrName: 'CPRegT',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.4',
        type: 'String',
        updatedEP: '201',
        id: 876,
        description:
            'The description of commercial paper registration or rule under which exempt commercial paper is offered. For example "144a", "Tax Exempt" or "REG. S".',
    },
    {
        name: 'UnderlyingCPProgram',
        abbrName: 'CPPgm',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.4',
        type: 'CPProgramCodeSet',
        updatedEP: '187',
        id: 877,
        description: 'The program under which the underlying commercial paper is issued',
    },
    {
        name: 'UnderlyingCPRegType',
        abbrName: 'CPRegTyp',
        added: 'FIX.4.4',
        type: 'String',
        id: 878,
        description: 'The registration type of the underlying commercial paper issuance',
    },
    {
        name: 'UnderlyingQty',
        abbrName: 'Qty',
        added: 'FIX.4.4',
        type: 'Qty',
        id: 879,
        description: 'Unit amount of the underlying security (par, shares, currency, etc.)',
    },
    {
        name: 'TrdMatchID',
        abbrName: 'MtchID',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'String',
        updatedEP: '279',
        id: 880,
        description:
            'Identifier assigned by a matching system to a match event that results in multiple executions or trades.',
    },
    {
        baseCategory: 'TradeCapture',
        name: 'SecondaryTradeReportRefID',
        abbrName: 'TrdRptRefID2',
        added: 'FIX.4.4',
        type: 'String',
        deprecated: 'FIX.5.0',
        baseCategoryAbbrName: 'RptRefID2',
        id: 881,
        description:
            'Used to refer to a previous SecondaryTradeReportRefID when amending the transaction (cancel, replace, release, or reversal).',
    },
    {
        name: 'UnderlyingDirtyPrice',
        abbrName: 'DirtPx',
        added: 'FIX.4.4',
        type: 'Price',
        id: 882,
        description:
            'Price (percent-of-par or per unit) of the underlying security or basket. "Dirty" means it includes accrued interest',
    },
    {
        name: 'UnderlyingEndPrice',
        abbrName: 'EndPx',
        added: 'FIX.4.4',
        type: 'Price',
        id: 883,
        description:
            'Price (percent-of-par or per unit) of the underlying security or basket at the end of the agreement.',
    },
    {
        name: 'UnderlyingStartValue',
        abbrName: 'StartVal',
        added: 'FIX.4.4',
        type: 'Amt',
        id: 884,
        description: 'Currency value attributed to this collateral at the start of the agreement',
    },
    {
        name: 'UnderlyingCurrentValue',
        abbrName: 'CurVal',
        added: 'FIX.4.4',
        type: 'Amt',
        id: 885,
        description: 'Currency value currently attributed to this collateral',
    },
    {
        name: 'UnderlyingEndValue',
        abbrName: 'EndVal',
        added: 'FIX.4.4',
        type: 'Amt',
        id: 886,
        description: 'Currency value attributed to this collateral at the end of the agreement',
    },
    {
        name: 'NoUnderlyingStips',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 887,
        description: 'Number of underlying stipulation entries',
    },
    {
        name: 'UnderlyingStipType',
        abbrName: 'Typ',
        added: 'FIX.4.4',
        type: 'StipulationTypeCodeSet',
        id: 888,
        description: 'Type of stipulation.\n\nSame values as StipulationType (233)',
    },
    {
        name: 'UnderlyingStipValue',
        abbrName: 'Val',
        added: 'FIX.4.4',
        type: 'String',
        id: 889,
        description: 'Value of stipulation.\n\nSame values as StipulationValue (234)',
    },
    {
        name: 'MaturityNetMoney',
        abbrName: 'MatNetMny',
        added: 'FIX.4.4',
        type: 'Amt',
        id: 890,
        description: 'Net Money at maturity if Zero Coupon and maturity value is different from par value',
    },
    {
        name: 'MiscFeeBasis',
        abbrName: 'Basis',
        added: 'FIX.4.4',
        type: 'MiscFeeBasisCodeSet',
        id: 891,
        description: 'Defines the unit for a miscellaneous fee.',
    },
    {
        name: 'TotNoAllocs',
        abbrName: 'TotNoAllocs',
        added: 'FIX.4.4',
        type: 'int',
        id: 892,
        description:
            'Total number of NoAlloc entries across all messages. Should be the sum of all NoAllocs in each message that has repeating NoAlloc entries related to the same AllocID or AllocReportID. Used to support fragmentation.',
    },
    {
        name: 'LastFragment',
        abbrName: 'LastFragment',
        added: 'FIX.4.4',
        type: 'LastFragmentCodeSet',
        id: 893,
        description:
            'Indicates whether this message is the last in a sequence of messages for those messages that support fragmentation, such as Allocation Instruction, Mass Quote, Security List, Derivative Security List',
    },
    {
        name: 'CollReqID',
        abbrName: 'ReqID',
        added: 'FIX.4.4',
        type: 'String',
        id: 894,
        description: 'Collateral Request Identifier',
    },
    {
        name: 'CollAsgnReason',
        abbrName: 'AsgnRsn',
        added: 'FIX.4.4',
        type: 'CollAsgnReasonCodeSet',
        id: 895,
        description: 'Reason for Collateral Assignment',
    },
    {
        name: 'CollInquiryQualifier',
        abbrName: 'Qual',
        added: 'FIX.4.4',
        type: 'CollInquiryQualifierCodeSet',
        id: 896,
        description: 'Collateral inquiry qualifiers:',
    },
    {
        name: 'NoTrades',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 897,
        description: 'Number of trades in repeating group.',
    },
    {
        name: 'MarginRatio',
        abbrName: 'MgnRatio',
        added: 'FIX.4.4',
        type: 'Percentage',
        id: 898,
        description:
            'The fraction of the cash consideration that must be collateralized, expressed as a percent. A MarginRatio of 02% indicates that the value of the collateral (after deducting for "haircut") must exceed the cash consideration by 2%.',
    },
    {
        name: 'MarginExcess',
        abbrName: 'MgnExcess',
        added: 'FIX.4.4',
        type: 'Amt',
        id: 899,
        description: 'Excess margin amount (deficit if value is negative)',
    },
    {
        name: 'TotalNetValue',
        abbrName: 'TotNetValu',
        added: 'FIX.4.4',
        type: 'Amt',
        id: 900,
        description:
            'TotalNetValue is determined as follows:\n\nAt the initial collateral assignment TotalNetValue is the sum of (UnderlyingStartValue * (1-haircut)).\n\nIn a collateral substitution TotalNetValue is the sum of (UnderlyingCurrentValue * (1-haircut)).\n\nFor listed derivatives clearing margin management, this is the collateral value which equals (Market value * haircut)',
    },
    {
        name: 'CashOutstanding',
        abbrName: 'CshOutstanding',
        added: 'FIX.4.4',
        type: 'Amt',
        id: 901,
        description: 'Starting consideration less repayments',
    },
    {
        name: 'CollAsgnID',
        abbrName: 'ID',
        added: 'FIX.4.4',
        type: 'String',
        id: 902,
        description: 'Collateral Assignment Identifier',
    },
    {
        name: 'CollAsgnTransType',
        abbrName: 'TransTyp',
        added: 'FIX.4.4',
        type: 'CollAsgnTransTypeCodeSet',
        id: 903,
        description: 'Collateral Assignment Transaction Type',
    },
    {
        name: 'CollRespID',
        abbrName: 'RespID',
        added: 'FIX.4.4',
        type: 'String',
        id: 904,
        description: 'Collateral Response Identifier',
    },
    {
        name: 'CollAsgnRespType',
        abbrName: 'RespTyp',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.4',
        type: 'CollAsgnRespTypeCodeSet',
        updatedEP: '192',
        id: 905,
        description: 'Type of collateral assignment response.',
    },
    {
        name: 'CollAsgnRejectReason',
        abbrName: 'RejRsn',
        unionDataType: 'Reserved100Plus',
        added: 'FIX.4.4',
        type: 'CollAsgnRejectReasonCodeSet',
        id: 906,
        description: 'Collateral Assignment Reject Reason',
    },
    {
        name: 'CollAsgnRefID',
        abbrName: 'RefID',
        added: 'FIX.4.4',
        type: 'String',
        id: 907,
        description: 'Collateral Assignment Identifier to which a transaction refers',
    },
    {
        name: 'CollRptID',
        abbrName: 'RptID',
        added: 'FIX.4.4',
        type: 'String',
        id: 908,
        description: 'Collateral Report Identifier',
    },
    {
        name: 'CollInquiryID',
        abbrName: 'ID',
        added: 'FIX.4.4',
        type: 'String',
        id: 909,
        description: 'Collateral Inquiry Identifier',
    },
    {
        name: 'CollStatus',
        abbrName: 'Stat',
        added: 'FIX.4.4',
        type: 'CollStatusCodeSet',
        id: 910,
        description: 'Collateral Status',
    },
    {
        name: 'TotNumReports',
        abbrName: 'TotNumRpts',
        updated: 'FIX.5.0SP1',
        added: 'FIX.4.4',
        type: 'int',
        updatedEP: '95',
        id: 911,
        description: 'Total number of reports returned in response to a request.',
    },
    {
        name: 'LastRptRequested',
        abbrName: 'LastRptReqed',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.4',
        type: 'LastRptRequestedCodeSet',
        updatedEP: '141',
        id: 912,
        description:
            'Indicates whether this message is the last report message in response to a request message, e.g. OrderMassStatusRequest(35=AF), TradeCaptureReportRequest(35=AD).',
    },
    {
        name: 'AgreementDesc',
        abbrName: 'AgmtDesc',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.4',
        type: 'String',
        updatedEP: '254',
        id: 913,
        description:
            'The full name of the base standard agreement, annexes and amendments in place between the principals applicable to a financing transaction. See http://www.fpml.org/coding-scheme/master-agreement-type for derivative values.\n\nFor EU SFTR reporting use the appropriate 4-character code noted in the regulations. See SFTR ITS "Commission Implementing Regulation (EU) 2019/363" Annexes 1 to 2 for values. For other agreement type use OTHR and the name of the agreement concatenated with a hyphen, e.g. OTHR-<IndexName>.',
    },
    {
        name: 'AgreementID',
        abbrName: 'AgmtID',
        added: 'FIX.4.4',
        type: 'String',
        id: 914,
        description:
            'A common reference to the applicable standing agreement between the counterparties to a financing transaction.',
    },
    {
        name: 'AgreementDate',
        abbrName: 'AgmtDt',
        added: 'FIX.4.4',
        type: 'LocalMktDate',
        id: 915,
        description:
            'A reference to the date the underlying agreement specified by AgreementID and AgreementDesc was executed.',
    },
    {
        name: 'StartDate',
        abbrName: 'StartDt',
        added: 'FIX.4.4',
        type: 'LocalMktDate',
        id: 916,
        description:
            'Start date of a financing deal, i.e. the date the buyer pays the seller cash and takes control of the collateral',
    },
    {
        name: 'EndDate',
        abbrName: 'EndDt',
        added: 'FIX.4.4',
        type: 'LocalMktDate',
        id: 917,
        description:
            'End date of a financing deal, i.e. the date the seller reimburses the buyer and takes back control of the collateral',
    },
    {
        name: 'AgreementCurrency',
        abbrName: 'AgmtCcy',
        added: 'FIX.4.4',
        type: 'Currency',
        id: 918,
        description:
            'Contractual currency forming the basis of a financing agreement and associated transactions. Usually, but not always, the same as the trade currency.',
    },
    {
        name: 'DeliveryType',
        abbrName: 'DlvryTyp',
        added: 'FIX.4.4',
        type: 'DeliveryTypeCodeSet',
        id: 919,
        description: 'Identifies type of settlement',
    },
    {
        name: 'EndAccruedInterestAmt',
        abbrName: 'EndAcrdIntAmt',
        added: 'FIX.4.4',
        type: 'Amt',
        id: 920,
        description: 'Accrued Interest Amount applicable to a financing transaction on the End Date.',
    },
    {
        name: 'StartCash',
        abbrName: 'StartCsh',
        added: 'FIX.4.4',
        type: 'Amt',
        id: 921,
        description:
            'Starting dirty cash consideration of a financing deal, i.e. paid to the seller on the Start Date.',
    },
    {
        name: 'EndCash',
        abbrName: 'EndCsh',
        added: 'FIX.4.4',
        type: 'Amt',
        id: 922,
        description:
            'Ending dirty cash consideration of a financing deal. i.e. reimbursed to the buyer on the End Date.',
    },
    {
        name: 'UserRequestID',
        abbrName: 'UserReqID',
        added: 'FIX.4.4',
        type: 'String',
        id: 923,
        description: 'Unique identifier for a User Request.',
    },
    {
        name: 'UserRequestType',
        abbrName: 'UserReqTyp',
        added: 'FIX.4.4',
        type: 'UserRequestTypeCodeSet',
        id: 924,
        description: 'Indicates the action required by a User Request Message',
    },
    {
        name: 'NewPassword',
        abbrName: 'NewPassword',
        added: 'FIX.4.4',
        type: 'String',
        id: 925,
        description: 'New Password or passphrase',
    },
    {
        name: 'UserStatus',
        abbrName: 'UserStat',
        added: 'FIX.4.4',
        type: 'UserStatusCodeSet',
        id: 926,
        description: 'Indicates the status of a user',
    },
    {
        name: 'UserStatusText',
        abbrName: 'UserStatText',
        added: 'FIX.4.4',
        type: 'String',
        id: 927,
        description: 'A text description associated with a user status.',
    },
    {
        name: 'StatusValue',
        abbrName: 'StatValu',
        added: 'FIX.4.4',
        type: 'StatusValueCodeSet',
        id: 928,
        description: 'Indicates the status of a network connection',
    },
    {
        name: 'StatusText',
        abbrName: 'StatText',
        added: 'FIX.4.4',
        type: 'String',
        id: 929,
        description: 'A text description associated with a network status.',
    },
    {
        name: 'RefCompID',
        abbrName: 'RefCompID',
        added: 'FIX.4.4',
        type: 'String',
        id: 930,
        description: 'Assigned value used to identify a firm.',
    },
    {
        name: 'RefSubID',
        abbrName: 'RefSubID',
        added: 'FIX.4.4',
        type: 'String',
        id: 931,
        description: 'Assigned value used to identify specific elements within a firm.',
    },
    {
        name: 'NetworkResponseID',
        abbrName: 'NtwkRspID',
        added: 'FIX.4.4',
        type: 'String',
        id: 932,
        description: 'Unique identifier for a network response.',
    },
    {
        name: 'NetworkRequestID',
        abbrName: 'NtwkReqID',
        added: 'FIX.4.4',
        type: 'String',
        id: 933,
        description: 'Unique identifier for a network resquest.',
    },
    {
        name: 'LastNetworkResponseID',
        abbrName: 'LastNtwkRspID',
        added: 'FIX.4.4',
        type: 'String',
        id: 934,
        description:
            'Identifier of the previous Network Response message sent to a counterparty, used to allow incremental updates.',
    },
    {
        name: 'NetworkRequestType',
        abbrName: 'NtwkReqTyp',
        added: 'FIX.4.4',
        type: 'NetworkRequestTypeCodeSet',
        id: 935,
        description:
            "Indicates the type and level of details required for a Network Status Request Message\n\nBoolean logic applies EG If you want to subscribe for changes to certain id's then UserRequestType =0 (8+2), Snapshot for certain ID's = 9 (8+1)",
    },
    {
        name: 'NoCompIDs',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 936,
        description: 'Number of CompID entries in a repeating group.',
    },
    {
        name: 'NetworkStatusResponseType',
        abbrName: 'NtwkStatRspTyp',
        added: 'FIX.4.4',
        type: 'NetworkStatusResponseTypeCodeSet',
        id: 937,
        description: 'Indicates the type of Network Response Message.',
    },
    {
        name: 'NoCollInquiryQualifier',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 938,
        description: 'Number of CollInquiryQualifier entries in a repeating group.',
    },
    {
        name: 'TrdRptStatus',
        abbrName: 'TrdRptStat',
        added: 'FIX.4.4',
        type: 'TrdRptStatusCodeSet',
        id: 939,
        description: 'Trade Report Status',
    },
    {
        name: 'AffirmStatus',
        abbrName: 'AffirmStat',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.4',
        type: 'AffirmStatusCodeSet',
        updatedEP: '215',
        id: 940,
        description: 'Specifies the affirmation status of the confirmation.',
    },
    {
        name: 'UnderlyingStrikeCurrency',
        abbrName: 'StrkCcy',
        added: 'FIX.4.4',
        type: 'Currency',
        id: 941,
        description: 'Currency in which the strike price of an underlying instrument is denominated',
    },
    {
        name: 'LegStrikeCurrency',
        abbrName: 'StrkCcy',
        added: 'FIX.4.4',
        type: 'Currency',
        id: 942,
        description: 'Currency in which the strike price of a instrument leg of a multileg instrument is denominated',
    },
    {
        name: 'TimeBracket',
        abbrName: 'TmBkt',
        added: 'FIX.4.4',
        type: 'String',
        id: 943,
        description:
            'A code that represents a time interval in which a fill or trade occurred.\n\nRequired for US futures markets.',
    },
    {
        name: 'CollAction',
        abbrName: 'Actn',
        added: 'FIX.4.4',
        type: 'CollActionCodeSet',
        id: 944,
        description: 'Action proposed for an Underlying Instrument instance.',
    },
    {
        name: 'CollInquiryStatus',
        abbrName: 'Stat',
        added: 'FIX.4.4',
        type: 'CollInquiryStatusCodeSet',
        id: 945,
        description: 'Status of Collateral Inquiry',
    },
    {
        name: 'CollInquiryResult',
        abbrName: 'Rslt',
        unionDataType: 'Reserved100Plus',
        added: 'FIX.4.4',
        type: 'CollInquiryResultCodeSet',
        id: 946,
        description:
            'Result returned in response to Collateral Inquiry\n\n4000+ Reserved and available for bi-laterally agreed upon user-defined values',
    },
    {
        name: 'StrikeCurrency',
        abbrName: 'StrkCcy',
        added: 'FIX.4.4',
        type: 'Currency',
        id: 947,
        description: 'Currency in which the StrikePrice is denominated.',
    },
    {
        name: 'NoNested3PartyIDs',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 948,
        description: 'Number of Nested3PartyID (949), Nested3PartyIDSource (950), and Nested3PartyRole (95) entries',
    },
    {
        name: 'Nested3PartyID',
        abbrName: 'ID',
        added: 'FIX.4.4',
        type: 'String',
        id: 949,
        discriminatorId: '950',
        description: 'PartyID value within a "third instance" Nested repeating group.\n\nSame values as PartyID (448)',
    },
    {
        name: 'Nested3PartyIDSource',
        abbrName: 'Src',
        added: 'FIX.4.4',
        type: 'PartyIDSourceCodeSet',
        id: 950,
        description:
            'PartyIDSource value within a "third instance" Nested repeating group.\n\nSame values as PartyIDSource (447)',
    },
    {
        name: 'Nested3PartyRole',
        abbrName: 'R',
        added: 'FIX.4.4',
        type: 'PartyRoleCodeSet',
        id: 951,
        description:
            'PartyRole value within a "third instance" Nested repeating group.\n\nSame values as PartyRole (452)',
    },
    {
        name: 'NoNested3PartySubIDs',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 952,
        description: 'Number of Nested3PartySubIDs (953) entries',
    },
    {
        name: 'Nested3PartySubID',
        abbrName: 'ID',
        added: 'FIX.4.4',
        type: 'String',
        id: 953,
        description:
            'PartySubID value within a "third instance" Nested repeating group.\n\nSame values as PartySubID (523)',
    },
    {
        name: 'Nested3PartySubIDType',
        abbrName: 'Typ',
        unionDataType: 'Reserved4000Plus',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'PartySubIDTypeCodeSet',
        updatedEP: '294',
        id: 954,
        description:
            'PartySubIDType value within a "third instance" Nested repeating group.\n\nSame values as PartySubIDType (803)',
    },
    {
        name: 'LegContractSettlMonth',
        abbrName: 'CSetMo',
        added: 'FIX.4.4',
        type: 'MonthYear',
        id: 955,
        description: 'Specifies when the contract (i.e. MBS/TBA) will settle.',
    },
    {
        name: 'LegInterestAccrualDate',
        abbrName: 'IntAcrl',
        added: 'FIX.4.4',
        type: 'LocalMktDate',
        id: 956,
        description:
            'The start date used for calculating accrued interest on debt instruments which are being sold between interest payment dates. Often but not always the same as the Issue Date and the Dated Date',
    },
    {
        name: 'NoStrategyParameters',
        updated: 'FIX.Latest',
        addedEP: '2',
        added: 'FIX.4.4',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 957,
        description: 'Indicates number of strategy parameters',
    },
    {
        name: 'StrategyParameterName',
        abbrName: 'StrtPrmNme',
        addedEP: '2',
        added: 'FIX.4.4',
        type: 'String',
        id: 958,
        description: 'Name of parameter',
    },
    {
        name: 'StrategyParameterType',
        abbrName: 'StrtPrmTyp',
        addedEP: '2',
        added: 'FIX.4.4',
        type: 'StrategyParameterTypeCodeSet',
        id: 959,
        description: 'Datatype of the parameter',
    },
    {
        name: 'StrategyParameterValue',
        abbrName: 'StrtPrmVal',
        addedEP: '2',
        added: 'FIX.4.4',
        type: 'String',
        id: 960,
        description: 'Value of the parameter',
    },
    {
        name: 'HostCrossID',
        abbrName: 'HstCxID',
        addedEP: '3',
        added: 'FIX.4.4',
        type: 'String',
        id: 961,
        description:
            'Host assigned entity ID that can be used to reference all components of a cross; sides + strategy + legs. Used as the primary key with which to refer to the Cross Order for cancellation and replace. The HostCrossID will also be used to link together components of the Cross Order. For example, each individual Execution Report associated with the order will carry HostCrossID in order to tie back to the original cross order.',
    },
    {
        name: 'SideTimeInForce',
        abbrName: 'SideTmFrc',
        addedEP: '3',
        added: 'FIX.4.4',
        type: 'UTCTimestamp',
        id: 962,
        description:
            'Indicates how long the order as specified in the side stays in effect. SideTimeInForce allows a two-sided cross order to specify order behavior separately for each side. Absence of this field indicates that TimeInForce should be referenced. SideTimeInForce will override TimeInForce if both are provided.',
    },
    {
        name: 'MDReportID',
        abbrName: 'RptID',
        addedEP: '4',
        added: 'FIX.4.4',
        type: 'int',
        id: 963,
        description: 'Unique identifier for the Market Data Report.',
    },
    {
        name: 'SecurityReportID',
        abbrName: 'RptID',
        updated: 'FIX.5.0SP1',
        addedEP: '4',
        added: 'FIX.4.4',
        type: 'int',
        updatedEP: '87',
        id: 964,
        description: 'Identifies a Security List message.',
    },
    {
        name: 'SecurityStatus',
        abbrName: 'Status',
        updated: 'FIX.Latest',
        addedEP: '4',
        added: 'FIX.4.4',
        type: 'SecurityStatusCodeSet',
        updatedEP: '271',
        id: 965,
        description: 'Indicates the current state of the instrument.',
    },
    {
        name: 'SettleOnOpenFlag',
        abbrName: 'SettlOnOpenFlag',
        addedEP: '4',
        added: 'FIX.4.4',
        type: 'String',
        id: 966,
        description: 'Indicator to determine if instrument is settle on open',
    },
    {
        name: 'StrikeMultiplier',
        abbrName: 'StrkMult',
        addedEP: '4',
        added: 'FIX.4.4',
        type: 'float',
        id: 967,
        description:
            'Used for derivatives. Multiplier applied to the strike price for the purpose of calculating the settlement value.',
    },
    {
        name: 'StrikeValue',
        abbrName: 'StrkValu',
        addedEP: '4',
        added: 'FIX.4.4',
        type: 'float',
        id: 968,
        description:
            'Used for derivatives. The number of shares/units for the financial instrument involved in the option trade.',
    },
    {
        name: 'MinPriceIncrement',
        abbrName: 'MinPxIncr',
        addedEP: '4',
        added: 'FIX.4.4',
        type: 'float',
        id: 969,
        description: 'Minimum price increase for a given exchange-traded Instrument',
    },
    {
        name: 'PositionLimit',
        abbrName: 'PosLmt',
        addedEP: '4',
        added: 'FIX.4.4',
        type: 'int',
        id: 970,
        description: 'Position Limit for a given exchange-traded product.',
    },
    {
        name: 'NTPositionLimit',
        abbrName: 'NTPosLmt',
        addedEP: '4',
        added: 'FIX.4.4',
        type: 'int',
        id: 971,
        description: 'Position Limit in the near-term contract for a given exchange-traded product.',
    },
    {
        name: 'UnderlyingAllocationPercent',
        abbrName: 'AllocPct',
        addedEP: '4',
        added: 'FIX.4.4',
        type: 'Percentage',
        id: 972,
        description: 'Percent of the Strike Price that this underlying represents.',
    },
    {
        name: 'UnderlyingCashAmount',
        abbrName: 'CashAmt',
        addedEP: '4',
        added: 'FIX.4.4',
        type: 'Amt',
        id: 973,
        description: 'Cash amount associated with the underlying component.',
    },
    {
        name: 'UnderlyingCashType',
        abbrName: 'CashTyp',
        updated: 'FIX.5.0SP1',
        addedEP: '4',
        added: 'FIX.4.4',
        type: 'UnderlyingCashTypeCodeSet',
        updatedEP: '95',
        id: 974,
        description: 'Used for derivatives that deliver into cash underlying.',
    },
    {
        name: 'UnderlyingSettlementType',
        abbrName: 'SettlTyp',
        addedEP: '4',
        added: 'FIX.4.4',
        type: 'UnderlyingSettlementTypeCodeSet',
        id: 975,
        description: 'Indicates order settlement period for the underlying instrument.',
    },
    {
        name: 'QuantityDate',
        abbrName: 'QtyDt',
        addedEP: '4',
        added: 'FIX.4.4',
        type: 'LocalMktDate',
        id: 976,
        description: 'Date associated to the quantity that is being reported for the position.',
    },
    {
        name: 'ContIntRptID',
        abbrName: 'RptID',
        addedEP: '4',
        added: 'FIX.4.4',
        type: 'String',
        id: 977,
        description: 'Unique identifier for the Contrary Intention report',
    },
    {
        name: 'LateIndicator',
        abbrName: 'LateInd',
        addedEP: '4',
        added: 'FIX.4.4',
        type: 'Boolean',
        id: 978,
        description: 'Indicates if the contrary intention was received after the exchange imposed cutoff time',
    },
    {
        name: 'InputSource',
        abbrName: 'InptSrc',
        updated: 'FIX.5.0SP2',
        addedEP: '4',
        added: 'FIX.4.4',
        type: 'String',
        updatedEP: '148',
        id: 979,
        description: 'Originating source of the request.',
    },
    {
        name: 'SecurityUpdateAction',
        abbrName: 'UpdActn',
        updated: 'FIX.Latest',
        addedEP: '4',
        added: 'FIX.4.4',
        type: 'SecurityUpdateActionCodeSet',
        updatedEP: '275',
        id: 980,
        description: 'Specifies the action taken or to be taken for the specified instrument or list of instruments.',
    },
    {
        name: 'NoExpiration',
        updated: 'FIX.Latest',
        addedEP: '4',
        added: 'FIX.4.4',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 981,
        description: 'Number of Expiration Qty entries',
    },
    {
        name: 'ExpirationQtyType',
        abbrName: 'ExpTyp',
        addedEP: '4',
        added: 'FIX.4.4',
        type: 'ExpirationQtyTypeCodeSet',
        id: 982,
        description: 'Expiration Quantity type',
    },
    {
        name: 'ExpQty',
        abbrName: 'ExpQty',
        addedEP: '4',
        added: 'FIX.4.4',
        type: 'Qty',
        id: 983,
        description: 'Expiration Quantity associated with the Expiration Type',
    },
    {
        name: 'NoUnderlyingAmounts',
        updated: 'FIX.Latest',
        addedEP: '4',
        added: 'FIX.4.4',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 984,
        description: 'Total number of occurrences of Amount to pay in order to receive the underlying instrument',
    },
    {
        name: 'UnderlyingPayAmount',
        abbrName: 'PayAmt',
        addedEP: '4',
        added: 'FIX.4.4',
        type: 'Amt',
        id: 985,
        description: 'Amount to pay in order to receive the underlying instrument',
    },
    {
        name: 'UnderlyingCollectAmount',
        abbrName: 'ColAmt',
        addedEP: '4',
        added: 'FIX.4.4',
        type: 'Amt',
        id: 986,
        description: 'Amount to collect in order to deliver the underlying instrument',
    },
    {
        name: 'UnderlyingSettlementDate',
        abbrName: 'StlDt',
        addedEP: '4',
        added: 'FIX.4.4',
        type: 'LocalMktDate',
        id: 987,
        description:
            'Date the underlying instrument will settle. Used for derivatives that deliver into more than one underlying instrument. Settlement dates can vary across underlying instruments.',
    },
    {
        name: 'UnderlyingSettlementStatus',
        abbrName: 'SetStat',
        addedEP: '4',
        added: 'FIX.4.4',
        type: 'String',
        id: 988,
        description:
            'Settlement status of the underlying instrument. Used for derivatives that deliver into more than one underlying instrument. Settlement can be delayed for an underlying instrument.',
    },
    {
        name: 'SecondaryIndividualAllocID',
        abbrName: 'IndAllocID2',
        addedEP: '5',
        added: 'FIX.4.4',
        type: 'String',
        id: 989,
        description: 'Will allow the intermediary to specify an allocation ID generated by their system.',
    },
    {
        name: 'LegReportID',
        abbrName: 'RptID',
        addedEP: '5',
        added: 'FIX.4.4',
        type: 'String',
        id: 990,
        description: 'Additional attribute to store the Trade ID of the Leg.',
    },
    {
        name: 'RndPx',
        abbrName: 'RndPx',
        addedEP: '5',
        added: 'FIX.4.4',
        type: 'Price',
        id: 991,
        description: 'Specifies average price rounded to quoted precision.',
    },
    {
        name: 'IndividualAllocType',
        abbrName: 'Typ',
        addedEP: '5',
        added: 'FIX.4.4',
        type: 'IndividualAllocTypeCodeSet',
        id: 992,
        description: 'Identifies whether the allocation is to be sub-allocated or allocated to a third party',
    },
    {
        name: 'AllocCustomerCapacity',
        abbrName: 'CustCpcty',
        addedEP: '5',
        added: 'FIX.4.4',
        type: 'String',
        id: 993,
        description: 'Capacity of customer in the allocation block.',
    },
    {
        name: 'TierCode',
        abbrName: 'TierCD',
        addedEP: '5',
        added: 'FIX.4.4',
        type: 'String',
        id: 994,
        description: 'The Tier the trade was matched by the clearing system.',
    },
    {
        name: 'UnitOfMeasure',
        abbrName: 'UOM',
        updated: 'FIX.5.0SP2',
        addedEP: '5',
        added: 'FIX.4.4',
        type: 'UnitOfMeasureCodeSet',
        updatedEP: '122',
        id: 996,
        description:
            "The unit of measure of the underlying commodity upon which the contract is based. Two groups of units of measure enumerations are supported.\n\nFixed Magnitude UOMs are primarily used in energy derivatives and specify a magnitude (such as, MM, Kilo, M, etc.) and the dimension (such as, watt hours, BTU's) to produce standard fixed measures (such as MWh - Megawatt-hours, MMBtu - One million BTUs).\n\nThe second group, Variable Quantity UOMs, specifies the dimension as a single unit without a magnitude (or more accurately a magnitude of one) and uses the UnitOfMeasureQty(1147) field to define the quantity of units per contract. Variable Quantity UOMs are used for both commodities (such as lbs of lean cattle, bushels of corn, ounces of gold) and financial futures.\n\nExamples:\n\nFor lean cattle futures contracts, a UnitOfMeasure of 'lbs' with a UnitOfMeasureQty(1147) of 40,000, means each lean cattle futures contract represents 40,000 lbs of lean cattle.\n\nFor Eurodollars futures contracts, a UnitOfMeasure of Ccy with a UnitOfMeasureCurrency(1716) of USD and a UnitOfMeasureQty(1147) of 1,000,000, means a Eurodollar futures contract represents 1,000,000 USD.\n\nFor gold futures contracts, a UnitOfMeasure is oz_tr (Troy ounce) with a UnitOfMeasureQty(1147) of 1,000, means each gold futures contract represents 1,000 troy ounces of gold.",
    },
    {
        name: 'TimeUnit',
        abbrName: 'TmUnit',
        updated: 'FIX.Latest',
        addedEP: '5',
        added: 'FIX.4.4',
        type: 'TimeUnitCodeSet',
        updatedEP: '287',
        id: 997,
        description:
            'Unit of time associated with the contract.\n\nNOTE: Additional values may be used by mutual agreement of the counterparties.',
    },
    {
        name: 'UnderlyingUnitOfMeasure',
        abbrName: 'UOM',
        updated: 'FIX.Latest',
        addedEP: '5',
        added: 'FIX.4.4',
        type: 'UnitOfMeasureCodeSet',
        updatedEP: '271',
        id: 998,
        description: 'Underlying unit of measure.\n\nSee UnitOfMeasure(996) for complete definition.',
    },
    {
        name: 'LegUnitOfMeasure',
        abbrName: 'UOM',
        updated: 'FIX.Latest',
        addedEP: '5',
        added: 'FIX.4.4',
        type: 'UnitOfMeasureCodeSet',
        updatedEP: '271',
        id: 999,
        description: 'Multileg instrument unit of measure.\n\nSee UnitOfMeasure(996) for complete definition.',
    },
    {
        name: 'UnderlyingTimeUnit',
        abbrName: 'TmUnit',
        updated: 'FIX.Latest',
        addedEP: '5',
        added: 'FIX.4.4',
        type: 'TimeUnitCodeSet',
        updatedEP: '287',
        id: 1000,
        description: 'See TimeUnit(997) for complete definition.',
    },
    {
        name: 'LegTimeUnit',
        abbrName: 'TmUnit',
        updated: 'FIX.Latest',
        addedEP: '5',
        added: 'FIX.4.4',
        type: 'TimeUnitCodeSet',
        updatedEP: '287',
        id: 1001,
        description: 'See TimeUnit(997) for complete definition.',
    },
    {
        name: 'AllocMethod',
        abbrName: 'Meth',
        addedEP: '5',
        added: 'FIX.4.4',
        type: 'AllocMethodCodeSet',
        id: 1002,
        description: 'Specifies the method under which a trade quantity was allocated.',
    },
    {
        name: 'TradeID',
        abbrName: 'TrdID',
        addedEP: '11',
        added: 'FIX.4.4',
        type: 'String',
        id: 1003,
        description:
            'The unique ID assigned to the trade entity once it is received or matched by the exchange or central counterparty.',
    },
    {
        name: 'SideTradeReportID',
        abbrName: 'RptID',
        addedEP: '5',
        added: 'FIX.4.4',
        type: 'String',
        id: 1005,
        description: 'Used on a multi-sided trade to designate the ReportID',
    },
    {
        name: 'SideFillStationCd',
        abbrName: 'FillStationCd',
        addedEP: '5',
        added: 'FIX.4.4',
        type: 'String',
        id: 1006,
        description: 'Used on a multi-sided trade to convey order routing information',
    },
    {
        name: 'SideReasonCd',
        abbrName: 'RsnCD',
        addedEP: '5',
        added: 'FIX.4.4',
        type: 'String',
        id: 1007,
        description: 'Used on a multi-sided trade to convey reason for execution',
    },
    {
        name: 'SideTrdSubType',
        abbrName: 'TrdSubTyp',
        updated: 'FIX.Latest',
        addedEP: '5',
        added: 'FIX.4.4',
        type: 'TrdSubTypeCodeSet',
        updatedEP: '271',
        id: 1008,
        description:
            'Used on a multi-sided trade to specify the type of trade for a given side. Same values as TrdSubType (829).',
    },
    {
        name: 'SideLastQty',
        abbrName: 'SideQty',
        updated: 'FIX.5.0SP2',
        addedEP: '5',
        added: 'FIX.4.4',
        type: 'Qty',
        updatedEP: '161',
        id: 1009,
        description: 'Used to indicate the quantity on one side of a multi-sided trade.',
    },
    {
        name: 'MessageEventSource',
        abbrName: 'MsgEvtSrc',
        addedEP: '5',
        added: 'FIX.4.4',
        type: 'String',
        id: 1011,
        description:
            'Used to identify the event or source which gave rise to a message.\n\nValid values will be based on an exchange\'s implementation.\n\nExample values are:\n\n"MQM" (originated at Firm Back Office)\n\n"Clear" (originated in Clearing System)\n\n"Reg" (static data generated via Register request)',
    },
    {
        name: 'SideTrdRegTimestamp',
        abbrName: 'TS',
        updated: 'FIX.Latest',
        addedEP: '5',
        added: 'FIX.4.4',
        type: 'UTCTimestamp',
        updatedEP: '291',
        id: 1012,
        description:
            'Same as TrdRegTimestamp(769). Used in a multi-sided message to indicate relevant trade-side timestamp.',
    },
    {
        name: 'SideTrdRegTimestampType',
        abbrName: 'Typ',
        updated: 'FIX.Latest',
        addedEP: '5',
        added: 'FIX.4.4',
        type: 'TrdRegTimestampTypeCodeSet',
        updatedEP: '291',
        id: 1013,
        description:
            'Same as TrdRegTimeStampType(770). Used in a multi-sided message to indicate relevant trade-side timestamp type.',
    },
    {
        name: 'SideTrdRegTimestampSrc',
        abbrName: 'Src',
        updated: 'FIX.Latest',
        addedEP: '5',
        added: 'FIX.4.4',
        type: 'String',
        updatedEP: '291',
        id: 1014,
        description:
            'Same as TrdRegTimestampOrigin(771). Used in a multi-sided message to indicate relevant trade-side origin or source of timestamp.',
    },
    {
        name: 'AsOfIndicator',
        abbrName: 'AsOfInd',
        updated: 'FIX.5.0SP2',
        addedEP: '5',
        added: 'FIX.4.4',
        type: 'AsOfIndicatorCodeSet',
        updatedEP: '141',
        id: 1015,
        description:
            'A trade that is being submitted for a trade date prior to the current trade or clearing date, e.g. in an open outcry market an out trade being submitted for the previous trading session or trading day.',
    },
    {
        name: 'NoSideTrdRegTS',
        updated: 'FIX.Latest',
        addedEP: '5',
        added: 'FIX.4.4',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 1016,
        description: 'Number of timestamp entries.',
    },
    {
        name: 'LegOptionRatio',
        abbrName: 'LegOptionRatio',
        addedEP: '18',
        added: 'FIX.4.4',
        type: 'float',
        id: 1017,
        description:
            'Expresses the risk of an option leg\n\nValue must be between -1 and 1.\n\nA Call Option will require a ratio value between 0 and 1\n\nA Put Option will require a ratio value between -1 and 0',
    },
    {
        name: 'NoInstrumentParties',
        updated: 'FIX.Latest',
        addedEP: '4',
        added: 'FIX.4.4',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 1018,
        description: 'Identifies the number of parties identified with an instrument',
    },
    {
        name: 'InstrumentPartyID',
        abbrName: 'ID',
        addedEP: '4',
        added: 'FIX.4.4',
        type: 'String',
        id: 1019,
        discriminatorId: '1050',
        description: 'PartyID value within an instrument party repeating group. Same values as PartyID (448)',
    },
    {
        name: 'TradeVolume',
        abbrName: 'TrdVol',
        addedEP: '7',
        added: 'FIX.4.4',
        type: 'Qty',
        id: 1020,
        description: 'Used to report volume with a trade',
    },
    {
        name: 'MDBookType',
        abbrName: 'MDBkTyp',
        addedEP: '7',
        added: 'FIX.4.4',
        type: 'MDBookTypeCodeSet',
        id: 1021,
        description:
            'Describes the type of book for which the feed is intended. Used when multiple feeds are provided over the same connection',
    },
    {
        name: 'MDFeedType',
        abbrName: 'MDFeedTyp',
        addedEP: '7',
        added: 'FIX.4.4',
        type: 'String',
        id: 1022,
        description:
            'Describes a class of service for a given data feed, ie Regular and Market Maker, Bandwidth Intensive or Bandwidth Conservative',
    },
    {
        name: 'MDPriceLevel',
        abbrName: 'MDPxLvl',
        updated: 'FIX.Latest',
        addedEP: '7',
        added: 'FIX.4.4',
        type: 'int',
        updatedEP: '271',
        id: 1023,
        description:
            'Integer to convey the level of a bid or offer at a given price level. This is in contrast to MDEntryPositionNo(290) which is used to convey the position of an order within a price level.',
    },
    {
        name: 'MDOriginType',
        abbrName: 'MDOrigTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '7',
        added: 'FIX.4.4',
        type: 'MDOriginTypeCodeSet',
        updatedEP: '216',
        id: 1024,
        description: 'Used to describe the origin of the market data entry.',
    },
    {
        name: 'FirstPx',
        abbrName: 'FirstPx',
        addedEP: '7',
        added: 'FIX.4.4',
        type: 'Price',
        id: 1025,
        description: 'Indicates the first trade price of the day/session',
    },
    {
        name: 'MDEntrySpotRate',
        abbrName: 'MDEntrySpotRt',
        addedEP: '7',
        added: 'FIX.4.4',
        type: 'float',
        id: 1026,
        description: 'The spot rate for an FX entry',
    },
    {
        name: 'MDEntryForwardPoints',
        abbrName: 'MDEntryFwdPnts',
        addedEP: '7',
        added: 'FIX.4.4',
        type: 'PriceOffset',
        id: 1027,
        description:
            'Used for an F/X entry. The forward points to be added to or subtracted from the spot rate to get the "all-in" rate in MDEntryPx. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199',
    },
    {
        name: 'ManualOrderIndicator',
        abbrName: 'ManOrdInd',
        updated: 'FIX.Latest',
        addedEP: '9',
        added: 'FIX.4.4',
        type: 'Boolean',
        updatedEP: '264',
        id: 1028,
        description:
            'Indicates if an order, quote or trade was initially received manually (as opposed to electronically) or if it was entered manually (as opposed to entered by automated trading software).',
    },
    {
        name: 'CustDirectedOrder',
        abbrName: 'CustDrctdOrd',
        updated: 'FIX.5.0SP1',
        addedEP: '9',
        added: 'FIX.4.4',
        type: 'Boolean',
        updatedEP: '95',
        id: 1029,
        description:
            'Indicates if the customer directed this order to a specific execution venue "Y" or not "N".\n\nA default of "N" customer did not direct this order should be used in the case where the information is both missing and essential.',
    },
    {
        deprecatedEP: '135',
        name: 'ReceivedDeptID',
        abbrName: 'RcvdDptID',
        updated: 'FIX.5.0SP2',
        addedEP: '9',
        added: 'FIX.4.4',
        type: 'String',
        updatedEP: '135',
        deprecated: 'FIX.5.0SP2',
        id: 1030,
        description: 'Identifies the broker-dealer department that first took the order.',
    },
    {
        name: 'CustOrderHandlingInst',
        abbrName: 'CustOrdHdlInst',
        updated: 'FIX.5.0SP2',
        addedEP: '9',
        added: 'FIX.4.4',
        type: 'CustOrderHandlingInstCodeSet',
        updatedEP: '135',
        id: 1031,
        description:
            'Codes that apply special information that the Broker / Dealer needs to report, as specified by the customer.\n\nNOTE: This field and its values have no bearing on the ExecInst and TimeInForce fields. These values should not be used instead of ExecInst or TimeInForce. This field and its values are intended for compliance reporting and/or billing purposes only.\n\nFor OrderHandlingInstSrc(1032) = 1 (FINRA OATS), valid values are (as of OATS Phase 3 as provided by FINRA. See also http://www.finra.org/Industry/Compliance/MarketTransparency/OATS/PhaseIII/index.htm for a complete list.\n\nFor OrderHandlingInstSrc(1032) = 2 (FIA Execution Source Code), only one enumeration value may be specified.',
    },
    {
        name: 'OrderHandlingInstSource',
        abbrName: 'OrdHndlInstSrc',
        updated: 'FIX.5.0SP2',
        addedEP: '9',
        added: 'FIX.4.4',
        type: 'OrderHandlingInstSourceCodeSet',
        updatedEP: '135',
        id: 1032,
        description:
            'Identifies the class or source of the order handling instruction values.  Scope of this will apply to both CustOrderHandlingInst(1031) and DeskOrderHandlingInst(1035).\n\nConditionally required when CustOrderHandlingInst(1031) or DeskOrderHandlingInst(1035) is specified.',
    },
    {
        name: 'DeskType',
        abbrName: 'DskTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '9',
        added: 'FIX.4.4',
        type: 'DeskTypeCodeSet',
        updatedEP: '135',
        id: 1033,
        discriminatorId: '1034',
        description:
            'Identifies the type of Trading Desk.\n\nConditionally required when InformationBarrierID(1727) is specified for OATS.',
    },
    {
        name: 'DeskTypeSource',
        abbrName: 'DskTypSrc',
        updated: 'FIX.5.0SP2',
        addedEP: '9',
        added: 'FIX.4.4',
        type: 'DeskTypeSourceCodeSet',
        updatedEP: '135',
        id: 1034,
        description:
            'Identifies the class or source of DeskType(1033) values. Conditionally required when DeskType(1033) is specified.',
    },
    {
        name: 'DeskOrderHandlingInst',
        abbrName: 'DskOrdHndlInst',
        updated: 'FIX.5.0SP2',
        addedEP: '9',
        added: 'FIX.4.4',
        type: 'CustOrderHandlingInstCodeSet',
        updatedEP: '135',
        id: 1035,
        description: 'Codes that apply special information that the broker-dealer needs to report.',
    },
    {
        name: 'ExecAckStatus',
        abbrName: 'ExecAckStat',
        addedEP: '10',
        added: 'FIX.4.4',
        type: 'ExecAckStatusCodeSet',
        id: 1036,
        description: 'The status of this execution acknowledgement message.',
    },
    {
        name: 'UnderlyingDeliveryAmount',
        abbrName: 'UndlyDlvAmt',
        addedEP: '8',
        added: 'FIX.4.4',
        type: 'Amt',
        id: 1037,
        description: 'Indicates the underlying position amount to be delivered',
    },
    {
        name: 'UnderlyingCapValue',
        abbrName: 'CapValu',
        addedEP: '8',
        added: 'FIX.4.4',
        type: 'Amt',
        id: 1038,
        description: 'Maximum notional value for a capped financial instrument',
    },
    {
        name: 'UnderlyingSettlMethod',
        abbrName: 'SetMeth',
        updated: 'FIX.5.0SP2',
        addedEP: '8',
        added: 'FIX.4.4',
        type: 'SettlMethodCodeSet',
        updatedEP: '169',
        id: 1039,
        description:
            'Settlement method for a contract or instrument. Additional values may be used with bilateral agreement.',
    },
    {
        name: 'SecondaryTradeID',
        abbrName: 'TrdID2',
        addedEP: '11',
        added: 'FIX.4.4',
        type: 'String',
        id: 1040,
        description: 'Used to carry an internal trade entity ID which may or may not be reported to the firm',
    },
    {
        name: 'FirmTradeID',
        abbrName: 'FirmTrdID',
        addedEP: '11',
        added: 'FIX.4.4',
        type: 'String',
        id: 1041,
        description:
            'The ID assigned to a trade by the Firm to track a trade within the Firm system. This ID can be assigned either before or after submission to the exchange or central counterpary',
    },
    {
        name: 'SecondaryFirmTradeID',
        abbrName: 'FirmTrdID2',
        addedEP: '11',
        added: 'FIX.4.4',
        type: 'String',
        id: 1042,
        description:
            'Used to carry an internal firm assigned ID which may or may not be reported to the exchange or central counterpary',
    },
    {
        name: 'CollApplType',
        abbrName: 'ApplTyp',
        addedEP: '12',
        added: 'FIX.4.4',
        type: 'CollApplTypeCodeSet',
        id: 1043,
        description: 'conveys how the collateral should be/has been applied',
    },
    {
        name: 'UnderlyingAdjustedQuantity',
        abbrName: 'AdjQty',
        addedEP: '12',
        added: 'FIX.4.4',
        type: 'Qty',
        id: 1044,
        description:
            'Unit amount of the underlying security (shares) adjusted for pending corporate action not yet allocated.',
    },
    {
        name: 'UnderlyingFXRate',
        abbrName: 'FxRate',
        addedEP: '12',
        added: 'FIX.4.4',
        type: 'float',
        id: 1045,
        description:
            'Foreign exchange rate used to compute UnderlyingCurrentValue(885) (or market value) from UnderlyingCurrency(318) to Currency(15).',
    },
    {
        name: 'UnderlyingFXRateCalc',
        abbrName: 'FxRateCalc',
        addedEP: '12',
        added: 'FIX.4.4',
        type: 'UnderlyingFXRateCalcCodeSet',
        id: 1046,
        description: 'Specifies whether the UnderlyingFxRate(1045) should be multiplied or divided.',
    },
    {
        name: 'AllocPositionEffect',
        abbrName: 'AllocPosEfct',
        addedEP: '17',
        added: 'FIX.4.4',
        type: 'AllocPositionEffectCodeSet',
        id: 1047,
        description:
            'Indicates whether the resulting position after a trade should be an opening position or closing position. Used for omnibus accounting - where accounts are held on a gross basis instead of being netted together.',
    },
    {
        name: 'DealingCapacity',
        abbrName: 'DealingCpcty',
        updated: 'FIX.5.0SP1',
        addedEP: '7',
        added: 'FIX.4.4',
        type: 'DealingCapacityCodeSet',
        updatedEP: '95',
        id: 1048,
        description: 'Identifies role of dealer; Agent, Principal, RisklessPrincipal',
    },
    {
        name: 'InstrmtAssignmentMethod',
        abbrName: 'AsgnMeth',
        addedEP: '4',
        added: 'FIX.4.4',
        type: 'InstrmtAssignmentMethodCodeSet',
        id: 1049,
        description: 'Method under which assignment was conducted',
    },
    {
        name: 'InstrumentPartyIDSource',
        abbrName: 'Src',
        addedEP: '4',
        added: 'FIX.4.4',
        type: 'PartyIDSourceCodeSet',
        id: 1050,
        description:
            'PartyIDSource value within an instrument partyrepeating group.\n\nSame values as PartyIDSource (447)',
    },
    {
        name: 'InstrumentPartyRole',
        abbrName: 'R',
        addedEP: '4',
        added: 'FIX.4.4',
        type: 'PartyRoleCodeSet',
        id: 1051,
        description: 'PartyRole value within an instrument partyepeating group.\n\nSame values as PartyRole (452)',
    },
    {
        name: 'NoInstrumentPartySubIDs',
        updated: 'FIX.Latest',
        addedEP: '4',
        added: 'FIX.4.4',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 1052,
        description: 'Number of InstrumentPartySubID (1053) and InstrumentPartySubIDType (1054) entries',
    },
    {
        name: 'InstrumentPartySubID',
        abbrName: 'ID',
        addedEP: '4',
        added: 'FIX.4.4',
        type: 'String',
        id: 1053,
        description: 'PartySubID value within an instrument party repeating group.\n\nSame values as PartySubID (523)',
    },
    {
        name: 'InstrumentPartySubIDType',
        abbrName: 'Typ',
        unionDataType: 'Reserved4000Plus',
        updated: 'FIX.Latest',
        addedEP: '4',
        added: 'FIX.4.4',
        type: 'PartySubIDTypeCodeSet',
        updatedEP: '294',
        id: 1054,
        description: 'Type of InstrumentPartySubID (1053) value.\n\nSame values as PartySubIDType (803)',
    },
    {
        name: 'PositionCurrency',
        abbrName: 'Ccy',
        addedEP: '8',
        added: 'FIX.4.4',
        type: 'String',
        id: 1055,
        description: 'The Currency in which the position Amount is denominated',
    },
    {
        name: 'CalculatedCcyLastQty',
        abbrName: 'CalcCcyLastQty',
        addedEP: '21',
        added: 'FIX.4.4',
        type: 'Qty',
        id: 1056,
        description:
            'Used for the calculated quantity of the other side of the currency trade. Can be derived from LastQty and LastPx.',
    },
    {
        name: 'AggressorIndicator',
        abbrName: 'AgrsrInd',
        addedEP: '21',
        added: 'FIX.4.4',
        type: 'AggressorIndicatorCodeSet',
        id: 1057,
        description: 'Used to identify whether the order initiator is an aggressor or not in the trade.',
    },
    {
        name: 'NoUndlyInstrumentParties',
        updated: 'FIX.Latest',
        addedEP: '8',
        added: 'FIX.4.4',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 1058,
        description: 'Identifies the number of parties identified with an underlying instrument',
    },
    {
        name: 'UnderlyingInstrumentPartyID',
        abbrName: 'ID',
        updated: 'FIX.5.0SP1',
        addedEP: '8',
        added: 'FIX.4.4',
        type: 'String',
        updatedEP: '95',
        id: 1059,
        discriminatorId: '1060',
        description:
            'PartyID value within an underlying instrument party repeating group.\n\nSame values as PartyID (448)',
    },
    {
        name: 'UnderlyingInstrumentPartyIDSource',
        abbrName: 'Src',
        updated: 'FIX.5.0SP1',
        addedEP: '8',
        added: 'FIX.4.4',
        type: 'PartyIDSourceCodeSet',
        updatedEP: '95',
        id: 1060,
        description:
            'PartyIDSource value within an underlying instrument partyrepeating group.\n\nSame values as PartyIDSource (447)',
    },
    {
        name: 'UnderlyingInstrumentPartyRole',
        abbrName: 'R',
        updated: 'FIX.5.0SP1',
        addedEP: '8',
        added: 'FIX.4.4',
        type: 'PartyRoleCodeSet',
        updatedEP: '95',
        id: 1061,
        description:
            'PartyRole value within an underlying instrument partyepeating group.\n\nSame values as PartyRole (452)',
    },
    {
        name: 'NoUndlyInstrumentPartySubIDs',
        updated: 'FIX.Latest',
        addedEP: '8',
        added: 'FIX.4.4',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 1062,
        description: 'Number of Underlying InstrumentPartySubID (1053) and InstrumentPartySubIDType (1054) entries',
    },
    {
        name: 'UnderlyingInstrumentPartySubID',
        abbrName: 'ID',
        updated: 'FIX.5.0SP1',
        addedEP: '8',
        added: 'FIX.4.4',
        type: 'String',
        updatedEP: '95',
        id: 1063,
        description:
            'PartySubID value within an underlying instrument party repeating group.\n\nSame values as PartySubID (523)',
    },
    {
        name: 'UnderlyingInstrumentPartySubIDType',
        abbrName: 'Typ',
        unionDataType: 'Reserved4000Plus',
        updated: 'FIX.Latest',
        addedEP: '8',
        added: 'FIX.4.4',
        type: 'PartySubIDTypeCodeSet',
        updatedEP: '294',
        id: 1064,
        description: 'Type of underlying InstrumentPartySubID (1053) value.\n\nSame values as PartySubIDType (803)',
    },
    {
        name: 'BidSwapPoints',
        abbrName: 'BidSwapPnts',
        addedEP: '21',
        added: 'FIX.4.4',
        type: 'PriceOffset',
        id: 1065,
        description:
            'The bid FX Swap points for an FX Swap. It is the "far bid forward points - near offer forward point". Value can be negative. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199',
    },
    {
        name: 'OfferSwapPoints',
        abbrName: 'OfrSwapPnts',
        addedEP: '21',
        added: 'FIX.4.4',
        type: 'PriceOffset',
        id: 1066,
        description:
            'The offer FX Swap points for an FX Swap. It is the "far offer forward points - near bid forward points". Value can be negative. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199',
    },
    {
        name: 'LegBidForwardPoints',
        abbrName: 'LegBidFwdPnts',
        addedEP: '21',
        added: 'FIX.4.4',
        type: 'PriceOffset',
        id: 1067,
        description:
            'The bid FX forward points for the leg of an FX Swap. Value can be negative. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199',
    },
    {
        name: 'LegOfferForwardPoints',
        abbrName: 'LegOfrFwdPnts',
        addedEP: '21',
        added: 'FIX.4.4',
        type: 'PriceOffset',
        id: 1068,
        description:
            'The offer FX forward points for the leg of an FX Swap. Value can be negative. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199',
    },
    {
        name: 'SwapPoints',
        abbrName: 'SwapPnts',
        addedEP: '21',
        added: 'FIX.4.4',
        type: 'PriceOffset',
        id: 1069,
        description:
            "For FX Swap, this is used to express the differential between the far leg's bid/offer and the near leg's bid/offer. Value can be negative. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199",
    },
    {
        name: 'MDQuoteType',
        abbrName: 'MDQteTyp',
        updated: 'FIX.Latest',
        addedEP: '7',
        added: 'FIX.4.4',
        type: 'QuoteTypeCodeSet',
        updatedEP: '294',
        id: 1070,
        description: 'Identifies market data quote type.',
    },
    {
        name: 'LastSwapPoints',
        abbrName: 'LastSwapPnts',
        addedEP: '21',
        added: 'FIX.4.4',
        type: 'PriceOffset',
        id: 1071,
        description:
            "For FX Swap, this is used to express the last market event for the differential between the far leg's bid/offer and the near leg's bid/offer in a fill or partial fill. Value can be negative. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199",
    },
    {
        name: 'SideGrossTradeAmt',
        abbrName: 'SideGrossTradeAmt',
        addedEP: '25',
        added: 'FIX.4.4',
        type: 'Amt',
        id: 1072,
        description:
            'The gross trade amount for this side of the trade. See also GrossTradeAmt (381) for additional definition.',
    },
    {
        name: 'LegLastForwardPoints',
        abbrName: 'LegLastFwdPnts',
        addedEP: '21',
        added: 'FIX.4.4',
        type: 'PriceOffset',
        id: 1073,
        description:
            "The forward points for this leg's fill event. Value can be negative. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199",
    },
    {
        name: 'LegCalculatedCcyLastQty',
        abbrName: 'LegCalcCcyLastQty',
        addedEP: '21',
        added: 'FIX.4.4',
        type: 'Qty',
        id: 1074,
        description:
            'Used for the calculated quantity of the other side of the currency for this leg. Can be derived from LegQty and LegLastPx.',
    },
    {
        name: 'LegGrossTradeAmt',
        abbrName: 'LegGrossTrdAmt',
        addedEP: '21',
        added: 'FIX.4.4',
        type: 'Amt',
        id: 1075,
        description:
            'The gross trade amount of the leg. For FX Futures this is used to express the notional value of a fill when LegLastQty and other quantity fields are express in terms of contract size.',
    },
    {
        name: 'MaturityTime',
        abbrName: 'MatTm',
        addedEP: '21',
        added: 'FIX.4.4',
        type: 'TZTimeOnly',
        id: 1079,
        description: "Time of security's maturity expressed in local time with offset to UTC specified",
    },
    {
        name: 'RefOrderID',
        abbrName: 'RefOrdID',
        updated: 'FIX.5.0SP2',
        addedEP: '22',
        added: 'FIX.4.4',
        type: 'String',
        updatedEP: '171',
        id: 1080,
        discriminatorId: '1081',
        description:
            'The ID reference to the order being hit or taken.\n\nFor pre-trade credit/risk limit check process, this is the reference to the placed order, quote request or quote for the credit/risk limit check.',
    },
    {
        name: 'RefOrderIDSource',
        abbrName: 'RefOrdIDSrc',
        updated: 'FIX.5.0SP2',
        addedEP: '22',
        added: 'FIX.4.4',
        type: 'RefOrderIDSourceCodeSet',
        updatedEP: '253',
        id: 1081,
        description:
            'Used to specify the source for the identifier in RefOrderID(1080). This can be an identifier provided in order depth market data when hitting (taking) a specific order or to identify what type of order or quote reference is being provided when seeking credit limit check. In the context of US CAT this can be used to identify related orders and quotes which are parent, previous, or manual orders or quotes. Previous relates to orders changing their unique system assigned order identifier.',
    },
    {
        name: 'SecondaryDisplayQty',
        abbrName: 'SecDspQty',
        addedEP: '22',
        added: 'FIX.4.4',
        type: 'Qty',
        id: 1082,
        description:
            'Used for reserve orders when DisplayQty applies to the primary execution market (e.g.an ECN) and another quantity is to be shown at other markets (e.g. the exchange). On orders specifies the qty to be displayed, on execution reports the currently displayed quantity.',
    },
    {
        name: 'DisplayWhen',
        abbrName: 'DspWhn',
        addedEP: '22',
        added: 'FIX.4.4',
        type: 'DisplayWhenCodeSet',
        id: 1083,
        description: 'Instructs when to refresh DisplayQty (1138).',
    },
    {
        name: 'DisplayMethod',
        abbrName: 'DspMthd',
        addedEP: '22',
        added: 'FIX.4.4',
        type: 'DisplayMethodCodeSet',
        id: 1084,
        description:
            'Defines what value to use in DisplayQty (1138). If not specified the default DisplayMethod is "1"',
    },
    {
        name: 'DisplayLowQty',
        abbrName: 'DsplLwQty',
        addedEP: '22',
        added: 'FIX.4.4',
        type: 'Qty',
        id: 1085,
        description: 'Defines the lower quantity limit to a randomized refresh of DisplayQty.',
    },
    {
        name: 'DisplayHighQty',
        abbrName: 'DisplayHighQty',
        addedEP: '22',
        added: 'FIX.4.4',
        type: 'Qty',
        id: 1086,
        description: 'Defines the upper quantity limit to a randomized refresh of DisplayQty.',
    },
    {
        name: 'DisplayMinIncr',
        abbrName: 'DspMinIncr',
        addedEP: '22',
        added: 'FIX.4.4',
        type: 'Qty',
        id: 1087,
        description:
            'Defines the minimum increment to be used when calculating a random refresh of DisplayQty. A user specifies this when he wants a larger increment than the standard provided by the market (e.g. the round lot size).',
    },
    {
        name: 'RefreshQty',
        abbrName: 'RfrshQty',
        addedEP: '22',
        added: 'FIX.4.4',
        type: 'Qty',
        id: 1088,
        description: 'Defines the quantity used to refresh DisplayQty.',
    },
    {
        name: 'MatchIncrement',
        abbrName: 'MtchInc',
        addedEP: '22',
        added: 'FIX.4.4',
        type: 'Qty',
        id: 1089,
        description:
            'Allows orders to specify a minimum quantity that applies to every execution (one execution could be for multiple counter-orders). The order may still fill against smaller orders, but the cumulative quantity of the execution must be in multiples of the MatchIncrement.',
    },
    {
        name: 'MaxPriceLevels',
        abbrName: 'MxPxLvls',
        addedEP: '22',
        added: 'FIX.4.4',
        type: 'int',
        id: 1090,
        description:
            'Allows an order to specify a maximum number of price levels to trade through. Only valid for aggressive orders and during continuous (autoexecution) trading sessions. Property lost when order is put on book. A partially filled order is assigned last trade price as limit price. Non-filled order behaves as ordinary Market or Limit.',
    },
    {
        name: 'PreTradeAnonymity',
        abbrName: 'PrTrdAnon',
        addedEP: '22',
        added: 'FIX.4.4',
        type: 'Boolean',
        id: 1091,
        description:
            'Allows trader to explicitly request anonymity or disclosure in pre-trade market data feeds. Anonymity is relevant in markets where counterparties are regularly disclosed in order depth feeds. Disclosure is relevant when counterparties are not normally visible.',
    },
    {
        name: 'PriceProtectionScope',
        abbrName: 'PxPrtScp',
        addedEP: '22',
        added: 'FIX.4.4',
        type: 'PriceProtectionScopeCodeSet',
        id: 1092,
        description: 'Defines the type of price protection the customer requires on their order.',
    },
    {
        name: 'LotType',
        abbrName: 'LotTyp',
        addedEP: '22',
        added: 'FIX.4.4',
        type: 'LotTypeCodeSet',
        id: 1093,
        description: 'Defines the lot type assigned to the order.',
    },
    {
        name: 'PegPriceType',
        abbrName: 'PegPxTyp',
        addedEP: '22',
        added: 'FIX.4.4',
        type: 'PegPriceTypeCodeSet',
        id: 1094,
        description: 'Defines the type of peg.',
    },
    {
        name: 'PeggedRefPrice',
        abbrName: 'PggdRefPx',
        addedEP: '22',
        added: 'FIX.4.4',
        type: 'Price',
        id: 1095,
        description:
            'The value of the reference price that the order is pegged to. PeggedRefPrice + PegOffsetValue (211) = PeggedPrice (839) unless the limit price (44, Price) is breached. The values may not be exact due to rounding.',
    },
    {
        name: 'PegSecurityIDSource',
        abbrName: 'PegSecurityIDSource',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.Latest',
        addedEP: '22',
        added: 'FIX.4.4',
        type: 'SecurityIDSourceCodeSet',
        updatedEP: '265',
        id: 1096,
        description:
            'Defines the identity of the security off whose prices the order will peg. Same values as SecurityIDSource (22)',
    },
    {
        name: 'PegSecurityID',
        abbrName: 'PegSecID',
        addedEP: '22',
        added: 'FIX.4.4',
        type: 'String',
        id: 1097,
        discriminatorId: '1096',
        description: 'Defines the identity of the security off whose prices the order will peg.',
    },
    {
        name: 'PegSymbol',
        abbrName: 'PgSymbl',
        addedEP: '22',
        added: 'FIX.4.4',
        type: 'String',
        id: 1098,
        description:
            "Defines the common, 'human understood' representation of the security off whose prices the order will Peg.",
    },
    {
        name: 'PegSecurityDesc',
        abbrName: 'PegSecDesc',
        addedEP: '22',
        added: 'FIX.4.4',
        type: 'String',
        id: 1099,
        description: 'Security description of the security off whose prices the order will Peg.',
    },
    {
        name: 'TriggerType',
        abbrName: 'TrgrTyp',
        addedEP: '-1',
        added: 'FIX.5.0',
        type: 'TriggerTypeCodeSet',
        id: 1100,
        description:
            'Defines when the trigger will hit, i.e. the action specified by the trigger instructions will come into effect.',
    },
    {
        name: 'TriggerAction',
        abbrName: 'TrgrActn',
        addedEP: '-1',
        added: 'FIX.5.0',
        type: 'TriggerActionCodeSet',
        id: 1101,
        description: 'Defines the type of action to take when the trigger hits.',
    },
    {
        name: 'TriggerPrice',
        abbrName: 'TrgrPx',
        addedEP: '-1',
        added: 'FIX.5.0',
        type: 'Price',
        id: 1102,
        description: 'The price at which the trigger should hit.',
    },
    {
        name: 'TriggerSymbol',
        abbrName: 'TrgrSym',
        addedEP: '-1',
        added: 'FIX.5.0',
        type: 'String',
        id: 1103,
        description:
            "Defines the common, 'human understood' representation of the security whose prices will be tracked by the trigger logic.",
    },
    {
        name: 'TriggerSecurityID',
        abbrName: 'TrgrSecID',
        addedEP: '-1',
        added: 'FIX.5.0',
        type: 'String',
        id: 1104,
        discriminatorId: '1105',
        description: 'Defines the identity of the security whose prices will be tracked by the trigger logic.',
    },
    {
        name: 'TriggerSecurityIDSource',
        abbrName: 'TrgrSecIDSrc',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.Latest',
        addedEP: '-1',
        added: 'FIX.5.0',
        type: 'SecurityIDSourceCodeSet',
        updatedEP: '265',
        id: 1105,
        description:
            'Defines the identity of the security whose prices will be tracked by the trigger logic. Same values as SecurityIDSource (22).',
    },
    {
        name: 'TriggerSecurityDesc',
        abbrName: 'TrgrSecDesc',
        addedEP: '-1',
        added: 'FIX.5.0',
        type: 'String',
        id: 1106,
        description:
            'Defines the security description of the security whose prices will be tracked by the trigger logic.',
    },
    {
        name: 'TriggerPriceType',
        abbrName: 'TrgrPxTyp',
        addedEP: '-1',
        added: 'FIX.5.0',
        type: 'TriggerPriceTypeCodeSet',
        id: 1107,
        description: 'The type of price that the trigger is compared to.',
    },
    {
        name: 'TriggerPriceTypeScope',
        abbrName: 'TrgrPxTypScp',
        addedEP: '-1',
        added: 'FIX.5.0',
        type: 'TriggerPriceTypeScopeCodeSet',
        id: 1108,
        description: 'Defines the type of price protection the customer requires on their order.',
    },
    {
        name: 'TriggerPriceDirection',
        abbrName: 'TrgrPxDir',
        addedEP: '-1',
        added: 'FIX.5.0',
        type: 'TriggerPriceDirectionCodeSet',
        id: 1109,
        description: 'The side from which the trigger price is reached.',
    },
    {
        name: 'TriggerNewPrice',
        abbrName: 'TrgrNewPx',
        addedEP: '-1',
        added: 'FIX.5.0',
        type: 'Price',
        id: 1110,
        description:
            'The Price that the order should have after the trigger has hit. Could be applicable for any trigger type, but must be specified for Trigger Type 1.',
    },
    {
        name: 'TriggerOrderType',
        abbrName: 'TrgrOrdTyp',
        addedEP: '-1',
        added: 'FIX.5.0',
        type: 'TriggerOrderTypeCodeSet',
        id: 1111,
        description:
            'The OrdType the order should have after the trigger has hit. Required to express orders that change from Limit to Market. Other values from OrdType (40) may be used if appropriate and bilaterally agreed upon.',
    },
    {
        name: 'TriggerNewQty',
        abbrName: 'TrgrNewQty',
        addedEP: '-1',
        added: 'FIX.5.0',
        type: 'Qty',
        id: 1112,
        description: 'The Quantity the order should have after the trigger has hit.',
    },
    {
        name: 'TriggerTradingSessionID',
        abbrName: 'TrgrTrdSessID',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.Latest',
        addedEP: '-1',
        added: 'FIX.5.0',
        type: 'TradingSessionIDCodeSet',
        updatedEP: '282',
        id: 1113,
        description: 'Defines the trading session at which the order will be activated.',
    },
    {
        name: 'TriggerTradingSessionSubID',
        abbrName: 'TrgrTrdSessSubID',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.Latest',
        addedEP: '-1',
        added: 'FIX.5.0',
        type: 'TradingSessionSubIDCodeSet',
        updatedEP: '282',
        id: 1114,
        description: 'Defines the subordinate trading session at which the order will be activated.',
    },
    {
        name: 'OrderCategory',
        abbrName: 'OrdCat',
        addedEP: '22',
        added: 'FIX.4.4',
        type: 'OrderCategoryCodeSet',
        id: 1115,
        description: 'Defines the type of interest behind a trade (fill or partial fill).',
    },
    {
        name: 'NoRootPartyIDs',
        updated: 'FIX.Latest',
        addedEP: '22',
        added: 'FIX.4.4',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 1116,
        description: 'Number of RootPartyID (1117), RootPartyIDSource (1118), and RootPartyRole (1119) entries',
    },
    {
        name: 'RootPartyID',
        abbrName: 'ID',
        addedEP: '22',
        added: 'FIX.4.4',
        type: 'String',
        id: 1117,
        discriminatorId: '1118',
        description: 'PartyID value within a root parties component. Same values as PartyID (448)',
    },
    {
        name: 'RootPartyIDSource',
        abbrName: 'Src',
        addedEP: '22',
        added: 'FIX.4.4',
        type: 'PartyIDSourceCodeSet',
        id: 1118,
        description: 'PartyIDSource value within a root parties component. Same values as PartyIDSource (447)',
    },
    {
        name: 'RootPartyRole',
        abbrName: 'R',
        addedEP: '22',
        added: 'FIX.4.4',
        type: 'PartyRoleCodeSet',
        id: 1119,
        description: 'PartyRole value within a root parties component. Same values as PartyRole (452)',
    },
    {
        name: 'NoRootPartySubIDs',
        updated: 'FIX.Latest',
        addedEP: '22',
        added: 'FIX.4.4',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 1120,
        description: 'Number of RootPartySubID (1121) and RootPartySubIDType (1122) entries',
    },
    {
        name: 'RootPartySubID',
        abbrName: 'ID',
        addedEP: '22',
        added: 'FIX.4.4',
        type: 'String',
        id: 1121,
        description: 'PartySubID value within a root parties component. Same values as PartySubID (523)',
    },
    {
        name: 'RootPartySubIDType',
        abbrName: 'Typ',
        unionDataType: 'Reserved4000Plus',
        updated: 'FIX.Latest',
        addedEP: '22',
        added: 'FIX.4.4',
        type: 'PartySubIDTypeCodeSet',
        updatedEP: '294',
        id: 1122,
        description: 'Type of RootPartySubID (1121) value. Same values as PartySubIDType (803)',
    },
    {
        name: 'TradeHandlingInstr',
        abbrName: 'TrdHandlInst',
        updated: 'FIX.5.0SP2',
        addedEP: '23',
        added: 'FIX.4.4',
        type: 'TradeHandlingInstrCodeSet',
        updatedEP: '136',
        id: 1123,
        description: 'Specified how the TradeCaptureReport(35=AE) should be handled by the respondent.',
    },
    {
        name: 'OrigTradeHandlingInstr',
        abbrName: 'OrigTrdHandlInst',
        addedEP: '23',
        added: 'FIX.4.4',
        type: 'TradeHandlingInstrCodeSet',
        id: 1124,
        description:
            'Optionally used with TradeHandlingInstr = 0 to relay the trade handling instruction used when reporting the trade to the marketplace. Same values as TradeHandlingInstr (1123)',
    },
    {
        name: 'OrigTradeDate',
        abbrName: 'OrigTrdDt',
        addedEP: '23',
        added: 'FIX.4.4',
        type: 'LocalMktDate',
        id: 1125,
        description:
            'Used to preserve original trade date when original trade is being referenced in a subsequent trade transaction such as a transfer',
    },
    {
        name: 'OrigTradeID',
        abbrName: 'OrigTrdID',
        addedEP: '23',
        added: 'FIX.4.4',
        type: 'String',
        id: 1126,
        description:
            'Used to preserve original trade id when original trade is being referenced in a subsequent trade transaction such as a transfer',
    },
    {
        name: 'OrigSecondaryTradeID',
        abbrName: 'OrignTrdID2',
        addedEP: '23',
        added: 'FIX.4.4',
        type: 'String',
        id: 1127,
        description:
            'Used to preserve original secondary trade id when original trade is being referenced in a subsequent trade transaction such as a transfer',
    },
    {
        name: 'ApplVerID',
        abbrName: 'ApplVerID',
        updated: 'FIX.Latest',
        addedEP: '16',
        added: 'FIX.4.4',
        type: 'ApplVerIDCodeSet',
        updatedEP: '270',
        id: 1128,
        description: 'Specifies the application layer version being applied at the message level.',
    },
    {
        name: 'CstmApplVerID',
        abbrName: 'CstmApplVerID',
        addedEP: '16',
        added: 'FIX.4.4',
        type: 'String',
        id: 1129,
        description: 'Specifies a custom extension to a message being applied at the message level. Enumerated field',
    },
    {
        name: 'RefApplVerID',
        abbrName: 'RefApplVerID',
        addedEP: '16',
        added: 'FIX.4.4',
        type: 'ApplVerIDCodeSet',
        id: 1130,
        description:
            'Specifies the service pack release being applied to a message at the session level. Enumerated field with values assigned at time of service pack release. Uses same values as ApplVerID',
    },
    {
        name: 'RefCstmApplVerID',
        abbrName: 'RefCstmApplVerID',
        addedEP: '16',
        added: 'FIX.4.4',
        type: 'String',
        id: 1131,
        description: 'Specifies a custom extension to a message being applied at the session level.',
    },
    {
        name: 'TZTransactTime',
        abbrName: 'TZTransactTime',
        addedEP: '26',
        added: 'FIX.4.4',
        type: 'TZTimestamp',
        id: 1132,
        description: 'Transact time in the local date-time stamp with a TZ offset to UTC identified',
    },
    {
        name: 'ExDestinationIDSource',
        abbrName: 'ExDestIDSrc',
        addedEP: '26',
        added: 'FIX.4.4',
        type: 'ExDestinationIDSourceCodeSet',
        id: 1133,
        description: 'The ID source of ExDestination',
    },
    {
        name: 'ReportedPxDiff',
        abbrName: 'ReportedPxDiff',
        addedEP: '26',
        added: 'FIX.4.4',
        type: 'Boolean',
        id: 1134,
        description:
            'Indicates that the reported price that is different from the market price. The price difference should be stated by using field 828 TrdType and, if required, field 829 TrdSubType',
    },
    {
        name: 'RptSys',
        abbrName: 'RptSys',
        addedEP: '26',
        added: 'FIX.4.4',
        type: 'String',
        id: 1135,
        description: 'Indicates the system or medium on which the report has been published',
    },
    {
        name: 'AllocClearingFeeIndicator',
        abbrName: 'ClrFeeInd',
        addedEP: '25',
        added: 'FIX.4.4',
        type: 'String',
        id: 1136,
        description: 'ClearingFeeIndicator(635) for Allocation, see ClearingFeeIndicator(635) for permitted values.',
    },
    {
        name: 'DefaultApplVerID',
        abbrName: 'DefApplVerID',
        addedEP: '16',
        added: 'FIX.4.4',
        type: 'ApplVerIDCodeSet',
        id: 1137,
        description:
            'Specifies the service pack release being applied, by default, to message at the session level. Enumerated field with values assigned at time of service pack release. Uses same values as ApplVerID',
    },
    {
        name: 'DisplayQty',
        abbrName: 'DisplayQty',
        addedEP: '22',
        added: 'FIX.4.4',
        type: 'Qty',
        id: 1138,
        description:
            'The quantity to be displayed . Required for reserve orders. On orders specifies the qty to be displayed, on execution reports the currently displayed quantity.',
    },
    {
        name: 'ExchangeSpecialInstructions',
        abbrName: 'ExchSpeclInstr',
        updated: 'FIX.5.0SP1',
        addedEP: '29',
        added: 'FIX.4.4',
        type: 'String',
        updatedEP: '95',
        id: 1139,
        description: 'Free format text string related to exchange.',
    },
    {
        name: 'UnderlyingMaturityTime',
        abbrName: 'MatTm',
        addedEP: '41',
        added: 'FIX.5.0',
        type: 'TZTimeOnly',
        id: 1213,
        description: "Time of security's maturity expressed in local time with offset to UTC specified",
    },
    {
        name: 'LegMaturityTime',
        abbrName: 'MatTm',
        addedEP: '41',
        added: 'FIX.5.0',
        type: 'TZTimeOnly',
        id: 1212,
        description: "Time of security's maturity expressed in local time with offset to UTC specified",
    },
    {
        name: 'MaxTradeVol',
        abbrName: 'MaxTrdVol',
        updated: 'FIX.5.0SP2',
        addedEP: '42',
        added: 'FIX.5.0',
        type: 'Qty',
        updatedEP: '130',
        id: 1140,
        description:
            'The maximum order quantity (as expressed by TradeVolType(1786)) that can be submitted for a security.',
    },
    {
        name: 'NoMDFeedTypes',
        updated: 'FIX.Latest',
        addedEP: '42',
        added: 'FIX.5.0',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 1141,
        description: 'The number of feed types and corresponding book depths associated with a security',
    },
    {
        name: 'MatchAlgorithm',
        abbrName: 'MtchAlgo',
        addedEP: '42',
        added: 'FIX.5.0',
        type: 'String',
        id: 1142,
        description:
            'The types of algorithm used to match orders in a specific security. Possilbe value types are FIFO, Allocation, Pro-rata, Lead Market Maker, Currency Calender.',
    },
    {
        name: 'MaxPriceVariation',
        abbrName: 'MxPxVar',
        updated: 'FIX.5.0SP2',
        addedEP: '42',
        added: 'FIX.5.0',
        type: 'float',
        updatedEP: '195',
        id: 1143,
        description:
            'The maximum price variation of an execution from one event to the next for a given security. Expressed in absolute price terms.',
    },
    {
        name: 'ImpliedMarketIndicator',
        abbrName: 'ImpldMktInd',
        addedEP: '42',
        added: 'FIX.5.0',
        type: 'ImpliedMarketIndicatorCodeSet',
        id: 1144,
        description:
            'Indicates that an implied market should be created for either the legs of a multi-leg instrument (Implied-in) or for the multi-leg instrument based on the existence of the legs (Implied-out). Determination as to whether implied markets should be created is generally done at the level of the multi-leg instrument. Commonly used in listed derivatives.',
    },
    {
        name: 'EventTime',
        abbrName: 'Tm',
        addedEP: '42',
        added: 'FIX.5.0',
        type: 'UTCTimestamp',
        id: 1145,
        description: 'Specific time of event. To be used in combination with EventDate [866]',
    },
    {
        name: 'MinPriceIncrementAmount',
        abbrName: 'MinPxIncrAmt',
        updated: 'FIX.Latest',
        addedEP: '42',
        added: 'FIX.5.0',
        type: 'Amt',
        updatedEP: '271',
        id: 1146,
        description:
            'Minimum price increment amount associated with MinPriceIncrement(969). For listed derivatives, the value can be calculated by multiplying MinPriceIncrement(969) with ContractMultiplier(231).',
    },
    {
        name: 'UnitOfMeasureQty',
        abbrName: 'UOMQty',
        addedEP: '42',
        added: 'FIX.5.0',
        type: 'Qty',
        id: 1147,
        description:
            'Used to indicate the quantity of the underlying commodity unit of measure on which the contract is based, such as, 2500 lbs of lean cattle, 1000 barrels of crude oil, 1000 bushels of corn, etc. UnitOfMeasureQty is required for UnitOfMeasure(996) Variable Quantity UOMs enumerations. Refer to the definition of UnitOfMeasure(996) for more information on the use of UnitOfMeasureQty.',
    },
    {
        name: 'LowLimitPrice',
        abbrName: 'LowLmtPx',
        addedEP: '42',
        added: 'FIX.5.0',
        type: 'Price',
        id: 1148,
        description:
            'Allowable low limit price for the trading day. A key parameter in validating order price. Used as the lower band for validating order prices. Orders submitted with prices below the lower limit will be rejected',
    },
    {
        name: 'HighLimitPrice',
        abbrName: 'HiLmtPx',
        updated: 'FIX.5.0SP1',
        addedEP: '42',
        added: 'FIX.5.0',
        type: 'Price',
        updatedEP: '76',
        id: 1149,
        description:
            'Allowable high limit price for the trading day. A key parameter in validating order price. Used as the upper band for validating order prices. Orders submitted with prices above the upper limit will be rejected',
    },
    {
        name: 'TradingReferencePrice',
        abbrName: 'TrdgRefPx',
        addedEP: '42',
        added: 'FIX.5.0',
        type: 'Price',
        id: 1150,
        description:
            'Reference price for the current trading price range usually representing the mid price between the HighLimitPrice and LowLimitPrice. The value may be the settlement price or closing price of the prior trading day.',
    },
    {
        name: 'SecurityGroup',
        abbrName: 'SecGrp',
        addedEP: '42',
        added: 'FIX.5.0',
        type: 'String',
        id: 1151,
        description:
            'An exchange specific name assigned to a group of related securities which may be concurrently affected by market events and actions.',
    },
    {
        name: 'LegNumber',
        abbrName: 'LegNo',
        addedEP: '44',
        added: 'FIX.5.0',
        type: 'int',
        id: 1152,
        description: 'Allow sequencing of Legs for a Strategy to be captured',
    },
    {
        name: 'SettlementCycleNo',
        abbrName: 'CycleNo',
        addedEP: '44',
        added: 'FIX.5.0',
        type: 'int',
        id: 1153,
        description: 'Settlement cycle in which the settlement obligation was generated',
    },
    {
        name: 'SideCurrency',
        abbrName: 'Ccy',
        addedEP: '44',
        added: 'FIX.5.0',
        type: 'Currency',
        id: 1154,
        description: 'Used to identify the trading currency on the Trade Capture Report Side',
    },
    {
        name: 'SideSettlCurrency',
        abbrName: 'SettlCcy',
        addedEP: '44',
        added: 'FIX.5.0',
        type: 'Currency',
        id: 1155,
        description: 'Used to identify the settlement currency on the Trade Capture Report Side',
    },
    {
        name: 'CcyAmt',
        abbrName: 'CcyAmt',
        addedEP: '44',
        added: 'FIX.5.0',
        type: 'Amt',
        id: 1157,
        description: 'Net flow of Currency 1',
    },
    {
        name: 'NoSettlDetails',
        updated: 'FIX.Latest',
        addedEP: '44',
        added: 'FIX.5.0',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 1158,
        description: 'Used to group Each Settlement Party',
    },
    {
        name: 'SettlObligMode',
        abbrName: 'SettlMode',
        addedEP: '44',
        added: 'FIX.5.0',
        type: 'SettlObligModeCodeSet',
        id: 1159,
        description:
            'Used to identify the reporting mode of the settlement obligation which is either preliminary or final',
    },
    {
        name: 'SettlObligMsgID',
        abbrName: 'SettlMsgID',
        addedEP: '44',
        added: 'FIX.5.0',
        type: 'String',
        id: 1160,
        description: 'Message identifier for Settlement Obligation Report',
    },
    {
        name: 'SettlObligID',
        abbrName: 'SettlID',
        addedEP: '44',
        added: 'FIX.5.0',
        type: 'String',
        id: 1161,
        description: 'Unique ID for this settlement instruction.',
    },
    {
        name: 'SettlObligTransType',
        abbrName: 'SettlTransTyp',
        addedEP: '44',
        added: 'FIX.5.0',
        type: 'SettlObligTransTypeCodeSet',
        id: 1162,
        description: 'Transaction Type - required except where SettlInstMode is 5=Reject SSI request',
    },
    {
        name: 'SettlObligRefID',
        abbrName: 'SettlRefID',
        addedEP: '44',
        added: 'FIX.5.0',
        type: 'String',
        id: 1163,
        description: 'Required where SettlInstTransType is Cancel or Replace',
    },
    {
        name: 'SettlObligSource',
        abbrName: 'SettlSrc',
        addedEP: '44',
        added: 'FIX.5.0',
        type: 'SettlObligSourceCodeSet',
        id: 1164,
        description: 'Used to identify whether these delivery instructions are for the buyside or the sellside.',
    },
    {
        name: 'NoSettlOblig',
        updated: 'FIX.Latest',
        addedEP: '44',
        added: 'FIX.5.0',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 1165,
        description: 'Number of settlement obligations',
    },
    {
        name: 'QuoteMsgID',
        abbrName: 'QtMsgID',
        addedEP: '45',
        added: 'FIX.5.0',
        type: 'String',
        id: 1166,
        description: 'Unique identifier for a quote message.',
    },
    {
        name: 'QuoteEntryStatus',
        abbrName: 'QtEntSts',
        updated: 'FIX.5.0SP1',
        addedEP: '45',
        added: 'FIX.5.0',
        type: 'QuoteEntryStatusCodeSet',
        updatedEP: '95',
        id: 1167,
        description:
            'Identifies the status of an individual quote. See also QuoteStatus(297) which is used for single Quotes.',
    },
    {
        name: 'TotNoCxldQuotes',
        abbrName: 'TotNoCxldQts',
        addedEP: '45',
        added: 'FIX.5.0',
        type: 'int',
        id: 1168,
        description: 'Specifies the number of canceled quotes',
    },
    {
        name: 'TotNoAccQuotes',
        abbrName: 'TotNoAccQts',
        addedEP: '45',
        added: 'FIX.5.0',
        type: 'int',
        id: 1169,
        description: 'Specifies the number of accepted quotes',
    },
    {
        name: 'TotNoRejQuotes',
        abbrName: 'TotNoRejQts',
        addedEP: '45',
        added: 'FIX.5.0',
        type: 'int',
        id: 1170,
        description: 'Specifies the number of rejected quotes',
    },
    {
        name: 'PrivateQuote',
        abbrName: 'PrvtQt',
        addedEP: '46',
        added: 'FIX.5.0',
        type: 'PrivateQuoteCodeSet',
        id: 1171,
        description:
            'Specifies whether a quote is public, i.e. available to the market, or private, i.e. available to a specified counterparty only.',
    },
    {
        name: 'RespondentType',
        abbrName: 'RspdntTyp',
        addedEP: '46',
        added: 'FIX.5.0',
        type: 'RespondentTypeCodeSet',
        id: 1172,
        description: 'Specifies the type of respondents requested.',
    },
    {
        name: 'MDSubBookType',
        abbrName: 'MDSubBkTyp',
        addedEP: '47',
        added: 'FIX.5.0',
        type: 'int',
        id: 1173,
        description:
            'Describes a class of sub book, e.g. for the separation of various lot types. The Sub Book Type indicates that the following Market Data Entries belong to a non-integrated Sub Book. Whenever provided the Sub Book must be used together with MDPriceLevel and MDEntryPositionNo in order to sort the order properly.\n\nValues are bilaterally agreed.',
    },
    {
        name: 'SecurityTradingEvent',
        abbrName: 'SecTrdEvnt',
        unionDataType: 'Reserved100Plus',
        addedEP: '47',
        added: 'FIX.5.0',
        type: 'SecurityTradingEventCodeSet',
        id: 1174,
        description:
            'Identifies an event related to a SecurityTradingStatus(326). An event occurs and is gone, it is not a state that applies for a period of time.',
    },
    {
        name: 'NoStatsIndicators',
        updated: 'FIX.Latest',
        addedEP: '47',
        added: 'FIX.5.0',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 1175,
        description: 'Number of statistics indicator repeating group entries',
    },
    {
        name: 'StatsType',
        abbrName: 'StatsTyp',
        addedEP: '47',
        added: 'FIX.5.0',
        type: 'StatsTypeCodeSet',
        id: 1176,
        description: 'Type of statistics',
    },
    {
        name: 'NoOfSecSizes',
        updated: 'FIX.Latest',
        addedEP: '47',
        added: 'FIX.5.0',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 1177,
        description: 'The number of secondary sizes specifies in this entry',
    },
    {
        name: 'MDSecSizeType',
        abbrName: 'MDSecSizeType',
        unionDataType: 'Reserved100Plus',
        addedEP: '47',
        added: 'FIX.5.0',
        type: 'MDSecSizeTypeCodeSet',
        id: 1178,
        description: 'Specifies the type of secondary size.',
    },
    {
        name: 'MDSecSize',
        abbrName: 'MDSecSize',
        addedEP: '47',
        added: 'FIX.5.0',
        type: 'Qty',
        id: 1179,
        description:
            'A part of the MDEntrySize(271) that represents secondary interest as specified by MDSecSizeType(1178).',
    },
    {
        name: 'ApplID',
        abbrName: 'ApplID',
        addedEP: '48',
        added: 'FIX.5.0',
        type: 'String',
        id: 1180,
        description:
            'Identifies the application with which a message is associated. Used only if application sequencing is in effect.',
    },
    {
        name: 'ApplSeqNum',
        abbrName: 'ApplSeqNum',
        addedEP: '48',
        added: 'FIX.5.0',
        type: 'SeqNum',
        id: 1181,
        description: 'Data sequence number to be used when FIX session is not in effect',
    },
    {
        name: 'ApplBegSeqNum',
        abbrName: 'ApplBegSeqNum',
        addedEP: '48',
        added: 'FIX.5.0',
        type: 'SeqNum',
        id: 1182,
        description: 'Beginning range of application sequence numbers',
    },
    {
        name: 'ApplEndSeqNum',
        abbrName: 'ApplEndSeq',
        addedEP: '48',
        added: 'FIX.5.0',
        type: 'SeqNum',
        id: 1183,
        description: 'Ending range of application sequence numbers',
    },
    {
        name: 'SecurityXMLLen',
        abbrName: 'SecXMLLen',
        updated: 'FIX.5.0SP2',
        addedEP: '49',
        added: 'FIX.5.0',
        type: 'Length',
        updatedEP: '145',
        id: 1184,
        description: 'The length of the SecurityXML(1185) data block.',
    },
    {
        name: 'SecurityXML',
        abbrName: 'SecXML',
        updated: 'FIX.Latest',
        addedEP: '49',
        added: 'FIX.5.0',
        type: 'XMLData',
        updatedEP: '275',
        id: 1185,
        lengthId: '1184',
        description: 'XML definition for the security.',
    },
    {
        name: 'SecurityXMLSchema',
        abbrName: 'Schema',
        updated: 'FIX.5.0SP2',
        addedEP: '49',
        added: 'FIX.5.0',
        type: 'String',
        updatedEP: '145',
        id: 1186,
        description: 'The schema used to validate the contents of SecurityXML(1185).',
    },
    {
        name: 'RefreshIndicator',
        abbrName: 'RefInd',
        addedEP: '50',
        added: 'FIX.5.0',
        type: 'Boolean',
        id: 1187,
        description:
            "Set by the sender to tell the receiver to perform an immediate refresh of the book due to disruptions in the accompanying real-time feed\n\n'Y' - Mandatory refresh by all participants\n\n'N' - Process as required",
    },
    {
        name: 'Volatility',
        abbrName: 'Vol',
        addedEP: '51',
        added: 'FIX.5.0',
        type: 'float',
        id: 1188,
        description: 'Annualized volatility for option model calculations',
    },
    {
        name: 'TimeToExpiration',
        abbrName: 'TmToExp',
        addedEP: '51',
        added: 'FIX.5.0',
        type: 'float',
        id: 1189,
        description:
            'Time to expiration in years calculated as the number of days remaining to expiration divided by 365 days per year.',
    },
    {
        name: 'RiskFreeRate',
        abbrName: 'RFR',
        addedEP: '51',
        added: 'FIX.5.0',
        type: 'float',
        id: 1190,
        description: 'Interest rate. Usually some form of short term rate.',
    },
    {
        name: 'PriceUnitOfMeasure',
        abbrName: 'PxUOM',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'UnitOfMeasureCodeSet',
        id: 1191,
        description:
            'Used to express the UOM of the price if different from the contract. In futures, this can be different for cross-rate products in which the price is quoted in units differently from the contract',
    },
    {
        name: 'PriceUnitOfMeasureQty',
        abbrName: 'PxUOMQty',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Qty',
        id: 1192,
        description:
            'Used to express the UOM Quantity of the price if different from the contract. In futures, this can be different for physically delivered products in which price is quoted in a unit size different from the contract, i.e. a Cattle Future contract has a UOMQty of 40,000 and a PriceUOMQty of 100.',
    },
    {
        name: 'SettlMethod',
        abbrName: 'SettlMeth',
        updated: 'FIX.5.0SP2',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'SettlMethodCodeSet',
        updatedEP: '169',
        id: 1193,
        description:
            'Settlement method for a contract or instrument. Additional values may be used with bilateral agreement.',
    },
    {
        name: 'ExerciseStyle',
        abbrName: 'ExerStyle',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.5.0SP2',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'ExerciseStyleCodeSet',
        updatedEP: '161',
        id: 1194,
        description: 'Type of exercise of a derivatives security',
    },
    {
        name: 'UnderlyingExerciseStyle',
        abbrName: 'ExerStyle',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'ExerciseStyleCodeSet',
        id: 1419,
        description: 'Type of exercise of a derivatives security',
    },
    {
        name: 'LegExerciseStyle',
        abbrName: 'ExerStyle',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'ExerciseStyleCodeSet',
        id: 1420,
        description: 'Type of exercise of a derivatives security',
    },
    {
        name: 'OptPayoutAmount',
        abbrName: 'OptPayAmt',
        updated: 'FIX.5.0SP2',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Amt',
        updatedEP: '169',
        id: 1195,
        description:
            'Cash amount indicating the pay out associated with an option. For binary options this is a fixed amount.',
    },
    {
        name: 'PriceQuoteMethod',
        abbrName: 'PxQteMeth',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'PriceQuoteMethodCodeSet',
        id: 1196,
        description: 'Method for price quotation',
    },
    {
        name: 'ValuationMethod',
        abbrName: 'ValMeth',
        updated: 'FIX.5.0SP1',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'ValuationMethodCodeSet',
        updatedEP: '83',
        id: 1197,
        description: 'Specifies the type of valuation method applied.',
    },
    {
        name: 'ListMethod',
        abbrName: 'ListMeth',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'ListMethodCodeSet',
        id: 1198,
        description: 'Indicates whether instruments are pre-listed only or can also be defined via user request',
    },
    {
        name: 'CapPrice',
        abbrName: 'CapPx',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Price',
        id: 1199,
        description: 'Used to express the ceiling price of a capped call',
    },
    {
        name: 'FloorPrice',
        abbrName: 'FlrPx',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Price',
        id: 1200,
        description: 'Used to express the floor price of a capped put',
    },
    {
        name: 'NoStrikeRules',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'NumInGroup',
        id: 1201,
        description:
            'Number of strike rule entries. This block specifies the rules for determining how new strikes should be listed within the stated price range of the underlying instrument',
    },
    {
        name: 'StartStrikePxRange',
        abbrName: 'StartStrkPxRng',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Price',
        id: 1202,
        description:
            'Starting price for the range to which the StrikeIncrement applies. Price refers to the price of the underlying',
    },
    {
        name: 'EndStrikePxRange',
        abbrName: 'EndStrkPxRng',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Price',
        id: 1203,
        description:
            'Ending price of the range to which the StrikeIncrement applies. Price refers to the price of the underlying',
    },
    {
        name: 'StrikeIncrement',
        abbrName: 'StrkIncr',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'float',
        id: 1204,
        description: 'Value by which strike price should be incremented within the specified price range.',
    },
    {
        name: 'NoTickRules',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'NumInGroup',
        id: 1205,
        description:
            'Number of tick rules. This block specifies the rules for determining how a security ticks, i.e. the price increments at which it can be quoted and traded, depending on the current price of the security',
    },
    {
        name: 'StartTickPriceRange',
        abbrName: 'StartTickPxRng',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Price',
        id: 1206,
        description: 'Starting price range for specified tick increment',
    },
    {
        name: 'EndTickPriceRange',
        abbrName: 'EndTickPxRng',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Price',
        id: 1207,
        description: 'Ending price range for the specified tick increment',
    },
    {
        name: 'TickIncrement',
        abbrName: 'TickIncr',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Price',
        id: 1208,
        description:
            'Tick increment for stated price range. Specifies the valid price increments at which a security can be quoted and traded',
    },
    {
        name: 'TickRuleType',
        abbrName: 'TickRuleTyp',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'TickRuleTypeCodeSet',
        id: 1209,
        description: 'Specifies the type of tick rule which is being described',
    },
    {
        name: 'NestedInstrAttribType',
        abbrName: 'Typ',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'InstrAttribTypeCodeSet',
        id: 1210,
        description: 'Code to represent the type of instrument attribute',
    },
    {
        name: 'NestedInstrAttribValue',
        abbrName: 'Val',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'String',
        id: 1211,
        description: 'Attribute value appropriate to the NestedInstrAttribType field',
    },
    {
        name: 'DerivativeSymbol',
        abbrName: 'Sym',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'String',
        updatedEP: '271',
        id: 1214,
        description:
            'Ticker symbol. Common, human understood representation of the security.\n\nSee Symbol(55) for complete definition.',
    },
    {
        name: 'DerivativeSymbolSfx',
        abbrName: 'Sfx',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'SymbolSfxCodeSet',
        updatedEP: '271',
        id: 1215,
        description:
            'Additional information about the security (e.g. preferred, warrants, etc.).\n\nSee SymbolSfx(65) for complete definition.',
    },
    {
        name: 'DerivativeSecurityID',
        abbrName: 'ID',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'String',
        updatedEP: '271',
        id: 1216,
        discriminatorId: '1217',
        description:
            'Security identifier value (e.g. CUSIP, SEDOL, ISIN, etc).\n\nRequires DerivativeSecurityIDSource(1217).\n\nSee SecurityID(48) for complete definition.',
    },
    {
        name: 'DerivativeSecurityIDSource',
        abbrName: 'Src',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'SecurityIDSourceCodeSet',
        updatedEP: '271',
        id: 1217,
        description:
            'Identifies class or source of the DerivativeSecurityID(1217) value.\n\nSee SecurityIDSource(22) for complete definition.',
    },
    {
        name: 'NoDerivativeSecurityAltID',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 1218,
        description: 'Number of alternate derivative security IDs.',
    },
    {
        name: 'DerivativeSecurityAltID',
        abbrName: 'ID',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'String',
        updatedEP: '271',
        id: 1219,
        discriminatorId: '1220',
        description:
            'Alternate derivative security identifier value of DerivativeSecurityAltIDSource(1220) type.\n\nRequires DerivativeSecurityAltIDSource(1220).',
    },
    {
        name: 'DerivativeSecurityAltIDSource',
        abbrName: 'Src',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'SecurityIDSourceCodeSet',
        updatedEP: '271',
        id: 1220,
        description: 'Identifies class or source of the DerivativeSecurityAltID(1219) value.',
    },
    {
        name: 'SecondaryLowLimitPrice',
        abbrName: 'LowLmtPx',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Price',
        id: 1221,
        description: 'Refer to definition of LowLimitPrice(1148)',
    },
    {
        name: 'SecondaryHighLimitPrice',
        abbrName: 'HiLmtPx',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Price',
        id: 1230,
        description: 'Refer to definition of HighLimitPrice(1149)',
    },
    {
        name: 'MaturityRuleID',
        abbrName: 'MatRuleID',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'String',
        id: 1222,
        description:
            'Allows maturity rule to be referenced via an identifier so that rules do not need to be explicitly enumerated',
    },
    {
        name: 'StrikeRuleID',
        abbrName: 'StrkRule',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'String',
        id: 1223,
        description:
            'Allows strike rule to be referenced via an identifier so that rules do not need to be explicitly enumerated',
    },
    {
        name: 'DerivativeOptPayoutAmount',
        abbrName: 'OptPayAmt',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Amt',
        updatedEP: '282',
        id: 1225,
        description:
            'Cash amount indicating the pay out associated with an option. For binary options this is a fixed amount.\n\nSee OptPayoutAmount(1195) for complete definition.',
    },
    {
        name: 'EndMaturityMonthYear',
        abbrName: 'EndMMY',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'MonthYear',
        id: 1226,
        description: 'Ending maturity month year for an option class',
    },
    {
        name: 'ProductComplex',
        abbrName: 'ProdCmplx',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'String',
        id: 1227,
        description:
            'Identifies an entire suite of products for a given market. In Futures this may be "interest rates", "agricultural", "equity indexes", etc.',
    },
    {
        name: 'DerivativeProductComplex',
        abbrName: 'ProdCmplx',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'String',
        updatedEP: '271',
        id: 1228,
        description:
            'Identifies an entire suite of products for a given market.\n\nSee ProductComplex(1227) for complete definition.',
    },
    {
        name: 'MaturityMonthYearIncrement',
        abbrName: 'MMYIncr',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'int',
        id: 1229,
        description: 'Increment between successive maturities for an option class',
    },
    {
        name: 'MinLotSize',
        abbrName: 'MinLotSz',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Qty',
        id: 1231,
        description: 'Minimum lot size allowed based on lot type specified in LotType(1093)',
    },
    {
        name: 'NoExecInstRules',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 1232,
        description: 'Number of execution instructions',
    },
    {
        name: 'NoLotTypeRules',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 1234,
        description: 'Number of Lot Type Rules',
    },
    {
        name: 'NoMatchRules',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 1235,
        description: 'Number of Match Rules',
    },
    {
        name: 'NoMaturityRules',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 1236,
        description: 'Number of maturity rules in MarurityRules component block',
    },
    {
        name: 'NoOrdTypeRules',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 1237,
        description: 'Number of order types',
    },
    {
        name: 'NoTimeInForceRules',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 1239,
        description: 'Number of time in force techniques',
    },
    {
        name: 'SecondaryTradingReferencePrice',
        abbrName: 'TrdgRefPx',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Price',
        id: 1240,
        description: 'Refer to definition for TradingReferencePrice(1150)',
    },
    {
        name: 'StartMaturityMonthYear',
        abbrName: 'StartMMY',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'MonthYear',
        id: 1241,
        description: 'Starting maturity month year for an option class',
    },
    {
        name: 'FlexProductEligibilityIndicator',
        abbrName: 'FlexProdElig',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Boolean',
        id: 1242,
        description: 'Used to indicate if a product or group of product supports the creation of flexible securities',
    },
    {
        name: 'DerivFlexProductEligibilityIndicator',
        abbrName: 'FlexProdElig',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Boolean',
        updatedEP: '271',
        id: 1243,
        description:
            'Used to indicate if a product or group of product supports the creation of flexible securities.\n\nSee FlexProductEligibilityIndicator(1242) for complete definition.',
    },
    {
        name: 'FlexibleIndicator',
        abbrName: 'FlexInd',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Boolean',
        id: 1244,
        description:
            'Used to indicate a derivatives security that can be defined using flexible terms. The terms commonly permitted to be defined by market participants are expiration date and strike price. FlexibleIndicator is an alternative CFICode(461) Standard/Non-standard attribute.',
    },
    {
        name: 'TradingCurrency',
        abbrName: 'TrdCcy',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Currency',
        id: 1245,
        description: 'Used when the trading currency can differ from the price currency',
    },
    {
        name: 'DerivativeProduct',
        abbrName: 'Prod',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'ProductCodeSet',
        updatedEP: '271',
        id: 1246,
        description:
            'The type of product the security is associated with.\n\nSee Product(460) for complete definition.',
    },
    {
        name: 'DerivativeSecurityGroup',
        abbrName: 'SecGrp',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'String',
        updatedEP: '271',
        id: 1247,
        description:
            'An exchange specific name assigned to a group of related securities which may be concurrently affected by market events and actions.\n\nSee SecurityGroup(1151) for complete definition.',
    },
    {
        name: 'DerivativeCFICode',
        abbrName: 'CFI',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'String',
        updatedEP: '271',
        id: 1248,
        description:
            'The type of security using ISO 10962 standard, Classification of Financial Instruments (CFI code) values.\n\nSee CFICode(461) for complete definition.',
    },
    {
        name: 'DerivativeSecurityType',
        abbrName: 'SecTyp',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'SecurityTypeCodeSet',
        updatedEP: '271',
        id: 1249,
        description: 'The type of security.\n\nSee SecurityType(167) for complete definition.',
    },
    {
        name: 'DerivativeSecuritySubType',
        abbrName: 'SecSubTyp',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'String',
        updatedEP: '271',
        id: 1250,
        description:
            'Sub-type qualification/identification of the security type.\n\nSee SecuritySubType(762) for complete definition.',
    },
    {
        name: 'DerivativeMaturityMonthYear',
        abbrName: 'MMY',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'MonthYear',
        updatedEP: '271',
        id: 1251,
        description:
            'Month and Year of the maturity (used for standardized futures and options).\n\nSee MaturityMonthYear(200) for complete definition.',
    },
    {
        name: 'DerivativeMaturityDate',
        abbrName: 'MatDt',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'LocalMktDate',
        updatedEP: '271',
        id: 1252,
        description: 'Date of maturity.\n\nSee MaturityDate(541) for complete definition.',
    },
    {
        name: 'DerivativeMaturityTime',
        abbrName: 'MatTm',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'TZTimeOnly',
        updatedEP: '271',
        id: 1253,
        description:
            "Time of security's maturity expressed in local time with offset to UTC specified.\n\nSee MaturityTime(1079) for complete definition.",
    },
    {
        name: 'DerivativeSettleOnOpenFlag',
        abbrName: 'SettlOnOpenFlag',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'String',
        updatedEP: '282',
        id: 1254,
        description:
            'Indicator to determine if instrument is settle on open.\n\nSee SettleOnOpenFlag(966) for complete definition.',
    },
    {
        name: 'DerivativeInstrmtAssignmentMethod',
        abbrName: 'AsgnMeth',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'InstrmtAssignmentMethodCodeSet',
        updatedEP: '271',
        id: 1255,
        description:
            'Method under which assignment was conducted.\n\nSee InstrmtAssignmentMethod(1049) for complete definition.',
    },
    {
        name: 'DerivativeSecurityStatus',
        abbrName: 'Status',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'SecurityStatusCodeSet',
        updatedEP: '271',
        id: 1256,
        description:
            'Indicates the current state of the derivative instrument.\n\nSee SecurityStatus(965) for complete definition.',
    },
    {
        name: 'DerivativeInstrRegistry',
        abbrName: 'Rgstry',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'String',
        updatedEP: '271',
        id: 1257,
        description:
            'Values may include BIC for the depository or custodian who maintain ownership records, the ISO country code for the location of the record, or the value ZZ to specify physical ownership of the security (e.g. stock certificate).\n\nSee InstrRegistry(543) for complete definition.',
    },
    {
        name: 'DerivativeCountryOfIssue',
        abbrName: 'Ctry',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Country',
        updatedEP: '271',
        id: 1258,
        description:
            'ISO Country code of instrument issue (e.g. the country portion typically used in ISIN).\n\nSee CountryOfIssue(470) for complete definition.',
    },
    {
        name: 'DerivativeStateOrProvinceOfIssue',
        abbrName: 'StPrv',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'String',
        updatedEP: '271',
        id: 1259,
        description:
            'A two-character state or province abbreviation.\n\nSee StateOrProvinceOfIssue(471) for complete definition.',
    },
    {
        name: 'DerivativeLocaleOfIssue',
        abbrName: 'Lcl',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'String',
        updatedEP: '271',
        id: 1260,
        description: 'Identifies the locale or region of issue.\n\nSee LocaleOfIssue(472) for complete definition.',
    },
    {
        name: 'DerivativeStrikePrice',
        abbrName: 'StrkPx',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Price',
        updatedEP: '271',
        id: 1261,
        description: 'Strike price for an option.\n\nSee StrikePrice(202) for complete definition.',
    },
    {
        name: 'DerivativeStrikeCurrency',
        abbrName: 'StrkCcy',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Currency',
        updatedEP: '271',
        id: 1262,
        description:
            'Currency in which the strike price is denominated.\n\nSee StrikeCurrency(947) for complete definition.',
    },
    {
        name: 'DerivativeStrikeMultiplier',
        abbrName: 'StrkMult',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'float',
        updatedEP: '271',
        id: 1263,
        description:
            'Multiplier applied to the strike price for the purpose of calculating the settlement value.\n\nSee StrikeMultiplier(967) for complete definition.',
    },
    {
        name: 'DerivativeStrikeValue',
        abbrName: 'StrkValu',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'float',
        updatedEP: '271',
        id: 1264,
        description:
            'The number of shares/units for the financial instrument involved in the option trade.\n\nSee StrikeValue(968) for complete definition.',
    },
    {
        name: 'DerivativeOptAttribute',
        abbrName: 'OptAt',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'char',
        updatedEP: '271',
        id: 1265,
        description:
            'Provided to support versioning of option contracts as a result of corporate actions or events. Use of this field is defined by counterparty agreement or market conventions.\n\nSee OptAttribute(206) for complete definition.',
    },
    {
        name: 'DerivativeContractMultiplier',
        abbrName: 'Mult',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'float',
        updatedEP: '271',
        id: 1266,
        description:
            'Specifies the ratio or multiply factor to convert from nominal units (e.g. contracts) to total units (e.g. shares) (e.g. 1.0, 100, 1000, etc.).\n\nSee ContractMultiplier(231) for complete definition.',
    },
    {
        name: 'DerivativeMinPriceIncrement',
        abbrName: 'MinPxIncr',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'float',
        updatedEP: '271',
        id: 1267,
        description:
            'Minimum price increase for a given exchange-traded Instrument.\n\nSee MinPriceIncrement(969) for complete definition.',
    },
    {
        name: 'DerivativeMinPriceIncrementAmount',
        abbrName: 'MinPxIncrAmt',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Amt',
        updatedEP: '271',
        id: 1268,
        description:
            'Minimum price increment amount associated with the minimum price increment.\n\nSee MinPriceIncrementAmount(1146) for complete definition.',
    },
    {
        name: 'DerivativeUnitOfMeasure',
        abbrName: 'UOM',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'UnitOfMeasureCodeSet',
        updatedEP: '271',
        id: 1269,
        description:
            'The unit of measure of the underlying commodity upon which the contract is based.\n\nSee UnitOfMeasure(996) for complete definition.',
    },
    {
        name: 'DerivativeUnitOfMeasureQty',
        abbrName: 'UOMQty',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Qty',
        updatedEP: '271',
        id: 1270,
        description:
            'Used to indicate the quantity of the underlying commodity unit of measure on which the contract is based.\n\nSee UnitOfMeasureQty(1147) for complete definition.',
    },
    {
        name: 'DerivativeTimeUnit',
        abbrName: 'TmUnit',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'TimeUnitCodeSet',
        updatedEP: '271',
        id: 1271,
        description:
            'Unit of time associated with the contract.\n\nNOTE: Additional values may be used by mutual agreement of the counterparties.\n\nSee TimeUnit(997) for complete definition.',
    },
    {
        name: 'DerivativeSecurityExchange',
        abbrName: 'Exch',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Exchange',
        updatedEP: '271',
        id: 1272,
        description: 'Market used to help identify a security.\n\nSee SecurityExchange(207) for complete definition.',
    },
    {
        name: 'DerivativePositionLimit',
        abbrName: 'PosLmt',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'int',
        updatedEP: '271',
        id: 1273,
        description:
            'Position limit for a given exchange-traded product.\n\nSee PositionLimit(970) for complete definition.',
    },
    {
        name: 'DerivativeNTPositionLimit',
        abbrName: 'NTPosLmt',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'int',
        updatedEP: '271',
        id: 1274,
        description:
            'Position limit in the near-term contract for a given exchange-traded product.\n\nSee NTPositionLimit(971) for complete definition.',
    },
    {
        name: 'DerivativeIssuer',
        abbrName: 'Issr',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'String',
        updatedEP: '271',
        id: 1275,
        description: 'Name of security issuer.\n\nSee Issuer(106) for complete definition.',
    },
    {
        name: 'DerivativeIssueDate',
        abbrName: 'IssDt',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'LocalMktDate',
        updatedEP: '271',
        id: 1276,
        description: 'The date on which the security is issued.\n\nSee IssueDate(225) for complete definition.',
    },
    {
        name: 'DerivativeEncodedIssuerLen',
        abbrName: 'EncIssrLen',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Length',
        updatedEP: '271',
        id: 1277,
        description:
            'Byte length of encoded (non-ASCII characters) DerivativeEncodedSecurityDesc (1281) field.\n\nSee EncodedIssuerLen(348) for complete definition.',
    },
    {
        name: 'DerivativeEncodedIssuer',
        abbrName: 'EncIssr',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'data',
        updatedEP: '271',
        id: 1278,
        lengthId: '1277',
        description:
            'Encoded (non-ASCII characters) representation of the DerivativeIssuer(1275) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the DerivativeIssuer(1275) field.\n\nSee EncodedIssuer(349) for complete definition.',
    },
    {
        name: 'DerivativeSecurityDesc',
        abbrName: 'Desc',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'String',
        updatedEP: '271',
        id: 1279,
        description:
            'Can be used by the venue or one of the trading parties to provide a non-normative textual description for the financial instrument.\n\nSee SecurityDesc(107) for complete definition.',
    },
    {
        name: 'DerivativeEncodedSecurityDescLen',
        abbrName: 'EncSecDescLen',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Length',
        updatedEP: '271',
        id: 1280,
        description:
            'Byte length of encoded (non-ASCII characters) DerivativeEncodedSecurityDesc (1281) field.\n\nSee EncodedSecurityDescLen(350) for complete definition.',
    },
    {
        name: 'DerivativeEncodedSecurityDesc',
        abbrName: 'EncSecDesc',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'data',
        updatedEP: '271',
        id: 1281,
        lengthId: '1280',
        description:
            'Encoded (non-ASCII characters) representation of the DerivativeSecurityDesc(1279) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the DerivativeSecurityDesc(1279) field.\n\nSee EncodedSecurityDesc(351) for complete definition.',
    },
    {
        name: 'DerivativeSecurityXMLLen',
        abbrName: 'SecXMLLen',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Length',
        updatedEP: '271',
        id: 1282,
        description:
            'The length of the DerivativeSecurityXML(1283) data block.\n\nSee SecurityXMLLen(1184) for complete definition.',
    },
    {
        name: 'DerivativeSecurityXML',
        abbrName: 'SecXML',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'XMLData',
        updatedEP: '275',
        id: 1283,
        lengthId: '1282',
        description: 'XML definition for the security.\n\nSee SecurityXML(1185) for complete definition.',
    },
    {
        name: 'DerivativeSecurityXMLSchema',
        abbrName: 'Schema',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'String',
        updatedEP: '271',
        id: 1284,
        description:
            'The schema used to validate the contents of DerivativeSecurityXML(1283).\n\nSee SecurityXMLSchema(1186) for complete definition.',
    },
    {
        name: 'DerivativeContractSettlMonth',
        abbrName: 'CSetMo',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'MonthYear',
        updatedEP: '271',
        id: 1285,
        description:
            'Specifies when the contract (i.e. MBS/TBA) will settle.\n\nSee ContractSettlMonth(667) for complete definition.',
    },
    {
        name: 'NoDerivativeEvents',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 1286,
        description: 'Number of repeating DerivativeEventType entries.',
    },
    {
        name: 'DerivativeEventType',
        abbrName: 'EventTyp',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'EventTypeCodeSet',
        updatedEP: '271',
        id: 1287,
        description: 'Code to represent the type of event.\n\nSee EventType(865) for complete definition.',
    },
    {
        name: 'DerivativeEventDate',
        abbrName: 'Dt',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'LocalMktDate',
        updatedEP: '271',
        id: 1288,
        description: 'Date of event.\n\nSee EventDate(866) for complete definition.',
    },
    {
        name: 'DerivativeEventTime',
        abbrName: 'Tm',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'UTCTimestamp',
        updatedEP: '271',
        id: 1289,
        description:
            'Specific time of event. To be used in combination with DerivativeEventDate(1288).\n\nSee EventTime(1145) for complete definition.',
    },
    {
        name: 'DerivativeEventPx',
        abbrName: 'Px',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Price',
        updatedEP: '271',
        id: 1290,
        description: 'Predetermined price of issue at event.\n\nSee EventPx(867) for complete definition.',
    },
    {
        name: 'DerivativeEventText',
        abbrName: 'Txt',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'String',
        updatedEP: '271',
        id: 1291,
        description: 'Comments related to the event.\n\nSee EventText(868) for complete definition.',
    },
    {
        name: 'NoDerivativeInstrumentParties',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'NumInGroup',
        updatedEP: '271',
        id: 1292,
        description: 'Number of repeating derivative instrument party entries.',
    },
    {
        name: 'DerivativeInstrumentPartyID',
        abbrName: 'ID',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'String',
        updatedEP: '271',
        id: 1293,
        discriminatorId: '1294',
        description: 'Party identifier/code.\n\nSee PartyID(448) for complete definition.',
    },
    {
        name: 'DerivativeInstrumentPartyIDSource',
        abbrName: 'Src',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'PartyIDSourceCodeSet',
        updatedEP: '271',
        id: 1294,
        description:
            'Identifies class or source of the DerivativeInstrumentPartyID (1293) value.\n\nRequired if DerivativeInstrumentPartyID(1293) is specified.\n\nSee PartyIDSource(447) for complete definition.',
    },
    {
        name: 'DerivativeInstrumentPartyRole',
        abbrName: 'R',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'PartyRoleCodeSet',
        updatedEP: '271',
        id: 1295,
        description:
            'Identifies the type or role of the DerivativeInstrumentPartyID (1293) specified.\n\nSee PartyRole(452) for complete definition.',
    },
    {
        name: 'NoDerivativeInstrumentPartySubIDs',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'NumInGroup',
        updatedEP: '271',
        id: 1296,
        description: 'Number of derivative instrument party sub IDs.',
    },
    {
        name: 'DerivativeInstrumentPartySubID',
        abbrName: 'ID',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'String',
        updatedEP: '271',
        id: 1297,
        description: 'Party sub-identifier.\n\nSee PartySubID(523) for complete definition.',
    },
    {
        name: 'DerivativeInstrumentPartySubIDType',
        abbrName: 'Typ',
        unionDataType: 'Reserved4000Plus',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'PartySubIDTypeCodeSet',
        updatedEP: '294',
        id: 1298,
        description: 'Type of party sub-identifier.\n\nSee PartySubIDType(803) for complete definition.',
    },
    {
        name: 'DerivativeExerciseStyle',
        abbrName: 'ExerStyle',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'ExerciseStyleCodeSet',
        updatedEP: '271',
        id: 1299,
        description: 'Type of exercise.\n\nSee ExerciseStyle(1194) for complete definition.',
    },
    {
        name: 'MarketSegmentID',
        abbrName: 'MktSegID',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'String',
        id: 1300,
        description: 'Identifies the market segment',
    },
    {
        name: 'MarketID',
        abbrName: 'MktID',
        updated: 'FIX.5.0SP2',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Exchange',
        updatedEP: '190',
        id: 1301,
        description: 'Identifies the market',
    },
    {
        name: 'MaturityMonthYearIncrementUnits',
        abbrName: 'MMYIncrUnits',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'MaturityMonthYearIncrementUnitsCodeSet',
        id: 1302,
        description: 'Unit of measure for the Maturity Month Year Increment',
    },
    {
        name: 'MaturityMonthYearFormat',
        abbrName: 'MMYFmt',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'MaturityMonthYearFormatCodeSet',
        id: 1303,
        description: 'Format used to generate the MaturityMonthYear for each option',
    },
    {
        name: 'StrikeExerciseStyle',
        abbrName: 'StrkExrStyle',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'ExerciseStyleCodeSet',
        id: 1304,
        description: 'Expiration Style for an option class:',
    },
    {
        name: 'SecondaryPriceLimitType',
        abbrName: 'PxLmtTyp',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'PriceLimitTypeCodeSet',
        id: 1305,
        description: 'Describes the how the price limits are expressed',
    },
    {
        name: 'PriceLimitType',
        abbrName: 'PxLmtTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'PriceLimitTypeCodeSet',
        updatedEP: '204',
        id: 1306,
        description: 'Describes the how the price limits are expressed.',
    },
    {
        name: 'ExecInstValue',
        abbrName: 'ExecInstValu',
        updated: 'FIX.5.0SP2',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'ExecInstCodeSet',
        updatedEP: '208',
        id: 1308,
        description: 'Indicates execution instructions that are valid for the specified market segment',
    },
    {
        name: 'NoTradingSessionRules',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'NumInGroup',
        id: 1309,
        description: 'Allows trading rules to be expressed by trading session',
    },
    {
        name: 'NoMarketSegments',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'NumInGroup',
        id: 1310,
        description: 'Number of Market Segments on which a security may trade.',
    },
    {
        name: 'NoDerivativeInstrAttrib',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'NumInGroup',
        updatedEP: '271',
        id: 1311,
        description: 'Number of instrument attributes.',
    },
    { name: 'NoNestedInstrAttrib', addedEP: '52', added: 'FIX.5.0', type: 'NumInGroup', id: 1312, description: '' },
    {
        name: 'DerivativeInstrAttribType',
        abbrName: 'Typ',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'InstrAttribTypeCodeSet',
        updatedEP: '271',
        id: 1313,
        description: 'Type of instrument attribute.\n\nSee InstrAttribType(871) for complete definition.',
    },
    {
        name: 'DerivativeInstrAttribValue',
        abbrName: 'Val',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'String',
        updatedEP: '271',
        id: 1314,
        description:
            'Attribute value appropriate to the DerivativeInstrAttribValue(1313) field.\n\nSee InstrAttribValue(872) for complete definition.',
    },
    {
        name: 'DerivativePriceUnitOfMeasure',
        abbrName: 'PxUOM',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'UnitOfMeasureCodeSet',
        updatedEP: '271',
        id: 1315,
        description:
            'Used to express the UOM of the price if different from the contract.\n\nSee PriceUnitOfMeasureQty(1191) for complete definition.',
    },
    {
        name: 'DerivativePriceUnitOfMeasureQty',
        abbrName: 'PxUOMQty',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Qty',
        updatedEP: '271',
        id: 1316,
        description:
            'Used to express the UOM Quantity of the price if different from the contract.\n\nSee PriceUnitOfMeasureQty(1192) for complete definition.',
    },
    {
        name: 'DerivativeSettlMethod',
        abbrName: 'SettlMeth',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'SettlMethodCodeSet',
        updatedEP: '271',
        id: 1317,
        description:
            'Settlement method for a contract or instrument.\n\nSee SettlMethod(1193) for complete definition.',
    },
    {
        name: 'DerivativePriceQuoteMethod',
        abbrName: 'PxQteMeth',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'PriceQuoteMethodCodeSet',
        updatedEP: '271',
        id: 1318,
        description: 'Specifies the method for price quotation.\n\nSee PriceQuoteMethod(1196) for complete definition.',
    },
    {
        name: 'DerivativeValuationMethod',
        abbrName: 'ValMeth',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'ValuationMethodCodeSet',
        updatedEP: '271',
        id: 1319,
        description: 'Specifies the method for price quotation.\n\nSee ValuationMethod(1197) for complete definition.',
    },
    {
        name: 'DerivativeListMethod',
        abbrName: 'ListMeth',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'ListMethodCodeSet',
        updatedEP: '271',
        id: 1320,
        description:
            'Indicates whether instruments are pre-listed only or can also be defined via user request.\n\nSee ListMethod(1198) for complete definition.',
    },
    {
        name: 'DerivativeCapPrice',
        abbrName: 'CapPx',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Price',
        updatedEP: '271',
        id: 1321,
        description:
            'Used to express the ceiling price of a capped call.\n\nSee CapPrice(1199) for complete definition.',
    },
    {
        name: 'DerivativeFloorPrice',
        abbrName: 'FlrPx',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Price',
        updatedEP: '271',
        id: 1322,
        description:
            'Used to express the floor price of a capped put.\n\nSee FloorPrice(1200) for complete definition.',
    },
    {
        name: 'DerivativePutOrCall',
        abbrName: 'PutCall',
        updated: 'FIX.Latest',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'PutOrCallCodeSet',
        updatedEP: '271',
        id: 1323,
        description:
            'Indicates whether an option contract is a put, call, chooser or undetermined.\n\nSee PutOrCall(201) for complete definition.',
    },
    {
        name: 'ListUpdateAction',
        abbrName: 'ListUpdActn',
        updated: 'FIX.5.0SP2',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'ListUpdateActionCodeSet',
        updatedEP: '128',
        id: 1324,
        description: 'If provided, then Instrument occurrence has explicitly changed',
    },
    {
        name: 'LegPutOrCall',
        abbrName: 'PutCall',
        updated: 'FIX.5.0SP2',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'PutOrCallCodeSet',
        updatedEP: '238',
        id: 1358,
        description: 'Indicates whether a leg option contract is a put, call, chooser or undetermined.',
    },
    {
        name: 'LegUnitOfMeasureQty',
        abbrName: 'UOMQty',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Qty',
        id: 1224,
        description: 'Refer to definition of UnitOfMeasureQty(1147)',
    },
    {
        name: 'LegPriceUnitOfMeasure',
        abbrName: 'PxUOM',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'UnitOfMeasureCodeSet',
        id: 1421,
        description: 'Refer to definition for PriceUnitOfMeasure(1191)',
    },
    {
        name: 'LegPriceUnitOfMeasureQty',
        abbrName: 'PxUOMQty',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Qty',
        id: 1422,
        description: 'Refer to definition of PriceUnitOfMeasureQty(1192)',
    },
    {
        name: 'UnderlyingUnitOfMeasureQty',
        abbrName: 'UOMQty',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Qty',
        id: 1423,
        description: 'Refer to definition of UnitOfMeasureQty(1147)',
    },
    {
        name: 'UnderlyingPriceUnitOfMeasure',
        abbrName: 'PxUOM',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'UnitOfMeasureCodeSet',
        id: 1424,
        description: 'Refer to definition for PriceUnitOfMeasure(1191)',
    },
    {
        name: 'UnderlyingPriceUnitOfMeasureQty',
        abbrName: 'PxUOMQty',
        addedEP: '52',
        added: 'FIX.5.0',
        type: 'Qty',
        id: 1425,
        description: 'Refer to definition of PriceUnitOfMeasureQty(1192)',
    },
    {
        name: 'MarketReqID',
        abbrName: 'MktReqID',
        addedEP: '53',
        added: 'FIX.5.0',
        type: 'String',
        id: 1393,
        description: 'Unique ID of a Market Definition Request message.',
    },
    {
        name: 'MarketReportID',
        abbrName: 'MktRptID',
        addedEP: '53',
        added: 'FIX.5.0',
        type: 'String',
        id: 1394,
        description: 'Market Definition message identifier.',
    },
    {
        name: 'MarketUpdateAction',
        abbrName: 'MktUpdtActn',
        addedEP: '53',
        added: 'FIX.5.0',
        type: 'SecurityUpdateActionCodeSet',
        id: 1395,
        description: 'Specifies the action taken for the specified MarketID(1301) + MarketSegmentID(1300).',
    },
    {
        name: 'MarketSegmentDesc',
        abbrName: 'MarketSegmentDesc',
        addedEP: '53',
        added: 'FIX.5.0',
        type: 'String',
        id: 1396,
        description: 'Description or name of Market Segment',
    },
    {
        name: 'EncodedMktSegmDescLen',
        abbrName: 'EncodedMktSegmDescLen',
        updated: 'FIX.5.0SP2',
        addedEP: '53',
        added: 'FIX.5.0',
        type: 'Length',
        updatedEP: '229',
        id: 1397,
        description: 'Byte length of encoded (non-ASCII characters) EncodedMktSegmDesc(1324) field.',
    },
    {
        name: 'EncodedMktSegmDesc',
        abbrName: 'EncodedMktSegmDesc',
        addedEP: '53',
        added: 'FIX.5.0',
        type: 'data',
        id: 1398,
        lengthId: '1397',
        description:
            'Encoded (non-ASCII characters) representation of the MarketSegmDesc(1396) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) representation should also be specified in the MarketSegmDesc field.',
    },
    {
        name: 'ParentMktSegmID',
        abbrName: 'ParentMktSegmID',
        addedEP: '53',
        added: 'FIX.5.0',
        type: 'String',
        id: 1325,
        description: 'Reference to a parent Market Segment. See MarketSegmentID(1300)',
    },
    {
        name: 'TradingSessionDesc',
        abbrName: 'TradingSessionDesc',
        addedEP: '53',
        added: 'FIX.5.0',
        type: 'String',
        id: 1326,
        description: 'Trading Session description',
    },
    {
        name: 'TradSesUpdateAction',
        abbrName: 'TradSesUpdtActn',
        addedEP: '53',
        added: 'FIX.5.0',
        type: 'SecurityUpdateActionCodeSet',
        id: 1327,
        description: 'Specifies the action taken for the specified trading sessions.',
    },
    {
        name: 'RejectText',
        abbrName: 'RejTxt',
        updated: 'FIX.5.0SP2',
        addedEP: '55',
        added: 'FIX.5.0',
        type: 'String',
        updatedEP: '103',
        id: 1328,
        description: 'Identifies the reason for rejection.',
    },
    {
        name: 'FeeMultiplier',
        abbrName: 'FeeMult',
        addedEP: '55',
        added: 'FIX.5.0',
        type: 'float',
        id: 1329,
        description:
            'This is a multiplier that Clearing (Fee system) will use to calculate fees and will be sent to the firms on their confirms.',
    },
    {
        deprecatedEP: '187',
        name: 'UnderlyingLegSymbol',
        abbrName: 'Sym',
        addedEP: '55',
        added: 'FIX.5.0',
        type: 'String',
        deprecated: 'FIX.5.0SP2',
        id: 1330,
        description: 'Refer to definition for Symbol(55)',
    },
    {
        deprecatedEP: '187',
        name: 'UnderlyingLegSymbolSfx',
        abbrName: 'Sfx',
        addedEP: '55',
        added: 'FIX.5.0',
        type: 'String',
        deprecated: 'FIX.5.0SP2',
        id: 1331,
        description: 'Refer to definition for SymbolSfx(65)',
    },
    {
        deprecatedEP: '187',
        name: 'UnderlyingLegSecurityID',
        abbrName: 'ID',
        addedEP: '55',
        added: 'FIX.5.0',
        type: 'String',
        deprecated: 'FIX.5.0SP2',
        id: 1332,
        discriminatorId: '1333',
        description: 'Refer to definition for SecurityID(48)',
    },
    {
        deprecatedEP: '187',
        name: 'UnderlyingLegSecurityIDSource',
        abbrName: 'Src',
        addedEP: '55',
        added: 'FIX.5.0',
        type: 'String',
        deprecated: 'FIX.5.0SP2',
        id: 1333,
        description: 'Refer to definition for SecurityIDSource(22)',
    },
    {
        deprecatedEP: '187',
        name: 'NoUnderlyingLegSecurityAltID',
        updated: 'FIX.Latest',
        addedEP: '55',
        added: 'FIX.5.0',
        type: 'NumInGroup',
        updatedEP: '294',
        deprecated: 'FIX.5.0SP2',
        id: 1334,
        description: 'Refer to definition for NoSecurityAltID(454)',
    },
    {
        deprecatedEP: '187',
        name: 'UnderlyingLegSecurityAltID',
        abbrName: 'AltID',
        addedEP: '55',
        added: 'FIX.5.0',
        type: 'String',
        deprecated: 'FIX.5.0SP2',
        id: 1335,
        discriminatorId: '1336',
        description: 'Refer to definition for SecurityAltID(455)',
    },
    {
        deprecatedEP: '187',
        name: 'UnderlyingLegSecurityAltIDSource',
        abbrName: 'AltIDSrc',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.Latest',
        addedEP: '55',
        added: 'FIX.5.0',
        type: 'String',
        updatedEP: '271',
        deprecated: 'FIX.5.0SP2',
        id: 1336,
        description: 'Refer to definition for SecurityAltIDSource(456)',
    },
    {
        deprecatedEP: '187',
        name: 'UnderlyingLegSecurityType',
        abbrName: 'SecType',
        addedEP: '55',
        added: 'FIX.5.0',
        type: 'String',
        deprecated: 'FIX.5.0SP2',
        id: 1337,
        description: 'Refer to definition for SecurityType(167)',
    },
    {
        deprecatedEP: '187',
        name: 'UnderlyingLegSecuritySubType',
        abbrName: 'SubType',
        addedEP: '55',
        added: 'FIX.5.0',
        type: 'String',
        deprecated: 'FIX.5.0SP2',
        id: 1338,
        description: 'Refer to definition for SecuritySubType(762)',
    },
    {
        deprecatedEP: '187',
        name: 'UnderlyingLegMaturityMonthYear',
        abbrName: 'MMY',
        addedEP: '55',
        added: 'FIX.5.0',
        type: 'MonthYear',
        deprecated: 'FIX.5.0SP2',
        id: 1339,
        description: 'Refer to definition for MaturityMonthYear(200)',
    },
    {
        deprecatedEP: '187',
        name: 'UnderlyingLegPutOrCall',
        abbrName: 'PutCall',
        addedEP: '55',
        added: 'FIX.5.0',
        type: 'int',
        deprecated: 'FIX.5.0SP2',
        id: 1343,
        description: 'Refer to definition for PutOrCall(201)',
    },
    {
        deprecatedEP: '187',
        name: 'UnderlyingLegStrikePrice',
        abbrName: 'StrkPx',
        addedEP: '55',
        added: 'FIX.5.0',
        type: 'Price',
        deprecated: 'FIX.5.0SP2',
        id: 1340,
        description: 'Refer to definition for StrikePrice(202)',
    },
    {
        deprecatedEP: '187',
        name: 'UnderlyingLegSecurityExchange',
        abbrName: 'Exch',
        addedEP: '55',
        added: 'FIX.5.0',
        type: 'String',
        deprecated: 'FIX.5.0SP2',
        id: 1341,
        description: 'Refer to definition for SecurityExchange(207)',
    },
    {
        deprecatedEP: '187',
        name: 'NoOfLegUnderlyings',
        updated: 'FIX.Latest',
        addedEP: '55',
        added: 'FIX.5.0',
        type: 'NumInGroup',
        updatedEP: '294',
        deprecated: 'FIX.5.0SP2',
        id: 1342,
        description: 'Number of Underlyings, Identifies the Underlying of the Leg',
    },
    {
        deprecatedEP: '187',
        name: 'UnderlyingLegCFICode',
        abbrName: 'CFI',
        addedEP: '55',
        added: 'FIX.5.0',
        type: 'String',
        deprecated: 'FIX.5.0SP2',
        id: 1344,
        description: 'Refer to definition for CFICode(461)',
    },
    {
        deprecatedEP: '187',
        name: 'UnderlyingLegMaturityDate',
        abbrName: 'MatDt',
        addedEP: '55',
        added: 'FIX.5.0',
        type: 'LocalMktDate',
        deprecated: 'FIX.5.0SP2',
        id: 1345,
        description: 'Date of maturity.',
    },
    {
        deprecatedEP: '187',
        name: 'UnderlyingLegMaturityTime',
        abbrName: 'MatTm',
        addedEP: '55',
        added: 'FIX.5.0',
        type: 'TZTimeOnly',
        deprecated: 'FIX.5.0SP2',
        id: 1405,
        description: "Time of security's maturity expressed in local time with offset to UTC specified",
    },
    {
        deprecatedEP: '187',
        name: 'UnderlyingLegOptAttribute',
        abbrName: 'OptAt',
        addedEP: '55',
        added: 'FIX.5.0',
        type: 'char',
        deprecated: 'FIX.5.0SP2',
        id: 1391,
        description: 'Refer to definition of OptAttribute(206)',
    },
    {
        deprecatedEP: '187',
        name: 'UnderlyingLegSecurityDesc',
        abbrName: 'Desc',
        addedEP: '55',
        added: 'FIX.5.0',
        type: 'String',
        deprecated: 'FIX.5.0SP2',
        id: 1392,
        description: 'Refer to definition of SecurityDesc(107)',
    },
    {
        name: 'EncryptedPasswordMethod',
        abbrName: 'EncPwdMethod',
        unionDataType: 'Reserved100Plus',
        addedEP: '56',
        added: 'FIX.5.0',
        type: 'int',
        id: 1400,
        description:
            'Enumeration defining the encryption method used to encrypt password fields.\n\nAt this time there are no encryption methods defined by FPL.',
    },
    {
        name: 'EncryptedPasswordLen',
        abbrName: 'EncPwdLen',
        updated: 'FIX.5.0SP2',
        addedEP: '56',
        added: 'FIX.5.0',
        type: 'Length',
        updatedEP: '208',
        id: 1401,
        description: 'Length of the EncryptedPassword(1402) field',
    },
    {
        name: 'EncryptedPassword',
        abbrName: 'EncPwd',
        addedEP: '56',
        added: 'FIX.5.0',
        type: 'data',
        id: 1402,
        lengthId: '1401',
        description:
            'Encrypted password - encrypted via the method specified in the field EncryptedPasswordMethod(1400)',
    },
    {
        name: 'EncryptedNewPasswordLen',
        abbrName: 'EncNewPwdLen',
        updated: 'FIX.5.0SP2',
        addedEP: '56',
        added: 'FIX.5.0',
        type: 'Length',
        updatedEP: '208',
        id: 1403,
        description: 'Length of the EncryptedNewPassword(1404) field',
    },
    {
        name: 'EncryptedNewPassword',
        abbrName: 'EncNewPwd',
        addedEP: '56',
        added: 'FIX.5.0',
        type: 'data',
        id: 1404,
        lengthId: '1403',
        description:
            'Encrypted new password - encrypted via the method specified in the field EncryptedPasswordMethod(1400)',
    },
    {
        name: 'ApplExtID',
        abbrName: 'ApplExtID',
        addedEP: '56',
        added: 'FIX.5.0',
        type: 'int',
        id: 1156,
        description: 'The extension pack number associated with an application message.',
    },
    {
        name: 'RefApplExtID',
        abbrName: 'RefApplExtID',
        addedEP: '56',
        added: 'FIX.5.0',
        type: 'int',
        id: 1406,
        description: 'The extension pack number associated with an application message.',
    },
    {
        name: 'DefaultApplExtID',
        abbrName: 'DfltApplExtID',
        addedEP: '56',
        added: 'FIX.5.0',
        type: 'int',
        id: 1407,
        description: 'The extension pack number that is the default for a FIX session.',
    },
    {
        name: 'DefaultCstmApplVerID',
        abbrName: 'DefaultCstmApplVerID',
        addedEP: '56',
        added: 'FIX.5.0',
        type: 'String',
        id: 1408,
        description: 'The default custom application version ID that is the default for a session.',
    },
    {
        name: 'SessionStatus',
        abbrName: 'SessStat',
        unionDataType: 'Reserved100Plus',
        addedEP: '56',
        added: 'FIX.5.0',
        type: 'SessionStatusCodeSet',
        id: 1409,
        description: 'Status of a FIX session',
    },
    {
        name: 'DefaultVerIndicator',
        abbrName: 'DfltVerInd',
        updated: 'FIX.Latest',
        addedEP: '56',
        added: 'FIX.5.0',
        type: 'Boolean',
        updatedEP: '275',
        id: 1410,
        description:
            'Indicates that the application version identified in the fields RefApplVerID(1130), RefApplExtID(1406), and RefCstmApplVerID(1131) is the default for the message type identified in RefMsgType(372) field.',
    },
    {
        name: 'NoUsernames',
        updated: 'FIX.Latest',
        added: 'FIX.4.4',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 809,
        description: 'Number of Usernames to which this this response is directed',
    },
    {
        name: 'LegAllocSettlCurrency',
        abbrName: 'AllocSettlCcy',
        addedEP: '58',
        added: 'FIX.5.0',
        type: 'Currency',
        id: 1367,
        description: 'Identifies settlement currency for the leg level allocation.',
    },
    {
        name: 'TotNoFills',
        abbrName: 'TotNoFills',
        addedEP: '58',
        added: 'FIX.5.0',
        type: 'int',
        id: 1361,
        description:
            'Total number of fill entries across all messages. Should be the sum of all NoFills(1362) in each message that has repeating list of fill entries related to the same ExecID(17). Used to support fragmentation.',
    },
    {
        name: 'NoFills',
        updated: 'FIX.Latest',
        addedEP: '58',
        added: 'FIX.5.0',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 1362,
        description: '',
    },
    {
        name: 'FillExecID',
        abbrName: 'FillExecID',
        addedEP: '58',
        added: 'FIX.5.0',
        type: 'String',
        id: 1363,
        description:
            'Refer to ExecID(17). Used when multiple partial fills are reported in single Execution Report. ExecID and FillExecID should not overlap,',
    },
    {
        name: 'FillPx',
        abbrName: 'FillPx',
        addedEP: '58',
        added: 'FIX.5.0',
        type: 'Price',
        id: 1364,
        description: 'Price of Fill. Refer to LastPx(31).',
    },
    {
        name: 'FillQty',
        abbrName: 'FillQty',
        addedEP: '58',
        added: 'FIX.5.0',
        type: 'Qty',
        id: 1365,
        description: 'Quantity of Fill. Refer to LastQty(32).',
    },
    {
        name: 'LegAllocID',
        abbrName: 'LegAllocID',
        addedEP: '58',
        added: 'FIX.5.0',
        type: 'String',
        id: 1366,
        description: 'The AllocID(70) of an individual leg of a multileg order.',
    },
    {
        name: 'TradSesEvent',
        abbrName: 'TradSesEvent',
        unionDataType: 'Reserved100Plus',
        addedEP: '58',
        added: 'FIX.5.0',
        type: 'TradSesEventCodeSet',
        id: 1368,
        description:
            'Identifies an event related to a TradSesStatus(340). An event occurs and is gone, it is not a state that applies for a period of time.',
    },
    {
        name: 'MassActionReportID',
        abbrName: 'MassActionReportID',
        addedEP: '58',
        added: 'FIX.5.0',
        type: 'String',
        id: 1369,
        description:
            'Unique identifier of Order Mass Cancel Report or Order Mass Action Report message as assigned by sell-side (broker, exchange, ECN)',
    },
    {
        name: 'NoNotAffectedOrders',
        updated: 'FIX.Latest',
        addedEP: '58',
        added: 'FIX.5.0',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 1370,
        description: 'Number of not affected orders in the repeating group of order ids.',
    },
    {
        name: 'NotAffectedOrderID',
        abbrName: 'OrdID',
        updated: 'FIX.5.0SP2',
        addedEP: '58',
        added: 'FIX.5.0',
        type: 'String',
        updatedEP: '131',
        id: 1371,
        description: 'OrderID(37) of an order not affected by a mass cancel or mass action request.',
    },
    {
        name: 'NotAffOrigClOrdID',
        abbrName: 'OrigClOrdID',
        updated: 'FIX.5.0SP2',
        addedEP: '58',
        added: 'FIX.5.0',
        type: 'String',
        updatedEP: '131',
        id: 1372,
        description: 'ClOrdID(11) of an order not affected by a mass cancel or mass action request.',
    },
    {
        name: 'MassActionType',
        abbrName: 'MassActionType',
        addedEP: '58',
        added: 'FIX.5.0',
        type: 'MassActionTypeCodeSet',
        id: 1373,
        description: 'Specifies the type of action requested',
    },
    {
        name: 'MassActionScope',
        abbrName: 'MassActionScope',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.5.0SP1',
        addedEP: '58',
        added: 'FIX.5.0',
        type: 'MassActionScopeCodeSet',
        updatedEP: '85',
        id: 1374,
        description: 'Specifies scope of Order Mass Action Request.',
    },
    {
        name: 'MassActionResponse',
        abbrName: 'MassActionResponse',
        addedEP: '58',
        added: 'FIX.5.0',
        type: 'MassActionResponseCodeSet',
        id: 1375,
        description:
            'Specifies the action taken by counterparty order handling system as a result of the action type indicated in MassActionType of the Order Mass Action Request.',
    },
    {
        name: 'MassActionRejectReason',
        abbrName: 'MassActionRejectReason',
        unionDataType: 'Reserved100Plus',
        addedEP: '58',
        added: 'FIX.5.0',
        type: 'MassActionRejectReasonCodeSet',
        id: 1376,
        description: 'Reason Order Mass Action Request was rejected',
    },
    {
        name: 'MultilegModel',
        abbrName: 'MlegModel',
        updated: 'FIX.5.0SP2',
        addedEP: '59',
        added: 'FIX.5.0',
        type: 'MultilegModelCodeSet',
        updatedEP: '195',
        id: 1377,
        description:
            'Specifies the type of multileg order. Defines whether the security is pre-defined or user-defined. Note that MultilegModel(1377)=2(User-defined, Non-Securitized, Multileg) does not apply for Securities.',
    },
    {
        name: 'MultilegPriceMethod',
        abbrName: 'MlegPxMeth',
        addedEP: '59',
        added: 'FIX.5.0',
        type: 'MultilegPriceMethodCodeSet',
        id: 1378,
        description:
            'Code to represent how the multileg price is to be interpreted when applied to the legs.\n\n(See Volume : "Glossary" for further value definitions)',
    },
    {
        name: 'LegVolatility',
        abbrName: 'LegVolatility',
        addedEP: '59',
        added: 'FIX.5.0',
        type: 'float',
        id: 1379,
        description: 'Specifies the volatility of an instrument leg.',
    },
    {
        name: 'DividendYield',
        abbrName: 'DividendYield',
        addedEP: '59',
        added: 'FIX.5.0',
        type: 'Percentage',
        id: 1380,
        description:
            'The continuously-compounded annualized dividend yield of the underlying(s) of an option. Used as a parameter to theoretical option pricing models.',
    },
    {
        name: 'LegDividendYield',
        abbrName: 'LegDividendYield',
        addedEP: '59',
        added: 'FIX.5.0',
        type: 'Percentage',
        id: 1381,
        description: 'Refer to definition for DividendYield(1380).',
    },
    {
        name: 'CurrencyRatio',
        abbrName: 'CurrencyRatio',
        addedEP: '59',
        added: 'FIX.5.0',
        type: 'float',
        id: 1382,
        description:
            'Specifies the currency ratio between the currency used for a multileg price and the currency used by the outright book defined by the leg. Example: Multileg quoted in EUR, outright leg in USD and 1 EUR = 0,7 USD then CurrencyRatio = 0.7',
    },
    {
        name: 'LegCurrencyRatio',
        abbrName: 'LegCurrencyRatio',
        addedEP: '59',
        added: 'FIX.5.0',
        type: 'float',
        id: 1383,
        description:
            'Specifies the currency ratio between the currency used for a multileg price and the currency used by the outright book defined by the leg. Example: Multileg quoted in EUR, outright leg in USD and 1 EUR = 0,7 USD then LegCurrencyRatio = 0.7',
    },
    {
        name: 'LegExecInst',
        abbrName: 'LegExecInst',
        addedEP: '59',
        added: 'FIX.5.0',
        type: 'ExecInstCodeSet',
        id: 1384,
        description: 'Refer to ExecInst(18)\n\nSame values as ExecInst(18)',
    },
    {
        name: 'ContingencyType',
        abbrName: 'ContingencyType',
        unionDataType: 'Reserved100Plus',
        addedEP: '60',
        added: 'FIX.5.0',
        type: 'ContingencyTypeCodeSet',
        id: 1385,
        description: 'Defines the type of contingency.',
    },
    {
        name: 'ListRejectReason',
        abbrName: 'ListRejectReason',
        unionDataType: 'Reserved100Plus',
        addedEP: '60',
        added: 'FIX.5.0',
        type: 'ListRejectReasonCodeSet',
        id: 1386,
        description:
            'Identifies the reason for rejection of a New Order List message. Note that OrdRejReason(103) is used if the rejection is based on properties of an individual order part of the List.',
    },
    {
        name: 'NoTrdRepIndicators',
        updated: 'FIX.Latest',
        addedEP: '61',
        added: 'FIX.5.0',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 1387,
        description: 'Number of trade reporting indicators',
    },
    {
        name: 'TrdRepPartyRole',
        abbrName: 'PtyRole',
        addedEP: '61',
        added: 'FIX.5.0',
        type: 'PartyRoleCodeSet',
        id: 1388,
        description: 'Identifies the type of party for trade reporting. Same values as PartyRole(452).',
    },
    {
        name: 'TrdRepIndicator',
        abbrName: 'TrdRepInd',
        addedEP: '61',
        added: 'FIX.5.0',
        type: 'Boolean',
        id: 1389,
        description:
            'Specifies whether the trade should be reported (or not) to parties of the provided TrdRepPartyRole(1388). Used to override standard reporting behavior by the receiver of the trade report and thereby complements the PublTrdIndicator( tag1390).',
    },
    {
        name: 'TradePublishIndicator',
        abbrName: 'TrdPubInd',
        updated: 'FIX.5.0SP2',
        addedEP: '61',
        added: 'FIX.5.0',
        type: 'TradePublishIndicatorCodeSet',
        updatedEP: '229',
        id: 1390,
        description:
            'Indicates if a trade should be or has been published via a market publication service. The indicator governs all publication services of the recipient. Replaces PublishTrdIndicator(852).',
    },
    {
        name: 'ApplReqID',
        abbrName: 'ApplReqID',
        addedEP: '63',
        added: 'FIX.5.0',
        type: 'String',
        id: 1346,
        description: 'Unique identifier for request',
    },
    {
        name: 'ApplReqType',
        abbrName: 'ApplReqTyp',
        addedEP: '63',
        added: 'FIX.5.0',
        type: 'ApplReqTypeCodeSet',
        id: 1347,
        description: 'Type of Application Message Request being made.',
    },
    {
        name: 'ApplResponseType',
        abbrName: 'ApplRespTyp',
        addedEP: '63',
        added: 'FIX.5.0',
        type: 'ApplResponseTypeCodeSet',
        id: 1348,
        description: 'Used to indicate the type of acknowledgement being sent.',
    },
    {
        name: 'ApplTotalMessageCount',
        abbrName: 'ApplTotMsgCnt',
        addedEP: '63',
        added: 'FIX.5.0',
        type: 'int',
        id: 1349,
        description: 'Total number of messages included in transmission.',
    },
    {
        name: 'ApplLastSeqNum',
        abbrName: 'ApplLastSeqNum',
        addedEP: '63',
        added: 'FIX.5.0',
        type: 'SeqNum',
        id: 1350,
        description: 'Application sequence number of last message in transmission',
    },
    {
        name: 'NoApplIDs',
        updated: 'FIX.Latest',
        addedEP: '63',
        added: 'FIX.5.0',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 1351,
        description: 'Specifies number of application id occurrences',
    },
    {
        name: 'ApplResendFlag',
        abbrName: 'ApplResendFlag',
        addedEP: '63',
        added: 'FIX.5.0',
        type: 'Boolean',
        id: 1352,
        description:
            "Used to indicate that a message is being sent in response to an Application Message Request. It is possible for both ApplResendFlag and PossDupFlag to be set on the same message if the Sender's cache size is greater than zero and the message is being resent due to a session level resend request",
    },
    {
        name: 'ApplResponseID',
        abbrName: 'ApplRespID',
        addedEP: '63',
        added: 'FIX.5.0',
        type: 'String',
        id: 1353,
        description: 'Identifier for the Applicaton Message Request Ack',
    },
    {
        name: 'ApplResponseError',
        abbrName: 'ApplRespErr',
        addedEP: '63',
        added: 'FIX.5.0',
        type: 'ApplResponseErrorCodeSet',
        id: 1354,
        description: 'Used to return an error code or text associated with a response to an Application Request.',
    },
    {
        name: 'RefApplID',
        abbrName: 'RefApplID',
        addedEP: '63',
        added: 'FIX.5.0',
        type: 'String',
        id: 1355,
        description:
            'Reference to the unique application identifier which corresponds to ApplID(1180) from the Application Sequence Group component',
    },
    {
        name: 'ApplReportID',
        abbrName: 'ApplRptID',
        addedEP: '63',
        added: 'FIX.5.0',
        type: 'String',
        id: 1356,
        description: 'Identifier for the Application Sequence Reset',
    },
    {
        name: 'RefApplLastSeqNum',
        abbrName: 'RefApplLastSeqNum',
        addedEP: '63',
        added: 'FIX.5.0',
        type: 'SeqNum',
        id: 1357,
        description: 'Application sequence number of last message in transmission.',
    },
    {
        name: 'ApplNewSeqNum',
        abbrName: 'ApplNewSeqNum',
        addedEP: '63',
        added: 'FIX.5.0',
        type: 'SeqNum',
        id: 1399,
        description: 'Used to specify a new application sequence number.',
    },
    {
        name: 'ApplReportType',
        abbrName: 'ApplRptTyp',
        added: 'FIX.5.0SP2',
        type: 'ApplReportTypeCodeSet',
        id: 1426,
        description: 'Type of report',
    },
    {
        name: 'Nested4PartySubIDType',
        abbrName: 'Typ',
        unionDataType: 'Reserved4000Plus',
        updated: 'FIX.Latest',
        addedEP: '69',
        added: 'FIX.5.0',
        type: 'PartySubIDTypeCodeSet',
        updatedEP: '294',
        id: 1411,
        description: 'Refer to definition of PartySubIDType(803)',
    },
    {
        name: 'Nested4PartySubID',
        abbrName: 'ID',
        addedEP: '69',
        added: 'FIX.5.0',
        type: 'String',
        id: 1412,
        description: 'Refer to definition of PartySubID(523)',
    },
    {
        name: 'NoNested4PartySubIDs',
        updated: 'FIX.Latest',
        addedEP: '69',
        added: 'FIX.5.0',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 1413,
        description: 'Refer to definition of NoPartySubIDs(802)',
    },
    {
        name: 'NoNested4PartyIDs',
        updated: 'FIX.Latest',
        addedEP: '69',
        added: 'FIX.5.0',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 1414,
        description: 'Refer to definition of NoPartyIDs(453)',
    },
    {
        name: 'Nested4PartyID',
        abbrName: 'ID',
        addedEP: '69',
        added: 'FIX.5.0',
        type: 'String',
        id: 1415,
        discriminatorId: '1416',
        description: 'Refer to definition of PartyID(448)',
    },
    {
        name: 'Nested4PartyIDSource',
        abbrName: 'Src',
        addedEP: '69',
        added: 'FIX.5.0',
        type: 'PartyIDSourceCodeSet',
        id: 1416,
        description: 'Refer to definition of PartyIDSource(447)',
    },
    {
        name: 'Nested4PartyRole',
        abbrName: 'R',
        addedEP: '69',
        added: 'FIX.5.0',
        type: 'PartyRoleCodeSet',
        id: 1417,
        description: 'Refer to definition of PartyRole(452)',
    },
    {
        name: 'LegLastQty',
        abbrName: 'LastQty',
        addedEP: '72',
        added: 'FIX.5.0',
        type: 'Qty',
        id: 1418,
        description: 'Fill quantity for the leg instrument',
    },
    {
        name: 'SideExecID',
        abbrName: 'SideExecID',
        addedEP: '77',
        added: 'FIX.5.0SP1',
        type: 'String',
        id: 1427,
        description:
            'When reporting trades, used to reference the identifier of the execution (ExecID) being reported if different ExecIDs were assigned to each side of the trade.',
    },
    {
        name: 'OrderDelay',
        abbrName: 'OrdDelay',
        addedEP: '77',
        added: 'FIX.5.0SP1',
        type: 'int',
        id: 1428,
        description:
            'Time lapsed from order entry until match, based on the unit of time specified in OrderDelayUnit. Default is seconds if OrderDelayUnit is not specified. Value = 0, indicates the aggressor (the initiating side of the trade).',
    },
    {
        name: 'OrderDelayUnit',
        abbrName: 'OrdDelayUnit',
        unionDataType: 'Reserved100Plus',
        addedEP: '77',
        added: 'FIX.5.0SP1',
        type: 'OrderDelayUnitCodeSet',
        id: 1429,
        description: 'Time unit in which the OrderDelay(1428) is expressed',
    },
    {
        name: 'VenueType',
        abbrName: 'VenuTyp',
        updated: 'FIX.Latest',
        addedEP: '77',
        added: 'FIX.5.0SP1',
        type: 'VenueTypeCodeSet',
        updatedEP: '286',
        id: 1430,
        description: 'Identifies the type of venue where a trade was executed.',
    },
    {
        name: 'RefOrdIDReason',
        abbrName: 'RefOrdIDRsn',
        unionDataType: 'Reserved100Plus',
        addedEP: '77',
        added: 'FIX.5.0SP1',
        type: 'RefOrdIDReasonCodeSet',
        id: 1431,
        description: 'The reason for updating the RefOrdID',
    },
    {
        name: 'OrigCustOrderCapacity',
        abbrName: 'OrigCustOrdCpcty',
        addedEP: '77',
        added: 'FIX.5.0SP1',
        type: 'OrigCustOrderCapacityCodeSet',
        id: 1432,
        description:
            'The customer capacity for this trade at the time of the order/execution.\n\nPrimarily used by futures exchanges to indicate the CTICode (customer type indicator) as required by the US CFTC (Commodity Futures Trading Commission).',
    },
    {
        name: 'RefApplReqID',
        abbrName: 'RefID',
        addedEP: '78',
        added: 'FIX.5.0SP1',
        type: 'String',
        id: 1433,
        description:
            'Used to reference a previously submitted ApplReqID (1346) from within a subsequent ApplicationMessageRequest(MsgType=BW)',
    },
    {
        name: 'ModelType',
        abbrName: 'ModelTyp',
        addedEP: '79',
        added: 'FIX.5.0SP1',
        type: 'ModelTypeCodeSet',
        id: 1434,
        description: 'Type of pricing model used',
    },
    {
        name: 'ContractMultiplierUnit',
        abbrName: 'MultTyp',
        addedEP: '80',
        added: 'FIX.5.0SP1',
        type: 'ContractMultiplierUnitCodeSet',
        id: 1435,
        description:
            'Indicates the type of multiplier being applied to the contract. Can be optionally used to further define what unit ContractMultiplier(tag 231) is expressed in.',
    },
    {
        name: 'LegContractMultiplierUnit',
        abbrName: 'MultTyp',
        updated: 'FIX.Latest',
        addedEP: '80',
        added: 'FIX.5.0SP1',
        type: 'ContractMultiplierUnitCodeSet',
        updatedEP: '271',
        id: 1436,
        description:
            'Indicates the type of multiplier being applied to the contract. Can be optionally used to further define what unit LegContractMultiplier(614) is expressed in.',
    },
    {
        name: 'UnderlyingContractMultiplierUnit',
        abbrName: 'MultTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '80',
        added: 'FIX.5.0SP1',
        type: 'ContractMultiplierUnitCodeSet',
        updatedEP: '204',
        id: 1437,
        description:
            'Indicates the type of multiplier being applied to the contract.\n\nCan be optionally used to further define what unit UnderlyingContractMultiplier(436) is expressed in.',
    },
    {
        name: 'DerivativeContractMultiplierUnit',
        abbrName: 'MultTyp',
        updated: 'FIX.Latest',
        addedEP: '80',
        added: 'FIX.5.0SP1',
        type: 'ContractMultiplierUnitCodeSet',
        updatedEP: '271',
        id: 1438,
        description:
            'Indicates the type of multiplier being applied to the contract. Can be optionally used to further define what unit DerivativeContractMultiplier(1266)is expressed in.\n\nSee ContractMultiplierUnit(1435) for complete definition.',
    },
    {
        name: 'FlowScheduleType',
        abbrName: 'FlowSchedTyp',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.5.0SP2',
        addedEP: '80',
        added: 'FIX.5.0SP1',
        type: 'FlowScheduleTypeCodeSet',
        updatedEP: '238',
        id: 1439,
        description:
            'The industry standard flow schedule by which electricity or natural gas is traded. Schedules may exist by regions and on-peak and off-peak status, such as "Western Peak".',
    },
    {
        name: 'LegFlowScheduleType',
        abbrName: 'FlowSchedTyp',
        unionDataType: 'Reserved100Plus',
        addedEP: '80',
        added: 'FIX.5.0SP1',
        type: 'FlowScheduleTypeCodeSet',
        id: 1440,
        description:
            'The industry standard flow schedule by which electricity or natural gas is traded. Schedules exist by regions and on-peak and off-peak status, such as "Western Peak".',
    },
    {
        name: 'UnderlyingFlowScheduleType',
        abbrName: 'FlowSchedTyp',
        unionDataType: 'Reserved100Plus',
        addedEP: '80',
        added: 'FIX.5.0SP1',
        type: 'FlowScheduleTypeCodeSet',
        id: 1441,
        description:
            'The industry standard flow schedule by which electricity or natural gas is traded. Schedules exist by regions and on-peak and off-peak status, such as "Western Peak".',
    },
    {
        name: 'DerivativeFlowScheduleType',
        abbrName: 'FlowSchedTyp',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.Latest',
        addedEP: '80',
        added: 'FIX.5.0SP1',
        type: 'FlowScheduleTypeCodeSet',
        updatedEP: '271',
        id: 1442,
        description:
            'The industry standard flow schedule by which electricity or natural gas is traded. Schedules exist by regions and on-peak and off-peak status, such as "Western Peak".\n\nSee FlowScheduleType(1439) for complete definition.',
    },
    {
        name: 'FillLiquidityInd',
        abbrName: 'LqdtyInd',
        addedEP: '81',
        added: 'FIX.5.0SP1',
        type: 'LastLiquidityIndCodeSet',
        id: 1443,
        description:
            'Indicator to identify whether this fill was a result of a liquidity provider providing or liquidity taker taking the liquidity. Applicable only for OrdStatus of Partial or Filled',
    },
    {
        name: 'SideLiquidityInd',
        abbrName: 'LqdtyInd',
        addedEP: '81',
        added: 'FIX.5.0SP1',
        type: 'LastLiquidityIndCodeSet',
        id: 1444,
        description:
            'Indicator to identify whether this fill was a result of a liquidity provider providing or liquidity taker taking the liquidity. Applicable only for OrdStatus of Partial or Filled.',
    },
    {
        name: 'NoRateSources',
        updated: 'FIX.Latest',
        addedEP: '82',
        added: 'FIX.5.0SP1',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 1445,
        description: 'Number of rate sources being specified.',
    },
    {
        name: 'RateSource',
        abbrName: 'RtSrc',
        updated: 'FIX.Latest',
        addedEP: '82',
        added: 'FIX.5.0SP1',
        type: 'RateSourceCodeSet',
        updatedEP: '293',
        id: 1446,
        description:
            'Identifies the source of rate information.\n\nFor FX, the reference source to be used for the FX spot rate.\n\nThis is where to look up the rate information and is not necessarily the entity that sets the rate.',
    },
    {
        name: 'RateSourceType',
        abbrName: 'RtSrcTyp',
        addedEP: '82',
        added: 'FIX.5.0SP1',
        type: 'RateSourceTypeCodeSet',
        id: 1447,
        description: 'Indicates whether the rate source specified is a primary or secondary source.',
    },
    {
        name: 'ReferencePage',
        abbrName: 'RefPg',
        updated: 'FIX.5.0SP2',
        addedEP: '82',
        added: 'FIX.5.0SP1',
        type: 'String',
        updatedEP: '161',
        id: 1448,
        description:
            'Identifies the reference "page" from the rate source.\n\nFor FX, the reference page to the spot rate to be used for the reference FX spot rate.\n\nWhen RateSource(1446) = 3 (ISDA Settlement Rate Option) this contains the value from the scheme that reflects the terms of the Annex A to the ISDA 1998 FX and Currency Option Definitions. See: http://www.fpml.org/coding-scheme/settlement-rate-option',
    },
    {
        name: 'RestructuringType',
        abbrName: 'RestrctTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '83',
        added: 'FIX.5.0SP1',
        type: 'RestructuringTypeCodeSet',
        updatedEP: '169',
        id: 1449,
        description:
            'A category of CDS credit event in which the underlying bond experiences a restructuring.\n\nUsed to define a CDS instrument.',
    },
    {
        name: 'Seniority',
        abbrName: 'Snrty',
        updated: 'FIX.5.0SP2',
        addedEP: '83',
        added: 'FIX.5.0SP1',
        type: 'SeniorityCodeSet',
        updatedEP: '235',
        id: 1450,
        description:
            'Specifies which issue (underlying bond) will receive payment priority in the event of a default.\n\nUsed to define a CDS instrument.\n\nThe payment priority is this: Senior Secured (SD), Senior (SR), Senior Non-Preferred (SN), Subordinated (SB), Mezzanine (MZ), Junior (JR).',
    },
    {
        name: 'NotionalPercentageOutstanding',
        abbrName: 'NotlPctOut',
        addedEP: '83',
        added: 'FIX.5.0SP1',
        type: 'Percentage',
        id: 1451,
        description:
            'Indicates the notional percentage of the deal that is still outstanding based on the remaining components of the index.\n\nUsed to calculate the true value of a CDS trade or position.',
    },
    {
        name: 'OriginalNotionalPercentageOutstanding',
        abbrName: 'OrigNotlPctOut',
        addedEP: '83',
        added: 'FIX.5.0SP1',
        type: 'Percentage',
        id: 1452,
        description:
            'Used to reflect the Original value prior to the application of a credit event. See NotionalPercentageOutstanding(1451).',
    },
    {
        name: 'UnderlyingRestructuringType',
        abbrName: 'RestrctTyp',
        addedEP: '83',
        added: 'FIX.5.0SP1',
        type: 'RestructuringTypeCodeSet',
        id: 1453,
        description: 'See RestructuringType(1449)',
    },
    {
        name: 'UnderlyingSeniority',
        abbrName: 'Snrty',
        addedEP: '83',
        added: 'FIX.5.0SP1',
        type: 'SeniorityCodeSet',
        id: 1454,
        description: 'See Seniority(1450)',
    },
    {
        name: 'UnderlyingNotionalPercentageOutstanding',
        abbrName: 'NotlPctOut',
        addedEP: '83',
        added: 'FIX.5.0SP1',
        type: 'Percentage',
        id: 1455,
        description: 'See NotionalPercentageOutstanding(1451)',
    },
    {
        name: 'UnderlyingOriginalNotionalPercentageOutstanding',
        abbrName: 'OrigNotlPctOut',
        addedEP: '83',
        added: 'FIX.5.0SP1',
        type: 'Percentage',
        id: 1456,
        description: 'See OriginalNotionalPercentageOutstanding(1452)',
    },
    {
        name: 'AttachmentPoint',
        abbrName: 'AttchPnt',
        addedEP: '83',
        added: 'FIX.5.0SP1',
        type: 'Percentage',
        id: 1457,
        description: 'Lower bound percentage of the loss that the tranche can endure.',
    },
    {
        name: 'DetachmentPoint',
        abbrName: 'DetchPnt',
        addedEP: '83',
        added: 'FIX.5.0SP1',
        type: 'Percentage',
        id: 1458,
        description: 'Upper bound percentage of the loss the tranche can endure.',
    },
    {
        name: 'UnderlyingAttachmentPoint',
        abbrName: 'AttchPnt',
        addedEP: '83',
        added: 'FIX.5.0SP1',
        type: 'Percentage',
        id: 1459,
        description: 'See AttachmentPoint(1457).',
    },
    {
        name: 'UnderlyingDetachmentPoint',
        abbrName: 'DetchPnt',
        addedEP: '83',
        added: 'FIX.5.0SP1',
        type: 'Percentage',
        id: 1460,
        description: 'See DetachmentPoint(1458).',
    },
    {
        name: 'NoTargetPartyIDs',
        addedEP: '85',
        added: 'FIX.5.0SP1',
        type: 'NumInGroup',
        id: 1461,
        description: 'Identifies the number of target parties identified in a mass action.',
    },
    {
        name: 'TargetPartyID',
        abbrName: 'ID',
        addedEP: '85',
        added: 'FIX.5.0SP1',
        type: 'String',
        id: 1462,
        discriminatorId: '1463',
        description: 'PartyID value within an target party repeating group.',
    },
    {
        name: 'TargetPartyIDSource',
        abbrName: 'Src',
        addedEP: '85',
        added: 'FIX.5.0SP1',
        type: 'PartyIDSourceCodeSet',
        id: 1463,
        description:
            'PartyIDSource value within an target party repeating group.\n\nSame values as PartyIDSource (447)',
    },
    {
        name: 'TargetPartyRole',
        abbrName: 'R',
        addedEP: '85',
        added: 'FIX.5.0SP1',
        type: 'PartyRoleCodeSet',
        id: 1464,
        description: 'PartyRole value within an target party repeating group.\n\nSame values as PartyRole (452)',
    },
    {
        name: 'SecurityListID',
        abbrName: 'ListID',
        addedEP: '87',
        added: 'FIX.5.0SP1',
        type: 'String',
        id: 1465,
        description: 'Specifies an identifier for a Security List',
    },
    {
        name: 'SecurityListRefID',
        abbrName: 'ListRefID',
        addedEP: '87',
        added: 'FIX.5.0SP1',
        type: 'String',
        id: 1466,
        description:
            'Specifies a reference from one Security List to another. Used to support a hierarchy of Security Lists.',
    },
    {
        name: 'SecurityListDesc',
        abbrName: 'ListDesc',
        addedEP: '87',
        added: 'FIX.5.0SP1',
        type: 'String',
        id: 1467,
        description: 'Specifies a description or name of a Security List.',
    },
    {
        name: 'EncodedSecurityListDescLen',
        abbrName: 'EncListDescLen',
        updated: 'FIX.Latest',
        addedEP: '87',
        added: 'FIX.5.0SP1',
        type: 'Length',
        updatedEP: '271',
        id: 1468,
        description: 'Byte length of encoded (non-ASCII characters) EncodedSecurityListDesc(1469) field.',
    },
    {
        name: 'EncodedSecurityListDesc',
        abbrName: 'EncListDesc',
        updated: 'FIX.Latest',
        addedEP: '87',
        added: 'FIX.5.0SP1',
        type: 'data',
        updatedEP: '271',
        id: 1469,
        lengthId: '1468',
        description:
            'Encoded (non-ASCII characters) representation of the SecurityListDesc(1467) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) representation should also be specified in the SecurityListDesc(1467) field.',
    },
    {
        name: 'SecurityListType',
        abbrName: 'ListTyp',
        unionDataType: 'Reserved100Plus',
        addedEP: '87',
        added: 'FIX.5.0SP1',
        type: 'SecurityListTypeCodeSet',
        id: 1470,
        discriminatorId: '1471',
        description: 'Specifies a type of Security List.',
    },
    {
        name: 'SecurityListTypeSource',
        abbrName: 'LstTypSrc',
        unionDataType: 'Reserved100Plus',
        addedEP: '87',
        added: 'FIX.5.0SP1',
        type: 'SecurityListTypeSourceCodeSet',
        id: 1471,
        description:
            'Specifies a specific source for a SecurityListType. Relevant when a certain type can be provided from various sources.',
    },
    {
        name: 'NewsID',
        abbrName: 'ID',
        addedEP: '90',
        added: 'FIX.5.0SP1',
        type: 'String',
        id: 1472,
        description: 'Unique identifier for a News message',
    },
    {
        name: 'NewsCategory',
        abbrName: 'NewsCatgy',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.Latest',
        addedEP: '90',
        added: 'FIX.5.0SP1',
        type: 'NewsCategoryCodeSet',
        updatedEP: '271',
        id: 1473,
        description: 'Category of news message.',
    },
    {
        name: 'LanguageCode',
        abbrName: 'LangCd',
        addedEP: '90',
        added: 'FIX.5.0SP1',
        type: 'Language',
        id: 1474,
        description: 'The national language in which the news item is provided.',
    },
    {
        name: 'NoNewsRefIDs',
        addedEP: '90',
        added: 'FIX.5.0SP1',
        type: 'NumInGroup',
        id: 1475,
        description: 'Number of News reference items',
    },
    {
        name: 'NewsRefID',
        abbrName: 'RefID',
        addedEP: '90',
        added: 'FIX.5.0SP1',
        type: 'String',
        id: 1476,
        description: 'Reference to another News message identified by NewsID(1474).',
    },
    {
        name: 'NewsRefType',
        abbrName: 'RefTyp',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.5.0SP2',
        addedEP: '90',
        added: 'FIX.5.0SP1',
        type: 'NewsRefTypeCodeSet',
        updatedEP: '190',
        id: 1477,
        description: 'Type of reference to another News(35=B) message item.',
    },
    {
        name: 'StrikePriceDeterminationMethod',
        abbrName: 'StrkPxDtrmnMeth',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.5.0SP2',
        addedEP: '92',
        added: 'FIX.5.0SP1',
        type: 'StrikePriceDeterminationMethodCodeSet',
        updatedEP: '169',
        id: 1478,
        description:
            'Specifies how the strike price is determined at the point of option exercise. The strike may be fixed throughout the life of the option, set at expiration to the value of the underlying, set to the average value of the underlying , or set to the optimal value of the underlying.',
    },
    {
        name: 'StrikePriceBoundaryMethod',
        abbrName: 'StrkPxBndryMeth',
        addedEP: '92',
        added: 'FIX.5.0SP1',
        type: 'StrikePriceBoundaryMethodCodeSet',
        id: 1479,
        description:
            'Specifies the boundary condition to be used for the strike price relative to the underlying price at the point of option exercise.',
    },
    {
        name: 'StrikePriceBoundaryPrecision',
        abbrName: 'StrkPxBndryPrcsn',
        addedEP: '92',
        added: 'FIX.5.0SP1',
        type: 'Percentage',
        id: 1480,
        description:
            'Used in combination with StrikePriceBoundaryMethod to specify the percentage of the strike price in relation to the underlying price. The percentage is generally 100 or greater for puts and 100 or less for calls.',
    },
    {
        name: 'UnderlyingPriceDeterminationMethod',
        abbrName: 'PxDtrmnMeth',
        addedEP: '92',
        added: 'FIX.5.0SP1',
        type: 'UnderlyingPriceDeterminationMethodCodeSet',
        id: 1481,
        description:
            'Specifies how the underlying price is determined at the point of option exercise. The underlying price may be set to the current settlement price, set to a special reference, set to the optimal value of the underlying during the defined period ("Look-back") or set to the average value of the underlying during the defined period ("Asian option").',
    },
    {
        name: 'OptPayoutType',
        abbrName: 'OptPayoutTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '92',
        added: 'FIX.5.0SP1',
        type: 'OptPayoutTypeCodeSet',
        updatedEP: '238',
        id: 1482,
        description: 'Indicates the type of valuation method or payout trigger for an in-the-money option.',
    },
    {
        name: 'NoComplexEvents',
        addedEP: '92',
        added: 'FIX.5.0SP1',
        type: 'NumInGroup',
        id: 1483,
        description: 'Number of complex event occurrences.',
    },
    {
        name: 'ComplexEventType',
        abbrName: 'Typ',
        addedEP: '92',
        added: 'FIX.5.0SP1',
        type: 'ComplexEventTypeCodeSet',
        id: 1484,
        description: 'Identifies the type of complex event.',
    },
    {
        name: 'ComplexOptPayoutAmount',
        abbrName: 'OptPayAmt',
        addedEP: '92',
        added: 'FIX.5.0SP1',
        type: 'Amt',
        id: 1485,
        description:
            'Cash amount indicating the pay out associated with an event. For binary options this is a fixed amount.',
    },
    {
        name: 'ComplexEventPrice',
        abbrName: 'Px',
        addedEP: '92',
        added: 'FIX.5.0SP1',
        type: 'Price',
        id: 1486,
        description:
            'Specifies the price at which the complex event takes effect. Impact of the event price is determined by the ComplexEventType(1484).',
    },
    {
        name: 'ComplexEventPriceBoundaryMethod',
        abbrName: 'PxBndryMeth',
        addedEP: '92',
        added: 'FIX.5.0SP1',
        type: 'ComplexEventPriceBoundaryMethodCodeSet',
        id: 1487,
        description:
            'Specifies the boundary condition to be used for the event price relative to the underlying price at the point the complex event outcome takes effect as determined by the ComplexEventPriceTimeType.',
    },
    {
        name: 'ComplexEventPriceBoundaryPrecision',
        abbrName: 'PxBndryPrcsn',
        addedEP: '92',
        added: 'FIX.5.0SP1',
        type: 'Percentage',
        id: 1488,
        description:
            'Used in combination with ComplexEventPriceBoundaryMethod to specify the percentage of the strike price in relation to the underlying price. The percentage is generally 100 or greater for puts and 100 or less for calls.',
    },
    {
        name: 'ComplexEventPriceTimeType',
        abbrName: 'PxTmTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '92',
        added: 'FIX.5.0SP1',
        type: 'ComplexEventPriceTimeTypeCodeSet',
        updatedEP: '169',
        id: 1489,
        description:
            'Specifies when the complex event outcome takes effect. The outcome of a complex event is a payout or barrier action as specified by the ComplexEventType(1484).',
    },
    {
        name: 'ComplexEventCondition',
        abbrName: 'Cond',
        addedEP: '92',
        added: 'FIX.5.0SP1',
        type: 'ComplexEventConditionCodeSet',
        id: 1490,
        description:
            'Specifies the condition between complex events when more than one event is specified.\n\nMultiple barrier events would use an "or" condition since only one can be effective at a given time. A set of digital range events would use an "and" condition since both conditions must be in effect for a payout to result.',
    },
    {
        name: 'NoComplexEventDates',
        addedEP: '92',
        added: 'FIX.5.0SP1',
        type: 'NumInGroup',
        id: 1491,
        description: 'Number of complex event date occurrences for a given complex event.',
    },
    {
        name: 'ComplexEventStartDate',
        abbrName: 'StartDt',
        updated: 'FIX.5.0SP2',
        addedEP: '92',
        added: 'FIX.5.0SP1',
        type: 'UTCDateOnly',
        updatedEP: '195',
        id: 1492,
        description:
            'Specifies the start date of the date range on which a complex event is effective. The start date will be set equal to the end date for single day events such as Bermuda options\n\nComplexEventStartDate must always be less than or equal to ComplexEventEndDate.',
    },
    {
        name: 'ComplexEventEndDate',
        abbrName: 'EndDt',
        updated: 'FIX.5.0SP2',
        addedEP: '92',
        added: 'FIX.5.0SP1',
        type: 'UTCDateOnly',
        updatedEP: '195',
        id: 1493,
        description:
            'Specifies the end date of the date range on which a complex event is effective. The start date will be set equal to the end date for single day events such as Bermuda options\n\nComplexEventEndDate must always be greater than or equal to ComplexEventStartDate.',
    },
    {
        name: 'NoComplexEventTimes',
        addedEP: '92',
        added: 'FIX.5.0SP1',
        type: 'NumInGroup',
        id: 1494,
        description:
            'Number of complex event time occurrences for a given complex event date\n\nThe default in case of an absence of time fields is 00:00:00-23:59:59.',
    },
    {
        name: 'ComplexEventStartTime',
        abbrName: 'StartTm',
        addedEP: '92',
        added: 'FIX.5.0SP1',
        type: 'UTCTimeOnly',
        id: 1495,
        description:
            'Specifies the start time of the time range on which a complex event date is effective.\n\nComplexEventStartTime must always be less than or equal to ComplexEventEndTime.',
    },
    {
        name: 'ComplexEventEndTime',
        abbrName: 'EndTm',
        addedEP: '92',
        added: 'FIX.5.0SP1',
        type: 'UTCTimeOnly',
        id: 1496,
        description:
            'Specifies the end time of the time range on which a complex event date is effective.\n\nComplexEventEndTime must always be greater than or equal to ComplexEventStartTime.',
    },
    {
        name: 'StreamAsgnReqID',
        abbrName: 'ReqID',
        addedEP: '93',
        added: 'FIX.5.0SP1',
        type: 'String',
        id: 1497,
        description: 'Unique identifier for the stream assignment request provided by the requester.',
    },
    {
        name: 'StreamAsgnReqType',
        abbrName: 'AsgnReqTyp',
        addedEP: '93',
        added: 'FIX.5.0SP1',
        type: 'StreamAsgnReqTypeCodeSet',
        id: 1498,
        description: 'Type of stream assignment request.',
    },
    {
        name: 'NoAsgnReqs',
        addedEP: '93',
        added: 'FIX.5.0SP1',
        type: 'NumInGroup',
        id: 1499,
        description: 'Number of assignment requests.',
    },
    {
        name: 'MDStreamID',
        abbrName: 'MDStrmID',
        addedEP: '93',
        added: 'FIX.5.0SP1',
        type: 'String',
        id: 1500,
        description: 'The identifier or name of the price stream.',
    },
    {
        name: 'StreamAsgnRptID',
        abbrName: 'RptID',
        addedEP: '93',
        added: 'FIX.5.0SP1',
        type: 'String',
        id: 1501,
        description: 'Unique identifier of the stream assignment report provided by the respondent.',
    },
    {
        name: 'StreamAsgnRejReason',
        abbrName: 'RejRsn',
        unionDataType: 'Reserved100Plus',
        addedEP: '93',
        added: 'FIX.5.0SP1',
        type: 'StreamAsgnRejReasonCodeSet',
        id: 1502,
        description: 'Reason code for stream assignment request reject.',
    },
    {
        name: 'StreamAsgnAckType',
        abbrName: 'ActTyp',
        addedEP: '93',
        added: 'FIX.5.0SP1',
        type: 'StreamAsgnAckTypeCodeSet',
        id: 1503,
        description: 'Type of acknowledgement.',
    },
    {
        name: 'StreamAsgnType',
        abbrName: 'AsgnTyp',
        addedEP: '93',
        added: 'FIX.5.0SP1',
        type: 'StreamAsgnTypeCodeSet',
        id: 1617,
        description: 'The type of assignment being affected in the Stream Assignment Report.',
    },
    {
        name: 'RelSymTransactTime',
        abbrName: 'TxnTm',
        addedEP: '94',
        added: 'FIX.5.0SP1',
        type: 'UTCTimestamp',
        id: 1504,
        description: 'See TransactTime(60)',
    },
    {
        name: 'FillYieldType',
        abbrName: 'Typ',
        addedEP: '98',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1622,
        description: 'Yield Type, using same values as YieldType (235)',
    },
    {
        name: 'FillYield',
        abbrName: 'Yld',
        addedEP: '98',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 1623,
        description: 'Yield Percentage, using same values as Yield (236)',
    },
    {
        name: 'NoMatchInst',
        addedEP: '99',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1624,
        description: 'Number of Instructions in the <MatchingInstructions> repeating group.',
    },
    {
        name: 'MatchInst',
        abbrName: 'Inst',
        addedEP: '99',
        added: 'FIX.5.0SP2',
        type: 'MatchInstCodeSet',
        id: 1625,
        description: 'Matching Instruction for the order.',
    },
    {
        name: 'MatchAttribTagID',
        abbrName: 'ID',
        addedEP: '99',
        added: 'FIX.5.0SP2',
        type: 'TagNum',
        id: 1626,
        description:
            'Existing FIX field to be applied as a matching criteria to the instruction, bilaterally agreed between parties.',
    },
    {
        name: 'MatchAttribValue',
        abbrName: 'Valu',
        addedEP: '99',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1627,
        description: 'Value of MatchAttribTagID(1626) on which to apply the matching instruction.',
    },
    {
        name: 'MatchInstMarketID',
        abbrName: 'MktID',
        addedEP: '99',
        added: 'FIX.5.0SP2',
        type: 'Exchange',
        id: 1673,
        description: 'Identifies the market to which the matching instruction applies.',
    },
    {
        name: 'TriggerScope',
        abbrName: 'TrgrScope',
        addedEP: '100',
        added: 'FIX.5.0SP2',
        type: 'TriggerScopeCodeSet',
        id: 1628,
        description: 'Defines the scope of TriggerAction(1101) when it is set to "cancel" (3).',
    },
    {
        name: 'ExposureDuration',
        abbrName: 'ExpsreDur',
        updated: 'FIX.5.0SP2',
        addedEP: '100',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '159',
        id: 1629,
        description:
            'This is the time in seconds of a "Good for Time" (GFT) TimeInForce.\n\nPositive integer value which represents the time is seconds in which the new order remains active in the market before it is automatically cancelled (e.g. expired).\n\nBi-lateral agreements will dictate the maximum value of this field. It is assumed that most systems will impose a max limit of 86,400 seconds (i.e. 24 hours).\n\nFor Quotes: The period of time a quoted price is tradable(i.e. on-the-wire) before it becomes indicative (i.e. off-the-wire).',
    },
    {
        name: 'NoLimitAmts',
        updated: 'FIX.Latest',
        addedEP: '100',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        updatedEP: '294',
        id: 1630,
        description: 'The number of limit amount entries.',
    },
    {
        name: 'LimitAmtType',
        abbrName: 'LmtAmtTyp',
        unionDataType: 'Reserved100Plus',
        addedEP: '100',
        added: 'FIX.5.0SP2',
        type: 'LimitAmtTypeCodeSet',
        id: 1631,
        description: 'Identifies the type of limit amount expressed in LastLimitAmt(1632) and LimitAmtRemaining(1633).',
    },
    {
        name: 'LastLimitAmt',
        abbrName: 'LastLmtAmt',
        addedEP: '100',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 1632,
        description:
            'The amount that has been drawn down against the counterparty for a given trade. The type of limit is specified in LimitAmtType(1631).\n\nBilateral agreements dictate the units and maximum value of this field.',
    },
    {
        name: 'LimitAmtRemaining',
        abbrName: 'LmtAmtRem',
        addedEP: '100',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 1633,
        description:
            'The remaining limit amount available between the counterparties. The type of limit is specified in LimitAmtType(1631).\n\nBilateral agreements dictate the units and maximum value of this field.',
    },
    {
        name: 'LimitAmtCurrency',
        abbrName: 'LmtAmtCcy',
        updated: 'FIX.Latest',
        addedEP: '100',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        updatedEP: '273',
        id: 1634,
        description: 'Indicates the currency that the limit amount is specified in.',
    },
    {
        name: 'MarginReqmtInqID',
        abbrName: 'ID',
        addedEP: '102',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1635,
        description: 'Unique identifier of the MarginRequirementInquiry.',
    },
    {
        name: 'NoMarginReqmtInqQualifier',
        addedEP: '102',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1636,
        description: 'Number of margin requirement inquiry qualifiers.',
    },
    {
        name: 'MarginReqmtInqQualifier',
        abbrName: 'Qual',
        addedEP: '102',
        added: 'FIX.5.0SP2',
        type: 'MarginReqmtInqQualifierCodeSet',
        id: 1637,
        description: 'Qualifier for MarginRequirementInquiry to identify a specific report.',
    },
    {
        name: 'MarginReqmtRptType',
        abbrName: 'RptTyp',
        addedEP: '102',
        added: 'FIX.5.0SP2',
        type: 'MarginReqmtRptTypeCodeSet',
        id: 1638,
        description: 'Type of MarginRequirementReport.',
    },
    {
        name: 'MarginClass',
        abbrName: 'Clss',
        addedEP: '102',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1639,
        description: 'Identifier for group of instruments with similar risk profile.',
    },
    {
        name: 'MarginReqmtInqStatus',
        abbrName: 'Stat',
        addedEP: '102',
        added: 'FIX.5.0SP2',
        type: 'CollInquiryStatusCodeSet',
        id: 1640,
        description: 'Status of MarginRequirementInquiry.',
    },
    {
        name: 'MarginReqmtInqResult',
        abbrName: 'Rslt',
        unionDataType: 'Reserved100Plus',
        addedEP: '102',
        added: 'FIX.5.0SP2',
        type: 'MarginReqmtInqResultCodeSet',
        id: 1641,
        description: 'Result returned in response to MarginRequirementInquiry.',
    },
    {
        name: 'MarginReqmtRptID',
        abbrName: 'RptID',
        addedEP: '102',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1642,
        description: 'Identifier for the MarginRequirementReport message.',
    },
    {
        name: 'NoMarginAmt',
        addedEP: '102',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1643,
        description: 'Number of margin requirement amounts.',
    },
    {
        name: 'MarginAmtType',
        abbrName: 'Typ',
        unionDataType: 'Reserved100Plus',
        addedEP: '102',
        added: 'FIX.5.0SP2',
        type: 'MarginAmtTypeCodeSet',
        id: 1644,
        description: 'Type of margin requirement amount being specified.',
    },
    {
        name: 'MarginAmt',
        abbrName: 'Amt',
        addedEP: '102',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 1645,
        description: 'Amount of margin requirement.',
    },
    {
        name: 'MarginAmtCcy',
        abbrName: 'Ccy',
        addedEP: '102',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 1646,
        description: 'Currency of the MarginAmt(1645).',
    },
    {
        name: 'NoRelatedInstruments',
        addedEP: '103',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1647,
        description: 'Number of related instruments',
    },
    {
        name: 'RelatedInstrumentType',
        abbrName: 'InstrmtTyp',
        addedEP: '103',
        added: 'FIX.5.0SP2',
        type: 'RelatedInstrumentTypeCodeSet',
        id: 1648,
        description: 'The type of instrument relationship',
    },
    {
        name: 'RelatedSymbol',
        abbrName: 'Sym',
        updated: 'FIX.5.0SP2',
        addedEP: '103',
        added: 'FIX.5.0SP2',
        type: 'String',
        updatedEP: '187',
        id: 1649,
        description: 'Ticker symbol of the related security. Common "human understood" representation of the security.',
    },
    {
        name: 'RelatedSecurityID',
        abbrName: 'ID',
        updated: 'FIX.5.0SP2',
        addedEP: '103',
        added: 'FIX.5.0SP2',
        type: 'String',
        updatedEP: '187',
        id: 1650,
        discriminatorId: '1651',
        description: 'Related security identifier value of RelatedSecurityIDSource(1651) type.',
    },
    {
        name: 'RelatedSecurityIDSource',
        abbrName: 'Src',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.5.0SP2',
        addedEP: '103',
        added: 'FIX.5.0SP2',
        type: 'SecurityIDSourceCodeSet',
        updatedEP: '187',
        id: 1651,
        description: 'Identifies class or source of the RelatedSecurityID (1650) value.',
    },
    {
        name: 'RelatedSecurityType',
        abbrName: 'SecTyp',
        updated: 'FIX.Latest',
        addedEP: '103',
        added: 'FIX.5.0SP2',
        type: 'SecurityTypeCodeSet',
        updatedEP: '271',
        id: 1652,
        description: 'Security type of the related instrument.',
    },
    {
        name: 'RelatedMaturityMonthYear',
        abbrName: 'MMY',
        updated: 'FIX.5.0SP2',
        addedEP: '103',
        added: 'FIX.5.0SP2',
        type: 'MonthYear',
        updatedEP: '187',
        id: 1653,
        description: 'Expiration date for the related instrument contract.',
    },
    {
        name: 'CoveredQty',
        abbrName: 'CvrdQty',
        updated: 'FIX.5.0SP2',
        addedEP: '103',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        updatedEP: '141',
        id: 1654,
        description:
            'Used to specify the portion of the short contract quantity that is considered covered (e.g. used for short option position).',
    },
    {
        name: 'MarketMakerActivity',
        abbrName: 'MktMkrActvty',
        addedEP: '104',
        added: 'FIX.5.0SP2',
        type: 'MarketMakerActivityCodeSet',
        id: 1655,
        description: 'Indicates market maker participation in security.',
    },
    {
        name: 'PartyDetailsListRequestID',
        abbrName: 'ReqID',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1505,
        description: 'Unique identifier for PartyDetailsListRequest.',
    },
    {
        name: 'NoRequestedPartyRoles',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1508,
        description: 'Number of requested party roles.',
    },
    {
        name: 'RequestedPartyRole',
        abbrName: 'R',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'PartyRoleCodeSet',
        id: 1509,
        description: 'Identifies the type or role of party that has been requested.',
    },
    {
        name: 'PartyDetailsListReportID',
        abbrName: 'RptID',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1510,
        description: 'Identifier for the PartyDetailsListReport and the PartyDetailsListUpdateReport.',
    },
    {
        name: 'RequestResult',
        abbrName: 'ReqRslt',
        unionDataType: 'Reserved4000Plus',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'RequestResultCodeSet',
        id: 1511,
        description: 'Result of a request as identified by the appropriate request ID field',
    },
    {
        name: 'TotNoParties',
        abbrName: 'TotNoPtys',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 1512,
        description: 'Total number of PartyListGrp returned.',
    },
    {
        name: 'NoPartyRelationships',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1514,
        description: 'Number of party relationships.',
    },
    {
        name: 'PartyRelationship',
        abbrName: 'Rltnshp',
        unionDataType: 'Reserved4000Plus',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'PartyRelationshipCodeSet',
        id: 1515,
        description: 'Used to specify the type of the party relationship.',
    },
    {
        name: 'NoPartyDetailAltID',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1516,
        description: 'Number of party alternative identifiers.',
    },
    {
        name: 'PartyDetailAltID',
        abbrName: 'ID',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1517,
        discriminatorId: '1518',
        description: 'An alternate party identifier for the party specified in PartyDetailID(1691)',
    },
    {
        name: 'PartyDetailAltIDSource',
        abbrName: 'Src',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'PartyIDSourceCodeSet',
        id: 1518,
        description: 'Identifies the source of the PartyDetailAltID(1517) value.',
    },
    {
        name: 'NoPartyDetailAltSubIDs',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1519,
        description: 'Number of party detail alternate sub-identifiers.',
    },
    {
        name: 'PartyDetailAltSubID',
        abbrName: 'ID',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1520,
        description: 'Sub-identifier for the party specified in PartyDetailAltID(1517).',
    },
    {
        name: 'PartyDetailAltSubIDType',
        abbrName: 'Typ',
        unionDataType: 'Reserved4000Plus',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'PartySubIDTypeCodeSet',
        id: 1521,
        description: 'Type of PartyDetailAltSubID(1520) value.',
    },
    {
        name: 'NoRiskLimitTypes',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1529,
        description: 'Number of risk limits with associated warning levels.',
    },
    {
        name: 'RiskLimitType',
        abbrName: 'Typ',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.5.0SP2',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'RiskLimitTypeCodeSet',
        updatedEP: '204',
        id: 1530,
        description:
            'Used to specify the type of risk limit amount or position limit quantity or margin requirement amounts.',
    },
    {
        name: 'RiskLimitAmount',
        abbrName: 'Amt',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 1531,
        description: 'Specifies the risk limit amount.',
    },
    {
        name: 'RiskLimitCurrency',
        abbrName: 'Ccy',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 1532,
        description: 'Used to specify the currency of the risk limit amount.',
    },
    {
        name: 'RiskLimitPlatform',
        abbrName: 'Pltfm',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1533,
        description: 'The area to which risk limit is applicable. This can be a trading platform or an offering.',
    },
    {
        name: 'NoRiskInstrumentScopes',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1534,
        description: 'Number of risk instrument scopes.',
    },
    {
        name: 'InstrumentScopeOperator',
        abbrName: 'Oper',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'InstrumentScopeOperatorCodeSet',
        id: 1535,
        description: 'Operator to perform on the instrument(s) specified',
    },
    {
        name: 'InstrumentScopeSymbol',
        abbrName: 'Sym',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1536,
        description: 'Used to limit instrument scope to specified symbol.\n\nSee Symbol(55) field for description.',
    },
    {
        name: 'InstrumentScopeSymbolSfx',
        abbrName: 'Sfx',
        updated: 'FIX.Latest',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'SymbolSfxCodeSet',
        updatedEP: '282',
        id: 1537,
        description:
            'Used to limit instrument scope to specified symbol suffix.\n\nSee SymbolSfx(65) field for description.',
    },
    {
        name: 'InstrumentScopeSecurityID',
        abbrName: 'ID',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1538,
        discriminatorId: '1539',
        description:
            'Used to limit instrument scope to specified security identifier.\n\nSee SecurityID(48) field for description.',
    },
    {
        name: 'InstrumentScopeSecurityIDSource',
        abbrName: 'Src',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.Latest',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'SecurityIDSourceCodeSet',
        updatedEP: '265',
        id: 1539,
        description:
            'Used to limit instrument scope to specified security identifier source.\n\nSee SecurityIDSource(22) field for description.',
    },
    {
        name: 'NoInstrumentScopeSecurityAltID',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1540,
        description: 'Number of alternate security identifier for the specified InstrumentScopeSecurityID(1538).',
    },
    {
        name: 'InstrumentScopeSecurityAltID',
        abbrName: 'AltID',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1541,
        discriminatorId: '1542',
        description:
            'Used to limit instrument scope to specified security alternate identifier.\n\nSee SecurityAltID(455) field for description.',
    },
    {
        name: 'InstrumentScopeSecurityAltIDSource',
        abbrName: 'AltIDSrc',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.Latest',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'SecurityIDSourceCodeSet',
        updatedEP: '271',
        id: 1542,
        description:
            'Used to limit instrument scope to specified security alternate identifier source.\n\nSee SecurityAltIDSource(456) field for complete definition.',
    },
    {
        name: 'InstrumentScopeProduct',
        abbrName: 'Prod',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'ProductCodeSet',
        id: 1543,
        description:
            'Used to limit instrument scope to specified instrument product category.\n\nSee Product (460) field for description.',
    },
    {
        name: 'InstrumentScopeProductComplex',
        abbrName: 'ProdCmplx',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1544,
        description:
            'Used to limit instrument scope to specified product complex.\n\nSee ProductComplex(1227) field for description.',
    },
    {
        name: 'InstrumentScopeSecurityGroup',
        abbrName: 'SecGrp',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1545,
        description:
            'Used to limit instrument scope to specified security group.\n\nSee SecurityGroup(1151) field for description.',
    },
    {
        name: 'InstrumentScopeCFICode',
        abbrName: 'CFI',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1546,
        description: 'Used to limit instrument scope to specified CFICode.\n\nSee CFICode(461) field for description.',
    },
    {
        name: 'InstrumentScopeSecurityType',
        abbrName: 'SecTyp',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'SecurityTypeCodeSet',
        id: 1547,
        description:
            'Used to limit instrument scope to specified security type.\n\nSee SecurityType(167) field for description).',
    },
    {
        name: 'InstrumentScopeSecuritySubType',
        abbrName: 'SecSubTyp',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1548,
        description:
            'Used to limit instrument scope to specified security sub-type.\n\nSee SecuritySubType(762) field for description.',
    },
    {
        name: 'InstrumentScopeMaturityMonthYear',
        abbrName: 'MMY',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'MonthYear',
        id: 1549,
        description:
            'Used to limit instrument scope to specified maturity month and year.\n\nSee MaturityMonthYear(200) field for description.',
    },
    {
        name: 'InstrumentScopeMaturityTime',
        abbrName: 'MatTm',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'TZTimeOnly',
        id: 1550,
        description:
            'Used to limit instrument scope to specified maturity time.\n\nSee MaturityTime(1079) field for description.',
    },
    {
        name: 'InstrumentScopeRestructuringType',
        abbrName: 'RstrctTyp',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1551,
        description:
            'Used to limit instrument scope to specified restructuring type.\n\nSee RestructuringType(1449) field for description.',
    },
    {
        name: 'InstrumentScopeSeniority',
        abbrName: 'Snrty',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1552,
        description:
            'Used to limit instrument scope to specified seniority type.\n\nSee Seniority(1450) field for description.',
    },
    {
        name: 'InstrumentScopePutOrCall',
        abbrName: 'PutCall',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'PutOrCallCodeSet',
        id: 1553,
        description: 'Used to limit instrument scope to puts or calls.\n\nSee PutOrCall(201) field for description.',
    },
    {
        name: 'InstrumentScopeFlexibleIndicator',
        abbrName: 'FlexInd',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 1554,
        description:
            'Used to limit instrument scope to securities that can be defined using flexible terms or not.\n\nSee FlexibleIndicator(1244) field for description.',
    },
    {
        name: 'InstrumentScopeCouponRate',
        abbrName: 'CpnRt',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 1555,
        description:
            'Used to limit instrument scope to specified coupon rate.\n\nSee CouponRate(223) field for description.',
    },
    {
        name: 'InstrumentScopeSecurityDesc',
        abbrName: 'Desc',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1556,
        description:
            'Used to limit instrument scope to specified security description.\n\nSee SecurityDesc(107) field for description.',
    },
    {
        name: 'InstrumentScopeSettlType',
        abbrName: 'SettlTyp',
        unionDataType: 'Tenor',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'SettlTypeCodeSet',
        id: 1557,
        description:
            'Used to limit instrument scope to specified settlement type.\n\nSee SettlType(63) field for description.',
    },
    {
        name: 'RiskInstrumentMultiplier',
        abbrName: 'Mult',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 1558,
        description:
            'Multiplier applied to the transaction amount for comparison with risk limits. Default if not specified is 1.0.',
    },
    {
        name: 'NoRiskWarningLevels',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1559,
        description: 'Number of risk warning levels.',
    },
    {
        name: 'RiskWarningLevelPercent',
        abbrName: 'Pct',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 1560,
        description: 'Percent of risk limit at which a warning is issued.',
    },
    {
        name: 'RiskWarningLevelName',
        abbrName: 'Nme',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1561,
        description: 'Name or error message associated with the risk warning level.',
    },
    {
        name: 'NoRelatedPartyDetailID',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1562,
        description: 'Number of related party detail identifiers.',
    },
    {
        name: 'RelatedPartyDetailID',
        abbrName: 'ID',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1563,
        discriminatorId: '1564',
        description: 'Party identifier for the party related to the party specified in PartyDetailID(1691).',
    },
    {
        name: 'RelatedPartyDetailIDSource',
        abbrName: 'Src',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'PartyIDSourceCodeSet',
        id: 1564,
        description: 'Identifies the source of the RelatedPartyDetailID(1563).',
    },
    {
        name: 'RelatedPartyDetailRole',
        abbrName: 'R',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'PartyRoleCodeSet',
        id: 1565,
        description: 'Identifies the type or role of the RelatedPartyDetailID(1563) specified.',
    },
    {
        name: 'NoRelatedPartyDetailSubIDs',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1566,
        description: 'Number of related party detail sub-identifiers.',
    },
    {
        name: 'RelatedPartyDetailSubID',
        abbrName: 'ID',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1567,
        description: 'Sub-identifier for the party specified in RelatedPartyID(1563).',
    },
];

const batch3: ISpecFields[] = [
    {
        name: 'RelatedPartyDetailSubIDType',
        abbrName: 'Typ',
        unionDataType: 'Reserved4000Plus',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'PartySubIDTypeCodeSet',
        id: 1568,
        description: 'Type of RelatedPartyDetailSubID(1567) value.',
    },
    {
        name: 'NoRelatedPartyDetailAltID',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1569,
        description: 'Number of related party detail alternate identifiers.',
    },
    {
        name: 'RelatedPartyDetailAltID',
        abbrName: 'ID',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1570,
        discriminatorId: '1571',
        description: 'An alternate party identifier for the party specified in RelatedPartyID(1563).',
    },
    {
        name: 'RelatedPartyDetailAltIDSource',
        abbrName: 'Src',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'PartyIDSourceCodeSet',
        id: 1571,
        description: 'Identifies the source of the RelatedPartyDetailAltID(1570) value.',
    },
    {
        name: 'NoRelatedPartyDetailAltSubIDs',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1572,
        description: 'Number of related party detail alternate sub-identifiers.',
    },
    {
        name: 'RelatedPartyDetailAltSubID',
        abbrName: 'ID',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1573,
        description: 'Sub-identifier for the party specified in RelatedPartyDetailAltID(1570).',
    },
    {
        name: 'RelatedPartyDetailAltSubIDType',
        abbrName: 'Typ',
        unionDataType: 'Reserved4000Plus',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'PartySubIDTypeCodeSet',
        id: 1574,
        description: 'Type of RelatedPartyDetailAltSubID(1573) value.',
    },
    {
        name: 'InstrumentScopeSecurityExchange',
        abbrName: 'Exch',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'Exchange',
        id: 1616,
        description:
            'Used to limit instrument scope to specified security exchange.\n\nSee SecurityExchange(207) field for description.',
    },
    {
        name: 'InstrumentScopeEncodedSecurityDescLen',
        abbrName: 'EncDescLen',
        updated: 'FIX.Latest',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'Length',
        updatedEP: '271',
        id: 1620,
        description: 'Byte length of encoded (non-ASCII characters) InstrumentScopeEncodedSecurityDesc (1621) field',
    },
    {
        name: 'InstrumentScopeEncodedSecurityDesc',
        abbrName: 'EncDesc',
        updated: 'FIX.Latest',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'data',
        updatedEP: '271',
        id: 1621,
        lengthId: '1620',
        description:
            'Encoded (non-ASCII characters) representation of the InstrumentScopeSecurityDesc(1556) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) representation should also be specified in the InstrumentScopeSecurityDesc(1556) field.',
    },
    {
        name: 'NoInstrumentScopes',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1656,
        description: 'Number of instrument scopes.',
    },
    {
        name: 'NoRequestingPartyIDs',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1657,
        description: 'Number of requesting party identifiers.',
    },
    {
        name: 'RequestingPartyID',
        abbrName: 'ID',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1658,
        discriminatorId: '1659',
        description: 'Party identifier for the requesting party.',
    },
    {
        name: 'RequestingPartyIDSource',
        abbrName: 'Src',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'PartyIDSourceCodeSet',
        id: 1659,
        description: 'Identifies the source of the RequestingPartyID(1658) value.',
    },
    {
        name: 'RequestingPartyRole',
        abbrName: 'R',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'PartyRoleCodeSet',
        id: 1660,
        description: 'Identifies the type or role of the RequestingPartyID(1658) specified.',
    },
    {
        name: 'NoRequestingPartySubIDs',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1661,
        description: 'Number of requesting party sub-identifiers.',
    },
    {
        name: 'RequestingPartySubID',
        abbrName: 'ID',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1662,
        description: 'Sub-identifier for the party specified in RequestingPartyID(1658).',
    },
    {
        name: 'RequestingPartySubIDType',
        abbrName: 'Typ',
        unionDataType: 'Reserved4000Plus',
        updated: 'FIX.Latest',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'PartySubIDTypeCodeSet',
        updatedEP: '294',
        id: 1663,
        description: 'Type of RequestingPartySubID(1662) value.',
    },
    {
        name: 'EncodedRejectTextLen',
        abbrName: 'EncRejTxtLen',
        updated: 'FIX.5.0SP2',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'Length',
        updatedEP: '192',
        id: 1664,
        description: 'Byte length of encoded (non-ASCII characters) EncodedRejectText(1665) field.',
    },
    {
        name: 'EncodedRejectText',
        abbrName: 'EncRejTxt',
        updated: 'FIX.5.0SP2',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'data',
        updatedEP: '192',
        id: 1665,
        lengthId: '1664',
        description:
            'Encoded (non-ASCII characters) representation of the RejectText(1328) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) representation should also be specified in the RejectText(1328) field.',
    },
    {
        name: 'RiskLimitRequestID',
        abbrName: 'ReqID',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1666,
        description: 'Unique identifier for the PartyRiskLimitsRequest',
    },
    {
        name: 'RiskLimitReportID',
        abbrName: 'RptID',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1667,
        description: 'Identifier for the PartyRiskLimitsReport',
    },
    {
        name: 'NoRequestedRiskLimitType',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1668,
        description: 'Number of risk limit types requested.',
    },
    {
        name: 'NoRiskLimits',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1669,
        description: 'Number of risk limits for different instrument scopes.',
    },
    {
        baseCategory: 'PartiesReferenceData',
        name: 'RiskLimitID',
        abbrName: 'RiskLmtID',
        updated: 'FIX.5.0SP2',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'String',
        updatedEP: '171',
        baseCategoryAbbrName: 'ID',
        id: 1670,
        description: 'Unique reference identifier for a specific risk limit defined for the specified party.',
    },
    {
        name: 'NoPartyDetails',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1671,
        description: 'Number of party details.',
    },
    {
        name: 'PartyDetailStatus',
        abbrName: 'Stat',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'PartyDetailStatusCodeSet',
        id: 1672,
        description: 'Indicates the status of the party identified with PartyDetailID(1691).',
    },
    {
        name: 'PartyDetailRoleQualifier',
        abbrName: 'Qual',
        updated: 'FIX.5.0SP2',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'PartyDetailRoleQualifierCodeSet',
        updatedEP: '223',
        id: 1674,
        description: 'Qualifies the value of PartyDetailRole(1693).',
    },
    {
        name: 'RelatedPartyDetailRoleQualifier',
        abbrName: 'Qual',
        updated: 'FIX.5.0SP2',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'PartyDetailRoleQualifierCodeSet',
        updatedEP: '173',
        id: 1675,
        description: 'Qualifies the value of RelatedPartyRole(1565)',
    },
    {
        name: 'NoPartyUpdates',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1676,
        description: 'Number of party updates.',
    },
    {
        name: 'NoPartyRiskLimits',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1677,
        description: 'Number of party risk limits.',
    },
    {
        name: 'PartyDetailID',
        abbrName: 'ID',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1691,
        discriminatorId: '1692',
        description: 'Party identifier within Parties Reference Data messages.',
    },
    {
        name: 'PartyDetailIDSource',
        abbrName: 'Src',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'PartyIDSourceCodeSet',
        id: 1692,
        description: 'Source of the identifier of the PartyDetailID(1691) specified.',
    },
    {
        name: 'PartyDetailRole',
        abbrName: 'R',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'PartyRoleCodeSet',
        id: 1693,
        description: 'Identifies the type or role of PartyDetailID(1691) specified.',
    },
    {
        name: 'NoPartyDetailSubIDs',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1694,
        description: 'Number of party detail sub-identifiers.',
    },
    {
        name: 'PartyDetailSubID',
        abbrName: 'ID',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1695,
        description: 'Sub-identifier for the party specified in PartyDetailID(1691).',
    },
    {
        name: 'PartyDetailSubIDType',
        abbrName: 'Typ',
        unionDataType: 'Reserved4000Plus',
        updated: 'FIX.Latest',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        type: 'PartySubIDTypeCodeSet',
        updatedEP: '294',
        id: 1696,
        description: 'Type of PartyDetailSubID(1695) value.',
    },
    {
        name: 'SecurityMassTradingStatus',
        abbrName: 'TrdgStat',
        addedEP: '106',
        added: 'FIX.5.0SP2',
        type: 'SecurityTradingStatusCodeSet',
        id: 1679,
        description: 'Identifies the trading status applicable to a group of instruments.',
    },
    {
        name: 'SecurityMassTradingEvent',
        abbrName: 'SecTrdEvnt',
        addedEP: '106',
        added: 'FIX.5.0SP2',
        type: 'SecurityTradingEventCodeSet',
        id: 1680,
        description: 'Identifies an event related to the mass trading status.',
    },
    {
        name: 'MassHaltReason',
        abbrName: 'HaltRsn',
        addedEP: '106',
        added: 'FIX.5.0SP2',
        type: 'HaltReasonCodeSet',
        id: 1681,
        description: 'Denotes the reason for the Opening Delay or Trading halt of a group of securities.',
    },
    {
        name: 'MDSecurityTradingStatus',
        abbrName: 'TrdgStat',
        addedEP: '106',
        added: 'FIX.5.0SP2',
        type: 'SecurityTradingStatusCodeSet',
        id: 1682,
        description: 'Identifies the trading status applicable to the instrument in the market data message.',
    },
    {
        name: 'MDSubFeedType',
        abbrName: 'MDSubFeedTyp',
        addedEP: '106',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1683,
        description: 'Describes a sub-class for a given class of service defined by MDFeedType (1022)',
    },
    {
        name: 'MDHaltReason',
        abbrName: 'HaltRsn',
        addedEP: '106',
        added: 'FIX.5.0SP2',
        type: 'HaltReasonCodeSet',
        id: 1684,
        description: 'Denotes the reason for the Opening Delay or Trading Halt.',
    },
    {
        name: 'SideTradeID',
        abbrName: 'TrdID',
        addedEP: '107',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1506,
        description: 'Used to represent the trade ID for each side of the trade assigned by an intermediary.',
    },
    {
        name: 'SideOrigTradeID',
        abbrName: 'OrigTrdID',
        addedEP: '107',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1507,
        description:
            'Used to capture the original trade id for each side of a trade undergoing novation to a standardized model.',
    },
    {
        name: 'DifferentialPrice',
        abbrName: 'DiffPx',
        updated: 'FIX.5.0SP2',
        addedEP: '107',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        updatedEP: '217',
        id: 1522,
        description:
            'Used to specify the differential price when reporting the individual leg of a spread trade. Both leg price and differential price may be provided on such a report. Note that MultiLegReportingType(442) will be set to 2 (Individual leg of a multi-leg security) in this case.\n\nAlso used in pricing Trade at Settlement (TAS) and Trade At Marker (TAM) contracts for which the value is the negotiated currency offset either at settlement (TAS) or at time specified in the product definition (TAM). The final contract price is specified in LastPx(31).',
    },
    {
        name: 'TrdAckStatus',
        abbrName: 'TrdAckStat',
        addedEP: '107',
        added: 'FIX.5.0SP2',
        type: 'TrdAckStatusCodeSet',
        id: 1523,
        description: 'Used to indicate the status of the trade submission (not the trade report)',
    },
    {
        name: 'PriceQuoteCurrency',
        abbrName: 'PxQteCcy',
        addedEP: '107',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 1524,
        description:
            'Default currency in which the price is quoted. Defined at the instrument level. Used in place of Currency (tag 15) to express the currency of a product when the former is implemented as the FX dealt currency.',
    },
    {
        name: 'UnderlyingPriceQuoteCurrency',
        abbrName: 'PxQteCcy',
        addedEP: '107',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 1526,
        description:
            'Default currency in which the price is quoted. Defined at the instrument level. Used in place of Currency (tag 15) to express the currency of a product when the former is implemented as the FX dealt currency.',
    },
    {
        name: 'LegPriceQuoteCurrency',
        abbrName: 'PxQteCcy',
        addedEP: '107',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 1528,
        description:
            'Default currency in which the price is quoted. Defined at the instrument level. Used in place of Currency (tag 15) to express the currency of a product when the former is implemented as the FX dealt currency.',
    },
    {
        name: 'DerivativePriceQuoteCurrency',
        abbrName: 'PxQteCcy',
        updated: 'FIX.Latest',
        addedEP: '107',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        updatedEP: '271',
        id: 1576,
        description:
            'Default currency in which the price is quoted. Defined at the instrument level. Used in place of Currency(tag 15) to express the currency of a product when the former is implemented as the FX dealt currency.\n\nSee PriceQuoteCurrency(1524) for complete definition.',
    },
    {
        name: 'NoSecurityClassifications',
        addedEP: '107',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1582,
        description: 'Number of Security Classifications.',
    },
    {
        name: 'SecurityClassificationReason',
        abbrName: 'Rsn',
        unionDataType: 'Reserved100Plus',
        addedEP: '107',
        added: 'FIX.5.0SP2',
        type: 'SecurityClassificationReasonCodeSet',
        id: 1583,
        description:
            'Allows classification of instruments according to a set of high level reasons. Classification reasons describe the classes in which the instrument participates.',
    },
    {
        name: 'SecurityClassificationValue',
        abbrName: 'Val',
        addedEP: '107',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1584,
        description:
            'Specifies the product classification value which further details the manner in which the instrument participates in the class.',
    },
    {
        name: 'PosAmtReason',
        abbrName: 'Rsn',
        unionDataType: 'Reserved1000Plus',
        addedEP: '107',
        added: 'FIX.5.0SP2',
        type: 'PosAmtReasonCodeSet',
        id: 1585,
        description:
            'Specifies the reason for an amount type when reported on a position. Useful when multiple instances of the same amount type are reported.',
    },
    {
        name: 'NoLegPosAmt',
        addedEP: '107',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1586,
        description: 'Number of TrdInstrmtLegPosAmt values.',
    },
    {
        name: 'LegPosAmt',
        abbrName: 'Amt',
        addedEP: '107',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 1587,
        description: 'Leg position amount.',
    },
    {
        name: 'LegPosAmtType',
        abbrName: 'Typ',
        addedEP: '107',
        added: 'FIX.5.0SP2',
        type: 'PosAmtTypeCodeSet',
        id: 1588,
        description: 'Type of leg position amount.',
    },
    {
        name: 'LegPosCurrency',
        abbrName: 'Ccy',
        addedEP: '107',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 1589,
        description: 'Leg position currency.',
    },
    {
        name: 'LegPosAmtReason',
        abbrName: 'Rsn',
        unionDataType: 'Reserved1000Plus',
        addedEP: '107',
        added: 'FIX.5.0SP2',
        type: 'PosAmtReasonCodeSet',
        id: 1590,
        description:
            'Specifies the reason for an amount type when reported on a position. Useful when multiple instances of the same amount type are reported.',
    },
    {
        name: 'LegQtyType',
        abbrName: 'QtyTyp',
        addedEP: '107',
        added: 'FIX.5.0SP2',
        type: 'QtyTypeCodeSet',
        id: 1591,
        description:
            'Type of quantity specified in LegQty field. LegContractMultiplier (614) is required when LegQtyType = 1 (Contracts). LegUnitOfMeasure (tag 999) and LegTimeUnit (tag 1001) are required when LegQtyType = 2 (Units of Measure per Time Unit). LegQtyType can be different for each leg.',
    },
    {
        name: 'DiscountFactor',
        abbrName: 'DiscFctr',
        addedEP: '107',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 1592,
        description: 'Used to calculate the present value of an amount to be paid in the future.',
    },
    {
        name: 'ParentAllocID',
        abbrName: 'ParentAllocID',
        addedEP: '107',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1593,
        description:
            'Contains the IndividualAllocId (tag 467) value of the allocation that is being offset as a result of a new allocation. This would be an optional field that would only be populated in the case of an allocation of an allocation (as well as any subsequent allocations). This wouldn’t be populated for an initial allocation since an allocation id is not supplied on default (initial) allocations.',
    },
    {
        name: 'LegSecurityGroup',
        abbrName: 'SecGrp',
        addedEP: '107',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1594,
        description:
            'Represents the product group of a leg.This is useful in conveying multi-leg instruments where the legs may participate in separate security groups.',
    },
    {
        name: 'PositionContingentPrice',
        abbrName: 'CntgPx',
        addedEP: '109',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 1595,
        description: 'Risk adjusted price used to calculate variation margin on a position.',
    },
    {
        name: 'ClearingTradePrice',
        abbrName: 'ClrTrdPx',
        addedEP: '111',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 1596,
        description: 'Alternate clearing price',
    },
    {
        name: 'SideClearingTradePrice',
        abbrName: 'ClrTrdPx',
        addedEP: '111',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 1597,
        description: 'Alternate clearing price for the side being reported.',
    },
    {
        name: 'SideClearingTradePriceType',
        abbrName: 'ClrTrdPxType',
        addedEP: '111',
        added: 'FIX.5.0SP2',
        type: 'SideClearingTradePriceTypeCodeSet',
        id: 1598,
        description:
            'Indicates to recipient whether trade is clearing at execution prices LastPx(tag 31) or alternate clearing prices SideClearingTradePrice(tag 1597).',
    },
    {
        name: 'SidePriceDifferential',
        abbrName: 'SidePxDiff',
        addedEP: '111',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 1599,
        description: 'Price Differential between the front and back leg of a spread or complex instrument.',
    },
    {
        name: 'FIXEngineName',
        addedEP: '113',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1600,
        description:
            'Provides the name of the infrastructure component being used for session level communication. Normally this would be the FIX Engine or FIX Gateway product name.',
    },
    {
        name: 'FIXEngineVersion',
        addedEP: '113',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1601,
        description: 'Provides the version of the infrastructure component.',
    },
    {
        name: 'FIXEngineVendor',
        addedEP: '113',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1602,
        description: 'Provides the name of the vendor providing the infrastructure component.',
    },
    {
        name: 'ApplicationSystemName',
        addedEP: '113',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1603,
        description:
            'Provides the name of the application system being used to generate FIX application messages. This will normally be a trading system, OMS, or EMS.',
    },
    {
        name: 'ApplicationSystemVersion',
        addedEP: '113',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1604,
        description: 'Provides the version of the application system being used to initiate FIX application messages.',
    },
    {
        name: 'ApplicationSystemVendor',
        addedEP: '113',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1605,
        description: 'Provides the vendor of the application system.',
    },
    {
        name: 'NumOfSimpleInstruments',
        abbrName: 'NumSimplInstrmt',
        addedEP: '114',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 1606,
        description:
            'Represents the total number of simple instruments that make up a multi-legged security. Complex spread instruments may be constructed of legs which themselves are multi-leg instruments.',
    },
    {
        name: 'SecurityRejectReason',
        abbrName: 'SecRejRsn',
        unionDataType: 'Reserved100Plus',
        addedEP: '114',
        added: 'FIX.5.0SP2',
        type: 'SecurityRejectReasonCodeSet',
        id: 1607,
        description: 'Identifies the reason a security definition request is being rejected.',
    },
    {
        name: 'InitialDisplayQty',
        abbrName: 'InitDsplyQty',
        addedEP: '115',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 1608,
        description:
            'Used to convey the initially requested display quantity specified in DisplayQty(1138) on order entry and modification messages in ExecutionReport message. Applicable only in ExecutionReport message where DisplayQty(1138) is the currently displayed quantity and the requested display quantity of the order also needs to be conveyed. The values of the two fields are different as soon as the order is partially filled and also after a refresh of the order whenever DisplayMethod(1084) is not 1=Initial.',
    },
    {
        name: 'ThrottleStatus',
        abbrName: 'ThrttlStat',
        addedEP: '116',
        added: 'FIX.5.0SP2',
        type: 'ThrottleStatusCodeSet',
        id: 1609,
        description: 'Indicates whether a message was queued as a result of throttling.',
    },
    {
        name: 'NoThrottles',
        addedEP: '116',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1610,
        description: 'Indicates number of repeating groups to follow.',
    },
    {
        name: 'ThrottleAction',
        abbrName: 'Actn',
        addedEP: '116',
        added: 'FIX.5.0SP2',
        type: 'ThrottleActionCodeSet',
        id: 1611,
        description: 'Action to take should throttle limit be exceeded.',
    },
    {
        name: 'ThrottleType',
        abbrName: 'Typ',
        addedEP: '116',
        added: 'FIX.5.0SP2',
        type: 'ThrottleTypeCodeSet',
        id: 1612,
        description: 'Type of throttle.',
    },
    {
        name: 'ThrottleNoMsgs',
        abbrName: 'NoMsgs',
        addedEP: '116',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 1613,
        description:
            'Maximum number of messages allowed by the throttle. May be a rate limit or a limit on the number of outstanding requests.',
    },
    {
        name: 'ThrottleTimeInterval',
        abbrName: 'TmIntvl',
        addedEP: '116',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 1614,
        description: 'Value of the time interval in which the rate throttle is applied.',
    },
    {
        name: 'ThrottleTimeUnit',
        abbrName: 'TmUnit',
        addedEP: '116',
        added: 'FIX.5.0SP2',
        type: 'OrderDelayUnitCodeSet',
        id: 1615,
        description:
            'Units in which ThrottleTimeInterval is expressed. Uses same enumerations as OrderDelayUnit(1429).',
    },
    {
        name: 'NoThrottleMsgType',
        addedEP: '116',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1618,
        description: 'Number of ThrottleMsgType fields.',
    },
    {
        name: 'ThrottleMsgType',
        abbrName: 'MsgTyp',
        addedEP: '116',
        added: 'FIX.5.0SP2',
        type: 'MsgTypeCodeSet',
        id: 1619,
        description: 'The MsgType (35) of the FIX message being referenced.',
    },
    {
        name: 'ThrottleInst',
        abbrName: 'ThrttlInst',
        addedEP: '116',
        added: 'FIX.5.0SP2',
        type: 'ThrottleInstCodeSet',
        id: 1685,
        description: 'Describes action recipient should take if a throttle limit were exceeded.',
    },
    {
        name: 'ThrottleCountIndicator',
        abbrName: 'ThrttlCntInd',
        addedEP: '116',
        added: 'FIX.5.0SP2',
        type: 'ThrottleCountIndicatorCodeSet',
        id: 1686,
        description:
            'Indicates whether a message decrements the number of outstanding requests, e.g. one where ThrottleType = Outstanding Requests.',
    },
    {
        name: 'AccountSummaryReportID',
        abbrName: 'RptID',
        addedEP: '117',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1699,
        description: 'Unique identifier for the AccountSummaryReport(35=CQ).',
    },
    {
        name: 'NoSettlementAmounts',
        addedEP: '117',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1700,
        description: 'Number of settlement amount entries.',
    },
    {
        name: 'SettlementAmount',
        abbrName: 'Amt',
        addedEP: '117',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 1701,
        description: 'The amount of settlement.',
    },
    {
        name: 'SettlementAmountCurrency',
        abbrName: 'Ccy',
        addedEP: '117',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 1702,
        description: 'The currency of the reported settlement amount.',
    },
    {
        name: 'NoCollateralAmounts',
        addedEP: '117',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1703,
        description: 'Number of collateral amount entries.',
    },
    {
        name: 'CurrentCollateralAmount',
        abbrName: 'Amt',
        updated: 'FIX.5.0SP2',
        addedEP: '117',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        updatedEP: '227',
        id: 1704,
        description: 'Currency value currently attributed to the collateral.',
    },
    {
        name: 'CollateralCurrency',
        abbrName: 'Ccy',
        addedEP: '117',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 1705,
        description: 'Currency of the collateral; optional, defaults to the Settlement Currency if not specified.',
    },
    {
        name: 'CollateralType',
        abbrName: 'Typ',
        addedEP: '117',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1706,
        description: 'Type of collateral on deposit being reported.',
    },
    {
        name: 'NoPayCollects',
        addedEP: '117',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1707,
        description: 'Number of pay collect entries.',
    },
    {
        name: 'PayAmount',
        abbrName: 'PayAmt',
        addedEP: '117',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 1710,
        description: 'Amount to be paid by the clearinghouse to the clearing firm.',
    },
    {
        name: 'CollectAmount',
        abbrName: 'ColAmt',
        addedEP: '117',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 1711,
        description: 'Amount to be collected by the clearinghouse from the clearing firm.',
    },
    {
        name: 'PayCollectType',
        abbrName: 'Typ',
        addedEP: '117',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1708,
        description: 'Category describing the reason for funds paid to, or the funds collected from the clearing firm.',
    },
    {
        name: 'PayCollectCurrency',
        abbrName: 'Ccy',
        addedEP: '117',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 1709,
        description:
            'Currency denomination of value in PayAmount(1710) and CollectAmount(1711). If not specified, default to currency specified in SettlementAmountCurrency(1702).',
    },
    {
        name: 'PayCollectMarketSegmentID',
        abbrName: 'MktSegID',
        addedEP: '117',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1712,
        description: 'Market segment associated with the pay collect amount.',
    },
    {
        name: 'PayCollectMarketID',
        abbrName: 'MktID',
        addedEP: '117',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1713,
        description: 'Market associated with the pay collect amount.',
    },
    {
        name: 'MarginAmountMarketSegmentID',
        abbrName: 'MktSegID',
        addedEP: '117',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1714,
        description: 'Market segment associated with the margin amount.',
    },
    {
        name: 'MarginAmountMarketID',
        abbrName: 'MktID',
        addedEP: '117',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1715,
        description: 'Market associated with the margin amount',
    },
    {
        name: 'FirmGroupID',
        abbrName: 'FirmGrpID',
        addedEP: '118',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1728,
        description: 'Firm assigned group allocation entity identifier.',
    },
    {
        name: 'FirmMnemonic',
        abbrName: 'FirmMnem',
        addedEP: '118',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1729,
        description:
            'Allocation identifier assigned by the Firm submitting the allocation for an individual allocation instruction (as opposed to the overall message level identifier).',
    },
    {
        name: 'AllocGroupID',
        abbrName: 'GrpID',
        addedEP: '118',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1730,
        description:
            'Intended to be used by a central counterparty to assign an identifier to allocations of trades for the same instrument traded at the same price.',
    },
    {
        name: 'AvgPxGroupID',
        abbrName: 'AvgPxGrpID',
        updated: 'FIX.5.0SP2',
        addedEP: '118',
        added: 'FIX.5.0SP2',
        type: 'String',
        updatedEP: '141',
        id: 1731,
        description:
            'Used by submitting firm to group trades being allocated into an average price group. The trades in average price group will be used to calculate an average price for the group.',
    },
    {
        name: 'FirmAllocText',
        abbrName: 'FirmTxt',
        addedEP: '118',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1732,
        description:
            'Firm reference information, usually internal information, that is part of the initial message. The information would not be carried forward (e.g to Take-up Firm) and preserved with the transaction.',
    },
    {
        name: 'EncodedFirmAllocTextLen',
        abbrName: 'EncFirmTxtLen',
        updated: 'FIX.Latest',
        addedEP: '118',
        added: 'FIX.5.0SP2',
        type: 'Length',
        updatedEP: '271',
        id: 1733,
        description: 'Byte length of encoded (non-ASCII characters) EncodedFirmAllocText(1734) field.',
    },
    {
        name: 'EncodedFirmAllocText',
        abbrName: 'EncFirmTxt',
        updated: 'FIX.Latest',
        addedEP: '118',
        added: 'FIX.5.0SP2',
        type: 'data',
        updatedEP: '271',
        id: 1734,
        lengthId: '1733',
        description:
            'Encoded (non-ASCII characters) representation of the FirmAllocText(1732) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) represention should also be specified in FirmAllocText(1732) field.',
    },
    {
        name: 'AllocationRollupInstruction',
        abbrName: 'AllocRollupInst',
        updated: 'FIX.5.0SP2',
        addedEP: '118',
        added: 'FIX.5.0SP2',
        type: 'AllocationRollupInstructionCodeSet',
        updatedEP: '141',
        id: 1735,
        description: 'An indicator to override the normal procedure to roll up allocations for the same take-up firm.',
    },
    {
        name: 'AllocGroupQuantity',
        abbrName: 'GrpQty',
        addedEP: '118',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 1736,
        description: 'Indicates the total quantity of an allocation group. Includes any allocated quantity.',
    },
    {
        name: 'AllocGroupRemainingQuantity',
        abbrName: 'RemQty',
        addedEP: '118',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 1737,
        description: 'Indicates the remaining quantity of an allocation group that has not yet been allocated.',
    },
    {
        name: 'AllocReversalStatus',
        abbrName: 'RvrslStat',
        addedEP: '118',
        added: 'FIX.5.0SP2',
        type: 'AllocReversalStatusCodeSet',
        id: 1738,
        description: 'Identifies the status of a reversal transaction.',
    },
    {
        name: 'ObligationType',
        abbrName: 'ObligTyp',
        addedEP: '119',
        added: 'FIX.5.0SP2',
        type: 'ObligationTypeCodeSet',
        id: 1739,
        description: 'Type of reference obligation for credit derivatives contracts.',
    },
    {
        name: 'TradePriceNegotiationMethod',
        abbrName: 'TrdPxNegottnMeth',
        addedEP: '119',
        added: 'FIX.5.0SP2',
        type: 'TradePriceNegotiationMethodCodeSet',
        id: 1740,
        description: 'Method used for negotiation of contract price.',
    },
    {
        name: 'UpfrontPriceType',
        abbrName: 'UpfrontPxTyp',
        addedEP: '119',
        added: 'FIX.5.0SP2',
        type: 'UpfrontPriceTypeCodeSet',
        id: 1741,
        description: 'Type of price used to determine upfront payment for swaps contracts.',
    },
    {
        name: 'UpfrontPrice',
        abbrName: 'UpfrontPx',
        addedEP: '119',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 1742,
        description: 'Price used to determine upfront payment for swaps contracts.',
    },
    {
        name: 'LastUpfrontPrice',
        abbrName: 'LastUpfrontPx',
        addedEP: '119',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 1743,
        description: 'Price used to determine upfront payment for swaps contracts reported for a deal (trade).',
    },
    {
        name: 'ShortSaleRestriction',
        abbrName: 'ShrtRstctn',
        addedEP: '120',
        added: 'FIX.5.0SP2',
        type: 'ShortSaleRestrictionCodeSet',
        id: 1687,
        description: 'Indicates whether a restriction applies to short selling a security.',
    },
    {
        name: 'ShortSaleExemptionReason',
        abbrName: 'ShrtSaleExmptnRsn',
        addedEP: '121',
        added: 'FIX.5.0SP2',
        type: 'ShortSaleExemptionReasonCodeSet',
        id: 1688,
        description:
            'Indicates the reason a short sale order is exempted from applicable regulation (e.g. Reg SHO addendum (b)(1) in the U.S.).',
    },
    {
        name: 'LegShortSaleExemptionReason',
        abbrName: 'ShrtSaleExmptnRsn',
        addedEP: '121',
        added: 'FIX.5.0SP2',
        type: 'ShortSaleExemptionReasonCodeSet',
        id: 1689,
        description:
            'Indicates the reason a short sale is exempted from applicable regulation (e.g. Reg SHO addendum (b)(1) in the U.S.)',
    },
    {
        name: 'SideShortSaleExemptionReason',
        abbrName: 'ShrtSaleExmptnRsn',
        addedEP: '121',
        added: 'FIX.5.0SP2',
        type: 'ShortSaleExemptionReasonCodeSet',
        id: 1690,
        description:
            'Indicates the reason a short sale is exempted from applicable regulation (e.g. Reg SHO addendum (b)(1) in the U.S.)',
    },
    {
        name: 'UnitOfMeasureCurrency',
        abbrName: 'UOMCcy',
        addedEP: '122',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 1716,
        description:
            'Indicates the currency of the unit of measure. Conditionally required when UnitOfMeasure(996) = Ccy',
    },
    {
        name: 'PriceUnitOfMeasureCurrency',
        abbrName: 'PxUOMCcy',
        addedEP: '122',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 1717,
        description:
            'Indicates the currency of the price unit of measure. Conditionally required when PriceUnitOfMeasure(1191) = Ccy',
    },
    {
        name: 'UnderlyingUnitOfMeasureCurrency',
        abbrName: 'UOMCcy',
        addedEP: '122',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 1718,
        description:
            'Indicates the currency of the underlying unit of measure. Conditionally required when UnderlyingUnitOfMeasure(998) = Ccy',
    },
    {
        name: 'UnderlyingPriceUnitOfMeasureCurrency',
        abbrName: 'PxUOMCcy',
        addedEP: '122',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 1719,
        description:
            'Indicates the currency of the underlying price unit of measure. Conditionally required when UnderlyingPriceUnitOfMeasure(1424) = Ccy',
    },
    {
        name: 'LegUnitOfMeasureCurrency',
        abbrName: 'UOMCcy',
        addedEP: '122',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 1720,
        description:
            'Indicates the currency of the unit of measure. Conditionally required when LegUnitOfMeasure(999) = Ccy',
    },
    {
        name: 'LegPriceUnitOfMeasureCurrency',
        abbrName: 'PxUOMCcy',
        addedEP: '122',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 1721,
        description:
            'Indicates the currency of the price unit of measure. Conditionally required when LegPriceUnitOfMeasure(1421) = Ccy',
    },
    {
        name: 'DerivativeUnitOfMeasureCurrency',
        abbrName: 'UOMCcy',
        updated: 'FIX.Latest',
        addedEP: '122',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        updatedEP: '271',
        id: 1722,
        description:
            'Indicates the currency of the unit of measure.\n\nConditionally required when DerivativeUnitOfMeasure(1269) = Ccy.\n\nSee UnitOfMeasureCurrency(1716) for complete definition.',
    },
    {
        name: 'DerivativePriceUnitOfMeasureCurrency',
        abbrName: 'PxUOMCcy',
        updated: 'FIX.Latest',
        addedEP: '122',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        updatedEP: '271',
        id: 1723,
        description:
            'Indicates the currency of the price unit of measure.\n\nConditionally required when DerivativePriceUnitOfMeasure(1315) = Ccy.\n\nSee PriceUnitOfMeasureCurrency(1717) for complete definition.',
    },
    {
        name: 'ApplLevelRecoveryIndicator',
        addedEP: '124',
        added: 'FIX.5.0SP2',
        type: 'ApplLevelRecoveryIndicatorCodeSet',
        id: 1744,
        description: 'Indicates whether application level recovery is needed.',
    },
    {
        name: 'BidMDEntryID',
        abbrName: 'BidMDID',
        addedEP: '125',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1745,
        description: 'The market data entry identifier of the bid side of a quote',
    },
    {
        name: 'OfferMDEntryID',
        abbrName: 'OfrMDID',
        addedEP: '125',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1746,
        description: 'The market data entry identifier of the offer side of a quote.',
    },
    {
        name: 'BidQuoteID',
        abbrName: 'BidQID',
        addedEP: '125',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1747,
        description: 'Marketplace assigned quote identifier for the bid side. Can be used to indicate priority.',
    },
    {
        name: 'OfferQuoteID',
        abbrName: 'OfrQID',
        addedEP: '125',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1748,
        description: 'Marketplace assigned quote identifier for the offer side. Can be used to indicate priority.',
    },
    {
        name: 'TotalBidSize',
        abbrName: 'TotBidSz',
        addedEP: '126',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 1749,
        description: 'Specifies the total bid size.',
    },
    {
        name: 'TotalOfferSize',
        abbrName: 'TotOfrSz',
        addedEP: '126',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 1750,
        description: 'Specifies the total offer size.',
    },
    {
        name: 'SecondaryQuoteID',
        abbrName: 'QID2',
        addedEP: '126',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1751,
        description:
            'Assigned by the party which accepts the quote. Can be used to provide the quote identifier assigned by an exchange, marketplace or executing system.',
    },
    {
        name: 'CustodialLotID',
        abbrName: 'CstdlLotID',
        addedEP: '127',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1752,
        description:
            'An opaque identifier used to communicate the custodian’s identifier for the lot. It is expected that this information would be provided by the custodian as part of a reconciliation process that occurs before trading.',
    },
    {
        name: 'VersusPurchaseDate',
        abbrName: 'VSPDt',
        addedEP: '127',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 1753,
        description:
            'The effective acquisition date of the lot that would be used for gain-loss trade lot reporting. The versus purchase date used to identify the lot in situations where a custodial lot identifier is not available.',
    },
    {
        name: 'VersusPurchasePrice',
        abbrName: 'VSPPx',
        addedEP: '127',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 1754,
        description:
            'The versus purchase price used to identify the lot in situations where a custodial lot identifier is not available. The value should be calculated based on current cost basis / quantity held.',
    },
    {
        name: 'CurrentCostBasis',
        abbrName: 'CurCostBasis',
        addedEP: '127',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 1755,
        description:
            'The amount that the current shares are worth. If this lot was liquidated, the total gain/loss for a trade is equal to the trade amount minus the current cost basis.',
    },
    {
        name: 'LegCustodialLotID',
        abbrName: 'CstdlLotID',
        addedEP: '127',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1756,
        description:
            'An opaque identifier used to communicate the custodian’s identifier for the lot. It is expected that this information would be provided by the custodian as part of a reconciliation process that occurs before trading.',
    },
    {
        name: 'LegVersusPurchaseDate',
        abbrName: 'VSPDt',
        addedEP: '127',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 1757,
        description:
            'The effective acquisition date of the lot that would be used for gain-loss trade lot reporting. The versus purchase date used to identify the lot in situations where a custodial lot identifier is not available.',
    },
    {
        name: 'LegVersusPurchasePrice',
        abbrName: 'VSPPx',
        addedEP: '127',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 1758,
        description:
            'The versus purchase price used to identify the lot in situations where a custodial lot identifier is not available.The value should be calculated based on current cost basis / quantity held.',
    },
    {
        name: 'LegCurrentCostBasis',
        abbrName: 'CurCostBasis',
        addedEP: '127',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 1759,
        description:
            'The amount that the current shares are worth. If this lot was liquidated, the total gain/loss for a trade is equal to the trade amount minus the current cost basis.',
    },
    {
        name: 'RiskLimitRequestType',
        abbrName: 'ReqTyp',
        addedEP: '128',
        added: 'FIX.5.0SP2',
        type: 'RiskLimitRequestTypeCodeSet',
        id: 1760,
        description: 'Type of risk limit information.',
    },
    {
        name: 'RiskLimitRequestResult',
        abbrName: 'ReqRslt',
        unionDataType: 'Reserved100Plus',
        addedEP: '128',
        added: 'FIX.5.0SP2',
        type: 'RiskLimitRequestResultCodeSet',
        id: 1761,
        description: 'Result of risk limit definition request.',
    },
    {
        name: 'RiskLimitRequestStatus',
        abbrName: 'ReqStat',
        updated: 'FIX.5.0SP2',
        addedEP: '128',
        added: 'FIX.5.0SP2',
        type: 'PartyDetailRequestStatusCodeSet',
        updatedEP: '146',
        id: 1762,
        description: 'Status of risk limit definition request.',
    },
    {
        name: 'RiskLimitStatus',
        abbrName: 'Stat',
        updated: 'FIX.5.0SP2',
        addedEP: '128',
        added: 'FIX.5.0SP2',
        type: 'PartyDetailDefinitionStatusCodeSet',
        updatedEP: '146',
        id: 1763,
        description: 'Status of risk limit definition for one party.',
    },
    {
        name: 'RiskLimitResult',
        abbrName: 'Rslt',
        addedEP: '128',
        added: 'FIX.5.0SP2',
        type: 'RiskLimitRequestResultCodeSet',
        id: 1764,
        description: 'Result of risk limit definition for one party.',
    },
    {
        name: 'RiskLimitUtilizationPercent',
        abbrName: 'UtilztnPct',
        addedEP: '128',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 1765,
        description: "Percentage of utilization of a party's set risk limit.",
    },
    {
        name: 'RiskLimitUtilizationAmount',
        abbrName: 'UtilztnAmt',
        addedEP: '128',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 1766,
        description: "Absolute amount of utilization of a party's set risk limit.",
    },
    {
        name: 'RiskLimitAction',
        abbrName: 'Actn',
        updated: 'FIX.5.0SP2',
        addedEP: '128',
        added: 'FIX.5.0SP2',
        type: 'RiskLimitActionCodeSet',
        updatedEP: '171',
        id: 1767,
        description:
            'Identifies the action to take or risk model to assume should risk limit be exceeded or breached for the specified party.',
    },
    {
        name: 'RiskWarningLevelAmount',
        abbrName: 'Amt',
        addedEP: '128',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 1768,
        description: 'Amount at which a warning is issued.',
    },
    {
        name: 'RiskWarningLevelAction',
        abbrName: 'Actn',
        updated: 'FIX.5.0SP2',
        addedEP: '128',
        added: 'FIX.5.0SP2',
        type: 'RiskLimitActionCodeSet',
        updatedEP: '171',
        id: 1769,
        description: 'Action to take should warning level be exceeded.',
    },
    {
        name: 'EntitlementRequestID',
        abbrName: 'ReqID',
        addedEP: '129',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1770,
        description: 'Unique identifier for PartyEntitlementsRequest(35=CU).',
    },
    {
        name: 'EntitlementReportID',
        abbrName: 'RptID',
        addedEP: '129',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1771,
        description: 'Identifier for the PartyEntitlementsReport(35=CV).',
    },
    {
        name: 'NoPartyEntitlements',
        addedEP: '129',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1772,
        description: 'Number of party entitlement values.',
    },
    {
        name: 'NoEntitlements',
        addedEP: '129',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1773,
        description: 'Number of entitlement values.',
    },
    {
        name: 'EntitlementIndicator',
        abbrName: 'Ind',
        addedEP: '129',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 1774,
        description:
            'Used to indicate if a party is entitled to an entitlement type specified in the EntitlementType(1775) field.',
    },
    {
        name: 'EntitlementType',
        abbrName: 'Typ',
        unionDataType: 'Reserved100Plus',
        addedEP: '129',
        added: 'FIX.5.0SP2',
        type: 'EntitlementTypeCodeSet',
        id: 1775,
        description: 'Type of entitlement.',
    },
    {
        name: 'EntitlementID',
        abbrName: 'ID',
        addedEP: '129',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1776,
        description: 'Unique identifier for a specific NoEntitlements(1773) repeating group instance.',
    },
    {
        name: 'NoEntitlementAttrib',
        updated: 'FIX.Latest',
        addedEP: '129',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        updatedEP: '275',
        id: 1777,
        description: 'Number of entitlement attributes.',
    },
    {
        name: 'EntitlementAttribType',
        abbrName: 'Typ',
        unionDataType: 'Reserved4000Plus',
        addedEP: '129',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 1778,
        description:
            'Name of the entitlement attribute type. A code list of allowed values will be maintained on the FIX Protocol website.\n\nValues "4000" and above are reserved for bilaterally agreed upon user defined enumerations.',
    },
    {
        name: 'EntitlementAttribDatatype',
        abbrName: 'Datatyp',
        addedEP: '129',
        added: 'FIX.5.0SP2',
        type: 'EntitlementAttribDatatypeCodeSet',
        id: 1779,
        description: 'Datatype of the entitlement attribute.',
    },
    {
        name: 'EntitlementAttribValue',
        abbrName: 'Value',
        addedEP: '129',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1780,
        description: 'Value of the entitlement attribute.',
    },
    {
        name: 'EntitlementAttribCurrency',
        abbrName: 'Ccy',
        addedEP: '129',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 1781,
        description:
            'Currency for EntitlementAttribValue(1780). Can be used if these fields represent a price, price offset, or amount.',
    },
    {
        name: 'EntitlementStartDate',
        abbrName: 'StartDt',
        addedEP: '129',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 1782,
        description: 'Indicates the starting date of the entitlement.',
    },
    {
        name: 'EntitlementEndDate',
        abbrName: 'EndDt',
        updated: 'FIX.5.0SP2',
        addedEP: '129',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        updatedEP: '204',
        id: 1783,
        description: 'Indicates the ending date of the entitlement.',
    },
    {
        name: 'EntitlementPlatform',
        abbrName: 'Pltfm',
        addedEP: '129',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1784,
        description: 'The area to which the entitlement is applicable. This can be a trading platform or an offering.',
    },
    {
        name: 'TradSesControl',
        abbrName: 'TrdgSesCtrl',
        addedEP: '130',
        added: 'FIX.5.0SP2',
        type: 'TradSesControlCodeSet',
        id: 1785,
        description: 'Indicates how control of trading session and subsession transitions are performed.',
    },
    {
        name: 'TradeVolType',
        abbrName: 'TrdVolTyp',
        addedEP: '130',
        added: 'FIX.5.0SP2',
        type: 'TradeVolTypeCodeSet',
        id: 1786,
        description: 'Define the type of trade volume applicable for the MinTradeVol(562) and MaxTradeVol(1140)',
    },
    {
        name: 'RefTickTableID',
        abbrName: 'RefTickTblID',
        addedEP: '130',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 1787,
        description: 'Spread table code referred by the security or symbol.',
    },
    {
        name: 'LegID',
        abbrName: 'LegID',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1788,
        description:
            'Unique identifier for the leg within the context of a message (the scope of uniqueness to be defined by counterparty agreement). The LegID(1788) can be referenced using LegRefID(654).',
    },
    {
        name: 'NoTargetMarketSegments',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1789,
        description: 'Number of market segments upon which a mass action is to be taken.',
    },
    {
        name: 'TargetMarketSegmentID',
        abbrName: 'MktSegID',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1790,
        description: 'Market segment within a target market segment repeating group.',
    },
    {
        name: 'NoAffectedMarketSegments',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1791,
        description: 'Number of market segments affected by a mass action.',
    },
    {
        name: 'AffectedMarketSegmentID',
        abbrName: 'MktSegID',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1792,
        description: 'Market segment within an affected market repeating segment group.',
    },
    {
        name: 'NoNotAffectedMarketSegments',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1793,
        description: 'Number of market segments left unaffected by a mass action.',
    },
    {
        name: 'NotAffectedMarketSegmentID',
        abbrName: 'MktSegID',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1794,
        description: 'Market segment within an unaffected market repeating segment group.',
    },
    {
        name: 'NoOrderEvents',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1795,
        description: 'Number of order events.',
    },
    {
        name: 'OrderEventType',
        abbrName: 'Typ',
        unionDataType: 'Reserved100Plus',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'OrderEventTypeCodeSet',
        id: 1796,
        description:
            'The type of event affecting an order. The last event type within the OrderEventGrp component indicates the ExecType(150) value resulting from the series of events (ExecType(150) values are shown in brackets).',
    },
    {
        name: 'OrderEventExecID',
        abbrName: 'ID',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1797,
        description:
            'Refer to ExecID(17). Used when multiple different events are reported in single Execution Report. ExecID(17) and OrderEventExecID(1797) values should not overlap.',
    },
    {
        name: 'OrderEventReason',
        abbrName: 'Rsn',
        unionDataType: 'Reserved100Plus',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'OrderEventReasonCodeSet',
        id: 1798,
        description: 'Action that caused the event to occur.',
    },
    {
        name: 'OrderEventPx',
        abbrName: 'Px',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 1799,
        description: 'Price associated with the event.',
    },
    {
        name: 'OrderEventQty',
        abbrName: 'Qty',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 1800,
        description: 'Quantity associated with the event.',
    },
    {
        name: 'OrderEventLiquidityIndicator',
        abbrName: 'LqdtyInd',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'LastLiquidityIndCodeSet',
        id: 1801,
        description:
            'Indicator to identify whether this fill was a result of a liquidity provider providing or liquidity taker taking the liquidity. Applicable only for OrderEventType(1796) values of 4(Partially Filled) or 5(Filled).',
    },
    {
        name: 'OrderEventText',
        abbrName: 'Txt',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1802,
        description: 'Additional information about the event.',
    },
    {
        name: 'AuctionType',
        abbrName: 'AuctTyp',
        unionDataType: 'Reserved100Plus',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'AuctionTypeCodeSet',
        id: 1803,
        description: 'Type of auction order.',
    },
    {
        name: 'AuctionAllocationPct',
        abbrName: 'AuctPct',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 1804,
        description:
            'Percentage of matched quantity to be allocated to the submitter of the response to an auction order.',
    },
    {
        name: 'AuctionInstruction',
        abbrName: 'AuctInst',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'AuctionInstructionCodeSet',
        id: 1805,
        description: 'Instruction related to system generated auctions, e.g. flash order auctions.',
    },
    {
        name: 'RefClOrdID',
        abbrName: 'RefClOrdID',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1806,
        description: 'Used to reference an order via ClOrdID(11).',
    },
    {
        name: 'LockType',
        abbrName: 'LckTyp',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'LockTypeCodeSet',
        id: 1807,
        description: 'Indicates whether an order is locked and for what reason.',
    },
    {
        name: 'LockedQty',
        abbrName: 'LckQty',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 1808,
        description: 'Locked order quantity.',
    },
    {
        name: 'SecondaryLockedQty',
        abbrName: 'LckQty2',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 1809,
        description:
            'Locked order quantity in addition to LockedQty (1808), e.g. to distinguish total locked quantity from currently locked quantity.',
    },
    {
        name: 'ReleaseInstruction',
        abbrName: 'RlsInst',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'ReleaseInstructionCodeSet',
        id: 1810,
        description: 'Instruction to define conditions under which to release a locked order or parts of it.',
    },
    {
        name: 'ReleaseQty',
        abbrName: 'RlsQty',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 1811,
        description: 'Quantity to be made available, i.e. released from a lock.',
    },
    {
        name: 'NoDisclosureInstructions',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1812,
        description: 'Number of disclosure instructions.',
    },
    {
        name: 'DisclosureType',
        abbrName: 'Typ',
        unionDataType: 'Reserved100Plus',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'DisclosureTypeCodeSet',
        id: 1813,
        description: 'Information subject to disclosure.',
    },
    {
        name: 'DisclosureInstruction',
        abbrName: 'Inst',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'DisclosureInstructionCodeSet',
        id: 1814,
        description: 'Instruction to disclose information or to use default value of the receiver.',
    },
    {
        name: 'TradingCapacity',
        abbrName: 'TrdgCpcty',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'TradingCapacityCodeSet',
        id: 1815,
        description: 'Designates the capacity in which the order is submitted for trading by the market participant.',
    },
    {
        name: 'ClearingAccountType',
        abbrName: 'ClrAcctTyp',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'ClearingAccountTypeCodeSet',
        id: 1816,
        description: 'Designates the account type to be used for the order when submitted to clearing.',
    },
    {
        name: 'LegClearingAccountType',
        abbrName: 'ClrAcctTyp',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'ClearingAccountTypeCodeSet',
        id: 1817,
        description: 'Designates the capacity in which the order will be submitted to clearing.',
    },
    {
        name: 'TargetPartyRoleQualifier',
        abbrName: 'Qual',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'PartyDetailRoleQualifierCodeSet',
        id: 1818,
        description: 'Qualifies the value of TargetPartyRole (1464).',
    },
    {
        name: 'RelatedHighPrice',
        abbrName: 'ReltdHiPx',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 1819,
        description:
            'Upper boundary for the price of a related entity, e.g. price of the underlying instrument in an Underlying Price Contingency (UPC) order.',
    },
    {
        name: 'RelatedLowPrice',
        abbrName: 'ReltdLowPx',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 1820,
        description:
            'Lower boundary for the price of a related entity, e.g. price of the underlying instrument in an Underlying Price Contingency (UPC) order.',
    },
    {
        name: 'RelatedPriceSource',
        abbrName: 'ReltdPxSrc',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'RelatedPriceSourceCodeSet',
        id: 1821,
        description:
            'Source for the price of a related entity, e.g. price of the underlying instrument in an Underlying Price Contingency (UPC) order. Can be used together with RelatedHighPrice (1819) and/or RelatedLowPrice (1820).',
    },
    {
        name: 'MinQtyMethod',
        abbrName: 'MinQtyMeth',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'MinQtyMethodCodeSet',
        id: 1822,
        description: 'Indicates how the minimum quantity should be applied when executing the order.',
    },
    {
        name: 'Triggered',
        abbrName: 'Trgrd',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'TriggeredCodeSet',
        id: 1823,
        description:
            'Indicates whether order has been triggered during its lifetime. Applies to cases where original information, e.g. OrdType(40), is modified when the order is triggered.',
    },
    {
        name: 'AffectedOrigClOrdID',
        abbrName: 'OrigClOrdID',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1824,
        description: 'OrigClOrdID(41) of an order affected by a mass cancel or mass action request.',
    },
    {
        name: 'NotAffSecondaryOrderID',
        abbrName: 'OrdID2',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1825,
        description: 'SecondaryOrderID (198) of an order not affected by a mass cancel or mass action request.',
    },
    {
        name: 'NoCrossLegs',
        addedEP: '131',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1829,
        description: 'Number of legs in the side of a cross order.',
    },
    {
        name: 'EventTimePeriod',
        abbrName: 'TmPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '132',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '161',
        id: 1826,
        description: 'Time unit multiplier for the event.',
    },
    {
        name: 'EventTimeUnit',
        abbrName: 'TmUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '132',
        added: 'FIX.5.0SP2',
        type: 'EventTimeUnitCodeSet',
        updatedEP: '161',
        id: 1827,
        description: 'Time unit associated with the event.',
    },
    {
        name: 'LastQtyVariance',
        abbrName: 'LastQtyVarnc',
        addedEP: '132',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 1828,
        description:
            'When LastQty is an estimated value, e.g. for a Repo “circled” trade, LastQtyVariance specifies the absolute amount that the size may vary up or down when finalized. Omitted when LastQty(32) is already final.',
    },
    {
        name: 'OrderOrigination',
        abbrName: 'OrdOrigntn',
        updated: 'FIX.5.0SP2',
        addedEP: '135',
        added: 'FIX.5.0SP2',
        type: 'OrderOriginationCodeSet',
        updatedEP: '222',
        id: 1724,
        description: 'Identifies the origin of the order.',
    },
    {
        name: 'OriginatingDeptID',
        abbrName: 'OrigntngDeptID',
        addedEP: '135',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1725,
        description: 'An identifier representing the department or desk within the firm that originated the order.',
    },
    {
        name: 'ReceivingDeptID',
        abbrName: 'RcvgDeptID',
        addedEP: '135',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1726,
        description: 'An identifier representing the department or desk within the firm that received the order.',
    },
    {
        name: 'InformationBarrierID',
        abbrName: 'InfoBrrID',
        addedEP: '135',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1727,
        description:
            'The identifier of the information barrier in place for a trading unit that will meet the criteria of the "no-knowledge" exception in FINRA Rule 5320.02.',
    },
    {
        name: 'SettlPriceIncrement',
        abbrName: 'SettlPxIncr',
        addedEP: '138',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 1830,
        description: 'Settlement price increment for stated price range.',
    },
    {
        name: 'SettlPriceSecondaryIncrement',
        abbrName: 'SettlPxIncr2',
        addedEP: '138',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 1831,
        description:
            'Secondary settlement price increment for stated price range. The meaning of secondary is left to bilateral agreement, e.g. it may refer to final settlement for a contract.',
    },
    {
        name: 'ClearedIndicator',
        abbrName: 'Clrd',
        updated: 'FIX.5.0SP2',
        addedEP: '140',
        added: 'FIX.5.0SP2',
        type: 'ClearedIndicatorCodeSet',
        updatedEP: '196',
        id: 1832,
        description:
            'Indicates whether the trade or position being reported was cleared through a clearing organization.',
    },
    {
        name: 'ContractRefPosType',
        abbrName: 'ConRefPosTyp',
        addedEP: '140',
        added: 'FIX.5.0SP2',
        type: 'ContractRefPosTypeCodeSet',
        id: 1833,
        description:
            'Additional information related to the pricing of a commodity swaps position, specifically an indicator referring to the position type.',
    },
    {
        name: 'PositionCapacity',
        abbrName: 'PosCpcty',
        addedEP: '140',
        added: 'FIX.5.0SP2',
        type: 'PositionCapacityCodeSet',
        id: 1834,
        description: 'Used to describe the ownership of the position.',
    },
    {
        name: 'PosQtyUnitOfMeasureCurrency',
        abbrName: 'UOMCcy',
        addedEP: '140',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 1835,
        description:
            'Indicates the currency of the unit of measure if position quantity is expressed in valuation rather than contracts. Conditionally required when PosQtyUnitOfMeasure(1836)=Ccy.',
    },
    {
        name: 'PosQtyUnitOfMeasure',
        abbrName: 'UOM',
        addedEP: '140',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 1836,
        description: 'Indicates the unit of measure of the position quantity when not expressed in contracts.',
    },
    {
        name: 'UnderlyingContractPriceRefMonth',
        abbrName: 'PxRefMo',
        addedEP: '140',
        added: 'FIX.5.0SP2',
        type: 'MonthYear',
        id: 1837,
        description:
            'Reference month if there is no applicable UnderlyingMaturityMonth(313) value for the contract or security.',
    },
    {
        name: 'NoTradePriceConditions',
        updated: 'FIX.Latest',
        addedEP: '141',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        updatedEP: '275',
        id: 1838,
        description: 'Number of trade price conditions.',
    },
    {
        name: 'TradePriceCondition',
        abbrName: 'TrdPxCond',
        addedEP: '141',
        added: 'FIX.5.0SP2',
        type: 'TradePriceConditionCodeSet',
        id: 1839,
        description:
            'Price conditions in effect at the time of the trade. Multiple price conditions can be in effect at the same time. Price conditions are usually required to be reported in markets that have regulations on price execution at a market or national best bid or offer, and the trade price differs from the best bid or offer.',
    },
    {
        name: 'TradeAllocStatus',
        abbrName: 'Stat',
        addedEP: '141',
        added: 'FIX.5.0SP2',
        type: 'TradeAllocStatusCodeSet',
        id: 1840,
        description:
            'Identifies the status of an allocation when using a pre-clear workflow.\n\nNote: This is different from the give-up process where a trade is cleared and then given up and goes through the allocation flow.',
    },
    {
        name: 'NoTradeQtys',
        updated: 'FIX.Latest',
        addedEP: '141',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        updatedEP: '275',
        id: 1841,
        description: 'Number of trade quantities.',
    },
    {
        name: 'TradeQtyType',
        abbrName: 'Typ',
        addedEP: '141',
        added: 'FIX.5.0SP2',
        type: 'TradeQtyTypeCodeSet',
        id: 1842,
        description: 'Indicates the type of trade quantity in TradeQty(1843).',
    },
    {
        name: 'TradeQty',
        abbrName: 'Qty',
        addedEP: '141',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 1843,
        description: 'Trade quantity.',
    },
    {
        name: 'NoTradeAllocAmts',
        updated: 'FIX.Latest',
        addedEP: '141',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        updatedEP: '275',
        id: 1844,
        description: 'Number of trade allocation amount entries.',
    },
    {
        name: 'TradeAllocAmtType',
        abbrName: 'Typ',
        addedEP: '141',
        added: 'FIX.5.0SP2',
        type: 'PosAmtTypeCodeSet',
        id: 1845,
        description: 'Type of the amount associated with a trade allocation.',
    },
    {
        name: 'TradeAllocAmt',
        abbrName: 'Amt',
        addedEP: '141',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 1846,
        description: 'The amount associated with a trade allocation.',
    },
    {
        name: 'TradeAllocCurrency',
        abbrName: 'Ccy',
        addedEP: '141',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 1847,
        description: 'Currency denomination of the trade allocation amount.',
    },
    {
        name: 'TradeAllocGroupInstruction',
        abbrName: 'AllocGrpInst',
        addedEP: '141',
        added: 'FIX.5.0SP2',
        type: 'TradeAllocGroupInstructionCodeSet',
        id: 1848,
        description: 'Instruction on how to add a trade to an allocation group when it is being given-up.',
    },
    {
        name: 'OffsetInstruction',
        abbrName: 'OfstInst',
        addedEP: '141',
        added: 'FIX.5.0SP2',
        type: 'OffsetInstructionCodeSet',
        id: 1849,
        description: 'Indicates the trade is a result of an offset or onset.',
    },
    {
        name: 'TradeAllocAmtReason',
        abbrName: 'Rsn',
        unionDataType: 'Reserved1000Plus',
        addedEP: '141',
        added: 'FIX.5.0SP2',
        type: 'PosAmtReasonCodeSet',
        id: 1850,
        description:
            'Specifies the reason for an amount type when reported on an allocation. Useful when multiple instances of the same amount type are reported.',
    },
    {
        name: 'StrategyLinkID',
        abbrName: 'StrategyLinkID',
        addedEP: '141',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1851,
        description:
            'Identifies the multileg strategy (e.g. spread) to which the trade belongs. This links together trade legs executed as part of a strategy during a single match event.',
    },
    {
        name: 'SideAvgPx',
        abbrName: 'AvgPx',
        addedEP: '141',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 1852,
        description: 'Calculated average price for this side of the trade.',
    },
    {
        name: 'SideAvgPxIndicator',
        abbrName: 'AvgPxInd',
        updated: 'FIX.Latest',
        addedEP: '141',
        added: 'FIX.5.0SP2',
        type: 'AvgPxIndicatorCodeSet',
        updatedEP: '282',
        id: 1853,
        description:
            'Used to indicate whether a trade or a sub-allocation should be allocated at the trade price (e.g. no average pricing), or whether it should be grouped with other trades/sub-allocations and allocated at the average price of the group.',
    },
    {
        name: 'SideAvgPxGroupID',
        abbrName: 'AvgPxGrpID',
        addedEP: '141',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1854,
        description: 'The identifier for the average price group for the trade side. See also AvgPxGroupID(1731).',
    },
    {
        name: 'NoRelatedTrades',
        updated: 'FIX.Latest',
        addedEP: '142',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        updatedEP: '275',
        id: 1855,
        description: 'Number of related trades.',
    },
    {
        name: 'RelatedTradeID',
        abbrName: 'ID',
        addedEP: '142',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1856,
        discriminatorId: '1857',
        description: 'Identifier of a related trade.',
    },
    {
        name: 'RelatedTradeIDSource',
        abbrName: 'Src',
        addedEP: '142',
        added: 'FIX.5.0SP2',
        type: 'RelatedTradeIDSourceCodeSet',
        id: 1857,
        description: 'Describes the source of the identifier that RelatedTradeID(1856) represents.',
    },
    {
        name: 'RelatedTradeDate',
        abbrName: 'Dt',
        addedEP: '142',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 1858,
        description: 'Date of a related trade.',
    },
    {
        name: 'RelatedTradeMarketID',
        abbrName: 'MktID',
        addedEP: '142',
        added: 'FIX.5.0SP2',
        type: 'Exchange',
        id: 1859,
        description: 'Market of execution of related trade.',
    },
    {
        name: 'RelatedTradeQuantity',
        abbrName: 'Qty',
        addedEP: '142',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 1860,
        description:
            'Quantity of the related trade which can be less than or equal to the actual quantity of the related trade. For example, when one trade offsets another across asset classes.',
    },
    {
        name: 'NoRelatedPositions',
        updated: 'FIX.Latest',
        addedEP: '142',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        updatedEP: '275',
        id: 1861,
        description: 'Number of related positions.',
    },
    {
        name: 'RelatedPositionID',
        abbrName: 'ID',
        addedEP: '142',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1862,
        discriminatorId: '1863',
        description: 'Identifier of a related position.',
    },
    {
        name: 'RelatedPositionIDSource',
        abbrName: 'Src',
        addedEP: '142',
        added: 'FIX.5.0SP2',
        type: 'RelatedPositionIDSourceCodeSet',
        id: 1863,
        description: 'Describes the source of the identifier that RelatedPositionID(1862) represents.',
    },
    {
        name: 'RelatedPositionDate',
        abbrName: 'Dt',
        addedEP: '142',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 1864,
        description:
            'Used to help identify the position when RelatedPositionID(1862) is not unique across multiple days. This date is generally the creation date of the identifier.',
    },
    {
        name: 'QuoteAckStatus',
        abbrName: 'QtAckStat',
        addedEP: '143',
        added: 'FIX.5.0SP2',
        type: 'QuoteAckStatusCodeSet',
        id: 1865,
        description: 'Acknowledgement status of a Quote(35=S) or QuoteCancel(35=Z) message submission.',
    },
    {
        name: 'OfferID',
        abbrName: 'OfrID',
        addedEP: '144',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1867,
        description: 'Unique identifier for the ask side of the quote assigned by the quote issuer.',
    },
    {
        name: 'NoValueChecks',
        updated: 'FIX.Latest',
        addedEP: '144',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        updatedEP: '275',
        id: 1868,
        description: 'Number of value check entries.',
    },
    {
        name: 'ValueCheckType',
        abbrName: 'Typ',
        addedEP: '144',
        added: 'FIX.5.0SP2',
        type: 'ValueCheckTypeCodeSet',
        id: 1869,
        description: 'Type of value to be checked.',
    },
    {
        name: 'ValueCheckAction',
        abbrName: 'Actn',
        addedEP: '144',
        added: 'FIX.5.0SP2',
        type: 'ValueCheckActionCodeSet',
        id: 1870,
        description: 'Action to be taken for the ValueCheckType(1869).',
    },
    {
        name: 'LegSecurityXMLLen',
        addedEP: '145',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 1871,
        description: 'The length of the LegSecurityXML(1872) data block.',
    },
    {
        name: 'LegSecurityXML',
        abbrName: 'SecXML',
        updated: 'FIX.Latest',
        addedEP: '145',
        added: 'FIX.5.0SP2',
        type: 'XMLData',
        updatedEP: '275',
        id: 1872,
        lengthId: '1871',
        description: 'XML definition for the leg security.',
    },
    {
        name: 'LegSecurityXMLSchema',
        abbrName: 'Schema',
        addedEP: '145',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1873,
        description: 'The schema used to validate the contents of LegSecurityXML(1872).',
    },
    {
        name: 'UnderlyingSecurityXMLLen',
        addedEP: '145',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 1874,
        description: 'The length of the UnderlyingSecurityXML(1875) data block.',
    },
    {
        name: 'UnderlyingSecurityXML',
        abbrName: 'SecXML',
        updated: 'FIX.Latest',
        addedEP: '145',
        added: 'FIX.5.0SP2',
        type: 'XMLData',
        updatedEP: '275',
        id: 1875,
        lengthId: '1874',
        description: 'XML definition for the underlying security.',
    },
    {
        name: 'UnderlyingSecurityXMLSchema',
        abbrName: 'Schema',
        addedEP: '145',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1876,
        description: 'The schema used to validate the contents of UnderlyingSecurityXML(1875).',
    },
    {
        name: 'PartyDetailRequestResult',
        abbrName: 'ReqRslt',
        unionDataType: 'Reserved100Plus',
        addedEP: '146',
        added: 'FIX.5.0SP2',
        type: 'PartyDetailRequestResultCodeSet',
        id: 1877,
        description: 'Result party detail definition request.',
    },
    {
        name: 'PartyDetailRequestStatus',
        abbrName: 'ReqStat',
        addedEP: '146',
        added: 'FIX.5.0SP2',
        type: 'PartyDetailRequestStatusCodeSet',
        id: 1878,
        description: 'Status of party details definition request.',
    },
    {
        name: 'PartyDetailDefinitionStatus',
        abbrName: 'Stat',
        addedEP: '146',
        added: 'FIX.5.0SP2',
        type: 'PartyDetailDefinitionStatusCodeSet',
        id: 1879,
        description: 'Status of party detail definition for one party.',
    },
    {
        name: 'PartyDetailDefinitionResult',
        abbrName: 'Rslt',
        addedEP: '146',
        added: 'FIX.5.0SP2',
        type: 'PartyDetailRequestResultCodeSet',
        id: 1880,
        description: 'Result of party detail definition for one party.',
    },
    {
        name: 'EntitlementRequestResult',
        abbrName: 'ReqRslt',
        unionDataType: 'Reserved100Plus',
        addedEP: '146',
        added: 'FIX.5.0SP2',
        type: 'EntitlementRequestResultCodeSet',
        id: 1881,
        description: 'Result of risk limit definition request.',
    },
    {
        name: 'EntitlementRequestStatus',
        abbrName: 'ReqStat',
        addedEP: '146',
        added: 'FIX.5.0SP2',
        type: 'PartyDetailRequestStatusCodeSet',
        id: 1882,
        description: 'Status of party entitlements definition request.',
    },
    {
        name: 'EntitlementStatus',
        abbrName: 'Stat',
        updated: 'FIX.5.0SP2',
        addedEP: '146',
        added: 'FIX.5.0SP2',
        type: 'EntitlementStatusCodeSet',
        updatedEP: '173',
        id: 1883,
        description: 'Status of entitlement definition for one party.',
    },
    {
        name: 'EntitlementResult',
        abbrName: 'Rslt',
        addedEP: '146',
        added: 'FIX.5.0SP2',
        type: 'EntitlementRequestResultCodeSet',
        id: 1884,
        description: 'Result of entitlement definition for one party.',
    },
    {
        name: 'EntitlementRefID',
        abbrName: 'RefID',
        addedEP: '146',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1885,
        description: 'Reference to an EntitlementID(1776). Used for modification or deletion of an entitlement.',
    },
    {
        name: 'SettlPriceUnitOfMeasure',
        abbrName: 'SetPxUOM',
        addedEP: '147',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 1886,
        description: 'Used to express the unit of measure of the settlement price if different from the contract.',
    },
    {
        name: 'SettlPriceUnitOfMeasureCurrency',
        abbrName: 'SetPxUOMCcy',
        addedEP: '147',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 1887,
        description:
            'Indicates the currency of the settlement price unit of measure if expressed in another currency than the base currency.\n\nConditionally required when SettlPriceUnitOfMeasure(1886)=Ccy.',
    },
    {
        name: 'TradeMatchTimestamp',
        abbrName: 'MtchTS',
        addedEP: '150',
        added: 'FIX.5.0SP2',
        type: 'UTCTimestamp',
        id: 1888,
        description:
            'Timestamp of the match event. For off-exchange trades the time at which the deal was matched by the exchange.\n\nThis timestamp will be the same on all the trades and will not change when a trade is modified.',
    },
    {
        name: 'NoInstrmtMatchSides',
        updated: 'FIX.Latest',
        addedEP: '150',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        updatedEP: '275',
        id: 1889,
        description: 'Number of instrument match sides.',
    },
    {
        name: 'NoTrdMatchSides',
        updated: 'FIX.Latest',
        addedEP: '150',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        updatedEP: '275',
        id: 1890,
        description: 'Number of trade match sides.',
    },
    {
        name: 'TrdMatchSubID',
        abbrName: 'MtchSubID',
        updated: 'FIX.5.0SP2',
        addedEP: '150',
        added: 'FIX.5.0SP2',
        type: 'String',
        updatedEP: '215',
        id: 1891,
        description:
            'Used to identify each price level, step or clip within a match event.\n\nThe identifier may represent a grouping of matched resting orders at a given price level that was matched by an aggressor order. For example, an aggressive order sweeping through 2 price levels that included 3 resting orders would have two different TrdMatchSubID(1891) values.',
    },
    {
        name: 'NoLegExecs',
        updated: 'FIX.Latest',
        addedEP: '150',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        updatedEP: '275',
        id: 1892,
        description: 'Number of instrument leg executions.',
    },
    {
        name: 'LegExecID',
        abbrName: 'ExecID',
        addedEP: '150',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1893,
        description: 'The ExecID(17) value corresponding to a trade leg.',
    },
    {
        name: 'LegTradeID',
        abbrName: 'TrdID',
        addedEP: '150',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1894,
        description: 'The TradeID(1003) value corresponding to a trade leg.',
    },
    {
        name: 'LegTradeReportID',
        abbrName: 'RptID',
        addedEP: '150',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1895,
        description: 'The TradeReportID(571) value corresponding to a trade leg.',
    },
    {
        name: 'TradeMatchAckStatus',
        abbrName: 'MtchAckStat',
        addedEP: '150',
        added: 'FIX.5.0SP2',
        type: 'TradeMatchAckStatusCodeSet',
        id: 1896,
        description: 'Used to indicate the status of the trade match report submission.',
    },
    {
        name: 'TradeMatchRejectReason',
        abbrName: 'RejRsn',
        unionDataType: 'Reserved100Plus',
        addedEP: '150',
        added: 'FIX.5.0SP2',
        type: 'TradeMatchRejectReasonCodeSet',
        id: 1897,
        description: 'Reason the trade match report submission was rejected.',
    },
    {
        name: 'SideMarketSegmentID',
        abbrName: 'MktSegID',
        addedEP: '150',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1898,
        description: 'Identifies the market segment of the side.',
    },
    {
        name: 'SideVenueType',
        abbrName: 'VenuTyp',
        addedEP: '150',
        added: 'FIX.5.0SP2',
        type: 'VenueTypeCodeSet',
        id: 1899,
        description: 'Identifies the type of venue where the trade was executed for the side.',
    },
    {
        name: 'SideExecRefID',
        abbrName: 'ExecRefID',
        addedEP: '150',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1900,
        description: 'Used to reference the value from SideExecID(1427).',
    },
    {
        name: 'LegExecRefID',
        abbrName: 'ExecRefID',
        addedEP: '150',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1901,
        description: 'Used to reference the value from LegExecID(1893).',
    },
    {
        name: 'HaircutIndicator',
        abbrName: 'HrctInd',
        addedEP: '157',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 1902,
        description:
            'Indicates, if "Y", that a stated valuation includes a haircut, e.g. that the stated value reflects the subtraction of the haircut. Note that a value of "N" does not imply a haircut is not applicable, only that the haircut (if any) is not reflected in the stated valuation.',
    },
    {
        name: 'NumOfCompetitors',
        abbrName: 'NumCmptors',
        addedEP: '159',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 1913,
        description:
            'The number of competing Respondents (e.g. dealers) to receive a quote request (either via the QuoteRequest(35=R) or via other means).',
    },
    {
        name: 'ResponseTime',
        abbrName: 'RspTm',
        addedEP: '159',
        added: 'FIX.5.0SP2',
        type: 'UTCTimestamp',
        id: 1914,
        description:
            'The time by which a meaningful response should arrive back (always expressed in UTC (Universal Time Coordinated, also known as "GMT").\n\nThe meaning of the response time is specific to the context where the field is used.\n\nFor a QuoteRequest(35=R) message, this is the time by which the Quote(35=S) message should arrive to the initiator of the QuoteRequest(35=R) message.',
    },
    {
        name: 'QuoteDisplayTime',
        abbrName: 'QuotDsplyTm',
        addedEP: '159',
        added: 'FIX.5.0SP2',
        type: 'UTCTimestamp',
        id: 1915,
        description:
            'Time by which the quote will be displayed.\n\nFor example, the time the execution venue will display dealer(s) submitted quotes to market participant(s).',
    },
    {
        name: 'ExposureDurationUnit',
        abbrName: 'ExpsreDurUnit',
        addedEP: '159',
        added: 'FIX.5.0SP2',
        type: 'OrderDelayUnitCodeSet',
        id: 1916,
        description: 'Time unit in which the ExposureDuration(1629) is expressed.',
    },
    {
        name: 'CoverPrice',
        abbrName: 'CoverPx',
        addedEP: '159',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 1917,
        description: 'The best quoted price received among those not traded.',
    },
    {
        name: 'NoClearingAccountTypes',
        addedEP: '160',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1918,
        description: 'Number of clearing account type entries.',
    },
    {
        name: 'NoPriceMovements',
        addedEP: '160',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1919,
        description: 'Number of price movement entries.',
    },
    {
        name: 'NoPriceMovementValues',
        addedEP: '160',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1920,
        description: 'Number of price movement value entries.',
    },
    {
        name: 'PriceMovementValue',
        abbrName: 'Valu',
        addedEP: '160',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 1921,
        description: 'Value at specific price movement point.',
    },
    {
        name: 'PriceMovementPoint',
        abbrName: 'Pnt',
        addedEP: '160',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 1922,
        description:
            'Price movement point up (positive integer) or down (negative integer) relative to the underlying price of the instrument.',
    },
    {
        name: 'PriceMovementType',
        abbrName: 'Typ',
        addedEP: '160',
        added: 'FIX.5.0SP2',
        type: 'PriceMovementTypeCodeSet',
        id: 1923,
        description: 'Describes the format of the PriceMovementValue(1921).',
    },
    {
        name: 'EncodedEventTextLen',
        abbrName: 'EncTxtLen',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 1578,
        description: 'Byte length of encoded (non-ASCII characters) EncodedEventText(868) fied.',
    },
    {
        name: 'EncodedEventText',
        abbrName: 'EncTxt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 1579,
        lengthId: '1578',
        description:
            'Encoded (non-ASCII characters) representation of the EventText(868) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the EventText(868) field.',
    },
    {
        name: 'RegulatoryTradeID',
        abbrName: 'ID',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1903,
        discriminatorId: '1905',
        description:
            'Trade identifier required by government regulators or other regulatory organizations for regulatory reporting purposes. For example, unique swap identifer (USI) as required by the U.S. Commodity Futures Trading Commission.',
    },
    {
        name: 'RegulatoryTradeIDEvent',
        abbrName: 'Evnt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'RegulatoryTradeIDEventCodeSet',
        id: 1904,
        description:
            'Identifies the event which caused origination of the identifier in RegulatoryTradeID(1903). When more than one event is the cause, use the higher enumeration value. For example, if the identifier is originated due to an allocated trade which was cleared and reported, use the enumeration value 2 (Clearing).',
    },
    {
        name: 'RegulatoryTradeIDSource',
        abbrName: 'Src',
        updated: 'FIX.Latest',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'RegulatoryTradeIDSourceCodeSet',
        updatedEP: '275',
        id: 1905,
        description:
            'Identifies the reporting entity that originated the value in RegulatoryTradeID(1903). The reporting entity identifier may be assigned by a regulator or from a supported standard identifier source scheme.\n\nIn the context of CFTC usage for Unique Swap Identifier (USI), this field is required to convey the namespace of the entity creating the USI, in accordance to the USI Data Standard (https://www.cftc.gov/sites/default/files/idc/groups/public/@swaps/documents/dfsubmission/usidatastandards100112.pdf). For standardized identifier source schemes, such as the Unique Transaction Identifier (UTI), the source scheme is identified using supported code values.',
    },
    {
        name: 'RegulatoryTradeIDType',
        abbrName: 'Typ',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'RegulatoryTradeIDTypeCodeSet',
        updatedEP: '222',
        id: 1906,
        description:
            'Specifies the type of trade identifier provided in RegulatoryTradeID(1903).\n\nContextual hierarchy of events for the same trade or transaction maybe captured through use of the different RegulatoryTradeIDType(1906) values using multiple instances of the repeating group as needed for regulatory reporting.',
    },
    {
        name: 'NoRegulatoryTradeIDs',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1907,
        description: 'Number of regulatory IDs in the repeating group.',
    },
    {
        name: 'NoAllocRegulatoryTradeIDs',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1908,
        description: 'Number of regulatory IDs in the repeating group.',
    },
    {
        name: 'AllocRegulatoryTradeID',
        abbrName: 'ID',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1909,
        discriminatorId: '1910',
        description:
            'Trade identifier required by government regulators or other regulatory organizations for regulatory reporting purposes. For example, unique swap identifer (USI) as required by the U.S. Commodity Futures Trading Commission.',
    },
    {
        name: 'AllocRegulatoryTradeIDSource',
        abbrName: 'Src',
        updated: 'FIX.Latest',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'RegulatoryTradeIDSourceCodeSet',
        updatedEP: '275',
        id: 1910,
        description:
            'Identifies the reporting entity that originated the value in RegulatoryTradeID(1903). The reporting entity identifier may be assigned by a regulator or from a supported standard identifier source scheme.\n\nIn the context of CFTC usage for Unique Swap Identifier (USI), this field is required to convey the namespace of the entity creating the USI, in accordance to the USI Data Standard (https://www.cftc.gov/sites/default/files/idc/groups/public/@swaps/documents/dfsubmission/usidatastandards100112.pdf). For standardized identifier source schemes, such as the Unique Transaction Identifier (UTI), the source scheme is identified using supported code values.',
    },
    {
        name: 'AllocRegulatoryTradeIDEvent',
        abbrName: 'Evnt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'RegulatoryTradeIDEventCodeSet',
        id: 1911,
        description:
            'Identifies the event which caused the origination of the identifier in AllocRegulatoryTradeID(1909). When more than one event is the cause, use the higher enumeration value. For example, if the identifier is originated due to an allocated trade which was cleared and reported, use the enumeration value 2(Clearing).',
    },
    {
        name: 'AllocRegulatoryTradeIDType',
        abbrName: 'Typ',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'RegulatoryTradeIDTypeCodeSet',
        id: 1912,
        description:
            'Specifies the type of trade identifier provided in AllocRegulatoryTradeID(1909), within the context of the hierarchy of trade events.',
    },
    {
        name: 'ClearingIntention',
        abbrName: 'ClrIntn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ClearingIntentionCodeSet',
        id: 1924,
        description: "Specifies the party's or parties' intention to clear the trade.",
    },
    {
        name: 'TradeClearingInstruction',
        abbrName: 'ClrngInstrctn',
        unionDataType: 'Reserved4000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ClearingInstructionCodeSet',
        id: 1925,
        description: 'Specifies the eligibility of this trade for clearing and central counterparty processing.',
    },
    {
        name: 'BackloadedTradeIndicator',
        abbrName: 'BackTrdInd',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 1926,
        description: 'Indicates that the trade being reported occurred in the past and is still in effect or active.',
    },
    {
        name: 'ConfirmationMethod',
        abbrName: 'CnfmMeth',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ConfirmationMethodCodeSet',
        id: 1927,
        description: 'Specifies how a trade was confirmed.',
    },
    {
        name: 'MandatoryClearingIndicator',
        abbrName: 'MandClrInd',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 1928,
        description: 'An indication that the trade is flagged for mandatory clearing.',
    },
    {
        name: 'MixedSwapIndicator',
        abbrName: 'MixedSwapInd',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        updatedEP: '193',
        id: 1929,
        description:
            'An indication that the trade is a mixed swap.\n\nIn the context of CFTC , a "Mixed swap" is defined in the Commodity Exchange Act (CEA) section 1a(47)(D) as an instrument that is in part a swap subject to the jurisdiction of the CFTC, and in part a security-based swap subject to the jurisdiction of the SEC. When reporting the additional Swap Data Repositories must be identified in the appropriate Parties component with PartyRole(452) = 102 (Data repository), PartyRoleQualifier(2376) = 12 (Additional domestic trade repository) and PartySub-IDType(803) = 70 (Location or jurisdiction).',
    },
    {
        name: 'OffMarketPriceIndicator',
        abbrName: 'OffMktPxInd',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 1930,
        description: 'An indication that the price is off-market.',
    },
    {
        name: 'VerificationMethod',
        abbrName: 'VerfctnMeth',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'VerificationMethodCodeSet',
        id: 1931,
        description: 'Indication of how a trade was verified.',
    },
    {
        name: 'ClearingRequirementException',
        abbrName: 'ClrReqmtExcptn',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ClearingRequirementExceptionCodeSet',
        updatedEP: '177',
        id: 1932,
        description:
            "Specifies whether a party to a swap is using an exception to a clearing requirement. In the US, one such clearing requirement is CFTC's rule pursuant to CEA Section 2(h)(1).",
    },
    {
        name: 'IRSDirection',
        abbrName: 'IRSDirctn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'IRSDirectionCodeSet',
        id: 1933,
        description:
            'Used to specify whether the principal is paying or receiving the fixed rate in an interest rate swap.',
    },
    {
        name: 'RegulatoryReportType',
        abbrName: 'RegRptTyp',
        unionDataType: 'Reserved100Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'RegulatoryReportTypeCodeSet',
        id: 1934,
        description: 'Type of regulatory report.',
    },
    {
        name: 'VoluntaryRegulatoryReport',
        abbrName: 'VolntyRegRpt',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        updatedEP: '187',
        id: 1935,
        description:
            'Used in conjunction with RegulatoryReportType(1934) to indicate whether the trade report is a voluntary regulatory report. If not specified, the default for a regulatory report is "N".\n\nWhen VoluntaryRegulatoryReport(1935)=Y it is recommended that one of the parties to the trade be identified as the voluntary reporting party through PartySubIDType(803) = 63 (Voluntary reporting entity).',
    },
    {
        name: 'TradeCollateralization',
        abbrName: 'TrdCollztn',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'TradeCollateralizationCodeSet',
        updatedEP: '254',
        id: 1936,
        description:
            'Specifies how the trade is collateralized.\n\nIn the context of Dodd-Frank, all values shown except for 4 (Net exposure) apply.\n\nIn the context of ESMA EU SFTR reporting only the values 1 (Uncollateralized), 3 (Fully collateralized) and 4 (Net exposure) apply.',
    },
    {
        name: 'TradeContinuation',
        abbrName: 'TrdContntn',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'TradeContinuationCodeSet',
        updatedEP: '179',
        id: 1937,
        description:
            'Specifies the post-execution trade continuation or lifecycle event. Additional values may be used by mutual agreement of the counterparties.',
    },
    {
        name: 'AssetClass',
        abbrName: 'AssetClss',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'AssetClassCodeSet',
        id: 1938,
        description: 'The broad asset category for assessing risk exposure.',
    },
    {
        name: 'AssetSubClass',
        abbrName: 'AssetSubClss',
        unionDataType: 'Reserved4000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'AssetSubClassCodeSet',
        id: 1939,
        description: 'The subcategory description of the asset class.',
    },
    {
        name: 'AssetType',
        abbrName: 'AssetTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        updatedEP: '235',
        id: 1940,
        description:
            "Used to provide more specific description of the asset specified in AssetSubClass(1939).\n\nSee https://www.fixtrading.org/codelists/AssetType for code list of applicable values. ISO 4721 Currency Code values are to be used when specific currency as an asset type is to be expressed.\n\nOther values may be used by mutual agreement of the counterparties.\n\nIn the context of MiFID II's this may indicate the value needed in ESMA RTS 2 Annex IV Table 2 Field 16, or ESMA RTS 23 Annex I Table 2 'Sub product' field.",
    },
    {
        name: 'SwapClass',
        abbrName: 'SwapClss',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'SwapClassCodeSet',
        id: 1941,
        description:
            'The classification or type of swap. Additional values may be used by mutual agreement of the counterparties.',
    },
    {
        name: 'NthToDefault',
        abbrName: 'NthDflt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 1942,
        description:
            'The Nth reference obligation to default in a CDS reference basket. If specified without MthToDefault(1943) the default will trigger a CDS payout. If MthToDefault(1943) is also present then payout occurs between the Nth and Mth obligations to default.',
    },
    {
        name: 'MthToDefault',
        abbrName: 'MthDflt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 1943,
        description:
            'The Mth reference obligation to default in a CDS reference basket. When NthToDefault(1942) and MthToDefault(1943) are represented then the CDS payout occurs between the Nth and Mth obligations to default.',
    },
    {
        name: 'SettledEntityMatrixSource',
        abbrName: 'SettldMtrxSrc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1944,
        description: 'Relevant settled entity matrix source.',
    },
    {
        name: 'SettledEntityMatrixPublicationDate',
        abbrName: 'SettldMtrxDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 1945,
        description:
            'The publication date of the applicable version of the matrix. If not specified, the Standard Terms Supplement defines rules for which version of the matrix is applicable.',
    },
    {
        name: 'CouponType',
        abbrName: 'CpnTyp',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'CouponTypeCodeSet',
        id: 1946,
        description: 'Coupon type of the bond.',
    },
    {
        name: 'TotalIssuedAmount',
        abbrName: 'TotIssuedAmt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 1947,
        description:
            'Specifies the total amount of the issue. Corresponds to the par value multiplied by the number of issued securities.',
    },
    {
        name: 'CouponFrequencyPeriod',
        abbrName: 'CpnPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 1948,
        description: "Time unit multiplier for the frequency of the bond's coupon payment.",
    },
    {
        name: 'CouponFrequencyUnit',
        abbrName: 'CpnUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'CouponFrequencyUnitCodeSet',
        id: 1949,
        description: "Time unit associated with the frequency of the bond's coupon payment.",
    },
    {
        name: 'CouponDayCount',
        abbrName: 'CpnDayCnt',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'CouponDayCountCodeSet',
        updatedEP: '200',
        id: 1950,
        description:
            'The day count convention used in interest calculations for a bond or an interest bearing security. Absence of this field for a bond or an interest bearing security transaction implies a "flat" trade, i.e. no accrued interest determined at time of the transaction.',
    },
    {
        name: 'ConvertibleBondEquityID',
        abbrName: 'CnvrtBondEqtyID',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1951,
        discriminatorId: '1952',
        description: 'Identifies the equity in which a convertible bond can be converted to.',
    },
    {
        name: 'ConvertibleBondEquityIDSource',
        abbrName: 'CnvrtBondEqtyIDSrc',
        unionDataType: 'Reserved100Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'SecurityIDSourceCodeSet',
        id: 1952,
        description:
            'Identifies class or source of the ConvertibleBondEquityID(1951) value.\n\n100+ are reserved for private security.',
    },
    {
        name: 'ContractPriceRefMonth',
        abbrName: 'PxRefMo',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'MonthYear',
        id: 1953,
        description:
            'Reference month if there is no applicable MaturityMonthYear(200) value for the contract or security.',
    },
    {
        name: 'LienSeniority',
        abbrName: 'LienSnrty',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LienSeniorityCodeSet',
        id: 1954,
        description: 'Indicates the seniority level of the lien in a loan.',
    },
    {
        name: 'LoanFacility',
        abbrName: 'LoanFclty',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LoanFacilityCodeSet',
        id: 1955,
        description: "Specifies the type of loan when the credit default swap's reference obligation is a loan.",
    },
    {
        name: 'ReferenceEntityType',
        abbrName: 'RefEntityTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ReferenceEntityTypeCodeSet',
        updatedEP: '192',
        id: 1956,
        description: 'Specifies the type of reference entity for first-to-default CDS basket contracts.',
    },
    {
        name: 'IndexSeries',
        abbrName: 'NdxSeries',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 1957,
        description: 'The series identifier of a credit default swap index.',
    },
    {
        name: 'IndexAnnexVersion',
        abbrName: 'NdxAnxVer',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 1958,
        description: 'The version of a credit default swap index annex.',
    },
    {
        name: 'IndexAnnexDate',
        abbrName: 'NdxAnxDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 1959,
        description: 'The date of a credit default swap index series annex.',
    },
    {
        name: 'IndexAnnexSource',
        abbrName: 'NdxAnxSrc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1960,
        description: 'The source of a credit default swap series annex.',
    },
    {
        name: 'AgreementVersion',
        abbrName: 'AgmtVer',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1961,
        description: 'The version of the master agreement',
    },
    {
        name: 'MasterConfirmationDesc',
        abbrName: 'CnfmDesc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1962,
        description:
            'The type of master confirmation executed between the parties.\n\nSee http://www.fpml.org/coding-scheme/master-confirmation-type for values.',
    },
    {
        name: 'MasterConfirmationDate',
        abbrName: 'CnfmDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 1963,
        description:
            'Alternative to broker confirmation. The date of the confirmation executed between the parties and intended to govern all relevant transactions between those parties.',
    },
    {
        name: 'MasterConfirmationAnnexDesc',
        abbrName: 'CnfmAnxDesc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1964,
        description:
            'The type of master confirmation annex executed between the parties.\n\nSee http://www.fpml.org/coding-scheme/master-confirmation-annex-type for values.',
    },
    {
        name: 'MasterConfirmationAnnexDate',
        abbrName: 'CnfmAnxDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 1965,
        description: 'The date that an annex to the master confirmation was executed between the parties.',
    },
    {
        name: 'BrokerConfirmationDesc',
        abbrName: 'BrkrCnfmDesc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1966,
        description:
            'Describes the type of broker confirmation executed between the parites. Can be used as an alterative to MasterConfirmationDesc(1962). See http://www.fpml.org/coding-scheme/broker-confirmation-type for values.',
    },
    {
        name: 'CreditSupportAgreementDesc',
        abbrName: 'CrdSuprtDesc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1967,
        description:
            'The type of ISDA Credit Support Agreement. See http://www.fpml.org/coding-scheme/credit-support-agreement-type for values.',
    },
    {
        name: 'CreditSupportAgreementDate',
        abbrName: 'CrdSuprtDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 1968,
        description:
            'The date of the ISDA Credit Support Agreement executed between the parties and intended to govern collateral arrangements for all OTC derivatives transactions between those parties.',
    },
    {
        name: 'CreditSupportAgreementID',
        abbrName: 'CrdSuprtID',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1969,
        description:
            'A common reference or unique identifier to identify the ISDA Credit Support Agreement executed between the parties.',
    },
    {
        name: 'GoverningLaw',
        abbrName: 'Law',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1970,
        description:
            'Identification of the law governing the transaction. See http://www.fpml.org/coding-scheme/governing-law for values.',
    },
    {
        name: 'NoSideRegulatoryTradeIDs',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1971,
        description: 'Number of regulatory IDs in the repeating group.',
    },
    {
        name: 'SideRegulatoryTradeID',
        abbrName: 'ID',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1972,
        discriminatorId: '1973',
        description:
            'Trade identifier required by government regulators or other regulatory organziations for regulatory reporting purposes. For example, unique swap identifier (USI) as required by the U.S. Commodity Futures Trading Commission.',
    },
    {
        name: 'SideRegulatoryTradeIDSource',
        abbrName: 'Src',
        updated: 'FIX.Latest',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'RegulatoryTradeIDSourceCodeSet',
        updatedEP: '275',
        id: 1973,
        description:
            'Identifies the reporting entity that originated the value in RegulatoryTradeID(1903). The reporting entity identifier may be assigned by a regulator or from a supported standard identifier source scheme.\n\nIn the context of CFTC usage for Unique Swap Identifier (USI), this field is required to convey the namespace of the entity creating the USI, in accordance to the USI Data Standard (https://www.cftc.gov/sites/default/files/idc/groups/public/@swaps/documents/dfsubmission/usidatastandards100112.pdf). For standardized identifier source schemes, such as the Unique Transaction Identifier (UTI), the source scheme is identified using supported code values.',
    },
    {
        name: 'SideRegulatoryTradeIDEvent',
        abbrName: 'Evnt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'RegulatoryTradeIDEventCodeSet',
        id: 1974,
        description:
            'Identifies the event which caused origination of the identifier in SideRegulatoryTradeID(1972). When more than one event is the cause, use the higher enumeration value. For example, if the identifier is originated due to an allocated trade which was cleared and reported, use the enumeration value 2 (Clearing).',
    },
    {
        name: 'SideRegulatoryTradeIDType',
        abbrName: 'Typ',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'RegulatoryTradeIDTypeCodeSet',
        id: 1975,
        description:
            'Specifies the type of trade identifier provided in SideRegulatoryTradeID(1972), within the context of the hierarchy of trade events.',
    },
    {
        name: 'NoSecondaryAssetClasses',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1976,
        description: 'Number of secondary asset classes in the repeating group.',
    },
    {
        name: 'SecondaryAssetClass',
        abbrName: 'Clss',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'AssetClassCodeSet',
        id: 1977,
        description: 'The broad asset category for assessing risk exposure for a multi-asset trade.',
    },
    {
        name: 'SecondaryAssetSubClass',
        abbrName: 'SubClss',
        unionDataType: 'Reserved4000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'AssetSubClassCodeSet',
        id: 1978,
        description: 'An indication of the general description of the asset class.',
    },
    {
        name: 'SecondaryAssetType',
        abbrName: 'Typ',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        updatedEP: '235',
        id: 1979,
        description:
            "Used to provide more specific description of the asset specified in SecondaryAssetSubClass(1978).\n\nSee https://www.fixtrading.org/codelists/AssetType for code list of applicable values. ISO 4721 Currency Code values are to be used when specific currency as an asset type is to be expressed.\n\nOther values may be used by mutual agreement of the counterparties.\n\nIn the context of MiFID II's this may indicate the value needed in ESMA RTS 2 Annex IV Table 2 Field 16, or ESMA RTS 23 Annex I Table 2 'Sub product' field.",
    },
    {
        name: 'BlockTrdAllocIndicator',
        abbrName: 'BlckTrdAllocInd',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BlockTrdAllocIndicatorCodeSet',
        id: 1980,
        description: 'Indication that a block trade will be allocated.',
    },
    {
        name: 'NoUnderlyingEvents',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 1981,
        description: 'Number of events in the repeating group.',
    },
    {
        name: 'UnderlyingEventType',
        abbrName: 'Typ',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'EventTypeCodeSet',
        id: 1982,
        description: 'Code to represent the type of event.',
    },
    {
        name: 'UnderlyingEventDate',
        abbrName: 'Dt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 1983,
        description: 'The date of the event.',
    },
    {
        name: 'UnderlyingEventTime',
        abbrName: 'Tm',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'UTCTimestamp',
        id: 1984,
        description: 'The time of the event. To be used in combination with UnderlyingEventDate(1983).',
    },
    {
        name: 'UnderlyingEventTimeUnit',
        abbrName: 'TmUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1985,
        description: 'Time unit associated with the event.',
    },
    {
        name: 'UnderlyingEventTimePeriod',
        abbrName: 'TmPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 1986,
        description: 'Time unit multiplier for the event.',
    },
    {
        name: 'UnderlyingEventPx',
        abbrName: 'Px',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 1987,
        description: 'Predetermined price of issue at event, if applicable.',
    },
    {
        name: 'UnderlyingConstituentWeight',
        abbrName: 'ConstuentWt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 1988,
        description:
            'For a basket, or pool, describes the weight of each of the constituents within the basket. If not provided, it is assumed to be equal weighted.',
    },
    {
        name: 'UnderlyingCouponType',
        abbrName: 'CpnTyp',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'CouponTypeCodeSet',
        id: 1989,
        description: 'Specifies the coupon type of the underlying bond.',
    },
    {
        name: 'UnderlyingTotalIssuedAmount',
        abbrName: 'TotIssuedAmt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 1990,
        description:
            'Specifies the total amount of the issue. Corresponds to the par value multiplied by the number of issued security.',
    },
    {
        name: 'UnderlyingCouponFrequencyPeriod',
        abbrName: 'CpnPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 1991,
        description: "Time unit multiplier for the frequency of the bond's coupon payment.",
    },
    {
        name: 'UnderlyingCouponFrequencyUnit',
        abbrName: 'CpnUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'CouponFrequencyUnitCodeSet',
        id: 1992,
        description: "Time unit associated with the frequency of the bond's coupon payment.",
    },
    {
        name: 'UnderlyingCouponDayCount',
        abbrName: 'CpnDayCnt',
        unionDataType: 'Reserved100Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'CouponDayCountCodeSet',
        id: 1993,
        description:
            'The day count convention used in interest calculations for a bond or an interest bearing security.',
    },
    {
        name: 'UnderlyingObligationID',
        abbrName: 'ObligID',
        updated: 'FIX.Latest',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        updatedEP: '271',
        id: 1994,
        discriminatorId: '1995',
        description:
            'For a CDS basket or pool identifies the reference obligation.\n\nUnderlyingObligationID(1994) is reserved for the reference entity for baskets or pools. In a CDS single name the reference entity is identified in instrument ID and the obligations are identified in UnderlyingObligationID(1994).',
    },
    {
        name: 'UnderlyingObligationIDSource',
        abbrName: 'ObligIDSrc',
        unionDataType: 'Reserved100Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'SecurityIDSourceCodeSet',
        id: 1995,
        description: 'Identifies the source scheme of the UnderlyingObligationID(1994).',
    },
    {
        name: 'UnderlyingEquityID',
        abbrName: 'EqtyID',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1996,
        discriminatorId: '1997',
        description: 'Specifies the equity in which a convertible bond can be converted.',
    },
    {
        name: 'UnderlyingEquityIDSource',
        abbrName: 'EqtyIDSrc',
        unionDataType: 'Reserved100Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'SecurityIDSourceCodeSet',
        id: 1997,
        description: 'Identifies the source of the UnderlyingEquityID(1996).',
    },
    {
        name: 'UnderlyingLienSeniority',
        abbrName: 'LienSnrty',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LienSeniorityCodeSet',
        id: 1998,
        description: 'Indicates the seniority level of the lien in a loan.',
    },
    {
        name: 'UnderlyingLoanFacility',
        abbrName: 'LoanFclty',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LoanFacilityCodeSet',
        id: 1999,
        description: "Specifies the type of loan when the credit default swap's reference obligation is a loan.",
    },
    {
        name: 'UnderlyingReferenceEntityType',
        abbrName: 'RefEntityTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ReferenceEntityTypeCodeSet',
        updatedEP: '192',
        id: 2000,
        description: 'Specifies the type of reference entity for first-to-default CDS basket contracts.',
    },
    {
        name: 'UnderlyingProtectionTermXIDRef',
        abbrName: 'ProtctnXIDRef',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'XIDREF',
        id: 41314,
        description:
            'Reference to the protection terms applicable to this entity or obligation. Contains the same XID named string value of the instance in the ProtectionTerms repeating group that applies to this Underlying.',
    },
    {
        name: 'UnderlyingSettlTermXIDRef',
        abbrName: 'SettlXIDRef',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'XIDREF',
        id: 41315,
        description:
            'Reference to the cash or physical settlement terms applicable to this entity or obligation. Contains the same XID named string value of the instance in the appropriate repeating group that applies to this Underlying.',
    },
    {
        name: 'UnderlyingIndexSeries',
        abbrName: 'NdxSeries',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2003,
        description: 'The series identifier of a credit default swap index.',
    },
    {
        name: 'UnderlyingIndexAnnexVersion',
        abbrName: 'NdxAnxVer',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2004,
        description: 'The version identifier of a credit default swap index annex.',
    },
    {
        name: 'UnderlyingIndexAnnexDate',
        abbrName: 'NdxAnxDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 2005,
        description: 'The date of a credit default swap index series annex.',
    },
    {
        name: 'UnderlyingIndexAnnexSource',
        abbrName: 'NdxAnxSrc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2006,
        description: 'The source of a credit default swap index series annex.',
    },
    {
        name: 'UnderlyingProductComplex',
        abbrName: 'ProdCmplx',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2007,
        description:
            'Identifies an entire suite of products for a given market. In Futures this may be "interest rates", "agricultural", "equity indexes", etc',
    },
    {
        name: 'UnderlyingSecurityGroup',
        abbrName: 'SecGrp',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2008,
        description:
            'An exchange specific name assigned to a group of related securities which may be concurrently affected by market events and actions.',
    },
    {
        name: 'UnderlyingSettleOnOpenFlag',
        abbrName: 'SettlOnOpenFlag',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2009,
        description: 'Indicator to determine if Instrument is Settle on Open.',
    },
    {
        name: 'UnderlyingAssignmentMethod',
        abbrName: 'AsgnMeth',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'InstrmtAssignmentMethodCodeSet',
        id: 2010,
        description: 'Method under which assignment was conducted',
    },
    {
        name: 'UnderlyingSecurityStatus',
        abbrName: 'Status',
        updated: 'FIX.Latest',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'SecurityStatusCodeSet',
        updatedEP: '271',
        id: 2011,
        description: 'Indicates the current state of the underlying instrument.',
    },
    {
        name: 'UnderlyingObligationType',
        abbrName: 'ObligTyp',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'UnderlyingObligationTypeCodeSet',
        id: 2012,
        description: 'Type of reference obligation for credit derivatives contracts.',
    },
    {
        name: 'UnderlyingAssetClass',
        abbrName: 'AssetClss',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'AssetClassCodeSet',
        id: 2013,
        description: 'The broad asset category for assessing risk exposure.',
    },
    {
        name: 'UnderlyingAssetSubClass',
        abbrName: 'AssetSubClss',
        unionDataType: 'Reserved4000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'AssetSubClassCodeSet',
        id: 2014,
        description: 'An indication of the general description of the asset class.',
    },
    {
        name: 'UnderlyingAssetType',
        abbrName: 'AssetTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        updatedEP: '235',
        id: 2015,
        description:
            "Used to provide more specific description of the asset specified in UnderlyingAssetSubClass(2082).\n\nSee https://www.fixtrading.org/codelists/AssetType for code list of applicable values. ISO 4721 Currency Code values are to be used when specific currency as an asset type is to be expressed.\n\nOther values may be used by mutual agreement of the counterparties.\n\nIn the context of MiFID II's this may indicate the value needed in ESMA RTS 2 Annex IV Table 2 Field 16, or ESMA RTS 23 Annex I Table 2 'Sub product' field.",
    },
    {
        name: 'UnderlyingSwapClass',
        abbrName: 'SwapClss',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'SwapClassCodeSet',
        id: 2016,
        description:
            'The type or classification of swap. Additional values may be used by mutual agreement of the counterparties.',
    },
    {
        name: 'UnderlyingNthToDefault',
        abbrName: 'NthDflt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2017,
        description:
            'The Nth reference obligation to default in a CDS reference basket. If specified without UnderlyingMthToDefault(2018) the default will trigger a CDS payout. If UnderlyingMthToDefault(2018) is also present then payout occurs between the Nth and Mth obligations to default.',
    },
    {
        name: 'UnderlyingMthToDefault',
        abbrName: 'MthDflt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2018,
        description:
            'The Mth reference obligation to default in a CDS reference basket. When UnderlyingNthToDefault(2017) and UnderlyingMthToDefault(2018) are represented then the CDS payout occurs between the Nth and Mth obligations to default.',
    },
    {
        name: 'UnderlyingSettledEntityMatrixSource',
        abbrName: 'SettldMtrxSrc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2019,
        description: 'Relevant settled entity matrix source.',
    },
    {
        name: 'UnderlyingSettledEntityMatrixPublicationDate',
        abbrName: 'SettldMtrxDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 2020,
        description:
            'Specifies the publication date of the applicable version of the matrix. If not specified, the Standard Terms Supplement defines rules for which version of the matrix is applicable.',
    },
    {
        name: 'UnderlyingStrikeMultiplier',
        abbrName: 'StrkMult',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 2021,
        description:
            'Used for derivatives. Multiplier applied to the strike price for the purpose of calculating the settlement value.',
    },
    {
        name: 'UnderlyingStrikeValue',
        abbrName: 'StrkValu',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 2022,
        description:
            'Used for derivatives. The number of shares/units for the financial instrument involved in the option trade.',
    },
    {
        name: 'UnderlyingStrikePriceDeterminationMethod',
        abbrName: 'StrkPxDtrmnMeth',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'StrikePriceDeterminationMethodCodeSet',
        updatedEP: '169',
        id: 2023,
        description:
            'Specifies how the strike price is determined at the point of option exercise. The strike may be fixed throughout the life of the option, set at expiration to the value of the underlying, set to the average value of the underlying , or set to the optimal value of the underlying.',
    },
    {
        name: 'UnderlyingStrikePriceBoundaryMethod',
        abbrName: 'StrkPxBndryMeth',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'StrikePriceBoundaryMethodCodeSet',
        id: 2024,
        description:
            'Specifies the boundary condition to be used for the strike price relative to the underlying price at the point of option exercise.',
    },
    {
        name: 'UnderlyingStrikePriceBoundaryPrecision',
        abbrName: 'StrkPxBndryPrcsn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 2025,
        description:
            'Used in combination with StrikePriceBoundaryMethod(1479) to specify the percentage of the strike price in relation to the underlying price. The percentage is generally 100 or greater for puts and 100 or less for calls.',
    },
    {
        name: 'UnderlyingMinPriceIncrement',
        abbrName: 'MinPxIncr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 2026,
        description: 'Minimum price increment for the instrument. Could also be used to represent tick value.',
    },
    {
        name: 'UnderlyingMinPriceIncrementAmount',
        abbrName: 'MinPxIncrAmt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 2027,
        description:
            'Minimum price increment amount associated with the UnderlyingMinPriceIncrement(2026). For listed derivatives, the value can be calculated by multiplying UnderlyingMinPriceIncrement(2026) by UnderlyingContractMultiplier(436).',
    },
    {
        name: 'UnderlyingOptPayoutType',
        abbrName: 'OptPayoutTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'OptPayoutTypeCodeSet',
        updatedEP: '238',
        id: 2028,
        description: 'Indicates the type of valuation method or payout trigger for an in-the-money option.',
    },
    {
        name: 'UnderlyingOptPayoutAmount',
        abbrName: 'OptPayAmt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 2029,
        description:
            'Cash amount indicating the pay out associated with an option. For binary options this is a fixed amount.',
    },
    {
        name: 'UnderlyingPriceQuoteMethod',
        abbrName: 'PxQteMeth',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PriceQuoteMethodCodeSet',
        id: 2030,
        description: 'Method for price quotation.',
    },
    {
        name: 'UnderlyingValuationMethod',
        abbrName: 'ValMeth',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ValuationMethodCodeSet',
        id: 2031,
        description: 'Indicates type of valuation method used.',
    },
    {
        name: 'UnderlyingListMethod',
        abbrName: 'ListMeth',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ListMethodCodeSet',
        id: 2032,
        description: 'Indicates whether the instruments are pre-listed only or can also be defined via user request.',
    },
    {
        name: 'UnderlyingCapPrice',
        abbrName: 'CapPx',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 2033,
        description: 'Used to express the ceiling price of a capped call.',
    },
    {
        name: 'UnderlyingFloorPrice',
        abbrName: 'FlrPx',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 2034,
        description: 'Used to express the floor price of a capped put.',
    },
    {
        name: 'UnderlyingFlexibleIndicator',
        abbrName: 'FlexInd',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2035,
        description:
            'Used to indicate if a security has been defined as flexible according to "non-standard" means. Analog to CFICode Standard/Non-standard indicator.',
    },
    {
        name: 'UnderlyingFlexProductEligibilityIndicator',
        abbrName: 'FlexProdElig',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2036,
        description: 'Used to indicate if a product or group of product supports the creation of flexible securities.',
    },
    {
        name: 'UnderlyingPositionLimit',
        abbrName: 'PosLmt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2037,
        description: 'Position limit for the instrument.',
    },
    {
        name: 'UnderlyingNTPositionLimit',
        abbrName: 'NTPosLmt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2038,
        description: 'Position Limit in the near-term contract for a given exchange-traded product.',
    },
    {
        name: 'UnderlyingPool',
        abbrName: 'Pool',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2039,
        description: 'Identifies the mortgage backed security (MBS) / asset backed security (ABS) pool.',
    },
    {
        name: 'UnderlyingContractSettlMonth',
        abbrName: 'CSetMo',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'MonthYear',
        id: 2040,
        description: 'Specifies when the contract (i.e. MBS/TBA) will settle. Must be present for MBS/TBA.',
    },
    {
        name: 'UnderlyingDatedDate',
        abbrName: 'Dated',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 2041,
        description: 'If different from IssueDate()',
    },
    {
        name: 'UnderlyingInterestAccrualDate',
        abbrName: 'IntAcrl',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 2042,
        description: 'If different from IssueDate and DatedDate',
    },
    {
        name: 'UnderlyingShortSaleRestriction',
        abbrName: 'ShrtRstctn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ShortSaleRestrictionCodeSet',
        id: 2043,
        description: 'Indicates whether a restriction applies to short selling a security.',
    },
    {
        name: 'UnderlyingRefTickTableID',
        abbrName: 'RefTickTblID',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2044,
        description: 'Spread table code referred by the security or symbol.',
    },
    {
        name: 'NoUnderlyingComplexEvents',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2045,
        description: 'Number of complex events in the repeating group.',
    },
    {
        name: 'UnderlyingComplexEventType',
        abbrName: 'Typ',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventTypeCodeSet',
        id: 2046,
        description: 'Identifies the type of complex event.',
    },
    {
        name: 'UnderlyingComplexOptPayoutAmount',
        abbrName: 'OptPayAmt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 2047,
        description:
            'Cash amount indicating the pay out associated with an event. For binary options this is a fixed amount.',
    },
    {
        name: 'UnderlyingComplexEventPrice',
        abbrName: 'Px',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 2048,
        description:
            'Specifies the price at which the complex event takes effect. Impact of the event price is determined by the UnderlyingComplexEventType(2046).',
    },
    {
        name: 'UnderlyingComplexEventPriceBoundaryMethod',
        abbrName: 'PxBndryMeth',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventPriceBoundaryMethodCodeSet',
        id: 2049,
        description:
            'Specifies the boundary condition to be used for the event price relative to the UnderlyingComplexEventPrice(2048) at the point the complex event outcome takes effect as determined by the UnderlyingComplexEventPriceTimeType(2051).',
    },
    {
        name: 'UnderlyingComplexEventPriceBoundaryPrecision',
        abbrName: 'PxBndryPrcsn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 2050,
        description:
            'Used in combination with UnderlyingComplexEventPriceBoundaryMethod(2049) to specify the percentage of the strike price in relation to the underlying price. The percentage is generally 100 or greater for puts and 100 or less for calls.',
    },
    {
        name: 'UnderlyingComplexEventPriceTimeType',
        abbrName: 'PxTmTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventPriceTimeTypeCodeSet',
        updatedEP: '169',
        id: 2051,
        description:
            'Specifies when the complex event outcome takes effect. The outcome of a complex event is a payout or barrier action as specified by the UnderlyingComplexEventType(2046).',
    },
    {
        name: 'UnderlyingComplexEventCondition',
        abbrName: 'Cond',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventConditionCodeSet',
        id: 2052,
        description:
            'Specifies the condition between complex events when more than one event is specified.\n\nMultiple barrier events would use an "or" condition since only one can be effective at a given time. A set of digital range events would use an "and" condition since both conditions must be in effect for a payout to result.',
    },
    {
        name: 'NoUnderlyingComplexEventDates',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2053,
        description: 'Number of underlying complex event dates in the repeating group.',
    },
    {
        name: 'UnderlyingComplexEventStartDate',
        abbrName: 'StartDt',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'UTCDateOnly',
        updatedEP: '195',
        id: 2054,
        description:
            'The start date of the date range on which a complex event is effective. The start date will be set equal to the end date for single day events such as Bermuda options.\n\nThe start date must always be less than or equal to end date.',
    },
    {
        name: 'UnderlyingComplexEventEndDate',
        abbrName: 'EndDt',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'UTCDateOnly',
        updatedEP: '195',
        id: 2055,
        description:
            'The end date of the date range on which a complex event is effective. The start date will be set equal to the end date for single day events such as Bermuda options.\n\nUnderlyingComplexEventEndDate(2056) must always be greater than or equal to UnderlyingComplexEventStartDate(2055).',
    },
    {
        name: 'NoUnderlyingComplexEventTimes',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2056,
        description: 'Number of complex event times in the repeating group.',
    },
    {
        name: 'UnderlyingComplexEventStartTime',
        abbrName: 'StartTm',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'UTCTimeOnly',
        id: 2057,
        description:
            'The start time of the time range on which a complex event date is effective.\n\nUnderlyingComplexEventStartTime(2057) must always be less than or equal to UndelryingComplexEventEndTime(2058).',
    },
    {
        name: 'UnderlyingComplexEventEndTime',
        abbrName: 'EndTm',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'UTCTimeOnly',
        id: 2058,
        description:
            'The end time of the time range on which a complex event date is effective.\n\nUnderlyingComplexEventEndTime(2058) must always be greater than or equal to UnderlyingComplexEventStartTime(2057).',
    },
    {
        name: 'NoLegEvents',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2059,
        description: 'Number of events in the repeating group',
    },
    {
        name: 'LegEventType',
        abbrName: 'Typ',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'EventTypeCodeSet',
        id: 2060,
        description: 'Code to represent the type of event.',
    },
    {
        name: 'LegEventDate',
        abbrName: 'Dt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 2061,
        description: 'The date of the event.',
    },
    {
        name: 'LegEventTime',
        abbrName: 'Tm',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'UTCTimestamp',
        id: 2062,
        description: 'Specific time of event. To be used in combination with LegEventDate(2061).',
    },
    {
        name: 'LegEventTimeUnit',
        abbrName: 'TmUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'EventTimeUnitCodeSet',
        id: 2063,
        description: 'Time unit associated with the event.',
    },
    {
        name: 'LegEventTimePeriod',
        abbrName: 'TmPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2064,
        description: 'Time unit multiplier for the event.',
    },
    {
        name: 'LegEventPx',
        abbrName: 'Px',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 2065,
        description: 'Predetermined price of issue at event, if applicable.',
    },
    {
        name: 'LegEventText',
        abbrName: 'Txt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2066,
        description:
            'Free form text to specify additional information or enumeration description when a standard value does not apply.',
    },
    {
        name: 'LegAssetClass',
        abbrName: 'AssetClss',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'AssetClassCodeSet',
        id: 2067,
        description: 'The broad asset category for assessing risk exposure.',
    },
    {
        name: 'LegAssetSubClass',
        abbrName: 'AssetSubClss',
        unionDataType: 'Reserved4000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'AssetSubClassCodeSet',
        id: 2068,
        description: 'The general subcategory description of the asset class.',
    },
    {
        name: 'LegAssetType',
        abbrName: 'AssetTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        updatedEP: '235',
        id: 2069,
        description:
            "Used to provide more specific description of the asset specified in LegAssetSubClass(2068).\n\nSee https://www.fixtrading.org/codelists/AssetType for code list of applicable values. ISO 4721 Currency Code values are to be used when specific currency as an asset type is to be expressed.\n\nOther values may be used by mutual agreement of the counterparties.\n\nIn the context of MiFID II's this may indicate the value needed in ESMA RTS 2 Annex IV Table 2 Field 16, or ESMA RTS 23 Annex I Table 2 'Sub product' field.",
    },
    {
        name: 'LegSwapClass',
        abbrName: 'SwapClss',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'SwapClassCodeSet',
        id: 2070,
        description: 'Swap type.',
    },
    {
        name: 'UnderlyingEventText',
        abbrName: 'Txt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2071,
        description: 'Free form text to specify comments related to the event.',
    },
    {
        name: 'EncodedUnderlyingEventTextLen',
        abbrName: 'EncTxtLen',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 2072,
        description: 'Byte length of encoded (non-ASCII characters) EncodedUnderlyingEventText(2073) field.',
    },
    {
        name: 'EncodedUnderlyingEventText',
        abbrName: 'EncTxt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 2073,
        lengthId: '2072',
        description:
            'Encoded (non-ASCII characters) representation of the UnderlyingEventText(2071) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the UnderlyingEventText(2071) field.',
    },
    {
        name: 'EncodedLegEventTextLen',
        abbrName: 'EncTxtLen',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 2074,
        description: 'Byte length of encoded (non-ASCII characters) EncodedLegEventText(2075) field.',
    },
    {
        name: 'EncodedLegEventText',
        abbrName: 'EncTxt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 2075,
        lengthId: '2074',
        description:
            'Encoded (non-ASCII characters) representation of the LegEventText(2066) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the LegEventText(2066) field.',
    },
    {
        name: 'NoLegSecondaryAssetClasses',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2076,
        description: 'Number of secondary asset classes in the repeating group.',
    },
    {
        name: 'LegSecondaryAssetClass',
        abbrName: 'Clss',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'AssetClassCodeSet',
        id: 2077,
        description: 'The broad asset category for assessing risk exposure for a multi-asset trade.',
    },
    {
        name: 'LegSecondaryAssetSubClass',
        abbrName: 'SubClss',
        unionDataType: 'Reserved4000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'AssetSubClassCodeSet',
        id: 2078,
        description: 'An indication of the general description of the asset class.',
    },
    {
        name: 'LegSecondaryAssetType',
        abbrName: 'Typ',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        updatedEP: '235',
        id: 2079,
        description:
            "Used to provide more specific description of the asset specified in LegSecondaryAssetSubClass(2078).\n\nSee https://www.fixtrading.org/codelists/AssetType for code list of applicable values. ISO 4721 Currency Code values are to be used when specific currency as an asset type is to be expressed.\n\nOther values may be used by mutual agreement of the counterparties.\n\nIn the context of MiFID II's this may indicate the value needed in ESMA RTS 2 Annex IV Table 2 Field 16, or ESMA RTS 23 Annex I Table 2 'Sub product' field.",
    },
    {
        name: 'NoUnderlyingSecondaryAssetClasses',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2080,
        description: 'Number of secondary asset classes in the repeating group.',
    },
    {
        name: 'UnderlyingSecondaryAssetClass',
        abbrName: 'Clss',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'AssetClassCodeSet',
        id: 2081,
        description: 'The broad asset category for assessing risk exposure for a multi-asset trade.',
    },
    {
        name: 'UnderlyingSecondaryAssetSubClass',
        abbrName: 'SubClss',
        unionDataType: 'Reserved4000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'AssetSubClassCodeSet',
        id: 2082,
        description: 'An indication of the general description of the asset class.',
    },
    {
        name: 'UnderlyingSecondaryAssetType',
        abbrName: 'Typ',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        updatedEP: '235',
        id: 2083,
        description:
            "Used to provide more specific description of the asset specified in UnderlyingSecondaryAssetSubClass(2082).\n\nSee https://www.fixtrading.org/codelists/AssetType for code list of applicable values. ISO 4721 Currency Code values are to be used when specific currency as an asset type is to be expressed.\n\nOther values may be used by mutual agreement of the counterparties.\n\nIn the context of MiFID II's this may indicate the value needed in ESMA RTS 2 Annex IV Table 2 Field 16, or ESMA RTS 23 Annex I Table 2 'Sub product' field.",
    },
    {
        name: 'NoAdditionalTermBondRefs',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40000,
        description: 'Number of bonds in the repeating group.',
    },
    {
        name: 'AdditionalTermBondSecurityID',
        abbrName: 'ID',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40001,
        discriminatorId: '40002',
        description: 'Security identifier of the bond.',
    },
    {
        name: 'AdditionalTermBondSecurityIDSource',
        abbrName: 'Src',
        unionDataType: 'Reserved100Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'SecurityIDSourceCodeSet',
        id: 40002,
        description: 'Identifies the source scheme of the AdditionalTermBondSecurityID(40001) value.',
    },
    {
        name: 'AdditionalTermBondDesc',
        abbrName: 'Desc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40003,
        description: 'Description of the bond.',
    },
    {
        name: 'EncodedAdditionalTermBondDescLen',
        abbrName: 'EncDescLen',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 40004,
        description: 'Byte length of encoded (non-ASCII characters) EncodedAdditionalTermBondDesc(40005) field.',
    },
    {
        name: 'EncodedAdditionalTermBondDesc',
        abbrName: 'EncDesc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 40005,
        lengthId: '40004',
        description:
            'Encoded (non-ASCII characters) representation of the AdditionalTermBondDesc(40003) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the AdditionalTermBondDesc(40003) field.',
    },
    {
        name: 'AdditionalTermBondCurrency',
        abbrName: 'Ccy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 40006,
        description: 'Specifies the currency the bond value is denominated in. Uses ISO 4217 currency codes.',
    },
    {
        name: 'AdditionalTermBondIssuer',
        abbrName: 'Issr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40007,
        description: 'Issuer of the bond.',
    },
    {
        name: 'EncodedAdditionalTermBondIssuerLen',
        abbrName: 'EncIssrLen',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 40008,
        description: 'Byte length of encoded (non-ASCII characters) EncodedAdditionalTermBondIssuer(40009) field.',
    },
    {
        name: 'EncodedAdditionalTermBondIssuer',
        abbrName: 'EncIssr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 40009,
        lengthId: '40008',
        description:
            'Encoded (non-ASCII characters) representation of the AdditionalTermBondIssuer(40007) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the AdditionalTermBondIssuer(40007) field.',
    },
    {
        name: 'AdditionalTermBondSeniority',
        abbrName: 'Snrty',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'SeniorityCodeSet',
        id: 40010,
        description: "Specifies the bond's payment priority in the event of a default.",
    },
    {
        name: 'AdditionalTermBondCouponType',
        abbrName: 'CpnTyp',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'CouponTypeCodeSet',
        id: 40011,
        description: 'Coupon type of the bond.',
    },
    {
        name: 'AdditionalTermBondCouponRate',
        abbrName: 'CpnRt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40012,
        description: 'Coupon rate of the bond. See also CouponRate(223).',
    },
    {
        name: 'AdditionalTermBondMaturityDate',
        abbrName: 'MatDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40013,
        description: 'The maturity date of the bond.',
    },
    {
        name: 'AdditionalTermBondParValue',
        abbrName: 'Par',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 40014,
        description: 'The par value of the bond.',
    },
    {
        name: 'AdditionalTermBondCurrentTotalIssuedAmount',
        abbrName: 'CurTotAmt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 40015,
        description: 'Total issued amount of the bond.',
    },
    {
        name: 'AdditionalTermBondCouponFrequencyPeriod',
        abbrName: 'CpnPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40016,
        description: "Time unit multiplier for the frequency of the bond's coupon payment.",
    },
    {
        name: 'AdditionalTermBondCouponFrequencyUnit',
        abbrName: 'CpnUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'CouponFrequencyUnitCodeSet',
        id: 40017,
        description: "Time unit associated with the frequency of the bond's coupon payment.",
    },
    {
        name: 'AdditionalTermBondDayCount',
        abbrName: 'DayCnt',
        unionDataType: 'Reserved100Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'CouponDayCountCodeSet',
        id: 40018,
        description:
            'The day count convention used in interest calculations for a bond or an interest bearing security.',
    },
    {
        name: 'NoAdditionalTerms',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40019,
        description: 'Number of additional terms in the repeating group.',
    },
    {
        name: 'AdditionalTermConditionPrecedentBondIndicator',
        abbrName: 'PrcdntInd',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 40020,
        description:
            'Indicates whether the condition precedent bond is applicable. The swap contract is only valid if the bond is issued and if there is any dispute over the terms of fixed stream then the bond terms would be used.',
    },
    {
        name: 'AdditionalTermDiscrepancyClauseIndicator',
        abbrName: 'DscrpncyInd',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 40021,
        description: 'Indicates whether the discrepancy clause is applicable.',
    },
    {
        name: 'NoCashSettlTerms',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40022,
        description: 'Number of elements in the repeating group.',
    },
    {
        name: 'CashSettlCurrency',
        abbrName: 'Ccy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 40023,
        description:
            'Specifies the currency the CashSettlAmount(40034) is denominated in. Uses ISO 4217 currency codes.',
    },
    {
        name: 'CashSettlValuationFirstBusinessDayOffset',
        abbrName: 'BizDayOfst',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40024,
        description:
            'The number of business days after settlement conditions have been satisfied, when the calculation agent is to obtain a price quotation on the reference obligation for the purpose of cash settlement.\n\nAssociated with ISDA 2003 Term: Valuation Date.',
    },
    {
        name: 'CashSettlValuationSubsequentBusinessDaysOffset',
        abbrName: 'SbsqntBizDayOfst',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40916,
        description:
            'The number of business days between successive valuation dates when multiple valuation dates are applicable for cash settlement.\n\nAssociated with ISDA 2003 Term: Valuation Date',
    },
    {
        name: 'CashSettlNumOfValuationDates',
        abbrName: 'NumValDts',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40917,
        description:
            'Where multiple valuation dates are specified as being applicable for cash settlement, this specifies the number of applicable valuation dates.\n\nAssociated with ISDA 2003 Term: Valuation Date',
    },
    {
        name: 'CashSettlValuationTime',
        abbrName: 'ValTm',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 40025,
        description: 'The time of valuation.',
    },
    {
        name: 'CashSettlBusinessCenter',
        abbrName: 'BizCtr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40026,
        description:
            'Identifies the business center calendar used at valuation time for cash settlement purposes e.g. "GBLO". See http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'CashSettlQuoteMethod',
        abbrName: 'QteMeth',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'CashSettlQuoteMethodCodeSet',
        id: 40027,
        description: 'The type of quote used to determine the cash settlement price.',
    },
    {
        name: 'CashSettlQuoteAmount',
        abbrName: 'QteAmt',
        updated: 'FIX.Latest',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        updatedEP: '271',
        id: 40028,
        description:
            'When determining the cash settlement amount, if weighted average price quotes are to be obtained for the reference obligation, this is the upper limit to the outstanding principal balance of the reference obligation for which the quote should be obtained. If not specified, the ISDA definitions provide for a fallback amount equal to floating rate payer calculation amount.\n\nISDA 2003 Term: Quotation Amount.',
    },
    {
        name: 'CashSettlQuoteCurrency',
        abbrName: 'QteCcy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 40029,
        description:
            'Specifies the currency the CashSettlQuoteAmount(40028) is denominated in. Uses ISO 4217 Currency Code.',
    },
    {
        name: 'CashSettlMinimumQuoteAmount',
        abbrName: 'MinQteAmt',
        updated: 'FIX.Latest',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        updatedEP: '271',
        id: 40030,
        description:
            'When determining the cash settlement amount, if weighted average price quotes are to be obtained for the reference obligation, this is the minimum intended threshold amount of outstanding principal balance of the reference obligation for which the quote should be obtained. If not specified, the ISDA definitions provide for a fallback amount of the lower of either USD1,000,000 (or its equivalent in the relevant obligation currency) or the (minimum) quoted amount.\n\nISDA 2003 Term: Minimum Quotation Amount.',
    },
    {
        name: 'CashSettlMinimumQuoteCurrency',
        abbrName: 'MinQteCcy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 40031,
        description:
            'Specifies the currency the CashSettlMinimumQuoteAmount(40030) is denominated in. Uses ISO 4217 Currency Code.',
    },
    {
        name: 'CashSettlDealer',
        abbrName: 'Dlr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40032,
        description:
            'Identifies the dealer from whom price quotations for the reference obligation are obtained for the purpose of cash settlement valuation calculation.\n\nISDA 2003 Term: Dealer.',
    },
    {
        name: 'CashSettlBusinessDays',
        abbrName: 'BizDays',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40033,
        description:
            'The number of business days used in the determination of the cash settlement payment date.\n\nIf a cash settlement amount is specified, the cash settlement payment date will be this number of business days following the calculation of the final price. If a cash settlement amount is not specified, the cash settlement payment date will be this number of business days after all conditions to settlement are satisfied.\n\nISDA 2003 Term: Cash Settlement Date.',
    },
    {
        name: 'CashSettlAmount',
        abbrName: 'Amt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 40034,
        description:
            'The amount paid between the trade parties, seller to the buyer, for cash settlement on the cash settlement date.\n\nIf not specified this is not to be included in the message and the parties to the trade are expected to calculate the value. The value is the greater of (a) floating rate payer calculation amount x (reference price - final price) or (b) zero. Price values are all expressed as a percentage. ISDA 2003 Term: Cash Settlement Amount',
    },
    {
        name: 'CashSettlRecoveryFactor',
        abbrName: 'RcvryFctr',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'float',
        updatedEP: '169',
        id: 40035,
        description:
            'Used for fixed recovery, this specifies the recovery level as determined at contract inception, to be applied in the event of a default. The factor is used to calculate the amount paid by the seller to the buyer for cash settlement on the cash settlement date. The amount calculated is (1 - CashSettlRecoveryFactor(40035)) x floating rate payer calculation amount. The currency is derived from the floating rate payer calculation amount.',
    },
    {
        name: 'CashSettlFixedTermIndicator',
        abbrName: 'FixedInd',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 40036,
        description: 'Indicates whether fixed settlement is applicable or not applicable in a recovery lock.',
    },
    {
        name: 'CashSettlAccruedInterestIndicator',
        abbrName: 'AcrdIntInd',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 40037,
        description:
            'Indicates whether accrued interest is included or not in the value provided in CashSettlAmount(40034). For cash settlement this specifies whether quotations should be obtained inclusive or not of accrued interest.\n\nFor physical settlement this specifies whether the buyer should deliver the obligation with an outstanding principal balance that includes or excludes accrued interest.\n\nISDA 2003 Term: Include/Exclude Accrued Interest.',
    },
    {
        name: 'CashSettlValuationMethod',
        abbrName: 'ValMeth',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'CashSettlValuationMethodCodeSet',
        id: 40038,
        description:
            'The ISDA defined methodology for determining the final price of the reference obligation for purposes of cash settlement.\n\nISDA 2003 Term: Valuation Method',
    },
    {
        name: 'CashSettlTermXID',
        abbrName: 'XID',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'XID',
        id: 40039,
        description: 'A named string value referenced by UnderlyingSettlTermXIDRef(41315).',
    },
    {
        name: 'NoContractualDefinitions',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40040,
        description: 'Number of financing definitions in the repeating group.',
    },
    {
        name: 'ContractualDefinition',
        abbrName: 'Def',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40041,
        description:
            'Specifies which contract definition, such as those published by ISDA, will apply for the terms of the trade. See http://www.fpml.org/coding-scheme/contractual-definitions for values.',
    },
    {
        name: 'NoContractualMatrices',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40042,
        description: 'Number of contractual matrices in the repeating group.',
    },
    {
        name: 'ContractualMatrixSource',
        abbrName: 'Src',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        updatedEP: '192',
        id: 40043,
        description:
            'Identifies the applicable contract matrix. See http://www.fpml.org/coding-scheme/matrix-type-1-0.xml for values.',
    },
    {
        name: 'ContractualMatrixDate',
        abbrName: 'Dt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40044,
        description:
            'The publication date of the applicable version of the contract matrix. If not specified, the ISDA Standard Terms Supplement defines rules for which version of the matrix is applicable.',
    },
    {
        name: 'ContractualMatrixTerm',
        abbrName: 'Trm',
        updated: 'FIX.Latest',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        updatedEP: '271',
        id: 40045,
        description:
            'Specifies the applicable key into the relevant contract matrix. In the case of 2000 ISDA Definitions Settlement Matrix for Early Termination and Swaptions, the ContractualMatrixTerm(40045) is not applicable and is to be omitted.\n\nSee http://www.fpml.org/coding-scheme/credit-matrix-transaction-type for values.',
    },
    {
        name: 'NoFinancingTermSupplements',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40046,
        description: 'Number of financing terms supplements in the repeating group.',
    },
    {
        name: 'FinancingTermSupplementDesc',
        abbrName: 'Desc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40047,
        description:
            'Identifies the applicable contractual supplement. See http://www.fpml.org/coding-scheme/contractual-supplement for values.',
    },
    {
        name: 'FinancingTermSupplementDate',
        abbrName: 'Dt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40048,
        description: 'The publication date of the applicable version of the contractual supplement.',
    },
    {
        name: 'NoStreams',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40049,
        description: 'Number of swap streams in the repeating group.',
    },
    {
        name: 'StreamType',
        abbrName: 'Typ',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'StreamTypeCodeSet',
        id: 40050,
        description: 'Type of swap stream.',
    },
    {
        name: 'StreamDesc',
        abbrName: 'Desc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40051,
        description:
            'A short descriptive name given to the payment stream. Eg. CDS, Fixed, Float, Float2, GBP. The description has no intrinsic meaning but should be arbitrarily chosen by the remitter as reference.',
    },
    {
        name: 'StreamPaySide',
        abbrName: 'PaySide',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentPaySideCodeSet',
        id: 40052,
        description: 'The side of the party paying the stream.',
    },
    {
        name: 'StreamReceiveSide',
        abbrName: 'RcvSide',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentPaySideCodeSet',
        id: 40053,
        description: 'The side of the party receiving the stream.',
    },
    {
        name: 'StreamNotional',
        abbrName: 'Notl',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 40054,
        description:
            'Notional, or initial notional value for the payment stream. Use the PaymentScheduleGrp component to specify the rate steps.',
    },
    {
        name: 'StreamCurrency',
        abbrName: 'Ccy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 40055,
        description:
            'Specifies the currency the StreamNotional(40054) is denominated in. Uses ISO 4217 currency codes.',
    },
    {
        name: 'StreamText',
        abbrName: 'Txt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40056,
        description:
            'Free form text to specify additional information or enumeration description when a standard value does not apply.',
    },
    {
        name: 'UnderlyingStreamEffectiveDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40057,
        description: 'The unadjusted effective date.',
    },
    {
        name: 'UnderlyingStreamEffectiveDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40058,
        description:
            "The business day convention used to adjust the underlying instrument's stream's effective, or relative effective, date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.",
    },
    {
        name: 'UnderlyingStreamEffectiveDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40059,
        description:
            'The business center calendar used to adjust the underlying instrument\'s stream\'s effective, or relative effective, date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'UnderlyingStreamEffectiveDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40060,
        description:
            'Specifies the anchor date when the effective date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'UnderlyingStreamEffectiveDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40061,
        description: 'Time unit multiplier for the relative effective date offset.',
    },
    {
        name: 'UnderlyingStreamEffectiveDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 40062,
        description: 'Time unit associated with the relative effective date offset.',
    },
    {
        name: 'UnderlyingStreamEffectiveDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40063,
        description: 'Specifies the day type of the relative effective date offset.',
    },
    {
        name: 'UnderlyingStreamEffectiveDateAdjusted',
        abbrName: 'Dt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40064,
        description: 'The adjusted effective date.',
    },
    {
        name: 'StreamTerminationDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40065,
        description: 'The unadjusted termination date.',
    },
    {
        name: 'StreamTerminationDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40066,
        description:
            "The business day convention used to adjust the instrument's stream's termination, or relative termination, date. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.",
    },
    {
        name: 'StreamTerminationDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40067,
        description:
            'The business center calendar used to adjust the instrument\'s stream\'s termination, or relative termination, date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'StreamTerminationDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40068,
        description:
            'Specifies the anchor date when the termination date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'StreamTerminationDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40069,
        description: 'Time unit multiplier for the relative termination date offset.',
    },
    {
        name: 'StreamTerminationDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 40070,
        description: 'Time unit associated with the relative termination date offset.',
    },
    {
        name: 'StreamTerminationDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40071,
        description: 'Specifies the day type of the relative termination date offset.',
    },
    {
        name: 'StreamTerminationDateAdjusted',
        abbrName: 'Dt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40072,
        description: 'The adjusted termination date.',
    },
    {
        name: 'StreamCalculationPeriodBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40073,
        description:
            'The business day convention used to adjust calculation periods. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.',
    },
    {
        name: 'StreamCalculationPeriodBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40074,
        description:
            'The business center calendar used to adjust calculation periods, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'StreamFirstPeriodStartDateUnadjusted',
        abbrName: 'FirstStartDtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40075,
        description: 'The unadjusted first calculation period start date if before the effective date.',
    },
    {
        name: 'StreamFirstPeriodStartDateBusinessDayConvention',
        abbrName: 'FirstStartDtBizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40076,
        description:
            "The business day convention used to adjust the instrument's stream's first calculation period start date. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.",
    },
    {
        name: 'StreamFirstPeriodStartDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40077,
        description:
            'The business center calendar used to adjust the instrument\'s stream\'s first calculation period start date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'StreamFirstPeriodStartDateAdjusted',
        abbrName: 'FirstStartDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40078,
        description: 'The adjusted first calculation period start date, if it is before the effective date.',
    },
    {
        name: 'StreamFirstRegularPeriodStartDateUnadjusted',
        abbrName: 'FirstReglrStartDtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40079,
        description:
            'The unadjusted first start date of the regular calculation period, if there is an initial stub period.',
    },
    {
        name: 'StreamFirstCompoundingPeriodEndDateUnadjusted',
        abbrName: 'FirstCmpndgEndDtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40080,
        description: 'The unadjusted end date of the initial compounding period.',
    },
    {
        name: 'StreamLastRegularPeriodEndDateUnadjusted',
        abbrName: 'LastReglrEndDtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40081,
        description: 'The unadjusted last regular period end date if there is a final stub period.',
    },
    {
        name: 'StreamCalculationFrequencyPeriod',
        abbrName: 'FreqPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40082,
        description: 'Time unit multiplier for the frequency at which calculation period end dates occur.',
    },
    {
        name: 'StreamCalculationFrequencyUnit',
        abbrName: 'FreqUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'CouponFrequencyUnitCodeSet',
        id: 40083,
        description: 'Time unit associated with the frequency at which calculation period end dates occur.',
    },
    {
        name: 'StreamCalculationRollConvention',
        abbrName: 'Roll',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'DateRollConventionCodeSet',
        id: 40084,
        description:
            'The convention for determining the sequence of end dates. It is used in conjunction with a specified frequency. Used only to override the roll convention specified in the DateAdjustment component within the Instrument component.',
    },
    {
        name: 'NoSettlRateFallbacks',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40085,
        description: 'Number of settlement rate fallbacks in the repeating group',
    },
    {
        name: 'SettlRatePostponementMaximumDays',
        abbrName: 'MaxDays',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40086,
        description:
            'The maximum number of days to wait for a quote from the disrupted settlement rate option before proceding to this method.',
    },
    {
        name: 'LegPaymentStreamNonDeliverableSettlRateSource',
        abbrName: 'RtSrc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'RateSourceCodeSet',
        id: 40087,
        description: 'Identifies the source of the rate information.',
    },
    {
        name: 'SettlRatePostponementSurvey',
        abbrName: 'Survey',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 40088,
        description: 'Indicates whether to request a settlement rate quote from the market.',
    },
    {
        name: 'SettlRatePostponementCalculationAgent',
        abbrName: 'CalcAgent',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ProvisionCalculationAgentCodeSet',
        id: 40089,
        description: 'Used to identify the settlement rate postponement calculation agent.',
    },
    {
        name: 'NoProvisions',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40090,
        description: 'Number of provisions in the repeating group.',
    },
    {
        name: 'ProvisionType',
        abbrName: 'Typ',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ProvisionTypeCodeSet',
        id: 40091,
        description: 'Type of provisions.',
    },
    {
        name: 'ProvisionDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40092,
        description: 'The unadjusted date of the provision.',
    },
    {
        name: 'ProvisionDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40093,
        description:
            "The business day convention used to adjust the instrument's provision's dates. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.",
    },
    {
        name: 'ProvisionDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40094,
        description:
            'The business center calendar used to adjust the instrument\'s provision\'s dates, e.g. "GBLO". See http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'ProvisionDateAdjusted',
        abbrName: 'Dt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40095,
        description: 'The adjusted date of the provision.',
    },
    {
        name: 'ProvisionDateTenorPeriod',
        abbrName: 'TenorPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40096,
        description: "Time unit multiplier for the provision's tenor period.",
    },
    {
        name: 'ProvisionDateTenorUnit',
        abbrName: 'TenorUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ProvisionDateTenorUnitCodeSet',
        id: 40097,
        description: "Time unit associated with the provision's tenor period.",
    },
    {
        name: 'ProvisionCalculationAgent',
        abbrName: 'CalcAgent',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ProvisionCalculationAgentCodeSet',
        id: 40098,
        description:
            'Used to identify the calculation agent. The calculation agent may be identified in ProvisionCalculationAgent(40098) or in the ProvisionParties component.',
    },
    {
        name: 'ProvisionOptionSinglePartyBuyerSide',
        abbrName: 'BuyerSide',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ProvisionOptionSinglePartyBuyerSideCodeSet',
        id: 40099,
        description:
            'If optional early termination is not available to both parties then this component identifies the buyer of the option through its side of the trade.',
    },
    {
        name: 'ProvisionOptionSinglePartySellerSide',
        abbrName: 'SellerSide',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ProvisionOptionSinglePartyBuyerSideCodeSet',
        updatedEP: '169',
        id: 40100,
        description:
            'If optional early termination is not available to both parties then this component identifies the seller of the option through its side of the trade.',
    },
    {
        name: 'ProvisionOptionExerciseStyle',
        abbrName: 'ExerStyle',
        unionDataType: 'Reserved100Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ExerciseStyleCodeSet',
        id: 40101,
        description: 'The instrument provision option’s exercise style.',
    },
    {
        name: 'ProvisionOptionExerciseMultipleNotional',
        abbrName: 'MultplNotl',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 40102,
        description:
            'A notional amount which restricts the amount of notional that can be exercised when partial exercise or multiple exercise is applicable. The integral multiple amount defines a lower limit of notional that can be exercised and also defines a unit multiple of notional that can be exercised, i.e. only integer multiples of this amount can be exercised.',
    },
    {
        name: 'ProvisionOptionExerciseMinimumNotional',
        abbrName: 'MinNotl',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 40103,
        description: 'The minimum notional amount that can be exercised on a given exercise date.',
    },
    {
        name: 'ProvisionOptionExerciseMaximumNotional',
        abbrName: 'MaxNotl',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 40104,
        description: 'The maximum notional amount that can be exercised on a given exercise date.',
    },
    {
        name: 'ProvisionOptionMinimumNumber',
        abbrName: 'MinNum',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40105,
        description: 'The minimum number of options that can be exercised on a given exercise date.',
    },
    {
        name: 'ProvisionOptionMaximumNumber',
        abbrName: 'MaxNum',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40106,
        description:
            'The maximum number of options that can be exercised on a given exercise date. If the number is not specified, it means that the maximum number of options corresponds to the remaining unexercised options.',
    },
    {
        name: 'ProvisionOptionExerciseConfirmation',
        abbrName: 'ExerCnfm',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 40107,
        description:
            "Used to indicate whether follow-up confirmation of exercise (written or electronic) is required following telephonic notice by the buyer to the seller or seller's agent.",
    },
    {
        name: 'ProvisionCashSettlMethod',
        abbrName: 'SettlMeth',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ProvisionCashSettlMethodCodeSet',
        updatedEP: '169',
        id: 40108,
        description:
            'An ISDA defined cash settlement method used for the determination of the applicable cash settlement amount. The method is defined in the 2006 ISDA Definitions, Section 18.3. Cash Settlement Methods, paragraph (e).',
    },
    {
        name: 'ProvisionCashSettlCurrency',
        abbrName: 'SettlCcy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 40109,
        description: 'Specifies the currency of settlement. Uses ISO 4217 currency codes.',
    },
    {
        name: 'ProvisionCashSettlCurrency2',
        abbrName: 'SettlCcy2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 40110,
        description:
            'Specifies the currency of settlement for a cross-currency provision. Uses ISO 4217 currency codes.',
    },
    {
        name: 'ProvisionCashSettlQuoteType',
        abbrName: 'SettlQteTyp',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ProvisionCashSettlQuoteTypeCodeSet',
        id: 40111,
        description: 'Identifies the type of quote to be used.',
    },
    {
        name: 'ProvisionCashSettlQuoteSource',
        abbrName: 'SettlQteSrc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexSourceCodeSet',
        id: 40112,
        description: 'Identifies the source of quote information.',
    },
    {
        name: 'ProvisionText',
        abbrName: 'Txt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40113,
        description:
            'Free form text to specify additional information or enumeration description when a standard value does not apply.',
    },
    {
        name: 'ProvisionCashSettlValueTime',
        abbrName: 'Tm',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 40114,
        description:
            'A time specified in 24-hour format, e.g. 11am would be represented as 11:00:00. The time of the cash settlement valuation date when the cash settlement amount will be determined according to the cash settlement method if the parties have not otherwise been able to agree to the cash settlement amount.',
    },
    {
        name: 'ProvisionCashSettlValueTimeBusinessCenter',
        abbrName: 'TmBizCtr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40115,
        description:
            "Identifies the business center calendar used with the provision's cash settlement valuation time. See http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.",
    },
    {
        name: 'ProvisionCashSettlValueDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        updatedEP: '187',
        id: 40116,
        description:
            'The cash settlement valuation date adjustment business day convention. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.',
    },
    {
        name: 'ProvisionCashSettlValueDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40117,
        description:
            'The business center calendar used to adjust the provision\'s cash settlement valuation date, e.g. "GBLO". See http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'ProvisionCashSettlValueDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40118,
        description:
            'Specifies the anchor date when the cash settlement value date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values',
    },
    {
        name: 'ProvisionCashSettlValueDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 40119,
        description: 'Time unit multiplier for the relative cash settlement value date offset.',
    },
    {
        name: 'ProvisionCashSettlValueDateOffsetUnit',
        abbrName: 'OfstUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 40120,
        description: 'Time unit associated with the relative cash settlement value date offset.',
    },
    {
        name: 'ProvisionCashSettlValueDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40121,
        description: "Specifies the day type of the provision's relative cash settlement value date offset.",
    },
    {
        name: 'ProvisionCashSettlValueDateAdjusted',
        abbrName: 'Dt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40122,
        description: 'The adjusted cash settlement value date.',
    },
    {
        name: 'ProvisionOptionExerciseBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40123,
        description:
            "The business day convention used to adjust the instrument's provision's option exercise date. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.",
    },
    {
        name: 'ProvisionOptionExerciseBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40124,
        description:
            'The business center calendar used to adjust the instrument\'s provision\'s option exercise date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'ProvisionOptionExerciseEarliestDateOffsetPeriod',
        abbrName: 'ErlstOfstPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40125,
        description:
            'Time unit multiplier for the interval to the first (and possibly only) exercise date in the exercise period.',
    },
    {
        name: 'ProvisionOptionExerciseEarliestDateOffsetUnit',
        abbrName: 'ErlstOfstUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ProvisionOptionExerciseEarliestDateOffsetUnitCodeSet',
        id: 40126,
        description:
            'Time unit associated with the interval to the first (and possibly only) exercise date in the exercise period.',
    },
    {
        name: 'ProvisionOptionExerciseFrequencyPeriod',
        abbrName: 'FreqPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40127,
        description:
            'Time unit multiplier for the frequency of subsequent exercise dates in the exercise period following the earliest exercise date. An interval of 1 day should be used to indicate an American style exercise period.',
    },
    {
        name: 'ProvisionOptionExerciseFrequencyUnit',
        abbrName: 'FreqUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'CouponFrequencyUnitCodeSet',
        id: 40128,
        description:
            'Time unit associated with the frequency of subsequent exercise dates in the exercise period following the earliest exercise date.',
    },
    {
        name: 'ProvisionOptionExerciseStartDateUnadjusted',
        abbrName: 'StartDtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40129,
        description: 'The unadjusted first day of the exercise period for an American style option.',
    },
    {
        name: 'ProvisionOptionExerciseStartDateRelativeTo',
        abbrName: 'StartDtReltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40130,
        description:
            'Specifies the anchor date when the option exercise start date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'ProvisionOptionExerciseStartDateOffsetPeriod',
        abbrName: 'StartDtOfstPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 40131,
        description: 'Time unit multiplier for the relative option exercise start date offset.',
    },
    {
        name: 'ProvisionOptionExerciseStartDateOffsetUnit',
        abbrName: 'StartDtOfstUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 40132,
        description: 'Time unit associated with the relative option exercise start date offset.',
    },
    {
        name: 'ProvisionOptionExerciseStartDateOffsetDayType',
        abbrName: 'StartDtOfstDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40133,
        description: "Specifies the day type of the provision's relative option exercise start date offset.",
    },
    {
        name: 'ProvisionOptionExerciseStartDateAdjusted',
        abbrName: 'StartDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40134,
        description: 'The adjusted first day of the exercise period for an American style option.',
    },
    {
        name: 'ProvisionOptionExercisePeriodSkip',
        abbrName: 'Skip',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40135,
        description:
            'The number of periods in the referenced date schedule that are between each date in the relative date schedule. Thus a skip of 2 would mean that dates are relative to every second date in the referenced schedule. If present this should have a value greater than 1.',
    },
    {
        name: 'ProvisionOptionExerciseBoundsFirstDateUnadjusted',
        abbrName: 'FirstDtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40136,
        description:
            'The unadjusted first date of a schedule. This can be used to restrict the range of exercise dates when they are relative.',
    },
    {
        name: 'ProvisionOptionExerciseBoundsLastDateUnadjusted',
        abbrName: 'LastDtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40137,
        description:
            'The unadjusted last date of a schedule. This can be used to restrict the range of exercise dates when they are relative.',
    },
    {
        name: 'ProvisionOptionExerciseEarliestTime',
        abbrName: 'ErlstTm',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 40138,
        description:
            "The earliest time at which notice of exercise can be given by the buyer to the seller (or seller's agent) i) on the expriation date, in the case of a European style option, (ii) on each bermuda option exercise date and the expiration date, in the case of a Bermuda style option the commencement date to, and including, the expiration date, in the case of an American option.",
    },
    {
        name: 'ProvisionOptionExerciseEarliestTimeBusinessCenter',
        abbrName: 'ErlstTmBizCtr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40139,
        description:
            "Identifies the business center calendar used with the provision's earliest time for notice of exercise.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.",
    },
    {
        name: 'ProvisionOptionExerciseLatestTime',
        abbrName: 'LtstTm',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 40140,
        description:
            "For a Bermuda or American style option, the latest time on an exercise business day (excluding the expiration date) within the exercise period that notice can be given by the buyer to the seller or seller's agent. Notice of exercise given after this time will be deemed to have been given on the next exercise business day.",
    },
    {
        name: 'ProvisionOptionExerciseLatestTimeBusinessCenter',
        abbrName: 'LtstTmBizCtr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40141,
        description:
            "Identifies the business center calendar used with the provision's latest time for notice of exercise.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.",
    },
    {
        name: 'NoProvisionOptionExerciseFixedDates',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40142,
        description: 'Number of provision option exercise fixed dates in the repeating group.',
    },
    {
        name: 'ProvisionOptionExerciseFixedDate',
        abbrName: 'Dt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40143,
        description:
            'A predetermined option exercise date, unadjusted or adjusted depending on ProvisionOptionExerciseFixedDateType(40144).',
    },
    {
        name: 'ProvisionOptionExerciseFixedDateType',
        abbrName: 'Typ',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ProvisionOptionExerciseFixedDateTypeCodeSet',
        id: 40144,
        description: 'Specifies the type of date (e.g. adjusted for holidays).',
    },
    {
        name: 'ProvisionOptionExpirationDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40145,
        description:
            'The unadjusted last day within an exercise period for an American style option. For a European style option it is the only day within the exercise period.',
    },
    {
        name: 'ProvisionOptionExpirationDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40146,
        description:
            "The business day convention used to adjust the instrument's provision's option expiration date. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.",
    },
    {
        name: 'ProvisionOptionExpirationDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40147,
        description:
            'The business center calendar used to adjust the instrument\'s provision\'s option expiration date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'ProvisionOptionExpirationDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40148,
        description:
            'Specifies the anchor date when the option expiration date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'ProvisionOptionExpirationDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 40149,
        description: 'Time unit multiplier for the relative option expiration date offset.',
    },
    {
        name: 'ProvisionOptionExpirationDateOffsetUnit',
        abbrName: 'OfstUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 40150,
        description: 'Time unit associated with the relative option expiration date offset.',
    },
    {
        name: 'ProvisionOptionExpirationDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40151,
        description: "Specifies the day type of the provision's relative option expiration date offset.",
    },
    {
        name: 'ProvisionOptionExpirationDateAdjusted',
        abbrName: 'Dt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40152,
        description:
            'The adjusted last date within an exercise period for an American style option. For a European style option it is the only date within the exercise period.',
    },
    {
        name: 'ProvisionOptionExpirationTime',
        abbrName: 'ExpTm',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 40153,
        description: 'The latest time for exercise on the expiration date.',
    },
    {
        name: 'ProvisionOptionExpirationTimeBusinessCenter',
        abbrName: 'ExpTmBizCtr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40154,
        description:
            "Identifies the business center calendar used with the provision's latest exercise time on expiration date.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.",
    },
    {
        name: 'ProvisionOptionRelevantUnderlyingDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40155,
        description:
            'The unadjusted date on the underlying set by the exercise of an option. What this date is depends on the option (e.g. in a swaption it is the swap effective date, in an extendible/cancelable provision it is the swap termination date).',
    },
    {
        name: 'ProvisionOptionRelevantUnderlyingDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40156,
        description:
            "The business day convention used to adjust the instrument's provision's option underlying date. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.",
    },
    {
        name: 'ProvisionOptionRelevantUnderlyingDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40157,
        description:
            'The business center calendar used to adjust the instrument\'s provision\'s option underlying date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'ProvisionOptionRelevantUnderlyingDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40158,
        description:
            'Specifies the anchor date when the date relevant to the underlying trade on exercise is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'ProvisionOptionRelevantUnderlyingDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 40159,
        description: 'Time unit multiplier for the relative option relevant underlying date offset.',
    },
    {
        name: 'ProvisionOptionRelevantUnderlyingDateOffsetUnit',
        abbrName: 'OfstUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 40160,
        description: 'Time unit associated with the relative option relevant underlying date offset.',
    },
    {
        name: 'ProvisionOptionRelevantUnderlyingDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40161,
        description: "Specifies the day type of the provision's relative option relevant underlying date offset.",
    },
    {
        name: 'ProvisionOptionRelevantUnderlyingDateAdjusted',
        abbrName: 'Dt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40162,
        description:
            'The adjusted date on the underlying set by the exercise of an option. What this date is depends on the option (e.g. in a swaption it is the swap effective date, in an extendible/cancelable provision it is the swap termination date).',
    },
    {
        name: 'ProvisionCashSettlPaymentDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40163,
        description:
            "The business day convention used to adjust the provisional cash settlement payment's termination or relative termination date. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.",
    },
    {
        name: 'ProvisionCashSettlPaymentDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40164,
        description:
            'The business center calendar used to adjust the provisional cash settlement payment\'s termination or relative termination date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'ProvisionCashSettlPaymentDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40165,
        description:
            'Specifies the anchor date when the cash settlement payment date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'ProvisionCashSettlPaymentDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 40166,
        description: 'Time unit multiplier for the relative cash settlement payment date offset.',
    },
    {
        name: 'ProvisionCashSettlPaymentDateOffsetUnit',
        abbrName: 'OfstUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 40167,
        description: 'Time unit associated with the relative cash settlement payment date offset.',
    },
    {
        name: 'ProvisionCashSettlPaymentDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40168,
        description: "Specifies the day type of the provision's relative cash settlement payment date offset.",
    },
    {
        name: 'ProvisionCashSettlPaymentDateRangeFirst',
        abbrName: 'DtFirst',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40169,
        description: 'First date in range when a settlement date range is provided.',
    },
    {
        name: 'ProvisionCashSettlPaymentDateRangeLast',
        abbrName: 'DtLast',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40170,
        description: 'The last date in range when a settlement date range is provided.',
    },
    {
        name: 'NoProvisionCashSettlPaymentDates',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40171,
        description: 'Number of provision cash settlement payment dates in the repeating group.',
    },
    {
        name: 'ProvisionCashSettlPaymentDate',
        abbrName: 'Dt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40172,
        description:
            'The cash settlement payment date, unadjusted or adjusted depending on ProvisionCashSettlPaymentDateType(40173).',
    },
    {
        name: 'ProvisionCashSettlPaymentDateType',
        abbrName: 'Typ',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ProvisionCashSettlPaymentDateTypeCodeSet',
        id: 40173,
        description: 'Specifies the type of date (e.g. adjusted for holidays).',
    },
    {
        name: 'NoProvisionPartyIDs',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40174,
        description: 'Number of parties identified in the contract provision.',
    },
    {
        name: 'ProvisionPartyID',
        abbrName: 'ID',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40175,
        discriminatorId: '40176',
        description: 'The party identifier/code for the payment settlement party.',
    },
    {
        name: 'ProvisionPartyIDSource',
        abbrName: 'Src',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PartyIDSourceCodeSet',
        id: 40176,
        description: 'Identifies class or source of the ProvisionPartyID(40175) value.',
    },
    {
        name: 'ProvisionPartyRole',
        abbrName: 'R',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PartyRoleCodeSet',
        id: 40177,
        description: 'Identifies the type or role of ProvisionPartyID(40175) specified.',
    },
    {
        name: 'NoProvisionPartySubIDs',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40178,
        description: 'Number of sub-party IDs to be reported for the party.',
    },
    {
        name: 'ProvisionPartySubID',
        abbrName: 'ID',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40179,
        description: 'Party sub-identifier, if applicable, for ProvisionPartyID(40175).',
    },
    {
        name: 'ProvisionPartySubIDType',
        abbrName: 'Typ',
        unionDataType: 'Reserved4000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PartySubIDTypeCodeSet',
        id: 40180,
        description: 'The type of ProvisionPartySubID(40179).',
    },
    {
        name: 'NoProtectionTerms',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40181,
        description: 'Number of protection terms in the repeating group.',
    },
    {
        name: 'ProtectionTermNotional',
        abbrName: 'Notl',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 40182,
        description:
            'The notional amount of protection coverage.\n\nISDA 2003 Term: Floating Rate Payer Calculation Amount.',
    },
    {
        name: 'ProtectionTermCurrency',
        abbrName: 'Ccy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 40183,
        description: 'The currency of ProtectionTermNotional(40182). Uses ISO 4217 currency codes.',
    },
    {
        name: 'ProtectionTermSellerNotifies',
        abbrName: 'Seller',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 40184,
        description:
            'The notifying party is the party that notifies the other party when a credit event has occurred by means of a credit event notice. If more than one party is referenced as being the notifying party then either party may notify the other of a credit event occurring.\n\nProtectionTermSellerNotifies(40184)=Y indicates that the seller notifies.\n\nISDA 2003 Term: Notifying Party.',
    },
    {
        name: 'ProtectionTermBuyerNotifies',
        abbrName: 'Buyer',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 40185,
        description:
            'The notifying party is the party that notifies the other party when a credit event has occurred by means of a credit event notice. If more than one party is referenced as being the notifying party then either party may notify the other of a credit event occurring.\n\nProtectionTermBuyerNotifies(40185)=Y indicates that the buyer notifies.\n\nISDA 2003 Term: Notifying Party.',
    },
    {
        name: 'ProtectionTermEventBusinessCenter',
        abbrName: 'BizCtr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40186,
        description:
            'When used, the business center indicates the local time of the business center that replaces the Greenwich Mean Time in Section 3.3 of the 2003 ISDA Credit Derivatives Definitions. See http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'ProtectionTermStandardSources',
        abbrName: 'StdSrcs',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 40187,
        description:
            'Indicates whether ISDA defined Standard Public Sources are applicable (ProtectionTermStandardSources(40187)=Y) or not.',
    },
    {
        name: 'ProtectionTermEventMinimumSources',
        abbrName: 'MinSrcs',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40188,
        description:
            'The minimum number of the specified public information sources that must publish information that reasonably confirms that a credit event has occurred. The market convention is two.\n\nISDA 2003 Term: Specified Number.',
    },
    {
        name: 'ProtectionTermEventNewsSource',
        abbrName: 'Src',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40189,
        description:
            'Newspaper or electronic news service or source that may publish relevant information used in the determination of whether or not a credit event has occurred.',
    },
    {
        name: 'ProtectionTermXID',
        abbrName: 'XID',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'XID',
        id: 40190,
        description: 'A named string value referenced by UnderlyingProtectionTermXIDRef(41314).',
    },
    {
        name: 'NoProtectionTermEvents',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40191,
        description: 'Number of protection term events in the repeating group.',
    },
    {
        name: 'ProtectionTermEventType',
        abbrName: 'Typ',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        updatedEP: '187',
        id: 40192,
        description:
            'Specifies the type of credit event applicable to the protection terms.\n\nSee http://www.fixtradingcommunity.org/codelists#Protection_Term_Event_Types for code list of applicable event types.',
    },
    {
        name: 'ProtectionTermEventValue',
        abbrName: 'Val',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        updatedEP: '187',
        id: 40193,
        description:
            'Protection term event value appropriate to ProtectionTermEvenType(40192).\n\nSee http://www.fixtradingcommunity.org/codelists#Protection_Term_Event_Types for applicable event type values.',
    },
    {
        name: 'ProtectionTermEventCurrency',
        abbrName: 'Ccy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 40194,
        description:
            'Applicable currency if ProtectionTermEventValue(40193) is an amount. Uses ISO 4217 currency codes.',
    },
    {
        name: 'ProtectionTermEventPeriod',
        abbrName: 'Period',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40195,
        description: 'Time unit multiplier for protection term events.',
    },
    {
        name: 'ProtectionTermEventUnit',
        abbrName: 'Unit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ProtectionTermEventUnitCodeSet',
        id: 40196,
        description: 'Time unit associated with protection term events.',
    },
    {
        name: 'ProtectionTermEventDayType',
        abbrName: 'DayTyp',
        updated: 'FIX.Latest',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ProtectionTermEventDayTypeCodeSet',
        updatedEP: '271',
        id: 40197,
        description: 'Day type for events that specify a period and unit.',
    },
    {
        name: 'ProtectionTermEventRateSource',
        abbrName: 'RtSrc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40198,
        description: 'Rate source for events that specify a rate source, e.g. Floating rate interest shortfall.',
    },
    {
        name: 'NoProtectionTermEventQualifiers',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40199,
        description: 'Number of qualifiers in the repeating group.',
    },
    {
        name: 'ProtectionTermEventQualifier',
        abbrName: 'Qual',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ProtectionTermEventQualifierCodeSet',
        id: 40200,
        description: 'Protection term event qualifier. Used to further qualify ProtectionTermEventType(40192).',
    },
    {
        name: 'NoProtectionTermObligations',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40201,
        description: 'Number of obligations in the repeating group.',
    },
    {
        name: 'ProtectionTermObligationType',
        abbrName: 'Typ',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        updatedEP: '187',
        id: 40202,
        description:
            'Specifies the type of obligation applicable to the protection terms.\n\nSee http://www.fixtradingcommunity.org/codelists#Protection_Term_Obligation_Types for code list of applicable obligation types.',
    },
    {
        name: 'ProtectionTermObligationValue',
        abbrName: 'Val',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        updatedEP: '187',
        id: 40203,
        description:
            'Protection term obligation value appropriate to ProtectionTermObligationType(40202).\n\nSee http://www.fixtradingcommunity.org/codelists#Protection_Term_Obligation_Types for applicable obligation type values.',
    },
    {
        name: 'NoPhysicalSettlTerms',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40204,
        description: 'Number of entries in the repeating group.',
    },
    {
        name: 'PhysicalSettlCurrency',
        abbrName: 'Ccy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 40205,
        description: 'Specifies the currency of physical settlement. Uses ISO 4217 currency codes.',
    },
    {
        name: 'PhysicalSettlBusinessDays',
        abbrName: 'BizDays',
        updated: 'FIX.Latest',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '271',
        id: 40206,
        description:
            'The number of business days used in the determination of physical settlement. Its precise meaning depends on the context in which this element is used.\n\nISDA 2003 Term: Business Day.',
    },
    {
        name: 'PhysicalSettlMaximumBusinessDays',
        abbrName: 'MaxBizDays',
        updated: 'FIX.Latest',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '271',
        id: 40207,
        description:
            'A maximum number of business days. Its precise meaning depends on the context in which this element is used. Intended to be used to limit a particular ISDA fallback provision.',
    },
    {
        name: 'PhysicalSettlTermXID',
        abbrName: 'XID',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'XID',
        id: 40208,
        description: 'A named string value referenced by UnderlyingSettlTermXIDRef(41315).',
    },
    {
        name: 'NoPhysicalSettlDeliverableObligations',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40209,
        description: 'Number of entries in the repeating group.',
    },
    {
        name: 'PhysicalSettlDeliverableObligationType',
        abbrName: 'Typ',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        updatedEP: '169',
        id: 40210,
        description:
            'Specifies the type of deliverable obligation applicable for physical settlement. See http://www.fixtradingcommunity.org/codelists#Deliverable_Obligation_Types for code list for applicable deliverable obligation types.',
    },
    {
        name: 'PhysicalSettlDeliverableObligationValue',
        abbrName: 'Val',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        updatedEP: '169',
        id: 40211,
        description:
            'Physical settlement deliverable obligation value appropriate to PhysicalSettlDeliverableObligationType(40210). See http://www.fixtradingcommunity.org/codelists#Deliverable_Obligation_Types for applicable obligation type values.',
    },
    {
        name: 'NoPayments',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40212,
        description: 'Number of additional settlement or bullet payments.',
    },
    {
        name: 'PaymentType',
        abbrName: 'Typ',
        unionDataType: 'Reserved100Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentTypeCodeSet',
        id: 40213,
        description: 'Type of payment.',
    },
    {
        name: 'PaymentPaySide',
        abbrName: 'PaySide',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentPaySideCodeSet',
        id: 40214,
        description: 'The side of the party paying the payment.',
    },
    {
        name: 'PaymentReceiveSide',
        abbrName: 'RcvSide',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentPaySideCodeSet',
        id: 40215,
        description: 'The side of the party receiving the payment.',
    },
    {
        name: 'PaymentCurrency',
        abbrName: 'Ccy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 40216,
        description:
            'Specifies the currency in which PaymentAmount(40217) is denominated. Uses ISO 4271 currency codes.',
    },
    {
        name: 'PaymentAmount',
        abbrName: 'Amt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 40217,
        description: 'The total payment amount.',
    },
    {
        name: 'PaymentPrice',
        abbrName: 'Px',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 40218,
        description:
            'The price determining the payment amount expressed in terms specified in PaymentPriceType(40919) and expressed in market format.',
    },
    {
        name: 'PaymentDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40219,
        description: 'The unadjusted payment date.',
    },
    {
        name: 'PaymentBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40220,
        description:
            'The business day convention used to adjust the payment date. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.',
    },
    {
        name: 'PaymentBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40221,
        description:
            'The business center calendar used to adjust the payment date, e.g. "GBLO". See http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'PaymentDateAdjusted',
        abbrName: 'Dt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40222,
        description: 'The adjusted payment date.',
    },
    {
        name: 'PaymentDiscountFactor',
        abbrName: 'DiscFctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 40224,
        description: 'The value representing the discount factor used to calculate the present value of the cash flow.',
    },
    {
        name: 'PaymentPresentValueAmount',
        abbrName: 'PVAmt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 40225,
        description: 'The amount representing the present value of the forecast payment.',
    },
    {
        name: 'PaymentPresentValueCurrency',
        abbrName: 'PVCcy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 40226,
        description:
            'Specifies the currency the PaymentPresentValueAmount(40225) is denominated in. Uses ISO 4217 currency codes.',
    },
    {
        name: 'PaymentSettlStyle',
        abbrName: 'SettlStyle',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentSettlStyleCodeSet',
        id: 40227,
        description: 'Payment settlement style.',
    },
    {
        name: 'LegPaymentStreamNonDeliverableSettlReferencePage',
        abbrName: 'RefPg',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40228,
        description:
            'Identifies the reference "page" from the rate source.\n\nWhen LegPaymentStreamNonDeliverableSettlRateSource(40087) = 3 (ISDA Settlement Rate Option) this contains a value from the scheme that reflects the terms of the Annex A to the ISDA 1998 FX and Currency Option Definitions. See: http://www.fpml.org/coding-scheme/settlement-rate-option',
    },
    {
        name: 'PaymentText',
        abbrName: 'Txt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40229,
        description:
            'Free form text to specify additional information or enumeration description when a sdtandard value does not apply. Identifies the payment type when PaymentType(40213) = 99 (Other).',
    },
    {
        name: 'NoPaymentSettls',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40230,
        description: 'Number of additional settlements or bullet payments.',
    },
    {
        name: 'PaymentSettlAmount',
        abbrName: 'Amt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 40231,
        description: 'The payment settlement amount.',
    },
    {
        name: 'PaymentSettlCurrency',
        abbrName: 'Ccy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 40232,
        description:
            'Specifies the currency the PaymentSettlAmount(40231) is denominated in. Uses ISO 4217 currency codes.',
    },
    {
        name: 'NoPaymentSettlPartyIDs',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40233,
        description: 'Number of parties identified in the additional settlement or bullet payment.',
    },
    {
        name: 'PaymentSettlPartyID',
        abbrName: 'ID',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40234,
        discriminatorId: '40235',
        description: 'The payment settlement party identifier.',
    },
    {
        name: 'PaymentSettlPartyIDSource',
        abbrName: 'Src',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PartyIDSourceCodeSet',
        id: 40235,
        description: 'Identifies the class or source of PaymentSettlPartyID(40234) value (e.g. BIC).',
    },
    {
        name: 'PaymentSettlPartyRole',
        abbrName: 'R',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PartyRoleCodeSet',
        id: 40236,
        description:
            "Identifies the role of PaymentSettlPartyID(40234) (e.g. the beneficiary's bank or depository institution).",
    },
    {
        name: 'PaymentSettlPartyRoleQualifier',
        abbrName: 'Qual',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PartyDetailRoleQualifierCodeSet',
        id: 40237,
        description: 'Qualifies the value of PaymentSettlPartyRole(40236).',
    },
    {
        name: 'NoPaymentSettlPartySubIDs',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40238,
        description: 'Number of sub-party IDs to be reported for the party.',
    },
    {
        name: 'PaymentSettlPartySubID',
        abbrName: 'ID',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40239,
        description: 'Party sub-identifier, if applicable, for PaymentSettlPartyRole(40236).',
    },
    {
        name: 'PaymentSettlPartySubIDType',
        abbrName: 'Typ',
        unionDataType: 'Reserved4000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PartySubIDTypeCodeSet',
        id: 40240,
        description: 'The type of PaymentSettlPartySubID(40239) value.',
    },
    {
        name: 'NoLegStreams',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40241,
        description: 'Number of swap streams in the repeating group.',
    },
    {
        name: 'LegStreamType',
        abbrName: 'Typ',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'StreamTypeCodeSet',
        id: 40242,
        description: 'Type of swap stream.',
    },
    {
        name: 'LegStreamDesc',
        abbrName: 'Desc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40243,
        description:
            'A short descriptive name given to the payment stream, e.g. CDS, Fixed, Float, Float2, GBP. The description has no intrinsic meaning but should be arbitrarily chosen by the remitter as a reference.',
    },
    {
        name: 'LegStreamPaySide',
        abbrName: 'PaySide',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentPaySideCodeSet',
        id: 40244,
        description: 'The side of the party paying the stream.',
    },
    {
        name: 'LegStreamReceiveSide',
        abbrName: 'RcvSide',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentPaySideCodeSet',
        id: 40245,
        description: 'The side of the party receiving the stream.',
    },
    {
        name: 'LegStreamNotional',
        abbrName: 'Notl',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 40246,
        description:
            'Notional, or initial notional value for the payment stream. The LegPaymentSchedule component should be used for specifying the steps.',
    },
    {
        name: 'LegStreamCurrency',
        abbrName: 'Ccy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 40247,
        description:
            'Specifies the currency the LegStreamNotional(40246) is denominated in. Uses ISO 4217 currency codes.',
    },
    {
        name: 'LegStreamText',
        abbrName: 'Txt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40248,
        description:
            'Free form text to specify additional information or enumeration description when a standard value does not apply.',
    },
    {
        name: 'LegStreamEffectiveDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40249,
        description: 'The unadjusted effective date.',
    },
    {
        name: 'LegStreamEffectiveDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40250,
        description:
            "The business day convention used to adjust the instrument leg's stream's effective date or relative effective date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.",
    },
    {
        name: 'LegStreamEffectiveDateBusinessCenter',
        abbrName: 'BizCtr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40251,
        description:
            'The business center calendar used to adjust the instrument leg\'s stream\'s effective date or relative effective date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegStreamEffectiveDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40252,
        description:
            'Specifies the anchor date when the effective date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values',
    },
    {
        name: 'LegStreamEffectiveDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40253,
        description: 'Time unit multiplier for the relative effective date offset.',
    },
    {
        name: 'LegStreamEffectiveDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 40254,
        description: 'Time unit associated with the relative effective date offset.',
    },
    {
        name: 'LegStreamEffectiveDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40255,
        description: 'Specifies the day type of the relative effective date offset.',
    },
    {
        name: 'LegStreamEffectiveDateAdjusted',
        abbrName: 'Dt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40256,
        description: 'The adjusted effective date.',
    },
    {
        name: 'LegStreamTerminationDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40257,
        description: 'The unadjusted termination date.',
    },
    {
        name: 'LegStreamTerminationDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40258,
        description:
            "The business day convention used to adjust the instrument leg's stream's termination, or relative termination, date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.",
    },
    {
        name: 'LegStreamTerminationDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40259,
        description:
            'The business center calendar used to adjust the instrument leg\'s stream\'s termination, or relative termination, date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegStreamTerminationDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40260,
        description:
            'Specifies the anchor date when the termination date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'LegStreamTerminationDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40261,
        description: 'Time unit multiplier for the relative termination date offset.',
    },
    {
        name: 'LegStreamTerminationDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 40262,
        description: 'Time unit associated with the relative termination date offset.',
    },
    {
        name: 'LegStreamTerminationDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40263,
        description: 'Specifies the day type of the relative termination date offset.',
    },
    {
        name: 'LegStreamTerminationDateAdjusted',
        abbrName: 'Dt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40264,
        description: 'The adjusted termination date.',
    },
    {
        name: 'LegStreamCalculationPeriodBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40265,
        description:
            'The business day convention used to adjust calculation periods. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.',
    },
    {
        name: 'LegStreamCalculationPeriodBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40266,
        description:
            'The business center calendar used to adjust calculation periods, e.g. "GLBO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegStreamFirstPeriodStartDateUnadjusted',
        abbrName: 'FirstStartDtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40267,
        description: 'The unadjusted first calculation period start date if before the effective date.',
    },
    {
        name: 'LegStreamFirstPeriodStartDateBusinessDayConvention',
        abbrName: 'FirstStartDtBizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40268,
        description:
            "The business day convention used to adjust the instrument leg's stream's first calculation period start date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.",
    },
    {
        name: 'LegStreamFirstPeriodStartDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40269,
        description:
            'The business center calendar used to adjust the instrument leg\'s stream\'s first calculation period start date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegStreamFirstPeriodStartDateAdjusted',
        abbrName: 'FirstStartDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40270,
        description: 'The adjusted first calculation period start date, if it is before the effective date.',
    },
    {
        name: 'LegStreamFirstRegularPeriodStartDateUnadjusted',
        abbrName: 'FirstReglrStartDtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40271,
        description:
            'The unadjusted first start date of the regular calculation period, if there is an initial stub period.',
    },
    {
        name: 'LegStreamFirstCompoundingPeriodEndDateUnadjusted',
        abbrName: 'FirstCmpndgEndDtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40272,
        description: 'The unadjusted end date of the initial compounding period.',
    },
    {
        name: 'LegStreamLastRegularPeriodEndDateUnadjusted',
        abbrName: 'LastReglrEndDtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40273,
        description: 'The unadjusted last regular period end date if there is a final stub period.',
    },
    {
        name: 'LegStreamCalculationFrequencyPeriod',
        abbrName: 'FreqPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40274,
        description: 'Time unit multiplier for the frequency at which calculation period end dates occur.',
    },
    {
        name: 'LegStreamCalculationFrequencyUnit',
        abbrName: 'FreqUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'CouponFrequencyUnitCodeSet',
        id: 40275,
        description: 'Time unit associated with the frequency at which calculation period end dates occur.',
    },
    {
        name: 'LegStreamCalculationRollConvention',
        abbrName: 'Roll',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'DateRollConventionCodeSet',
        id: 40276,
        description:
            'The convention for determining the sequence of end dates. It is used in conjunction with a specified frequency. Used only to override the roll convention specified in the LegDateAdjustment component within the InstrumentLeg component.',
    },
    {
        name: 'NoCashSettlDealers',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40277,
        description: 'Number of dealers in the repeating group.',
    },
    {
        name: 'NoBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40278,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'LegPaymentStreamType',
        abbrName: 'Typ',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamTypeCodeSet',
        id: 40279,
        description:
            'Identifies the type of payment stream applicable to the swap stream associated with the instrument leg.',
    },
    {
        name: 'LegPaymentStreamMarketRate',
        abbrName: 'MktRt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40280,
        description:
            'Used only for credit index trade. This contains the credit spread ("fair value") at which the trade was executed. The market rate varies over the life of the index depending on market conditions. This is the price of the index as quoted by trading desks.',
    },
    {
        name: 'LegPaymentStreamDelayIndicator',
        abbrName: 'DelayInd',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 40281,
        description:
            'Applicable to credit default swaps on mortgage backed securities to specify whether payment delays are applicable to the fixed amount.\n\nResidential mortgage backed securities typically have a payment delay of 5 days between the coupon date of the reference obligation and the payment date of the synthetic swap.\n\nCommercial mortage backed securities do not typically have a payment delay, with both payment dates (the coupon date of the reference obligation and the payment date of the synthetic swap) being on the 25th of each month.',
    },
    {
        name: 'LegPaymentStreamSettlCurrency',
        abbrName: 'SettlCcy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 40282,
        description:
            'Specifies the currency that the stream settles in (to support swaps that settle in a currency different from the notional currency). Uses ISO 4217 currency codes.',
    },
    {
        name: 'LegPaymentStreamDayCount',
        abbrName: 'DayCnt',
        unionDataType: 'Reserved100Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'CouponDayCountCodeSet',
        id: 40283,
        description: 'The day count convention used in the payment stream calculations.',
    },
    {
        name: 'LegPaymentStreamAccrualDays',
        abbrName: 'AcrlDays',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40284,
        description:
            'The number of days from the adjusted calculation period start date to the adjusted value date, calculated in accordance with the applicable day count fraction.',
    },
    {
        name: 'LegPaymentStreamDiscountType',
        abbrName: 'DiscTyp',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamDiscountTypeCodeSet',
        id: 40285,
        description: 'The method of calculating discounted payment amounts.',
    },
    {
        name: 'LegPaymentStreamDiscountRate',
        abbrName: 'Disc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40286,
        description: 'Discount rate. The rate is expressed in decimal, e.g. 5% is expressed as 0.05.',
    },
    {
        name: 'LegPaymentStreamDiscountRateDayCount',
        abbrName: 'DiscDayCnt',
        unionDataType: 'Reserved100Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'CouponDayCountCodeSet',
        id: 40287,
        description: 'The day count convention applied to the LegPaymentStreamDiscountRate(40286).',
    },
    {
        name: 'LegPaymentStreamCompoundingMethod',
        abbrName: 'CmpndgMeth',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamCompoundingMethodCodeSet',
        id: 40288,
        description: 'Compounding method.',
    },
    {
        name: 'LegPaymentStreamInitialPrincipalExchangeIndicator',
        abbrName: 'InitPrncplExchInd',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 40289,
        description: 'Indicates whether there is an initial exchange of principal on the effective date.',
    },
];

const batch4: ISpecFields[] = [
    {
        name: 'LegPaymentStreamInterimPrincipalExchangeIndicator',
        abbrName: 'IntrmPrncplExchInd',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 40290,
        description:
            'Indicates whether there are intermediate or interim exchanges of principal during the term of the swap.',
    },
    {
        name: 'LegPaymentStreamFinalPrincipalExchangeIndicator',
        abbrName: 'FnlPrncplExchInd',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 40291,
        description: 'Indicates whether there is a final exchange of principal on the termination date.',
    },
    {
        name: 'LegPaymentStreamPaymentDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40292,
        description:
            "The business day convention used to adjust the payment stream's payment date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.",
    },
    {
        name: 'LegPaymentStreamPaymentDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40293,
        description:
            'The business center calendar used to adjust the payment stream\'s payment date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegPaymentStreamPaymentFrequencyPeriod',
        abbrName: 'FreqPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40294,
        description: 'Time unit multiplier for the frequency of payments.',
    },
    {
        name: 'LegPaymentStreamPaymentFrequencyUnit',
        abbrName: 'FreqUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentFrequencyUnitCodeSet',
        id: 40295,
        description: 'Time unit associated with the frequency of payments.',
    },
    {
        name: 'LegPaymentStreamPaymentRollConvention',
        abbrName: 'Roll',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'DateRollConventionCodeSet',
        id: 40296,
        description:
            'The convention for determining the sequence of end dates. It is used in conjunction with a specified frequency. Used only to override the roll convention specified in the LegDateAdjustment component within the InstrumentLeg component.',
    },
    {
        name: 'LegPaymentStreamFirstPaymentDateUnadjusted',
        abbrName: 'FirstDtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40297,
        description: 'The unadjusted first payment date.',
    },
    {
        name: 'LegPaymentStreamLastRegularPaymentDateUnadjusted',
        abbrName: 'LastReglrDtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40298,
        description: 'The unadjusted last regular payment date.',
    },
    {
        name: 'LegPaymentStreamPaymentDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40299,
        description:
            'Specifies the anchor date when payment dates are relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'LegPaymentStreamPaymentDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 40300,
        description: 'Time unit multiplier for the relative payment date offset.',
    },
    {
        name: 'LegPaymentStreamPaymentDateOffsetUnit',
        abbrName: 'OfstUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 40301,
        description: 'Time unit associated with the relative payment date offset.',
    },
    {
        name: 'LegPaymentStreamPaymentDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40302,
        description: 'Specifies the day type of the relative payment date offset.',
    },
    {
        name: 'LegPaymentStreamResetDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40303,
        description:
            'Specifies the anchor date when the reset dates are relative to an anchor date.\n\nIf the reset frequency is specified as daily this element must not be included.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'LegPaymentStreamResetDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40304,
        description:
            "The business day convention used to adjust the payment stream's reset date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.",
    },
    {
        name: 'LegPaymentStreamResetDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40305,
        description:
            'The business center calendar used to adjust the payment stream\'s reset date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegPaymentStreamResetFrequencyPeriod',
        abbrName: 'FreqPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40306,
        description: 'Time unit multiplier for frequency of resets.',
    },
    {
        name: 'LegPaymentStreamResetFrequencyUnit',
        abbrName: 'FreqUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'CouponFrequencyUnitCodeSet',
        id: 40307,
        description: 'Time unit associated with frequency of resets.',
    },
    {
        name: 'LegPaymentStreamResetWeeklyRollConvention',
        abbrName: 'WklyRoll',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamResetWeeklyRollConventionCodeSet',
        id: 40308,
        description:
            'Used to specify the day of the week in which the reset occurs for payments that reset on a weekly basis.',
    },
    {
        name: 'LegPaymentStreamInitialFixingDateRelativeTo',
        abbrName: 'InitReltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40309,
        description:
            'Specifies the anchor date when the initial fixing date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'LegPaymentStreamInitialFixingDateBusinessDayConvention',
        abbrName: 'InitBizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40310,
        description:
            "The business day convention used to adjust the payment stream's initial fixing date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.",
    },
    {
        name: 'LegPaymentStreamInitialFixingDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40311,
        description:
            'The business center calendar used to adjust the payment stream\'s initial fixing date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegPaymentStreamInitialFixingDateOffsetPeriod',
        abbrName: 'InitPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 40312,
        description: 'Time unit multiplier for the relative initial fixing date offset.',
    },
    {
        name: 'LegPaymentStreamInitialFixingDateOffsetUnit',
        abbrName: 'InitUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 40313,
        description: 'Time unit associated with the relative initial fixing date offset.',
    },
    {
        name: 'LegPaymentStreamInitialFixingDateOffsetDayType',
        abbrName: 'InitDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40314,
        description: 'Specifies the day type of the relative initial fixing date offset.',
    },
    {
        name: 'LegPaymentStreamInitialFixingDateAdjusted',
        abbrName: 'InitDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40315,
        description: 'The adjusted initial fixing date.',
    },
    {
        name: 'LegPaymentStreamFixingDateRelativeTo',
        abbrName: 'FixngReltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40316,
        description:
            'Specifies the anchor date when the fixing date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'LegPaymentStreamFixingDateBusinessDayConvention',
        abbrName: 'FixngBizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40317,
        description:
            "The business day convention used to adjust the payment stream's fixing date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.",
    },
    {
        name: 'LegPaymentStreamFixingDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40318,
        description:
            'The business center calendar used to adjust the payment stream\'s fixing date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegPaymentStreamFixingDateOffsetPeriod',
        abbrName: 'FixngPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 40319,
        description: 'Time unit multiplier for the relative fixing date offset.',
    },
    {
        name: 'LegPaymentStreamFixingDateOffsetUnit',
        abbrName: 'FixngUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 40320,
        description: 'Time unit associated with the relative fixing date offset.',
    },
    {
        name: 'LegPaymentStreamFixingDateOffsetDayType',
        abbrName: 'FixngDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40321,
        description: 'Specifies the day type of the relative fixing date offset.',
    },
    {
        name: 'LegPaymentStreamFixingDateAdjusted',
        abbrName: 'FixngDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40322,
        description: 'The adjusted fixing date.',
    },
    {
        name: 'LegPaymentStreamRateCutoffDateOffsetPeriod',
        abbrName: 'CutoffPeriod',
        updated: 'FIX.Latest',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '271',
        id: 40323,
        description:
            'Time unit multiplier for the relative rate cut-off date offset.\n\nThis is generally the number of days preceding the period end date or termination date, as appropriate, for the specified floating rate index.',
    },
    {
        name: 'LegPaymentStreamRateCutoffDateOffsetUnit',
        abbrName: 'CutoffUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 40324,
        description: 'Time unit associated with the relative rate cut-off date offset.',
    },
    {
        name: 'LegPaymentStreamRateCutoffDateOffsetDayType',
        abbrName: 'CutoffDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40325,
        description: 'Specifies the day type of the relative rate cut-off date offset.',
    },
    {
        name: 'LegPaymentStreamRate',
        abbrName: 'Rt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40326,
        description: 'The rate applicable to the fixed rate payment stream.',
    },
    {
        name: 'LegPaymentStreamFixedAmount',
        abbrName: 'Amt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 40327,
        description:
            "The leg instrument payment stream's fixed payment amount. In a CDS, this can be an alternative to LegPaymentStreamRate(40326).",
    },
    {
        name: 'LegPaymentStreamRateOrAmountCurrency',
        abbrName: 'Ccy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 40328,
        description:
            'Specifies the currency in which LegPaymentStreamFixedAmount(40327) or LegPaymentStreamRate(40326) is denominated. Uses ISO 4217 currency codes.',
    },
    {
        name: 'LegPaymentStreamFutureValueNotional',
        abbrName: 'FutValNotl',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 40329,
        description:
            'The future value notional is normally only required for certain non-deliverable interest rate swaps (e.g. Brazillian Real (BRL) vs. CETIP Interbank Deposit Rate (CDI)). The value is calculated as follows: Future Value Notional = Notional Amount * (1 + Fixed Rate) ^ (Fixed Rate Day Count Fraction). The currency is the same as the stream notional.',
    },
    {
        name: 'LegPaymentStreamFutureValueDateAdjusted',
        abbrName: 'FutValDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40330,
        description: 'The adjusted value date of the future value amount.',
    },
    {
        name: 'LegPaymentStreamRateIndex',
        abbrName: 'Ndx',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40331,
        discriminatorId: '40332',
        description: 'The payment stream floating rate index.',
    },
    {
        name: 'LegPaymentStreamRateIndexSource',
        abbrName: 'NdxSrc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexSourceCodeSet',
        id: 40332,
        description: 'The source of the payment stream floating rate index.',
    },
    {
        name: 'LegPaymentStreamRateIndexCurveUnit',
        abbrName: 'NdxUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexCurveUnitCodeSet',
        id: 40333,
        description: "Time unit associated with the payment stream's floating rate index curve period.",
    },
    {
        name: 'LegPaymentStreamRateIndexCurvePeriod',
        abbrName: 'NdxPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40334,
        description: "Time unit multiplier for the payment stream's floating rate index curve period.",
    },
    {
        name: 'LegPaymentStreamRateMultiplier',
        abbrName: 'RtMult',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 40335,
        description:
            'A rate multiplier to apply to the floating rate. The multiplier can be less than or greater than 1 (one). This element should only be included if the multiplier is not equal to 1 (one) for the term of the stream.',
    },
    {
        name: 'LegPaymentStreamRateSpread',
        abbrName: 'Spread',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 40336,
        description: 'The basis points spread from the index specified in LegPaymentStreamRateIndex(40331).',
    },
    {
        name: 'LegPaymentStreamRateSpreadPositionType',
        abbrName: 'SpreadPosTyp',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
        id: 40337,
        description: 'Identifies whether the rate spread is applied to a long or short position.',
    },
    {
        name: 'LegPaymentStreamRateTreatment',
        abbrName: 'RtTrtmt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateTreatmentCodeSet',
        id: 40338,
        description: 'Specifies the yield calculation treatment for the index.',
    },
    {
        name: 'LegPaymentStreamCapRate',
        abbrName: 'CapRt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40339,
        description:
            'The cap rate, if any, which applies to the floating rate. It is only required where the floating rate on a swap stream is capped at a certain level The cap rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A cap rate of 5% would be represented as 0.05.',
    },
    {
        name: 'LegPaymentStreamCapRateBuySide',
        abbrName: 'CapRtBuy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamCapRateBuySideCodeSet',
        id: 40340,
        description: 'Reference to the buyer of the cap rate option through its trade side.',
    },
    {
        name: 'LegPaymentStreamCapRateSellSide',
        abbrName: 'CapRtSell',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamCapRateBuySideCodeSet',
        id: 40341,
        description: 'Reference to the seller of the cap rate option through its trade side.',
    },
    {
        name: 'LegPaymentStreamFloorRate',
        abbrName: 'FlrRt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40342,
        description:
            'The floor rate, if any, which applies to the floating rate. The floor rate (strike) is only required where the floating rate on a swap stream is floored at a certain strike level The floor rate is assumed to be exclusive of any spread and is a per annum rate. The rate is expressed as a decimal, e.g. 5% is represented as 0.05.',
    },
    {
        name: 'LegPaymentStreamFloorRateBuySide',
        abbrName: 'FlrRtBuy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamFloorRateBuySideCodeSet',
        id: 40343,
        description: 'Reference to the buyer of the floor rate option through its trade side.',
    },
    {
        name: 'LegPaymentStreamFloorRateSellSide',
        abbrName: 'FlrRtSell',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamFloorRateBuySideCodeSet',
        id: 40344,
        description: 'Reference to the seller of the floor rate option through its trade side.',
    },
    {
        name: 'LegPaymentStreamInitialRate',
        abbrName: 'InitRt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40345,
        description:
            'The initial floating rate reset agreed between the principal parties involved in the trade. This is assumed to be the first required reset rate for the first regular calculation period. It should only be included when the rate is not equal to the rate published on the source implied by the floating rate index. The initial rate is expressed in decimal form, e.g. 5% is represented as 0.05.',
    },
    {
        name: 'LegPaymentStreamFinalRateRoundingDirection',
        abbrName: 'FnlRtRndDirctn',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'RoundingDirectionCodeSet',
        updatedEP: '208',
        id: 40346,
        description: 'Specifies the rounding direction.',
    },
    {
        name: 'LegPaymentStreamFinalRatePrecision',
        abbrName: 'FnlRtPrcsn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40347,
        description:
            'Specifies the rounding precision in terms of a number of decimal places. Note how a percentage rate rounding of 5 decimal places is expressed as a rounding precision of 7.',
    },
    {
        name: 'LegPaymentStreamAveragingMethod',
        abbrName: 'AvgngMeth',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamAveragingMethodCodeSet',
        id: 40348,
        description:
            'When averaging is applicable, used to specify whether a weighted or unweighted average method of calculation is to be used.',
    },
    {
        name: 'LegPaymentStreamNegativeRateTreatment',
        abbrName: 'NegtvRtTrtmt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamNegativeRateTreatmentCodeSet',
        id: 40349,
        description:
            'The specification of any provisions for calculating payment obligations when a floating rate is negative (either due to a quoted negative floating rate or by operation of a spread that is subtracted from the floating rate).',
    },
    {
        name: 'LegPaymentStreamInflationLagPeriod',
        abbrName: 'LagPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40350,
        description:
            'Time unit multiplier for the inflation lag period. The lag period is the offsetting period from the payment date which determineds the reference period for which the inflation index is observed.',
    },
    {
        name: 'LegPaymentStreamInflationLagUnit',
        abbrName: 'LagUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamInflationLagUnitCodeSet',
        id: 40351,
        description: 'Time unit associated with the inflation lag period.',
    },
    {
        name: 'LegPaymentStreamInflationLagDayType',
        abbrName: 'LagDayTyp',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamInflationLagDayTypeCodeSet',
        id: 40352,
        description: 'The inflation lag period day type.',
    },
    {
        name: 'LegPaymentStreamInflationInterpolationMethod',
        abbrName: 'IntrpltnMeth',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamInflationInterpolationMethodCodeSet',
        id: 40353,
        description:
            'The method used when calculating the inflation index level from multiple points. The most common is linear method.',
    },
    {
        name: 'LegPaymentStreamInflationIndexSource',
        abbrName: 'InfltnNdxSrc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexSourceCodeSet',
        id: 40354,
        description: 'The inflation index reference source.',
    },
    {
        name: 'LegPaymentStreamInflationPublicationSource',
        abbrName: 'PublctnSrc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40355,
        description:
            'The publication source, such as relevant web site, news publication or a government body, where inflation information is obtained.',
    },
    {
        name: 'LegPaymentStreamInflationInitialIndexLevel',
        abbrName: 'InitLvl',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 40356,
        description: 'Initial known index level for the first calculation period.',
    },
    {
        name: 'LegPaymentStreamInflationFallbackBondApplicable',
        abbrName: 'FallbckBond',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 40357,
        description:
            'Indicates whether a fallback bond as defined in the 2006 ISDA Inflation Derivatives Definitions, sections 1.3 and 1.8, is applicable or not. If not specified, the default value is "Y" (True/Yes).',
    },
    {
        name: 'LegPaymentStreamFRADiscounting',
        abbrName: 'FRADisc',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamFRADiscountingCodeSet',
        updatedEP: '169',
        id: 40358,
        description: 'The method of Forward Rate Agreement (FRA) discounting, if any, that will apply.',
    },
    {
        name: 'LegPaymentStreamNonDeliverableRefCurrency',
        abbrName: 'Ccy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 40359,
        description: 'Non-deliverable settlement reference currency. Uses ISO 4217 currency codes.',
    },
    {
        name: 'LegPaymentStreamNonDeliverableFixingDatesBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40360,
        description:
            "The business day convention used to adjust the payment stream's fixing date for the non-deliverable settlement terms. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.",
    },
    {
        name: 'LegPaymentStreamNonDeliverableFixingDatesBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40361,
        description:
            'The business center calendar used to adjust the payment stream\'s fixing date for the non-deliverable terms, e.g. "GBLO". See http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegPaymentStreamNonDeliverableFixingDatesRelativeTo',
        abbrName: 'FixngReltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40362,
        description:
            'Specifies the anchor date when the non-deliverable fixing dates are relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'LegPaymentStreamNonDeliverableFixingDatesOffsetPeriod',
        abbrName: 'FixngPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 40363,
        description: 'Time unit multiplier for the relative non-deliverable fixing date offset.',
    },
    {
        name: 'LegPaymentStreamNonDeliverableFixingDatesOffsetUnit',
        abbrName: 'FixngUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 40364,
        description: 'Time unit associated with the relative non-deliverable fixing date offset.',
    },
    {
        name: 'LegPaymentStreamNonDeliverableFixingDatesOffsetDayType',
        abbrName: 'FixngDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40365,
        description: 'Specifies the day type of the relative non-deliverable fixing date offset.',
    },
    {
        name: 'LegSettlRateFallbackRateSource',
        abbrName: 'RtSrc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'RateSourceCodeSet',
        id: 40366,
        description: 'Identifies the source of rate information.',
    },
    {
        name: 'NoLegNonDeliverableFixingDates',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40367,
        description: 'Number of fixing dates in the repeating group.',
    },
    {
        name: 'LegNonDeliverableFixingDate',
        abbrName: 'Dt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40368,
        description:
            'The non-deliverable fixing date. Type of date is specified in LegNonDeliverableFixingDateType(40369).',
    },
    {
        name: 'LegNonDeliverableFixingDateType',
        abbrName: 'Typ',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NonDeliverableFixingDateTypeCodeSet',
        id: 40369,
        description: 'Specifies the type of date (e.g. adjusted for holidays).',
    },
    {
        name: 'LegSettlRateFallbackReferencePage',
        abbrName: 'RefPg',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40370,
        description:
            'Identifies the reference "page" from the rate source.\n\nWhen LegSettlRateFallbackRateSource(40366) = 3(ISDA Settlement Rate Option) this contains the value from the scheme that reflects the terms of the Annex A to the ISDA 1998 FX and Currency Option Definitions. See: http://www.fpml.org/coding-scheme/settlement-rate-option',
    },
    {
        name: 'PaymentStreamNonDeliverableSettlRateSource',
        abbrName: 'RtSrc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'RateSourceCodeSet',
        id: 40371,
        description: 'Identifies the source of rate information.',
    },
    {
        name: 'PaymentStreamNonDeliverableSettlReferencePage',
        abbrName: 'RefPg',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40372,
        description:
            'Identifies the reference "page" from the rate source.\n\nWhen PaymentStreamNonDeliverableSettlRateSource(40371) = 3(ISDA Settlement Rate Option) this contains the value from the scheme that reflects the terms of the Annex A to the ISDA 1998 FX and Currency Option Definitions. See: http://www.fpml.org/coding-scheme/settlement-rate-option',
    },
    {
        name: 'SettlRateFallbackRateSource',
        abbrName: 'RtSrc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'RateSourceCodeSet',
        id: 40373,
        description: 'Identifies the source of rate information.',
    },
    {
        name: 'NoLegPaymentSchedules',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40374,
        description: 'Number of swap schedules in the repeating group',
    },
    {
        name: 'LegPaymentScheduleType',
        abbrName: 'Typ',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentScheduleTypeCodeSet',
        id: 40375,
        description: 'Specifies the type of schedule.',
    },
    {
        name: 'LegPaymentScheduleStubType',
        abbrName: 'StubTyp',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStubTypeCodeSet',
        id: 40376,
        description: 'Indicates to which stub this schedule applies.',
    },
    {
        name: 'LegPaymentScheduleStartDateUnadjusted',
        abbrName: 'StartDtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40377,
        description:
            'The unadjusted date on which the value is adjusted, or calculated if a future value notional for certain non-deliverable interest rate swaps (e.g. Brazillian Real (BRL) vs. CETIP Interbank Deposit Rate (CDI)), or the start date of a cashflow payment.',
    },
    {
        name: 'LegPaymentScheduleEndDateUnadjusted',
        abbrName: 'EndDtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40378,
        description: 'The unadjusted end date of a cashflow payment.',
    },
    {
        name: 'LegPaymentSchedulePaySide',
        abbrName: 'PaySide',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentPaySideCodeSet',
        id: 40379,
        description: 'The side of the party paying the step schedule.',
    },
    {
        name: 'LegPaymentScheduleReceiveSide',
        abbrName: 'RcvSide',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentPaySideCodeSet',
        id: 40380,
        description: 'The side of the party receiving the step schedule.',
    },
    {
        name: 'LegPaymentScheduleNotional',
        abbrName: 'Notl',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 40381,
        description: 'The notional value for this step schedule, or amount of a cashflow payment.',
    },
    {
        name: 'LegPaymentScheduleCurrency',
        abbrName: 'Ccy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 40382,
        description: 'The currency for this step schedule. Uses ISO 4217 currency codes.',
    },
    {
        name: 'LegPaymentScheduleRate',
        abbrName: 'Rt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40383,
        discriminatorId: '40415',
        description: 'The rate value for this step schedule.',
    },
    {
        name: 'LegPaymentScheduleRateMultiplier',
        abbrName: 'RtMult',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 40384,
        description:
            'A rate multiplier to apply to the floating rate. The multiplier can be less than or greater than 1 (one). This element should only be included if the multiplier is not equal to 1 (one) for the term of the stream.',
    },
    {
        name: 'LegPaymentScheduleRateSpread',
        abbrName: 'Spread',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 40385,
        description: 'The spread value for this step schedule.',
    },
    {
        name: 'LegPaymentScheduleRateSpreadPositionType',
        abbrName: 'SpreadPosTyp',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
        id: 40386,
        description: 'Identifies whether the rate spread is applied to a long or a short position.',
    },
    {
        name: 'LegPaymentScheduleRateTreatment',
        abbrName: 'RtTrtmt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateTreatmentCodeSet',
        id: 40387,
        description: 'Specifies the yield calculation treatment for the step schedule.',
    },
    {
        name: 'LegPaymentScheduleFixedAmount',
        abbrName: 'FixedAmt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 40388,
        description: 'The explicit payment amount for this step schedule.',
    },
    {
        name: 'LegPaymentScheduleFixedCurrency',
        abbrName: 'FixedCcy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 40389,
        description: 'The currency of the fixed amount. Uses ISO 4217 currency codes.',
    },
    {
        name: 'LegPaymentScheduleStepFrequencyPeriod',
        abbrName: 'StepPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40390,
        description: 'Time unit multiplier for the step frequency.',
    },
    {
        name: 'LegPaymentScheduleStepFrequencyUnit',
        abbrName: 'StepUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'CouponFrequencyUnitCodeSet',
        id: 40391,
        description: 'Time unit associated with the step frequency.',
    },
    {
        name: 'LegPaymentScheduleStepOffsetValue',
        abbrName: 'StepVal',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 40392,
        description:
            'The explicit amount that the notional changes on each step date. This can be a positive or negative amount.',
    },
    {
        name: 'LegPaymentScheduleStepRate',
        abbrName: 'StepRt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40393,
        description:
            'The percentage by which the notional changes on each step date. The percentage is either a percentage applied to the initial notional amount or the previous outstanding notional, depending on the value specified in LegPaymentScheduleStepRelativeTo(40395). The percentage can be either positive or negative.',
    },
    {
        name: 'LegPaymentScheduleStepOffsetRate',
        abbrName: 'StepOfstRt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40394,
        description:
            'The explicit amount that the rate changes on each step date. This can be a positive or negative value.',
    },
    {
        name: 'LegPaymentScheduleStepRelativeTo',
        abbrName: 'StepReltv',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentScheduleStepRelativeToCodeSet',
        id: 40395,
        description:
            'Specifies whether the LegPaymentScheduleStepRate(40393) or LegPaymentScheduleStepOffsetValue(40392) should be applied to the initial notional or the previous notional in order to calculate the notional step change amount.',
    },
    {
        name: 'LegPaymentScheduleFixingDateUnadjusted',
        abbrName: 'FixngDtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40396,
        description: 'The unadjusted fixing date.',
    },
    {
        name: 'LegPaymentScheduleWeight',
        abbrName: 'Wt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 40397,
        description: 'Floating rate observation weight for cashflow payment.',
    },
    {
        name: 'LegPaymentScheduleFixingDateRelativeTo',
        abbrName: 'FixngReltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40398,
        description:
            'Specifies the anchor date when the fixing date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'LegPaymentScheduleFixingDateBusinessDayConvention',
        abbrName: 'FixngBizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40399,
        description:
            "The business day convention used to adjust the payment schedule's fixing date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.",
    },
    {
        name: 'LegPaymentScheduleFixingDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40400,
        description:
            'The business center calendar used to adjust the payment schedule\'s fixing date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegPaymentScheduleFixingDateOffsetPeriod',
        abbrName: 'FixngPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 40401,
        description: 'Time unit multiplier for the relative fixing date offset.',
    },
    {
        name: 'LegPaymentScheduleFixingDateOffsetUnit',
        abbrName: 'FixngUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 40402,
        description: 'Time unit associated with the relative fixing date offset.',
    },
    {
        name: 'LegPaymentScheduleFixingDateOffsetDayType',
        abbrName: 'FixngDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40403,
        description: 'Specifies the day type of the relative fixing date offset.',
    },
    {
        name: 'LegPaymentScheduleFixingDateAdjusted',
        abbrName: 'FixngDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40404,
        description: 'The adjusted fixing date.',
    },
    {
        name: 'LegPaymentScheduleFixingTime',
        abbrName: 'FixngTm',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 40405,
        description: 'The fxing time associated with the step schedule.',
    },
    {
        name: 'LegPaymentScheduleFixingTimeBusinessCenter',
        abbrName: 'FixngTmBizCtr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40406,
        description:
            'Business center for determining fixing time.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegPaymentScheduleInterimExchangePaymentDateRelativeTo',
        abbrName: 'IntrmExchDtReltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40407,
        description:
            'Specifies the anchor date when the interim exchange payment date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'LegPaymentScheduleInterimExchangeDatesBusinessDayConvention',
        abbrName: 'IntrmExchDtBizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40408,
        description:
            "The business day convention used to adjust the payment schedule's interim exchange date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.",
    },
    {
        name: 'LegPaymentScheduleInterimExchangeDatesBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40409,
        description:
            'The business center calendar used to adjust the payment schedule\'s interim exchange date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegPaymentScheduleInterimExchangeDatesOffsetPeriod',
        abbrName: 'IntrmExchDtPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 40410,
        description: 'Time unit multiplier for the relative interim exchange date offset.',
    },
    {
        name: 'LegPaymentScheduleInterimExchangeDatesOffsetUnit',
        abbrName: 'IntrmExchDtUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 40411,
        description: 'Time unit associated with the relative interim exchange date offset.',
    },
    {
        name: 'LegPaymentScheduleInterimExchangeDatesOffsetDayType',
        abbrName: 'IntrmExchDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40412,
        description: 'Specifies the day type of the relative interim exchange date offset.',
    },
    {
        name: 'LegPaymentScheduleInterimExchangeDateAdjusted',
        abbrName: 'IntrmExchDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40413,
        description: 'The adjusted interim exchange date.',
    },
    {
        name: 'NoLegPaymentScheduleRateSources',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40414,
        description: 'Number of rate sources in the repeating group',
    },
    {
        name: 'LegPaymentScheduleRateSource',
        abbrName: 'Src',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'RateSourceCodeSet',
        id: 40415,
        description: 'Identifies the source of rate information.',
    },
    {
        name: 'LegPaymentScheduleRateSourceType',
        abbrName: 'Typ',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'RateSourceTypeCodeSet',
        id: 40416,
        description: 'Rate source type.',
    },
    {
        name: 'LegPaymentScheduleReferencePage',
        abbrName: 'RefPg',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40417,
        description:
            'Identifies the reference "page" from the rate source.\n\nFor FX, the reference page to the spot rate to be used for the reference FX spot rate.\n\nWhen RateSource(1446) = 3 (ISDA Settlement Rate Option) this contains the value from the scheme that reflects the terms of the Annex A to the ISDA 1998 FX and Currency Option Definitions. See: http://www.fpml.org/coding-scheme/settlement-rate-option',
    },
    {
        name: 'NoLegPaymentStubs',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40418,
        description: 'Number of stubs in the repeating group',
    },
    {
        name: 'LegPaymentStubType',
        abbrName: 'Typ',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStubTypeCodeSet',
        id: 40419,
        description: 'Stub type.',
    },
    {
        name: 'LegPaymentStubLength',
        abbrName: 'Lngth',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStubLengthCodeSet',
        id: 40420,
        description: 'Optional indication whether stub is shorter or longer than the regular swap period.',
    },
    {
        name: 'LegPaymentStubRate',
        abbrName: 'Rt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40421,
        description: 'The agreed upon fixed rate for this stub.',
    },
    {
        name: 'LegPaymentStubFixedAmount',
        abbrName: 'FixedAmt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 40422,
        description: 'A fixed payment amount for the stub.',
    },
    {
        name: 'LegPaymentStubFixedCurrency',
        abbrName: 'FixedCcy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 40423,
        description: 'The currency of the fixed payment amount. Uses ISO 4217 currency codes.',
    },
    {
        name: 'LegPaymentStubIndex',
        abbrName: 'Ndx',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40424,
        discriminatorId: '40425',
        description: 'The stub floating rate index.',
    },
    {
        name: 'LegPaymentStubIndexSource',
        abbrName: 'NdxSrc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexSourceCodeSet',
        id: 40425,
        description: 'The source for the stub floating rate index.',
    },
    {
        name: 'LegPaymentStubIndexCurvePeriod',
        abbrName: 'NdxPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40426,
        description: 'Time unit multiplier for the floating rate index.',
    },
    {
        name: 'LegPaymentStubIndexCurveUnit',
        abbrName: 'NdxUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexCurveUnitCodeSet',
        id: 40427,
        description: 'Time unit associated with the floating rate index.',
    },
    {
        name: 'LegPaymentStubIndexRateMultiplier',
        abbrName: 'RtMult',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 40428,
        description:
            'A rate multiplier to apply to the floating rate. The multiplier can be less than or greater than 1 (one). This element should only be included if the multiplier is not equal to 1 (one) for the term of the stream.',
    },
    {
        name: 'LegPaymentStubIndexRateSpread',
        abbrName: 'Spread',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 40429,
        description: 'Spread from floating rate index.',
    },
    {
        name: 'LegPaymentStubIndexRateSpreadPositionType',
        abbrName: 'SpreadPosTyp',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
        id: 40430,
        description: 'Identifies whether the rate spread is applied to a long or a short position.',
    },
    {
        name: 'LegPaymentStubIndexRateTreatment',
        abbrName: 'RtTrtmt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateTreatmentCodeSet',
        id: 40431,
        description: 'Specifies the yield calculation treatment for the stub index.',
    },
    {
        name: 'LegPaymentStubIndexCapRate',
        abbrName: 'CapRt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40432,
        description:
            'The cap rate, if any, which applies to the floating rate. The cap rate (strike) is only required where the floating rate on a swap stream is capped at a certain level. The cap rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A cap rate of 5% would be represented as 0.05.',
    },
    {
        name: 'LegPaymentStubIndexCapRateBuySide',
        abbrName: 'CapRtBuy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamCapRateBuySideCodeSet',
        id: 40433,
        description: 'Reference to the buyer of the cap rate option through its trade side.',
    },
    {
        name: 'LegPaymentStubIndexCapRateSellSide',
        abbrName: 'CapRtSell',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamCapRateBuySideCodeSet',
        id: 40434,
        description: 'Reference to the seller of the cap rate option through its trade side.',
    },
    {
        name: 'LegPaymentStubIndexFloorRate',
        abbrName: 'FlrRt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40435,
        description:
            'The floor rate, if any, which applies to the floating rate. The floor rate (strike) is only required where the floating rate on a swap stream is floored at a certain strike level. The floor rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A floor rate of 5% would be represented as 0.05.',
    },
    {
        name: 'LegPaymentStubIndexFloorRateBuySide',
        abbrName: 'FlrRtBuy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamFloorRateBuySideCodeSet',
        id: 40436,
        description: 'Reference to the buyer of the floor rate option through its trade side.',
    },
    {
        name: 'LegPaymentStubIndexFloorRateSellSide',
        abbrName: 'FlrRtSell',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamFloorRateBuySideCodeSet',
        id: 40437,
        description: 'Reference to the seller of the floor rate option through its trade side.',
    },
    {
        name: 'LegPaymentStubIndex2',
        abbrName: 'Ndx2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40438,
        discriminatorId: '40439',
        description: 'The second stub floating rate index.',
    },
    {
        name: 'LegPaymentStubIndex2Source',
        abbrName: 'Ndx2Src',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexSourceCodeSet',
        id: 40439,
        description: 'The source for the second stub floating rate index.',
    },
    {
        name: 'LegPaymentStubIndex2CurvePeriod',
        abbrName: 'Ndx2Period',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40440,
        description: 'Secondary time unit multiplier for the stub floating rate index curve.',
    },
    {
        name: 'LegPaymentStubIndex2CurveUnit',
        abbrName: 'Ndx2Unit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexCurveUnitCodeSet',
        id: 40441,
        description: 'Secondary time unit associated with the stub floating rate index curve.',
    },
    {
        name: 'LegPaymentStubIndex2RateMultiplier',
        abbrName: 'RtMult2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 40442,
        description:
            'A rate multiplier to apply to the second floating rate. The multiplier can be less than or greater than 1 (one). This element should only be included if the multiplier is not equal to 1 (one) for the term of the stream.',
    },
    {
        name: 'LegPaymentStubIndex2RateSpread',
        abbrName: 'Spread2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 40443,
        description: 'Spread from the second floating rate index.',
    },
    {
        name: 'LegPaymentStubIndex2RateSpreadPositionType',
        abbrName: 'Spread2PosTyp',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
        id: 40444,
        description: 'Identifies whether the rate spread is applied to a long or a short position.',
    },
    {
        name: 'LegPaymentStubIndex2RateTreatment',
        abbrName: 'RtTrtmt2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateTreatmentCodeSet',
        id: 40445,
        description: 'Specifies the yield calculation treatment for the second stub index.',
    },
    {
        name: 'LegPaymentStubIndex2CapRate',
        abbrName: 'CapRt2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40446,
        description:
            'The cap rate, if any, which applies to the second floating rate. The cap rate (strike) is only required where the floating rate on a swap stream is capped at a certain level. The cap rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A cap rate of 5% would be represented as 0.05.',
    },
    {
        name: 'LegPaymentStubIndex2FloorRate',
        abbrName: 'FlrRt2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40447,
        description:
            'The floor rate, if any, which applies to the second floating rate. The floor rate (strike) is only required where the floating rate on a swap stream is floored at a certain strike level. The floor rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A floor rate of 5% would be represented as 0.05.',
    },
    {
        name: 'NoLegProvisions',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40448,
        description: 'Number of provisions in the repeating group.',
    },
    {
        name: 'LegProvisionType',
        abbrName: 'Typ',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ProvisionTypeCodeSet',
        id: 40449,
        description: 'Type of provisions.',
    },
    {
        name: 'LegProvisionDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40450,
        description: 'The unadjusted date of the provision.',
    },
    {
        name: 'LegProvisionDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40451,
        description:
            "The business day convention used to adjust the instrument leg's provision's date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.",
    },
    {
        name: 'LegProvisionDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40452,
        description:
            'The business center calendar used to adjust the instrument leg\'s provision\'s date, e.g. "GBLO". See http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegProvisionDateAdjusted',
        abbrName: 'Dt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40453,
        description: 'The adjusted date of the provision.',
    },
    {
        name: 'LegProvisionDateTenorPeriod',
        abbrName: 'TenorPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40454,
        description: "Time unit multiplier for the leg provision's tenor period.",
    },
    {
        name: 'LegProvisionDateTenorUnit',
        abbrName: 'TenorUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ProvisionDateTenorUnitCodeSet',
        id: 40455,
        description: "Time unit associated with the leg provision's tenor period.",
    },
    {
        name: 'LegProvisionCalculationAgent',
        abbrName: 'CalcAgent',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ProvisionCalculationAgentCodeSet',
        id: 40456,
        description:
            'Used to identify the calculation agent. The calculation agent may be identified in LegProvisionCalculationAgent(40456) or in the ProvisionParties component.',
    },
    {
        name: 'LegProvisionOptionSinglePartyBuyerSide',
        abbrName: 'BuyerSide',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ProvisionOptionSinglePartyBuyerSideCodeSet',
        id: 40457,
        description:
            'If optional early termination is not available to both parties then this component identifies the buyer of the option through its side of the trade.',
    },
    {
        name: 'LegProvisionOptionSinglePartySellerSide',
        abbrName: 'SellerSide',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ProvisionOptionSinglePartyBuyerSideCodeSet',
        updatedEP: '169',
        id: 40458,
        description:
            'If optional early termination is not available to both parties then this component identifies the seller of the option through its side of the trade.',
    },
    {
        name: 'LegProvisionOptionExerciseStyle',
        abbrName: 'ExerStyle',
        unionDataType: 'Reserved100Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ExerciseStyleCodeSet',
        id: 40459,
        description: 'The instrument provision option exercise style.',
    },
    {
        name: 'LegProvisionOptionExerciseMultipleNotional',
        abbrName: 'MultplNotl',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 40460,
        description:
            'A notional amount which restricts the amount of notional that can be exercised when partial exercise or multiple exercise is applicable. The integral multiple amount defines a lower limit of notional that can be exercised and also defines a unit multiple of notional that can be exercised, i.e. only integer multiples of this amount can be exercised.',
    },
    {
        name: 'LegProvisionOptionExerciseMinimumNotional',
        abbrName: 'MinNotl',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 40461,
        description: 'The minimum notional amount that can be exercised on a given exercise date.',
    },
    {
        name: 'LegProvisionOptionExerciseMaximumNotional',
        abbrName: 'MaxNotl',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 40462,
        description: 'The maximum notional amount that can be exercised on a given exercise date.',
    },
    {
        name: 'LegProvisionOptionMinimumNumber',
        abbrName: 'MinNum',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40463,
        description: 'The minimum number of options that can be exercised on a given exercise date.',
    },
    {
        name: 'LegProvisionOptionMaximumNumber',
        abbrName: 'MaxNum',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40464,
        description:
            'The maximum number of options that can be exercised on a given exercise date. If the number is not specified, it means that the maximum number of options corresponds to the remaining unexercised options.',
    },
    {
        name: 'LegProvisionOptionExerciseConfirmation',
        abbrName: 'ExerCnfm',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 40465,
        description:
            "Used to indicate whether follow-up confirmation of exercise (written or electronic) is required following telephonic notice by the buyer to the seller or seller's agent.",
    },
    {
        name: 'LegProvisionCashSettlMethod',
        abbrName: 'SettlMeth',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ProvisionCashSettlMethodCodeSet',
        id: 40466,
        description:
            'An ISDA defined cash settlement method used for the determination of the applicable cash settlement amount. The method is defined in the 2006 ISDA Definitions, Section 18.3. Cash Settlement Methods, paragraph (e).',
    },
    {
        name: 'LegProvisionCashSettlCurrency',
        abbrName: 'SettlCcy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 40467,
        description: 'Specifies the currency of settlement. Uses ISO 4217 currency codes.',
    },
    {
        name: 'LegProvisionCashSettlCurrency2',
        abbrName: 'SettlCcy2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 40468,
        description:
            'Specifies the currency of settlement for a cross-currency provision. Uses ISO 4217 currency codes.',
    },
    {
        name: 'LegProvisionCashSettlQuoteType',
        abbrName: 'SettlQteTyp',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ProvisionCashSettlQuoteTypeCodeSet',
        id: 40469,
        description: 'Identifies the type of quote to be used.',
    },
    {
        name: 'LegProvisionCashSettlQuoteSource',
        abbrName: 'SettlQteSrc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexSourceCodeSet',
        id: 40470,
        description: 'Identifies the source of quote information.',
    },
    {
        name: 'BusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40471,
        description:
            'A business center whose calendar is used for date adjustment, e.g. "GBLO". See http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegProvisionText',
        abbrName: 'Txt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40472,
        description:
            'Free form text to specify additional information or enumeration description when a standard value does not apply.',
    },
    {
        name: 'NoLegProvisionCashSettlPaymentDates',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40473,
        description: 'Number of provision cash settlement payment dates in the repeating group.',
    },
    {
        name: 'LegProvisionCashSettlPaymentDate',
        abbrName: 'Dt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40474,
        description:
            'The cash settlement payment date, unadjusted or adjusted depending on LegProvisionCashSettlPaymentDateType(40521).',
    },
    {
        name: 'LegProvisionCashSettlPaymentDateType',
        abbrName: 'Typ',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ProvisionCashSettlPaymentDateTypeCodeSet',
        id: 40475,
        description: 'Specifies the type of date (e.g. adjusted for holidays).',
    },
    {
        name: 'LegProvisionOptionExerciseBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40476,
        description:
            "The business day convention used to adjust the instrument leg's provision's option exercise date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.",
    },
    {
        name: 'LegProvisionOptionExerciseBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40477,
        description:
            'The business center calendar used to adjust the instrument leg\'s provision\'s option exercise date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegProvisionOptionExerciseEarliestDateOffsetPeriod',
        abbrName: 'ErlstOfstPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40478,
        description:
            'Time unit multiplier for the interval to the first (and possibly only) exercise date in the exercise period.',
    },
    {
        name: 'LegProvisionOptionExerciseEarliestDateOffsetUnit',
        abbrName: 'ErlstOfstUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ProvisionOptionExerciseEarliestDateOffsetUnitCodeSet',
        id: 40479,
        description:
            'Time unit associated with the interval to the first (and possibly only) exercise date in the exercise period.',
    },
    {
        name: 'LegProvisionOptionExerciseFrequencyPeriod',
        abbrName: 'FreqPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40480,
        description:
            'Time unit multiplier for subsequent exercise dates in the exercise period following the earliest exercise date. An interval of 1 day should be used to indicate an American style exercise period.',
    },
    {
        name: 'LegProvisionOptionExerciseFrequencyUnit',
        abbrName: 'FreqUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'CouponFrequencyUnitCodeSet',
        id: 40481,
        description:
            'Time unit associated with subsequent exercise dates in the exercise period following the earliest exercise date.',
    },
    {
        name: 'LegProvisionOptionExerciseStartDateUnadjusted',
        abbrName: 'StartDtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40482,
        description: 'The unadjusted first day of the exercise period for an American style option.',
    },
    {
        name: 'LegProvisionOptionExerciseStartDateRelativeTo',
        abbrName: 'StartDtReltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40483,
        description:
            'Specifies the anchor date when the option exercise start date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'LegProvisionOptionExerciseStartDateOffsetPeriod',
        abbrName: 'StartDtOfstPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 40484,
        description: 'Time unit multiplier for the relative option exercise start date offset.',
    },
    {
        name: 'LegProvisionOptionExerciseStartDateOffsetUnit',
        abbrName: 'StartDtOfstUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 40485,
        description: 'Time unit associated with the relative option exercise start date offset.',
    },
    {
        name: 'LegProvisionOptionExerciseStartDateOffsetDayType',
        abbrName: 'StartDtOfstDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40486,
        description: "Specifies the day type of the provision's relative option exercise start date offset.",
    },
    {
        name: 'LegProvisionOptionExerciseStartDateAdjusted',
        abbrName: 'StartDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40487,
        description: 'The adjusted first day of the exercise period for an American style option.',
    },
    {
        name: 'LegProvisionOptionExercisePeriodSkip',
        abbrName: 'Skip',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40488,
        description:
            'The number of periods in the referenced date schedule that are between each date in the relative date schedule. Thus a skip of 2 would mean that dates are relative to every second date in the referenced schedule. If present this should have a value greater than 1.',
    },
    {
        name: 'LegProvisionOptionExerciseBoundsFirstDateUnadjusted',
        abbrName: 'FirstDtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40489,
        description:
            'The unadjusted first date of a schedule. This can be used to restrict the range of exercise dates when they are relative.',
    },
    {
        name: 'LegProvisionOptionExerciseBoundsLastDateUnadjusted',
        abbrName: 'LastDtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40490,
        description:
            'The unadjusted last date of a schedule. This can be used to restrict the range of exercise dates when they are relative.',
    },
    {
        name: 'LegProvisionOptionExerciseEarliestTime',
        abbrName: 'ErlstTm',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 40491,
        description:
            "The earliest time at which notice of exercise can be given by the buyer to the seller (or seller's agent) (i) on the expriation date, in the case of a European style option, (ii) on each bermuda option exercise date and the expiration date, in the case of a Bermuda style option the commencement date to, and including, the expiration date, in the case of an American option.",
    },
    {
        name: 'LegProvisionOptionExerciseEarliestTimeBusinessCenter',
        abbrName: 'ErlstTmBizCtr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40492,
        description:
            "Identifies the business center calendar used with the provision's earliest time for notice of exercise.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.",
    },
    {
        name: 'LegProvisionOptionExerciseLatestTime',
        abbrName: 'LtstTm',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 40493,
        description:
            "For a Bermuda or American style option, the latest time on an exercise business day (excluding the expiration date) within the exercise period that notice can be given by the buyer to the seller or seller's agent. Notice of exercise given after this time will be deemed to have been given on the next exercise business day.",
    },
    {
        name: 'LegProvisionOptionExerciseLatestTimeBusinessCenter',
        abbrName: 'LtstTmBizCtr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40494,
        description:
            "Identifies the business center calendar used with the provision's latest time for notice of exercise.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.",
    },
    {
        name: 'NoLegProvisionOptionExerciseFixedDates',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40495,
        description: 'Number of provision option exercise fixed dates in the repeating group.',
    },
    {
        name: 'LegProvisionOptionExerciseFixedDate',
        abbrName: 'Dt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40496,
        description:
            'A predetermined option exercise date unadjusted or adjusted depending on LegProvisionOptionExerciseFixedDateType(40497).',
    },
    {
        name: 'LegProvisionOptionExerciseFixedDateType',
        abbrName: 'Typ',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ProvisionOptionExerciseFixedDateTypeCodeSet',
        id: 40497,
        description: 'Specifies the type of date (e.g. adjusted for holidays).',
    },
    {
        name: 'LegProvisionOptionExpirationDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40498,
        description:
            'The unadjusted last day within an exercise period for an American style option. For a European style option it is the only day within the exercise period.',
    },
    {
        name: 'LegProvisionOptionExpirationDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40499,
        description:
            "The business day convention used to adjust the instrument leg's provision's option expiration date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.",
    },
    {
        name: 'LegProvisionOptionExpirationDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40500,
        description:
            'The business center calendar used to adjust the instrument leg\'s provision\'s option expiration date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegProvisionOptionExpirationDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40501,
        description:
            'Specifies the anchor date when the option expiration date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'LegProvisionOptionExpirationDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 40502,
        description: 'Time unit multiplier for the relative option expiration date offset.',
    },
    {
        name: 'LegProvisionOptionExpirationDateOffsetUnit',
        abbrName: 'OfstUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 40503,
        description: 'Time unit associated with the relative option expiration date offset.',
    },
    {
        name: 'LegProvisionOptionExpirationDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40504,
        description: "Specifies the day type of the provision's relative option expiration date offset.",
    },
    {
        name: 'LegProvisionOptionExpirationDateAdjusted',
        abbrName: 'Dt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40505,
        description:
            'The adjusted last date within an exercise period for an American style option. For a European style option it is the only date within the exercise period.',
    },
    {
        name: 'LegProvisionOptionExpirationTime',
        abbrName: 'ExpTm',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 40506,
        description: 'The latest time for exercise on the expiration date.',
    },
    {
        name: 'LegProvisionOptionExpirationTimeBusinessCenter',
        abbrName: 'ExpTmBizCtr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40507,
        description:
            "Identifies the business center calendar used with the provision's latest exercise time on expiration date.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.",
    },
    {
        name: 'LegProvisionOptionRelevantUnderlyingDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40508,
        description:
            'The unadjusted date on the underlying set by the exercise of an option. What this date is depends on the option (e.g. in a swaption it is the swap effective date, in an extendible/cancelable provision it is the swap termination date).',
    },
    {
        name: 'LegProvisionOptionRelevantUnderlyingDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40509,
        description:
            "The business day convention used to adjust the instrument leg's provision's option relevant underlying date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.",
    },
    {
        name: 'LegProvisionOptionRelevantUnderlyingDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40510,
        description:
            'The business center calendar used to adjust the instrument leg\'s provision\'s option underlying date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegProvisionOptionRelevantUnderlyingDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40511,
        description:
            'Specifies the anchor date when the date relevant to the underlying trade on exercise is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'LegProvisionOptionRelevantUnderlyingDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 40512,
        description: 'Time unit multiplier for the relative option relevant underlying date offset.',
    },
    {
        name: 'LegProvisionOptionRelevantUnderlyingDateOffsetUnit',
        abbrName: 'OfstUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 40513,
        description: 'Time unit associated with the relative option relevant underlying date offset.',
    },
    {
        name: 'LegProvisionOptionRelevantUnderlyingDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40514,
        description: "Specifies the day type of the provision's relative option relevant underlying date offset.",
    },
    {
        name: 'LegProvisionOptionRelevantUnderlyingDateAdjusted',
        abbrName: 'Dt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40515,
        description:
            'The adjusted date on the underlying set by the exercise of an option. What this date is depends on the option (e.g. in a swaption it is the swap effective date, in an extendible/cancelable provision it is the swap termination date).',
    },
    {
        name: 'LegProvisionCashSettlPaymentDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40516,
        description:
            "The business day convention used to adjust the provisional cash settlement payment's termination, or relative termination, date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.",
    },
    {
        name: 'LegProvisionCashSettlPaymentDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40517,
        description:
            'The business center calendar used to adjust the provisional cash settlement payment\'s termination, or relative termination, date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegProvisionCashSettlPaymentDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40518,
        description:
            'Specifies the anchor date when the cash settlement payment date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'LegProvisionCashSettlPaymentDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 40519,
        description: 'Time unit multiplier for the relative cash settlement payment date offset.',
    },
    {
        name: 'LegProvisionCashSettlPaymentDateOffsetUnit',
        abbrName: 'OfstUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 40520,
        description: 'Time unit associated with the relative cash settlement payment date offset.',
    },
    {
        name: 'LegProvisionCashSettlPaymentDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40521,
        description: "Specifies the day type of the provision's relative cash settlement payment date offset.",
    },
    {
        name: 'LegProvisionCashSettlPaymentDateRangeFirst',
        abbrName: 'DtFirst',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40522,
        description: 'The first date in range when a settlement date range is provided.',
    },
    {
        name: 'LegProvisionCashSettlPaymentDateRangeLast',
        abbrName: 'DtLast',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40523,
        description: 'The last date in range when a settlement date range is provided.',
    },
    {
        name: 'LegProvisionCashSettlValueTime',
        abbrName: 'Tm',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 40524,
        description:
            'A time specified in 24-hour format, e.g. 11am would be represented as 11:00:00. The time of the cash settlement valuation date when the cash settlement amount will be determined according to the cash settlement method if the parties have not otherwise been able to agree to the cash settlement amount.',
    },
    {
        name: 'LegProvisionCashSettlValueTimeBusinessCenter',
        abbrName: 'TmBizCtr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40525,
        description:
            "Identifies the business center calendar used with the provision's cash settlement valuation time.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.",
    },
    {
        name: 'LegProvisionCashSettlValueDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40526,
        description:
            "The business day convention used to adjust the provision's cash settlement valuation date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.",
    },
    {
        name: 'LegProvisionCashSettlValueDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40527,
        description:
            'The business center calendar used to adjust the provision\'s cash settlement valuation date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegProvisionCashSettlValueDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40528,
        description:
            'Specifies the anchor date when the cash settlement value date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'LegProvisionCashSettlValueDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 40529,
        description: 'Time unit multiplier for the relative cash settlement value date offset.',
    },
    {
        name: 'LegProvisionCashSettlValueDateOffsetUnit',
        abbrName: 'OfstUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 40530,
        description: 'Time unit associated with the relative cash settlement value date offset.',
    },
    {
        name: 'LegProvisionCashSettlValueDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40531,
        description: "Specifies the day type of the provision's relative cash settlement value date offset.",
    },
    {
        name: 'LegProvisionCashSettlValueDateAdjusted',
        abbrName: 'Dt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40532,
        description: 'The adjusted cash settlement value date.',
    },
    {
        name: 'NoLegProvisionPartyIDs',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40533,
        description: 'Number of parties identified in the contract provision.',
    },
    {
        name: 'LegProvisionPartyID',
        abbrName: 'ID',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40534,
        discriminatorId: '40535',
        description: 'The party identifier/code for the payment settlement party.',
    },
    {
        name: 'LegProvisionPartyIDSource',
        abbrName: 'Src',
        updated: 'FIX.Latest',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PartyIDSourceCodeSet',
        updatedEP: '271',
        id: 40535,
        description: 'Identifies the class or source of LegProvisionPartyID(40534).',
    },
    {
        name: 'LegProvisionPartyRole',
        abbrName: 'R',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PartyRoleCodeSet',
        id: 40536,
        description: 'Identifies the type or role of LegProvisionPartyID(40534) specified.',
    },
    {
        name: 'NoLegProvisionPartySubIDs',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40537,
        description: 'Number of sub-party IDs to be reported for the party.',
    },
    {
        name: 'LegProvisionPartySubID',
        abbrName: 'ID',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40538,
        description: 'Party sub-identifier, if applicable, for LegProvisionPartyRole(40536).',
    },
    {
        name: 'LegProvisionPartySubIDType',
        abbrName: 'Typ',
        unionDataType: 'Reserved4000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PartySubIDTypeCodeSet',
        id: 40539,
        description: 'The type of LegProvisionPartySubID(40538) value.',
    },
    {
        name: 'NoUnderlyingStreams',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40540,
        description: 'Number of swap streams in the repeating group.',
    },
    {
        name: 'UnderlyingStreamType',
        abbrName: 'Typ',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'StreamTypeCodeSet',
        id: 40541,
        description: 'Type of swap stream.',
    },
    {
        name: 'UnderlyingStreamDesc',
        abbrName: 'Desc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40542,
        description:
            'A short descriptive name given to payment stream. Eg. CDS, Fixed, Float, Float2, GBP. The description has no intrinsic meaning but should be arbitrarily chosen by the remitter as a reference.',
    },
    {
        name: 'UnderlyingStreamPaySide',
        abbrName: 'PaySide',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentPaySideCodeSet',
        id: 40543,
        description: 'The side of the party paying the stream.',
    },
    {
        name: 'UnderlyingStreamReceiveSide',
        abbrName: 'RcvSide',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentPaySideCodeSet',
        id: 40544,
        description: 'The side of the party receiving the stream.',
    },
    {
        name: 'UnderlyingStreamNotional',
        abbrName: 'Notl',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 40545,
        description: 'Notional, or initial notional value for the payment stream. Use SwapSchedule for steps.',
    },
    {
        name: 'UnderlyingStreamCurrency',
        abbrName: 'Ccy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 40546,
        description:
            'Specifies the currency the UnderlyingStreamNotional(40545) is denominated in. Uses ISO 4217 currency codes.',
    },
    {
        name: 'UnderlyingStreamText',
        abbrName: 'Txt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40547,
        description:
            'Free form text to specify additional information or enumeration description when a standard value does not apply.',
    },
    {
        name: 'UnderlyingStreamTerminationDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40548,
        description: 'The unadjusted termination date.',
    },
    {
        name: 'UnderlyingStreamTerminationDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40549,
        description:
            "The business day convention used to adjust the underlying instrument's stream's termination, or relative termination, date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.",
    },
    {
        name: 'UnderlyingStreamTerminationDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40550,
        description:
            'The business center calendar used to adjust the underlying instrument\'s stream\'s termination, or relative termination, date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'UnderlyingStreamTerminationDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40551,
        description:
            'Specifies the anchor date when the termination date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'UnderlyingStreamTerminationDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40552,
        description: 'Time unit multiplier for the relative termination date offset.',
    },
    {
        name: 'UnderlyingStreamTerminationDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 40553,
        description: 'Time unit associated with the relative termination date offset.',
    },
    {
        name: 'UnderlyingStreamTerminationDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40554,
        description: 'Specifies the day type of the relative termination date offset.',
    },
    {
        name: 'UnderlyingStreamTerminationDateAdjusted',
        abbrName: 'Dt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40555,
        description: 'The adjusted termination date.',
    },
    {
        name: 'UnderlyingStreamCalculationPeriodBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40556,
        description:
            'The business day convention used to adjust the calculation periods. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.',
    },
    {
        name: 'UnderlyingStreamCalculationPeriodBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40557,
        description:
            'The business center calendar used to adjust the calculation periods, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'UnderlyingStreamFirstPeriodStartDateUnadjusted',
        abbrName: 'FirstStartDtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40558,
        description: 'The unadjusted first calculation period start date if before the effective date.',
    },
    {
        name: 'UnderlyingStreamFirstPeriodStartDateBusinessDayConvention',
        abbrName: 'FirstStartDtBizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40559,
        description:
            "The business day convention used to adjust the underlying instrument's stream's first calculation period start date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.",
    },
    {
        name: 'UnderlyingStreamFirstPeriodStartDateBusinessCenter',
        abbrName: 'FirstStartDtBizCtr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40560,
        description:
            'The business center calendar used to adjust the underlying instrument\'s stream\'s first calculation period start date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'UnderlyingStreamFirstPeriodStartDateAdjusted',
        abbrName: 'FirstStartDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40561,
        description: 'The adjusted first calculation period start date, if it is before the effective date.',
    },
    {
        name: 'UnderlyingStreamFirstRegularPeriodStartDateUnadjusted',
        abbrName: 'FirstReglrStartDtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40562,
        description:
            'The unadjusted first start date of the regular calculation period, if there is an initial stub period.',
    },
    {
        name: 'UnderlyingStreamFirstCompoundingPeriodEndDateUnadjusted',
        abbrName: 'FirstCmpndgEndDtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40563,
        description: 'The unadjusted end date of the initial compounding period.',
    },
    {
        name: 'UnderlyingStreamLastRegularPeriodEndDateUnadjusted',
        abbrName: 'LastReglrEndDtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40564,
        description: 'The unadjusted last regular period end date if there is a final stub period.',
    },
    {
        name: 'UnderlyingStreamCalculationFrequencyPeriod',
        abbrName: 'FreqPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40565,
        description: 'Time unit multiplier for the frequency at which calculation period end dates occur.',
    },
    {
        name: 'UnderlyingStreamCalculationFrequencyUnit',
        abbrName: 'FreqUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'CouponFrequencyUnitCodeSet',
        id: 40566,
        description: 'Time unit associated with the frequency at which calculation period end dates occur.',
    },
    {
        name: 'UnderlyingStreamCalculationRollConvention',
        abbrName: 'Roll',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'DateRollConventionCodeSet',
        id: 40567,
        description:
            'The convention for determining the sequence of end dates. It is used in conjunction with a specified frequency. Used only to override the roll convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.',
    },
    {
        name: 'UnderlyingPaymentStreamType',
        abbrName: 'Typ',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamTypeCodeSet',
        id: 40568,
        description:
            'Identifies the type of payment stream applicable to the swap stream associated with the underlying instrument.',
    },
    {
        name: 'UnderlyingPaymentStreamMarketRate',
        abbrName: 'MktRt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40569,
        description:
            'Used only for credit index trade. This contains the credit spread ("fair value") at which the trade was executed. The market rate varies over the life of the index depending on market conditions. This is the price of the index as quoted by trading desks.',
    },
    {
        name: 'UnderlyingPaymentStreamDelayIndicator',
        abbrName: 'DelayInd',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 40570,
        description:
            'Applicable to credit default swaps on mortgage backed securities to specify whether payment delays are applicable to the fixed amount.\n\nResidential mortgage backed securities typically have a payment delay of 5 days between the coupon date of the reference obligation and the payment date of the synthetic swap.\n\nCommercial mortage backed securities do not typically have a payment delay, with both payment dates (the coupon date of the reference obligation and the payment date of the synthetic swap) being on the 25th of each month.',
    },
    {
        name: 'UnderlyingPaymentStreamSettlCurrency',
        abbrName: 'SettlCcy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 40571,
        description:
            'Specifies the currency that the stream settles in (to support swaps that settle in a currency different from the notional currency). Uses ISO 4217 currency codes.',
    },
    {
        name: 'UnderlyingPaymentStreamDayCount',
        abbrName: 'DayCnt',
        unionDataType: 'Reserved100Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'CouponDayCountCodeSet',
        id: 40572,
        description: 'The day count convention used in the payment stream calculations.',
    },
    {
        name: 'UnderlyingPaymentStreamAccrualDays',
        abbrName: 'AcrlDays',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40573,
        description:
            'The number of days from the adjusted calculation period start date to the adjusted value date, calculated in accordance with the applicable day count fraction.',
    },
    {
        name: 'UnderlyingPaymentStreamDiscountType',
        abbrName: 'DiscTyp',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamDiscountTypeCodeSet',
        id: 40574,
        description: 'The method of calculating discounted payment amounts',
    },
    {
        name: 'UnderlyingPaymentStreamDiscountRate',
        abbrName: 'Disc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40575,
        description: 'Discount rate. The rate is expressed in decimal, e.g. 5% is expressed as 0.05.',
    },
    {
        name: 'UnderlyingPaymentStreamDiscountRateDayCount',
        abbrName: 'DiscDayCnt',
        unionDataType: 'Reserved100Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'CouponDayCountCodeSet',
        id: 40576,
        description: 'The day count convention applied to the UnderlyingPaymentStreamDiscountRate(40575).',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingMethod',
        abbrName: 'CmpndgMeth',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamCompoundingMethodCodeSet',
        id: 40577,
        description: 'Compounding Method.',
    },
    {
        name: 'UnderlyingPaymentStreamInitialPrincipalExchangeIndicator',
        abbrName: 'InitPrncplExchInd',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 40578,
        description: 'Indicates whether there is an initial exchange of principal on the effective date.',
    },
    {
        name: 'UnderlyingPaymentStreamInterimPrincipalExchangeIndicator',
        abbrName: 'IntrmPrncplExchInd',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 40579,
        description:
            'Indicates whether there are intermediate or interim exchanges of principal during the term of the swap.',
    },
    {
        name: 'UnderlyingPaymentStreamFinalPrincipalExchangeIndicator',
        abbrName: 'FnlPrncplExchInd',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 40580,
        description: 'Indicates whether there is a final exchange of principal on the termination date.',
    },
    {
        name: 'UnderlyingPaymentStreamPaymentDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40581,
        description:
            "The business day convention used to adjust the payment stream's payment date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.",
    },
    {
        name: 'UnderlyingPaymentStreamPaymentDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40582,
        description:
            'The business center calendar used to adjust the payment stream\'s payment date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'UnderlyingPaymentStreamPaymentFrequencyPeriod',
        abbrName: 'FreqPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40583,
        description: 'Time unit multiplier for the frequency of payments.',
    },
    {
        name: 'UnderlyingPaymentStreamPaymentFrequencyUnit',
        abbrName: 'FreqUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentFrequencyUnitCodeSet',
        id: 40584,
        description: 'Time unit associated with the frequency of payments.',
    },
    {
        name: 'UnderlyingPaymentStreamPaymentRollConvention',
        abbrName: 'Roll',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'DateRollConventionCodeSet',
        id: 40585,
        description:
            'The convention for determining the sequence of end dates. It is used in conjunction with a specified frequency. Used only to override the roll convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.',
    },
    {
        name: 'UnderlyingPaymentStreamFirstPaymentDateUnadjusted',
        abbrName: 'FirstDtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40586,
        description: 'The unadjusted first payment date.',
    },
    {
        name: 'UnderlyingPaymentStreamLastRegularPaymentDateUnadjusted',
        abbrName: 'LastReglrDtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40587,
        description: 'The unadjusted last regular payment date.',
    },
    {
        name: 'UnderlyingPaymentStreamPaymentDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40588,
        description:
            'Specifies the anchor date when payment dates are relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'UnderlyingPaymentStreamPaymentDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 40589,
        description: 'Time unit multiplier for the relative payment date offset.',
    },
    {
        name: 'UnderlyingPaymentStreamPaymentDateOffsetUnit',
        abbrName: 'OfstUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 40590,
        description: 'Time unit associated with the relative payment date offset.',
    },
    {
        name: 'UnderlyingPaymentStreamPaymentDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40591,
        description: 'Specifies the day type of the relative payment date offset.',
    },
    {
        name: 'UnderlyingPaymentStreamResetDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40592,
        description:
            'Specifies the anchor date when the reset dates are relative to an anchor date.\n\nIf the reset frequency is specified as daily this element must not be included.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'UnderlyingPaymentStreamResetDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40593,
        description:
            "The business day convention used to adjust the payment stream's reset date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.",
    },
    {
        name: 'UnderlyingPaymentStreamResetDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40594,
        description:
            'The business center calendar used to adjust the payment stream\'s reset date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'UnderlyingPaymentStreamResetFrequencyPeriod',
        abbrName: 'FreqPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40595,
        description: 'Time unit multiplier for frequency of resets.',
    },
    {
        name: 'UnderlyingPaymentStreamResetFrequencyUnit',
        abbrName: 'FreqUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'CouponFrequencyUnitCodeSet',
        id: 40596,
        description: 'Time unit associated with frequency of resets.',
    },
    {
        name: 'UnderlyingPaymentStreamResetWeeklyRollConvention',
        abbrName: 'WklyRoll',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamResetWeeklyRollConventionCodeSet',
        id: 40597,
        description:
            'Used to specify the day of the week in which the reset occurs for payments that reset on a weekly basis.',
    },
    {
        name: 'UnderlyingPaymentStreamInitialFixingDateRelativeTo',
        abbrName: 'InitReltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40598,
        description:
            'Specifies the anchor date when the initial fixing date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'UnderlyingPaymentStreamInitialFixingDateBusinessDayConvention',
        abbrName: 'InitBizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40599,
        description:
            "The business day convention used to adjust the payment stream's initial fixing date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.",
    },
    {
        name: 'UnderlyingPaymentStreamInitialFixingDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40600,
        description:
            'The business center calendar used to adjust the payment stream\'s initial fixing date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'UnderlyingPaymentStreamInitialFixingDateOffsetPeriod',
        abbrName: 'InitPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 40601,
        description: 'Time unit multiplier for the relative initial fixing date offset.',
    },
    {
        name: 'UnderlyingPaymentStreamInitialFixingDateOffsetUnit',
        abbrName: 'InitUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 40602,
        description: 'Time unit associated with the relative initial fixing date offset.',
    },
    {
        name: 'UnderlyingPaymentStreamInitialFixingDateOffsetDayType',
        abbrName: 'InitDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40603,
        description: 'Specifies the day type of the relative initial fixing date offset.',
    },
    {
        name: 'UnderlyingPaymentStreamInitialFixingDateAdjusted',
        abbrName: 'InitDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40604,
        description: 'The adjusted initial fixing date.',
    },
    {
        name: 'UnderlyingPaymentStreamFixingDateRelativeTo',
        abbrName: 'FixngReltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40605,
        description:
            'Specifies the anchor date when the fixing date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'UnderlyingPaymentStreamFixingDateBusinessDayConvention',
        abbrName: 'FixngBizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40606,
        description:
            "The business day convention used to adjust the payment stream's fixing date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.",
    },
    {
        name: 'UnderlyingPaymentStreamFixingDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40607,
        description:
            'The business center calendar used to adjust the payment stream\'s fixing date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'UnderlyingPaymentStreamFixingDateOffsetPeriod',
        abbrName: 'FixngPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 40608,
        description: 'Time unit multiplier for the relative fixing date offset.',
    },
    {
        name: 'UnderlyingPaymentStreamFixingDateOffsetUnit',
        abbrName: 'FixngUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 40609,
        description: 'Time unit associated with the relative fixing date offset.',
    },
    {
        name: 'UnderlyingPaymentStreamFixingDateOffsetDayType',
        abbrName: 'FixngDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40610,
        description: 'Specifies the day type of the relative fixing date offset.',
    },
    {
        name: 'UnderlyingPaymentStreamFixingDateAdjusted',
        abbrName: 'FixngDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40611,
        description: 'The adjusted fixing date.',
    },
    {
        name: 'UnderlyingPaymentStreamRateCutoffDateOffsetPeriod',
        abbrName: 'CutoffPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 40612,
        description: 'Time unit multiplier for the relative rate cut-off date offset.',
    },
    {
        name: 'UnderlyingPaymentStreamRateCutoffDateOffsetUnit',
        abbrName: 'CutoffUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 40613,
        description: 'Time unit associated with the relative rate cut-off date offset.',
    },
    {
        name: 'UnderlyingPaymentStreamRateCutoffDateOffsetDayType',
        abbrName: 'CutoffDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40614,
        description: 'Specifies the day type of the relative rate cut-off date offset.',
    },
    {
        name: 'UnderlyingPaymentStreamRate',
        abbrName: 'Rt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40615,
        description: 'The rate applicable to the fixed rate payment stream.',
    },
    {
        name: 'UnderlyingPaymentStreamFixedAmount',
        abbrName: 'Amt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 40616,
        description:
            "The underlying payment stream's fixed payment amount. In CDS an alternative to UnderlyingPaymentStreamRate(40615).",
    },
    {
        name: 'UnderlyingPaymentStreamRateOrAmountCurrency',
        abbrName: 'Ccy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 40617,
        description:
            'Specifies the currency in which UnderlyingPaymentStreamFixedAmount(40616) or UnderlyingPaymentStreamRate(40615) is denominated. Users ISO 4271 currency codes.',
    },
    {
        name: 'UnderlyingPaymentStreamFutureValueNotional',
        abbrName: 'FutValNotl',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 40618,
        description:
            'The future value notional is normally only required for certain non-deliverable interest rate swaps (e.g. Brazillian Real (BRL) vs. CETIP Interbank Deposit Rate (CDI)). The value is calculated as follows: Future Value Notional = Notional Amount * (1 + Fixed Rate) ^ (Fixed Rate Day Count Fraction). The currency is the same as the stream notional.',
    },
    {
        name: 'UnderlyingPaymentStreamFutureValueDateAdjusted',
        abbrName: 'FutValDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40619,
        description: 'The adjusted value date of the future value amount.',
    },
    {
        name: 'UnderlyingPaymentStreamRateIndex',
        abbrName: 'Ndx',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40620,
        discriminatorId: '40621',
        description: "The payment stream's floating rate index.",
    },
    {
        name: 'UnderlyingPaymentStreamRateIndexSource',
        abbrName: 'NdxSrc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexSourceCodeSet',
        id: 40621,
        description: 'The source of the payment stream floating rate index.',
    },
    {
        name: 'UnderlyingPaymentStreamRateIndexCurveUnit',
        abbrName: 'NdxUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexCurveUnitCodeSet',
        id: 40622,
        description: 'Time unit associated with the underlying instrument’s floating rate index.',
    },
    {
        name: 'UnderlyingPaymentStreamRateIndexCurvePeriod',
        abbrName: 'NdxPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40623,
        description: 'Time unit multiplier for the underlying instrument’s floating rate index.',
    },
    {
        name: 'UnderlyingPaymentStreamRateMultiplier',
        abbrName: 'RtMult',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 40624,
        description:
            'A rate multiplier to apply to the floating rate. A multiplier schedule is expressed as explicit multipliers and dates. In the case of a schedule, the step dates may be subject to adjustment in accordance with any adjustments specified in the calculationPeriodDatesAdjustments. The multiplier can be less than or greater than 1 (one). This element should only be included if the multiplier is not equal to 1 (one) for the term of the stream.',
    },
    {
        name: 'UnderlyingPaymentStreamRateSpread',
        abbrName: 'Spread',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 40625,
        description: 'Spread from floating rate index.',
    },
    {
        name: 'UnderlyingPaymentStreamRateSpreadPositionType',
        abbrName: 'SpreadPosTyp',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
        id: 40626,
        description: 'Identifies a short or long spread value.',
    },
    {
        name: 'UnderlyingPaymentStreamRateTreatment',
        abbrName: 'RtTrtmt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateTreatmentCodeSet',
        id: 40627,
        description: 'Specifies the yield calculation treatment for the index.',
    },
    {
        name: 'UnderlyingPaymentStreamCapRate',
        abbrName: 'CapRt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40628,
        description:
            'The cap rate, if any, which applies to the floating rate. The cap rate (strike) is only required where the floating rate on a swap stream is capped at a certain level. The cap rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A cap rate of 5% would be represented as 0.05.',
    },
    {
        name: 'UnderlyingPaymentStreamCapRateBuySide',
        abbrName: 'CapRtBuy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamCapRateBuySideCodeSet',
        id: 40629,
        description: 'Reference to the buyer of the cap rate option through its trade side.',
    },
    {
        name: 'UnderlyingPaymentStreamCapRateSellSide',
        abbrName: 'CapRtSell',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamCapRateBuySideCodeSet',
        id: 40630,
        description: 'Reference to the seller of the cap rate option through its trade side.',
    },
    {
        name: 'UnderlyingPaymentStreamFloorRate',
        abbrName: 'FlrRt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40631,
        description:
            'The floor rate, if any, which applies to the floating rate. The floor rate (strike) is only required where the floating rate on a swap stream is floored at a certain strike level. The floor rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A floor rate of 5% would be represented as 0.05.',
    },
    {
        name: 'UnderlyingPaymentStreamFloorRateBuySide',
        abbrName: 'FlrRtBuy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamFloorRateBuySideCodeSet',
        id: 40632,
        description: 'Reference to the buyer of the floor rate option through its trade side.',
    },
    {
        name: 'UnderlyingPaymentStreamFloorRateSellSide',
        abbrName: 'FlrRtSell',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamFloorRateBuySideCodeSet',
        id: 40633,
        description: 'Reference to the seller of the floor rate option through its trade side.',
    },
    {
        name: 'UnderlyingPaymentStreamInitialRate',
        abbrName: 'InitRt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40634,
        description:
            'The initial floating rate reset agreed between the principal parties involved in the trade. This is assumed to be the first required reset rate for the first regular calculation period. It should only be included when the rate is not equal to the rate published on the source implied by the floating rate index. An initial rate of 5% would be represented as 0.05.',
    },
    {
        name: 'UnderlyingPaymentStreamFinalRateRoundingDirection',
        abbrName: 'FnlRtRndDirctn',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'RoundingDirectionCodeSet',
        updatedEP: '208',
        id: 40635,
        description: 'Specifies the rounding direction.',
    },
    {
        name: 'UnderlyingPaymentStreamFinalRatePrecision',
        abbrName: 'FnlRtPrcsn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40636,
        description:
            'Specifies the rounding precision in terms of a number of decimal places. Note how a percentage rate rounding of 5 decimal places is expressed as a rounding precision of 7.',
    },
    {
        name: 'UnderlyingPaymentStreamAveragingMethod',
        abbrName: 'AvgngMeth',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamAveragingMethodCodeSet',
        id: 40637,
        description:
            'When rate averaging is applicable, used to specify whether a weighted or unweighted average calculation method is to be used.',
    },
    {
        name: 'UnderlyingPaymentStreamNegativeRateTreatment',
        abbrName: 'NegtvRtTrtmt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamNegativeRateTreatmentCodeSet',
        id: 40638,
        description:
            'The specification of any provisions for calculating payment obligations when a floating rate is negative (either due to a quoted negative floating rate or by operation of a spread that is subtracted from the floating rate).',
    },
    {
        name: 'UnderlyingPaymentStreamInflationLagPeriod',
        abbrName: 'LagPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40639,
        description:
            'Time unit multiplier for the inflation lag period. The lag period is the offsetting period from the payment date which determines the reference period for which the inflation index is observed.',
    },
    {
        name: 'UnderlyingPaymentStreamInflationLagUnit',
        abbrName: 'LagUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamInflationLagUnitCodeSet',
        id: 40640,
        description: 'Time unit associated with the inflation lag period.',
    },
    {
        name: 'UnderlyingPaymentStreamInflationLagDayType',
        abbrName: 'LagDayTyp',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamInflationLagDayTypeCodeSet',
        id: 40641,
        description: 'The inflation lag period day type.',
    },
    {
        name: 'UnderlyingPaymentStreamInflationInterpolationMethod',
        abbrName: 'IntrpltnMeth',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamInflationInterpolationMethodCodeSet',
        id: 40642,
        description:
            'The method used when calculating the Inflation Index Level from multiple points - the most common is Linear.',
    },
    {
        name: 'UnderlyingPaymentStreamInflationIndexSource',
        abbrName: 'InfltnNdxSrc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexSourceCodeSet',
        id: 40643,
        description: 'The inflation index reference source.',
    },
    {
        name: 'UnderlyingPaymentStreamInflationPublicationSource',
        abbrName: 'PublctnSrc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40644,
        description: 'The current main publication source such as relevant web site or a government body.',
    },
    {
        name: 'UnderlyingPaymentStreamInflationInitialIndexLevel',
        abbrName: 'InitLvl',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 40645,
        description: 'Initial known index level for the first calculation period.',
    },
    {
        name: 'UnderlyingPaymentStreamInflationFallbackBondApplicable',
        abbrName: 'FallbckBond',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 40646,
        description:
            'Indicates whether a fallback bond as defined in the 2006 ISDA Inflation Derivatives Definitions, sections 1.3 and 1.8, is applicable or not. If not specified, the default value is "Y" (True/Yes).',
    },
    {
        name: 'UnderlyingPaymentStreamFRADiscounting',
        abbrName: 'FRADisc',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamFRADiscountingCodeSet',
        updatedEP: '169',
        id: 40647,
        description: 'The method of Forward Rate Agreement (FRA) discounting, if any, that will apply.',
    },
    {
        name: 'UnderlyingPaymentStreamNonDeliverableRefCurrency',
        abbrName: 'Ccy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 40648,
        description: 'The non-deliverable settlement reference currency. Uses ISO 4217 currency codes.',
    },
    {
        name: 'UnderlyingPaymentStreamNonDeliverableFixingDatesBizDayConvention',
        abbrName: 'BizDayCnvtn',
        updated: 'FIX.Latest',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        updatedEP: '271',
        id: 40649,
        description:
            "The business day convention used to adjust the payment stream's fixing date for the non-deliverable terms. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.",
    },
    {
        name: 'UnderlyingPaymentStreamNonDeliverableFixingDatesBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40650,
        description:
            'The business center calendar used to adjust the payment stream\'s fixing date for the non-deliverable terms, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'UnderlyingPaymentStreamNonDeliverableFixingDatesRelativeTo',
        abbrName: 'FixngReltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40651,
        description:
            'Specifies the anchor date when the non-deliverable fixing dates are relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'UnderlyingPaymentStreamNonDeliverableFixingDatesOffsetPeriod',
        abbrName: 'FixngPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 40652,
        description: 'Time unit multiplier for the relative non-deliverable fixing date offset.',
    },
    {
        name: 'UnderlyingPaymentStreamNonDeliverableFixingDatesOffsetUnit',
        abbrName: 'FixngUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 40653,
        description: 'Time unit associated with the relative non-deliverable fixing date offset.',
    },
    {
        name: 'UnderlyingPaymentStreamNonDeliverableFixingDatesOffsetDayType',
        abbrName: 'FixngDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40654,
        description: 'Specifies the day type of the relative non-deliverable fixing date offset.',
    },
    {
        name: 'SettlRateFallbackReferencePage',
        abbrName: 'RefPg',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40655,
        description:
            'Identifies the reference "page" from the rate source.\n\nWhen SettlRateFallbackRateSource(40373) = 3 (ISDA Settlement Rate Option) this contains the value from the scheme that reflects the terms of the Annex A to the ISDA 1998 FX and Currency Option Definitions. See: http://www.fpml.org/coding-scheme/settlement-rate-option',
    },
    {
        name: 'NoUnderlyingNonDeliverableFixingDates',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40656,
        description: 'Number of Fixing dates in the repeating group',
    },
    {
        name: 'UnderlyingNonDeliverableFixingDate',
        abbrName: 'Dt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40657,
        description:
            'The non-deliverable fixing date unadjusted or adjusted depending on UnderlyingNonDeliverableFixingDateType(40658).',
    },
    {
        name: 'UnderlyingNonDeliverableFixingDateType',
        abbrName: 'Typ',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NonDeliverableFixingDateTypeCodeSet',
        id: 40658,
        description: 'Specifies the type of date (e.g. adjusted for holidays).',
    },
    {
        name: 'NoUnderlyingSettlRateFallbacks',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40659,
        description: 'Number of settlement rate fallbacks in the repeating group',
    },
    {
        name: 'UnderlyingSettlRatePostponementMaximumDays',
        abbrName: 'MaxDays',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40660,
        description:
            'The maximum number of days to wait for a quote from the disrupted settlement rate option before proceding to this method.',
    },
    {
        name: 'UnderlyingPaymentStreamNonDeliverableSettlRateSource',
        abbrName: 'RtSrc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'RateSourceCodeSet',
        id: 40661,
        description: 'Identifies the source of rate information.',
    },
    {
        name: 'UnderlyingSettlRatePostponementSurvey',
        abbrName: 'Survey',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 40662,
        description: 'Indicates whether to request a settlement rate quote from the market.',
    },
    {
        name: 'UnderlyingSettlRatePostponementCalculationAgent',
        abbrName: 'CalcAgent',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ProvisionCalculationAgentCodeSet',
        id: 40663,
        description: 'Used to identify the settlement rate postponement calculation agent.',
    },
    {
        name: 'NoUnderlyingPaymentSchedules',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40664,
        description: 'Number of swap schedules in the repeating group',
    },
    {
        name: 'UnderlyingPaymentScheduleType',
        abbrName: 'Typ',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentScheduleTypeCodeSet',
        id: 40665,
        description: 'Type of schedule.',
    },
    {
        name: 'UnderlyingPaymentScheduleStubType',
        abbrName: 'StubTyp',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStubTypeCodeSet',
        id: 40666,
        description: 'Indicates to which stub this schedule applies.',
    },
    {
        name: 'UnderlyingPaymentScheduleStartDateUnadjusted',
        abbrName: 'StartDtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40667,
        description:
            'The unadjusted date on which the value is adjusted, or calculated if a future value notional for certain non-deliverable interest rate swaps (e.g. Brazillian Real (BRL) vs. CETIP Interbank Deposit Rate (CDI)), or the start date of a cashflow payment.',
    },
    {
        name: 'UnderlyingPaymentScheduleEndDateUnadjusted',
        abbrName: 'EndDtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40668,
        description: 'The unadjusted end date of a cashflow payment.',
    },
    {
        name: 'UnderlyingPaymentSchedulePaySide',
        abbrName: 'PaySide',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentPaySideCodeSet',
        id: 40669,
        description: 'The side of the party paying the step schedule.',
    },
    {
        name: 'UnderlyingPaymentScheduleReceiveSide',
        abbrName: 'RcvSide',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentPaySideCodeSet',
        id: 40670,
        description: 'The side of the party receiving the step schedule.',
    },
    {
        name: 'UnderlyingPaymentScheduleNotional',
        abbrName: 'Notl',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 40671,
        description: 'The notional value for this step, or amount of a cashflow payment.',
    },
    {
        name: 'UnderlyingPaymentScheduleCurrency',
        abbrName: 'Ccy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 40672,
        description: 'The currency for this step. Uses ISO 4217 currency codes.',
    },
    {
        name: 'UnderlyingPaymentScheduleRate',
        abbrName: 'Rt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40673,
        discriminatorId: '40705',
        description: 'The rate value for this step.',
    },
    {
        name: 'UnderlyingPaymentScheduleRateMultiplier',
        abbrName: 'RtMult',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 40674,
        description:
            'A rate multiplier to apply to the floating rate. The multiplier can be less than or greater than 1 (one). This element should only be included if the multiplier is not equal to 1 (one) for the term of the stream.',
    },
    {
        name: 'UnderlyingPaymentScheduleRateSpread',
        abbrName: 'Spread',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 40675,
        description: 'The spread value for this step.',
    },
    {
        name: 'UnderlyingPaymentScheduleRateSpreadPositionType',
        abbrName: 'SpreadPosTyp',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
        id: 40676,
        description: 'Identifies whether the rate spread is applied to a long or short position.',
    },
    {
        name: 'UnderlyingPaymentScheduleRateTreatment',
        abbrName: 'RtTrtmt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateTreatmentCodeSet',
        id: 40677,
        description: 'Specifies the yield calculation treatment for the step schedule.',
    },
    {
        name: 'UnderlyingPaymentScheduleFixedAmount',
        abbrName: 'FixedAmt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 40678,
        description: 'The explicit payment amount for this step.',
    },
    {
        name: 'UnderlyingPaymentScheduleFixedCurrency',
        abbrName: 'FixedCcy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 40679,
        description: 'The currency of the fixed amount. Uses ISO 4217 currency codes.',
    },
    {
        name: 'UnderlyingPaymentScheduleStepFrequencyPeriod',
        abbrName: 'StepPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40680,
        description: 'Time unit multiplier for the step frequency.',
    },
    {
        name: 'UnderlyingPaymentScheduleStepFrequencyUnit',
        abbrName: 'StepUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'CouponFrequencyUnitCodeSet',
        id: 40681,
        description: 'Time unit associated with the step frequency.',
    },
    {
        name: 'UnderlyingPaymentScheduleStepOffsetValue',
        abbrName: 'StepVal',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 40682,
        description:
            'The explicit amount that the notional changes on each step date. This can be a positive or negative amount.',
    },
    {
        name: 'UnderlyingPaymentScheduleStepRate',
        abbrName: 'StepRt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40683,
        description:
            'The percentage by which the notional changes on each step date. The percentage is either a percentage applied to the initial notional amount or the previous outstanding notional, depending on the value specified in UnderlyingPaymentScheduleStepRelativeTo(40685). The percentage can be either positive or negative.',
    },
    {
        name: 'UnderlyingPaymentScheduleStepOffsetRate',
        abbrName: 'StepOfstRt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40684,
        description:
            'The explicit amount that the rate changes on each step date. This can be a positive or negative value.',
    },
    {
        name: 'UnderlyingPaymentScheduleStepRelativeTo',
        abbrName: 'StepReltv',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentScheduleStepRelativeToCodeSet',
        id: 40685,
        description:
            'Specifies whether the UnderlyingPaymentScheduleStepRate(40683) or UnderlyingPaymentScheduleStepOffsetValue(40682) should be applied to the initial notional or the previous notional in order to calculate the notional step change amount.',
    },
    {
        name: 'UnderlyingPaymentScheduleFixingDateUnadjusted',
        abbrName: 'FixngDtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40686,
        description: 'The unadjusted fixing date.',
    },
    {
        name: 'UnderlyingPaymentScheduleWeight',
        abbrName: 'Wt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 40687,
        description: 'Floating rate observation weight for cashflow payment.',
    },
    {
        name: 'UnderlyingPaymentScheduleFixingDateRelativeTo',
        abbrName: 'FixngReltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40688,
        description:
            'Specifies the anchor date when the fixing date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'UnderlyingPaymentScheduleFixingDateBusinessDayCnvtn',
        abbrName: 'FixngBizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40689,
        description:
            "The business day convention used to adjust the payment schedule's fixing date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.",
    },
    {
        name: 'UnderlyingPaymentScheduleFixingDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40690,
        description:
            'The business center calendar used to adjust the payment schedule\'s fixing date, e.g. "GBLO". See http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'UnderlyingPaymentScheduleFixingDateOffsetPeriod',
        abbrName: 'FixngPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 40691,
        description: 'Time unit multiplier for the relative fixing date offset.',
    },
    {
        name: 'UnderlyingPaymentScheduleFixingDateOffsetUnit',
        abbrName: 'FixngUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 40692,
        description: 'Time unit associated with the relative fixing date offset.',
    },
    {
        name: 'UnderlyingPaymentScheduleFixingDateOffsetDayType',
        abbrName: 'FixngDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40693,
        description: 'Specifies the day type of the relative fixing date offset.',
    },
    {
        name: 'UnderlyingPaymentScheduleFixingDateAdjusted',
        abbrName: 'FixngDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40694,
        description: 'The adjusted fixing date.',
    },
    {
        name: 'UnderlyingPaymentScheduleFixingTime',
        abbrName: 'FixngTm',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 40695,
        description: 'The fixing time.',
    },
    {
        name: 'UnderlyingPaymentScheduleFixingTimeBusinessCenter',
        abbrName: 'FixngTmBizCtr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40696,
        description:
            'Business center for determining fixing time. See http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'UnderlyingPaymentScheduleInterimExchangePaymentDateRelativeTo',
        abbrName: 'IntrmExchDtReltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40697,
        description:
            'Specifies the anchor date when the interim exchange payment date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'UnderlyingPaymentScheduleInterimExchangeDatesBizDayConvention',
        abbrName: 'IntrmExchDtBizDayCnvtn',
        updated: 'FIX.Latest',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        updatedEP: '271',
        id: 40698,
        description:
            "The business day convention used to adjust the payment schedule's interim exchange date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.",
    },
    {
        name: 'UnderlyingPaymentScheduleInterimExchangeDatesBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40699,
        description:
            'The business center calendar used to adjust the payment schedule\'s interim exchange date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'UnderlyingPaymentScheduleInterimExchangeDatesOffsetPeriod',
        abbrName: 'IntrmExchDtPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 40700,
        description: 'Time unit multiplier for the relative interim exchange date offset.',
    },
    {
        name: 'UnderlyingPaymentScheduleInterimExchangeDatesOffsetUnit',
        abbrName: 'IntrmExchDtUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 40701,
        description: 'Time unit associated with the relative interim exchange date offset.',
    },
    {
        name: 'UnderlyingPaymentScheduleInterimExchangeDatesOffsetDayType',
        abbrName: 'IntrmExchDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40702,
        description: 'Specifies the day type of the relative interim exchange date offset.',
    },
    {
        name: 'UnderlyingPaymentScheduleInterimExchangeDateAdjusted',
        abbrName: 'IntrmExchDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40703,
        description: 'The adjusted interim exchange date.',
    },
    {
        name: 'NoUnderlyingPaymentScheduleRateSources',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40704,
        description: 'Number of rate sources in the repeating group',
    },
    {
        name: 'UnderlyingPaymentScheduleRateSource',
        abbrName: 'Src',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'RateSourceCodeSet',
        id: 40705,
        description: 'Identifies the source of rate information.',
    },
    {
        name: 'UnderlyingPaymentScheduleRateSourceType',
        abbrName: 'Typ',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'RateSourceTypeCodeSet',
        id: 40706,
        description: 'Rate source type.',
    },
    {
        name: 'UnderlyingPaymentScheduleReferencePage',
        abbrName: 'RefPg',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40707,
        description:
            'Identifies the reference “page” from the rate source.\n\nFor FX, the reference page to the spot rate to be used for the reference FX spot rate.\n\nWhen RateSource(1446) = 3 (ISDA Settlement Rate Option) this contains the value from the scheme that reflects the terms of the Annex A to the ISDA 1998 FX and Currency Option Definitions. See: http://www.fpml.org/coding-scheme/settlement-rate-option',
    },
    {
        name: 'NoUnderlyingPaymentStubs',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40708,
        description: 'Number of stubs in the repeating group',
    },
    {
        name: 'UnderlyingPaymentStubType',
        abbrName: 'Typ',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStubTypeCodeSet',
        id: 40709,
        description: 'Stub type.',
    },
    {
        name: 'UnderlyingPaymentStubLength',
        abbrName: 'Lngth',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStubLengthCodeSet',
        id: 40710,
        description: 'Optional indication whether stub is shorter or longer than the regular swap period.',
    },
    {
        name: 'UnderlyingPaymentStubRate',
        abbrName: 'Rt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40711,
        description: 'The agreed upon fixed rate for this stub.',
    },
    {
        name: 'UnderlyingPaymentStubFixedAmount',
        abbrName: 'FixedAmt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 40712,
        description: 'A fixed payment amount for the stub.',
    },
    {
        name: 'UnderlyingPaymentStubFixedCurrency',
        abbrName: 'FixedCcy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 40713,
        description: 'The currency of the fixed payment amount. Uses ISO 4217 currency codes.',
    },
    {
        name: 'UnderlyingPaymentStubIndex',
        abbrName: 'Ndx',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40714,
        discriminatorId: '40715',
        description: 'The stub floating rate index.',
    },
    {
        name: 'UnderlyingPaymentStubIndexSource',
        abbrName: 'NdxSrc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexSourceCodeSet',
        id: 40715,
        description: 'The source for the underlying payment stub floating rate index.',
    },
    {
        name: 'UnderlyingPaymentStubIndexCurvePeriod',
        abbrName: 'NdxPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40716,
        description: 'Time unit multiplier for the underlying payment stub floating rate index.',
    },
    {
        name: 'UnderlyingPaymentStubIndexCurveUnit',
        abbrName: 'NdxUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexCurveUnitCodeSet',
        id: 40717,
        description: 'Time unit associated with the underlying payment stub floating rate index.',
    },
    {
        name: 'UnderlyingPaymentStubIndexRateMultiplier',
        abbrName: 'RtMult',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 40718,
        description:
            'A rate multiplier to apply to the floating rate. The multiplier can be less than or greater than 1 (one). This element should only be included if the multiplier is not equal to 1 (one) for the term of the stream.',
    },
    {
        name: 'UnderlyingPaymentStubIndexRateSpread',
        abbrName: 'Spread',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 40719,
        description: 'Spread from floating rate index.',
    },
    {
        name: 'UnderlyingPaymentStubIndexRateSpreadPositionType',
        abbrName: 'SpreadPosTyp',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
        id: 40720,
        description: 'Identifies whether the rate spread is applied to a long or short position.',
    },
    {
        name: 'UnderlyingPaymentStubIndexRateTreatment',
        abbrName: 'RtTrtmt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateTreatmentCodeSet',
        id: 40721,
        description: 'Specifies the yield calculation treatment for the stub index.',
    },
    {
        name: 'UnderlyingPaymentStubIndexCapRate',
        abbrName: 'CapRt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40722,
        description:
            'The cap rate, if any, which applies to the floating rate. The cap rate (strike) is only required where the floating rate on a swap stream is capped at a certain level. The cap rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A cap rate of 5% would be represented as 0.05.',
    },
    {
        name: 'UnderlyingPaymentStubIndexCapRateBuySide',
        abbrName: 'CapRtBuy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamCapRateBuySideCodeSet',
        id: 40723,
        description: 'Reference to the buyer of the cap rate option through its trade side.',
    },
    {
        name: 'UnderlyingPaymentStubIndexCapRateSellSide',
        abbrName: 'CapRtSell',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamCapRateBuySideCodeSet',
        id: 40724,
        description: 'Reference to the seller of the cap rate option through its trade side.',
    },
    {
        name: 'UnderlyingPaymentStubIndexFloorRate',
        abbrName: 'FlrRt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40725,
        description:
            'The floor rate, if any, which applies to the floating rate. The floor rate (strike) is only required where the floating rate on a swap stream is floored at a certain strike level. The floor rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A floor rate of 5% would be represented as 0.05.',
    },
    {
        name: 'UnderlyingPaymentStubIndexFloorRateBuySide',
        abbrName: 'FlrRtBuy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamFloorRateBuySideCodeSet',
        id: 40726,
        description: 'Reference to the buyer of the floor rate option through its trade side.',
    },
    {
        name: 'UnderlyingPaymentStubIndexFloorRateSellSide',
        abbrName: 'FlrRtSell',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamFloorRateBuySideCodeSet',
        id: 40727,
        description: 'Reference to the seller of the floor rate option through its trade side.',
    },
    {
        name: 'UnderlyingPaymentStubIndex2',
        abbrName: 'Ndx2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40728,
        discriminatorId: '40729',
        description: 'The second stub floating rate index.',
    },
    {
        name: 'UnderlyingPaymentStubIndex2Source',
        abbrName: 'Ndx2Src',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexSourceCodeSet',
        id: 40729,
        description: 'The source of the second stub floating rate index.',
    },
    {
        name: 'UnderlyingPaymentStubIndex2CurvePeriod',
        abbrName: 'Ndx2Period',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40730,
        description: 'Secondary time unit multiplier for the stub floating rate index curve.',
    },
    {
        name: 'UnderlyingPaymentStubIndex2CurveUnit',
        abbrName: 'Ndx2Unit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexCurveUnitCodeSet',
        id: 40731,
        description: 'Secondary time unit associated with the stub floating rate index curve.',
    },
    {
        name: 'UnderlyingPaymentStubIndex2RateMultiplier',
        abbrName: 'RtMult2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 40732,
        description:
            'A rate multiplier to apply to the second floating rate. The multiplier can be less than or greater than 1 (one). This element should only be included if the multiplier is not equal to 1 (one) for the term of the stream.',
    },
    {
        name: 'UnderlyingPaymentStubIndex2RateSpread',
        abbrName: 'Spread2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 40733,
        description: 'Spread from the second floating rate index.',
    },
    {
        name: 'UnderlyingPaymentStubIndex2RateSpreadPositionType',
        abbrName: 'Spread2PosTyp',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
        id: 40734,
        description: 'Identifies whether the rate spread is applied to a long or short position.',
    },
    {
        name: 'UnderlyingPaymentStubIndex2RateTreatment',
        abbrName: 'RtTrtmt2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateTreatmentCodeSet',
        id: 40735,
        description: 'Specifies the yield calculation treatment for the second stub index.',
    },
    {
        name: 'UnderlyingPaymentStubIndex2CapRate',
        abbrName: 'CapRt2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40736,
        description:
            'The cap rate, if any, which applies to the second floating rate. The cap rate (strike) is only required where the floating rate on a swap stream is capped at a certain level. The cap rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A cap rate of 5% would be represented as 0.05.',
    },
    {
        name: 'UnderlyingPaymentStubIndex2FloorRate',
        abbrName: 'FlrRt2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40737,
        description:
            'The floor rate, if any, which applies to the second floating rate. The floor rate (strike) is only required where the floating rate on a swap stream is floored at a certain strike level. The floor rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A floor rate of 5% would be represented as 0.05.',
    },
    {
        name: 'PaymentStreamType',
        abbrName: 'Typ',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamTypeCodeSet',
        id: 40738,
        description: 'Identifies the type of payment stream associated with the swap.',
    },
    {
        name: 'PaymentStreamMarketRate',
        abbrName: 'MktRt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40739,
        description:
            'Used only for credit index trade. This contains the credit spread ("fair value") at which the trade was executed. The market rate varies over the life of the index depending on market conditions. This is the price of the index as quoted by trading desks.',
    },
    {
        name: 'PaymentStreamDelayIndicator',
        abbrName: 'DelayInd',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 40740,
        description:
            'Applicable to credit default swaps on mortgage backed securities to specify whether payment delays are applicable to the fixed amount.\n\nResidential mortgage backed securities typically have a payment delay of 5 days between the coupon date of the reference obligation and the payment date of the synthetic swap.\n\nCommercial mortgage backed securities do not typically have a payment delay, with both payment dates (the coupon date of the reference obligation and the payment date of the synthetic swap) being on the 25th of each month.',
    },
    {
        name: 'PaymentStreamSettlCurrency',
        abbrName: 'SettlCcy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 40741,
        description:
            'Specifies the currency that the stream settles in (to support swaps that settle in a currency different from the notional currency). Uses ISO 4217 currency codes.',
    },
    {
        name: 'PaymentStreamDayCount',
        abbrName: 'DayCnt',
        unionDataType: 'Reserved100Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'CouponDayCountCodeSet',
        id: 40742,
        description: 'The day count convention used in the payment stream calculations.',
    },
    {
        name: 'PaymentStreamAccrualDays',
        abbrName: 'AcrlDays',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40743,
        description:
            'The number of days from the adjusted calculation period start date to the adjusted value date, calculated in accordance with the applicable day count fraction.',
    },
    {
        name: 'PaymentStreamDiscountType',
        abbrName: 'DiscTyp',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamDiscountTypeCodeSet',
        id: 40744,
        description: 'The method of calculating discounted payment amounts',
    },
    {
        name: 'PaymentStreamDiscountRate',
        abbrName: 'Disc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40745,
        description: 'Discount rate. The rate is expressed in decimal, e.g. 5% is expressed as 0.05.',
    },
    {
        name: 'PaymentStreamDiscountRateDayCount',
        abbrName: 'DiscDayCnt',
        unionDataType: 'Reserved100Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'CouponDayCountCodeSet',
        id: 40746,
        description: 'The day count convention applied to the PaymentStreamDiscountRate(40745).',
    },
    {
        name: 'PaymentStreamCompoundingMethod',
        abbrName: 'CmpndgMeth',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamCompoundingMethodCodeSet',
        id: 40747,
        description: 'Compounding method.',
    },
    {
        name: 'PaymentStreamInitialPrincipalExchangeIndicator',
        abbrName: 'InitPrncplExchInd',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 40748,
        description: 'Indicates whether there is an initial exchange of principal on the effective date.',
    },
    {
        name: 'PaymentStreamInterimPrincipalExchangeIndicator',
        abbrName: 'IntrmPrncplExchInd',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 40749,
        description:
            'Indicates whether there are intermediate or interim exchanges of principal during the term of the swap.',
    },
    {
        name: 'PaymentStreamFinalPrincipalExchangeIndicator',
        abbrName: 'FnlPrncplExchInd',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 40750,
        description: 'Indicates whether there is a final exchange of principal on the termination date.',
    },
    {
        name: 'PaymentStreamPaymentDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40751,
        description:
            "The business day convention used to adjust the payment stream's payment date. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.",
    },
    {
        name: 'PaymentStreamPaymentDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40752,
        description:
            'The business center calendar used to adjust the payment stream\'s payment date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'PaymentStreamPaymentFrequencyPeriod',
        abbrName: 'FreqPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40753,
        description: 'Time unit multiplier for the frequency of payments.',
    },
    {
        name: 'PaymentStreamPaymentFrequencyUnit',
        abbrName: 'FreqUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentFrequencyUnitCodeSet',
        id: 40754,
        description: 'Time unit associated with the frequency of payments.',
    },
    {
        name: 'PaymentStreamPaymentRollConvention',
        abbrName: 'Roll',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'DateRollConventionCodeSet',
        id: 40755,
        description:
            'The convention for determining the sequence of end dates. It is used in conjunction with a specified frequency. Used only to override the roll convention specified in the DateAdjustment component within the Instrument component.',
    },
    {
        name: 'PaymentStreamFirstPaymentDateUnadjusted',
        abbrName: 'FirstDtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40756,
        description: 'The unadjusted first payment date.',
    },
    {
        name: 'PaymentStreamLastRegularPaymentDateUnadjusted',
        abbrName: 'LastReglrDtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40757,
        description: 'The unadjusted last regular payment date.',
    },
    {
        name: 'PaymentStreamPaymentDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40758,
        description:
            'Specifies the anchor date when payment dates are relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'PaymentStreamPaymentDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 40759,
        description: 'Time unit multiplier for the relative payment date offset.',
    },
    {
        name: 'PaymentStreamPaymentDateOffsetUnit',
        abbrName: 'OfstUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 40760,
        description: 'Time unit multiplier for the relative initial fixing date offset.',
    },
    {
        name: 'PaymentStreamResetDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40761,
        description:
            'Specifies the anchor date when the reset dates are relative to an anchor date.\n\nIf the reset frequency is specified as daily this element must not be included.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'PaymentStreamResetDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40762,
        description:
            "The business day convention used to adjust the payment stream's reset date. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.",
    },
    {
        name: 'PaymentStreamResetDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40763,
        description:
            'The business center calendar used to adjust the payment stream\'s reset date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'PaymentStreamResetFrequencyPeriod',
        abbrName: 'FreqPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40764,
        description: 'Time unit multiplier for the frequency of resets.',
    },
    {
        name: 'PaymentStreamResetFrequencyUnit',
        abbrName: 'FreqUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'CouponFrequencyUnitCodeSet',
        id: 40765,
        description: 'Time unit associated with the frequency of resets.',
    },
    {
        name: 'PaymentStreamResetWeeklyRollConvention',
        abbrName: 'WklyRoll',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamResetWeeklyRollConventionCodeSet',
        id: 40766,
        description:
            'Used to specify the day of the week in which the reset occurs for payments that reset on a weekly basis.',
    },
    {
        name: 'PaymentStreamInitialFixingDateRelativeTo',
        abbrName: 'InitReltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40767,
        description:
            'Specifies the anchor date when the initial fixing date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'PaymentStreamInitialFixingDateBusinessDayConvention',
        abbrName: 'InitBizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40768,
        description:
            "The business day convention used to adjust the payment stream's initial fixing date. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.",
    },
    {
        name: 'PaymentStreamInitialFixingDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40769,
        description:
            'The business center calendar used to adjust the payment stream\'s initial fixing date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'PaymentStreamInitialFixingDateOffsetPeriod',
        abbrName: 'InitPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 40770,
        description: 'Time unit multiplier for the relative initial fixing date offset.',
    },
    {
        name: 'PaymentStreamInitialFixingDateOffsetUnit',
        abbrName: 'InitUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 40771,
        description: 'Time unit associated with the relative initial fixing date offset.',
    },
    {
        name: 'PaymentStreamInitialFixingDateOffsetDayType',
        abbrName: 'InitDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40772,
        description: 'Specifies the day type of the relative initial fixing date offset.',
    },
    {
        name: 'PaymentStreamInitialFixingDateAdjusted',
        abbrName: 'InitDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40773,
        description: 'The adjusted initial fixing date.',
    },
    {
        name: 'PaymentStreamFixingDateRelativeTo',
        abbrName: 'FixngReltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40774,
        description:
            'Specifies the anchor date when the fixing date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'PaymentStreamFixingDateBusinessDayConvention',
        abbrName: 'FixngBizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40775,
        description:
            "The business day convention used to adjust the payment stream's fixing date. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.",
    },
    {
        name: 'PaymentStreamFixingDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40776,
        description:
            'The business center calendar used to adjust the payment stream\'s fixing date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'PaymentStreamFixingDateOffsetPeriod',
        abbrName: 'FixngPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 40777,
        description: 'Time unit multiplier for the relative fixing date offset.',
    },
    {
        name: 'PaymentStreamFixingDateOffsetUnit',
        abbrName: 'FixngUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 40778,
        description: 'Time unit associated with the relative fixing date offset.',
    },
    {
        name: 'PaymentStreamFixingDateOffsetDayType',
        abbrName: 'FixngDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40779,
        description: 'Specifies the day type of the relative fixing date offset.',
    },
    {
        name: 'PaymentStreamFixingDateAdjusted',
        abbrName: 'FixngDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40780,
        description: 'The adjusted fixing date.',
    },
    {
        name: 'PaymentStreamRateCutoffDateOffsetPeriod',
        abbrName: 'CutoffPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 40781,
        description: 'Time unit multiplier for the relative rate cut-off date offset.',
    },
    {
        name: 'PaymentStreamRateCutoffDateOffsetUnit',
        abbrName: 'CutoffUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 40782,
        description: 'Time unit associated with the relative rate cut-off date offset.',
    },
    {
        name: 'PaymentStreamRateCutoffDateOffsetDayType',
        abbrName: 'CutoffDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40783,
        description: 'Specifies the day type of the relative rate cut-off date offset.',
    },
    {
        name: 'PaymentStreamRate',
        abbrName: 'Rt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40784,
        description: 'The rate applicable to the fixed rate payment stream.',
    },
    {
        name: 'PaymentStreamFixedAmount',
        abbrName: 'Amt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 40785,
        description: "The payment stream's fixed payment amount. In CDS an alternative to PaymentStreamRate(40784).",
    },
    {
        name: 'PaymentStreamRateOrAmountCurrency',
        abbrName: 'Ccy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 40786,
        description:
            'Specifies the currency in which PaymentStreamFixedAmount(40785) or PaymentStreamRate(40784) is denominated. Uses ISO 4271 currency codes.',
    },
    {
        name: 'PaymentStreamFutureValueNotional',
        abbrName: 'FutValNotl',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 40787,
        description:
            'The future value notional is normally only required for certain non-deliverable interest rate swaps (e.g. Brazillian Real (BRL) vs. CETIP Interbank Deposit Rate (CDI)). The value is calculated as follows: Future Value Notional = Notional Amount * (1 + Fixed Rate) ^ (Fixed Rate Day Count Fraction). The currency is the same as the stream notional.',
    },
    {
        name: 'PaymentStreamFutureValueDateAdjusted',
        abbrName: 'FutValDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40788,
        description: 'The adjusted value date of the future value amount.',
    },
    {
        name: 'PaymentStreamRateIndex',
        abbrName: 'Ndx',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40789,
        discriminatorId: '40790',
        description: 'The payment stream floating rate index.',
    },
    {
        name: 'PaymentStreamRateIndexSource',
        abbrName: 'NdxSrc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexSourceCodeSet',
        id: 40790,
        description: 'The source of the payment stream floating rate index.',
    },
    {
        name: 'PaymentStreamRateIndexCurveUnit',
        abbrName: 'NdxUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexCurveUnitCodeSet',
        id: 40791,
        description: 'Time unit associated with the floating rate index.',
    },
    {
        name: 'PaymentStreamRateIndexCurvePeriod',
        abbrName: 'NdxPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40792,
        description: 'Time unit multiplier for the floating rate index.',
    },
    {
        name: 'PaymentStreamRateMultiplier',
        abbrName: 'RtMult',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 40793,
        description:
            'A rate multiplier to apply to the floating rate. A multiplier schedule is expressed as explicit multipliers and dates. In the case of a schedule, the step dates may be subject to adjustment in accordance with any adjustments specified in the calculationPeriodDatesAdjustments. The multiplier can be less than or greater than 1 (one). This element should only be included if the multiplier is not equal to 1 (one) for the term of the stream.',
    },
    {
        name: 'PaymentStreamRateSpread',
        abbrName: 'Spread',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 40794,
        description: 'Spread from floating rate index.',
    },
    {
        name: 'PaymentStreamRateSpreadPositionType',
        abbrName: 'SpreadPosTyp',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
        id: 40795,
        description: 'Identifies whether the rate spread is applied to a long or short position.',
    },
    {
        name: 'PaymentStreamRateTreatment',
        abbrName: 'RtTrtmt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateTreatmentCodeSet',
        id: 40796,
        description: 'Specifies the yield calculation treatment for the index.',
    },
    {
        name: 'PaymentStreamCapRate',
        abbrName: 'CapRt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40797,
        description:
            'The cap rate, if any, which applies to the floating rate. The cap rate (strike) is only required where the floating rate on a swap stream is capped at a certain level. The cap rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A cap rate of 5% would be represented as 0.05.',
    },
    {
        name: 'PaymentStreamCapRateBuySide',
        abbrName: 'CapRtBuy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamCapRateBuySideCodeSet',
        id: 40798,
        description: 'Reference to the buyer of the cap rate option through its trade side.',
    },
    {
        name: 'PaymentStreamCapRateSellSide',
        abbrName: 'CapRtSell',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamCapRateBuySideCodeSet',
        id: 40799,
        description: 'Reference to the seller of the cap rate option through its trade side.',
    },
    {
        name: 'PaymentStreamFloorRate',
        abbrName: 'FlrRt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40800,
        description:
            'The floor rate, if any, which applies to the floating rate. The floor rate (strike) is only required where the floating rate on a swap stream is floored at a certain strike level. The floor rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A floor rate of 5% would be represented as 0.05.',
    },
    {
        name: 'PaymentStreamFloorRateBuySide',
        abbrName: 'FlrRtBuy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamFloorRateBuySideCodeSet',
        id: 40801,
        description: 'Reference to the buyer of the floor rate option through its trade side.',
    },
    {
        name: 'PaymentStreamFloorRateSellSide',
        abbrName: 'FlrRtSell',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamFloorRateBuySideCodeSet',
        id: 40802,
        description: 'Reference to the seller of the floor rate option through its trade side.',
    },
    {
        name: 'PaymentStreamInitialRate',
        abbrName: 'InitRt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40803,
        description:
            'The initial floating rate reset agreed between the principal parties involved in the trade. This is assumed to be the first required reset rate for the first regular calculation period. It should only be included when the rate is not equal to the rate published on the source implied by the floating rate index. An initial rate of 5% would be represented as 0.05.',
    },
    {
        name: 'PaymentStreamFinalRateRoundingDirection',
        abbrName: 'FnlRtRndDirctn',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'RoundingDirectionCodeSet',
        updatedEP: '208',
        id: 40804,
        description: 'Specifies the rounding direction.',
    },
    {
        name: 'PaymentStreamFinalRatePrecision',
        abbrName: 'FnlRtPrcsn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40805,
        description:
            'Specifies the rounding precision in terms of a number of decimal places. Note how a percentage rate rounding of 5 decimal places is expressed as a rounding precision of 7.',
    },
    {
        name: 'PaymentStreamAveragingMethod',
        abbrName: 'AvgngMeth',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamAveragingMethodCodeSet',
        id: 40806,
        description:
            'When rate averaging is applicable, used to specify whether a weighted or unweighted average calculation method is to be used.',
    },
    {
        name: 'PaymentStreamNegativeRateTreatment',
        abbrName: 'NegtvRtTrtmt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamNegativeRateTreatmentCodeSet',
        id: 40807,
        description:
            'The specification of any provisions for calculating payment obligations when a floating rate is negative (either due to a quoted negative floating rate or by operation of a spread that is subtracted from the floating rate).',
    },
    {
        name: 'PaymentStreamInflationLagPeriod',
        abbrName: 'LagPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40808,
        description:
            'Time unit multiplier for the inflation lag period. The lag period is the offsetting period from the payment date which determines the reference period for which the inflation index is observed.',
    },
    {
        name: 'PaymentStreamInflationLagUnit',
        abbrName: 'LagUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamInflationLagUnitCodeSet',
        id: 40809,
        description: 'Time unit associated with the inflation lag period.',
    },
    {
        name: 'PaymentStreamInflationLagDayType',
        abbrName: 'LagDayTyp',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamInflationLagDayTypeCodeSet',
        id: 40810,
        description: 'The inflation lag period day type.',
    },
    {
        name: 'PaymentStreamInflationInterpolationMethod',
        abbrName: 'IntrpltnMeth',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamInflationInterpolationMethodCodeSet',
        id: 40811,
        description:
            'The method used when calculating the Inflation Index Level from multiple points - the most common is Linear.',
    },
    {
        name: 'PaymentStreamInflationIndexSource',
        abbrName: 'InfltnNdxSrc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexSourceCodeSet',
        id: 40812,
        description: 'The inflation index reference source.',
    },
    {
        name: 'PaymentStreamInflationPublicationSource',
        abbrName: 'PublctnSrc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40813,
        description: 'The current main publication source such as relevant web site or a government body.',
    },
    {
        name: 'PaymentStreamInflationInitialIndexLevel',
        abbrName: 'InitLvl',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 40814,
        description: 'Initial known index level for the first calculation period.',
    },
    {
        name: 'PaymentStreamInflationFallbackBondApplicable',
        abbrName: 'FallbckBond',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 40815,
        description:
            'Indicates whether a fallback bond as defined in the 2006 ISDA Inflation Derivatives Definitions, sections 1.3 and 1.8, is applicable or not. If not specified, the default value is "Y" (True/Yes).',
    },
    {
        name: 'PaymentStreamFRADiscounting',
        abbrName: 'FRADisc',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamFRADiscountingCodeSet',
        updatedEP: '169',
        id: 40816,
        description: 'The method of Forward Rate Agreement (FRA) discounting, if any, that will apply.',
    },
    {
        name: 'PaymentStreamNonDeliverableRefCurrency',
        abbrName: 'Ccy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 40817,
        description: 'The non-deliverable settlement reference currency. Uses ISO 4217 currency codes.',
    },
    {
        name: 'PaymentStreamNonDeliverableFixingDatesBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40818,
        description:
            "The business day convention used to adjust the payment stream's fixing date for the non-deliverable settlement terms. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component",
    },
    {
        name: 'PaymentStreamNonDeliverableFixingDatesBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40819,
        description:
            'The business center calendar used to adjust the payment stream\'s fixing date for the non-deliverable terms, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'PaymentStreamNonDeliverableFixingDatesRelativeTo',
        abbrName: 'FixngReltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40820,
        description:
            'Specifies the anchor date when the non-deliverable fixing dates are relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'PaymentStreamNonDeliverableFixingDatesOffsetPeriod',
        abbrName: 'FixngPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 40821,
        description: 'Time unit multiplier for the relative non-deliverable fixing date offset.',
    },
    {
        name: 'PaymentStreamNonDeliverableFixingDatesOffsetUnit',
        abbrName: 'FixngUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 40822,
        description: 'Time unit associated with the relative non-deliverable fixing date offset.',
    },
    {
        name: 'PaymentStreamNonDeliverableFixingDatesOffsetDayType',
        abbrName: 'FixngDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40823,
        description: 'Specifies the day type of the relative non-deliverable fixing date offset.',
    },
    {
        name: 'UnderlyingPaymentStreamNonDeliverableSettlReferencePage',
        abbrName: 'RefPg',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40824,
        description:
            'Identifies the reference "page" from the rate source.\n\nWhen UnderlyingPaymentStreamNonDeliverableSettlRateSource(40661) = 3(ISDA Settlement Rate Option) this contains the value from the scheme that reflects the terms of the Annex A to the ISDA 1998 FX and Currency Option Definitions. See: http://www.fpml.org/coding-scheme/settlement-rate-option',
    },
    {
        name: 'NoNonDeliverableFixingDates',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40825,
        description: 'Number of Fixing dates in the repeating group',
    },
    {
        name: 'NonDeliverableFixingDate',
        abbrName: 'Dt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40826,
        description:
            'Non-deliverable fixing date unadjusted or adjusted depending on NonDeliverableFixingDateType(40827).',
    },
    {
        name: 'NonDeliverableFixingDateType',
        abbrName: 'Typ',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NonDeliverableFixingDateTypeCodeSet',
        id: 40827,
        description: 'Specifies the type of date (e.g. adjusted for holidays).',
    },
    {
        name: 'NoPaymentSchedules',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40828,
        description: 'Number of swap schedules in the repeating group',
    },
    {
        name: 'PaymentScheduleType',
        abbrName: 'Typ',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentScheduleTypeCodeSet',
        id: 40829,
        description: 'Type of schedule.',
    },
    {
        name: 'PaymentScheduleStubType',
        abbrName: 'StubTyp',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStubTypeCodeSet',
        id: 40830,
        description: 'Indicates to which stub this schedule applies.',
    },
    {
        name: 'PaymentScheduleStartDateUnadjusted',
        abbrName: 'StartDtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40831,
        description:
            'The date on which the value is adjusted, or calculated if a future value notional for certain non-deliverable interest rate swaps (e.g. Brazillian Real (BRL) vs. CETIP Interbank Deposit Rate (CDI)), or the start date of a cashflow payment.',
    },
    {
        name: 'PaymentScheduleEndDateUnadjusted',
        abbrName: 'EndDtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40832,
        description: 'The unadjusted end date of a cash flow payment.',
    },
    {
        name: 'PaymentSchedulePaySide',
        abbrName: 'PaySide',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentPaySideCodeSet',
        id: 40833,
        description: 'The side of the party paying the step schedule.',
    },
    {
        name: 'PaymentScheduleReceiveSide',
        abbrName: 'RcvSide',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentPaySideCodeSet',
        id: 40834,
        description: 'The side of the party receiving the stepf schedule.',
    },
    {
        name: 'PaymentScheduleNotional',
        abbrName: 'Notl',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 40835,
        description: 'The notional value for this step, or amount of a cashflow payment.',
    },
    {
        name: 'PaymentScheduleCurrency',
        abbrName: 'Ccy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 40836,
        description: 'The currency for this step. Uses ISO 4217 currency codes.',
    },
    {
        name: 'PaymentScheduleRate',
        abbrName: 'Rt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40837,
        discriminatorId: '40869',
        description: 'The rate value for this step schedule.',
    },
    {
        name: 'PaymentScheduleRateMultiplier',
        abbrName: 'RtMult',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 40838,
        description:
            'A rate multiplier to apply to the floating rate. The multiplier can be less than or greater than 1 (one). This element should only be included if the multiplier is not equal to 1 (one) for the term of the stream.',
    },
    {
        name: 'PaymentScheduleRateSpread',
        abbrName: 'Spread',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 40839,
        description: 'The spread value for this step schedule.',
    },
    {
        name: 'PaymentScheduleRateSpreadPositionType',
        abbrName: 'SpreadPosTyp',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
        id: 40840,
        description: 'Identifies whether the rate spread is applied to a long or short position.',
    },
    {
        name: 'PaymentScheduleRateTreatment',
        abbrName: 'RtTrtmt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateTreatmentCodeSet',
        id: 40841,
        description: 'Specifies the yield calculation treatment for the step schedule.',
    },
    {
        name: 'PaymentScheduleFixedAmount',
        abbrName: 'FixedAmt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 40842,
        description: 'The explicit payment amount for this step schedule.',
    },
    {
        name: 'PaymentScheduleFixedCurrency',
        abbrName: 'FixedCcy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 40843,
        description: 'The currency of the fixed amount. Uses ISO 4217 currency codes.',
    },
    {
        name: 'PaymentScheduleStepFrequencyPeriod',
        abbrName: 'StepPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40844,
        description: 'Time unit multiplier for the step frequency.',
    },
    {
        name: 'PaymentScheduleStepFrequencyUnit',
        abbrName: 'StepUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'CouponFrequencyUnitCodeSet',
        id: 40845,
        description: 'Time unit associated with the step frequency.',
    },
    {
        name: 'PaymentScheduleStepOffsetValue',
        abbrName: 'StepVal',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 40846,
        description:
            'The explicit amount that the notional changes on each step date. This can be a positive or negative amount.',
    },
    {
        name: 'PaymentScheduleStepRate',
        abbrName: 'StepRt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40847,
        description:
            'The percentage by which the notional changes on each step date. The percentage is either a percentage applied to the initial notional amount or the previous outstanding notional, depending on the value specified in PaymentScheduleStepRelativeTo(40849). The percentage can be either positive or negative.',
    },
    {
        name: 'PaymentScheduleStepOffsetRate',
        abbrName: 'StepOfstRt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40848,
        description:
            'The explicit amount that the rate changes on each step date. This can be a positive or negative value.',
    },
    {
        name: 'PaymentScheduleStepRelativeTo',
        abbrName: 'StepReltv',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentScheduleStepRelativeToCodeSet',
        id: 40849,
        description:
            'Specifies whether the PaymentScheduleStepRate(40847) or PaymentScheduleStepOffsetValue(40846) should be applied to the initial notional or the previous notional in order to calculate the notional step change amount.',
    },
    {
        name: 'PaymentScheduleFixingDateUnadjusted',
        abbrName: 'FixngDtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40850,
        description: 'The unadjusted fixing date.',
    },
    {
        name: 'PaymentScheduleWeight',
        abbrName: 'Wt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 40851,
        description: 'Floating rate observation weight for cashflow payment.',
    },
    {
        name: 'PaymentScheduleFixingDateRelativeTo',
        abbrName: 'FixngReltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40852,
        description:
            'Specifies the anchor date when the fixing date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'PaymentScheduleFixingDateBusinessDayConvention',
        abbrName: 'FixngBizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40853,
        description:
            "The business day convention used to adjust the payment schedule's fixing date. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.",
    },
    {
        name: 'PaymentScheduleFixingDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40854,
        description:
            'The business center calendar used to adjust the payment schedule\'s fixing date, e.g. "GBLO". See http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'PaymentScheduleFixingDateOffsetPeriod',
        abbrName: 'FixngPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 40855,
        description: 'Time unit multiplier for the relative fixing date offset.',
    },
    {
        name: 'PaymentScheduleFixingDateOffsetUnit',
        abbrName: 'FixngUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 40856,
        description: 'Time unit associated with the relative fixing date offset.',
    },
    {
        name: 'PaymentScheduleFixingDateOffsetDayType',
        abbrName: 'FixngDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40857,
        description: 'Specifies the day type of the relative fixing date offset.',
    },
    {
        name: 'PaymentScheduleFixingDateAdjusted',
        abbrName: 'FixngDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40858,
        description: 'The adjusted fixing date.',
    },
    {
        name: 'PaymentScheduleFixingTime',
        abbrName: 'FixngTm',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 40859,
        description: 'The fixing time associated with the step schedule.',
    },
    {
        name: 'PaymentScheduleFixingTimeBusinessCenter',
        abbrName: 'FixngTmBizCtr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40860,
        description:
            'Business center for determining fixing time.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'PaymentScheduleInterimExchangePaymentDateRelativeTo',
        abbrName: 'IntrmExchDtReltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40861,
        description:
            'Specifies the anchor date when the interim exchange payment date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'PaymentScheduleInterimExchangeDatesBusinessDayConvention',
        abbrName: 'IntrmExchDtBizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40862,
        description:
            "The business day convention used to adjust the payment schedule's interim exchange date. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.",
    },
    {
        name: 'PaymentScheduleInterimExchangeDatesBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40863,
        description:
            'The business center calendar used to adjust the payment schedule\'s interim exchange date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'PaymentScheduleInterimExchangeDatesOffsetPeriod',
        abbrName: 'IntrmExchDtPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 40864,
        description: 'Time unit multiplier for the relative interim exchange date offset.',
    },
    {
        name: 'PaymentScheduleInterimExchangeDatesOffsetUnit',
        abbrName: 'IntrmExchDtUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 40865,
        description: 'Time unit associated with the relative interim exchange date offset.',
    },
    {
        name: 'PaymentScheduleInterimExchangeDatesOffsetDayType',
        abbrName: 'IntrmExchDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40866,
        description: 'Specifies the day type of the relative interim exchange date offset.',
    },
    {
        name: 'PaymentScheduleInterimExchangeDateAdjusted',
        abbrName: 'IntrmExchDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40867,
        description: 'The adjusted interim exchange date.',
    },
    {
        name: 'NoPaymentScheduleRateSources',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40868,
        description: 'Number of swap schedule rate sources.',
    },
    {
        name: 'PaymentScheduleRateSource',
        abbrName: 'Src',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'RateSourceCodeSet',
        id: 40869,
        description: 'Identifies the source of rate information.',
    },
    {
        name: 'PaymentScheduleRateSourceType',
        abbrName: 'Typ',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'RateSourceTypeCodeSet',
        id: 40870,
        description: 'Rate source type.',
    },
    {
        name: 'PaymentScheduleReferencePage',
        abbrName: 'RefPg',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40871,
        description:
            'Identifies the reference “page” from the rate source.\n\nFor FX, the reference page to the spot rate to be used for the reference FX spot rate.\n\nWhen RateSource(1446) = 3 (ISDA Settlement Rate Option) this contains the value from the scheme that reflects the terms of the Annex A to the ISDA 1998 FX and Currency Option Definitions. See: http://www.fpml.org/coding-scheme/settlement-rate-option',
    },
    {
        name: 'NoPaymentStubs',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40872,
        description: 'Number of stubs in the repeating group',
    },
    {
        name: 'PaymentStubType',
        abbrName: 'Typ',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStubTypeCodeSet',
        id: 40873,
        description: 'Stub type.',
    },
    {
        name: 'PaymentStubLength',
        abbrName: 'Lngth',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStubLengthCodeSet',
        id: 40874,
        description: 'Optional indication whether stub is shorter or longer than the regular swap period.',
    },
    {
        name: 'PaymentStubRate',
        abbrName: 'Rt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40875,
        description: 'The agreed upon fixed rate for this stub.',
    },
    {
        name: 'PaymentStubFixedAmount',
        abbrName: 'FixedAmt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 40876,
        description: 'A fixed payment amount for the stub.',
    },
    {
        name: 'PaymentStubFixedCurrency',
        abbrName: 'FixedCcy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 40877,
        description: 'The currency of the fixed payment amount. Uses ISO 4217 currency codes.',
    },
    {
        name: 'PaymentStubIndex',
        abbrName: 'Ndx',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40878,
        discriminatorId: '40879',
        description: 'The stub floating rate index.',
    },
    {
        name: 'PaymentStubIndexSource',
        abbrName: 'NdxSrc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexSourceCodeSet',
        id: 40879,
        description: 'The source of the stub floating rate index.',
    },
    {
        name: 'PaymentStubIndexCurvePeriod',
        abbrName: 'NdxPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40880,
        description: 'Time unit multiplier for the stub floating rate index.',
    },
    {
        name: 'PaymentStubIndexCurveUnit',
        abbrName: 'NdxUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexCurveUnitCodeSet',
        id: 40881,
        description: 'Time unit associated with the stub floating rate index.',
    },
    {
        name: 'PaymentStubIndexRateMultiplier',
        abbrName: 'RtMult',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 40882,
        description:
            'A rate multiplier to apply to the floating rate. The multiplier can be less than or greater than 1 (one). This element should only be included if the multiplier is not equal to 1 (one) for the term of the stream.',
    },
    {
        name: 'PaymentStubIndexRateSpread',
        abbrName: 'Spread',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 40883,
        description: 'Spread from floating rate index.',
    },
    {
        name: 'PaymentStubIndexRateSpreadPositionType',
        abbrName: 'SpreadPosTyp',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
        id: 40884,
        description: 'Identifies whether the rate spread is applied to a long or short position.',
    },
    {
        name: 'PaymentStubIndexRateTreatment',
        abbrName: 'RtTrtmt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateTreatmentCodeSet',
        id: 40885,
        description: 'Specifies the yield calculation treatment for the payment stub index.',
    },
    {
        name: 'PaymentStubIndexCapRate',
        abbrName: 'CapRt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40886,
        description:
            'The cap rate, if any, which applies to the floating rate. The cap rate (strike) is only required where the floating rate on a swap stream is capped at a certain level. The cap rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A cap rate of 5% would be represented as 0.05.',
    },
    {
        name: 'PaymentStubIndexCapRateBuySide',
        abbrName: 'CapRtBuy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamCapRateBuySideCodeSet',
        id: 40887,
        description: 'Reference to the buyer of the cap rate option through its trade side.',
    },
    {
        name: 'PaymentStubIndexCapRateSellSide',
        abbrName: 'CapRtSell',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamCapRateBuySideCodeSet',
        id: 40888,
        description: 'Reference to the seller of the cap rate option through its trade side.',
    },
    {
        name: 'PaymentStubIndexFloorRate',
        abbrName: 'FlrRt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40889,
        description:
            'The floor rate, if any, which applies to the floating rate. The floor rate (strike) is only required where the floating rate on a swap stream is floored at a certain strike level. The floor rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A floor rate of 5% would be represented as 0.05.',
    },
    {
        name: 'PaymentStubIndexFloorRateBuySide',
        abbrName: 'FlrRtBuy',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamFloorRateBuySideCodeSet',
        id: 40890,
        description: 'Reference to the buyer of the floor rate option through its trade side.',
    },
    {
        name: 'PaymentStubIndexFloorRateSellSide',
        abbrName: 'FlrRtSell',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamFloorRateBuySideCodeSet',
        id: 40891,
        description: 'Reference to the seller of the floor rate option through its trade side.',
    },
    {
        name: 'PaymentStubIndex2',
        abbrName: 'Ndx2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40892,
        discriminatorId: '40893',
        description: 'The second stub floating rate index.',
    },
    {
        name: 'PaymentStubIndex2Source',
        abbrName: 'Ndx2Src',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexSourceCodeSet',
        id: 40893,
        description: 'The source of the second stub floating rate index.',
    },
    {
        name: 'PaymentStubIndex2CurvePeriod',
        abbrName: 'Ndx2Period',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40894,
        description: 'Secondary time unit multiplier for the stub floating rate index curve.',
    },
    {
        name: 'PaymentStubIndex2CurveUnit',
        abbrName: 'Ndx2Unit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexCurveUnitCodeSet',
        id: 40895,
        description: 'Secondary time unit associated with the stub floating rate index curve.',
    },
    {
        name: 'PaymentStubIndex2RateMultiplier',
        abbrName: 'RtMult2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 40896,
        description:
            'A rate multiplier to apply to the second floating rate. The multiplier can be less than or greater than 1 (one). This element should only be included if the multiplier is not equal to 1 (one) for the term of the stream.',
    },
    {
        name: 'PaymentStubIndex2RateSpread',
        abbrName: 'Spread2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 40897,
        description: 'Spread from the second floating rate index.',
    },
    {
        name: 'PaymentStubIndex2RateSpreadPositionType',
        abbrName: 'Spread2PosTyp',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
        id: 40898,
        description: 'Identifies whether the rate spread is applied to a long or short position.',
    },
    {
        name: 'PaymentStubIndex2RateTreatment',
        abbrName: 'RtTrtmt2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateTreatmentCodeSet',
        id: 40899,
        description: 'Specifies the yield calculation treatment for the second stub index.',
    },
    {
        name: 'PaymentStubIndex2CapRate',
        abbrName: 'CapRt2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40900,
        description:
            'The cap rate, if any, which applies to the second floating rate. The cap rate (strike) is only required where the floating rate on a swap stream is capped at a certain level. The cap rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A cap rate of 5% would be represented as 0.05.',
    },
    {
        name: 'PaymentStubIndex2FloorRate',
        abbrName: 'FlrRt2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 40901,
        description:
            'The floor rate, if any, which applies to the second floating rate. The floor rate (strike) is only required where the floating rate on a swap stream is floored at a certain strike level. The floor rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A floor rate of 5% would be represented as 0.05.',
    },
    {
        name: 'NoLegSettlRateFallbacks',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40902,
        description: 'Number of settlement rate fallbacks in the repeating group',
    },
    {
        name: 'LegSettlRatePostponementMaximumDays',
        abbrName: 'MaxDays',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40903,
        description:
            'The maximum number of days to wait for a quote from the disrupted settlement rate option before proceding to this method.',
    },
    {
        name: 'UnderlyingSettlRateFallbackRateSource',
        abbrName: 'RtSrc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'RateSourceCodeSet',
        id: 40904,
        description: 'Identifies the source of rate information.',
    },
    {
        name: 'LegSettlRatePostponementSurvey',
        abbrName: 'Survey',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 40905,
        description: 'Indicates whether to request a settlement rate quote from the market.',
    },
    {
        name: 'LegSettlRatePostponementCalculationAgent',
        abbrName: 'CalcAgent',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'ProvisionCalculationAgentCodeSet',
        id: 40906,
        description: 'Used to identify the settlement rate postponement calculation agent.',
    },
    {
        name: 'StreamEffectiveDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40907,
        description: 'The unadjusted effective date.',
    },
    {
        name: 'StreamEffectiveDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40908,
        description:
            "The business day convention used to adjust the instrument's stream's effective, or relative effective, date. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.",
    },
    {
        name: 'StreamEffectiveDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40909,
        description:
            'The business center calendar used to adjust the instrument\'s stream\'s effective, or relative effective, date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'StreamEffectiveDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40910,
        description:
            'Specifies the anchor date when the effective date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'StreamEffectiveDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40911,
        description: 'Time unit multiplier for the relative effective date offset.',
    },
    {
        name: 'StreamEffectiveDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 40912,
        description: 'Time unit associated with the relative effective date offset.',
    },
    {
        name: 'StreamEffectiveDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40913,
        description: 'Specifies the day type of the relative effective date offset.',
    },
    {
        name: 'StreamEffectiveDateAdjusted',
        abbrName: 'Dt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 40914,
        description: 'The adjusted effective date.',
    },
    {
        name: 'UnderlyingSettlRateFallbackReferencePage',
        abbrName: 'RefPg',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40915,
        description:
            'Identifies the reference "page" from the rate source.\n\nWhen UnderlyingSettlRateFallbackRateSource(40904) = 3(ISDA Settlement Rate Option) this contains the value from the scheme that reflects the terms of the Annex A to the ISDA 1998 FX and Currency Option Definitions. See: http://www.fpml.org/coding-scheme/settlement-rate-option',
    },
    {
        name: 'PaymentPriceType',
        abbrName: 'PxTyp',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PriceTypeCodeSet',
        id: 40919,
        description: 'Specifies the type of price for PaymentPrice(40218).',
    },
    {
        name: 'PaymentStreamPaymentDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 40920,
        description: 'Specifies the day type of the relative payment date offset.',
    },
    {
        name: 'BusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40921,
        description:
            'The business day convention used for adjusting dates. The value defined here applies to all adjustable dates in the instrument unless specifically overridden.',
    },
    {
        name: 'DateRollConvention',
        abbrName: 'Roll',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'DateRollConventionCodeSet',
        id: 40922,
        description:
            'The convention for determining a sequence of dates. It is used in conjunction with a specified frequency. The value defined here applies to all adjustable dates in the instrument unless specifically overridden. Additional values may be used by mutual agreement of the counterparties.',
    },
    {
        name: 'NoLegBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40923,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'LegBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40924,
        description:
            'A business center whose calendar is used for date adjustment, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40925,
        description:
            'The business day convention used for adjusting dates. The value defined here applies to all adjustable dates in the instrument leg unless specifically overridden.',
    },
    {
        name: 'LegDateRollConvention',
        abbrName: 'Roll',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'DateRollConventionCodeSet',
        id: 40926,
        description:
            'The convention for determining a sequence of dates. It is used in conjunction with a specified frequency. The value defined here applies to all adjustable dates in the instrument leg unless specifically overridden.',
    },
    {
        name: 'NoLegPaymentScheduleFixingDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40927,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoLegPaymentScheduleInterimExchangeDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40928,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoLegPaymentStreamNonDeliverableFixingDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40929,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoLegPaymentStreamPaymentDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40930,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoLegPaymentStreamResetDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40931,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoLegPaymentStreamInitialFixingDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40932,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoLegPaymentStreamFixingDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40933,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoLegProvisionCashSettlPaymentDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40934,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoLegProvisionCashSettlValueDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40935,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoLegProvisionOptionExerciseBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40936,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoLegProvisionOptionExpirationDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40937,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoLegProvisionOptionRelevantUnderlyingDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40938,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoLegProvisionDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40939,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoLegStreamCalculationPeriodBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40940,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoLegStreamFirstPeriodStartDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40941,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoLegStreamEffectiveDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40942,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoLegStreamTerminationDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40943,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoPaymentBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40944,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoPaymentScheduleInterimExchangeDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40945,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoPaymentStreamNonDeliverableFixingDatesBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40946,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoPaymentStreamPaymentDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40947,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoPaymentStreamResetDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40948,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoPaymentStreamInitialFixingDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40949,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoPaymentStreamFixingDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40950,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoProtectionTermEventNewsSources',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40951,
        description: 'Number of event news sources in the repeating group.',
    },
    {
        name: 'NoProvisionCashSettlPaymentDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40952,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoProvisionCashSettlValueDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40953,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoProvisionOptionExerciseBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40954,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoProvisionOptionExpirationDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40955,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoProvisionOptionRelevantUnderlyingDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40956,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoProvisionDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40957,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoStreamCalculationPeriodBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40958,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoStreamFirstPeriodStartDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40959,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoStreamEffectiveDateBusinessCenters',
        updated: 'FIX.Latest',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        updatedEP: '271',
        id: 40960,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoStreamTerminationDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40961,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoUnderlyingBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40962,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'UnderlyingBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40963,
        description:
            'A business center whose calendar is used for date adjustment, e.g. "GBLO". See http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'UnderlyingBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 40964,
        description:
            'The business day convention used for adjusting dates. The value defined here applies to all adjustable dates in the underlying instrument unless specifically overridden.',
    },
    {
        name: 'UnderlyingDateRollConvention',
        abbrName: 'Roll',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'DateRollConventionCodeSet',
        id: 40965,
        description:
            'The convention for determining a sequence of dates. It is used in conjunction with a specified frequency. The value defined here applies to all adjustable dates in the underlying instrument unless specifically overridden.',
    },
    {
        name: 'NoUnderlyingPaymentScheduleFixingDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40966,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoUnderlyingPaymentScheduleInterimExchangeDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40967,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoUnderlyingPaymentStreamNonDeliverableFixingDatesBizCenters',
        updated: 'FIX.Latest',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        updatedEP: '271',
        id: 40968,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoUnderlyingPaymentStreamPaymentDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40969,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoUnderlyingPaymentStreamResetDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40970,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoUnderlyingPaymentStreamInitialFixingDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40971,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoUnderlyingPaymentStreamFixingDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40972,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoUnderlyingStreamCalculationPeriodBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40973,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoUnderlyingStreamFirstPeriodStartDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40974,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoUnderlyingStreamEffectiveDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40975,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoUnderlyingStreamTerminationDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40976,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'NoPaymentScheduleFixingDateBusinessCenters',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40977,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'EncodedLegStreamTextLen',
        abbrName: 'EncTxtLen',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 40978,
        description: 'Byte length of encoded (non-ASCII characters) EncodedLegStreamText(40979) field.',
    },
    {
        name: 'EncodedLegStreamText',
        abbrName: 'EncTxt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 40979,
        lengthId: '40978',
        description:
            'Encoded (non-ASCII characters) representation of the LegStreamText(40248) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the LegStreamText(40248) field.',
    },
    {
        name: 'EncodedLegProvisionTextLen',
        abbrName: 'EncTxtLen',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 40980,
        description: 'Byte length of encoded (non-ASCII characters) EncodedLegProvisionText(40472) field.',
    },
    {
        name: 'EncodedLegProvisionText',
        abbrName: 'EncTxt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 40981,
        lengthId: '40980',
        description:
            'Encoded (non-ASCII characters) representation of the LegProvisionText(40472) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the LegProvisionText(40472) field.',
    },
    {
        name: 'EncodedStreamTextLen',
        abbrName: 'EncTxtLen',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 40982,
        description: 'Byte length of encoded (non-ASCII characters) EncodedStreamText(40983) field.',
    },
    {
        name: 'EncodedStreamText',
        abbrName: 'EncTxt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 40983,
        lengthId: '40982',
        description:
            'Encoded (non-ASCII characters) representation of the StreamText(40056) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the StreamText(40056) field.',
    },
    {
        name: 'EncodedPaymentTextLen',
        abbrName: 'EncTxtLen',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 40984,
        description: 'Byte length of encoded (non-ASCII characters) EncodedPaymentText(40985) field.',
    },
    {
        name: 'EncodedPaymentText',
        abbrName: 'EncTxt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 40985,
        lengthId: '40984',
        description:
            'Encoded (non-ASCII characters) representation of the PaymentText(40229) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the PaymentText(40229) field.',
    },
    {
        name: 'EncodedProvisionTextLen',
        abbrName: 'EncTxtLen',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 40986,
        description: 'Byte length of encoded (non-ASCII characters) EncodedProvisionText(40987) field.',
    },
    {
        name: 'EncodedProvisionText',
        abbrName: 'EncTxt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 40987,
        lengthId: '40986',
        description:
            'Encoded (non-ASCII characters) representation of the ProvisionText(40113) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the ProvisionText(40113) field.',
    },
    {
        name: 'EncodedUnderlyingStreamTextLen',
        abbrName: 'EncTxtLen',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 40988,
        description: 'Byte length of encoded (non-ASCII characters) EncodedUnderlyingStreamText(40989) field.',
    },
    {
        name: 'EncodedUnderlyingStreamText',
        abbrName: 'EncTxt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 40989,
        lengthId: '40988',
        description:
            'Encoded (non-ASCII characters) representation of the UnderlyingStreamText(40547) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the UnderlyingStreamText(40547) field.',
    },
    {
        name: 'ProvisionCashSettlQuoteReferencePage',
        abbrName: 'RefPg',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41406,
        description: 'Identifies the reference "page" from the quote source.',
    },
    {
        name: 'LegProvisionCashSettlQuoteReferencePage',
        abbrName: 'RefPg',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41407,
        description: 'Identifies the reference "page" from the quote source.',
    },
    {
        name: 'EventMonthYear',
        abbrName: 'MoYr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'MonthYear',
        id: 2340,
        description:
            'Used with derivatives when an event is express as a month-year with optional day or month or week of month.\n\nFormat:\n\nYYYYMM (e.g. 199903)\n\nYYYYMMDD (e.g. 20030323)\n\nYYYYMMwN (e.g. 200303w2) for week\n\nA specific date can be appended to the month-year. For instance, if multiple event types exist in the same Year and Month, but actually at a different time, a value can be appended, such as "w" or "w2" to indicate week. Likewise, the day of monty (0-31) can be appended to indicate a specific event date.',
    },
    {
        name: 'LegEventMonthYear',
        abbrName: 'MoYr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'MonthYear',
        id: 2341,
        description:
            'Used with derivatives when an event is express as a month-year with optional day or month or week of month.\n\nFormat:\n\nYYYYMM (e.g. 199903)\n\nYYYYMMDD (e.g. 20030323)\n\nYYYYMMwN (e.g. 200303w2) for week\n\nA specific date can be appended to the month-year. For instance, if multiple event types exist in the same Year and Month, but actually at a different time, a value can be appended, such as "w" or "w2" to indicate week. Likewise, the day of monty (0-31) can be appended to indicate a specific event date.',
    },
    {
        name: 'UnderlyingEventMonthYear',
        abbrName: 'MoYr',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        type: 'MonthYear',
        id: 2342,
        description:
            'Used with derivatives when an event is express as a month-year with optional day or month or week of month.\n\nFormat:\n\nYYYYMM (e.g. 199903)\n\nYYYYMMDD (e.g. 20030323)\n\nYYYYMMwN (e.g. 200303w2) for week\n\nA specific date can be appended to the month-year. For instance, if multiple event types exist in the same Year and Month, but actually at a different time, a value can be appended, such as "w" or "w2" to indicate week. Likewise, the day of monty (0-31) can be appended to indicate a specific event date.',
    },
    {
        name: 'PreviousClearingBusinessDate',
        abbrName: 'PrevBizDt',
        addedEP: '162',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 2084,
        description: 'The date of the previous clearing business day.',
    },
    {
        name: 'ValuationDate',
        abbrName: 'ValDt',
        updated: 'FIX.5.0SP2',
        addedEP: '162',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        updatedEP: '169',
        id: 2085,
        description: 'The valuation date of the trade.',
    },
    {
        name: 'ValuationTime',
        abbrName: 'ValTm',
        updated: 'FIX.5.0SP2',
        addedEP: '162',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        updatedEP: '169',
        id: 2086,
        description: 'The valuation time of the trade.',
    },
    {
        name: 'ValuationBusinessCenter',
        abbrName: 'ValBizCtr',
        updated: 'FIX.Latest',
        addedEP: '162',
        added: 'FIX.5.0SP2',
        type: 'String',
        updatedEP: '271',
        id: 2087,
        description:
            'Identifies the business center whose calendar is used for valuation, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'MarginAmtFXRate',
        abbrName: 'FxRt',
        addedEP: '162',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 2088,
        description:
            'Foreign exchange rate used to compute the MarginAmt(1645) from the MarginAmtCcy(1646) and the Currency(15).',
    },
    {
        name: 'MarginAmtFXRateCalc',
        abbrName: 'FxRtCalc',
        addedEP: '162',
        added: 'FIX.5.0SP2',
        type: 'UnderlyingFXRateCalcCodeSet',
        id: 2089,
        description: 'Specifies whether or not MarginAmtFXRate(2088) should be multipled or divided.',
    },
    {
        name: 'CollateralFXRate',
        abbrName: 'FxRt',
        addedEP: '162',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 2090,
        description:
            'Foreign exchange rate used to compute the CurrentCollateralAmount(1704) from the CollateralCurrency(1646) and the Currency(15).',
    },
    {
        name: 'CollateralFXRateCalc',
        abbrName: 'FxRtCalc',
        addedEP: '162',
        added: 'FIX.5.0SP2',
        type: 'UnderlyingFXRateCalcCodeSet',
        id: 2091,
        description: 'Specifies whether or not CollateralFXRate(2090) should be multipled or divided.',
    },
    {
        name: 'CollateralAmountMarketSegmentID',
        abbrName: 'MktSegID',
        addedEP: '162',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2092,
        description: 'Market segment associated with the collateral amount.',
    },
    {
        name: 'CollateralAmountMarketID',
        abbrName: 'MktID',
        addedEP: '162',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2093,
        description: 'Market associated with the collateral amount.',
    },
    {
        name: 'PayCollectFXRate',
        abbrName: 'FxRt',
        addedEP: '162',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 2094,
        description:
            'Foreign exchange rate used to compute the PayAmount(1710) or CollectAmount(1711) from the PayCollectCurrency(1709) and the Currency(15).',
    },
    {
        name: 'PayCollectFXRateCalc',
        abbrName: 'FxRtCalc',
        addedEP: '162',
        added: 'FIX.5.0SP2',
        type: 'UnderlyingFXRateCalcCodeSet',
        id: 2095,
        description: 'Specifies whether or not PayCollectFXRate(2094) should be multipled or divided.',
    },
    {
        name: 'PosAmtStreamDesc',
        abbrName: 'StrmDesc',
        addedEP: '162',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2096,
        description: 'Corresponds to the value in StreamDesc(40051) in the StreamGrp component.',
    },
    {
        name: 'PositionFXRate',
        abbrName: 'FxRt',
        addedEP: '162',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 2097,
        description:
            'Foreign exchange rate used to compute the PosAmt(708) from the PositionCurrency(1055) and the Currency (15).',
    },
    {
        name: 'PositionFXRateCalc',
        abbrName: 'FxRtCalc',
        addedEP: '162',
        added: 'FIX.5.0SP2',
        type: 'UnderlyingFXRateCalcCodeSet',
        id: 2098,
        description: 'Specifies whether or not PositionFXRate(2097) should be multipled or divided.',
    },
    {
        name: 'PosAmtMarketSegmentID',
        abbrName: 'MktSegID',
        addedEP: '162',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2099,
        description: 'Market segment associated with the position amount.',
    },
    {
        name: 'PosAmtMarketID',
        abbrName: 'MktID',
        addedEP: '162',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2100,
        description: 'Market associated with the position amount.',
    },
    {
        name: 'TerminatedIndicator',
        abbrName: 'TrmtdInd',
        addedEP: '162',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2101,
        description: 'Indicates if the position has been terminated.',
    },
    {
        name: 'ShortMarkingExemptIndicator',
        abbrName: 'SMEInd',
        addedEP: '164',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2102,
        description:
            'Indicates whether the originating account is exempt (Y) from marking orders as short or not (N). This designation may be used on both buy and sell orders.',
    },
    {
        name: 'RelatedRegulatoryTradeIDSource',
        abbrName: 'RegSrc',
        addedEP: '165',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2103,
        description: 'Specifies the identifier of the reporting entity as assigned by regulatory agency.',
    },
    {
        name: 'NoAttachments',
        addedEP: '167',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2104,
        description: 'The number of attached files.',
    },
    {
        name: 'AttachmentName',
        abbrName: 'Name',
        addedEP: '167',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2105,
        description: 'Specifies the file name of the attachment.',
    },
    {
        name: 'AttachmentMediaType',
        abbrName: 'MediaTyp',
        addedEP: '167',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2106,
        description:
            'The MIME media type (and optional subtype) of the attachment. The values used are those assigned, listed and maintained by IANA (www.iana.org) [RFC2046]. See http://www.iana.org/assignments/media-types/index.html for available types.\n\nExamples values (RFC number provided for reference here only):\n\n"application/pdf" (see [RFC3778])\n\n"application/msword" (for .doc files)\n\n"multipart/signed" (see [RFC1847])\n\n"application/vnd.openxmlformats-officedocument.wordprocessingml.document" (for .docx files)',
    },
    {
        name: 'AttachmentClassification',
        abbrName: 'Clsfn',
        addedEP: '167',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2107,
        description:
            'Specifies semantically the type of the attached document from a business perspective. The default classification scheme reuses the FIX standard classification scheme of a high level section (pretrade, trade, posttrade, etc.) and a category, then a specific application or document type. The expression follows {"section/category/application type"}.\n\nThe goal here is to map the attachment into the sections and categories of the FIX business messages if possible. The classification scheme can be expanded or replaced by counterparty agreement. This approach permits the introduction and reference to other business ontologies.\n\nExample:\n\nposttrade/confirmation/confirm\n\npretrade//termsheet',
    },
    {
        name: 'AttachmentExternalURL',
        abbrName: 'URL',
        addedEP: '167',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2108,
        description: 'Used to specify an external URL where the attachment can be obtained.',
    },
    {
        name: 'AttachmentEncodingType',
        abbrName: 'EncTyp',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.Latest',
        addedEP: '167',
        added: 'FIX.5.0SP2',
        type: 'AttachmentEncodingTypeCodeSet',
        updatedEP: '271',
        id: 2109,
        description:
            'The encoding type of the content provided in EncodedAttachment(2112).\n\nThe AttachmentEncodingType(2109) is a distinct and separate concept from MessageEncoding(347) that defines how FIX fields of type data are encoded. The MessageEncoding(347) is used to embed text in another character set (e.g. Unicode or Shift-JIS) within FIX.',
    },
    {
        name: 'UnencodedAttachmentLen',
        abbrName: 'UnencAttchmntLen',
        addedEP: '167',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2110,
        description: 'Unencoded content length in bytes. Can be used to validate successful unencoding.',
    },
    {
        name: 'EncodedAttachmentLen',
        abbrName: 'EncAttchmntLen',
        addedEP: '167',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 2111,
        description: 'Byte length of encoded the EncodedAttachment(2112) field.',
    },
    {
        name: 'EncodedAttachment',
        abbrName: 'EncAttchmnt',
        addedEP: '167',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 2112,
        lengthId: '2111',
        description:
            'The content of the attachment in the encoding format specified in the AttachmentEncodingType(2109) field.',
    },
    {
        name: 'NoAttachmentKeywords',
        addedEP: '167',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2113,
        description: 'The number of attachment keywords.',
    },
    {
        name: 'AttachmentKeyword',
        abbrName: 'Keywd',
        addedEP: '167',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2114,
        description: 'Can be used to provide data or keyword tagging of the content of the attachment.',
    },
    {
        name: 'NegotiationMethod',
        abbrName: 'NegottnMeth',
        unionDataType: 'Reserved100Plus',
        addedEP: '168',
        added: 'FIX.5.0SP2',
        type: 'NegotiationMethodCodeSet',
        id: 2115,
        description: 'Specifies the negotiation method to be used.',
    },
    {
        name: 'NextAuctionTime',
        abbrName: 'NxtAuctTm',
        addedEP: '168',
        added: 'FIX.5.0SP2',
        type: 'UTCTimestamp',
        id: 2116,
        description: 'The time of the next auction.',
    },
    {
        name: 'NoAssetAttributes',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2304,
        description: 'The number of asset attribute entries in the group.',
    },
    {
        name: 'AssetAttributeType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2305,
        description:
            'Specifies the name of the attribute.\n\nSee http://www.fixtradingcommunity.org/codelists#Asset_Attribute_Types for code list of applicable asset attribute types.',
    },
    {
        name: 'AssetAttributeValue',
        abbrName: 'Val',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2306,
        description: 'Specifies the value of the asset attribute.',
    },
    {
        name: 'AssetAttributeLimit',
        abbrName: 'Lmt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2307,
        description: 'Limit or lower acceptable value of the attribute.',
    },
    {
        name: 'CommRate',
        abbrName: 'Rt',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        updatedEP: '204',
        id: 1233,
        description:
            'The commission rate when Commission(12) is based on a percentage of quantity, amount per unit or a factor of "unit of measure". If the rate is a percentage, use the decimalized form, e.g. "0.05" for a 5% commission or "0.005" for 50 basis points.',
    },
    {
        name: 'CommUnitOfMeasure',
        abbrName: 'UOM',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        updatedEP: '204',
        id: 1238,
        description: 'The commission rate unit of measure.',
    },
    {
        name: 'NoComplexEventAveragingObservations',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40994,
        description: 'The number of averaging observations in the repeating group.',
    },
    {
        name: 'ComplexEventAveragingObservationNumber',
        abbrName: 'ObsvtnNum',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 40995,
        description:
            'Cross reference to the ordinal observation as specified either in the ComplexEventScheduleGrp or ComplexEventPeriodDateGrp components.',
    },
    {
        name: 'ComplexEventAveragingWeight',
        abbrName: 'Wt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 40996,
        description: 'The weight factor to be applied to the observation.',
    },
    {
        name: 'NoComplexEventCreditEvents',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 40997,
        description: 'The number of credit events specified in the repeating group.',
    },
    {
        name: 'ComplexEventCreditEventType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40998,
        description:
            'Specifies the type of credit event.\n\nSee http://www.fixtradingcommunity.org/codelists#Credit_Event_Types for code list of applicable event types.',
    },
    {
        name: 'ComplexEventCreditEventValue',
        abbrName: 'Val',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40999,
        description:
            'The credit event value appropriate to ComplexEventCreditEventType(40998).\n\nSee http://www.fixtradingcommunity.org/codelists#Credit_Event_Types for applicable event type values.',
    },
    {
        name: 'ComplexEventCreditEventCurrency',
        abbrName: 'Ccy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41000,
        description:
            'Specifies the applicable currency when ComplexEventCreditEventValue(40999) is an amount. Uses ISO 4217 currency codes.',
    },
    {
        name: 'ComplexEventCreditEventPeriod',
        abbrName: 'Period',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41001,
        description: 'Time unit multiplier for complex credit events.',
    },
    {
        name: 'ComplexEventCreditEventUnit',
        abbrName: 'Unit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ProtectionTermEventUnitCodeSet',
        id: 41002,
        description: 'Time unit associated with complex credit events.',
    },
    {
        name: 'ComplexEventCreditEventDayType',
        abbrName: 'DayTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventDateOffsetDayTypeCodeSet',
        id: 41003,
        description: 'Specifies the day type for the complex credit events.',
    },
    {
        name: 'ComplexEventCreditEventRateSource',
        abbrName: 'RtSrc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41004,
        description:
            'Identifies the source of rate information used for credit events.\n\nSee http://www.fixtradingcommunity.org/codelists#Credit_Event_Rate_Source for code list of applicable sources.',
    },
    {
        name: 'NoComplexEventCreditEventQualifiers',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41005,
        description: 'The number of qualifiers in the repeating group.',
    },
    {
        name: 'ComplexEventCreditEventQualifier',
        abbrName: 'Qual',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ProtectionTermEventQualifierCodeSet',
        id: 41006,
        description: 'Specifies a complex event qualifier. Used to further qualify ComplexEventCreditEventType(40998).',
    },
    {
        name: 'NoComplexEventPeriodDateTimes',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41007,
        description: 'The number of entries in the date-time repeating group.',
    },
    {
        name: 'ComplexEventPeriodDate',
        abbrName: 'Dt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41008,
        description: 'The averaging date for an Asian option.\n\nThe trigger date for a Barrier or Knock option.',
    },
    {
        name: 'ComplexEventPeriodTime',
        abbrName: 'Tm',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 41009,
        description: 'The averaging time for an Asian option.',
    },
    {
        name: 'NoComplexEventPeriods',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41010,
        description: 'The number of periods in the repeating group.',
    },
    {
        name: 'ComplexEventPeriodType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventPeriodTypeCodeSet',
        id: 41011,
        description: 'Specifies the period type.',
    },
    {
        name: 'ComplexEventBusinessCenter',
        abbrName: 'BizCtr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41012,
        description:
            'The business center used to determine dates and times in the schedule or date-time group.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'NoComplexEventRateSources',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41013,
        description: 'The number of rate sources in the repeating group.',
    },
    {
        name: 'ComplexEventRateSource',
        abbrName: 'RtSrc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'RateSourceCodeSet',
        id: 41014,
        description:
            'Identifies the source of rate information.\n\nFor FX, the reference source to be used for the FX spot rate.',
    },
    {
        name: 'ComplexEventRateSourceType',
        abbrName: 'RtSrcTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'RateSourceTypeCodeSet',
        id: 41015,
        description: 'Indicates whether the rate source specified is a primary or secondary source.',
    },
    {
        name: 'ComplexEventReferencePage',
        abbrName: 'RefPg',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41016,
        description:
            'Identifies the reference page from the rate source.\n\nFor FX, the reference page to the spot rate is to be used for the reference FX spot rate.\n\nWhen ComplexEventRateSource(41014) = 3 (ISDA Settlement Rate Option) this contains the value from the scheme that reflects the terms of the Annex A to the ISDA 1998 FX and Currency Option Definitions. See: http://www.fpml.org/coding-scheme/settlement-rate-option.',
    },
    {
        name: 'ComplexEventReferencePageHeading',
        abbrName: 'RefHdng',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41017,
        description: 'Identifies the reference page heading from the rate source.',
    },
    {
        name: 'NoComplexEventDateBusinessCenters',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41018,
        description: 'The number of business centers in the repeating group.',
    },
    {
        name: 'ComplexEventDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41019,
        description:
            'The business center calendar used to adjust the complex event date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'ComplexEventDateUnadjusted',
        abbrName: 'DtUnadj',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        updatedEP: '208',
        id: 41020,
        description:
            'The unadjusted complex event date.\n\nFor example the second expiration date for a calendar spread option strategy.',
    },
    {
        name: 'ComplexEventDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 41021,
        description:
            'Specifies the anchor date when the complex event date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'ComplexEventDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41022,
        description: 'Time unit multiplier for the relative date offset.',
    },
];

const batch5: ISpecFields[] = [
    {
        name: 'ComplexEventDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 41023,
        description: 'Time unit associated with the relative date offset.',
    },
    {
        name: 'ComplexEventDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventDateOffsetDayTypeCodeSet',
        id: 41024,
        description: 'Specifies the day type of the relative date offset.',
    },
    {
        name: 'ComplexEventDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 41025,
        description:
            'The business day convention used to adjust the complex event date. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.',
    },
    {
        name: 'ComplexEventDateAdjusted',
        abbrName: 'Dt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41026,
        description: 'The adjusted complex event date.',
    },
    {
        name: 'ComplexEventFixingTime',
        abbrName: 'FixngTm',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 41027,
        description: 'The local market fixing time.',
    },
    {
        name: 'ComplexEventFixingTimeBusinessCenter',
        abbrName: 'FixngBizCtr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41028,
        description:
            'The business center calendar used to determine the actual fixing times.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'NoComplexEventCreditEventSources',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41029,
        description: 'Number of event sources in the repeating group.',
    },
    {
        name: 'ComplexEventCreditEventSource',
        abbrName: 'Src',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41030,
        description:
            'A newspaper or electronic news service that may publish relevant information used in the determination of whether or not a credit event has occurred.',
    },
    {
        name: 'ComplexOptPayoutPaySide',
        abbrName: 'OptPay',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentPaySideCodeSet',
        id: 2117,
        description: 'Trade side of payout payer.',
    },
    {
        name: 'ComplexOptPayoutReceiveSide',
        abbrName: 'OptRcv',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentPaySideCodeSet',
        id: 2118,
        description: 'Trade side of payout receiver.',
    },
    {
        name: 'ComplexOptPayoutUnderlier',
        abbrName: 'OptUndlr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2119,
        description: 'Reference to the underlier whose payments are being passed through.',
    },
    {
        name: 'ComplexOptPayoutPercentage',
        abbrName: 'OptPctage',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 2120,
        description: 'Percentage of observed price for calculating the payout associated with the event.',
    },
    {
        name: 'ComplexOptPayoutTime',
        abbrName: 'OptTm',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ComplexOptPayoutTimeCodeSet',
        id: 2121,
        description: 'Specifies when the payout is to occur.',
    },
    {
        name: 'ComplexOptPayoutCurrency',
        abbrName: 'OptCcy',
        updated: 'FIX.Latest',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        updatedEP: '273',
        id: 2122,
        description:
            'Specifies the currency of the payout amount.\n\nComplexOptPayoutCurrencyCodeSource(2941) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.',
    },
    {
        name: 'ComplexEventPricePercentage',
        abbrName: 'PxPctage',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 2123,
        description:
            'Specifies the price percentage at which the complex event takes effect. Impact of the event price is determined by the ComplexEventType(1484).',
    },
    {
        name: 'ComplexEventCurrencyOne',
        abbrName: 'Ccy1',
        updated: 'FIX.Latest',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        updatedEP: '273',
        id: 2124,
        description:
            'Specifies the first or only reference currency of the trade.\n\nComplexEventCurrencyOneCodeSource(2942) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.\n\nApplicable for complex FX option strategies.',
    },
    {
        name: 'ComplexEventCurrencyTwo',
        abbrName: 'Ccy2',
        updated: 'FIX.Latest',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        updatedEP: '273',
        id: 2125,
        description:
            'Specifies the second reference currency of the trade.\n\nComplexEventCurrencyTwoCodeSource(2943) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.\n\nApplicable for complex FX option strategies.',
    },
    {
        name: 'ComplexEventQuoteBasis',
        abbrName: 'QteBasis',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventQuoteBasisCodeSet',
        id: 2126,
        description: 'For foreign exchange Quanto option feature.',
    },
    {
        name: 'ComplexEventFixedFXRate',
        abbrName: 'Rt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 2127,
        description: 'Specifies the fixed FX rate alternative for FX Quantro options.',
    },
    {
        name: 'ComplexEventDeterminationMethod',
        abbrName: 'Meth',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2128,
        description:
            'Specifies the method according to which an amount or a date is determined.\n\nSee http://www.fpml.org/coding-scheme/determination-method for values.',
    },
    {
        name: 'ComplexEventCalculationAgent',
        abbrName: 'CalcAgent',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ProvisionCalculationAgentCodeSet',
        id: 2129,
        description: 'Used to identify the calculation agent.',
    },
    {
        name: 'ComplexEventStrikePrice',
        abbrName: 'StrkPx',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 2130,
        description: 'Upper strike price for Asian option feature. Strike percentage for a Strike Spread.',
    },
    {
        name: 'ComplexEventStrikeFactor',
        abbrName: 'StrkFctr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 2131,
        description: 'Strike factor for Asian option feature. Upper strike percentage for a Strike Spread.',
    },
    {
        name: 'ComplexEventStrikeNumberOfOptions',
        abbrName: 'StrkNum',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2132,
        description: 'Upper string number of options for a Strike Spread.',
    },
    {
        name: 'ComplexEventCreditEventsXIDRef',
        abbrName: 'CdtEvntXIDRef',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XIDREF',
        id: 2133,
        description: 'Reference to credit event table elsewhere in the message.',
    },
    {
        name: 'ComplexEventCreditEventNotifyingParty',
        abbrName: 'NotifygPty',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventCreditEventNotifyingPartyCodeSet',
        id: 2134,
        description:
            'The notifying party is the party that notifies the other party when a credit event has occurred by means of a credit event notice. If more than one party is referenced as being the notifying party then either party may notify the other of a credit event occurring.',
    },
    {
        name: 'ComplexEventCreditEventBusinessCenter',
        abbrName: 'BizCtr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2135,
        description:
            'The local business center for which the credit event is to be determined. The inclusion of this business center implies that Greenwich Mean Time in Section 3.3 of the 2003 ISDA Credit Derivatives Definitions is replaced by the local time of the specified business center.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'ComplexEventCreditEventStandardSources',
        abbrName: 'StdSrcs',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2136,
        description:
            "When this element is specified and set to 'Y', indicates that ISDA defined Standard Public Sources are applicable.",
    },
    {
        name: 'ComplexEventCreditEventMinimumSources',
        abbrName: 'MinSrcs',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2137,
        description:
            'The minimum number of the specified public information sources that must publish information that reasonably confirms that a credit event has occurred. The market convention is two.\n\nISDA 2003 Term: Specified Number.',
    },
    {
        name: 'ComplexEventXID',
        abbrName: 'XID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XID',
        id: 2138,
        description: 'Identifier of this complex event for cross referencing elsewhere in the message.',
    },
    {
        name: 'ComplexEventXIDRef',
        abbrName: 'XIDRef',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XIDREF',
        id: 2139,
        description: 'Reference to a complex event elsewhere in the message.',
    },
    {
        name: 'NoComplexEventSchedules',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41031,
        description: 'Number of schedules in the repeating group.',
    },
    {
        name: 'ComplexEventScheduleStartDate',
        abbrName: 'StartDt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41032,
        description: 'The start date of the schedule.',
    },
    {
        name: 'ComplexEventScheduleEndDate',
        abbrName: 'EndDt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41033,
        description: 'The end date of the schedule.',
    },
    {
        name: 'ComplexEventScheduleFrequencyPeriod',
        abbrName: 'FreqPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41034,
        description: 'Time unit multiplier for the schedule date frequency.',
    },
    {
        name: 'ComplexEventScheduleFrequencyUnit',
        abbrName: 'FreqUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ProtectionTermEventUnitCodeSet',
        id: 41035,
        description: 'Time unit associated with the schedule date frequency.',
    },
    {
        name: 'ComplexEventScheduleRollConvention',
        abbrName: 'Roll',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DateRollConventionCodeSet',
        id: 41036,
        description:
            'The convention for determining the sequence of dates. It is used in conjunction with a specified frequency. Used only to override the roll convention defined in the DateAdjustment component in Instrument.',
    },
    {
        name: 'NoDeliverySchedules',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41037,
        description: 'Number of delivery schedules in the repeating group.',
    },
    {
        name: 'DeliveryScheduleType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryScheduleTypeCodeSet',
        id: 41038,
        description: 'Specifies the type of delivery schedule.',
    },
    {
        name: 'DeliveryScheduleXID',
        abbrName: 'XID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XID',
        id: 41039,
        description:
            'Identifier for this instance of delivery schedule for cross referencing elsewhere in the message.',
    },
    {
        name: 'DeliveryScheduleNotional',
        abbrName: 'Notl',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 41040,
        description: 'Physical delivery quantity.',
    },
    {
        name: 'DeliveryScheduleNotionalUnitOfMeasure',
        abbrName: 'NotlUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41041,
        description: 'Specifies the delivery quantity unit of measure (UOM).',
    },
    {
        name: 'DeliveryScheduleNotionalCommodityFrequency',
        abbrName: 'NotlFreq',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'StreamNotionalCommodityFrequencyCodeSet',
        id: 41042,
        description: 'The frequency of notional delivery.',
    },
    {
        name: 'DeliveryScheduleNegativeTolerance',
        abbrName: 'NegtvTlrnc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 41043,
        description:
            'Specifies the negative tolerance value. The value may be an absolute quantity or a percentage, as specified in DeliveryScheduleToleranceType(41046). Percentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%).',
    },
    {
        name: 'DeliverySchedulePositiveTolerance',
        abbrName: 'PostvTlrnc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 41044,
        description:
            'Specifies the positive tolerance value. The value may be an absolute quantity or a percentage, as specified in DeliveryScheduleToleranceType(41046). Value may exceed agreed upon value. Percentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%).',
    },
    {
        name: 'DeliveryScheduleToleranceUnitOfMeasure',
        abbrName: 'TlrncUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41045,
        description: "Specifies the tolerance value's unit of measure (UOM).",
    },
    {
        name: 'DeliveryScheduleToleranceType',
        abbrName: 'TlrncTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryScheduleToleranceTypeCodeSet',
        id: 41046,
        description: 'Specifies the tolerance value type.',
    },
    {
        name: 'DeliveryScheduleSettlCountry',
        abbrName: 'Ctry',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Country',
        id: 41047,
        description: 'Specifies the country where delivery takes place. Uses ISO 3166 2-character country code.',
    },
    {
        name: 'DeliveryScheduleSettlTimeZone',
        abbrName: 'TZ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41048,
        description:
            'Delivery timezone specified as "prevailing" rather than "standard" or "daylight".\n\nSee http://www.fixtradingcommunity.org/codelists#Prevailing_Timezones for code list of applicable prevailing timezones.',
    },
    {
        name: 'DeliveryScheduleSettlFlowType',
        abbrName: 'FlowTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryScheduleSettlFlowTypeCodeSet',
        updatedEP: '179',
        id: 41049,
        description: 'Specifies the commodity delivery flow type.',
    },
    {
        name: 'DeliveryScheduleSettlHolidaysProcessingInstruction',
        abbrName: 'Holidays',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryScheduleSettlHolidaysProcessingInstructionCodeSet',
        id: 41050,
        description:
            'Indicates whether holidays are included in the settlement periods. Required for electricity contracts.',
    },
    {
        name: 'NoDeliveryScheduleSettlDays',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41051,
        description: 'Number of delivery schedules in the repeating group.',
    },
    {
        name: 'DeliveryScheduleSettlDay',
        abbrName: 'Day',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryScheduleSettlDayCodeSet',
        id: 41052,
        description: 'Specifies the day or group of days for delivery.',
    },
    {
        name: 'DeliveryScheduleSettlTotalHours',
        abbrName: 'TotHrs',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41053,
        description: 'The sum of the total hours specified in the DeliveryScheduleSettlTimeGrp component.',
    },
    {
        name: 'NoDeliveryScheduleSettlTimes',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41054,
        description: 'Number of hour ranges in the repeating group.',
    },
    {
        name: 'DeliveryScheduleSettlStart',
        abbrName: 'Start',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41055,
        description:
            'The scheduled start time for the delivery of the commodity where delivery occurs over specified times. The format of the time value is specified in DeliveryScheduleSettlTimeType(41057).',
    },
    {
        name: 'DeliveryScheduleSettlEnd',
        abbrName: 'End',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41056,
        description:
            'The scheduled end time for the delivery of the commodity where delivery occurs over specified times. The format of the time value is specified in DeliveryScheduleSettlTimeType(41057).',
    },
    {
        name: 'DeliveryScheduleSettlTimeType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryScheduleSettlTimeTypeCodeSet',
        id: 41057,
        description: 'Specifies the format of the delivery start and end time values.',
    },
    {
        name: 'DeliveryStreamType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryStreamTypeCodeSet',
        id: 41058,
        description: 'Specifies the type of delivery stream.',
    },
    {
        name: 'DeliveryStreamPipeline',
        abbrName: 'Ppln',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41059,
        description: 'The name of the oil delivery pipeline.',
    },
    {
        name: 'DeliveryStreamEntryPoint',
        abbrName: 'EntryPnt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41060,
        description: 'The point at which the commodity will enter the delivery mechanism or pipeline.',
    },
    {
        name: 'DeliveryStreamWithdrawalPoint',
        abbrName: 'WthdrwlPnt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41061,
        description: 'The point at which the commodity product will be withdrawn prior to delivery.',
    },
    {
        name: 'DeliveryStreamDeliveryPoint',
        abbrName: 'DlvryPnt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41062,
        discriminatorId: '42192',
        description:
            'The point at which the commodity product will be delivered and received. Value specified should follow market convention appropriate for the commodity product.\n\nFor bullion, see http://www.fpml.org/coding-scheme/bullion-delivery-location for values.',
    },
    {
        name: 'DeliveryStreamDeliveryRestriction',
        abbrName: 'DlvryRstctn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryStreamDeliveryRestrictionCodeSet',
        id: 41063,
        description:
            'Specifies under what conditions the buyer and seller should be excused of their delivery obligations.',
    },
    {
        name: 'DeliveryStreamDeliveryContingency',
        abbrName: 'Cntgncy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41064,
        description:
            'Specifies the electricity delivery contingency.\n\nSee http://www.fpml.org/coding-scheme/electricity-transmission-contingency for values.',
    },
    {
        name: 'DeliveryStreamDeliveryContingentPartySide',
        abbrName: 'CntgPty',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryStreamElectingPartySideCodeSet',
        id: 41065,
        description: 'The trade side value of the party responsible for electricity delivery contingency.',
    },
    {
        name: 'DeliveryStreamDeliverAtSourceIndicator',
        abbrName: 'DlvrAtSrc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 41066,
        description:
            "When this element is specified and set to 'Y', delivery of the coal product is to be at its source.",
    },
    {
        name: 'DeliveryStreamRiskApportionment',
        abbrName: 'RiskApprtnmt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41067,
        discriminatorId: '41218',
        description:
            'Specifies how the parties to the trade apportion responsibility for the delivery of the commodity product.\n\nSee http://www.fixtradingcommunity.org/codelists#Risk_Apportionment for the details of the external code list.',
    },
    {
        name: 'DeliveryStreamRiskApportionmentSource',
        abbrName: 'RiskApprtnmtSrc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41218,
        description:
            'Specifies the source or legal framework for the risk apportionment.\n\nSee http://www.fixtradingcommunity.org/codelists#Risk_Apportionment_Source for the details of the external code list.',
    },
    {
        name: 'DeliveryStreamTitleTransferLocation',
        abbrName: 'TtlXfer',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41068,
        description: 'Specifies the title transfer location.',
    },
    {
        name: 'DeliveryStreamTitleTransferCondition',
        abbrName: 'TtlXferCond',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryStreamTitleTransferConditionCodeSet',
        id: 41069,
        description: 'Specifies the condition of title transfer.',
    },
    {
        name: 'DeliveryStreamImporterOfRecord',
        abbrName: 'Imprtr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41070,
        description:
            'A party, not necessarily of the trade, who is the Importer of Record for the purposes of paying customs duties and applicable taxes or costs related to importation.',
    },
    {
        name: 'DeliveryStreamNegativeTolerance',
        abbrName: 'NegtvTlrnc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 41071,
        description:
            'Specifies the negative tolerance value. The value may be an absolute quantity or a percentage, as specified in DeliveryStreamToleranceType(41074). Percentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%).',
    },
    {
        name: 'DeliveryStreamPositiveTolerance',
        abbrName: 'PostvTlrnc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 41072,
        description:
            'Specifies the positive tolerance value. The value may be an absolute quantity or a percentage, as specified in DeliveryStreamToleranceType(41074). Value may exceed agreed upon value. Percentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%).',
    },
    {
        name: 'DeliveryStreamToleranceUnitOfMeasure',
        abbrName: 'TlrncUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41073,
        description: "Specifies the tolerance value's unit of measure (UOM).",
    },
    {
        name: 'DeliveryStreamToleranceType',
        abbrName: 'TlrncTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryScheduleToleranceTypeCodeSet',
        id: 41074,
        description: 'Specifies the tolerance value type.',
    },
    {
        name: 'DeliveryStreamToleranceOptionSide',
        abbrName: 'TlrncOptSide',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryStreamToleranceOptionSideCodeSet',
        id: 41075,
        description: "Indicates whether the tolerance is at the seller's or buyer's option.",
    },
    {
        name: 'DeliveryStreamTotalPositiveTolerance',
        abbrName: 'TotPostvTlrnc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 41076,
        description:
            'The positive percent tolerance which applies to the total quantity delivered over all shipment periods.\n\nPercentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%.).',
    },
    {
        name: 'DeliveryStreamTotalNegativeTolerance',
        abbrName: 'TotNegtvTlrnc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 41077,
        description:
            'The negative percent tolerance which applies to the total quantity delivered over all shipment periods.\n\nPercentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%.).',
    },
    {
        name: 'DeliveryStreamNotionalConversionFactor',
        abbrName: 'CnvrsnFctr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 41078,
        description:
            'If the notional quantity is specified in a unit that does not match the unit in which the commodity reference price is quoted, the scaling or conversion factor used to convert the commodity reference price unit into the notional quantity unit should be stated here. If there is no conversion, this field is not intended to be used.',
    },
    {
        name: 'DeliveryStreamTransportEquipment',
        abbrName: 'Eqpmt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41079,
        description:
            'The transportation equipment with which the commodity product will be delivered and received.\n\nExamples of transportation equipment or mode are barge, truck, railcar, etc.',
    },
    {
        name: 'DeliveryStreamElectingPartySide',
        abbrName: 'ElctngSide',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryStreamElectingPartySideCodeSet',
        id: 41080,
        description:
            'A reference to the party able to choose whether the gas is delivered for a particular period as found in a swing or interruptible contract.',
    },
    {
        name: 'NoDeliveryStreamCycles',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41081,
        description: 'Number of delivery cycles in the repeating group.',
    },
    {
        name: 'DeliveryStreamCycleDesc',
        abbrName: 'Desc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41082,
        description: 'The delivery cycles during which the oil product will be transported in the pipeline.',
    },
    {
        name: 'EncodedDeliveryStreamCycleDescLen',
        abbrName: 'EncDescLen',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 41083,
        description: 'Byte length of encoded (non-ASCII characters) EncodedDeliveryStreamCycleDesc(41084) field.',
    },
    {
        name: 'EncodedDeliveryStreamCycleDesc',
        abbrName: 'EncDesc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 41084,
        lengthId: '41083',
        description:
            'Encoded (non-ASCII characters) representation of the DeliveryStreamCycleDesc(41082) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the DeliveryStreamCycleDesc(41082) field.',
    },
    {
        name: 'NoDeliveryStreamCommoditySources',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41085,
        description: 'Number of commodity sources in the repeating group.',
    },
    {
        name: 'DeliveryStreamCommoditySource',
        abbrName: 'Src',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41086,
        description:
            'The SCoTA coal cargo origin, mining region, mine(s), mining complex(es), loadout(s) or river dock(s) or other point(s) of origin that seller and buyer agree are acceptable origins for the coal product. For international coal transactions, this is the origin of the coal product.\n\nSee http://www.fpml.org/coding-scheme/commodity-coal-product-source for values.',
    },
    {
        name: 'DocumentationText',
        abbrName: 'DcmntnTxt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1513,
        description:
            'A sentence or phrase pertenant to the trade, not a reference to an external document. E.g. "To be registered with the U.S. Environmental Protection Agency, Acid Rain Division, SO2 Allowance Tracking System"',
    },
    {
        name: 'EncodedDocumentationTextLen',
        abbrName: 'EncDcmntnTxtLen',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 1525,
        description: 'Byte length of encoded (non-ASCII characters) EncodedDocumentationText(1527) field.',
    },
    {
        name: 'EncodedDocumentationText',
        abbrName: 'EncDcmntnTxt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 1527,
        lengthId: '1525',
        description:
            'Encoded (non-ASCII characters) representation of the DocumentationText(1513) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the DocumentationText(1513) field.',
    },
    {
        name: 'SwapSubClass',
        abbrName: 'SwapSubClss',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'SwapSubClassCodeSet',
        updatedEP: '238',
        id: 1575,
        description: 'The sub-classification or notional schedule type of the swap.',
    },
    {
        name: 'SettlRateIndex',
        abbrName: 'SettlNdx',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1577,
        description:
            'In an outright or forward commodity trade that is cash settled this is the index used to determine the cash payment.',
    },
    {
        name: 'SettlRateIndexLocation',
        abbrName: 'SettlNdxLctn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1580,
        description:
            'This is an optional qualifying attribute of SettlRateIndex(1577) such as the delivery zone for an electricity contract.',
    },
    {
        name: 'OptionExpirationDesc',
        abbrName: 'ExpDesc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1581,
        description: 'Description of the option expiration.',
    },
    {
        name: 'EncodedOptionExpirationDescLen',
        abbrName: 'EncExpDescLen',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 1678,
        description: 'Byte length of encoded (non-ASCII characters) EncodedOptionExpirationDesc(1697) field.',
    },
    {
        name: 'EncodedOptionExpirationDesc',
        abbrName: 'EncExpDesc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 1697,
        lengthId: '1678',
        description:
            'Encoded (non-ASCII characters) representation of the OptionExpirationDesc(1581) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the OptionExpirationDesc(1581).',
    },
    {
        name: 'StrikeUnitOfMeasure',
        abbrName: 'StrkUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 1698,
        description: 'Used to express the unit of measure (UOM) of the price if different from the contract.',
    },
    {
        name: 'StrikeIndex',
        abbrName: 'StrkNdx',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 1866,
        description: 'Specifies the index used to calculate the strike price.',
    },
    {
        name: 'StrikeIndexSpread',
        abbrName: 'StrkSpread',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 2001,
        description: 'Specifies the strike price offset from the named index.',
    },
    {
        name: 'ValuationSource',
        abbrName: 'ValSrc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2002,
        description: 'Specifies the source of trade valuation data.',
    },
    {
        name: 'ValuationReferenceModel',
        abbrName: 'ValRefModel',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2140,
        description: 'Specifies the methodology and/or assumptions used to generate the trade value.',
    },
    {
        name: 'StrategyType',
        abbrName: 'StrtTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'StrategyTypeCodeSet',
        id: 2141,
        description: 'Specifies the type of trade strategy.',
    },
    {
        name: 'CommonPricingIndicator',
        abbrName: 'CmnPxng',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2142,
        description:
            "When this element is specified and set to 'Y', it indicates that common pricing applies. Common pricing may be relevant for a transaction that references more than one commodity reference price.",
    },
    {
        name: 'SettlDisruptionProvision',
        abbrName: 'SettlDsrptnProv',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'SettlDisruptionProvisionCodeSet',
        id: 2143,
        description: 'Specifies the consequences of bullion settlement disruption events.',
    },
    {
        name: 'InstrumentRoundingDirection',
        abbrName: 'RndDirctn',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'RoundingDirectionCodeSet',
        updatedEP: '208',
        id: 2144,
        description: 'Specifies the rounding direction if not overridden elsewhere.',
    },
    {
        name: 'InstrumentRoundingPrecision',
        abbrName: 'RndPrcsn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2145,
        description:
            'Specifies the rounding precision in terms of a number of decimal places. Note how a percentage rate rounding of 5 decimal places is expressed as a rounding precision of 7.',
    },
    {
        name: 'LegSettleOnOpenFlag',
        abbrName: 'SettlOnOpenFlag',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2146,
        description: 'Indicator to determine if the instrument is to settle on open.',
    },
    {
        name: 'LegInstrmtAssignmentMethod',
        abbrName: 'AsgnMeth',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'InstrmtAssignmentMethodCodeSet',
        id: 2147,
        description: 'Specifies the method under which assignment was conducted.',
    },
    {
        name: 'LegSecurityStatus',
        abbrName: 'Status',
        updated: 'FIX.Latest',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'SecurityStatusCodeSet',
        updatedEP: '271',
        id: 2148,
        description: 'Indicates the current state of the leg instrument.',
    },
    {
        name: 'LegRestructuringType',
        abbrName: 'RestrctTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'RestructuringTypeCodeSet',
        id: 2149,
        description:
            'A category of CDS credit event in which the underlying bond experiences a restructuring.\n\nUsed to define a CDS instrument.',
    },
    {
        name: 'LegSeniority',
        abbrName: 'Snrty',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'SeniorityCodeSet',
        id: 2150,
        description:
            'Specifies which issue (underlying bond) will receive payment priority in the event of a default.\n\nUsed to define a CDS instrument.',
    },
    {
        name: 'LegNotionalPercentageOutstanding',
        abbrName: 'NotlPctOut',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 2151,
        description:
            'Indicates the notional percentage of the deal that is still outstanding based on the remaining components of the index.\n\nUsed to calculate the true value of a CDS trade or position.',
    },
    {
        name: 'LegOriginalNotionalPercentageOutstanding',
        abbrName: 'OrigNotlPctOut',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 2152,
        description:
            'Used to reflect the Original value prior to the application of a credit event. See LegNotionalPercentageOutstanding(2151).',
    },
    {
        name: 'LegAttachmentPoint',
        abbrName: 'AttchPnt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 2153,
        description: 'Lower bound percentage of the loss that the tranche can endure.',
    },
    {
        name: 'LegDetachmentPoint',
        abbrName: 'DetchPnt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 2154,
        description: 'Upper bound percentage of the loss the tranche can endure.',
    },
    {
        name: 'LegObligationType',
        abbrName: 'ObligTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ObligationTypeCodeSet',
        id: 2155,
        description: 'Type of reference obligation for credit derivatives contracts.',
    },
    {
        name: 'LegSwapSubClass',
        abbrName: 'SwapSubClss',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'SwapSubClassCodeSet',
        updatedEP: '238',
        id: 2156,
        description: 'The sub-classification or notional schedule type of the swap.',
    },
    {
        name: 'LegNthToDefault',
        abbrName: 'NthDflt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2157,
        description:
            'The Nth reference obligation in a CDS reference basket. If specified without LegMthToDefault(2158) the default will trigger a CDS payout. If LegMthToDefault(2158) is also present then payout occurs between the Nth and Mth obligations to default.',
    },
    {
        name: 'LegMthToDefault',
        abbrName: 'MthDflt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2158,
        description:
            'The Mth reference obligation to default in a CDS reference basket. When an NthToDefault(2157) to MthToDefault(2158) are represented then the CDS payout occurs between the Nth and Mth obligations to default.',
    },
    {
        name: 'LegSettledEntityMatrixSource',
        abbrName: 'SettldMtrxSrc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2159,
        description: 'Relevant settled entity matrix source.',
    },
    {
        name: 'LegSettledEntityMatrixPublicationDate',
        abbrName: 'SettldMtrxDt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 2160,
        description:
            'The publication date of the applicable version of the matrix. When this element is omitted, the Standard Terms Supplement defines rules for which version of the matrix is applicable.',
    },
    {
        name: 'LegCouponType',
        abbrName: 'CpnTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'CouponTypeCodeSet',
        id: 2161,
        description: 'Specifies the coupon type of the bond.',
    },
    {
        name: 'LegTotalIssuedAmount',
        abbrName: 'TotAmt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 2162,
        description:
            'Specifies the total amount of the issue. Corresponds to the par value multiplied by the number of issued security.',
    },
    {
        name: 'LegCouponFrequencyPeriod',
        abbrName: 'CpnPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2163,
        description: "Time unit multiplier for the frequency of the bond's coupon payment.",
    },
    {
        name: 'LegCouponFrequencyUnit',
        abbrName: 'CpnUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'CouponFrequencyUnitCodeSet',
        id: 2164,
        description: "Time unit associated with the frequency of the bond's coupon payment.",
    },
    {
        name: 'LegCouponDayCount',
        abbrName: 'CpnDayCnt',
        unionDataType: 'Reserved100Plus',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'CouponDayCountCodeSet',
        id: 2165,
        description:
            'The day count convention used in interest calculations for a bond or an interest bearing security.',
    },
    {
        name: 'LegConvertibleBondEquityID',
        abbrName: 'CnvrtBondEqtyID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2166,
        discriminatorId: '2167',
        description: 'Identifies the equity in which a convertible bond can be converted to.',
    },
    {
        name: 'LegConvertibleBondEquityIDSource',
        abbrName: 'CnvrtBondEqtyIDSrc',
        unionDataType: 'Reserved100Plus',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'SecurityIDSourceCodeSet',
        id: 2167,
        description: 'Identifies class or source of the LegConvertibleBondEquitySecurityID(2166) value.',
    },
    {
        name: 'LegContractPriceRefMonth',
        abbrName: 'PxRefMo',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'MonthYear',
        id: 2168,
        description:
            'Reference month if there is no applicable LegMaturityMonthYear(610) value for the contract or security.',
    },
    {
        name: 'LegLienSeniority',
        abbrName: 'LienSnrty',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LienSeniorityCodeSet',
        id: 2169,
        description: 'Indicates the seniority level of the lien in a loan.',
    },
    {
        name: 'LegLoanFacility',
        abbrName: 'LoanFclty',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LoanFacilityCodeSet',
        id: 2170,
        description: "Specifies the type of loan when the credit default swap's reference obligation is a loan.",
    },
    {
        name: 'LegReferenceEntityType',
        abbrName: 'RefEntityTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ReferenceEntityTypeCodeSet',
        updatedEP: '192',
        id: 2171,
        description: 'Specifies the type of reference entity for first-to-default CDS basket contracts.',
    },
    {
        name: 'LegIndexSeries',
        abbrName: 'NdxSeries',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2172,
        description: 'The series identifier of a credit default swap index.',
    },
    {
        name: 'LegIndexAnnexVersion',
        abbrName: 'NdxAnxVer',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2173,
        description: 'The version of a credit default swap index annex.',
    },
    {
        name: 'LegIndexAnnexDate',
        abbrName: 'NdxAnxDt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 2174,
        description: 'The date of a credit default swap index series annex.',
    },
    {
        name: 'LegIndexAnnexSource',
        abbrName: 'NdxAnxSrc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2175,
        description: 'The source of a credit default swap series annex.',
    },
    {
        name: 'LegSettlRateIndex',
        abbrName: 'SettlNdx',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2176,
        description:
            'In an outright or forward commodity trade that is cash settled this is the index used to determine the cash payment.',
    },
    {
        name: 'LegSettlRateIndexLocation',
        abbrName: 'SettlNdxLctn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2177,
        description:
            'This is an optional qualifying attribute of LegSettlementRateIndex(2176) such as the delivery zone for an electricity contract.',
    },
    {
        name: 'LegOptionExpirationDesc',
        abbrName: 'ExpDesc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2178,
        description: 'Description of the option expiration.',
    },
    {
        name: 'EncodedLegOptionExpirationDescLen',
        abbrName: 'EncExpDescLen',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 2179,
        description: 'Byte length of encoded (non-ASCII characters) EncodedLegOptionExpirationDesc(2180) field.',
    },
    {
        name: 'EncodedLegOptionExpirationDesc',
        abbrName: 'EncExpDesc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 2180,
        lengthId: '2179',
        description:
            'Encoded (non-ASCII characters) representation of the LegOptionExpirationDesc(2178) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the LegOptionExpirationDesc(2178).',
    },
    {
        name: 'LegStrikeMultiplier',
        abbrName: 'StrkMult',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 2181,
        description:
            'Used for derivatives. Multiplier applied to the strike price for the purpose of calculating the settlement value.',
    },
    {
        name: 'LegStrikeValue',
        abbrName: 'StrkValu',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 2182,
        description:
            'The number of shares/units for the financial instrument involved in the option trade. Used for derivatives.',
    },
    {
        name: 'LegStrikeUnitOfMeasure',
        abbrName: 'StrkUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 2183,
        description: 'Used to express the unit of measure (UOM) of the price if different from the contract.',
    },
    {
        name: 'LegStrikeIndex',
        abbrName: 'StrkNdx',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2184,
        description: 'Specifies the index used to calculate the strike price.',
    },
    {
        name: 'LegStrikeIndexSpread',
        abbrName: 'StrkSpread',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 2185,
        description: 'Specifies the strike price offset from the named index.',
    },
    {
        name: 'LegStrikePriceDeterminationMethod',
        abbrName: 'StrkPxDtrmnMeth',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'StrikePriceDeterminationMethodCodeSet',
        id: 2186,
        description:
            'Specifies how the strike price is determined at the point of option exercise. The strike may be fixed throughout the life of the option, set at expiration to the value of the underlying, set to the average value of the underlying , or set to the optimal value of the underlying.',
    },
    {
        name: 'LegStrikePriceBoundaryMethod',
        abbrName: 'StrkPxBndryMeth',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'StrikePriceBoundaryMethodCodeSet',
        id: 2187,
        description:
            'Specifies the boundary condition to be used for the strike price relative to the underlying price at the point of option exercise.',
    },
    {
        name: 'LegStrikePriceBoundaryPrecision',
        abbrName: 'StrkPxBndryPrcsn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 2188,
        description:
            'Used in combination with StrikePriceBoundaryMethod(2187) to specify the percentage of the strike price in relation to the underlying price. The percentage is generally 100 or greater for puts and 100 or less for calls.',
    },
    {
        name: 'LegUnderlyingPriceDeterminationMethod',
        abbrName: 'PxDtrmnMeth',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnderlyingPriceDeterminationMethodCodeSet',
        id: 2189,
        description:
            'Specifies how the underlying price is determined at the point of option exercise. The underlying price may be set to the current settlement price, set to a special reference, set to the optimal value of the underlying during the defined period ("Look-back") or set to the average value of the underlying during the defined period ("Asian option").',
    },
    {
        name: 'LegMinPriceIncrement',
        abbrName: 'MinPxIncr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 2190,
        description:
            'Minimum price increment for a given exchange-traded instrument. Could also be used to represent tick value.',
    },
    {
        name: 'LegMinPriceIncrementAmount',
        abbrName: 'MinPxIncrAmt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 2191,
        description:
            'Minimum price increment amount associated with the LegMinPriceIncrement(2190). For listed derivatives, the value can be calculated by multiplying LegMinPriceIncrement(2190) by LegContractMultiplier(614).',
    },
    {
        name: 'LegSettlMethod',
        abbrName: 'SettlMeth',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'SettlMethodCodeSet',
        updatedEP: '208',
        id: 2192,
        description:
            'Settlement method for a contract or instrument. Additional values may be used with bilateral agreement.',
    },
    {
        name: 'LegOptPayoutType',
        abbrName: 'OptPayoutTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'OptPayoutTypeCodeSet',
        updatedEP: '238',
        id: 2193,
        description: 'Indicates the type of valuation method or trigger payout for an in-the-money option.',
    },
    {
        name: 'LegOptPayoutAmount',
        abbrName: 'OptPayAmt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 2194,
        description:
            'Cash amount indicating the pay out associated with an option. For binary options this is a fixed amount.',
    },
    {
        name: 'LegPriceQuoteMethod',
        abbrName: 'PxQteMeth',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PriceQuoteMethodCodeSet',
        id: 2195,
        description: 'Specifies the method for price quotation.',
    },
    {
        name: 'LegValuationMethod',
        abbrName: 'ValMeth',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ValuationMethodCodeSet',
        id: 2196,
        description: 'Specifies the type of valuation method applied.',
    },
    {
        name: 'LegValuationSource',
        abbrName: 'ValSrc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2197,
        description: 'Specifies the source of trade valuation data.',
    },
    {
        name: 'LegValuationReferenceModel',
        abbrName: 'ValRefModel',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2198,
        description: 'Specifies the methodology and/or assumptions used to generate the trade value.',
    },
    {
        name: 'LegListMethod',
        abbrName: 'ListMeth',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ListMethodCodeSet',
        id: 2199,
        description: 'Indicates whether instruments are pre-listed only or can also be defined via user request.',
    },
    {
        name: 'LegCapPrice',
        abbrName: 'CapPx',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 2200,
        description: 'Used to express the ceiling price of a capped call.',
    },
    {
        name: 'LegFloorPrice',
        abbrName: 'FlrPx',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 2201,
        description: 'Used to express the floor price of a capped put.',
    },
    {
        name: 'LegFlexibleIndicator',
        abbrName: 'FlexInd',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2202,
        description:
            'Used to indicate a derivatives security that can be defined using flexible terms. The terms commonly permitted to be defined by market participants are expiration date and strike price. FlexibleIndicator is an alternative to LegCFICode(608) Standard/Non-standard attribute.',
    },
    {
        name: 'LegFlexProductEligibilityIndicator',
        abbrName: 'FlexProdElig',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2203,
        description: 'Used to indicate if a product or group of product supports the creation of flexible securities.',
    },
    {
        name: 'LegPositionLimit',
        abbrName: 'PosLmt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2205,
        description: 'Position Limit for a given exchange-traded product.',
    },
    {
        name: 'LegNTPositionLimit',
        abbrName: 'NTPosLmt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2206,
        description: 'Position limit in the near-term contract for a given exchange-traded product.',
    },
    {
        name: 'LegCPProgram',
        abbrName: 'CPPgm',
        unionDataType: 'Reserved100Plus',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'CPProgramCodeSet',
        id: 2207,
        description: 'The program under which a commercial paper is issued.',
    },
    {
        name: 'LegCPRegType',
        abbrName: 'CPRegTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2208,
        description: 'The registration type of a commercial paper issuance.',
    },
    {
        name: 'LegShortSaleRestriction',
        abbrName: 'ShrtRstctn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ShortSaleRestrictionCodeSet',
        id: 2209,
        description: 'Indicates whether a restriction applies to short selling a security.',
    },
    {
        name: 'LegStrategyType',
        abbrName: 'StrtTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'StrategyTypeCodeSet',
        id: 2211,
        description: 'Specifies the type of trade strategy.',
    },
    {
        name: 'LegCommonPricingIndicator',
        abbrName: 'CmnPxng',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2212,
        description:
            "When this element is specified and set to 'Y', it indicates that common pricing applies. Common pricing may be relevant for a transaction that references more than one commodity reference price.",
    },
    {
        name: 'LegSettlDisruptionProvision',
        abbrName: 'SettlDsrptnProv',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'SettlDisruptionProvisionCodeSet',
        id: 2213,
        description: 'Specifies the consequences of bullion settlement disruption events.',
    },
    {
        name: 'LegInstrumentRoundingDirection',
        abbrName: 'RndDirctn',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'RoundingDirectionCodeSet',
        updatedEP: '208',
        id: 2214,
        description:
            'Specifies the rounding direction if not overridden elsewhere.\n\nApplicable for complex FX option strategies.',
    },
    {
        name: 'LegInstrumentRoundingPrecision',
        abbrName: 'RndPrcsn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2215,
        description:
            'Specifies the rounding precision in terms of a number of decimal places. Note how a percentage rate rounding of 5 decimal places is expressed as a rounding precision of 7.',
    },
    {
        name: 'MarketDisruptionProvision',
        abbrName: 'Prov',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'MarketDisruptionProvisionCodeSet',
        id: 41087,
        description: 'The consequences of market disruption events.',
    },
    {
        name: 'MarketDisruptionFallbackProvision',
        abbrName: 'FallbckProv',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'MarketDisruptionFallbackProvisionCodeSet',
        id: 41088,
        description: 'Specifies the location of the fallback provision documentation.',
    },
    {
        name: 'MarketDisruptionMaximumDays',
        abbrName: 'MaxDays',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41089,
        description:
            'Specifies the maximum number of market disruption days (commodity or bullion business days) in a contract or confirmation. If none are specified, the maximum number of market disruption days is five (5).\n\nISDA 2005 Commodity Definition.',
    },
    {
        name: 'MarketDisruptionMaterialityPercentage',
        abbrName: 'MtrltyPctage',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 41090,
        description:
            'Used when a price materiality percentage applies to the price source disruption event and this event has been specified.\n\nApplicable to 2005 Commodity Definitions only.',
    },
    {
        name: 'MarketDisruptionMinimumFuturesContracts',
        abbrName: 'MinCtrcts',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41091,
        description:
            "Specifies the minimum futures contracts level that dictates whether or not a 'De Minimis Trading' event has occurred.\n\nApplicable to 1993 Commodity Definitions only.",
    },
    {
        name: 'NoMarketDisruptionEvents',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41092,
        description: 'Number of disruption events in the repeating group.',
    },
    {
        name: 'MarketDisruptionEvent',
        abbrName: 'Evnt',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        updatedEP: '187',
        id: 41093,
        description:
            'Specifies the market disruption event.\n\nFor commodities see http://www.fpml.org/coding-scheme/commodity-market-disruption for values.\n\nFor foreign exchange, see http://www.fixtradingcommunity.org/codelists#Market_Disruption_Event for code list of applicable event types.',
    },
    {
        name: 'NoMarketDisruptionFallbacks',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41094,
        description: 'Number of fallbacks in the repeating group.',
    },
    {
        name: 'MarketDisruptionFallbackType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41095,
        description:
            'Specifies the type of disruption fallback.\n\nSee http://www.fpml.org/coding-scheme/commodity-market-disruption-fallback for values.',
    },
    {
        name: 'NoMarketDisruptionFallbackReferencePrices',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41096,
        description: 'Number of fallback reference securities in the repeating group.',
    },
    {
        name: 'MarketDisruptionFallbackUnderlierType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'MarketDisruptionFallbackUnderlierTypeCodeSet',
        id: 41097,
        description: 'The type of reference price underlier.',
    },
    {
        name: 'MarketDisruptionFallbackUnderlierSecurityID',
        abbrName: 'ID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41098,
        discriminatorId: '41099',
        description: 'Specifies the identifier value of the security.',
    },
    {
        name: 'MarketDisruptionFallbackUnderlierSecurityIDSource',
        abbrName: 'Src',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.Latest',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'SecurityIDSourceCodeSet',
        updatedEP: '265',
        id: 41099,
        description: 'Specifies the class or source scheme of the security identifier.',
    },
    {
        name: 'MarketDisruptionFallbackUnderlierSecurityDesc',
        abbrName: 'Desc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41100,
        description: 'Specifies the description of the underlying security.',
    },
    {
        name: 'EncodedMarketDisruptionFallbackUnderlierSecurityDescLen',
        abbrName: 'EncDescLen',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 41101,
        description:
            'Byte length of encoded (non-ASCII characters) EncodedMarketDisruptionFallbackUnderlierSecurityDesc(41102) field.',
    },
    {
        name: 'EncodedMarketDisruptionFallbackUnderlierSecurityDesc',
        abbrName: 'EncDesc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 41102,
        lengthId: '41101',
        description:
            'Encoded (non-ASCII characters) representation of the MarketDisruptionFallbackUnderlierSecurityDesc(41100) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the MarketDisruptionFallbackUnderlierSecurityDesc(41100) field.',
    },
    {
        name: 'MarketDisruptionFallbackOpenUnits',
        abbrName: 'OpnUnits',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 41103,
        description:
            'If there are multiple underlying assets, this specifies the number of units (index or securities) that constitute the underlier of the swap. In the case of a basket swap, this is used to reference both the number of basket units, and the number of each asset components of the basket when these are expressed in absolute terms.',
    },
    {
        name: 'MarketDisruptionFallbackBasketCurrency',
        abbrName: 'Ccy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41104,
        description: 'Specifies the currency if the underlier is a basket. Uses ISO 4217 currency codes.',
    },
    {
        name: 'MarketDisruptionFallbackBasketDivisor',
        abbrName: 'Dvsr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 41105,
        description:
            'Specifies the basket divisor amount. This value is normally used to adjust the constituent weight for pricing or to adjust for dividends, or other corporate actions.',
    },
    {
        name: 'MiscFeeRate',
        abbrName: 'Rt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 2216,
        description: 'The fee rate when MiscFeeAmt(137) is a percentage of trade quantity.',
    },
    {
        name: 'MiscFeeAmountDue',
        abbrName: 'AmtDue',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 2217,
        description: 'The fee amount due if different from MiscFeeAmt(137).',
    },
    {
        name: 'ExerciseDesc',
        abbrName: 'Desc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41106,
        description: 'A description of the option exercise.',
    },
    {
        name: 'EncodedExerciseDescLen',
        abbrName: 'EncDescLen',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 41107,
        description: 'Byte length of encoded (non-ASCII characters) EncodedExerciseDesc(41102) field.',
    },
    {
        name: 'EncodedExerciseDesc',
        abbrName: 'EncDesc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 41108,
        lengthId: '41107',
        description:
            'Encoded (non-ASCII characters) representation of the ExerciseDesc(41106) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the ExerciseDesc(41106) field.',
    },
    {
        name: 'AutomaticExerciseIndicator',
        abbrName: 'AutoExerInd',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 41109,
        description:
            "Indicates (when 'Y') that exercise is automatic when the strike price is crossed or the underlying trade is in the money.",
    },
    {
        name: 'AutomaticExerciseThresholdRate',
        abbrName: 'AutoRt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 41110,
        description: 'The threshold rate for triggering automatic exercise.',
    },
    {
        name: 'ExerciseConfirmationMethod',
        abbrName: 'ExerCnfm',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ExerciseConfirmationMethodCodeSet',
        id: 41111,
        description:
            "Indicates whether follow-up confirmation of exercise (written or electronic) is required following telephonic notice by the buyer to the seller or seller's agent.",
    },
    {
        name: 'ManualNoticeBusinessCenter',
        abbrName: 'ManNtcBizCtr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41112,
        description:
            'Identifies the business center used for adjusting the time for manual exercise notice.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'FallbackExerciseIndicator',
        abbrName: 'FallbckExerInd',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 41113,
        description:
            'Indicates whether the notional amount of the underlying swap, not previously exercised under the option, will be automatically exercised at the expiration time on the expiration date if at such time the buyer is in-the-money, provided that the difference between the settlement rate and the fixed rate under the relevant underlying swap is not less than one tenth of a percentage point (0.10% or 0.001).',
    },
    {
        name: 'LimitedRightToConfirmIndicator',
        abbrName: 'LtdRightCnfmInd',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 41114,
        description:
            'Indicates whether the Seller may request the Buyer to confirm its intent to exercise if not done on or before the expiration time on the expiration date. If true ("Y") specific rules will apply in relation to the settlement mode.',
    },
    {
        name: 'ExerciseSplitTicketIndicator',
        abbrName: 'ExerSplitTktInd',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 41115,
        description:
            'Indicates in physical settlement of bond and convertible bond options whether the party required to deliver the bonds will divide those to be delivered as notifying party desires to facilitate delivery obligations.',
    },
    {
        name: 'NoOptionExerciseBusinessCenters',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41116,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'OptionExerciseBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41117,
        description:
            'The business center calendar used to adjust the option exercise dates, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'OptionExerciseBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 41118,
        description:
            'The business day convention used to adjust the option exercise dates. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.',
    },
    {
        name: 'OptionExerciseEarliestDateOffsetDayType',
        abbrName: 'ErlstOfstDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 41119,
        description: 'Specifies the day type of the relative earliest option exercise date offset.',
    },
    {
        name: 'OptionExerciseEarliestDateOffsetPeriod',
        abbrName: 'ErlstOfstPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41120,
        description: 'Time unit multiplier for the relative earliest exercise date offset.',
    },
    {
        name: 'OptionExerciseEarliestDateOffsetUnit',
        abbrName: 'ErlstOfstUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ProvisionOptionExerciseEarliestDateOffsetUnitCodeSet',
        id: 41121,
        description: 'Time unit associated with the relative earliest exercise date offset.',
    },
    {
        name: 'OptionExerciseFrequencyPeriod',
        abbrName: 'FreqPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41122,
        description: 'Time unit multiplier for the frequency of exercise dates.',
    },
    {
        name: 'OptionExerciseFrequencyUnit',
        abbrName: 'FreqUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ProtectionTermEventUnitCodeSet',
        id: 41123,
        description: 'Time unit associated with the frequency of exercise dates.',
    },
    {
        name: 'OptionExerciseStartDateUnadjusted',
        abbrName: 'StartDtUnadj',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41124,
        description: 'The unadjusted start date for calculating periodic exercise dates.',
    },
    {
        name: 'OptionExerciseStartDateRelativeTo',
        abbrName: 'StartDtReltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41125,
        description:
            'Specifies the anchor date when the option exercise start date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'OptionExerciseStartDateOffsetPeriod',
        abbrName: 'StartDtOfstPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41126,
        description: 'Time unit multiplier for the relative exercise start date offset.',
    },
    {
        name: 'OptionExerciseStartDateOffsetUnit',
        abbrName: 'StartDtOfstUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 41127,
        description: 'Time unit associated with the relative exercise start date offset.',
    },
    {
        name: 'OptionExerciseStartDateOffsetDayType',
        abbrName: 'StartDtOfstDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 41128,
        description: 'Specifies the day type of the relative option exercise start date offset.',
    },
    {
        name: 'OptionExerciseStartDateAdjusted',
        abbrName: 'StartDt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41129,
        description: 'The adjusted start date for calculating periodic exercise dates.',
    },
    {
        name: 'OptionExerciseSkip',
        abbrName: 'Skip',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41130,
        description:
            'The number of periods in the referenced date schedule that are between each date in the relative date schedule. Thus a skip of 2 would mean that dates are relative to every second date in the referenced schedule. If present this should have a value greater than 1.',
    },
    {
        name: 'OptionExerciseNominationDeadline',
        abbrName: 'NomntnDdln',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41131,
        description: 'Last date (adjusted) for establishing the option exercise terms.',
    },
    {
        name: 'OptionExerciseFirstDateUnadjusted',
        abbrName: 'FirstDtUnadj',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41132,
        description: 'The unadjusted first exercise date.',
    },
    {
        name: 'OptionExerciseLastDateUnadjusted',
        abbrName: 'LastDtUnadj',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41133,
        description: 'The unadjusted last exercise date.',
    },
    {
        name: 'OptionExerciseEarliestTime',
        abbrName: 'ErlstTm',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 41134,
        description:
            "The earliest time at which notice of exercise can be given by the buyer to the seller (or seller's agent) (i) on the expriation date, in the case of a European style option, (ii) on each Bermuda option exercise date and the expiration date, in the case of a Bermuda style option, (iii) the commencement date to, and including, the expiration date, in the case of an American option.",
    },
    {
        name: 'OptionExerciseLatestTime',
        abbrName: 'LtstTm',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 41135,
        description: 'The latest exercise time. See also OptionExerciseEarliestTime(41134).',
    },
    {
        name: 'OptionExerciseTimeBusinessCenter',
        abbrName: 'TmBizCtr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41136,
        description:
            'The business center used to determine the locale for option exercise time, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values',
    },
    {
        name: 'NoOptionExerciseDates',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41137,
        description: 'Number of dates in the repeating group.',
    },
    {
        name: 'OptionExerciseDate',
        abbrName: 'Dt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41138,
        description:
            'The option exercise fixed date, unadjusted or adjusted depending on OptionExerciseDateType(41139).',
    },
    {
        name: 'OptionExerciseDateType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'OptionExerciseDateTypeCodeSet',
        id: 41139,
        description:
            'Specifies the type of date. When specified it applies not only to the current date but to all subsequent dates in the group until overridden with a new type.',
    },
    {
        name: 'NoOptionExerciseExpirationDateBusinessCenters',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41140,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'OptionExerciseExpirationDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41141,
        description:
            'The business center calendar used to adjust the option exercise expiration dates, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'OptionExerciseExpirationDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 41142,
        description:
            'The business day convention used to adjust the option exercise expiration dates. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.',
    },
    {
        name: 'OptionExerciseExpirationDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 41143,
        description:
            'Specifies the anchor date when the option exercise expiration date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'OptionExerciseExpirationDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41144,
        description: 'Time unit multiplier for the relative exercise expiration date offset.',
    },
    {
        name: 'OptionExerciseExpirationDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 41145,
        description: 'Time unit associated with the relative exercise expiration date offset.',
    },
    {
        name: 'OptionExerciseExpirationFrequencyPeriod',
        abbrName: 'FreqPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41146,
        description: 'Time unit multiplier for the frequency of exercise expiration dates.',
    },
    {
        name: 'OptionExerciseExpirationFrequencyUnit',
        abbrName: 'FreqUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ProtectionTermEventUnitCodeSet',
        id: 41147,
        description: 'Time unit associated with the frequency of exercise expiration dates.',
    },
    {
        name: 'OptionExerciseExpirationRollConvention',
        abbrName: 'Roll',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DateRollConventionCodeSet',
        id: 41148,
        description:
            'The convention for determining the sequence of exercise expiration dates. It is used in conjunction with a specified frequency. Used only to override the roll convention defined in the DateAdjustment component in Instrument.',
    },
    {
        name: 'OptionExerciseExpirationDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 41149,
        description: 'Specifies the day type of the relative option exercise expiration date offset.',
    },
    {
        name: 'OptionExerciseExpirationTime',
        abbrName: 'Tm',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 41150,
        description: 'The option exercise expiration time.',
    },
    {
        name: 'OptionExerciseExpirationTimeBusinessCenter',
        abbrName: 'TmBizCtr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41151,
        description:
            'The business center used to determine the locale for option exercise expiration time, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'NoOptionExerciseExpirationDates',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41152,
        description: 'Number of fixed exercise expiration dates in the repeating group.',
    },
    {
        name: 'OptionExerciseExpirationDate',
        abbrName: 'Dt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41153,
        description: 'An adjusted or unadjusted fixed option exercise expiration date.',
    },
    {
        name: 'OptionExerciseExpirationDateType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'OptionExerciseDateTypeCodeSet',
        id: 41154,
        description:
            'Specifies the type of option exercise expiration date. When specified it applies not only to the current date but to all subsequent dates in the group until overridden with a new type.',
    },
    {
        name: 'PaymentUnitOfMeasure',
        abbrName: 'UOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41155,
        description:
            'Used to express the unit of measure (UOM) of the payment amount if not in the currency of the trade.',
    },
    {
        name: 'PaymentDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 41156,
        description:
            'Specifies the anchor date when the payment date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'PaymentDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41157,
        description: 'Time unit multiplier for the relative payment date offset.',
    },
    {
        name: 'PaymentDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 41158,
        description: 'Time unit associated with the relative payment date offset.',
    },
    {
        name: 'PaymentDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 41159,
        description: 'Specifies the day type of the relative payment date offset.',
    },
    {
        name: 'PaymentForwardStartType',
        abbrName: 'FwdStartTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentForwardStartTypeCodeSet',
        id: 41160,
        description: 'Forward start premium type.',
    },
    {
        name: 'NoPaymentScheduleFixingDays',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41161,
        description: 'Number of fixing days in the repeating group.',
    },
    {
        name: 'PaymentScheduleFixingDayOfWeek',
        abbrName: 'DayOfWk',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPricingDayOfWeekCodeSet',
        id: 41162,
        description: 'The day of the week on which fixing will take place.',
    },
    {
        name: 'PaymentScheduleFixingDayNumber',
        abbrName: 'DayNum',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41163,
        description:
            'The occurrence of the day of week on which fixing takes place.\n\nFor example, a fixing of the 3rd Friday would be DayOfWk=5 DayNum=3. If omitted every day of the week is a fixing day.',
    },
    {
        name: 'PaymentScheduleXID',
        abbrName: 'XID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XID',
        id: 41164,
        description: 'Identifier of this PaymentSchedule for cross referencing elsewhere in the message.',
    },
    {
        name: 'PaymentScheduleXIDRef',
        abbrName: 'XIDRef',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XIDREF',
        id: 41165,
        description: 'Reference to payment schedule elsewhere in the message.',
    },
    {
        name: 'PaymentScheduleRateCurrency',
        abbrName: 'RtCcy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41166,
        description: 'The currency of the schedule rate. Uses ISO 4217 currency codes.',
    },
    {
        name: 'PaymentScheduleRateUnitOfMeasure',
        abbrName: 'RtUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41167,
        description: 'The schedule rate unit of measure (UOM).',
    },
    {
        name: 'PaymentScheduleRateConversionFactor',
        abbrName: 'RtFctr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 41168,
        description:
            'The number to be multiplied by the derived floating rate of the payment schedule in order to arrive at the payment rate. If omitted, the schedule rate conversion factor is 1.',
    },
    {
        name: 'PaymentScheduleRateSpreadType',
        abbrName: 'SpreadTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateSpreadTypeCodeSet',
        id: 41169,
        description:
            'Identifies whether the rate spread is an absolute value to be added to the index rate or a percentage of the index rate.',
    },
    {
        name: 'PaymentScheduleSettlPeriodPrice',
        abbrName: 'SettlPx',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 41170,
        description: 'The schedule settlement period price.',
    },
    {
        name: 'PaymentScheduleSettlPeriodPriceCurrency',
        abbrName: 'SettlPxCcy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41171,
        description: 'Specifies the currency of the schedule settlement period price. Uses ISO 4217 currency codes.',
    },
    {
        name: 'PaymentScheduleSettlPeriodPriceUnitOfMeasure',
        abbrName: 'SettlPxUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41172,
        description: 'The settlement period price unit of measure (UOM).',
    },
    {
        name: 'PaymentScheduleStepUnitOfMeasure',
        abbrName: 'StepUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41173,
        description: 'The schedule step unit of measure (UOM).',
    },
    {
        name: 'PaymentScheduleFixingDayDistribution',
        abbrName: 'FixngDayDistrib',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPricingDayDistributionCodeSet',
        id: 41174,
        description: 'The distribution of fixing days.',
    },
    {
        name: 'PaymentScheduleFixingDayCount',
        abbrName: 'FixngDayCnt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41175,
        description: 'The number of days over which fixing should take place.',
    },
    {
        name: 'PaymentScheduleFixingLagPeriod',
        abbrName: 'FixngLagPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41176,
        description: 'Time unit multiplier for the fixing lag duration.',
    },
    {
        name: 'PaymentScheduleFixingLagUnit',
        abbrName: 'FixngLagUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamInflationLagUnitCodeSet',
        id: 41177,
        description: 'Time unit associated with the fixing lag duration.',
    },
    {
        name: 'PaymentScheduleFixingFirstObservationDateOffsetPeriod',
        abbrName: 'FixngFirstObsvtnPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 41178,
        description:
            'Time unit multiplier for the relative first observation date offset.\n\nIf the first observation offset is specified, the observation period will start the specified interval prior to each calculation period - i.e. if the first observation offset is 4 months and the lag duration is 3 months, observations will be taken in months 4, 3 and 2 (but not 1) prior to each calculation period. If no first observation offset is specified, the observation period will end immediately preceding each calculation period.',
    },
    {
        name: 'PaymentScheduleFixingFirstObservationDateOffsetUnit',
        abbrName: 'FixngFirstObsvtnUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 41179,
        description: 'Time unit associated with the relative first observation date offset.',
    },
    {
        name: 'PaymentStreamFlatRateIndicator',
        abbrName: 'FlatRtInd',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 41180,
        description:
            "When this element is specified and set to 'Y', the Flat Rate is the New Worldwide Tanker Nominal Freight Scale for the Freight Index Route taken at the Trade Date of the transaction “Fixed”. If 'N' it is taken on each Pricing Date “Floating”.",
    },
    {
        name: 'PaymentStreamFlatRateAmount',
        abbrName: 'FlatRtAmt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 41181,
        description:
            "Specifies the actual monetary value of the flat rate when PaymentStreamFlatRateIndicator(41180) = 'Y'.",
    },
    {
        name: 'PaymentStreamFlatRateCurrency',
        abbrName: 'FlatRtCcy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41182,
        description: 'Specifies the currency of the actual flat rate. Uses ISO 4217 currency codes.',
    },
    {
        name: 'PaymentStreamMaximumPaymentAmount',
        abbrName: 'MaxPmtAmt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 41183,
        description: 'Specifies the limit on the total payment amount.',
    },
    {
        name: 'PaymentStreamMaximumPaymentCurrency',
        abbrName: 'MaxPmtCcy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41184,
        description: 'Specifies the currency of total payment amount limit. Uses ISO 4217 currency codes.',
    },
    {
        name: 'PaymentStreamMaximumTransactionAmount',
        abbrName: 'MaxTxnAmt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 41185,
        description: 'Specifies the limit on the payment amount that goes out in any particular calculation period.',
    },
    {
        name: 'PaymentStreamMaximumTransactionCurrency',
        abbrName: 'MaxTxnCcy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41186,
        description: 'Specifies the currency of the period payment amount limit. Uses ISO 4217 currency codes.',
    },
    {
        name: 'PaymentStreamFixedAmountUnitOfMeasure',
        abbrName: 'FixedAmtUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41187,
        description: 'Specifies the fixed payment amount unit of measure (UOM).',
    },
    {
        name: 'PaymentStreamTotalFixedAmount',
        abbrName: 'FixedAmt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 41188,
        description: 'Specifies the total fixed payment amount.',
    },
    {
        name: 'PaymentStreamWorldScaleRate',
        abbrName: 'WorldScaleRt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 41189,
        description:
            'The number of Worldscale points for purposes of the calculation of a fixed amount for a wet voyage charter commodity swap.',
    },
    {
        name: 'PaymentStreamContractPrice',
        abbrName: 'CtrctPx',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 41190,
        description:
            'The price per relevant unit for purposes of the calculation of a fixed amount for a dry voyage charter or time charter commodity swap.',
    },
    {
        name: 'PaymentStreamContractPriceCurrency',
        abbrName: 'CtrctPxCcy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41191,
        description: 'Specifies the currency of PaymentStreamContractPrice(41190). Uses ISO 4217 currency codes.',
    },
    {
        name: 'NoPaymentStreamPricingBusinessCenters',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41192,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'PaymentStreamPricingBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41193,
        description:
            'The business center calendar used to adjust the payment stream\'s pricing dates, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'PaymentStreamRateIndex2CurvePeriod',
        abbrName: 'Ndx2Period',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41194,
        description:
            "Secondary time unit multiplier for the payment stream's floating rate index curve.\n\nMay be used for a Forward Rate Agreement (FRA) with an average rate between two curve points.",
    },
    {
        name: 'PaymentStreamRateIndex2CurveUnit',
        abbrName: 'Ndx2Unit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexCurveUnitCodeSet',
        id: 41195,
        description: "Secondary time unit associated with the payment stream's floating rate index curve.",
    },
    {
        name: 'PaymentStreamRateIndexLocation',
        abbrName: 'NdxLctn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41196,
        description: 'Specifies the location of the floating rate index.',
    },
    {
        name: 'PaymentStreamRateIndexLevel',
        abbrName: 'NdxLvl',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 41197,
        description:
            'This is the weather Cooling Degree Days (CDD), Heating Degree Days (HDD) or HDD index level specified as the number of (amount of) weather index units specified by the parties in the related confirmation.',
    },
    {
        name: 'PaymentStreamRateIndexUnitOfMeasure',
        abbrName: 'NdxUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41198,
        description: 'The unit of measure (UOM) of the rate index level.',
    },
    {
        name: 'PaymentStreamSettlLevel',
        abbrName: 'SettlLvl',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamSettlLevelCodeSet',
        id: 41199,
        description: 'Specifies how weather index units are to be calculated.',
    },
    {
        name: 'PaymentStreamReferenceLevel',
        abbrName: 'RefLvl',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 41200,
        description:
            'This is the weather Cooling Degree Days (CDD), Heating Degree Days (HDD) or HDD reference level specified as the number of (amount of) weather index units specified by the parties in the related confirmation.',
    },
    {
        name: 'PaymentStreamReferenceLevelUnitOfMeasure',
        abbrName: 'RefUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41201,
        description: 'The unit of measure (UOM) of the rate reference level.',
    },
    {
        name: 'PaymentStreamReferenceLevelEqualsZeroIndicator',
        abbrName: 'RefLvlZero',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 41202,
        description: "When set to 'Y', it indicates the weather reference level equals zero.",
    },
    {
        name: 'PaymentStreamRateSpreadCurrency',
        abbrName: 'SpreadCcy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41203,
        description: 'Specifies the currency of the floating rate spread. Uses ISO 4217 currency codes.',
    },
    {
        name: 'PaymentStreamRateSpreadUnitOfMeasure',
        abbrName: 'SpreadUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41204,
        description: 'Species the unit of measure (UOM) of the floating rate spread.',
    },
    {
        name: 'PaymentStreamRateConversionFactor',
        abbrName: 'RtFctr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 41205,
        description:
            'The number to be multiplied by the derived floating rate of the payment stream in order to arrive at the payment rate. If omitted, the floating rate conversion factor is 1.',
    },
    {
        name: 'PaymentStreamRateSpreadType',
        abbrName: 'SpreadTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateSpreadTypeCodeSet',
        id: 41206,
        description:
            'Identifies whether the rate spread is an absolute value to be added to the index rate or a percentage of the index rate.',
    },
    {
        name: 'PaymentStreamLastResetRate',
        abbrName: 'LastResetRt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 41207,
        description:
            'The floating rate determined at the most recent reset. The rate is expressed in decimal form, e.g. 5% is represented as 0.05.',
    },
    {
        name: 'PaymentStreamFinalRate',
        abbrName: 'FnlRt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 41208,
        description:
            'The floating rate determined at the final reset. The rate is expressed in decimal form, e.g. 5% is represented as 0.05.',
    },
    {
        name: 'PaymentStreamCalculationLagPeriod',
        abbrName: 'CalcLagPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41209,
        description: 'Time unit multiplier for the calculation lag duration.',
    },
    {
        name: 'PaymentStreamCalculationLagUnit',
        abbrName: 'CalcLagUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamInflationLagUnitCodeSet',
        id: 41210,
        description: 'Time unit associated with the calculation lag duration.',
    },
    {
        name: 'PaymentStreamFirstObservationDateOffsetPeriod',
        abbrName: 'FirstObsvtnOfstPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 41211,
        description:
            'Time unit multiplier for the relative first observation date offset.\n\nIf the first observation offset is specified, the observation period will start the specified interval prior to each calculation period - i.e. if the first observation offset is 4 months and the lag duration is 3 months, observations will be taken in months 4, 3 and 2 (but not 1) prior to each calculation period. If no first observation offset is specified, the observation period will end immediately preceding each calculation period.',
    },
    {
        name: 'PaymentStreamFirstObservationDateOffsetUnit',
        abbrName: 'FirstObsvtnOfstUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 41212,
        description: 'Time unit associated with the relative first observation date offset.',
    },
    {
        name: 'PaymentStreamPricingDayType',
        abbrName: 'PxngDayTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventDateOffsetDayTypeCodeSet',
        id: 41213,
        description: 'Specifies the commodity pricing day type.',
    },
    {
        name: 'PaymentStreamPricingDayDistribution',
        abbrName: 'PxngDayDistrib',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPricingDayDistributionCodeSet',
        id: 41214,
        description: 'The distribution of pricing days.',
    },
    {
        name: 'PaymentStreamPricingDayCount',
        abbrName: 'PxngDayCnt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41215,
        description: 'The number of days over which pricing should take place.',
    },
    {
        name: 'PaymentStreamPricingBusinessCalendar',
        abbrName: 'PxngClndr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41216,
        description:
            'Specifies the business calendar to use for pricing.\n\nSee http://www.fpml.org/coding-scheme/commodity-business-calendar for values.',
    },
    {
        name: 'PaymentStreamPricingBusinessDayConvention',
        abbrName: 'PxngBizDayCnvtn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 41217,
        description:
            "The business day convention used to adjust the payent stream's pricing dates. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.",
    },
    {
        name: 'NoPaymentStreamPaymentDates',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41220,
        description: 'Number of payment dates in the repeating group.',
    },
    {
        name: 'PaymentStreamPaymentDate',
        abbrName: 'Dt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41221,
        description: 'The adjusted or unadjusted fixed stream payment date.',
    },
    {
        name: 'PaymentStreamPaymentDateType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'OptionExerciseDateTypeCodeSet',
        id: 41222,
        description:
            'Specifies the type of payment date. When specified it applies not only to the current date but to all subsequent dates in the group until overridden with a new type.',
    },
    {
        name: 'PaymentStreamMasterAgreementPaymentDatesIndicator',
        abbrName: 'MADts',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 41223,
        description: "When set to 'Y', it indicates that payment dates are specified in the relevant master agreement.",
    },
    {
        name: 'NoPaymentStreamPricingDates',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41224,
        description: 'Number of pricing dates in the repeating group.',
    },
    {
        name: 'PaymentStreamPricingDate',
        abbrName: 'Dt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41225,
        description: 'The adjusted or unadjusted fixed stream pricing date.',
    },
    {
        name: 'PaymentStreamPricingDateType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'OptionExerciseDateTypeCodeSet',
        id: 41226,
        description:
            'Specifies the type of pricing date. When specified it applies not only to the current date but to all subsequent dates in the group until overridden with a new type.',
    },
    {
        name: 'NoPaymentStreamPricingDays',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41227,
        description: 'Number of pricing days in the repeating group.',
    },
    {
        name: 'PaymentStreamPricingDayOfWeek',
        abbrName: 'DayOfWk',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPricingDayOfWeekCodeSet',
        id: 41228,
        description: 'The day of the week on which pricing takes place.',
    },
    {
        name: 'PaymentStreamPricingDayNumber',
        abbrName: 'DayNum',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41229,
        description:
            'The occurrence of the day of week on which pricing takes place.\n\nFor example a pricing day of the 3rd Friday would be DayOfWk=5 DayNum=3.',
    },
    {
        name: 'NoPricingDateBusinessCenters',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41230,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'PricingDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41231,
        description:
            'The business center calendar used to adjust pricing or fixing dates, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'PricingDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41232,
        description: 'The unadjusted pricing or fixing date.',
    },
    {
        name: 'PricingDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 41233,
        description:
            'The business day convention used to adjust pricing or fixing dates. Used only to override the business day convention defined in the DateAdjustment component within the Instrument component.',
    },
    {
        name: 'PricingDateAdjusted',
        abbrName: 'Dt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41234,
        description: 'The adjusted pricing or fixing date.',
    },
    {
        name: 'PricingTime',
        abbrName: 'Tm',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 41235,
        description: 'Specifies the local market time of the pricing or fixing.',
    },
    {
        name: 'PricingTimeBusinessCenter',
        abbrName: 'TmBizCtr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41236,
        description:
            'Specifies the business center for determining the pricing or fixing time. See http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'NoStreamAssetAttributes',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41237,
        description: 'Number of asset attribute entries in the group.',
    },
    {
        name: 'StreamAssetAttributeType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41238,
        description:
            'Specifies the name of the attribute.\n\nSee http://www.fixtradingcommunity.org/codelists#Asset_Attribute_Types for code list of applicable asset attribute types.',
    },
    {
        name: 'StreamAssetAttributeValue',
        abbrName: 'Val',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41239,
        description: 'Specifies the value of the attribute.',
    },
    {
        name: 'StreamAssetAttributeLimit',
        abbrName: 'Lmt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41240,
        description: 'Limit or lower acceptable value of the attribute.',
    },
    {
        name: 'NoStreamCalculationPeriodDates',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41241,
        description: 'Number of calculation period dates in the repeating group.',
    },
    {
        name: 'StreamCalculationPeriodDate',
        abbrName: 'Dt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41242,
        description: 'The adjusted or unadjusted fixed calculation period date.',
    },
    {
        name: 'StreamCalculationPeriodDateType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'OptionExerciseDateTypeCodeSet',
        id: 41243,
        description:
            'Specifies the type of fixed calculation period date. When specified it applies not only to the current date but to all subsequent dates in the group until overridden with a new type.',
    },
    {
        name: 'StreamCalculationPeriodDatesXID',
        abbrName: 'XID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XID',
        id: 41244,
        description: 'Identifier of this calculation period for cross referencing elsewhere in the message.',
    },
    {
        name: 'StreamCalculationPeriodDatesXIDRef',
        abbrName: 'XIDRef',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XIDREF',
        id: 41245,
        description: 'Cross reference to another calculation period for duplicating its properties.',
    },
    {
        name: 'StreamCalculationBalanceOfFirstPeriod',
        abbrName: 'BalFirst',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 41246,
        description:
            "When specified and set to 'Y', it indicates that the first calculation period should run from the effective date to the end of the calendar period in which the effective date falls (e.g. Jan 15 - Jan 31 if the calculation periods are one month long and effective date is Jan 15.). If 'N' or not specified, it indicates that the first calculation period should run from the effective date for one whole period (e.g. Jan 15 to Feb 14 if the calculation periods are one month long and the effective date is Jan 15.).",
    },
    {
        name: 'StreamCalculationCorrectionPeriod',
        abbrName: 'CrrctnPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41247,
        description:
            'Time unit multiplier for the length of time after the publication of the data when corrections can be made.',
    },
    {
        name: 'StreamCalculationCorrectionUnit',
        abbrName: 'CrrctnUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ProtectionTermEventUnitCodeSet',
        id: 41248,
        description:
            'Time unit associated with the length of time after the publication of the data when corrections can be made.',
    },
    {
        name: 'NoStreamCommoditySettlBusinessCenters',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41249,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'StreamCommoditySettlBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41250,
        description:
            'The business center calendar used to adjust the commodity delivery date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'StreamCommodityBase',
        abbrName: 'Base',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41251,
        description:
            'Specifies the general base type of the commodity traded. Where possible, this should follow the naming convention used in the 2005 ISDA Commodity Definitions.\n\nExamples of general commodity base types include: Metal, Bullion, Oil, Natural Gas, Coal, Electricity, Inter-Energy, Grains, Oils Seeds, Dairy, Livestock, Forestry, Softs, Weather, Emissions.',
    },
    {
        name: 'StreamCommodityType',
        abbrName: 'CmdtyTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41252,
        description:
            'Specifies the type of commodity product.\n\nFor coal see http://www.fpml.org/coding-scheme/commodity-coal-product-type for values.\n\nFor metals see http://www.fpml.org/coding-scheme/commodity-metal-product-type for values.\n\nFor bullion see http://www.fixtradingcommunity.org/codelists#Bullion_Types for the external code list of bullion types.',
    },
    {
        name: 'StreamCommoditySecurityID',
        abbrName: 'ID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41253,
        discriminatorId: '41254',
        description: 'Specifies the market identifier for the commodity.',
    },
    {
        name: 'StreamCommoditySecurityIDSource',
        abbrName: 'Src',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.Latest',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'SecurityIDSourceCodeSet',
        updatedEP: '265',
        id: 41254,
        description: 'Identifies the class or source of the StreamCommoditySecurityIDSource(41253) value.',
    },
    {
        name: 'StreamCommodityDesc',
        abbrName: 'Desc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41255,
        description: 'Description of the commodity asset.',
    },
    {
        name: 'EncodedStreamCommodityDescLen',
        abbrName: 'EncDescLen',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 41256,
        description: 'Byte length of encoded (non-ASCII characters) EncodedStreamCommodityDesc(41257) field.',
    },
    {
        name: 'EncodedStreamCommodityDesc',
        abbrName: 'EncDesc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 41257,
        lengthId: '41256',
        description:
            'Encoded (non-ASCII characters) representation of the StreamCommodityDesc(41255) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the StreamCommodityDesc(41255) field.',
    },
    {
        name: 'StreamCommodityUnitOfMeasure',
        abbrName: 'UOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41258,
        description: 'The unit of measure (UOM) of the commodity asset.',
    },
    {
        name: 'StreamCommodityCurrency',
        abbrName: 'Ccy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41259,
        description: 'Identifies the currency of the commodity asset. Uses ISO 4217 currency codes.',
    },
    {
        name: 'StreamCommodityExchange',
        abbrName: 'Exch',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Exchange',
        id: 41260,
        description: 'Identifies the exchange where the commodity is traded.',
    },
    {
        name: 'StreamCommodityRateSource',
        abbrName: 'RtSrc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41261,
        description:
            'Identifies the source of rate information used for commodities.\n\nSee http://www.fixtradingcommunity.org/codelists#Commodity_Rate_Source for code list of applicable sources.',
    },
    {
        name: 'StreamCommodityRateReferencePage',
        abbrName: 'RefPg',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41262,
        description: 'Identifies the reference "page" from the rate source.',
    },
    {
        name: 'StreamCommodityRateReferencePageHeading',
        abbrName: 'RefHdng',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41263,
        description: 'Identifies the page heading from the rate source.',
    },
    {
        name: 'StreamDataProvider',
        abbrName: 'DataPrvdr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41264,
        description:
            'Specifies the commodity data or information provider.\n\nSee http://www.fpml.org/coding-scheme/commodity-information-provider for values.',
    },
    {
        name: 'StreamCommodityPricingType',
        abbrName: 'PxngTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41265,
        description:
            'Specifies how the pricing or rate setting of the trade is to be determined or based upon.\n\nSee http://www.fixtradingcommunity.org/codelists#Commodity_Rate_Pricing_Type for code list of applicable commodity pricing types.',
    },
    {
        name: 'StreamCommodityNearbySettlDayPeriod',
        abbrName: 'Period',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41266,
        description:
            'Time unit multiplier for the nearby settlement day.\n\nWhen the commodity transaction references a futures contract, the delivery or settlement dates are a nearby month or week. For example, for eighth nearby month use Period=8 and Unit=Mo.',
    },
    {
        name: 'StreamCommodityNearbySettlDayUnit',
        abbrName: 'Unit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'StreamCommodityNearbySettlDayUnitCodeSet',
        id: 41267,
        description: 'Time unit associated with the nearby settlement day.',
    },
    {
        name: 'StreamCommoditySettlDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41268,
        description: 'The unadjusted commodity delivery date.',
    },
    {
        name: 'StreamCommoditySettlDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 41269,
        description:
            'The business day convention used to adjust the commodity delivery date. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.',
    },
    {
        name: 'StreamCommoditySettlDateAdjusted',
        abbrName: 'Dt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41270,
        description: 'The adjusted commodity delivery date.',
    },
    {
        name: 'StreamCommoditySettlMonth',
        abbrName: 'Mo',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41271,
        description:
            'Specifies a fixed single month for commodity delivery.\n\nUse "1" for January, "2" for February, etc.',
    },
    {
        name: 'StreamCommoditySettlDateRollPeriod',
        abbrName: 'RollPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41272,
        description:
            'Time unit multiplier for the commodity delivery date roll.\n\nFor a commodity transaction that references a listed future via the delivery dates, this is the day offset on which the specified future will roll to the next nearby month when the referenced future expires.',
    },
    {
        name: 'StreamCommoditySettlDateRollUnit',
        abbrName: 'RollUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'StreamCommoditySettlDateRollUnitCodeSet',
        id: 41273,
        description: 'Time unit associated with the commodity delivery date roll.',
    },
    {
        name: 'StreamCommoditySettlDayType',
        abbrName: 'DayTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventDateOffsetDayTypeCodeSet',
        id: 41274,
        description: 'Specifies the commodity delivery roll day type.',
    },
    {
        name: 'StreamCommodityXID',
        abbrName: 'XID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XID',
        id: 41275,
        description: 'Identifier of this stream commodity for cross referencing elsewhere in the message.',
    },
    {
        name: 'StreamCommodityXIDRef',
        abbrName: 'XIDRef',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XIDREF',
        id: 41276,
        description: 'Reference to a stream commodity elsewhere in the message.',
    },
    {
        name: 'NoStreamCommodityAltIDs',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41277,
        description: 'Number of alternate security identifers.',
    },
    {
        name: 'StreamCommodityAltID',
        abbrName: 'AltID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41278,
        discriminatorId: '41279',
        description: 'Alternate security identifier value for the commodity.',
    },
    {
        name: 'StreamCommodityAltIDSource',
        abbrName: 'AltIDSrc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41279,
        description: 'Identifies the class or source of the alternate commodity security identifier.',
    },
    {
        name: 'NoStreamCommodityDataSources',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41280,
        description:
            'Number of data sources in the repeating group. The order of entry determines priority – first is the main source, second is fallback, third is second fallback.',
    },
    {
        name: 'StreamCommodityDataSourceID',
        abbrName: 'ID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41281,
        description: 'Data source identifier.',
    },
    {
        name: 'StreamCommodityDataSourceIDType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'StreamCommodityDataSourceIDTypeCodeSet',
        id: 41282,
        description: 'Type of data source identifier.',
    },
    {
        name: 'NoStreamCommoditySettlDays',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41283,
        description: 'Number of days in the repeating group.',
    },
    {
        name: 'StreamCommoditySettlDay',
        abbrName: 'Day',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryScheduleSettlDayCodeSet',
        id: 41284,
        description: 'Specifies the day or group of days for delivery.',
    },
    {
        name: 'StreamCommoditySettlTotalHours',
        abbrName: 'TotHrs',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41285,
        description: 'Sum of the hours specified in StreamCommoditySettlTimeGrp.',
    },
    {
        name: 'NoStreamCommoditySettlTimes',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41286,
        description: 'Number of hour ranges in the repeating group.',
    },
    {
        name: 'StreamCommoditySettlStart',
        abbrName: 'Start',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41287,
        description:
            'The start time for commodities settlement where delivery occurs over time. The time format is specified by the settlement time type.',
    },
    {
        name: 'StreamCommoditySettlEnd',
        abbrName: 'End',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41288,
        description:
            'The end time for commodities settlement where delivery occurs over time. The time format is specified by the settlement time type.',
    },
    {
        name: 'StreamCommoditySettlTimeType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryScheduleSettlTimeTypeCodeSet',
        id: 41588,
        description: 'Specifies the format of the commodities settlement start and end times.',
    },
    {
        name: 'NoStreamCommoditySettlPeriods',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41289,
        description: 'Number of commodity settlement periods in the repeating group.',
    },
    {
        name: 'StreamCommoditySettlCountry',
        abbrName: 'Ctry',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Country',
        id: 41290,
        description: 'Specifies the country where delivery takes place. Uses ISO 3166 2-character country code.',
    },
    {
        name: 'StreamCommoditySettlTimeZone',
        abbrName: 'TZ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41291,
        description:
            'Commodity delivery timezone specified as "prevailing" rather than "standard" or "daylight".\n\nSee http://www.fixtradingcommunity.org/codelists#Prevailing_Timezones for code list of applicable prevailing timezones.',
    },
    {
        name: 'StreamCommoditySettlFlowType',
        abbrName: 'FlowTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryScheduleSettlFlowTypeCodeSet',
        updatedEP: '179',
        id: 41292,
        description: 'Specifies the commodity delivery flow type.',
    },
    {
        name: 'StreamCommoditySettlPeriodNotional',
        abbrName: 'Notl',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 41293,
        description: 'Specifies the delivery quantity associated with this settlement period.',
    },
    {
        name: 'StreamCommoditySettlPeriodNotionalUnitOfMeasure',
        abbrName: 'NotlUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41294,
        description:
            'Specifies the unit of measure (UOM) of the delivery quantity associated with this settlement period.',
    },
    {
        name: 'StreamCommoditySettlPeriodFrequencyPeriod',
        abbrName: 'FreqPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41295,
        description: 'Time unit multiplier for the settlement period frequency.',
    },
    {
        name: 'StreamCommoditySettlPeriodFrequencyUnit',
        abbrName: 'FreqUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ProtectionTermEventUnitCodeSet',
        id: 41296,
        description: 'Time unit associated with the settlement period frequency.',
    },
    {
        name: 'StreamCommoditySettlPeriodPrice',
        abbrName: 'Px',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 41297,
        description: 'The settlement period price.',
    },
    {
        name: 'StreamCommoditySettlPeriodPriceUnitOfMeasure',
        abbrName: 'PxUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41298,
        description: 'Specifies the settlement period price unit of measure (UOM).',
    },
    {
        name: 'StreamCommoditySettlPeriodPriceCurrency',
        abbrName: 'PxCcy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41299,
        description: 'The currency of the settlement period price. Uses ISO 4217 currency codes.',
    },
    {
        name: 'StreamCommoditySettlHolidaysProcessingInstruction',
        abbrName: 'Holidays',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryScheduleSettlHolidaysProcessingInstructionCodeSet',
        id: 41300,
        description:
            'Indicates whether holidays are included in the settlement periods. Required for electricity contracts.',
    },
    {
        name: 'StreamCommoditySettlPeriodXID',
        abbrName: 'XID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XID',
        id: 41301,
        description: 'Identifier of this settlement period for cross referencing elsewhere in the message.',
    },
    {
        name: 'StreamCommoditySettlPeriodXIDRef',
        abbrName: 'XIDRef',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XIDREF',
        id: 41302,
        description: 'Cross reference to another settlement period for duplicating its properties.',
    },
    {
        name: 'StreamXID',
        abbrName: 'XID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XID',
        id: 41303,
        description: 'Identifier of this Stream for cross referencing elsewhere in the message.',
    },
    {
        name: 'StreamNotionalXIDRef',
        abbrName: 'NotlXIDRef',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XIDREF',
        id: 41305,
        description: 'Cross reference to another Stream notional for duplicating its properties.',
    },
    {
        name: 'StreamNotionalFrequencyPeriod',
        abbrName: 'NotlPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41306,
        description: "Time unit multiplier for the swap stream's notional frequency.",
    },
    {
        name: 'StreamNotionalFrequencyUnit',
        abbrName: 'NotlUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'TimeUnitCodeSet',
        id: 41307,
        description: "Time unit associated with the swap stream's notional frequency.",
    },
    {
        name: 'StreamNotionalCommodityFrequency',
        abbrName: 'NotlFreq',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'StreamNotionalCommodityFrequencyCodeSet',
        id: 41308,
        description: "The commodity's notional or quantity delivery frequency.",
    },
    {
        name: 'StreamNotionalUnitOfMeasure',
        abbrName: 'NotlUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41309,
        description: 'Specifies the delivery stream quantity unit of measure (UOM).',
    },
    {
        name: 'StreamTotalNotional',
        abbrName: 'TotNotl',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 41310,
        description: 'Total notional or delivery quantity over the term of the contract.',
    },
    {
        name: 'StreamTotalNotionalUnitOfMeasure',
        abbrName: 'TotNotlUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41311,
        description:
            'Specifies the unit of measure (UOM) for the total notional or delivery quantity over the term of the contract.',
    },
    {
        name: 'NoMandatoryClearingJurisdictions',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41312,
        description: 'Number of mandatory clearing jurisdictions.',
    },
    {
        name: 'MandatoryClearingJurisdiction',
        abbrName: 'Jrsdctn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41313,
        description: 'Identifier of the regulatory jurisdiction requiring the trade to be cleared.',
    },
    {
        name: 'LastQtyChanged',
        abbrName: 'QtyChngd',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 2301,
        description:
            'The positive or negative change in quantity when this report is a trade correction or continuation.',
    },
    {
        name: 'TradeVersion',
        abbrName: 'TrdVer',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2302,
        description:
            'Specifies the version of a trade or contract. This is used by systems or trading platforms in conjunction with TradeID(1003) to uniquely identify the version of a trade or contract. If used the conditions for a change of version are subject to bilateral agreement. It is recommended to change the version only for significant updates to the business entity rather than for minor changes to trade details or systematic distribution of reports. Examples where the version would change are trade quantity modification, customer account assignment or trade novation.',
    },
    {
        name: 'HistoricalReportIndicator',
        abbrName: 'HistrclRpt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2303,
        description:
            'Indicates that the trade or event being reported occurred in the past and the trade is terminated or no longer active.',
    },
    {
        name: 'NoLegAdditionalTermBondRefs',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41316,
        description: 'Number of bonds in the repeating group.',
    },
    {
        name: 'LegAdditionalTermBondSecurityID',
        abbrName: 'ID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41317,
        discriminatorId: '41318',
        description: 'Security identifier of the bond.',
    },
    {
        name: 'LegAdditionalTermBondSecurityIDSource',
        abbrName: 'Src',
        unionDataType: 'Reserved100Plus',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'SecurityIDSourceCodeSet',
        id: 41318,
        description: 'Identifies the source scheme of the LegAdditionalTermBondSecurityID(41317) value.',
    },
    {
        name: 'LegAdditionalTermBondDesc',
        abbrName: 'Desc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41319,
        description: 'Description of the bond.',
    },
    {
        name: 'EncodedLegAdditionalTermBondDescLen',
        abbrName: 'EncDescLen',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 41320,
        description: 'Byte length of encoded (non-ASCII characters) EncodedLegAdditionalTermBondDesc(41321) field.',
    },
    {
        name: 'EncodedLegAdditionalTermBondDesc',
        abbrName: 'EncDesc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 41321,
        lengthId: '41320',
        description:
            'Encoded (non-ASCII characters) representation of the LegAdditionalTermBondDesc(41319) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the LegAdditionalTermBondDesc(41319) field.',
    },
    {
        name: 'LegAdditionalTermBondCurrency',
        abbrName: 'Ccy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41322,
        description: 'Specifies the currency the bond value is denominated in. Uses ISO 4217 currency codes.',
    },
    {
        name: 'LegAdditionalTermBondIssuer',
        abbrName: 'Issr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41323,
        description: 'Issuer of the bond.',
    },
    {
        name: 'EncodedLegAdditionalTermBondIssuerLen',
        abbrName: 'EncIssrLen',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 41324,
        description: 'Byte length of encoded (non-ASCII characters) EncodedLegAdditionalTermBondIssuer(41325) field.',
    },
    {
        name: 'EncodedLegAdditionalTermBondIssuer',
        abbrName: 'EncIssr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 41325,
        lengthId: '41324',
        description:
            'Encoded (non-ASCII characters) representation of the LegAdditionalTermBondIssuer(41323) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the LegAdditionalTermBondIssuer(41323) field.',
    },
    {
        name: 'LegAdditionalTermBondSeniority',
        abbrName: 'Snrty',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'SeniorityCodeSet',
        id: 41326,
        description: "Specifies the bond's payment priority in the event of a default.",
    },
    {
        name: 'LegAdditionalTermBondCouponType',
        abbrName: 'CpnTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'CouponTypeCodeSet',
        id: 41327,
        description: 'Specifies the coupon type of the bond.',
    },
    {
        name: 'LegAdditionalTermBondCouponRate',
        abbrName: 'CpnRt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 41328,
        description: 'Coupon rate of the bond. See also CouponRate(223).',
    },
    {
        name: 'LegAdditionalTermBondMaturityDate',
        abbrName: 'MatDt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41329,
        description: 'The maturity date of the bond.',
    },
    {
        name: 'LegAdditionalTermBondParValue',
        abbrName: 'Par',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 41330,
        description: 'The par value of the bond.',
    },
    {
        name: 'LegAdditionalTermBondCurrentTotalIssuedAmount',
        abbrName: 'CurTotAmt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 41331,
        description: 'Total issued amount of the bond.',
    },
    {
        name: 'LegAdditionalTermBondCouponFrequencyPeriod',
        abbrName: 'CpnPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41332,
        description: "Time unit multiplier for the frequency of the bond's coupon payment.",
    },
    {
        name: 'LegAdditionalTermBondCouponFrequencyUnit',
        abbrName: 'CpnUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'CouponFrequencyUnitCodeSet',
        id: 41333,
        description: "Time unit associated with the frequency of the bond's coupon payment.",
    },
    {
        name: 'LegAdditionalTermBondDayCount',
        abbrName: 'DayCnt',
        unionDataType: 'Reserved100Plus',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'CouponDayCountCodeSet',
        id: 41334,
        description:
            'The day count convention used in interest calculations for a bond or an interest bearing security.',
    },
    {
        name: 'NoLegAdditionalTerms',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41335,
        description: 'Number of additional terms in the repeating group.',
    },
    {
        name: 'LegAdditionalTermConditionPrecedentBondIndicator',
        abbrName: 'PrcdntInd',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 41336,
        description:
            'Indicates whether the condition precedent bond is applicable. The swap contract is only valid if the bond is issued and if there is any dispute over the terms of fixed stream then the bond terms would be used.',
    },
    {
        name: 'LegAdditionalTermDiscrepancyClauseIndicator',
        abbrName: 'DscrpncyInd',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 41337,
        description: 'Indicates whether the discrepancy clause is applicable.',
    },
    {
        name: 'NoLegAssetAttributes',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2308,
        description: 'Number of asset attribute entries in the group.',
    },
    {
        name: 'LegAssetAttributeType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2309,
        description:
            'Specifies the name of the attribute.\n\nSee http://www.fixtradingcommunity.org/codelists#Asset_Attribute_Types for code list of applicable asset attribute types.',
    },
    {
        name: 'LegAssetAttributeValue',
        abbrName: 'Val',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2310,
        description: 'Specifies the value of the attribute.',
    },
    {
        name: 'LegAssetAttributeLimit',
        abbrName: 'Lmt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2311,
        description: 'Limit or lower acceptable value of the attribute.',
    },
    {
        name: 'NoLegCashSettlDealers',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41342,
        description: 'Number of dealers in the repeating group.',
    },
    {
        name: 'LegCashSettlDealer',
        abbrName: 'Dlr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41343,
        description:
            'Identifies the dealer from whom price quotations for the reference obligation are obtained for the purpose of cash settlement valuation calculation.\n\nISDA 2003 Term: Dealer',
    },
    {
        name: 'NoLegCashSettlTerms',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41344,
        description: 'Number of elements in the repeating group.',
    },
    {
        name: 'LegCashSettlCurrency',
        abbrName: 'Ccy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41345,
        description:
            'Specifies the currency the LegCashSettlAmount(41357) is denominated in. Uses ISO 4217 currency codes.',
    },
    {
        name: 'LegCasSettlValuationFirstBusinessDayOffset',
        abbrName: 'BizDayOfst',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41346,
        description:
            'The number of business days after settlement conditions have been satisfied, when the calculation agent is to obtain a price quotation on the reference obligation for purposes of cash settlement.\n\nAssociated with ISDA 2003 Term: Valuation Date.',
    },
    {
        name: 'LegCashSettlValuationSubsequentBusinessDaysOffset',
        abbrName: 'SbsqntBizDayOfst',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41347,
        description:
            'The number of business days between successive valuation dates when multiple valuation dates are applicable for cash settlement.',
    },
    {
        name: 'LegCashSettlNumOfValuationDates',
        abbrName: 'NumValDts',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41348,
        description:
            'Where multiple valuation dates are specified as being applicable for cash settlement, this element specifies the number of applicable valuation dates.\n\nAssociated with ISDA 2003 Term: Valuation Date',
    },
    {
        name: 'LegCashSettlValuationTime',
        abbrName: 'ValTm',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 41349,
        description: 'Time of valuation.',
    },
    {
        name: 'LegCashSettlBusinessCenter',
        abbrName: 'BizCtr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41350,
        description:
            'Identifies the business center calendar used at valuation time for cash settlement purposes e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegCashSettlQuoteMethod',
        abbrName: 'QteMeth',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'CashSettlQuoteMethodCodeSet',
        id: 41351,
        description: 'The type of quote used to determine the cash settlement price.',
    },
    {
        name: 'LegCashSettlQuoteAmount',
        abbrName: 'QteAmt',
        updated: 'FIX.Latest',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        updatedEP: '271',
        id: 41352,
        description:
            'When determining the cash settlement amount, if weighted average price quotes are to be obtained for the reference obligation, this is the upper limit to the outstanding principal balance of the reference obligation for which the quote should be obtained. If not specified, the ISDA definitions provide for a fallback amount equal to floating rate payer calculation amount.\n\nISDA 2003 Term: Quotation Amount.',
    },
    {
        name: 'LegCashSettlQuoteCurrency',
        abbrName: 'QteCcy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41353,
        description:
            'Specifies the currency the LegCashSettlQuoteAmount(41352) is denominated in. Uses ISO 4217 Currency Code.',
    },
    {
        name: 'LegCashSettlMinimumQuoteAmount',
        abbrName: 'MinQteAmt',
        updated: 'FIX.Latest',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        updatedEP: '271',
        id: 41354,
        description:
            'When determining the cash settlement amount, if weighted average price quotes are to be obtained for the reference obligation, this is the minimum intended threshold amount of outstanding principal balance of the reference obligation for which the quote should be obtained. If not specified, the ISDA definitions provide for a fallback amount of the lower of either USD1,000,000 (or its equivalent in the relevant obligation currency) or the (minimum) quoted amount.\n\nISDA 2003 Term: Minimum Quotation Amount.',
    },
    {
        name: 'LegCashSettlMinimumQuoteCurrency',
        abbrName: 'MinQteCcy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41355,
        description:
            'Specifies the currency the LegCashSettlQuoteMinimumAmount(41354) is denominated in. Uses ISO 4217 Currency Code.',
    },
    {
        name: 'LegCashSettlBusinessDays',
        abbrName: 'BizDays',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41356,
        description:
            'The number of business days used in the determination of the cash settlement payment date.\n\nIf a cash settlement amount is specified, the cash settlement payment date will be this number of business days following the calculation of the final price. If a cash settlement amount is not specified, the cash settlement payment date will be this number of business days after all conditions to settlement are satisfied. ISDA 2003 Term: Cash Settlement Date.',
    },
    {
        name: 'LegCashSettlAmount',
        abbrName: 'Amt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 41357,
        description:
            'The amount paid between the trade parties, seller to the buyer, for cash settlement on the cash settlement date.\n\nIf not specified this would typically be calculated as ((100 or the reference price) - reference obligation price) x floating rate payer calculation amount. Price values are all expressed as a percentage. ISDA 2003 Term: Cash Settlement Amount.',
    },
    {
        name: 'LegCashSettlRecoveryFactor',
        abbrName: 'RcvryFctr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 41358,
        description:
            'Used for fixed recovery, this specifies the recovery level as determined at contract inception, to be applied in the event of a default. The factor is used to calculate the amount paid by the seller to the buyer for cash settlement on the cash settlement date. The amount calculated is (1 - LegCashSettlRecoveryFactor(41358)) x floating rate payer calculation amount. The currency is derived from the floating rate payer calculation amount.',
    },
    {
        name: 'LegCashSettlFixedTermIndicator',
        abbrName: 'FixedInd',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 41359,
        description: 'Indicates whether fixed settlement is applicable or not applicable in a recovery lock.',
    },
    {
        name: 'LegCashSettlAccruedInterestIndicator',
        abbrName: 'AcrdIntInd',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 41360,
        description:
            'Indicates whether accrued interest is included or not in the value provided in LegCashSettlAmount(41357).\n\nFor cash settlement this specifies whether quotations should be obtained inclusive or not of accrued interest.\n\nFor physical settlement this specifies whether the buyer should deliver the obligation with an outstanding principal balance that includes or excludes accrued interest.\n\nISDA 2003 Term: Include/Exclude Accrued Interest.',
    },
    {
        name: 'LegCashSettlValuationMethod',
        abbrName: 'ValMeth',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'CashSettlValuationMethodCodeSet',
        id: 41361,
        description:
            'The ISDA defined methodology for determining the final price of the reference obligation for purposes of cash settlement.\n\nISDA 2003 Term: Valuation Method.',
    },
    {
        name: 'LegCashSettlTermXID',
        abbrName: 'XID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XID',
        id: 41362,
        description: 'A named string value referenced by UnderlyingSettlTermXIDRef(41315).',
    },
    {
        name: 'NoLegComplexEventAveragingObservations',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41363,
        description: 'The number of averaging observations in the repeating group.',
    },
    {
        name: 'LegComplexEventAveragingObservationNumber',
        abbrName: 'ObsvtnNum',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41364,
        description:
            'Cross reference to the ordinal observation as specified either in the LegComplexEventScheduleGrp or LegComplexEventPeriodDateGrp components.',
    },
    {
        name: 'LegComplexEventAveragingWeight',
        abbrName: 'Wt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 41365,
        description: 'The weight factor to be applied to the observation.',
    },
    {
        name: 'NoLegComplexEventCreditEvents',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41366,
        description: 'The number of credit events specified in the repeating group.',
    },
    {
        name: 'LegComplexEventCreditEventType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41367,
        description:
            'Specifies the type of credit event.\n\nSee http://www.fixtradingcommunity.org/codelists#Credit_Event_Types for code list of applicable event types.',
    },
    {
        name: 'LegComplexEventCreditEventValue',
        abbrName: 'Val',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41368,
        description:
            'The credit event value appropriate to LegComplexEventCreditEventType(41367).\n\nSee http://www.fixtradingcommunity.org/codelists#Credit_Event_Types for applicable event type values.',
    },
    {
        name: 'LegComplexEventCreditEventCurrency',
        abbrName: 'Ccy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41369,
        description:
            'Specifies the applicable currency when LegComplexEventCreditEventCurrency(41368) is an amount. Uses ISO 4217 currency codes.',
    },
    {
        name: 'LegComplexEventCreditEventPeriod',
        abbrName: 'Period',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41370,
        description: 'Time unit multiplier for complex credit events.',
    },
    {
        name: 'LegComplexEventCreditEventUnit',
        abbrName: 'Unit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ProtectionTermEventUnitCodeSet',
        id: 41371,
        description: 'Time unit associated with complex credit events.',
    },
    {
        name: 'LegComplexEventCreditEventDayType',
        abbrName: 'DayTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventDateOffsetDayTypeCodeSet',
        id: 41372,
        description: 'Specifies the day type for the complex credit events.',
    },
    {
        name: 'LegComplexEventCreditEventRateSource',
        abbrName: 'RtSrc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41373,
        description:
            'Identifies the source of rate information used for credit events.\n\nSee http://www.fixtradingcommunity.org/codelists#Credit_Event_Rate_Source for code list of applicable sources.',
    },
    {
        name: 'NoLegComplexEventCreditEventQualifiers',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41374,
        description: 'Number of qualifiers in the repeating group.',
    },
    {
        name: 'LegComplexEventCreditEventQualifier',
        abbrName: 'Qual',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ProtectionTermEventQualifierCodeSet',
        id: 41375,
        description:
            'Specifies a complex event qualifier. Used to further qualify LegComplexEventCreditEventType(41367).',
    },
    {
        name: 'NoLegComplexEventPeriodDateTimes',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41376,
        description: 'Number of entries in the date-time repeating group.',
    },
    {
        name: 'LegComplexEventPeriodDate',
        abbrName: 'Dt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41377,
        description: 'Averaging date for an Asian option.\n\nTrigger date for a Barrier or Knock option.',
    },
    {
        name: 'LegComplexEventPeriodTime',
        abbrName: 'Tm',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 41378,
        description: 'Averaging time for an Asian option.',
    },
    {
        name: 'NoLegComplexEventPeriods',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41379,
        description: 'Number of periods in the repeating group.',
    },
    {
        name: 'LegComplexEventPeriodType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventPeriodTypeCodeSet',
        id: 41380,
        description: 'Specifies the period type.',
    },
    {
        name: 'LegComplexEventBusinessCenter',
        abbrName: 'BizCtr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41381,
        description:
            'The business center for adjusting dates and times in the schedule or date-time group.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'NoLegComplexEventRateSources',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41382,
        description: 'Number of rate sources in the repeating group.',
    },
    {
        name: 'LegComplexEventRateSource',
        abbrName: 'RtSrc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'RateSourceCodeSet',
        id: 41383,
        description:
            'Identifies the source of rate information.\n\nFor FX, the reference source to be used for the FX spot rate.',
    },
    {
        name: 'LegComplexEventRateSourceType',
        abbrName: 'RtSrcTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'RateSourceTypeCodeSet',
        id: 41384,
        description: 'Indicates whether the rate source specified is a primary or secondary source.',
    },
    {
        name: 'LegComplexEventReferencePage',
        abbrName: 'RefPg',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41385,
        description:
            'Identifies the reference page from the rate source.\n\nFor FX, the reference page to the spot rate is to be used for the reference FX spot rate.\n\nWhen LegComplexEventRateSource(41383) = 3 (ISDA Settlement Rate Option) this contains the value from the scheme that reflects the terms of the Annex A to the ISDA 1998 FX and Currency Option Definitions. See: http://www.fpml.org/coding-scheme/settlement-rate-option.',
    },
    {
        name: 'LegComplexEvenReferencePageHeading',
        abbrName: 'RefHdng',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41386,
        description: 'Identifies the reference page heading from the rate source.',
    },
    {
        name: 'NoLegComplexEventDateBusinessCenters',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41387,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'LegComplexEventDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41388,
        description:
            'The business center calendar used to adjust the event date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegComplexEventDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41389,
        description:
            'The unadjusted complex event date.\n\nFor example the second expiration date for a calendar spread option strategy.',
    },
    {
        name: 'LegComplexEventDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 41390,
        description:
            'Specifies the anchor date when the complex event date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'LegComplexEventDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41391,
        description: 'Time unit multiplier for the relative date offset.',
    },
    {
        name: 'LegComplexEventDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 41392,
        description: 'Time unit associated with the relative date offset.',
    },
    {
        name: 'LegComplexEventDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventDateOffsetDayTypeCodeSet',
        id: 41393,
        description: 'Specifies the day type of the relative date offset.',
    },
    {
        name: 'LegComplexEventDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 41394,
        description:
            'The business day convention used to adjust the event date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.',
    },
    {
        name: 'LegComplexEventDateAdjusted',
        abbrName: 'Dt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41395,
        description: 'The adjusted complex event date.',
    },
    {
        name: 'LegComplexEventFixingTime',
        abbrName: 'FixngTm',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 41396,
        description: 'The local market fixing time.',
    },
    {
        name: 'LegComplexEventFixingTimeBusinessCenter',
        abbrName: 'FixngBizCtr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41397,
        description:
            'The business center for determining the actual fixing times.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'NoLegComplexEventCreditEventSources',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41398,
        description: 'Number of event sources in the repeating group.',
    },
    {
        name: 'LegComplexEventCreditEventSource',
        abbrName: 'Src',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41399,
        description:
            'A newspaper or electronic news service that may publish relevant information used in the determination of whether or not a credit event has occurred.',
    },
    {
        name: 'NoLegComplexEvents',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2218,
        description: 'Number of complex events in the repeating group.',
    },
    {
        name: 'LegComplexEventType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventTypeCodeSet',
        id: 2219,
        description: 'Identifies the type of complex event.',
    },
    {
        name: 'LegComplexOptPayoutPaySide',
        abbrName: 'OptPay',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentPaySideCodeSet',
        id: 2220,
        description: 'Trade side of payout payer.',
    },
    {
        name: 'LegComplexOptPayoutReceiveSide',
        abbrName: 'OptRcv',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentPaySideCodeSet',
        id: 2221,
        description: 'Trade side of payout receiver.',
    },
    {
        name: 'LegComplexOptPayoutUnderlier',
        abbrName: 'OptUndlr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2222,
        description: 'Reference to the underlier whose payments are being passed through.',
    },
    {
        name: 'LegComplexOptPayoutAmount',
        abbrName: 'OptPayAmt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 2223,
        description:
            'Cash amount indicating the pay out associated with an event. For binary options this is a fixed amount.',
    },
    {
        name: 'LegComplexOptPayoutPercentage',
        abbrName: 'OptPctage',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 2224,
        description: 'Percentage of observed price for calculating the payout associated with the event.',
    },
    {
        name: 'LegComplexOptPayoutTime',
        abbrName: 'OptTm',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ComplexOptPayoutTimeCodeSet',
        id: 2225,
        description: 'Specifies when the payout is to occur.',
    },
    {
        name: 'LegComplexOptPayoutCurrency',
        abbrName: 'OptCcy',
        updated: 'FIX.Latest',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        updatedEP: '273',
        id: 2226,
        description:
            'Specifies the currency of the payout amount.\n\nLegComplexOptPayoutCurrencyCodeSource(2944) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.',
    },
    {
        name: 'LegComplexEventPrice',
        abbrName: 'Px',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 2227,
        description:
            'Specifies the price at which the complex event takes effect. Impact of the event price is determined by the LegComplexEventType(2219).',
    },
    {
        name: 'LegComplexEventPricePercentage',
        abbrName: 'PxPctage',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 2228,
        description:
            'Specifies the price percentage at which the complex event takes effect. Impact of the event price is determined by the LegComplexEventType(2219).',
    },
    {
        name: 'LegComplexEventPriceBoundaryMethod',
        abbrName: 'PxBndryMeth',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventPriceBoundaryMethodCodeSet',
        id: 2229,
        description:
            'Specifies the boundary condition to be used for the event price relative to the complex event price at the point the complex event outcome takes effect as determined by the LegComplexEventPriceTimeType(2231).',
    },
    {
        name: 'LegComplexEventPriceBoundaryPrecision',
        abbrName: 'PxBndryPrcsn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 2230,
        description:
            'Used in combination with LegComplexEventPriceBoundaryMethod(2229) to specify the percentage of the strike price in relation to the underlying price. The percentage is generally 100 or greater for puts and 100 or less for calls.',
    },
    {
        name: 'LegComplexEventPriceTimeType',
        abbrName: 'PxTmTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventPriceTimeTypeCodeSet',
        id: 2231,
        description:
            'Specifies when the complex event outcome takes effect. The outcome of a complex event is a payout or barrier action as specified by the LegComplexEventType(2219).',
    },
    {
        name: 'LegComplexEventCondition',
        abbrName: 'Cond',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventConditionCodeSet',
        id: 2232,
        description:
            'Specifies the condition between complex events when more than one event is specified.\n\nMultiple barrier events would use an "or" condition since only one can be effective at a given time. A set of digital range events would use an "and" condition since both conditions must be in effect for a payout to result.',
    },
    {
        name: 'LegComplexEventCurrencyOne',
        abbrName: 'Ccy1',
        updated: 'FIX.Latest',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        updatedEP: '273',
        id: 2233,
        description:
            'Specifies the first or only reference currency of the trade.\n\nLegComplexEventCurrencyOneCodeSource(2945) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.\n\nApplicable for complex FX option strategies.',
    },
    {
        name: 'LegComplexEventCurrencyTwo',
        abbrName: 'Ccy2',
        updated: 'FIX.Latest',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        updatedEP: '273',
        id: 2234,
        description:
            'Specifies the second reference currency of the trade.\n\nLegComplexEventCurrencyTwoCodeSource(2946) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.\n\nApplicable for complex FX option strategies.',
    },
    {
        name: 'LegComplexEventQuoteBasis',
        abbrName: 'QteBasis',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventQuoteBasisCodeSet',
        id: 2235,
        description: 'For foreign exchange Quanto option feature.',
    },
    {
        name: 'LegComplexEventFixedFXRate',
        abbrName: 'Rt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 2236,
        description: 'Specifies the fixed FX rate alternative for FX Quantro options.',
    },
    {
        name: 'LegComplexEventDeterminationMethod',
        abbrName: 'Meth',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2237,
        description:
            'Specifies the method according to which an amount or a date is determined.\n\nSee http://www.fpml.org/coding-scheme/determination-method for values.',
    },
    {
        name: 'LegComplexEventCalculationAgent',
        abbrName: 'CalcAgent',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ProvisionCalculationAgentCodeSet',
        id: 2238,
        description: 'Used to identify the calculation agent.',
    },
    {
        name: 'LegComplexEventStrikePrice',
        abbrName: 'StrkPx',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 2239,
        description: 'Upper strike price for Asian option feature. Strike percentage for a Strike Spread.',
    },
    {
        name: 'LegComplexEventStrikeFactor',
        abbrName: 'StrkFctr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 2240,
        description: 'Strike factor for Asian option feature. Upper strike percentage for a Strike Spread.',
    },
    {
        name: 'LegComplexEventStrikeNumberOfOptions',
        abbrName: 'StrkNum',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2241,
        description: 'Upper string number of options for a Strike Spread.',
    },
    {
        name: 'LegComplexEventCreditEventsXIDRef',
        abbrName: 'CdtEvntXIDRef',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XIDREF',
        id: 2242,
        description: 'Reference to credit event table elsewhere in the message.',
    },
    {
        name: 'LegComplexEventCreditEventNotifyingParty',
        abbrName: 'NotifygPty',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventCreditEventNotifyingPartyCodeSet',
        id: 2243,
        description:
            'The notifying party is the party that notifies the other party when a credit event has occurred by means of a credit event notice. If more than one party is referenced as being the notifying party then either party may notify the other of a credit event occurring.',
    },
    {
        name: 'LegComplexEventCreditEventBusinessCenter',
        abbrName: 'BizCtr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2244,
        description:
            'Specifies the local business center for which the credit event is to be determined. The inclusion of this business center implies that Greenwich Mean Time in Section 3.3 of the 2003 ISDA Credit Derivatives Definitions is replaced by the local time of the specified business center.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegComplexEventCreditEventStandardSources',
        abbrName: 'StdSrcs',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2245,
        description:
            "When this element is specified and set to 'Y', indicates that ISDA defined Standard Public Sources are applicable.",
    },
    {
        name: 'LegComplexEventCreditEventMinimumSources',
        abbrName: 'MinSrcs',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2246,
        description:
            'The minimum number of the specified public information sources that must publish information that reasonably confirms that a credit event has occurred. The market convention is two.\n\nISDA 2003 Term: Specified Number.',
    },
    {
        name: 'LegComplexEventXID',
        abbrName: 'XID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XID',
        id: 2248,
        description: 'Identifier of this complex event for cross referencing elsewhere in the message.',
    },
    {
        name: 'LegComplexEventXIDRef',
        abbrName: 'XIDRef',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XIDREF',
        id: 2249,
        description: 'Reference to a complex event elsewhere in the message.',
    },
    {
        name: 'NoLegComplexEventDates',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2250,
        description: 'Number of complex event dates in the repeating group.',
    },
    {
        name: 'LegComplexEventStartDate',
        abbrName: 'StartDt',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UTCDateOnly',
        updatedEP: '195',
        id: 2251,
        description:
            'The start date of the date range on which a complex event is effective. The start date will be set equal to the end date for single day events such as Bermuda options.\n\nThe start date must always be less than or equal to end date.',
    },
    {
        name: 'LegComplexEventEndDate',
        abbrName: 'EndDt',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UTCDateOnly',
        updatedEP: '195',
        id: 2252,
        description:
            'The end date of the date range on which a complex event is effective. The start date will be set equal to the end date for single day events such as Bermuda options.\n\nThe end date must always be greater than or equal to start date.',
    },
    {
        name: 'NoLegComplexEventTimes',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2253,
        description: 'Number of complex event times in the repeating group.',
    },
    {
        name: 'LegComplexEventStartTime',
        abbrName: 'StartTm',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UTCTimeOnly',
        id: 2204,
        description:
            'The start time of the time range on which a complex event date is effective.\n\nThe start time must always be less than or equal to the end time.',
    },
    {
        name: 'LegComplexEventEndTime',
        abbrName: 'EndTm',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UTCTimeOnly',
        id: 2247,
        description:
            'The end time of the time range on which a complex event date is effective.\n\nThe end time must always be greater than or equal to the start time.',
    },
    {
        name: 'NoLegComplexEventSchedules',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41400,
        description: 'Number of schedules in the repeating group.',
    },
    {
        name: 'LegComplexEventScheduleStartDate',
        abbrName: 'StartDt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41401,
        description: 'The start date of the schedule.',
    },
    {
        name: 'LegComplexEventScheduleEndDate',
        abbrName: 'EndDt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41402,
        description: 'The end date of the schedule.',
    },
    {
        name: 'LegComplexEventScheduleFrequencyPeriod',
        abbrName: 'FreqPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41403,
        description: 'Time unit multiplier for the schedule date frequency.',
    },
    {
        name: 'LegComplexEventScheduleFrequencyUnit',
        abbrName: 'FreqUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ProtectionTermEventUnitCodeSet',
        id: 41404,
        description: 'Time unit associated with the schedule date frequency.',
    },
    {
        name: 'LegComplexEventScheduleRollConvention',
        abbrName: 'Roll',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DateRollConventionCodeSet',
        id: 41405,
        description:
            'The convention for determining the sequence of dates. It is used in conjunction with a specified frequency. Used only to override the roll convention defined in the LegDateAdjustment component in InstrumentLeg.',
    },
    {
        name: 'NoLegDeliverySchedules',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41408,
        description: 'Number of delivery schedules in the repeating group.',
    },
    {
        name: 'LegDeliveryScheduleType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryScheduleTypeCodeSet',
        id: 41409,
        description: 'Specifies the type of delivery schedule.',
    },
    {
        name: 'LegDeliveryScheduleXID',
        abbrName: 'XID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XID',
        id: 41410,
        description:
            'Identifier for this instance of delivery schedule for cross referencing elsewhere in the message.',
    },
    {
        name: 'LegDeliveryScheduleNotional',
        abbrName: 'Notl',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 41411,
        description: 'Physical delivery quantity.',
    },
    {
        name: 'LegDeliveryScheduleNotionalUnitOfMeasure',
        abbrName: 'NotlUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41412,
        description: 'Specifies the delivery quantity unit of measure (UOM).',
    },
    {
        name: 'LegDeliveryScheduleNotionalCommodityFrequency',
        abbrName: 'NotlFreq',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'StreamNotionalCommodityFrequencyCodeSet',
        id: 41413,
        description: 'The frequency of notional delivery.',
    },
    {
        name: 'LegDeliveryScheduleNegativeTolerance',
        abbrName: 'NegtvTlrnc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 41414,
        description:
            'Specifies the negative tolerance value. The value may be an absolute quantity or a percentage, as specified in LegDeliveryScheduleToleranceType(41417). Percentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%).',
    },
    {
        name: 'LegDeliverySchedulePositiveTolerance',
        abbrName: 'PostvTlrnc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 41415,
        description:
            'Specifies the positive tolerance value. The value may be an absolute quantity or a percentage, as specified in LegDeliveryScheduleToleranceType(41417). Value may exceed agreed upon value. Percentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%).',
    },
    {
        name: 'LegDeliveryScheduleToleranceUnitOfMeasure',
        abbrName: 'TlrncUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41416,
        description: "Specifies the tolerance value's unit of measure (UOM).",
    },
    {
        name: 'LegDeliveryScheduleToleranceType',
        abbrName: 'TlrncTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryScheduleToleranceTypeCodeSet',
        id: 41417,
        description: 'Specifies the tolerance value type.',
    },
    {
        name: 'LegDeliveryScheduleSettlCountry',
        abbrName: 'Ctry',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Country',
        id: 41418,
        description: 'Specifies the country where delivery takes place. Uses ISO 3166 2-character country code.',
    },
    {
        name: 'LegDeliveryScheduleSettlTimeZone',
        abbrName: 'TZ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41419,
        description:
            'Delivery timezone specified as "prevailing" rather than "standard" or "daylight".\n\nSee http://www.fixtradingcommunity.org/codelists#Prevailing_Timezones for code list of applicable prevailing timezones.',
    },
    {
        name: 'LegDeliveryScheduleSettlFlowType',
        abbrName: 'FlowTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryScheduleSettlFlowTypeCodeSet',
        id: 41420,
        description: 'Specifies the delivery flow type.',
    },
    {
        name: 'LegDeliveryScheduleSettlHolidaysProcessingInstruction',
        abbrName: 'Holidays',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryScheduleSettlHolidaysProcessingInstructionCodeSet',
        id: 41421,
        description:
            'Indicates whether holidays are included in the settlement periods. Required for electricity contracts.',
    },
    {
        name: 'NoLegDeliveryScheduleSettlDays',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41422,
        description: 'Number of delivery schedules in the repeating group.',
    },
    {
        name: 'LegDeliveryScheduleSettlDay',
        abbrName: 'Day',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryScheduleSettlDayCodeSet',
        id: 41423,
        description: 'Specifies the day or group of days for delivery.',
    },
    {
        name: 'LegDeliveryScheduleSettlTotalHours',
        abbrName: 'TotHrs',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41424,
        description: 'The sum of the total hours specified in the LegDeliveryScheduleSettlTimeGrp component.',
    },
    {
        name: 'NoLegDeliveryScheduleSettlTimes',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41425,
        description: 'Number of hour ranges in the repeating group.',
    },
    {
        name: 'LegDeliveryScheduleSettlStart',
        abbrName: 'Start',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41426,
        description:
            'The scheduled start time for the delivery of the commodity where delivery occurs over specified times. The format of the time value is specified in LegDeliveryScheduleSettlTimeType(41428).',
    },
    {
        name: 'LegDeliveryScheduleSettlEnd',
        abbrName: 'End',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41427,
        description:
            'The scheduled end time for the delivery of the commodity where delivery occurs over specified times. The format of the time value is specified in LegDeliveryScheduleSettlTimeType(41428).',
    },
    {
        name: 'LegDeliveryScheduleSettlTimeType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryScheduleSettlTimeTypeCodeSet',
        id: 41428,
        description: 'Specifies the format of the delivery start and end time values.',
    },
    {
        name: 'LegDeliveryStreamType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryStreamTypeCodeSet',
        id: 41429,
        description: 'Specifies the type of delivery stream.',
    },
    {
        name: 'LegDeliveryStreamPipeline',
        abbrName: 'Ppln',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41430,
        description: 'The name of the oil delivery pipeline.',
    },
    {
        name: 'LegDeliveryStreamEntryPoint',
        abbrName: 'EntryPnt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41431,
        description: 'The point at which the commodity will enter the delivery mechanism or pipeline.',
    },
    {
        name: 'LegDeliveryStreamWithdrawalPoint',
        abbrName: 'WthdrwlPnt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41432,
        description: 'The point at which the commodity product will be withdrawn prior to delivery.',
    },
    {
        name: 'LegDeliveryStreamDeliveryPoint',
        abbrName: 'DlvryPnt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41433,
        discriminatorId: '42194',
        description:
            'The point at which the commodity product will be delivered and received. Value specified should follow market convention appropriate for the commodity product.\n\nFor bullion, see http://www.fpml.org/coding-scheme/bullion-delivery-location for values.',
    },
    {
        name: 'LegDeliveryStreamDeliveryRestriction',
        abbrName: 'DlvryRstctn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryStreamDeliveryRestrictionCodeSet',
        id: 41434,
        description:
            'Specifies under what conditions the buyer and seller should be excused of their delivery obligations.',
    },
    {
        name: 'LegDeliveryStreamDeliveryContingency',
        abbrName: 'Cntgncy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41435,
        description:
            'Specifies the electricity delivery contingency. See\n\nhttp://www.fpml.org/coding-scheme/electricity-transmission-contingency for values.',
    },
    {
        name: 'LegDeliveryStreamDeliveryContingentPartySide',
        abbrName: 'CntgPty',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryStreamElectingPartySideCodeSet',
        id: 41436,
        description: 'The trade side value of the party responsible for electricity delivery contingency.',
    },
    {
        name: 'LegDeliveryStreamDeliverAtSourceIndicator',
        abbrName: 'DlvrAtSrc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 41437,
        description:
            "When this element is specified and set to 'Y', delivery of the coal product is to be at its source.",
    },
    {
        name: 'LegDeliveryStreamRiskApportionment',
        abbrName: 'RiskApprtnmt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41438,
        discriminatorId: '41219',
        description:
            'Specifies how the parties to the trade apportion responsibility for the delivery of the commodity product.\n\nSee http://www.fixtradingcommunity.org/codelists#Risk_Apportionment for the details of the external code list.',
    },
    {
        name: 'LegDeliveryStreamRiskApportionmentSource',
        abbrName: 'RiskApprtnmtSrc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41219,
        description:
            'Specifies the source or legal framework for the risk apportionment.\n\nSee http://www.fixtradingcommunity.org/codelists#Risk_Apportionment_Source for the details of the external code list.',
    },
    {
        name: 'LegDeliveryStreamTitleTransferLocation',
        abbrName: 'TtlXfer',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41439,
        description: 'Specifies the title transfer location.',
    },
    {
        name: 'LegDeliveryStreamTitleTransferCondition',
        abbrName: 'TtlXferCond',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryStreamTitleTransferConditionCodeSet',
        id: 41440,
        description: 'Specifies the condition of title transfer.',
    },
    {
        name: 'LegDeliveryStreamImporterOfRecord',
        abbrName: 'Imprtr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41441,
        description:
            'A party, not necessarily of the trade, who is the Importer of Record for the purposes of paying customs duties and applicable taxes or costs related to importation.',
    },
    {
        name: 'LegDeliveryStreamNegativeTolerance',
        abbrName: 'NegtvTlrnc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 41442,
        description:
            'Specifies the negative tolerance value. The value may be an absolute quantity or a percentage, as specified in LegDeliveryStreamToleranceType(41445). Percentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%).',
    },
    {
        name: 'LegDeliveryStreamPositiveTolerance',
        abbrName: 'PostvTlrnc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 41443,
        description:
            'Specifies the positive tolerance value. The value may be an absolute quantity or a percentage, as specified in LegDeliveryStreamToleranceType(41445). Value may exceed agreed upon value. Percentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%).',
    },
    {
        name: 'LegDeliveryStreamToleranceUnitOfMeasure',
        abbrName: 'TlrncUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41444,
        description: "Specifies the tolerance value's unit of measure (UOM).",
    },
    {
        name: 'LegDeliveryStreamToleranceType',
        abbrName: 'TlrncTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryScheduleToleranceTypeCodeSet',
        id: 41445,
        description: 'Specifies the tolerance value type.',
    },
    {
        name: 'LegDeliveryStreamToleranceOptionSide',
        abbrName: 'TlrncOptSide',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryStreamToleranceOptionSideCodeSet',
        id: 41446,
        description: "Indicates whether the tolerance is at the seller's or buyer's option.",
    },
    {
        name: 'LegDeliveryStreamTotalPositiveTolerance',
        abbrName: 'TotPostvTlrnc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 41447,
        description:
            'The positive percent tolerance which applies to the total quantity delivered over all shipment periods.\n\nPercentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%.).',
    },
    {
        name: 'LegDeliveryStreamTotalNegativeTolerance',
        abbrName: 'TotNegtvTlrnc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 41448,
        description:
            'The negative percent tolerance which applies to the total quantity delivered over all shipment periods.\n\nPercentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%.).',
    },
    {
        name: 'LegDeliveryStreamNotionalConversionFactor',
        abbrName: 'CnvrsnFctr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 41449,
        description:
            'If the notional quantity is specified in a unit that does not match the unit in which the commodity reference price is quoted, the scaling or conversion factor used to convert the commodity reference price unit into the notional quantity unit should be stated here. If there is no conversion, this field is not intended to be used.',
    },
    {
        name: 'LegDeliveryStreamTransportEquipment',
        abbrName: 'Eqpmt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41450,
        description:
            'The transportation equipment with which the commodity product will be delivered and received.\n\nExamples of transportation equipment or mode are barge, truck, railcar, etc.',
    },
    {
        name: 'LegDeliveryStreamElectingPartySide',
        abbrName: 'ElctngSide',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryStreamElectingPartySideCodeSet',
        id: 41451,
        description:
            'A reference to the party able to choose whether the gas is delivered for a particular period e.g. a swing or interruptible contract.',
    },
    {
        name: 'NoLegStreamAssetAttributes',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41452,
        description: 'Number of asset attribute entries in the group.',
    },
    {
        name: 'LegStreamAssetAttributeType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41453,
        description:
            'Specifies the name of the attribute.\n\nSee http://www.fixtradingcommunity.org/codelists#Asset_Attribute_Types for code list of applicable asset attribute types.',
    },
    {
        name: 'LegStreamAssetAttributeValue',
        abbrName: 'Val',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41454,
        description: 'Specifies the value of the attribute.',
    },
    {
        name: 'LegStreamAssetAttributeLimit',
        abbrName: 'Lmt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41455,
        description: 'Limit or lower acceptable value of the attribute.',
    },
    {
        name: 'NoLegDeliveryStreamCycles',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41456,
        description: 'Number of commodity sources in the repeating group.',
    },
    {
        name: 'LegDeliveryStreamCycleDesc',
        abbrName: 'Desc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41457,
        description: 'The delivery cycles during which the oil product will be transported in the pipeline.',
    },
    {
        name: 'EncodedLegDeliveryStreamCycleDescLen',
        abbrName: 'EncDescLen',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 41458,
        description: 'Byte length of encoded (non-ASCII characters) EncodedLegDeliveryStreamCycleDesc(41459) field.',
    },
    {
        name: 'EncodedLegDeliveryStreamCycleDesc',
        abbrName: 'EncDesc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 41459,
        lengthId: '41458',
        description:
            'Encoded (non-ASCII characters) representation of the LegDeliveryStreamCycleDesc(41457) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the LegLeg DeliveryStream(41457) field.',
    },
    {
        name: 'NoLegDeliveryStreamCommoditySources',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41460,
        description: 'Number of commodity sources in the repeating group.',
    },
    {
        name: 'LegDeliveryStreamCommoditySource',
        abbrName: 'Src',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41461,
        description:
            'The SCoTA coal cargo origin, mining region, mine(s), mining complex(es), loadout(s) or river dock(s) or other point(s) of origin that seller and buyer agree are acceptable origins for the coal product. For international coal transactions, this is the origin of the coal product.\n\nSee http://www.fpml.org/coding-scheme/commodity-coal-product-source for values.',
    },
    {
        name: 'NoLegInstrumentParties',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2254,
        description: 'Number of parties in the repeating group.',
    },
    {
        name: 'LegInstrumentPartyID',
        abbrName: 'ID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2255,
        discriminatorId: '2256',
        description: 'Used to identify party id related to instrument.',
    },
    {
        name: 'LegInstrumentPartyIDSource',
        abbrName: 'Src',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PartyIDSourceCodeSet',
        id: 2256,
        description: 'Used to identify source of instrument party id.',
    },
    {
        name: 'LegInstrumentPartyRole',
        abbrName: 'R',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PartyRoleCodeSet',
        id: 2257,
        description: 'Used to identify the role of instrument party id.',
    },
    {
        name: 'NoLegInstrumentPartySubIDs',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2258,
        description: 'Number of parties sub-IDs in the repeating group.',
    },
    {
        name: 'LegInstrumentPartySubID',
        abbrName: 'ID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2259,
        description: 'PartySubID value within an instrument party repeating group.',
    },
    {
        name: 'LegInstrumentPartySubIDType',
        abbrName: 'Typ',
        unionDataType: 'Reserved4000Plus',
        updated: 'FIX.Latest',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PartySubIDTypeCodeSet',
        updatedEP: '294',
        id: 2260,
        description: 'Type of LegInstrumentPartySubID (2259) value.',
    },
    {
        name: 'LegMarketDisruptionProvision',
        abbrName: 'Prov',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'MarketDisruptionProvisionCodeSet',
        id: 41462,
        description: 'The consequences of market disruption events.',
    },
    {
        name: 'LegMarketDisruptionFallbackProvision',
        abbrName: 'FallbckProv',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'MarketDisruptionFallbackProvisionCodeSet',
        id: 41463,
        description: 'Specifies the location of the fallback provision documentation.',
    },
    {
        name: 'LegMarketDisruptionMaximumDays',
        abbrName: 'MaxDays',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41464,
        description:
            'Specifies the maximum number of market disruption days (commodity or bullion business days) in a contract or confirmation. If none are specified, the maximum number of market disruption days is five (5).\n\nISDA 2005 Commodity Definition.',
    },
    {
        name: 'LegMarketDisruptionMaterialityPercentage',
        abbrName: 'MtrltyPctage',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 41465,
        description:
            'Used when a price materiality percentage applies to the price source disruption event and this event has been specified.\n\nApplicable to 2005 Commodity Definitions only.',
    },
    {
        name: 'LegMarketDisruptionMinimumFuturesContracts',
        abbrName: 'MinCtrcts',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41466,
        description:
            "Specifies the minimum futures contracts level that dictates whether or not a 'De Minimis Trading' event has occurred.\n\nApplicable to 1993 Commodity Definitions only.",
    },
    {
        name: 'NoLegMarketDisruptionEvents',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41467,
        description: 'Number of disruption events in the repeating group.',
    },
    {
        name: 'LegMarketDisruptionEvent',
        abbrName: 'Evnt',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        updatedEP: '187',
        id: 41468,
        description:
            'Specifies the market disruption event.\n\nFor commodities see http://www.fpml.org/coding-scheme/commodity-market-disruption for values.\n\nFor foreign exchange, see http://www.fixtradingcommunity.org/codelists#Market_Disruption_Event for code list of applicable event types.',
    },
    {
        name: 'NoLegMarketDisruptionFallbacks',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41469,
        description: 'Number of fallbacks in the repeating group.',
    },
    {
        name: 'LegMarketDisruptionFallbackType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41470,
        description:
            'Specifies the type of disruption fallback.\n\nSee http://www.fpml.org/coding-scheme/commodity-market-disruption-fallback for values.',
    },
    {
        name: 'NoLegMarketDisruptionFallbackReferencePrices',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41471,
        description: 'Number of fallback reference securities in the repeating group.',
    },
    {
        name: 'LegMarketDisruptionFallbackUnderlierType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'MarketDisruptionFallbackUnderlierTypeCodeSet',
        id: 41472,
        description: 'The type of reference price underlier.',
    },
    {
        name: 'LegMarketDisruptionFallbackUnderlierSecurityID',
        abbrName: 'ID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41473,
        discriminatorId: '41474',
        description: 'Specifies the identifier value of the security.',
    },
    {
        name: 'LegMarketDisruptionFallbackUnderlierSecurityIDSource',
        abbrName: 'Src',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.Latest',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'SecurityIDSourceCodeSet',
        updatedEP: '265',
        id: 41474,
        description: 'Specifies the class or source scheme of the security identifier.',
    },
    {
        name: 'LegMarketDisruptionFallbackUnderlierSecurityDesc',
        abbrName: 'Desc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41475,
        description: 'Specifies the description of the underlying security.',
    },
    {
        name: 'EncodedLegMarketDisruptionFallbackUnderlierSecurityDescLen',
        abbrName: 'EncDescLen',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 41476,
        description:
            'Byte length of encoded (non-ASCII characters) EncodedLegMarketDisruptionFallbackUnderlierSecurityDesc (41477) field.',
    },
    {
        name: 'EncodedLegMarketDisruptionFallbackUnderlierSecurityDesc',
        abbrName: 'EncDesc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 41477,
        lengthId: '41476',
        description:
            'Encoded (non-ASCII characters) representation of the LegMarketDisruptionFallbackUnderlierSecurityDesc(41475) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the LegMarketDisruptionFallbackUnderlierSecurityDesc(41475) field.',
    },
    {
        name: 'LegMarketDisruptionFallbackOpenUnits',
        abbrName: 'OpnUnits',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 41478,
        description:
            'If there are multiple underlying assets, this specifies the number of units (index or securities) that constitute the underlier of the swap. In the case of a basket swap, this is used to reference both the number of basket units, and the number of each asset components of the basket when these are expressed in absolute terms.',
    },
    {
        name: 'LegMarketDisruptionFallbackBasketCurrency',
        abbrName: 'Ccy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41479,
        description: 'Specifies the currency if the underlier is a basket. Uses ISO 4217 currency codes.',
    },
    {
        name: 'LegMarketDisruptionFallbackBasketDivisor',
        abbrName: 'Dvsr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 41480,
        description:
            'Specifies the basket divisor amount. This value is normally used to adjust the constituent weight for pricing or to adjust for dividends, or other corporate actions.',
    },
    {
        name: 'LegExerciseDesc',
        abbrName: 'Desc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41481,
        description: 'A description of the option exercise.',
    },
    {
        name: 'EncodedLegExerciseDescLen',
        abbrName: 'EncDescLen',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 41482,
        description: 'Byte length of encoded (non-ASCII characters) EncodedLegExerciseDesc(41483) field.',
    },
    {
        name: 'EncodedLegExerciseDesc',
        abbrName: 'EncDesc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 41483,
        lengthId: '41482',
        description:
            'Encoded (non-ASCII characters) representation of the LegExerciseDesc(41481) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the LegExerciseDesc(41481) field.',
    },
    {
        name: 'LegAutomaticExerciseIndicator',
        abbrName: 'AutoExerInd',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 41484,
        description:
            "Indicates (when 'Y') that exercise is automatic when the strike price is crossed or the underlying trade is in the money.",
    },
    {
        name: 'LegAutomaticExerciseThresholdRate',
        abbrName: 'AutoRt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 41485,
        description: 'The threshold rate for triggering automatic exercise.',
    },
    {
        name: 'LegExerciseConfirmationMethod',
        abbrName: 'ExerCnfm',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ExerciseConfirmationMethodCodeSet',
        id: 41486,
        description:
            "Indicates whether follow-up confirmation of exercise (written or electronic) is required following telephonic notice by the buyer to the seller or seller's agent.",
    },
    {
        name: 'LegManualNoticeBusinessCenter',
        abbrName: 'ManNtcBizCtr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41487,
        description:
            'Identifies the business center used for adjusting the time for manual exercise notice.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegFallbackExerciseIndicator',
        abbrName: 'FallbckExerInd',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 41488,
        description:
            'Indicates whether the notional amount of the underlying swap, not previously exercised under the option, will be automatically exercised at the expiration time on the expiration date if at such time the buyer is in-the-money, provided that the difference between the settlement rate and the fixed rate under the relevant underlying swap is not less than one tenth of a percentage point (0.10% or 0.001).',
    },
    {
        name: 'LegLimitRightToConfirmIndicator',
        abbrName: 'LtdRightCnfmInd',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 41489,
        description:
            'Indicates whether the Seller may request the Buyer to confirm its intent to exercise if not done on or before the expiration time on the expiration date. If true ("Y") specific rules will apply in relation to the settlement mode.',
    },
    {
        name: 'LegExerciseSplitTicketIndicator',
        abbrName: 'ExerSplitTktInd',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 41490,
        description:
            'Indicates in physical settlement of bond and convertible bond options whether the party required to deliver the bonds will divide those to be delivered as notifying party desires to facilitate delivery obligations.',
    },
    {
        name: 'NoLegOptionExerciseBusinessCenters',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41491,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'LegOptionExerciseBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41492,
        description:
            'The business center calendar used to adjust the option exercise dates, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegOptionExerciseBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 41493,
        description:
            'The business day convention used to adjust the option exercise dates. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.',
    },
    {
        name: 'LegOptionExerciseEarliestDateOffsetDayType',
        abbrName: 'ErlstOfstDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 41494,
        description: 'Specifies the day type of the relative earliest exercise date offset.',
    },
    {
        name: 'LegOptionExerciseEarliestDateOffsetPeriod',
        abbrName: 'ErlstOfstPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41495,
        description: 'Time unit multiplier for the relative earliest exercise date offset.',
    },
    {
        name: 'LegOptionExerciseEarliestDateOffsetUnit',
        abbrName: 'ErlstOfstUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ProvisionOptionExerciseEarliestDateOffsetUnitCodeSet',
        id: 41496,
        description: 'Time unit associated with the relative earliest exercise date offset.',
    },
    {
        name: 'LegOptionExerciseFrequencyPeriod',
        abbrName: 'FreqPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41497,
        description: 'Time unit multiplier for the frequency of exercise dates.',
    },
    {
        name: 'LegOptionExerciseFrequencyUnit',
        abbrName: 'FreqUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ProtectionTermEventUnitCodeSet',
        id: 41498,
        description: 'Time unit associated with the frequency of exercise dates.',
    },
    {
        name: 'LegOptionExerciseStartDateUnadjusted',
        abbrName: 'StartDtUnadj',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41499,
        description: 'The unadjusted start date for calculating periodic exercise dates.',
    },
    {
        name: 'LegOptionExerciseStartDateRelativeTo',
        abbrName: 'StartDtReltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41500,
        description:
            'Specifies the anchor date when the option exercise start date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'LegOptionExerciseStartDateOffsetPeriod',
        abbrName: 'StartDtOfstPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41501,
        description: 'Time unit multiplier for the relative exercise start date offset.',
    },
    {
        name: 'LegOptionExerciseStartDateOffsetUnit',
        abbrName: 'StartDtOfstUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 41502,
        description: 'Time unit associated with the relative exercise start date offset.',
    },
    {
        name: 'LegOptionExerciseStartDateOffsetDayType',
        abbrName: 'StartDtOfstDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 41503,
        description: 'Specifies the day type of the relative option exercise start date offset.',
    },
    {
        name: 'LegOptionExerciseStartDateAdjusted',
        abbrName: 'StartDt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41504,
        description: 'The adjusted start date for calculating periodic exercise dates.',
    },
    {
        name: 'LegOptionExerciseSkip',
        abbrName: 'Skip',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41505,
        description:
            'The number of periods in the referenced date schedule that are between each date in the relative date schedule. Thus a skip of 2 would mean that dates are relative to every second date in the referenced schedule. If present this should have a value greater than 1.',
    },
    {
        name: 'LegOptionExerciseNominationDeadline',
        abbrName: 'NomntnDdln',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41506,
        description: 'The last date (adjusted) for establishing the option exercise terms.',
    },
    {
        name: 'LegOptionExerciseFirstDateUnadjusted',
        abbrName: 'FirstDtUnadj',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41507,
        description: 'The unadjusted first exercise date.',
    },
    {
        name: 'LegOptionExerciseLastDateUnadjusted',
        abbrName: 'LastDtUnadj',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41508,
        description: 'The unadjusted last exercise date.',
    },
    {
        name: 'LegOptionExerciseEarliestTime',
        abbrName: 'ErlstTm',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 41509,
        description:
            "The earliest time at which notice of exercise can be given by the buyer to the seller (or seller's agent) (i) on the expriation date, in the case of a European style option, (ii) on each Bermuda option exercise date and the expiration date, in the case of a Bermuda style option, (iii) the commencement date to, and including, the expiration date, in the case of an American option.",
    },
    {
        name: 'LegOptionExerciseLatestTime',
        abbrName: 'LtstTm',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 41510,
        description: 'The latest exercise time. See also LegOptionExerciseEarliestTime(41509).',
    },
    {
        name: 'LegOptionExerciseTimeBusinessCenter',
        abbrName: 'TmBizCtr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41511,
        description:
            'The business center used to determine the locale for option exercise time, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'NoLegOptionExerciseDates',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41512,
        description: 'Number of dates in the repeating group.',
    },
    {
        name: 'LegOptionExerciseDate',
        abbrName: 'Dt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41513,
        description: 'The adjusted or unadjusted option exercise fixed date.',
    },
    {
        name: 'LegOptionExerciseDateType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'OptionExerciseDateTypeCodeSet',
        id: 41514,
        description:
            'Specifies the type of option exercise date. When specified it applies not only to the current date but to all subsequent dates in the group until overridden with a new type.',
    },
    {
        name: 'NoLegOptionExerciseExpirationDateBusinessCenters',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41515,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'LegOptionExerciseExpirationDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41516,
        description:
            'The business center calendar used to adjust the option exercise expiration dates, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegOptionExerciseExpirationDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 41517,
        description:
            'The business day convention used to adjust the option exercise expiration dates. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.',
    },
    {
        name: 'LegOptionExerciseExpirationDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41518,
        description:
            'Specifies the anchor date when the option exercise expiration date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'LegOptionExerciseExpirationDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41519,
        description: 'Time unit multiplier for the relative exercise expiration date offset.',
    },
    {
        name: 'LegOptionExerciseExpirationDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 41520,
        description: 'Time unit associated with the relative exercise expiration date offset.',
    },
    {
        name: 'LegOptionExerciseExpirationFrequencyPeriod',
        abbrName: 'FreqPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41521,
        description: 'Time unit multiplier for the frequency of exercise expiration dates.',
    },
    {
        name: 'LegOptionExerciseExpirationFrequencyUnit',
        abbrName: 'FreqUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ProtectionTermEventUnitCodeSet',
        id: 41522,
        description: 'Time unit associated with the frequency of exercise expiration dates.',
    },
    {
        name: 'LegOptionExerciseExpirationRollConvention',
        abbrName: 'Roll',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DateRollConventionCodeSet',
        id: 41523,
        description:
            'The convention for determining the sequence of exercise expiration dates. It is used in conjunction with a specified frequency. Used only to override the roll convention defined in the LegDateAdjustment component in InstrumentLeg.',
    },
    {
        name: 'LegOptionExerciseExpirationDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 41524,
        description: 'Specifies the day type of the relative option exercise expiration date offset.',
    },
    {
        name: 'LegOptionExerciseExpirationTime',
        abbrName: 'Tm',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 41525,
        description: 'The option exercise expiration time.',
    },
    {
        name: 'LegOptionExerciseExpirationTimeBusinessCenter',
        abbrName: 'TmBizCtr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41526,
        description:
            'The business center used to determine the locale for option exercise expiration time, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'NoLegOptionExerciseExpirationDates',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41527,
        description: 'Number of fixed exercise expiration dates in the repeating group.',
    },
    {
        name: 'LegOptionExerciseExpirationDate',
        abbrName: 'Dt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41528,
        description: 'The adjusted or unadjusted option exercise expiration fixed date.',
    },
    {
        name: 'LegOptionExerciseExpirationDateType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'OptionExerciseDateTypeCodeSet',
        id: 41529,
        description:
            'Specifies the type of option exercise expiration date. When specified it applies not only to the current date but to all subsequent dates in the group until overridden with a new type.',
    },
    {
        name: 'NoLegPaymentScheduleFixingDays',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41530,
        description: 'Number of fixing days in the repeating group.',
    },
    {
        name: 'LegPaymentScheduleFixingDayOfWeek',
        abbrName: 'DayOfWk',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPricingDayOfWeekCodeSet',
        id: 41531,
        description: 'The day of the week on which fixing takes place.',
    },
    {
        name: 'LegPaymentScheduleFixingDayNumber',
        abbrName: 'DayNum',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41532,
        description:
            'The occurrence of the day of week on which fixing takes place.\n\nFor example, a fixing of the 3rd Friday would be DayOfWk=5 DayNum=3. If omitted every day of the week is a fixing day.',
    },
    {
        name: 'LegPaymentScheduleXID',
        abbrName: 'XID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XID',
        id: 41533,
        description: 'Identifier of this LegPaymentSchedule for cross referencing elsewhere in the message.',
    },
    {
        name: 'LegPaymentScheduleXIDRef',
        abbrName: 'XIDRef',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XIDREF',
        id: 41534,
        description: 'Reference to payment schedule elsewhere in the message.',
    },
    {
        name: 'LegPaymentScheduleRateCurrency',
        abbrName: 'RtCcy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41535,
        description: 'The currency of the schedule rate. Uses ISO 4217 currency codes.',
    },
    {
        name: 'LegPaymentScheduleRateUnitOfMeasure',
        abbrName: 'RtUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41536,
        description: 'The schedule rate unit of measure (UOM).',
    },
    {
        name: 'LegPaymentScheduleRateConversionFactor',
        abbrName: 'RtFctr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 41537,
        description:
            "The number multipled by the derived floating rate of the leg's payment schedule in order to arrive at the payment rate. If omitted, the schedule rate conversion factor is 1.",
    },
    {
        name: 'LegPaymentScheduleRateSpreadType',
        abbrName: 'SpreadTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateSpreadTypeCodeSet',
        id: 41538,
        description:
            'Identifies whether the rate spread is an absolute value to be added to the index rate or a percentage of the index rate.',
    },
    {
        name: 'LegPaymentScheduleSettlPeriodPrice',
        abbrName: 'SettlPx',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 41539,
        description: 'The schedule settlement period price.',
    },
    {
        name: 'LegPaymentScheduleSettlPeriodPriceCurrency',
        abbrName: 'SettlPxCcy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41540,
        description: 'The currency of the schedule settlement period price. Uses ISO 4217 currency codes.',
    },
    {
        name: 'LegPaymentScheduleSettlPeriodPriceUnitOfMeasure',
        abbrName: 'SettlPxUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41541,
        description: 'The settlement period price unit of measure (UOM).',
    },
    {
        name: 'LegPaymentScheduleStepUnitOfMeasure',
        abbrName: 'StepUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41542,
        description: 'The schedule step unit of measure (UOM).',
    },
    {
        name: 'LegPaymentScheduleFixingDayDistribution',
        abbrName: 'FixngDayDistrib',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPricingDayDistributionCodeSet',
        id: 41543,
        description: 'The distribution of fixing days.',
    },
    {
        name: 'LegPaymentScheduleFixingDayCount',
        abbrName: 'FixngDayCnt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41544,
        description: 'The number of days over which fixing should take place.',
    },
    {
        name: 'LegPaymentScheduleFixingLagPeriod',
        abbrName: 'FixngLagPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41545,
        description: 'Time unit multiplier for the fixing lag duration.',
    },
    {
        name: 'LegPaymentScheduleFixingLagUnit',
        abbrName: 'FixngLagUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamInflationLagUnitCodeSet',
        id: 41546,
        description: 'Time unit associated with the fixing lag duration.',
    },
    {
        name: 'LegPaymentScheduleFixingFirstObservationDateOffsetPeriod',
        abbrName: 'FixngFirstObsvtnPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 41547,
        description:
            'Time unit multiplier for the relative first observation date offset.\n\nIf the first observation offset is specified, the observation period will start the specified interval prior to each calculation period - i.e. if the first observation offset is 4 months and the lag duration is 3 months, observations will be taken in months 4, 3 and 2 (but not 1) prior to each calculation period. If no first observation offset is specified, the observation period will end immediately preceding each calculation period.',
    },
    {
        name: 'LegPaymentScheduleFixingFirstObservationDateOffsetUnit',
        abbrName: 'FixngFirstObsvtnUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 41548,
        description: 'Time unit associated with the relative first observation date offset.',
    },
    {
        name: 'LegPaymentStreamFlatRateIndicator',
        abbrName: 'FlatRtInd',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 41549,
        description:
            'When this element is specified and set to \'Y\', the Flat Rate is the New Worldwide Tanker Nominal Freight Scale for the Freight Index Route taken at the trade date of the transaction "Fixed". If \'N\' it is taken on each pricing date "Floating".',
    },
    {
        name: 'LegPaymentStreamFlatRateAmount',
        abbrName: 'FlatRtAmt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 41550,
        description:
            "Specifies the actual monetary value of the flat rate when LegPaymentStreamFlatRateIndicator(41549) = 'Y'.",
    },
    {
        name: 'LegPaymentStreamFlatRateCurrency',
        abbrName: 'FlatRtCcy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41551,
        description: 'Specifies the currency of the actual flat rate. Uses ISO 4217 currency codes.',
    },
    {
        name: 'LegStreamMaximumPaymentAmount',
        abbrName: 'MaxPmtAmt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 41552,
        description: 'Specifies the limit on the total payment amount.',
    },
    {
        name: 'LegStreamMaximumPaymentCurrency',
        abbrName: 'MaxPmtCcy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41553,
        description: 'Specifies the currency of total payment amount limit. Uses ISO 4217 currency codes.',
    },
    {
        name: 'LegStreamMaximumTransactionAmount',
        abbrName: 'MaxTxnAmt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 41554,
        description: 'Specifies the limit on the payment amount that goes out in any particular calculation period.',
    },
    {
        name: 'LegStreamMaximumTransactionCurrency',
        abbrName: 'MaxTxnCcy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41555,
        description: 'Specifies the currency of the period payment amount limit. Uses ISO 4217 currency codes.',
    },
    {
        name: 'LegPaymentStreamFixedAmountUnitOfMeasure',
        abbrName: 'FixedAmtUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41556,
        description: 'The fixed payment amount unit of measure (UOM).',
    },
    {
        name: 'LegPaymentStreamTotalFixedAmount',
        abbrName: 'FixedAmt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 41557,
        description: 'Specifies the total fixed payment amount.',
    },
    {
        name: 'LegPaymentStreamWorldScaleRate',
        abbrName: 'WorldScaleRt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 41558,
        description:
            'The number of Worldscale points for purposes of the calculation of a fixed amount for a wet voyage charter commodity swap.',
    },
    {
        name: 'LegPaymentStreamContractPrice',
        abbrName: 'CtrctPx',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 41559,
        description:
            'The price per relevant unit for purposes of the calculation of a fixed amount for a dry voyage charter or time charter commodity swap.',
    },
    {
        name: 'LegPaymentStreamContractPriceCurrency',
        abbrName: 'CtrctPxCcy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41560,
        description: 'Specifies the currency of LegPaymentStreamContractPrice(41559). Uses ISO 4217 currency codes.',
    },
    {
        name: 'NoLegPaymentStreamPricingBusinessCenters',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41561,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'LegPaymentStreamPricingBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41562,
        description:
            'The business center calendar used to adjust the pricing dates, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegPaymentStreamRateIndex2CurveUnit',
        abbrName: 'Ndx2Unit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexCurveUnitCodeSet',
        id: 41563,
        description: "Secondary time unit associated with the payment stream's floating rate index curve.",
    },
    {
        name: 'LegPaymentStreamRateIndex2CurvePeriod',
        abbrName: 'Ndx2Period',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41564,
        description:
            "Secondary time unit multiplier for the payment stream's floating rate index curve.\n\nMay be used for a Forward Rate Agreement (FRA) with an average rate between two curve points.",
    },
    {
        name: 'LegPaymentStreamRateIndexLocation',
        abbrName: 'NdxLctn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41565,
        description: 'Specifies the location of the floating rate index.',
    },
    {
        name: 'LegPaymentStreamRateIndexLevel',
        abbrName: 'NdxLvl',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 41566,
        description:
            'This is the weather Cooling Degree Days (CDD), Heating Degree Days (HDD) or HDD index level specified as the number of (amount of) weather index units specified by the parties in the related confirmation.',
    },
    {
        name: 'LegPaymentStreamRateIndexUnitOfMeasure',
        abbrName: 'NdxUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41567,
        description: 'The unit of measure (UOM) of the rate index level.',
    },
    {
        name: 'LegPaymentStreamSettlLevel',
        abbrName: 'SettlLvl',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamSettlLevelCodeSet',
        id: 41568,
        description: 'Specifies how weather index units are to be calculated.',
    },
    {
        name: 'LegPaymentStreamReferenceLevel',
        abbrName: 'RefLvl',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 41569,
        description:
            'This is the weather Cooling Degree Days (CDD), Heating Degree Days (HDD) or HDD reference level specified as the number of (amount of) weather index units specified by the parties in the related confirmation.',
    },
    {
        name: 'LegPaymentStreamReferenceLevelUnitOfMeasure',
        abbrName: 'RefUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41570,
        description: 'The unit of measure (UOM) of the rate reference level.',
    },
    {
        name: 'LegPaymentStreamReferenceLevelEqualsZeroIndicator',
        abbrName: 'RefLvlZero',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 41571,
        description: "When set to 'Y', it indicates that the weather reference level equals zero.",
    },
    {
        name: 'LegPaymentStreamRateSpreadCurrency',
        abbrName: 'SpreadCcy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41572,
        description: 'Specifies the currency of the floating rate spread. Uses ISO 4217 currency codes.',
    },
    {
        name: 'LegPaymentStreamRateSpreadUnitOfMeasure',
        abbrName: 'SpreadUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41573,
        description: 'Specifies the unit of measure (UOM) of the floating rate spread.',
    },
    {
        name: 'LegPaymentStreamRateConversionFactor',
        abbrName: 'RtFctr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 41574,
        description:
            "The number to be multiplied by the derived floating rate of the leg's payment stream in order to arrive at the payment rate. If omitted, the floating rate conversion factor is 1.",
    },
    {
        name: 'LegPaymentStreamRateSpreadType',
        abbrName: 'SpreadTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateSpreadTypeCodeSet',
        id: 41575,
        description:
            'Identifies whether the rate spread is an absolute value to be added to the index rate or a percentage of the index rate.',
    },
    {
        name: 'LegPaymentStreamLastResetRate',
        abbrName: 'LastResetRt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 41576,
        description:
            'The floating rate determined at the most recent reset. The rate is expressed in decimal form, e.g. 5% is represented as 0.05.',
    },
    {
        name: 'LegPaymentStreamFinalRate',
        abbrName: 'FnlRt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 41577,
        description:
            'The floating rate determined at the final reset. The rate is expressed in decimal form, e.g. 5% is represented as 0.05.',
    },
    {
        name: 'LegPaymentStreamCalculationLagPeriod',
        abbrName: 'CalcLagPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41578,
        description: 'Time unit multiplier for the calculation lag duration.',
    },
    {
        name: 'LegPaymentStreamCalculationLagUnit',
        abbrName: 'CalcLagUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamInflationLagUnitCodeSet',
        id: 41579,
        description: 'Time unit associated with the calculation lag duration.',
    },
    {
        name: 'LegPaymentStreamFirstObservationDateOffsetPeriod',
        abbrName: 'FirstObsvtnOfstPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 41580,
        description:
            'Time unit multiplier for the relative first observation date offset.\n\nIf the first observation offset is specified, the observation period will start the specified interval prior to each calculation period - i.e. if the first observation offset is 4 months and the lag duration is 3 months, observations will be taken in months 4, 3 and 2 (but not 1) prior to each calculation period. If no first observation offset is specified, the observation period will end immediately preceding each calculation period.',
    },
    {
        name: 'LegPaymentStreamFirstObservationDateOffsetUnit',
        abbrName: 'FirstObsvtnOfstUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 41581,
        description: 'Time unit associated with the relative first observation date offset.',
    },
    {
        name: 'LegPaymentStreamPricingDayType',
        abbrName: 'PxngDayTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventDateOffsetDayTypeCodeSet',
        id: 41582,
        description: 'Specifies the commodity pricing day type.',
    },
    {
        name: 'LegPaymentStreamPricingDayDistribution',
        abbrName: 'PxngDayDistrib',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPricingDayDistributionCodeSet',
        id: 41583,
        description: 'The distribution of pricing days.',
    },
    {
        name: 'LegPaymentStreamPricingDayCount',
        abbrName: 'PxngDayCnt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41584,
        description: 'The number of days over which pricing should take place.',
    },
    {
        name: 'LegPaymentStreamPricingBusinessCalendar',
        abbrName: 'PxngClndr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41585,
        description:
            'Specifies the business calendar to use for pricing.\n\nSee http://www.fpml.org/coding-scheme/commodity-business-calendar for values.',
    },
    {
        name: 'LegPaymentStreamPricingBusinessDayConvention',
        abbrName: 'PxngBizDayCnvtn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 41586,
        description:
            "The business day convention used to adjust the payment stream's pricing dates. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.",
    },
    {
        name: 'NoLegPaymentStreamPaymentDates',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41589,
        description: 'Number of payment dates in the repeating group.',
    },
    {
        name: 'LegPaymentStreamPaymentDate',
        abbrName: 'Dt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41590,
        description: 'The adjusted or unadjusted fixed stream payment date.',
    },
    {
        name: 'LegPaymentStreamPaymentDateType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'OptionExerciseDateTypeCodeSet',
        id: 41591,
        description:
            'Specifies the type of payment date. When specified it applies not only to the current date but to all subsequent dates in the group until overridden with a new type.',
    },
    {
        name: 'LegPaymentStreamMasterAgreementPaymentDatesIndicator',
        abbrName: 'MADts',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 41592,
        description: "When set to 'Y', it indicates that payment dates are specified in the relevant master agreement.",
    },
    {
        name: 'NoLegPaymentStreamPricingDates',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41593,
        description: 'Number of pricing dates in the repeating group.',
    },
    {
        name: 'LegPaymentStreamPricingDate',
        abbrName: 'Dt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41594,
        description: 'The adjusted or unadusted fixed stream pricing date.',
    },
    {
        name: 'LegPaymentStreamPricingDateType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'OptionExerciseDateTypeCodeSet',
        id: 41595,
        description:
            'Specifies the type of pricing date. When specified it applies not only to the current date but to all subsequent dates in the group until overridden with a new type.',
    },
    {
        name: 'NoLegPaymentStreamPricingDays',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41596,
        description: 'Number of pricing days in the repeating group.',
    },
    {
        name: 'LegPaymentStreamPricingDayOfWeek',
        abbrName: 'DayOfWk',
        updated: 'FIX.Latest',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPricingDayOfWeekCodeSet',
        updatedEP: '282',
        id: 41597,
        description: 'The day of the week on which pricing takes place.',
    },
    {
        name: 'LegPaymentStreamPricingDayNumber',
        abbrName: 'DayNum',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41598,
        description:
            'The occurrence of the day of week on which pricing takes place.\n\nFor example a pricing day of the 3rd Friday would be DayOfWk=5 DayNum=3.',
    },
    {
        name: 'NoLegPhysicalSettlTerms',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41599,
        description: 'Number of entries in the repeating group.',
    },
    {
        name: 'LegPhysicalSettlTermXID',
        abbrName: 'XID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XID',
        id: 41600,
        description: 'A named string value referenced by UnderlyingSettlTermXIDRef(41315).',
    },
    {
        name: 'LegPhysicalSettlCurency',
        abbrName: 'Ccy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41601,
        description: 'Specifies the currency of physical settlement. Uses ISO 4217 currency codes.',
    },
    {
        name: 'LegPhysicalSettlBusinessDays',
        abbrName: 'BizDays',
        updated: 'FIX.Latest',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '271',
        id: 41602,
        description:
            'The number of business days used in the determination of physical settlement. Its precise meaning depends on the context in which this is used.\n\nISDA 2003 Term: Business Day.',
    },
    {
        name: 'LegPhysicalSettlMaximumBusinessDays',
        abbrName: 'MaxBizDays',
        updated: 'FIX.Latest',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '271',
        id: 41603,
        description:
            'A maximum number of business days. Its precise meaning depends on the context in which this element is used. Intended to be used to limit a particular ISDA fallback provision.',
    },
    {
        name: 'NoLegPhysicalSettlDeliverableObligations',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41604,
        description: 'Number of entries in the repeating group.',
    },
    {
        name: 'LegPhysicalSettlDeliverableObligationType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41605,
        description:
            'Specifies the type of delivery obligation applicable for physical settlement.\n\nSee http://www.fixptradingcommunity.org/codelists#Deliverable_Obligation_Types for code list for applicable deliverable obligation types.',
    },
    {
        name: 'LegPhysicalSettlDeliverableObligationValue',
        abbrName: 'Val',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41606,
        description:
            'Physical settlement delivery obligation value appropriate to LegPhysicalSettlDeliverableObligationType(41605).\n\nSee http://www.fixtradingcommunity.org/codelists#Deliverable_Obligation_Types for code list for applicable deliverable obligation types.',
    },
    {
        name: 'NoLegPricingDateBusinessCenters',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41607,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'LegPricingDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41608,
        description:
            'The business center calendar used to adjust the pricing or fixing date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegPricingDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41609,
        description: 'The unadjusted pricing or fixing date.',
    },
    {
        name: 'LegPricingDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 41610,
        description:
            'The business day convention used to adjust the pricing or fixing date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.',
    },
    {
        name: 'LegPricingDateAdjusted',
        abbrName: 'Dt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41611,
        description: 'The adjusted pricing or fixing date.',
    },
    {
        name: 'LegPricingTime',
        abbrName: 'Tm',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 41612,
        description: 'The local market pricing or fixing time.',
    },
    {
        name: 'LegPricingTimeBusinessCenter',
        abbrName: 'TmBizCtr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41613,
        description:
            'Specifies the business center for determining the pricing or fixing time. See http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'NoLegProtectionTermEventNewsSources',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41614,
        description: 'Number of event sources in the repeating group.',
    },
    {
        name: 'LegProtectionTermEventNewsSource',
        abbrName: 'Src',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41615,
        description:
            'A newspaper or electronic news service that may publish relevant information used in the determination of whether or not a credit event has occurred.',
    },
    {
        name: 'NoLegProtectionTerms',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41616,
        description: 'Number of protection terms in the repeating group.',
    },
    {
        name: 'LegProtectionTermXID',
        abbrName: 'XID',
        updated: 'FIX.Latest',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XID',
        updatedEP: '271',
        id: 41617,
        description: 'A named string value referenced from UnderlyingProtectionTermXIDRef(41314).',
    },
    {
        name: 'LegProtectionTermNotional',
        abbrName: 'Notl',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 41618,
        description:
            'The notional amount of protection coverage.\n\nISDA 2003 Term: Floating Rate Payer Calculation Amount.',
    },
    {
        name: 'LegProtectionTermCurrency',
        abbrName: 'Ccy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41619,
        description: 'The currency of LegProtectionTermNotional(41618). Uses ISO 4217 currency codes.',
    },
    {
        name: 'LegProtectionTermSellerNotifies',
        abbrName: 'Seller',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 41620,
        description:
            'The notifying party is the party that notifies the other party when a credit event has occurred by means of a credit event notice. If more than one party is referenced as being the notifying party then either party may notify the other of a credit event occurring. LegProtectionTermSellerNotifies(41620)=Y indicates that the seller notifies.\n\nISDA 2003 Term: Notifying Party.',
    },
    {
        name: 'LegProtectionTermBuyerNotifies',
        abbrName: 'Buyer',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 41621,
        description:
            'The notifying party is the party that notifies the other party when a credit event has occurred by means of a credit event notice. If more than one party is referenced as being the notifying party then either party may notify the other of a credit event occurring. LegProtectionTermBuyerNotifies(41621)=Y indicates that the buyer notifies.\n\nISDA 2003 Term: Notifying Party.',
    },
    {
        name: 'LegProtectionTermEventBusinessCenter',
        abbrName: 'BizCtr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41622,
        description:
            'When used, the business center indicates the local time of the business center that replaces the Greenwich Mean Time in Section 3.3 of the 2003 ISDA Credit Derivatives Definitions.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegProtectionTermStandardSources',
        abbrName: 'StdSrcs',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 41623,
        description:
            'Indicates whether ISDA defined Standard Public Sources are applicable (LegProtectionTermStandardSources(41623)=Y) or not.',
    },
    {
        name: 'LegProtectionTermEventMinimumSources',
        abbrName: 'MinSrcs',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41624,
        description:
            'The minimum number of the specified public information sources that must publish information that reasonably confirms that a credit event has occurred. The market convention is two.\n\nISDA 2003 Term: Specified Number.',
    },
    {
        name: 'NoLegProtectionTermEvents',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41625,
        description: 'Number of protection term events in the repeating group.',
    },
    {
        name: 'LegProtectionTermEventType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41626,
        description:
            'Specifies the type of credit event applicable to the protection terms.\n\nSee http://www.fixtradingcommunity.org/codelists#Protection_Term_Event_Types for code list of applicable event types.',
    },
    {
        name: 'LegProtectionTermEventValue',
        abbrName: 'Val',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41627,
        description:
            'Specifies the protection term event value appropriate to LegProtectionTermEventType(41626). See http:///www.fixtradingcommunity.org/codelists#Protection_Term_Event_Types for applicable event type values.',
    },
    {
        name: 'LegProtectionTermEventCurrency',
        abbrName: 'Ccy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41628,
        description: 'Applicable currency if the event value is an amount. Uses ISO 4217 currency codes.',
    },
    {
        name: 'LegProtectionTermEventPeriod',
        abbrName: 'Period',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41629,
        description: 'Time unit multiplier for protection term events.',
    },
    {
        name: 'LegProtectionTermEventUnit',
        abbrName: 'Unit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ProtectionTermEventUnitCodeSet',
        id: 41630,
        description: 'Time unit associated with protection term events.',
    },
    {
        name: 'LegProtectionTermEventDayType',
        abbrName: 'DayTyp',
        updated: 'FIX.Latest',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamInflationLagDayTypeCodeSet',
        updatedEP: '271',
        id: 41631,
        description: 'Day type for events that specify a period and unit.',
    },
    {
        name: 'LegProtectionTermEventRateSource',
        abbrName: 'RtSrc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41632,
        description: 'Rate source for events that specify a rate source, e.g. floating rate interest shortfall.',
    },
    {
        name: 'NoLegProtectionTermEventQualifiers',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41633,
        description: 'Number of qualifiers in the repeating group.',
    },
    {
        name: 'LegProtectionTermEventQualifier',
        abbrName: 'Qual',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ProtectionTermEventQualifierCodeSet',
        id: 41634,
        description:
            'Specifies the protection term event qualifier. Used to further qualify LegProtectionTermEventType(41626).',
    },
    {
        name: 'NoLegProtectionTermObligations',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41635,
        description: 'Number of obligations in the repeating group.',
    },
    {
        name: 'LegProtectionTermObligationType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41636,
        description:
            'Specifies the type of obligation applicable to the protection terms.\n\nSee http://www.fixtradingcommunity.org/codelists#Protection_Term_Obligation_Types for code list of applicable obligation types.',
    },
    {
        name: 'LegProtectionTermObligationValue',
        abbrName: 'Val',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41637,
        description:
            'The value associated with the protection term obligation specified in LegProtectionTermObligationType(41636). See http://www.fixtradingcommunity.org/codelists#Protection_Term_Obligation_Types for applicable obligation type values.',
    },
    {
        name: 'NoLegStreamCalculationPeriodDates',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41638,
        description: 'Number of calculation period dates in the repeating group.',
    },
    {
        name: 'LegStreamCalculationPeriodDate',
        abbrName: 'Dt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41639,
        description: 'The adjusted or unadjusted fixed calculation period date.',
    },
];

const batch6: ISpecFields[] = [
    {
        name: 'LegStreamCalculationPeriodDateType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'OptionExerciseDateTypeCodeSet',
        id: 41640,
        description:
            'Specifies the type of fixed calculation period date. When specified it applies not only to the current date but to all subsequent dates in the group until overridden with a new type.',
    },
    {
        name: 'LegStreamCalculationPeriodDatesXID',
        abbrName: 'XID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XID',
        id: 41641,
        description: 'Identifier of this calculation period for cross referencing elsewhere in the message.',
    },
    {
        name: 'LegStreamCalculationPeriodDatesXIDRef',
        abbrName: 'XIDRef',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XIDREF',
        id: 41642,
        description: 'Cross reference to another calculation period for duplicating its properties.',
    },
    {
        name: 'LegStreamCalculationBalanceOfFirstPeriod',
        abbrName: 'BalFirst',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 41643,
        description:
            "When specified and set to 'Y', it indicates that the first calculation period should run from the effective date to the end of the calendar period in which the effective date falls (e.g. Jan 15 - Jan 31 if the calculation periods are one month long and effective date is Jan 15.). If 'N' or not specified, it indicates that the first calculation period should run from the effective date for one whole period (e.g. Jan 15 to Feb 14 if the calculation periods are one month long and the effective date is Jan 15.).",
    },
    {
        name: 'LegStreamCalculationCorrectionPeriod',
        abbrName: 'CrrctnPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41644,
        description:
            'Time unit multiplier for the length of time after the publication of the data when corrections can be made.',
    },
    {
        name: 'LegStreamCalculationCorrectionUnit',
        abbrName: 'CrrctnUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ProtectionTermEventUnitCodeSet',
        id: 41645,
        description:
            'Time unit associated with the length of time after the publication of the data when corrections can be made.',
    },
    {
        name: 'NoLegStreamCommoditySettlBusinessCenters',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41646,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'LegStreamCommoditySettlBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41647,
        description:
            'The business center calendar used to adjust the commodity delivery date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegStreamCommodityBase',
        abbrName: 'Base',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41648,
        description:
            'Specifies the general base type of the commodity traded. Where possible, this should follow the naming convention used in the 2005 ISDA Commodity Definitions.\n\nExamples of general commodity base types include: Metal, Bullion, Oil, Natural Gas, Coal, Electricity, Inter-Energy, Grains, Oils Seeds, Dairy, Livestock, Forestry, Softs, Weather, Emissions.',
    },
    {
        name: 'LegStreamCommodityType',
        abbrName: 'CmdtyTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41649,
        description:
            'Specifies the type of commodity product.\n\nFor coal see http://www.fpml.org/coding-scheme/commodity-coal-product-type for values.\n\nFor metals see http://www.fpml.org/coding-scheme/commodity-metal-product-type for values.\n\nFor bullion see http://www.fixtradingcommunity.org/codelists#Bullion_Types for the external code list of bullion types.',
    },
    {
        name: 'LegStreamCommoditySecurityID',
        abbrName: 'ID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41650,
        discriminatorId: '41651',
        description: 'Specifies the market identifier for the commodity.',
    },
    {
        name: 'LegStreamCommoditySecurityIDSource',
        abbrName: 'Src',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.Latest',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'SecurityIDSourceCodeSet',
        updatedEP: '265',
        id: 41651,
        description: 'Identifies the class or source of the LegStreamCommoditySecurityIDSource(41650) value.',
    },
    {
        name: 'LegStreamCommodityDesc',
        abbrName: 'Desc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41652,
        description: 'Description of the commodity asset.',
    },
    {
        name: 'EncodedLegStreamCommodityDescLen',
        abbrName: 'EncDescLen',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 41653,
        description: 'Byte length of encoded (non-ASCII characters) EncodedLegStreamCommodityDesc(41654) field.',
    },
    {
        name: 'EncodedLegStreamCommodityDesc',
        abbrName: 'EncDesc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 41654,
        lengthId: '41653',
        description:
            'Encoded (non-ASCII characters) representation of the LegStreamCommodityDesc(41652) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the LegStreamCommodityDesc(41652) field.',
    },
    {
        name: 'LegStreamCommodityUnitOfMeasure',
        abbrName: 'UOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41655,
        description: 'The unit of measure (UOM) of the commodity asset.',
    },
    {
        name: 'LegStreamCommodityCurrency',
        abbrName: 'Ccy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41656,
        description: 'Identifies the currency of the commodity asset. Uses ISO 4217 currency codes.',
    },
    {
        name: 'LegStreamCommodityExchange',
        abbrName: 'Exch',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Exchange',
        id: 41657,
        description: 'Identifies the exchange where the commodity is traded.',
    },
    {
        name: 'LegStreamCommodityRateSource',
        abbrName: 'RtSrc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41658,
        description:
            'Identifies the source of rate information used for commodities.\n\nSee http://www.fixtradingcommunity.org/codelists#Commodity_Rate_Source for code list of applicable sources.',
    },
    {
        name: 'LegStreamCommodityRateReferencePage',
        abbrName: 'RefPg',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41659,
        description: 'Identifies the reference "page" from the rate source.',
    },
    {
        name: 'LegStreamCommodityRateReferencePageHeading',
        abbrName: 'RefHdng',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41660,
        description: 'Identifies the page heading from the rate source.',
    },
    {
        name: 'LegStreamDataProvider',
        abbrName: 'DataPrvdr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41661,
        description:
            'Specifies the commodity data or information provider.\n\nSee http://www.fpml.org/coding-scheme/commodity-information-provider for values.',
    },
    {
        name: 'LegStreamCommodityPricingType',
        abbrName: 'PxngTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41662,
        description:
            'Specifies how the pricing or rate setting of the trade is to be determined or based upon.\n\nSee http://www.fixtradingcommunity.org/codelists#Commodity_Rate_Pricing_Type for code list of applicable commodity pricing types.',
    },
    {
        name: 'LegStreamCommodityNearbySettlDayPeriod',
        abbrName: 'Period',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41663,
        description:
            'Time unit multiplier for the nearby settlement day.\n\nWhen the commodity transaction references a futures contract, the delivery or settlement dates are a nearby month or week. For example, for eighth nearby month use Period=8 and Unit=Mo.',
    },
    {
        name: 'LegStreamCommodityNearbySettlDayUnit',
        abbrName: 'Unit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'StreamCommodityNearbySettlDayUnitCodeSet',
        id: 41664,
        description: 'Time unit associated with the nearby settlement day.',
    },
    {
        name: 'LegStreamCommoditySettlDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41665,
        description: 'The unadjusted commodity delivery date.',
    },
    {
        name: 'LegStreamCommoditySettlDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 41666,
        description:
            'The business day convention used to adjust the commodity delivery date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.',
    },
    {
        name: 'LegStreamCommoditySettlDateAdjusted',
        abbrName: 'Dt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41667,
        description: 'The adjusted commodity delivery date.',
    },
    {
        name: 'LegStreamCommoditySettlMonth',
        abbrName: 'Mo',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41668,
        description:
            'Specifies a fixed single month for commodity delivery.\n\nUse "1" for January, "2" for February, etc.',
    },
    {
        name: 'LegStreamCommoditySettlDateRollPeriod',
        abbrName: 'RollPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41669,
        description:
            'Time unit multiplier for the commodity delivery date roll.\n\nFor a commodity transaction that references a listed future via the delivery dates, this is the day offset on which the specified future will roll to the next nearby month when the referenced future expires.',
    },
    {
        name: 'LegStreamCommoditySettlDateRollUnit',
        abbrName: 'RollUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'StreamCommoditySettlDateRollUnitCodeSet',
        id: 41670,
        description: 'Time unit associated with the commodity delivery date roll.',
    },
    {
        name: 'LegStreamCommoditySettlDayType',
        abbrName: 'DayTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventDateOffsetDayTypeCodeSet',
        id: 41671,
        description: 'Specifies the commodity delivery roll day type.',
    },
    {
        name: 'LegStreamCommodityXID',
        abbrName: 'XID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XID',
        id: 41672,
        description: 'Identifier of this stream commodity for cross referencing elsewhere in the message.',
    },
    {
        name: 'LegStreamCommodityXIDRef',
        abbrName: 'XIDRef',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XIDREF',
        id: 41673,
        description: 'Reference to a stream commodity elsewhere in the message.',
    },
    {
        name: 'NoLegStreamCommodityAltIDs',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41674,
        description: 'Number of alternate security identifers.',
    },
    {
        name: 'LegStreamCommodityAltID',
        abbrName: 'AltID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41675,
        discriminatorId: '41676',
        description: 'Alternate security identifier value for the commodity.',
    },
    {
        name: 'LegStreamCommodityAltIDSource',
        abbrName: 'AltIDSrc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41676,
        description: 'Identifies the class or source of the alternate commodity security identifier.',
    },
    {
        name: 'NoLegStreamCommodityDataSources',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41677,
        description:
            'Number of data sources in the repeating group. The order of entry determines priority – first is the main source, second is fallback, third is second fallback.',
    },
    {
        name: 'LegStreamCommodityDataSourceID',
        abbrName: 'ID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41678,
        description: 'Specifies the data source identifier.',
    },
    {
        name: 'LegStreamCommodityDataSourceIDType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'StreamCommodityDataSourceIDTypeCodeSet',
        id: 41679,
        description: 'Specifies the type of data source identifier.',
    },
    {
        name: 'NoLegStreamCommoditySettlDays',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41680,
        description: 'Number of days in the repeating group.',
    },
    {
        name: 'LegStreamCommoditySettlDay',
        abbrName: 'Day',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryScheduleSettlDayCodeSet',
        id: 41681,
        description: 'Specifies the day or group of days for delivery.',
    },
    {
        name: 'LegStreamCommoditySettlTotalHours',
        abbrName: 'TotHrs',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41682,
        description: 'Sum of the hours specified in LegStreamCommoditySettlTimeGrp.',
    },
    {
        name: 'NoLegStreamCommoditySettlTimes',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41683,
        description: 'Number of hour ranges in the repeating group.',
    },
    {
        name: 'LegStreamCommoditySettlStart',
        abbrName: 'Start',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41684,
        description:
            'The start time for commodity settlement where delivery occurs over time. The time format is specified by the settlement time type.',
    },
    {
        name: 'LegStreamCommoditySettlEnd',
        abbrName: 'End',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41685,
        description:
            'The end time for commodity settlement where delivery occurs over time. The time format is specified by the settlement time type.',
    },
    {
        name: 'LegStreamCommoditySettlTimeType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryScheduleSettlTimeTypeCodeSet',
        id: 41935,
        description: 'Specifies the format of the commodity settlement start and end times.',
    },
    {
        name: 'NoLegStreamCommoditySettlPeriods',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41686,
        description: 'Number of commodity settlement periods in the repeating group.',
    },
    {
        name: 'LegStreamCommoditySettlCountry',
        abbrName: 'Ctry',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Country',
        id: 41687,
        description: 'Specifies the country where delivery takes place. Uses ISO 3166 2-character country code.',
    },
    {
        name: 'LegStreamCommoditySettlTimeZone',
        abbrName: 'TZ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41688,
        description:
            'Commodity delivery timezone specified as "prevailing" rather than "standard" or "daylight".\n\nSee http://www.fixtradingcommunity.org/codelists#Prevailing_Timezones for code list of applicable prevailing timezones.',
    },
    {
        name: 'LegStreamCommoditySettlFlowType',
        abbrName: 'FlowTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryScheduleSettlFlowTypeCodeSet',
        id: 41689,
        description: 'Specifies the commodity delivery flow type.',
    },
    {
        name: 'LegStreamCommoditySettlPeriodNotional',
        abbrName: 'Notl',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 41690,
        description: 'Delivery quantity associated with this settlement period.',
    },
    {
        name: 'LegStreamCommoditySettlPeriodNotionalUnitOfMeasure',
        abbrName: 'NotlUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41691,
        description:
            'Specifies the unit of measure (UOM) of the delivery quantity associated with this settlement period.',
    },
    {
        name: 'LegStreamCommoditySettlPeriodFrequencyPeriod',
        abbrName: 'FreqPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41692,
        description: 'Time unit multiplier for the settlement period frequency.',
    },
    {
        name: 'LegStreamCommoditySettlPeriodFrequencyUnit',
        abbrName: 'FreqUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ProtectionTermEventUnitCodeSet',
        id: 41693,
        description: 'Time unit associated with the settlement period frequency.',
    },
    {
        name: 'LegStreamCommoditySettlPeriodPrice',
        abbrName: 'Px',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 41694,
        description: 'The settlement period price.',
    },
    {
        name: 'LegStreamCommoditySettlPeriodPriceUnitOfMeasure',
        abbrName: 'PxUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41695,
        description: 'The settlement period price unit of measure (UOM).',
    },
    {
        name: 'LegStreamCommoditySettlPeriodPriceCurrency',
        abbrName: 'PxCcy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41696,
        description: 'The currency of the settlement period price. Uses ISO 4217 currency codes.',
    },
    {
        name: 'LegStreamCommoditySettlHolidaysProcessingInstruction',
        abbrName: 'Holidays',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryScheduleSettlHolidaysProcessingInstructionCodeSet',
        id: 41697,
        description:
            'Indicates whether holidays are included in the settlement periods. Required for electricity contracts.',
    },
    {
        name: 'LegStreamCommoditySettlPeriodXID',
        abbrName: 'XID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XID',
        id: 41698,
        description: 'Identifier of this settlement period for cross referencing elsewhere in the message.',
    },
    {
        name: 'LegStreamCommoditySettlPeriodXIDRef',
        abbrName: 'XIDRef',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XIDREF',
        id: 41699,
        description: 'Cross reference to another settlement period for duplicating its properties.',
    },
    {
        name: 'LegStreamXID',
        abbrName: 'XID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XID',
        id: 41700,
        description: 'Identifier of this LegStream for cross referencing elsewhere in the message.',
    },
    {
        name: 'LegStreamNotionalXIDRef',
        abbrName: 'NotlXIDRef',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XIDREF',
        id: 41702,
        description: 'Cross reference to another LegStream notional for duplicating its properties.',
    },
    {
        name: 'LegStreamNotionalFrequencyPeriod',
        abbrName: 'NotlPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41703,
        description: "Time unit multiplier for the swap stream's notional frequency.",
    },
    {
        name: 'LegStreamNotionalFrequencyUnit',
        abbrName: 'NotlUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'TimeUnitCodeSet',
        id: 41704,
        description: "Time unit associated with the swap stream's notional frequency.",
    },
    {
        name: 'LegStreamNotionalCommodityFrequency',
        abbrName: 'NotlFreq',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'StreamNotionalCommodityFrequencyCodeSet',
        id: 41705,
        description: "The commodity's notional or quantity delivery frequency.",
    },
    {
        name: 'LegStreamNotionalUnitOfMeasure',
        abbrName: 'NotlUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41706,
        description: 'Specifies the delivery quantity unit of measure (UOM).',
    },
    {
        name: 'LegStreamTotalNotional',
        abbrName: 'TotNotl',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 41707,
        description: 'Specifies the total notional or delivery quantity over the term of the contract.',
    },
    {
        name: 'LegStreamTotalNotionalUnitOfMeasure',
        abbrName: 'TotNotlUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41708,
        description:
            'Specifies the unit of measure (UOM) for the total notional or delivery quantity over the term of the contract.',
    },
    {
        name: 'NoUnderlyingAssetAttributes',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2312,
        description: 'Number of asset attribute entries in the group.',
    },
    {
        name: 'UnderlyingAssetAttributeType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2313,
        description:
            'Specifies the name of the attribute.\n\nSee http://www.fixtradingcommunity.org/codelists#Asset_Attribute_Types for code list of applicable asset attribute types.',
    },
    {
        name: 'UnderlyingAssetAttributeValue',
        abbrName: 'Val',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2314,
        description: 'Specifies the value of the attribute.',
    },
    {
        name: 'UnderlyingAssetAttributeLimit',
        abbrName: 'Lmt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2315,
        description: 'Limit or lower acceptable value of the attribute.',
    },
    {
        name: 'NoUnderlyingComplexEventAveragingObservations',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41713,
        description: 'The number of averaging observations in the repeating group.',
    },
    {
        name: 'UnderlyingComplexEventAveragingObservationNumber',
        abbrName: 'ObsvtnNum',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41714,
        description:
            'Cross reference to the ordinal observation as specified either in the UnderlyingComplexEventScheduleGrp or UnderlyingComplexEventPeriodDateGrp components.',
    },
    {
        name: 'UnderlyingComplexEventAveragingWeight',
        abbrName: 'Wt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 41715,
        description: 'The weight factor to be applied to the observation.',
    },
    {
        name: 'NoUnderlyingComplexEventCreditEvents',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41716,
        description: 'The number of credit events specified in the repeating group.',
    },
    {
        name: 'UnderlyingComplexEventCreditEventType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41717,
        description:
            'Specifies the type of credit event.\n\nSee http://www.fixtradingcommunity.org/codelists#Credit_Event_Types for code list of applicable event types.',
    },
    {
        name: 'UnderlyingComplexEventCreditEventValue',
        abbrName: 'Val',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41718,
        description:
            'The credit event value appropriate to UnderlyingComplexEventCreditEventType(41717).\n\nSee http://www.fixtradingcommunity.org/codelists#Credit_Event_Types for applicable event type values.',
    },
    {
        name: 'UnderlyingComplexEventCreditEventCurrency',
        abbrName: 'Ccy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41719,
        description:
            'Specifies the applicable currency when UnderlyingComplexEventCreditEventValue(41718) is an amount. Uses ISO 4217 currency codes.',
    },
    {
        name: 'UnderlyingComplexEventCreditEventPeriod',
        abbrName: 'Period',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41720,
        description: 'Time unit multiplier for complex credit events.',
    },
    {
        name: 'UnderlyingComplexEventCreditEventUnit',
        abbrName: 'Unit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ProtectionTermEventUnitCodeSet',
        id: 41721,
        description: 'Time unit associated with complex credit events.',
    },
    {
        name: 'UnderlyingComplexEventCreditEventDayType',
        abbrName: 'DayTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventDateOffsetDayTypeCodeSet',
        id: 41722,
        description: 'Specifies the day type for the complex credit events.',
    },
    {
        name: 'UnderlyingComplexEventCreditEventRateSource',
        abbrName: 'RtSrc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41723,
        description:
            'Identifies the source of rate information used for credit events.\n\nSee http://www.fixtradingcommunity.org/codelists#Credit_Event_Rate_Source for code list of applicable sources.',
    },
    {
        name: 'NoUnderlyingComplexEventCreditEventQualifiers',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41724,
        description: 'Number of qualifiers in the repeating group.',
    },
    {
        name: 'UnderlyingComplexEventCreditEventQualifier',
        abbrName: 'Qual',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ProtectionTermEventQualifierCodeSet',
        id: 41725,
        description:
            'Specifies a complex event qualifier. Used to further qualify UnderlyingComplexEventCreditEventType(41717).',
    },
    {
        name: 'NoUnderlyingComplexEventPeriodDateTimes',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41726,
        description: 'Number of entries in the date-time repeating group.',
    },
    {
        name: 'UnderlyingComplexEventPeriodDate',
        abbrName: 'Dt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41727,
        description: 'The averaging date for an Asian option.\n\nThe trigger date for a Barrier or Knock option.',
    },
    {
        name: 'UnderlyingComplexEventPeriodTime',
        abbrName: 'Tm',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 41728,
        description: 'The averaging time for an Asian option.',
    },
    {
        name: 'NoUnderlyingComplexEventPeriods',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41729,
        description: 'Number of periods in the repeating group.',
    },
    {
        name: 'UnderlyingComplexEventPeriodType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventPeriodTypeCodeSet',
        id: 41730,
        description: 'Specifies the period type.',
    },
    {
        name: 'UnderlyingComplexEventBusinessCenter',
        abbrName: 'BizCtr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41731,
        description:
            'The business center for adjusting dates and times in the schedule or date-time group.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'NoUnderlyingComplexEventRateSources',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41732,
        description: 'Number of rate sources in the repeating group.',
    },
    {
        name: 'UnderlyingComplexEventRateSource',
        abbrName: 'RtSrc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'RateSourceCodeSet',
        id: 41733,
        description:
            'Identifies the source of rate information.\n\nFor FX, the reference source to be used for the FX spot rate.',
    },
    {
        name: 'UnderlyingComplexEventRateSourceType',
        abbrName: 'RtSrcTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'RateSourceTypeCodeSet',
        id: 41734,
        description: 'Indicates whether the rate source specified is a primary or secondary source.',
    },
    {
        name: 'UnderlyingComplexEventReferencePage',
        abbrName: 'RefPg',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41735,
        description:
            'Identifies the reference page from the rate source.\n\nFor FX, the reference page to the spot rate is to be used for the reference FX spot rate.\n\nWhen UnderlyingComplexEventRateSource(41733) = 3 (ISDA Settlement Rate Option) this contains the value from the scheme that reflects the terms of the Annex A to the ISDA 1998 FX and Currency Option Definitions. See: http://www.fpml.org/coding-scheme/settlement-rate-option.',
    },
    {
        name: 'UnderlyingComplexEventReferencePageHeading',
        abbrName: 'RefHdg',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41736,
        description: 'Identifies the reference page heading from the rate source.',
    },
    {
        name: 'NoUnderlyingComplexEventDateBusinessCenters',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41737,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'UnderlyingComplexEventDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41738,
        description:
            'The business center calendar is used to adjust the event date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'UnderlyingComplexEventDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41739,
        description:
            'The unadjusted complex event date.\n\nFor example the second expiration date for a calendar spread option strategy.',
    },
    {
        name: 'UnderlyingComplexEventDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 41740,
        description:
            'Specifies the anchor date when the complex event date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'UnderlyingComplexEventDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41741,
        description: 'Time unit multiplier for the relative date offset.',
    },
    {
        name: 'UnderlyingComplexEventDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 41742,
        description: 'Time unit associated with the relative date offset.',
    },
    {
        name: 'UnderlyingComplexEventDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventDateOffsetDayTypeCodeSet',
        id: 41743,
        description: 'Specifies the day type of the relative date offset.',
    },
    {
        name: 'UnderlyingComplexEventDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 41744,
        description:
            'The business day convention used to adjust the event date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.',
    },
    {
        name: 'UnderlyingComplexEventDateAdjusted',
        abbrName: 'Dt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41745,
        description: 'The adjusted complex event date.',
    },
    {
        name: 'UnderlyingComplexEventFixingTime',
        abbrName: 'FixngTm',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 41746,
        description: 'The local market fixing time.',
    },
    {
        name: 'UnderlyingComplexEventFixingTimeBusinessCenter',
        abbrName: 'FixngBizCtr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41747,
        description:
            'The business center for determining the actual fixing times.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'NoUnderlyingComplexEventCreditEventSources',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41748,
        description: 'Number of event sources in the repeating group.',
    },
    {
        name: 'UnderlyingComplexEventCreditEventSource',
        abbrName: 'Src',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41749,
        description:
            'A newspaper or electronic news service that may publish relevant information used in the determination of whether or not a credit event has occurred.',
    },
    {
        name: 'UnderlyingComplexOptPayoutPaySide',
        abbrName: 'OptPay',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentPaySideCodeSet',
        id: 2261,
        description: 'Trade side of payout payer.',
    },
    {
        name: 'UnderlyingComplexOptPayoutReceiveSide',
        abbrName: 'OptRcv',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentPaySideCodeSet',
        id: 2262,
        description: 'Trade side of payout receiver.',
    },
    {
        name: 'UnderlyingComplexOptPayoutUnderlier',
        abbrName: 'OptUndlr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2263,
        description: 'Reference to the underlier whose payments are being passed through.',
    },
    {
        name: 'UnderlyingComplexOptPayoutPercentage',
        abbrName: 'OptPctage',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 2264,
        description: 'Percentage of observed price for calculating the payout associated with the event.',
    },
    {
        name: 'UnderlyingComplexOptPayoutTime',
        abbrName: 'OptTm',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ComplexOptPayoutTimeCodeSet',
        id: 2265,
        description: 'The time when the payout is to occur.',
    },
    {
        name: 'UnderlyingComplexOptPayoutCurrency',
        abbrName: 'OptCcy',
        updated: 'FIX.Latest',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        updatedEP: '273',
        id: 2266,
        description:
            'Specifies the currency of the payout amount.\n\nUnderlyingComplexOptPayoutCurrencyCodeSource(2947) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.',
    },
    {
        name: 'UnderlyingComplexEventPricePercentage',
        abbrName: 'PxPctage',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 2267,
        description:
            'Specifies the price percentage at which the complex event takes effect. Impact of the event price is determined by the UnderlyingComplexEventType(2046).',
    },
    {
        name: 'UnderlyingComplexEventCurrencyOne',
        abbrName: 'Ccy1',
        updated: 'FIX.Latest',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        updatedEP: '273',
        id: 2268,
        description:
            'Specifies the first or only reference currency of the trade.\n\nUnderlyingComplexEventCurrencyOneCodeSource(2948) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.\n\nApplicable for complex FX option strategies.',
    },
    {
        name: 'UnderlyingComplexEventCurrencyTwo',
        abbrName: 'Ccy2',
        updated: 'FIX.Latest',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        updatedEP: '273',
        id: 2269,
        description:
            'Specifies the second reference currency of the trade.\n\nUnderlyingComplexEventCurrencyTwoCodeSource(2949) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.\n\nApplicable for complex FX option strategies.',
    },
    {
        name: 'UnderlyingComplexEventQuoteBasis',
        abbrName: 'QteBasis',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventQuoteBasisCodeSet',
        id: 2270,
        description: 'Specifies the currency pairing for the quote.',
    },
    {
        name: 'UnderlyingComplexEventFixedFXRate',
        abbrName: 'Rt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 2271,
        description: 'Specifies the fixed FX rate alternative for FX Quantro options.',
    },
    {
        name: 'UnderlyingComplexEventDeterminationMethod',
        abbrName: 'Meth',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2272,
        description:
            'Specifies the method according to which an amount or a date is determined.\n\nSee http://www.fpml.org/coding-scheme/determination-method for values.',
    },
    {
        name: 'UnderlyingComplexEventCalculationAgent',
        abbrName: 'CalcAgent',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ProvisionCalculationAgentCodeSet',
        id: 2273,
        description: 'Used to identify the calculation agent.',
    },
    {
        name: 'UnderlyingComplexEventStrikePrice',
        abbrName: 'StrkPx',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 2274,
        description: 'Upper strike price for Asian option feature. Strike percentage for a Strike Spread.',
    },
    {
        name: 'UnderlyingComplexEventStrikeFactor',
        abbrName: 'StrkFctr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 2275,
        description: 'Strike factor for Asian option feature. Upper strike percentage for a Strike Spread.',
    },
    {
        name: 'UnderlyingComplexEventStrikeNumberOfOptions',
        abbrName: 'StrkNum',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2276,
        description: 'Upper string number of options for a Strike Spread.',
    },
    {
        name: 'UnderlyingComplexEventCreditEventsXIDRef',
        abbrName: 'CdtEvntXIDRef',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XIDREF',
        id: 2277,
        description: 'Reference to credit event table elsewhere in the message.',
    },
    {
        name: 'UnderlyingComplexEventCreditEventNotifyingParty',
        abbrName: 'NotifygPty',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventCreditEventNotifyingPartyCodeSet',
        id: 2278,
        description:
            'The notifying party is the party that notifies the other party when a credit event has occurred by means of a credit event notice. If more than one party is referenced as being the notifying party then either party may notify the other of a credit event occurring.',
    },
    {
        name: 'UnderlyingComplexEventCreditEventBusinessCenter',
        abbrName: 'BizCtr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2279,
        description:
            'Specifies the local business center for which the credit event is to be determined. The inclusion of this business center implies that Greenwich Mean Time in Section 3.3 of the 2003 ISDA Credit Derivatives Definitions is replaced by the local time of the specified business center.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'UnderlyingComplexEventCreditEventStandardSources',
        abbrName: 'StdSrcs',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2280,
        description:
            "When this element is specified and set to 'Y', indicates that ISDA defined Standard Public Sources are applicable.",
    },
    {
        name: 'UnderlyingComplexEventCreditEventMinimumSources',
        abbrName: 'MinSrcs',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2281,
        description:
            'The minimum number of the specified public information sources that must publish information that reasonably confirms that a credit event has occurred. The market convention is two.\n\nISDA 2003 Term: Specified Number.',
    },
    {
        name: 'UnderlyingComplexEventXID',
        abbrName: 'XID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XID',
        id: 2282,
        description: 'Identifier of this complex event for cross referencing elsewhere in the message.',
    },
    {
        name: 'UnderlyingComplexEventXIDRef',
        abbrName: 'XIDRef',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XIDREF',
        id: 2283,
        description: 'Reference to a complex event elsewhere in the message.',
    },
    {
        name: 'NoUnderlyingComplexEventSchedules',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41750,
        description: 'Number of schedules in the repeating group.',
    },
    {
        name: 'UnderlyingComplexEventScheduleStartDate',
        abbrName: 'StartDt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41751,
        description: 'The start date of the schedule.',
    },
    {
        name: 'UnderlyingComplexEventScheduleEndDate',
        abbrName: 'EndDt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41752,
        description: 'The end date of the schedule.',
    },
    {
        name: 'UnderlyingComplexEventScheduleFrequencyPeriod',
        abbrName: 'FreqPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41753,
        description: 'Time unit multiplier for the schedule date frequency.',
    },
    {
        name: 'UnderlyingComplexEventScheduleFrequencyUnit',
        abbrName: 'FreqUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ProtectionTermEventUnitCodeSet',
        id: 41754,
        description: 'Time unit associated with the schedule date frequency.',
    },
    {
        name: 'UnderlyingComplexEventScheduleRollConvention',
        abbrName: 'Roll',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DateRollConventionCodeSet',
        id: 41755,
        description:
            'The convention for determining the sequence of dates. It is used in conjunction with a specified frequency. Used only to override the roll convention defined in the UnderlyingDateAdjustment component in UnderlyingInstrument.',
    },
    {
        name: 'NoUnderlyingDeliverySchedules',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41756,
        description: 'Number of delivery schedules in the repeating group.',
    },
    {
        name: 'UnderlyingDeliveryScheduleType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryScheduleTypeCodeSet',
        id: 41757,
        description: 'Specifies the type of delivery schedule.',
    },
    {
        name: 'UnderlyingDeliveryScheduleXID',
        abbrName: 'XID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XID',
        id: 41758,
        description:
            'Identifier for this instance of delivery schedule for cross referencing elsewhere in the message.',
    },
    {
        name: 'UnderlyingDeliveryScheduleNotional',
        abbrName: 'Notl',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 41759,
        description: 'Physical delivery quantity.',
    },
    {
        name: 'UnderlyingDeliveryScheduleNotionalUnitOfMeasure',
        abbrName: 'NotlUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41760,
        description: 'Specifies the delivery quantity unit of measure (UOM).',
    },
    {
        name: 'UnderlyingDeliveryScheduleNotionalCommodityFrequency',
        abbrName: 'NotlFreq',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'StreamNotionalCommodityFrequencyCodeSet',
        id: 41761,
        description: 'The frequency of notional delivery.',
    },
    {
        name: 'UnderlyingDeliveryScheduleNegativeTolerance',
        abbrName: 'NegtvTlrnc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 41762,
        description:
            'Specifies the negative tolerance value. The value may be an absolute quantity or a percentage, as specified in UnderlyingDeliveryScheduleToleranceType(41765). Percentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%).',
    },
    {
        name: 'UnderlyingDeliverySchedulePositiveTolerance',
        abbrName: 'PostvTlrnc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 41763,
        description:
            'Specifies the positive tolerance value. The value may be an absolute quantity or a percentage, as specified in UnderlyingDeliveryScheduleToleranceType(41765). Value may exceed agreed upon value. Percentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%).',
    },
    {
        name: 'UnderlyingDeliveryScheduleToleranceUnitOfMeasure',
        abbrName: 'TlrncUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41764,
        description: "Specifies the tolerance value's unit of measure (UOM).",
    },
    {
        name: 'UnderlyingDeliveryScheduleToleranceType',
        abbrName: 'TlrncTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryScheduleToleranceTypeCodeSet',
        id: 41765,
        description: 'Specifies the tolerance value type.',
    },
    {
        name: 'UnderlyingDeliveryScheduleSettlCountry',
        abbrName: 'Ctry',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Country',
        id: 41766,
        description: 'Specifies the country where delivery takes place. Uses ISO 3166 2-character country code.',
    },
    {
        name: 'UnderlyingDeliveryScheduleSettlTimeZone',
        abbrName: 'TZ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41767,
        description:
            'Delivery timezone specified as "prevailing" rather than "standard" or "daylight".\n\nSee http://www.fixtradingcommunity.org/codelists#Prevailing_Timezones for code list of applicable prevailing timezones.',
    },
    {
        name: 'UnderlyingDeliveryScheduleSettlFlowType',
        abbrName: 'FlowTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryScheduleSettlFlowTypeCodeSet',
        id: 41768,
        description: 'Specifies the delivery flow type.',
    },
    {
        name: 'UnderlyingDeliveryScheduleSettlHolidaysProcessingInstruction',
        abbrName: 'Holidays',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryScheduleSettlHolidaysProcessingInstructionCodeSet',
        id: 41769,
        description:
            'Indicates whether holidays are included in the settlement periods. Required for electricity contracts.',
    },
    {
        name: 'NoUnderlyingDeliveryScheduleSettlDays',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41770,
        description: 'Number of delivery schedules in the repeating group.',
    },
    {
        name: 'UnderlyingDeliveryScheduleSettlDay',
        abbrName: 'Day',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryScheduleSettlDayCodeSet',
        id: 41771,
        description: 'Specifies the day or group of days for delivery.',
    },
    {
        name: 'UnderlyingDeliveryScheduleSettlTotalHours',
        abbrName: 'TotHrs',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41772,
        description: 'The sum of the total hours specified in the UnderlyingDeliveryScheduleSettlTimeGrp component.',
    },
    {
        name: 'NoUnderlyingDeliveryScheduleSettlTimes',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41773,
        description: 'Number of hour ranges in the repeating group.',
    },
    {
        name: 'UnderlyingDeliveryScheduleSettlStart',
        abbrName: 'Start',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41774,
        description:
            'The scheduled start time for the delivery of the commodity where delivery occurs over specified times. The format of the time value is specified in UnderlyingDeliveryScheduleSettlTimeType(41776).',
    },
    {
        name: 'UnderlyingDeliveryScheduleSettlEnd',
        abbrName: 'End',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41775,
        description:
            'The scheduled end time for the delivery of the commodity where delivery occurs over specified times. The format of the time value is specified in UnderlyingDeliveryScheduleSettlTimeType(41776).',
    },
    {
        name: 'UnderlyingDeliveryScheduleSettlTimeType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryScheduleSettlTimeTypeCodeSet',
        id: 41776,
        description: 'Specifies the format of the delivery start and end time values.',
    },
    {
        name: 'UnderlyingDeliveryStreamType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryStreamTypeCodeSet',
        id: 41777,
        description: 'Specifies the type of delivery stream.',
    },
    {
        name: 'UnderlyingDeliveryStreamPipeline',
        abbrName: 'Ppln',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41778,
        description: 'The name of the oil delivery pipeline.',
    },
    {
        name: 'UnderlyingDeliveryStreamEntryPoint',
        abbrName: 'EntryPnt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41779,
        description: 'The point at which the commodity will enter the delivery mechanism or pipeline.',
    },
    {
        name: 'UnderlyingDeliveryStreamWithdrawalPoint',
        abbrName: 'WthdrwlPnt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41780,
        description: 'The point at which the commodity product will be withdrawn prior to delivery.',
    },
    {
        name: 'UnderlyingDeliveryStreamDeliveryPoint',
        abbrName: 'DlvryPnt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41781,
        discriminatorId: '42196',
        description:
            'The point at which the commodity product will be delivered and received. Value specified should follow market convention appropriate for the commodity product.\n\nFor bullion see http://www.fpml.org/coding-scheme/bullion-delivery-location for values.',
    },
    {
        name: 'UnderlyingDeliveryStreamDeliveryRestriction',
        abbrName: 'DlvryRstctn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryStreamDeliveryRestrictionCodeSet',
        id: 41782,
        description:
            'Specifies under what conditions the buyer and seller should be excused of their delivery obligations.',
    },
    {
        name: 'UnderlyingDeliveryStreamDeliveryContingency',
        abbrName: 'Cntgncy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41783,
        description:
            'Specifies the electricity delivery contingency.\n\nSee http://www.fpml.org/coding-scheme/electricity-transmission-contingency for values.',
    },
    {
        name: 'UnderlyingDeliveryStreamDeliveryContingentPartySide',
        abbrName: 'CntgPty',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryStreamElectingPartySideCodeSet',
        id: 41784,
        description: 'The trade side value of the party responsible for electricity delivery contingency.',
    },
    {
        name: 'UnderlyingDeliveryStreamDeliverAtSourceIndicator',
        abbrName: 'DlvrAtSrc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 41785,
        description:
            "When this element is specified and set to 'Y', delivery of the coal product is to be at its source.",
    },
    {
        name: 'UnderlyingDeliveryStreamRiskApportionment',
        abbrName: 'RiskApprtnmt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41786,
        discriminatorId: '41587',
        description:
            'Specifies how the parties to the trade apportion responsibility for the delivery of the commodity product.\n\nSee http://www.fixtradingcommunity.org/codelists#Risk_Apportionment for the details of the external code list.',
    },
    {
        name: 'UnderlyingDeliveryStreamRiskApportionmentSource',
        abbrName: 'RiskApprtnmtSrc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41587,
        description:
            'Specifies the source or legal framework for the risk apportionment.\n\nSee http://www.fixtradingcommunity.org/codelists#Risk_Apportionment_Source for the details of the external code list.',
    },
    {
        name: 'UnderlyingDeliveryStreamTitleTransferLocation',
        abbrName: 'TtlXfer',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41787,
        description: 'Specifies the title transfer location.',
    },
    {
        name: 'UnderlyingDeliveryStreamTitleTransferCondition',
        abbrName: 'TltXferCond',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryStreamTitleTransferConditionCodeSet',
        id: 41788,
        description: 'Specifies the title transfer condition.',
    },
    {
        name: 'UnderlyingDeliveryStreamImporterOfRecord',
        abbrName: 'Imprtr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41789,
        description:
            'A party, not necessarily of the trade, who is the Importer of Record for the purposes of paying customs duties and applicable taxes or costs related to importation.',
    },
    {
        name: 'UnderlyingDeliveryStreamNegativeTolerance',
        abbrName: 'NegtvTlrnc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 41790,
        description:
            'Specifies the negative tolerance value. The value may be an absolute quantity or a percentage, as specified in UnderlyingDeliveryStreamToleranceType(41793). Percentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%).',
    },
    {
        name: 'UnderlyingDeliveryStreamPositiveTolerance',
        abbrName: 'PostvTlrnc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 41791,
        description:
            'Specifies the positive tolerance value. The value may be an absolute quantity or a percentage, as specified in UnderlyingDeliveryStreamToleranceType(41793). Value may exceed agreed upon value. Percentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%).',
    },
    {
        name: 'UnderlyingDeliveryStreamToleranceUnitOfMeasure',
        abbrName: 'TlrncUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41792,
        description: "Specifies the tolerance value's unit of measure (UOM).",
    },
    {
        name: 'UnderlyingDeliveryStreamToleranceType',
        abbrName: 'TlrncTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryScheduleToleranceTypeCodeSet',
        id: 41793,
        description: 'Specifies the tolerance value type.',
    },
    {
        name: 'UnderlyingDeliveryStreamToleranceOptionSide',
        abbrName: 'TlrncOptSide',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryStreamToleranceOptionSideCodeSet',
        id: 41794,
        description: "Indicates whether the tolerance is at the seller's or buyer's option.",
    },
    {
        name: 'UnderlyingDeliveryStreamTotalPositiveTolerance',
        abbrName: 'TotPostvTlrnc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 41795,
        description:
            'The positive percent tolerance which applies to the total quantity delivered over all shipment periods.\n\nPercentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%.).',
    },
    {
        name: 'UnderlyingDeliveryStreamTotalNegativeTolerance',
        abbrName: 'TotNegtvTlrnc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 41796,
        description:
            'The negative percent tolerance which applies to the total quantity delivered over all shipment periods.\n\nPercentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%.).',
    },
    {
        name: 'UnderlyingDeliveryStreamNotionalConversionFactor',
        abbrName: 'CnvrsnFctr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 41797,
        description:
            'If the notional quantity is specified in a unit that does not match the unit in which the commodity reference price is quoted, the scaling or conversion factor used to convert the commodity reference price unit into the notional quantity unit should be stated here. If there is no conversion, this field is not intended to be used.',
    },
    {
        name: 'UnderlyingDeliveryStreamTransportEquipment',
        abbrName: 'Eqpmt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41798,
        description:
            'The transportation equipment with which the commodity product will be delivered and received.\n\nExamples of transportation equipment or mode are barge, truck, railcar, etc.',
    },
    {
        name: 'UnderlyingDeliveryStreamElectingPartySide',
        abbrName: 'ElctngSide',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryStreamElectingPartySideCodeSet',
        id: 41799,
        description:
            'A reference to the party able to choose whether the gas is delivered for a particular period e.g. a swing or interruptible contract.',
    },
    {
        name: 'NoUnderlyingStreamAssetAttributes',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41800,
        description: 'Number of asset attribute entries in the group.',
    },
    {
        name: 'UnderlyingStreamAssetAttributeType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41801,
        description:
            'Specifies the name of the attribute.\n\nSee http://www.fixtradingcommunity.org/codelists#Asset_Attribute_Types for code list of applicable asset attribute types.',
    },
    {
        name: 'UnderlyingStreamAssetAttributeValue',
        abbrName: 'Val',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41802,
        description: 'Specifies the value of the attribute.',
    },
    {
        name: 'UnderlyingStreamAssetAttributeLimit',
        abbrName: 'Lmt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41803,
        description: 'The limit or lower acceptable value of the attribute.',
    },
    {
        name: 'NoUnderlyingDeliveryStreamCycles',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41804,
        description: 'Number of delivery cycles in the repeating group.',
    },
    {
        name: 'UnderlyingDeliveryStreamCycleDesc',
        abbrName: 'Desc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41805,
        description: 'The delivery cycles during which the oil product will be transported in the pipeline.',
    },
    {
        name: 'EncodedUnderlyingDeliveryStreamCycleDescLen',
        abbrName: 'EncDescLen',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 41806,
        description:
            'Byte length of encoded (non-ASCII characters) EncodedUnderlyingDeliveryStreamCycleDesc(41807) field.',
    },
    {
        name: 'EncodedUnderlyingDeliveryStreamCycleDesc',
        abbrName: 'EncDesc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 41807,
        lengthId: '41806',
        description:
            'Encoded (non-ASCII characters) representation of the UnderlyingDeliveryStreamCycleDesc(41805) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the UnderlyingDeliveryStreamCycleDesc(41805) field.',
    },
    {
        name: 'NoUnderlyingDeliveryStreamCommoditySources',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41808,
        description: 'Number of commodity sources in the repeating group.',
    },
    {
        name: 'UnderlyingDeliveryStreamCommoditySource',
        abbrName: 'Src',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41809,
        description:
            'The SCoTA coal cargo origin, mining region, mine(s), mining complex(es), loadout(s) or river dock(s) or other point(s) of origin that seller and buyer agree are acceptable origins for the coal product. For international coal transactions, this is the origin of the coal product.\n\nSee http://www.fpml.org/coding-scheme/commodity-coal-product-source for values.',
    },
    {
        name: 'UnderlyingExerciseDesc',
        abbrName: 'Desc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41810,
        description: 'A description of the option exercise.',
    },
    {
        name: 'EncodedUnderlyingExerciseDescLen',
        abbrName: 'EncDescLen',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 41811,
        description: 'Byte length of encoded (non-ASCII characters) EncodedUnderlyingExerciseDesc(41812) field.',
    },
    {
        name: 'EncodedUnderlyingExerciseDesc',
        abbrName: 'EncDesc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 41812,
        lengthId: '41811',
        description:
            'Encoded (non-ASCII characters) representation of the UnderlyingExerciseDesc(41810) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the UnderlyingExerciseDesc(41810) field.',
    },
    {
        name: 'UnderlyingAutomaticExerciseIndicator',
        abbrName: 'AutoExerInd',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 41813,
        description:
            "Indicates (when 'Y') that exercise is automatic when the strike price is crossed or the underlying trade is in the money.",
    },
    {
        name: 'UnderlyingAutomaticExerciseThresholdRate',
        abbrName: 'AutoRt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 41814,
        description: 'The threshold rate for triggering automatic exercise.',
    },
    {
        name: 'UnderlyingExerciseConfirmationMethod',
        abbrName: 'ExerCnfm',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ExerciseConfirmationMethodCodeSet',
        id: 41815,
        description:
            "Indicates whether follow-up confirmation of exercise (written or electronic) is required following telephonic notice by the buyer to the seller or seller's agent.",
    },
    {
        name: 'UnderlyingManualNoticeBusinessCenter',
        abbrName: 'ManNtcBizCtr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41816,
        description:
            'Identifies the business center used for adjusting the time for manual exercise notice.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'UnderlyingFallbackExerciseIndicator',
        abbrName: 'FallbckExerInd',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 41817,
        description:
            'Indicates whether the notional amount of the underlying swap, not previously exercised under the option, will be automatically exercised at the expiration time on the expiration date if at such time the buyer is in-the-money, provided that the difference between the settlement rate and the fixed rate under the relevant underlying swap is not less than one tenth of a percentage point (0.10% or 0.001).',
    },
    {
        name: 'UnderlyingLimitedRightToConfirmIndicator',
        abbrName: 'LtdRightCnfmInd',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 41818,
        description:
            'Indicates whether the Seller may request the Buyer to confirm its intent to exercise if not done on or before the expiration time on the Expiration date. If true ("Y") specific rules will apply in relation to the settlement mode.',
    },
    {
        name: 'UnderlyingExerciseSplitTicketIndicator',
        abbrName: 'ExerSplitTktInd',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 41819,
        description:
            'Indicates in physical settlement of bond and convertible bond options whether the party required to deliver the bonds will divide those to be delivered as notifying party desires to facilitate delivery obligations.',
    },
    {
        name: 'NoUnderlyingOptionExerciseBusinessCenters',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41820,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'UnderlyingOptionExerciseBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41821,
        description:
            'The business center calendar used to adjust the option exercise dates, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'UnderlyingOptionExerciseBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 41822,
        description:
            'The business day convention used to adjust the option exercise dates. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.',
    },
    {
        name: 'UnderlyingOptionExerciseEarliestDateOffsetDayType',
        abbrName: 'ErlstOfstDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 41823,
        description: 'Specifies the day type of the relative earliest exercise date offset.',
    },
    {
        name: 'UnderlyingOptionExerciseEarliestDateOffsetPeriod',
        abbrName: 'ErlstOfstPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41824,
        description: 'Time unit multiplier for the relative earliest exercise date offset.',
    },
    {
        name: 'UnderlyingOptionExerciseEarliestDateOffsetUnit',
        abbrName: 'ErlstOfstUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ProvisionOptionExerciseEarliestDateOffsetUnitCodeSet',
        id: 41825,
        description: 'Time unit associated with the relative earliest exercise date offset.',
    },
    {
        name: 'UnderlyingOptionExerciseFrequencyPeriod',
        abbrName: 'FreqPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41826,
        description: 'Time unit multiplier for the frequency of exercise dates.',
    },
    {
        name: 'UnderlyingOptionExerciseFrequencyUnit',
        abbrName: 'FreqUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ProtectionTermEventUnitCodeSet',
        id: 41827,
        description: 'Time unit associated with the frequency of exercise dates.',
    },
    {
        name: 'UnderlyingOptionExerciseStartDateUnadjusted',
        abbrName: 'StartDtUnadj',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41828,
        description: 'The unadjusted start date for calculating periodic exercise dates.',
    },
    {
        name: 'UnderlyingOptionExerciseStartDateRelativeTo',
        abbrName: 'StartDtReltv',
        unionDataType: 'Reserved1000Plus',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 41829,
        description:
            'Specifies the anchor date when the option exercise start date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'UnderlyingOptionExerciseStartDateOffsetPeriod',
        abbrName: 'StartDtOfstPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41830,
        description: 'Time unit multiplier for the relative exercise start date offset.',
    },
    {
        name: 'UnderlyingOptionExerciseStartDateOffsetUnit',
        abbrName: 'StartDtOfstUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 41831,
        description: 'Time unit associated with the relative exercise start date offset.',
    },
    {
        name: 'UnderlyingOptionExerciseStartDateOffsetDayType',
        abbrName: 'StartDtOfstDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 41832,
        description: 'Specifies the day type of the relative option exercise start date offset.',
    },
    {
        name: 'UnderlyingOptionExerciseStartDateAdjusted',
        abbrName: 'StartDt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41833,
        description: 'The adjusted start date for calculating periodic exercise dates.',
    },
    {
        name: 'UnderlyingOptionExerciseSkip',
        abbrName: 'Skip',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41834,
        description:
            'The number of periods in the referenced date schedule that are between each date in the relative date schedule. Thus a skip of 2 would mean that dates are relative to every second date in the referenced schedule. If present this should have a value greater than 1.',
    },
    {
        name: 'UnderlyingOptionExerciseNominationDeadline',
        abbrName: 'NomntnDdln',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41835,
        description: 'The last date (adjusted) for establishing the option exercise terms.',
    },
    {
        name: 'UnderlyingOptionExerciseFirstDateUnadjusted',
        abbrName: 'FirstDtUnadj',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41836,
        description: 'The unadjusted first exercise date.',
    },
    {
        name: 'UnderlyingOptionExerciseLastDateUnadjusted',
        abbrName: 'LastDtUnadj',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41837,
        description: 'The unadjusted last exercise date.',
    },
    {
        name: 'UnderlyingOptionExerciseEarliestTime',
        abbrName: 'ErlstTm',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 41838,
        description:
            "The earliest time at which notice of exercise can be given by the buyer to the seller (or seller's agent) (i) on the expriation date, in the case of a European style option, (ii) on each Bermuda option exercise date and the expiration date, in the case of a Bermuda style option, (iii) the commencement date to, and including, the expiration date, in the case of an American option.",
    },
    {
        name: 'UnderlyingOptionExerciseLatestTime',
        abbrName: 'LtstTm',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 41839,
        description: 'Latest exercise time. See also UnderlyingOptionExerciseEarliestTime(41838).',
    },
    {
        name: 'UnderlyingOptionExerciseTimeBusinessCenter',
        abbrName: 'TmBizCtr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41840,
        description:
            'The business center used to determine the locale for option exercise time, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values',
    },
    {
        name: 'NoUnderlyingOptionExerciseDates',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41841,
        description: 'Number of dates in the repeating group.',
    },
    {
        name: 'UnderlyingOptionExerciseDate',
        abbrName: 'Dt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41842,
        description: 'The adjusted or unadjusted option exercise fixed date.',
    },
    {
        name: 'UnderlyingOptionExerciseDateType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'OptionExerciseDateTypeCodeSet',
        id: 41843,
        description:
            'Specifies the type of option exercise date. When specified it applies not only to the current date but to all subsequent dates in the group until overridden with a new type.',
    },
    {
        name: 'NoUnderlyingOptionExerciseExpirationDateBusinessCenters',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41844,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'UnderlyingOptionExerciseExpirationDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41845,
        description:
            'The business center calendar used to adjust the option exercise expiration dates, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'UnderlyingOptionExerciseExpirationDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 41846,
        description:
            'The business day convention used to adjust the option exercise expiration dates. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.',
    },
    {
        name: 'UnderlyingOptionExerciseExpirationDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 41847,
        description:
            'Specifies the anchor date when the option exercise expiration date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'UnderlyingOptionExerciseExpirationDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41848,
        description: 'Time unit multiplier for the relative exercise expiration date offset.',
    },
    {
        name: 'UnderlyingOptionExerciseExpirationDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 41849,
        description: 'Time unit associated with the relative exercise expiration date offset.',
    },
    {
        name: 'UnderlyingOptionExerciseExpirationFrequencyPeriod',
        abbrName: 'FreqPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41850,
        description: 'Time unit multiplier for the frequency of exercise expiration dates.',
    },
    {
        name: 'UnderlyingOptionExerciseExpirationFrequencyUnit',
        abbrName: 'FreqUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ProtectionTermEventUnitCodeSet',
        id: 41851,
        description: 'Time unit associated with the frequency of exercise expiration dates.',
    },
    {
        name: 'UnderlyingOptionExerciseExpirationRollConvention',
        abbrName: 'Roll',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DateRollConventionCodeSet',
        id: 41852,
        description:
            'The convention for determining the sequence of exercise expiration dates. It is used in conjunction with a specified frequency. Used only to override the roll convention defined in the UnderlyingDateAdjustment component in UnderlyingInstrument.',
    },
    {
        name: 'UnderlyingOptionExerciseExpirationDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 41853,
        description: 'Specifies the day type of the relative option exercise expiration date offset.',
    },
    {
        name: 'UnderlyingOptionExerciseExpirationTime',
        abbrName: 'Tm',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 41854,
        description: 'The option exercise expiration time.',
    },
    {
        name: 'UnderlyingOptionExerciseExpirationTimeBusinessCenter',
        abbrName: 'TmBizCtr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41855,
        description:
            'The business center used to determine the locale for option exercise expiration time, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'NoUnderlyingOptionExerciseExpirationDates',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41856,
        description: 'Number of fixed exercise expiration dates in the repeating group.',
    },
    {
        name: 'UnderlyingOptionExerciseExpirationDate',
        abbrName: 'Dt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41857,
        description: 'The adjusted or unadjusted option exercise expiration fixed date.',
    },
    {
        name: 'UnderlyingOptionExerciseExpirationDateType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'OptionExerciseDateTypeCodeSet',
        id: 41858,
        description:
            'Specifies the type of option exercise expiration date. When specified it applies not only to the current date but to all subsequent dates in the group until overridden with a new type.',
    },
    {
        name: 'UnderlyingSettlRateIndex',
        abbrName: 'SettlNdx',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2284,
        description:
            'In an outright or forward commodity trade that is cash settled this is the index used to determine the cash payment.',
    },
    {
        name: 'UnderlyingSettlRateIndexLocation',
        abbrName: 'SettlNdxLctn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2285,
        description:
            'This is an optional qualifying attribute of UnderlyingSettlementRateIndex(2284) such as the delivery zone for an electricity contract.',
    },
    {
        name: 'UnderlyingOptionExpirationDesc',
        abbrName: 'ExpDesc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2286,
        description: 'Description of the option expiration.',
    },
    {
        name: 'EncodedUnderlyingOptionExpirationDescLen',
        abbrName: 'EncExpDescLen',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 2287,
        description: 'Byte length of encoded (non-ASCII characters) EncodedUnderlyingOptionExpirationDesc(2288) field.',
    },
    {
        name: 'EncodedUnderlyingOptionExpirationDesc',
        abbrName: 'EncExpDesc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 2288,
        lengthId: '2287',
        description:
            'Encoded (non-ASCII characters) representation of the UnderlyingOptionExpirationDesc(2286) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the UnderlyingOptionExpirationDesc(2286).',
    },
    {
        name: 'UnderlyingSwapSubClass',
        abbrName: 'SwapSubClss',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'SwapSubClassCodeSet',
        updatedEP: '238',
        id: 2289,
        description: 'The sub-classification or notional schedule type of the swap.',
    },
    {
        name: 'UnderlyingStrikeUnitOfMeasure',
        abbrName: 'StrkUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 2290,
        description: 'Used to express the unit of measure (UOM) of the price if different from the contract.',
    },
    {
        name: 'UnderlyingStrikeIndex',
        abbrName: 'StrkNdx',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2291,
        description: 'Specifies the index used to calculate the strike price.',
    },
    {
        name: 'UnderlyingStrikeIndexSpread',
        abbrName: 'StrkSpread',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 2292,
        description: 'Specifies the strike price offset from the named index.',
    },
    {
        name: 'UnderlyingValuationSource',
        abbrName: 'ValSrc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2293,
        description: 'Specifies the source of trade valuation data.',
    },
    {
        name: 'UnderlyingValuationReferenceModel',
        abbrName: 'ValRefModel',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2294,
        description: 'Specifies the methodology and/or assumptions used to generate the trade value.',
    },
    {
        name: 'UnderlyingStrategyType',
        abbrName: 'StrtTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'StrategyTypeCodeSet',
        id: 2295,
        description: 'Specifies the type of trade strategy.',
    },
    {
        name: 'UnderlyingCommonPricingIndicator',
        abbrName: 'CmnPxng',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2296,
        description:
            "When this element is specified and set to 'Y', it indicates that common pricing applies. Common pricing may be relevant for a transaction that references more than one commodity reference price.",
    },
    {
        name: 'UnderlyingSettlDisruptionProvision',
        abbrName: 'SettlDsrptnProv',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'SettlDisruptionProvisionCodeSet',
        id: 2297,
        description: 'Specifies the consequences of settlement disruption events.',
    },
    {
        name: 'UnderlyingInstrumentRoundingDirection',
        abbrName: 'RndDirctn',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'RoundingDirectionCodeSet',
        updatedEP: '208',
        id: 2298,
        description: 'Specifies the rounding direction if not overridden elsewhere.',
    },
    {
        name: 'UnderlyingInstrumentRoundingPrecision',
        abbrName: 'RndPrcsn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2299,
        description:
            'Specifies the rounding precision in terms of a number of decimal places. Note how a percentage rate rounding of 5 decimal places is expressed as a rounding precision of 7.',
    },
    {
        name: 'UnderlyingMarketDisruptionProvision',
        abbrName: 'Prov',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'MarketDisruptionProvisionCodeSet',
        id: 41859,
        description: 'The consequences of market disruption events.',
    },
    {
        name: 'UnderlyingMarketDisruptionFallbackProvision',
        abbrName: 'FallbckProv',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'MarketDisruptionFallbackProvisionCodeSet',
        id: 41860,
        description: 'Specifies the location of the fallback provision documentation.',
    },
    {
        name: 'UnderlyingMarketDisruptionMaximumDays',
        abbrName: 'MaxDays',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41861,
        description:
            'Specifies the maximum number of market disruption days (commodity or bullion business days) in a contract or confirmation. If none are specified, the maximum number of market disruption days is five (5).\n\nISDA 2005 Commodity Definition.',
    },
    {
        name: 'UnderlyingMarketDisruptionMaterialityPercentage',
        abbrName: 'MtrltyPctage',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 41862,
        description:
            'Used when a price materiality percentage applies to the price source disruption event and this event has been specified.\n\nApplicable to 2005 Commodity Definitions only.',
    },
    {
        name: 'UnderlyingMarketDisruptionMinimumFuturesContracts',
        abbrName: 'MinCtrcts',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41863,
        description:
            "Specifies the minimum futures contracts level that dictates whether or not a 'De Minimis Trading' event has occurred.\n\nApplicable to 1993 Commodity Definitions only.",
    },
    {
        name: 'NoUnderlyingMarketDisruptionEvents',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41864,
        description: 'Number of disruption events in the repeating group.',
    },
    {
        name: 'UnderlyingMarketDisruptionEvent',
        abbrName: 'Evnt',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        updatedEP: '187',
        id: 41865,
        description:
            'Specifies the market disruption event.\n\nFor commodities see http://www.fpml.org/coding-scheme/commodity-market-disruption for values.\n\nFor foreign exchange, see http://www.fixtradingcommunity.org/codelists#Market_Disruption_Event for code list of applicable event types.',
    },
    {
        name: 'NoUnderlyingMarketDisruptionFallbacks',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41866,
        description: 'Number of fallbacks in the repeating group.',
    },
    {
        name: 'UnderlyingMarketDisruptionFallbackType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41867,
        description:
            'Specifies the type of disruption fallback.\n\nSee http://www.fpml.org/coding-scheme/commodity-market-disruption-fallback for values.',
    },
    {
        name: 'NoUnderlyingMarketDisruptionFallbackReferencePrices',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41868,
        description: 'Number of fallback reference securities in the repeating group.',
    },
    {
        name: 'UnderlyingMarketDisruptionFallbackUnderlierType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'MarketDisruptionFallbackUnderlierTypeCodeSet',
        id: 41869,
        description: 'The type of reference price underlier.',
    },
    {
        name: 'UnderlyingMarketDisruptionFallbackUnderlierSecurityID',
        abbrName: 'ID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41870,
        discriminatorId: '41871',
        description: 'Specifies the identifier value of the security.',
    },
    {
        name: 'UnderlyingMarketDisruptionFallbackUnderlierSecurityIDSource',
        abbrName: 'Src',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.Latest',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'SecurityIDSourceCodeSet',
        updatedEP: '265',
        id: 41871,
        description: 'Specifies the class or source scheme of the security identifier.',
    },
    {
        name: 'UnderlyingMarketDisruptionFallbackUnderlierSecurityDesc',
        abbrName: 'Desc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41872,
        description: 'Specifies the description of underlying security.',
    },
    {
        name: 'EncodedUnderlyingMarketDisruptionFallbackUnderlierSecDescLen',
        abbrName: 'EncDescLen',
        updated: 'FIX.Latest',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Length',
        updatedEP: '271',
        id: 41873,
        description:
            'Byte length of encoded (non-ASCII characters) EncodedUnderlyingMarketDisruptionFallbackUnderlierSecurityDesc(41874) field.',
    },
    {
        name: 'EncodedUnderlyingMarketDisruptionFallbackUnderlierSecurityDesc',
        abbrName: 'EncDesc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 41874,
        lengthId: '41873',
        description:
            'Encoded (non-ASCII characters) representation of the UnderlyingMarketDisruptionFallbackUnderlierSecurityDesc(41872) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the UnderlyingMarketDisruptionFallbackUnderlierSecurityDesc(41872).',
    },
    {
        name: 'UnderlyingMarketDisruptionFallbackOpenUnits',
        abbrName: 'OpnUnits',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 41875,
        description:
            'If there are multiple underlying assets, this specifies the number of units (index or securities) that constitute the underlier of the swap. In the case of a basket swap, this is used to reference both the number of basket units, and the number of each asset components of the basket when these are expressed in absolute terms.',
    },
    {
        name: 'UnderlyingMarketDisruptionFallbackBasketCurrency',
        abbrName: 'Ccy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41876,
        description: 'Specifies the currency if the underlier is a basket. Uses ISO 4217 currency codes.',
    },
    {
        name: 'UnderlyingMarketDisruptionFallbackBasketDivisor',
        abbrName: 'Dvsr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 41877,
        description:
            'Specifies the basket divisor amount. This value is normally used to adjust the constituent weight for pricing or to adjust for dividends, or other corporate actions.',
    },
    {
        name: 'NoUnderlyingPaymentScheduleFixingDays',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41878,
        description: 'Number of fixing days in the repeating group.',
    },
    {
        name: 'UnderlyingPaymentScheduleFixingDayOfWeek',
        abbrName: 'DayOfWk',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPricingDayOfWeekCodeSet',
        id: 41879,
        description: 'The day of the week on which fixing takes place.',
    },
    {
        name: 'UnderlyingPaymentScheduleFixingDayNumber',
        abbrName: 'DayNum',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41880,
        description:
            'The occurrence of the day of week on which fixing takes place.\n\nFor example, a fixing of the 3rd Friday would be DayOfWk=5 DayNum=3. If omitted every day of the week is a fixing day.',
    },
    {
        name: 'UnderlyingPaymentScheduleXID',
        abbrName: 'XID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XID',
        id: 41881,
        description: 'Identifier of this UnderlyingPaymentSchedule for cross referencing elsewhere in the message.',
    },
    {
        name: 'UnderlyingPaymentScheduleXIDRef',
        abbrName: 'XIDRef',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XIDREF',
        id: 41882,
        description: 'Reference to payment schedule elsewhere in the message.',
    },
    {
        name: 'UnderlyingPaymentScheduleRateCurrency',
        abbrName: 'RtCcy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41883,
        description: 'Specifies the currency of the schedule rate. Uses ISO 4217 currency codes.',
    },
    {
        name: 'UnderlyingPaymentScheduleRateUnitOfMeasure',
        abbrName: 'RtUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41884,
        description: 'The schedule rate unit of measure (UOM).',
    },
    {
        name: 'UnderlyingPaymentScheduleRateConversionFactor',
        abbrName: 'RtFctr',
        updated: 'FIX.Latest',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        updatedEP: '271',
        id: 41885,
        description:
            "The number to be multiplied by the derived floating rate of the underlying's payment schedule in order to arrive at the payment rate. If omitted, the schedule rate conversion factor is 1.",
    },
    {
        name: 'UnderlyingPaymentScheduleRateSpreadType',
        abbrName: 'SpreadTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateSpreadTypeCodeSet',
        id: 41886,
        description:
            'Specifies whether the rate spread is an absolute value to be added to the index rate or a percentage of the index rate.',
    },
    {
        name: 'UnderlyingPaymentScheduleSettlPeriodPrice',
        abbrName: 'SettlPx',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 41887,
        description: 'The schedule settlement period price.',
    },
    {
        name: 'UnderlyingPaymentScheduleSettlPeriodPriceCurrency',
        abbrName: 'SettlPxCcy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41888,
        description: 'The currency of the schedule settlement period price. Uses ISO 4217 currency codes.',
    },
    {
        name: 'UnderlyingPaymentScheduleSettlPeriodPriceUnitOfMeasure',
        abbrName: 'SettlPxUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41889,
        description: 'The settlement period price unit of measure (UOM).',
    },
    {
        name: 'UnderlyingPaymentScheduleStepUnitOfMeasure',
        abbrName: 'StepUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41890,
        description: 'The schedule step unit of measure (UOM).',
    },
    {
        name: 'UnderlyingPaymentScheduleFixingDayDistribution',
        abbrName: 'FixngDayDistrib',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPricingDayDistributionCodeSet',
        id: 41891,
        description: 'The distribution of fixing days.',
    },
    {
        name: 'UnderlyingPaymentScheduleFixingDayCount',
        abbrName: 'FixngDayCnt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41892,
        description: 'The number of days over which fixing should take place.',
    },
    {
        name: 'UnderlyingPaymentScheduleFixingLagPeriod',
        abbrName: 'FixngLagPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41893,
        description: 'Time unit multiplier for the fixing lag duration.',
    },
    {
        name: 'UnderlyingPaymentScheduleFixingLagUnit',
        abbrName: 'FixngLagUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamInflationLagUnitCodeSet',
        id: 41894,
        description: 'Time unit associated with the fixing lag duration.',
    },
    {
        name: 'UnderlyingPaymentScheduleFixingFirstObservationDateOffsetPeriod',
        abbrName: 'FixngFirstObsvtnPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 41895,
        description:
            'Time unit multiplier for the relative first observation date offset.\n\nIf the first observation offset is specified, the observation period will start the specified interval prior to each calculation period - i.e. if the first observation offset is 4 months and the lag duration is 3 months, observations will be taken in months 4, 3 and 2 (but not 1) prior to each calculation period. If no first observation offset is specified, the observation period will end immediately preceding each calculation period.',
    },
    {
        name: 'UnderlyingPaymentScheduleFixingFirstObservationDateOffsetUnit',
        abbrName: 'FixngFirstObsvtnUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 41896,
        description: 'Time unit associated with the relative first observation date offset.',
    },
    {
        name: 'UnderlyingPaymentStreamFlatRateIndicator',
        abbrName: 'FlatRtInd',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 41897,
        description:
            'When this element is specified and set to \'Y\', the Flat Rate is the New Worldwide Tanker Nominal Freight Scale for the Freight Index Route taken at the Trade Date of the transaction "Fixed". If \'N\' it is taken on each Pricing Date "Floating".',
    },
    {
        name: 'UnderlyingPaymentStreamFlatRateAmount',
        abbrName: 'FlatRtAmt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 41898,
        description:
            "Specifies the actual monetary value of the flat rate when UnderlyingPaymentStreamFlatRateIndicator(41897) = 'Y'.",
    },
    {
        name: 'UnderlyingPaymentStreamFlatRateCurrency',
        abbrName: 'FlatRtCcy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41899,
        description: 'Specifies the currency of the actual flat rate. Uses ISO 4217 currency codes.',
    },
    {
        name: 'UnderlyingPaymentStreamMaximumPaymentAmount',
        abbrName: 'MaxPmtAmt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 41900,
        description: 'Specifies the limit on the total payment amount.',
    },
    {
        name: 'UnderlyingPaymentStreamMaximumPaymentCurrency',
        abbrName: 'MaxPmtCcy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41901,
        description: 'Specifies the currency of total payment amount limit. Uses ISO 4217 currency codes.',
    },
    {
        name: 'UnderlyingPaymentStreamMaximumTransactionAmount',
        abbrName: 'MaxTxnAmt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 41902,
        description: 'Specifies the limit on the payment amount that goes out in any particular calculation period.',
    },
    {
        name: 'UnderlyingPaymentStreamMaximumTransactionCurrency',
        abbrName: 'MaxTxnCcy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41903,
        description: 'Specifies the currency of the period payment amount limit. Uses ISO 4217 currency codes.',
    },
    {
        name: 'UnderlyingPaymentStreamFixedAmountUnitOfMeasure',
        abbrName: 'FixedAmtUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41904,
        description: 'Fixed payment amount unit of measure (UOM).',
    },
    {
        name: 'UnderlyingPaymentStreamTotalFixedAmount',
        abbrName: 'FixedAmt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 41905,
        description: 'Specifies the total fixed payment amount.',
    },
    {
        name: 'UnderlyingPaymentStreamWorldScaleRate',
        abbrName: 'WorldScaleRt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 41906,
        description:
            'The number of Worldscale points for purposes of the calculation of a fixed amount for a wet voyage charter commodity swap.',
    },
    {
        name: 'UnderlyingPaymentStreamContractPrice',
        abbrName: 'CtrctPx',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 41907,
        description:
            'The price per relevant unit for purposes of the calculation of a fixed amount for a dry voyage charter or time charter commodity swap.',
    },
    {
        name: 'UnderlyingPaymentStreamContractPriceCurrency',
        abbrName: 'CtrctPxCcy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41908,
        description:
            'Specifies the currency of UnderlyingPaymentStreamContractPrice(41907). Uses ISO 4217 currency codes.',
    },
    {
        name: 'NoUnderlyingPaymentStreamPricingBusinessCenters',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41909,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'UnderlyingPaymentStreamPricingBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41910,
        description:
            'The business center calendar used to adjust the payment stream\'s pricing dates, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'UnderlyingPaymentStreamRateIndex2CurveUnit',
        abbrName: 'Ndx2Unit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexCurveUnitCodeSet',
        id: 41911,
        description: 'Secondary time unit associated with the payment stream’s floating rate index curve.',
    },
    {
        name: 'UnderlyingPaymentStreamRateIndex2CurvePeriod',
        abbrName: 'Ndx2Period',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41912,
        description:
            'Secondary time unit multiplier for the payment stream’s floating rate index curve.\n\nMay be used for a Forward Rate Agreement (FRA) with an average rate between two curve points.',
    },
    {
        name: 'UnderlyingPaymentStreamRateIndexLocation',
        abbrName: 'NdxLctn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41913,
        description: 'Specifies the location of the floating rate index.',
    },
    {
        name: 'UnderlyingPaymentStreamRateIndexLevel',
        abbrName: 'NdxLvl',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 41914,
        description:
            'This is the weather Cooling Degree Days (CDD), Heating Degree Days (HDD) or HDD index level specified as the number of (amount of) weather index units specified by the parties in the related confirmation.',
    },
    {
        name: 'UnderlyingPaymentStreamRateIndexUnitOfMeasure',
        abbrName: 'NdxUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41915,
        description: 'The unit of measure (UOM) of the rate index level.',
    },
    {
        name: 'UnderlyingPaymentStreamSettlLevel',
        abbrName: 'SettlLvl',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamSettlLevelCodeSet',
        id: 41916,
        description: 'Specifies how weather index units are to be calculated.',
    },
    {
        name: 'UnderlyingPaymentStreamReferenceLevel',
        abbrName: 'RefLvl',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 41917,
        description:
            'This is the weather Cooling Degree Days (CDD), Heating Degree Days (HDD) or HDD reference level specified as the number of (amount of) weather index units specified by the parties in the related confirmation.',
    },
    {
        name: 'UnderlyingPaymentStreamReferenceLevelUnitOfMeasure',
        abbrName: 'RefUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41918,
        description: 'The unit of measure (UOM) of the rate reference level.',
    },
    {
        name: 'UnderlyingPaymentStreamReferenceLevelEqualsZeroIndicator',
        abbrName: 'RefLvlZero',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 41919,
        description: "When set to 'Y', it indicates that the weather reference level equals zero.",
    },
    {
        name: 'UnderlyingPaymentStreamRateSpreadCurrency',
        abbrName: 'SpreadCcy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41920,
        description: 'Specifies the currency of the floating rate spread. Uses ISO 4217 currency codes.',
    },
    {
        name: 'UnderlyingPaymentStreamRateSpreadUnitOfMeasure',
        abbrName: 'SpreadUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41921,
        description: 'Specifies the unit of measure (UOM) of the floating rate spread.',
    },
    {
        name: 'UnderlyingPaymentStreamRateConversionFactor',
        abbrName: 'RtFctr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 41922,
        description:
            "The number to be multiplied by the derived floating rate of the underlying's payment stream in order to arrive at the payment rate. If omitted, the floating rate conversion factor is 1.",
    },
    {
        name: 'UnderlyingPaymentStreamRateSpreadType',
        abbrName: 'SpreadTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateSpreadTypeCodeSet',
        id: 41923,
        description:
            'Identifies whether the rate spread is an absolute value to be added to the index rate or a percentage of the index rate.',
    },
    {
        name: 'UnderlyingPaymentStreamLastResetRate',
        abbrName: 'LastResetRt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 41924,
        description:
            'The floating rate determined at the most recent reset. The rate is expressed in decimal form, e.g. 5% is represented as 0.05.',
    },
    {
        name: 'UnderlyingPaymentStreamFinalRate',
        abbrName: 'FnlRt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 41925,
        description:
            'The floating rate determined at the final reset. The rate is expressed in decimal form, e.g. 5% is represented as 0.05.',
    },
    {
        name: 'UnderlyingPaymentStreamCalculationLagPeriod',
        abbrName: 'CalcLagPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41926,
        description: 'Time unit multiplier for the calculation lag duration.',
    },
    {
        name: 'UnderlyingPaymentStreamCalculationLagUnit',
        abbrName: 'CalcLagUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamInflationLagUnitCodeSet',
        id: 41927,
        description: 'Time unit associated with the calculation lag duration.',
    },
    {
        name: 'UnderlyingPaymentStreamFirstObservationDateOffsetPeriod',
        abbrName: 'FirstObsvtnOfstPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 41928,
        description:
            'Time unit multiplier for the relative first observation date offset.\n\nIf the first observation offset is specified, the observation period will start the specified interval prior to each calculation period - i.e. if the first observation offset is 4 months and the lag duration is 3 months, observations will be taken in months 4, 3 and 2 (but not 1) prior to each calculation period. If no first observation offset is specified, the observation period will end immediately preceding each calculation period.',
    },
    {
        name: 'UnderlyingPaymentStreamFirstObservationDateOffsetUnit',
        abbrName: 'FirstObsvtnOfstUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 41929,
        description: 'Time unit associated with the relative first observation date offset.',
    },
    {
        name: 'UnderlyingPaymentStreamPricingDayType',
        abbrName: 'PxngDayTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventDateOffsetDayTypeCodeSet',
        id: 41930,
        description: 'Specifies the commodity pricing day type.',
    },
    {
        name: 'UnderlyingPaymentStreamPricingDayDistribution',
        abbrName: 'PxngDayDistrib',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPricingDayDistributionCodeSet',
        id: 41931,
        description: 'The distribution of pricing days.',
    },
    {
        name: 'UnderlyingPaymentStreamPricingDayCount',
        abbrName: 'PxngDayCnt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41932,
        description: 'The number of days over which pricing should take place.',
    },
    {
        name: 'UnderlyingPaymentStreamPricingBusinessCalendar',
        abbrName: 'PxngClndr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41933,
        description:
            'Specifies the business calendar to use for pricing.\n\nSee http://www.fpml.org/coding-scheme/commodity-business-calendar for values.',
    },
    {
        name: 'UnderlyingPaymentStreamPricingBusinessDayConvention',
        abbrName: 'PxngBizDayCnvtn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 41934,
        description:
            "The business day convention used to adjust the payment stream's pricing dates. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.",
    },
    {
        name: 'NoUnderlyingPaymentStreamPaymentDates',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41937,
        description: 'Number of payment dates in the repeating group.',
    },
    {
        name: 'UnderlyingPaymentStreamPaymentDate',
        abbrName: 'Dt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41938,
        description: 'The adjusted or unadjusted fixed stream payment date.',
    },
    {
        name: 'UnderlyingPaymentStreamPaymentDateType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'OptionExerciseDateTypeCodeSet',
        id: 41939,
        description:
            'Specifies the type of payment date. When specified it applies not only to the current date but to all subsequent dates in the group until overridden with a new type.',
    },
    {
        name: 'UnderlyingPaymentStreamMasterAgreementPaymentDatesIndicator',
        abbrName: 'MADts',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 41940,
        description: "When set to 'Y', it indicates that payment dates are specified in the relevant master agreement.",
    },
    {
        name: 'NoUnderlyingPaymentStreamPricingDates',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41941,
        description: 'Number of pricing dates in the repeating group.',
    },
    {
        name: 'UnderlyingPaymentStreamPricingDate',
        abbrName: 'Dt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41942,
        description: 'An adjusted or unadjusted fixed pricing date.',
    },
    {
        name: 'UnderlyingPaymentStreamPricingDateType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'OptionExerciseDateTypeCodeSet',
        id: 41943,
        description:
            'Specifies the type of pricing date. When specified it applies not only to the current date but to all subsequent dates in the group until overridden with a new type.',
    },
    {
        name: 'NoUnderlyingPaymentStreamPricingDays',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41944,
        description: 'Number of pricing days in the repeating group.',
    },
    {
        name: 'UnderlyingPaymentStreamPricingDayOfWeek',
        abbrName: 'DayOfWk',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPricingDayOfWeekCodeSet',
        id: 41945,
        description: 'The day of the week on which pricing takes place.',
    },
    {
        name: 'UnderlyingPaymentStreamPricingDayNumber',
        abbrName: 'DayNum',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41946,
        description:
            'The occurrence of the day of week on which pricing takes place.\n\nFor example a pricing day of the 3rd Friday would be DayOfWk=5 DayNum=3.',
    },
    {
        name: 'NoUnderlyingPricingDateBusinessCenters',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41947,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'UnderlyingPricingDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41948,
        description:
            'The business center calendar used to adjust the pricing or fixing date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'UnderlyingPricingDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41949,
        description: 'The unadjusted pricing or fixing date.',
    },
    {
        name: 'UnderlyingPricingDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 41950,
        description:
            'The business day convention used to adjust the pricing or fixing date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.',
    },
    {
        name: 'UnderlyingPricingDateAdjusted',
        abbrName: 'Dt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41951,
        description: 'The adjusted pricing or fixing date.',
    },
    {
        name: 'UnderlyingPricingTime',
        abbrName: 'Tm',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 41952,
        description: 'The local market pricing or fixing time.',
    },
    {
        name: 'UnderlyingPricingTimeBusinessCenter',
        abbrName: 'TmBizCtr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41953,
        description:
            'Specifies the business center for determining the pricing or fixing time. See http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'NoUnderlyingStreamCalculationPeriodDates',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41954,
        description: 'Number of calculation period dates in the repeating group.',
    },
    {
        name: 'UnderlyingStreamCalculationPeriodDate',
        abbrName: 'Dt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41955,
        description: 'The adjusted or unadjusted fixed calculation period date.',
    },
    {
        name: 'UnderlyingStreamCalculationPeriodDateType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'OptionExerciseDateTypeCodeSet',
        id: 41956,
        description:
            'Specifies the type of fixed calculation period date. When specified it applies not only to the current date but to all subsequent dates in the group until overridden with a new type.',
    },
    {
        name: 'UnderlyingStreamCalculationPeriodDatesXID',
        abbrName: 'XID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XID',
        id: 41957,
        description: 'Identifier of this calculation period for cross referencing elsewhere in the message.',
    },
    {
        name: 'UnderlyingStreamCalculationPeriodDatesXIDRef',
        abbrName: 'XIDRef',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XIDREF',
        id: 41958,
        description: 'Cross reference to another calculation period for duplicating its properties.',
    },
    {
        name: 'UnderlyingStreamCalculationBalanceOfFirstPeriod',
        abbrName: 'BalFirst',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 41959,
        description:
            "When specified and set to 'Y', it indicates that the first calculation period should run from the effective date to the end of the calendar period in which the effective date falls (e.g. Jan 15 - Jan 31 if the calculation periods are one month long and effective date is Jan 15.). If 'N' or not specified, it indicates that the first calculation period should run from the effective date for one whole period (e.g. Jan 15 to Feb 14 if the calculation periods are one month long and the effective date is Jan 15.).",
    },
    {
        name: 'UnderlyingStreamCalculationCorrectionPeriod',
        abbrName: 'CrrctnPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41960,
        description:
            'Time unit multiplier for the length of time after the publication of the data when corrections can be made.',
    },
    {
        name: 'UnderlyingStreamCalculationCorrectionUnit',
        abbrName: 'CrrctnUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ProtectionTermEventUnitCodeSet',
        id: 41961,
        description:
            'Time unit associated with the length of time after the publication of the data when corrections can be made.',
    },
    {
        name: 'NoUnderlyingStreamCommoditySettlBusinessCenters',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41962,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'UnderlyingStreamCommoditySettlBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41963,
        description:
            'The business center calendar used to adjust the commodity delivery date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'UnderlyingStreamCommodityBase',
        abbrName: 'Base',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41964,
        description:
            'Specifies the general base type of the commodity traded. Where possible, this should follow the naming convention used in the 2005 ISDA Commodity Definitions.\n\nExamples of general commodity base types include:Metal, Bullion, Oil, Natural Gas, Coal, Electricity, Inter-Energy, Grains, Oils Seeds, Dairy, Livestock, Forestry, Softs, Weather, Emissions.',
    },
    {
        name: 'UnderlyingStreamCommodityType',
        abbrName: 'CmdtyTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41965,
        description:
            'Specifies the type of commodity product.\n\nFor coal see http://www.fpml.org/coding-scheme/commodity-coal-product-type for values.\n\nFor metals see http://www.fpml.org/coding-scheme/commodity-metal-product-type for values.\n\nFor bullion see http://www.fixtradingcommunity.org/codelists#Bullion_Types for the external code list of bullion types.',
    },
    {
        name: 'UnderlyingStreamCommoditySecurityID',
        abbrName: 'ID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41966,
        discriminatorId: '41967',
        description: 'Specifies the market identifier for the commodity.',
    },
    {
        name: 'UnderlyingStreamCommoditySecurityIDSource',
        abbrName: 'Src',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.Latest',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'SecurityIDSourceCodeSet',
        updatedEP: '265',
        id: 41967,
        description: 'Identifies the class or source of the UnderlyingStreamCommoditySecurityIDSource(41966) value.',
    },
    {
        name: 'UnderlyingStreamCommodityDesc',
        abbrName: 'Desc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41968,
        description: 'Description of the commodity asset.',
    },
    {
        name: 'EncodedUnderlyingStreamCommodityDescLen',
        abbrName: 'EncDescLen',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 41969,
        description: 'Byte length of encoded (non-ASCII characters) EncodedUnderlyingStreamCommodityDesc(41970) field.',
    },
    {
        name: 'EncodedUnderlyingStreamCommodityDesc',
        abbrName: 'EncDesc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 41970,
        lengthId: '41969',
        description:
            'Encoded (non-ASCII characters) representation of the UnderlyingStreamCommodityDesc(41968) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the UnderlyingStreamCommodityDesc(41968) field.',
    },
    {
        name: 'UnderlyingStreamCommodityUnitOfMeasure',
        abbrName: 'UOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 41971,
        description: 'The unit of measure (UOM) of the commodity asset.',
    },
    {
        name: 'UnderlyingStreamCommodityCurrency',
        abbrName: 'Ccy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41972,
        description: 'Identifies the currency of the commodity asset. Uses ISO 4217 currency codes.',
    },
    {
        name: 'UnderlyingStreamCommodityExchange',
        abbrName: 'Exch',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Exchange',
        id: 41973,
        description: 'Identifies the exchange where the commodity is traded.',
    },
    {
        name: 'UnderlyingStreamCommodityRateSource',
        abbrName: 'RtSrc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41974,
        description:
            'Identifies the source of rate information used for commodities.\n\nSee http://www.fixtradingcommunity.org/codelists#Commodity_Rate_Source for code list of applicable sources.',
    },
    {
        name: 'UnderlyingStreamCommodityRateReferencePage',
        abbrName: 'RefPg',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41975,
        description: 'Identifies the reference "page" from the rate source.',
    },
    {
        name: 'UnderlyingStreamCommodityRateReferencePageHeading',
        abbrName: 'RefHdng',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41976,
        description: 'Identifies the page heading from the rate source.',
    },
    {
        name: 'UnderlyingStreamDataProvider',
        abbrName: 'DataPrvdr',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41977,
        description:
            'Specifies the commodity data or information provider.\n\nSee http://www.fpml.org/coding-scheme/commodity-information-provider for values.',
    },
    {
        name: 'UnderlyingStreamCommodityPricingType',
        abbrName: 'PxngTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41978,
        description:
            'Specifies how the pricing or rate setting of the trade is to be determined or based upon.\n\nSee http://www.fixtradingcommunity.org/codelists#Commodity_Rate_Pricing_Type for code list of applicable commodity pricing types.',
    },
    {
        name: 'UnderlyingStreamCommodityNearbySettlDayPeriod',
        abbrName: 'Period',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41979,
        description:
            'Time unit multiplier for the nearby settlement day.\n\nWhen the commodity transaction references a futures contract, the delivery or settlement dates are a nearby month or week. For example, for eighth nearby month use Period=8 and Unit=Mo.',
    },
    {
        name: 'UnderlyingStreamCommodityNearbySettlDayUnit',
        abbrName: 'Unit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'StreamCommodityNearbySettlDayUnitCodeSet',
        id: 41980,
        description: 'Time unit associated with the nearby settlement day.',
    },
    {
        name: 'UnderlyingStreamCommoditySettlDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41981,
        description: 'The unadjusted commodity delivery date.',
    },
    {
        name: 'UnderlyingStreamCommoditySettlDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 41982,
        description:
            'The business day convention used to adjust the commodity delivery date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.',
    },
    {
        name: 'UnderlyingStreamCommoditySettlDateAdjusted',
        abbrName: 'Dt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 41983,
        description: 'The adjusted commodity delivery date.',
    },
    {
        name: 'UnderlyingStreamCommoditySettlMonth',
        abbrName: 'Mo',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41984,
        description:
            'Specifies a fixed single month for commodity delivery.\n\nUse "1" for January, "2" for February, etc.',
    },
    {
        name: 'UnderlyingStreamCommoditySettlDateRollPeriod',
        abbrName: 'RollPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41985,
        description:
            'Time unit multiplier for the commodity delivery date roll.\n\nFor a commodity transaction that references a listed future via the delivery dates, this is the day offset on which the specified future will roll to the next nearby month when the referenced future expires.',
    },
    {
        name: 'UnderlyingStreamCommoditySettlDateRollUnit',
        abbrName: 'RollUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'StreamCommoditySettlDateRollUnitCodeSet',
        id: 41986,
        description: 'Time unit associated with the commodity delivery date roll.',
    },
    {
        name: 'UnderlyingStreamCommoditySettlDayType',
        abbrName: 'DayTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventDateOffsetDayTypeCodeSet',
        id: 41987,
        description: 'Specifies the commodity delivery roll day type.',
    },
    {
        name: 'UnderlyingStreamCommodityXID',
        abbrName: 'XID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XID',
        id: 41988,
        description: 'Identifier of this stream commodity for cross referencing elsewhere in the message.',
    },
    {
        name: 'UnderlyingStreamCommodityXIDRef',
        abbrName: 'XIDRef',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XIDREF',
        id: 41989,
        description: 'Reference to a stream commodity elsewhere in the message.',
    },
    {
        name: 'NoUnderlyingStreamCommodityAltIDs',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41990,
        description: 'Number of alternate security identifers.',
    },
    {
        name: 'UnderlyingStreamCommodityAltID',
        abbrName: 'AltID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41991,
        discriminatorId: '41992',
        description: 'Alternate security identifier value for the commodity.',
    },
    {
        name: 'UnderlyingStreamCommodityAltIDSource',
        abbrName: 'AltIDSrc',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41992,
        description: 'Identifies the class or source of the alternate commodity security identifier.',
    },
    {
        name: 'NoUnderlyingStreamCommodityDataSources',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41993,
        description: 'Number of commodity data sources in the repeating group.',
    },
    {
        name: 'UnderlyingStreamCommodityDataSourceID',
        abbrName: 'ID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41994,
        description: 'Data source identifier.',
    },
    {
        name: 'UnderlyingStreamCommodityDataSourceIDType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'StreamCommodityDataSourceIDTypeCodeSet',
        id: 41995,
        description: 'Specifies the type of data source identifier.',
    },
    {
        name: 'NoUnderlyingStreamCommoditySettlDays',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41996,
        description: 'Number of days in the repeating group.',
    },
    {
        name: 'UnderlyingStreamCommoditySettlDay',
        abbrName: 'Day',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryScheduleSettlDayCodeSet',
        id: 41997,
        description: 'Specifies the day or group of days for delivery.',
    },
    {
        name: 'UnderlyingStreamCommoditySettlTotalHours',
        abbrName: 'TotHrs',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 41998,
        description: 'Sum of the hours specified in UnderlyingStreamCommoditySettlTimeGrp.',
    },
    {
        name: 'NoUnderlyingStreamCommoditySettlTimes',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41999,
        description: 'Number of hour ranges in the repeating group.',
    },
    {
        name: 'UnderlyingStreamCommoditySettlStart',
        abbrName: 'Start',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42000,
        description:
            'The start time for commodity settlement where delivery occurs over time. The time format is specified by the settlement time type.',
    },
    {
        name: 'UnderlyingStreamCommoditySettlEnd',
        abbrName: 'End',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42001,
        description:
            'The end time for commodity settlement where delivery occurs over time. The time format is specified by the settlement time type.',
    },
    {
        name: 'UnderlyingStreamCommoditySettlTimeType',
        abbrName: 'Typ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryScheduleSettlTimeTypeCodeSet',
        id: 41936,
        description: 'Specifies the format of the commodity settlement start and end times.',
    },
    {
        name: 'NoUnderlyingStreamCommoditySettlPeriods',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42002,
        description: 'Number of commodity settlement periods in the repeating group.',
    },
    {
        name: 'UnderlyingStreamCommoditySettlCountry',
        abbrName: 'Ctry',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Country',
        id: 42003,
        description: 'Specifies the country where delivery takes place. Uses ISO 3166 2-character country code.',
    },
    {
        name: 'UnderlyingStreamCommoditySettlTimeZone',
        abbrName: 'TZ',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42004,
        description:
            'Commodity delivery timezone specified as "prevailing" rather than "standard" or "daylight".\n\nSee http://www.fixtradingcommunity.org/codelists#Prevailing_Timezones for code list of applicable prevailing timezones.',
    },
    {
        name: 'UnderlyingStreamCommoditySettlFlowType',
        abbrName: 'FlowTyp',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryScheduleSettlFlowTypeCodeSet',
        id: 42005,
        description: 'Specifies the commodity delivery flow type.',
    },
    {
        name: 'UnderlyingStreamCommoditySettlPeriodNotional',
        abbrName: 'Notl',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 42006,
        description: 'Specifies the delivery quantity associated with this settlement period.',
    },
    {
        name: 'UnderlyingStreamCommoditySettlPeriodNotionalUnitOfMeasure',
        abbrName: 'NotlUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 42007,
        description:
            'Specifies the unit of measure (UOM) of the delivery quantity associated with this settlement period.',
    },
    {
        name: 'UnderlyingStreamCommoditySettlPeriodFrequencyPeriod',
        abbrName: 'FreqPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42008,
        description: 'Time unit multiplier for the settlement period frequency.',
    },
    {
        name: 'UnderlyingStreamCommoditySettlPeriodFrequencyUnit',
        abbrName: 'FreqUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'ProtectionTermEventUnitCodeSet',
        id: 42009,
        description: 'Time unit associated with the settlement period frequency.',
    },
    {
        name: 'UnderlyingStreamCommoditySettlPeriodPrice',
        abbrName: 'Px',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 42010,
        description: 'The settlement period price.',
    },
    {
        name: 'UnderlyingStreamCommoditySettlPeriodPriceUnitOfMeasure',
        abbrName: 'PxUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 42011,
        description: 'Specifies the settlement period price unit of measure (UOM).',
    },
    {
        name: 'UnderlyingStreamCommoditySettlPeriodPriceCurrency',
        abbrName: 'PxCcy',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 42012,
        description: 'The currency of the settlement period price. Uses ISO 4217 currency codes.',
    },
    {
        name: 'UnderlyingStreamCommoditySettlHolidaysProcessingInstruction',
        abbrName: 'Holidays',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'DeliveryScheduleSettlHolidaysProcessingInstructionCodeSet',
        id: 42013,
        description:
            'Indicates whether holidays are included in the settlement periods. Required for electricity contracts.',
    },
    {
        name: 'UnderlyingStreamCommoditySettlPeriodXID',
        abbrName: 'XID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XID',
        id: 42014,
        description: 'Identifier of this settlement period for cross referencing elsewhere in the message.',
    },
    {
        name: 'UnderlyingStreamCommoditySettlPeriodXIDRef',
        abbrName: 'XIDRef',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XIDREF',
        id: 42015,
        description: 'Cross reference to another settlement period for duplicating its properties.',
    },
    {
        name: 'UnderlyingStreamXID',
        abbrName: 'XID',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XID',
        id: 42016,
        description: 'Identifier of this UnderlyingStream for cross referencing elsewhere in the message.',
    },
    {
        name: 'UnderlyingStreamNotionalXIDRef',
        abbrName: 'NotlXIDRef',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'XIDREF',
        id: 42018,
        description: 'Cross reference to another UnderlyingStream notional for duplicating its properties.',
    },
    {
        name: 'UnderlyingStreamNotionalFrequencyPeriod',
        abbrName: 'NotlPeriod',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42019,
        description: "Time unit multiplier for the swap stream's notional frequency.",
    },
    {
        name: 'UnderlyingStreamNotionalFrequencyUnit',
        abbrName: 'NotlUnit',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'TimeUnitCodeSet',
        id: 42020,
        description: "Time unit associated with the swap stream's notional frequency.",
    },
    {
        name: 'UnderlyingStreamNotionalCommodityFrequency',
        abbrName: 'NotlFreq',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'StreamNotionalCommodityFrequencyCodeSet',
        id: 42021,
        description: "The commodity's notional or quantity delivery frequency.",
    },
    {
        name: 'UnderlyingStreamNotionalUnitOfMeasure',
        abbrName: 'NotlUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 42022,
        description: 'Specifies the delivery quantity unit of measure (UOM).',
    },
    {
        name: 'UnderlyingStreamTotalNotional',
        abbrName: 'TotNotl',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 42023,
        description: 'Specifies the total notional or delivery quantity over the term of the contract.',
    },
    {
        name: 'UnderlyingStreamTotalNotionalUnitOfMeasure',
        abbrName: 'TotNotlUOM',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 42024,
        description:
            'Specifies the unit of measure (UOM) for the total notional or delivery quantity over the term of the contract.',
    },
    {
        name: 'AllocGrossTradeAmt',
        abbrName: 'GrossTrdAmt',
        addedEP: '170',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 2300,
        description: 'Total amount traded for this account (i.e. quantity * price) expressed in units of currency.',
    },
    {
        name: 'RiskLimitReportStatus',
        abbrName: 'RptStat',
        addedEP: '171',
        added: 'FIX.5.0SP2',
        type: 'RiskLimitReportStatusCodeSet',
        id: 2316,
        description: 'Status of risk limit report.',
    },
    {
        name: 'RiskLimitReportRejectReason',
        abbrName: 'RejRsn',
        addedEP: '171',
        added: 'FIX.5.0SP2',
        type: 'RiskLimitReportRejectReasonCodeSet',
        id: 2317,
        description: 'The reason for rejecting the PartyRiskLimitsReport(35=CM) or PartyRiskLimitsUpdateReport(35=CR).',
    },
    {
        name: 'RiskLimitCheckRequestID',
        abbrName: 'ChkReqID',
        addedEP: '171',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2318,
        description: 'The unique identifier of the PartyRiskLimitCheckRequest(35=DF) message.',
    },
    {
        name: 'RiskLimitCheckID',
        abbrName: 'LmtChkID',
        addedEP: '171',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2319,
        description: 'The unique and static identifier, at the business entity level, of a risk limit check request.',
    },
    {
        name: 'RiskLimitCheckTransType',
        abbrName: 'TransTyp',
        addedEP: '171',
        added: 'FIX.5.0SP2',
        type: 'RiskLimitCheckTransTypeCodeSet',
        id: 2320,
        description: 'Specifies the transaction type of the risk limit check request.',
    },
    {
        name: 'RiskLimitCheckType',
        abbrName: 'ChkTyp',
        addedEP: '171',
        added: 'FIX.5.0SP2',
        type: 'RiskLimitCheckTypeCodeSet',
        id: 2321,
        description: 'Specifies the type of limit check message.',
    },
    {
        name: 'RiskLimitCheckRequestRefID',
        abbrName: 'ReqRefID',
        addedEP: '171',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2322,
        description: 'Specifies the message reference identifier of the risk limit check request message.',
    },
    {
        name: 'RiskLimitCheckRequestType',
        abbrName: 'ChkReqTyp',
        addedEP: '171',
        added: 'FIX.5.0SP2',
        type: 'RiskLimitCheckRequestTypeCodeSet',
        id: 2323,
        description: 'Specifies the type of limit amount check being requested.',
    },
    {
        name: 'RiskLimitCheckAmount',
        abbrName: 'LmtChkAmt',
        addedEP: '171',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 2324,
        description: 'Specifies the amount being requested for approval.',
    },
    {
        name: 'RiskLimitCheckRequestStatus',
        abbrName: 'ReqStat',
        addedEP: '171',
        added: 'FIX.5.0SP2',
        type: 'RiskLimitCheckRequestStatusCodeSet',
        id: 2325,
        description: 'Indicates the status of the risk limit check request.',
    },
    {
        name: 'RiskLimitCheckRequestResult',
        abbrName: 'ReqRslt',
        addedEP: '171',
        added: 'FIX.5.0SP2',
        type: 'RiskLimitCheckRequestResultCodeSet',
        id: 2326,
        description: 'Result of the credit limit check request.',
    },
    {
        name: 'RiskLimitApprovedAmount',
        abbrName: 'LmtAprvdAmt',
        addedEP: '171',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 2327,
        description: 'The credit/risk limit amount approved.',
    },
    {
        name: 'PartyActionRequestID',
        abbrName: 'ActnReqID',
        addedEP: '171',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2328,
        description: 'The unique identifier of the PartyActionRequest(35=DH) message.',
    },
    {
        name: 'PartyActionType',
        abbrName: 'ActnTyp',
        addedEP: '171',
        added: 'FIX.5.0SP2',
        type: 'PartyActionTypeCodeSet',
        id: 2329,
        description: 'Specifies the type of action to take or was taken for a given party.',
    },
    {
        name: 'ApplTestMessageIndicator',
        abbrName: 'ApplTstMsgInd',
        addedEP: '171',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2330,
        description:
            'Used to indicate whether the message being sent is to test the receiving application\'s availability to process the message. When set to "Y" the message is a test message. If not specified, the message is by default not a test message.',
    },
    {
        name: 'PartyActionReportID',
        abbrName: 'ActnRptID',
        addedEP: '171',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2331,
        description: 'The unique identifier of the PartyActionReport(35=DI) message as assigned by the message sender.',
    },
    {
        name: 'PartyActionResponse',
        abbrName: 'ActnRsp',
        addedEP: '171',
        added: 'FIX.5.0SP2',
        type: 'PartyActionResponseCodeSet',
        id: 2332,
        description:
            'Specifies the action taken as a result of the PartyActionType(2239) of the PartyActionRequest(35=DH) message.',
    },
    {
        name: 'PartyActionRejectReason',
        abbrName: 'RejRsn',
        addedEP: '171',
        added: 'FIX.5.0SP2',
        type: 'PartyActionRejectReasonCodeSet',
        id: 2333,
        description: 'Specifies the reason the PartyActionRequest(35=DH) was rejected.',
    },
    {
        name: 'RefRiskLimitCheckID',
        abbrName: 'RefRiskLmtChkID',
        updated: 'FIX.5.0SP2',
        addedEP: '171',
        added: 'FIX.5.0SP2',
        type: 'String',
        updatedEP: '180',
        id: 2334,
        description:
            'The reference identifier of the PartyRiskLimitCheckRequest(35=DF) message, or a similar out of band message, that contained the approval for the risk/credit limit check request.',
    },
    {
        name: 'RefRiskLimitCheckIDType',
        abbrName: 'RefRiskLmtChkIDTyp',
        addedEP: '171',
        added: 'FIX.5.0SP2',
        type: 'RefRiskLimitCheckIDTypeCodeSet',
        id: 2335,
        description: 'Specifies which type of identifier is specified in RefRiskLimitCheckID(2334) field.',
    },
    {
        name: 'RiskLimitVelocityPeriod',
        abbrName: 'Velcty',
        addedEP: '171',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2336,
        description:
            'The time interval for which the clip size limit applies. The velocity time unit is expressed in RiskLimitVelocityUnit(2337).',
    },
    {
        name: 'RiskLimitVelocityUnit',
        abbrName: 'VelctyUnit',
        addedEP: '171',
        added: 'FIX.5.0SP2',
        type: 'TimeUnitCodeSet',
        id: 2337,
        description: 'Unit of time in which RiskLimitVelocityPeriod(2336) is expressed.',
    },
    {
        name: 'RequestingPartyRoleQualifier',
        abbrName: 'Qual',
        addedEP: '171',
        added: 'FIX.5.0SP2',
        type: 'PartyDetailRoleQualifierCodeSet',
        id: 2338,
        description: 'Qualifies the value of RequestingPartyRole(1660).',
    },
    {
        name: 'RiskLimitCheckModelType',
        abbrName: 'ChkModelTyp',
        addedEP: '171',
        added: 'FIX.5.0SP2',
        type: 'RiskLimitCheckModelTypeCodeSet',
        id: 2339,
        description: 'Specifies the type of credit limit check model workflow to apply for the specified party',
    },
    {
        name: 'RiskLimitCheckStatus',
        abbrName: 'RiskLmtChkStat',
        addedEP: '172',
        added: 'FIX.5.0SP2',
        type: 'RiskLimitCheckStatusCodeSet',
        id: 2343,
        description: 'Indicates the status of the risk limit check performed on a trade.',
    },
    {
        name: 'SideRiskLimitCheckStatus',
        abbrName: 'RiskLmtChkStat',
        addedEP: '172',
        added: 'FIX.5.0SP2',
        type: 'RiskLimitCheckStatusCodeSet',
        id: 2344,
        description: 'Indicates the status of the risk limit check performed on the side of a trade.',
    },
    {
        name: 'NoEntitlementTypes',
        addedEP: '173',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2345,
        description: 'Number of entitlement types in the repeating group.',
    },
    {
        name: 'LegMidPx',
        abbrName: 'MidPx',
        addedEP: '175',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 2346,
        description:
            'Leg Mid price/rate.\n\nFor OTC swaps, this is the mid-market mark (for example, as defined by CFTC).\n\nFor uncleared OTC swaps, LegMidPx(2346) and the MidPx(631) fields are mutually exclusive.',
    },
    {
        name: 'RegulatoryTransactionType',
        abbrName: 'RegTxnTyp',
        addedEP: '176',
        added: 'FIX.5.0SP2',
        type: 'RegulatoryTransactionTypeCodeSet',
        id: 2347,
        description: 'Specifies the regulatory mandate or rule that the transaction complies with.',
    },
    {
        name: 'BatchID',
        abbrName: 'ID',
        addedEP: '178',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 50000,
        description: 'Unique Identifier for a batch of messages.',
    },
    {
        name: 'BatchTotalMessages',
        abbrName: 'TotMsg',
        addedEP: '178',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 50001,
        description: 'Total # of messages contained within batch.',
    },
    {
        name: 'BatchProcessMode',
        abbrName: 'ProcMode',
        addedEP: '178',
        added: 'FIX.5.0SP2',
        type: 'BatchProcessModeCodeSet',
        id: 50002,
        description: 'Indicates the processing mode for a batch of messages.',
    },
    {
        name: 'CollateralPortfolioID',
        abbrName: 'PrtflioID',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2350,
        description: 'Identifier of the collateral portfolio when reporting on a portfolio basis.',
    },
    {
        name: 'DeliveryStreamDeliveryPointSource',
        abbrName: 'DlvryPntSrc',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'DeliveryStreamDeliveryPointSourceCodeSet',
        id: 42192,
        description: 'Identifies the class or source of DeliveryStreamDeliveryPoint(41062).',
    },
    {
        name: 'DeliveryStreamDeliveryPointDesc',
        abbrName: 'DlvryPntDesc',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42193,
        description: 'Description of the delivery point identified in DeliveryStreamDeliveryPoint(41062).',
    },
    {
        name: 'TradingUnitPeriodMultiplier',
        abbrName: 'TrdgUnitPeriodMult',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2353,
        description:
            'Indicates the number of contract periods associated with the minimum trading unit for a given contract duration resulting in the number of total traded contracts.\n\nAs an example, 456 is the number of off-peak periods for a product with a minimum trading unit of 5 MWh resulting in 2280 total traded contracts.',
    },
    {
        name: 'LegTradingUnitPeriodMultiplier',
        abbrName: 'TrdgUnitPeriodMult',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2354,
        description:
            'Indicates the number of contract periods associated with the minimum trading unit for a given contract duration resulting in the number of total traded contracts.\n\nAs an example, 456 is the number of off-peak periods for a product with a minimum trading unit of 5 MWh resulting in 2280 total traded contracts.',
    },
    {
        name: 'LegDeliveryStreamDeliveryPointDesc',
        abbrName: 'DlvryPntDesc',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42195,
        description: 'Description of the delivery point identified in LegDeliveryStreamDeliveryPoint(41433).',
    },
    {
        name: 'LegDeliveryStreamDeliveryPointSource',
        abbrName: 'DlvryPntSrc',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'DeliveryStreamDeliveryPointSourceCodeSet',
        id: 42194,
        description: 'Identifies the class or source of LegDeliveryStreamDeliveryPoint(41433).',
    },
    {
        name: 'LegTotalTradeQty',
        abbrName: 'TotTrdQty',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 2357,
        description:
            'Expresses the total quantity traded over the life of the contract when LegLastQty(1418) is to be repeated periodically over the term of the contract. The value is the product of LegLastQty(1418) and LegTradingUnitPeriodMultiplier(2353).',
    },
    {
        name: 'LegLastMultipliedQty',
        abbrName: 'LastMultdQty',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 2358,
        description:
            'Expresses the quantity bought/sold when LastQty is expressed in contracts. Used in addition to LegLastQty(1418), it is the product of LegLastQty(1418) and LegContractMultiplier(614).',
    },
    {
        name: 'LegTotalGrossTradeAmt',
        abbrName: 'TotGrossTrdAmt',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 2359,
        description:
            'Expresses the full total monetary value of the traded contract. The value is the product of LegLastPx(637) and LegTotalTradeQty(2357) or LegTotalTradeMultipliedQty(2360), if priced in units instead of contracts.',
    },
    {
        name: 'LegTotalTradeMultipliedQty',
        abbrName: 'TotTrdMultdQty',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 2360,
        description:
            'Expresses the total trade quantity in units where LegContractMultiplier(614) is not 1. The value is the product of LegTotalTradeQty(2357) and LegContractMultiplier(614).',
    },
    {
        name: 'UnderlyingDeliveryStreamDeliveryPointDesc',
        abbrName: 'DlvryPntDesc',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42197,
        description: 'Description of the delivery point identified in UnderlyingDeliveryStreamDeliveryPoint(41781).',
    },
    {
        name: 'UnderlyingDeliveryStreamDeliveryPointSource',
        abbrName: 'DlvryPntSrc',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'DeliveryStreamDeliveryPointSourceCodeSet',
        id: 42196,
        description: 'Identifies the class or source of UnderlyingDeliveryStreamDeliveryPoint(41781).',
    },
    {
        name: 'UnderlyingTradingUnitPeriodMultiplier',
        abbrName: 'TrdgUnitPeriodMult',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2363,
        description:
            'Indicates the number of contract periods associated with the minimum trading unit for a given contract duration resulting in the number of total traded contracts.\n\nAs an example, 456 is the number of off-peak periods for a product with a minimum trading unit of 5 MWh resulting in 2280 total traded contracts.',
    },
    {
        name: 'PosReportAction',
        abbrName: 'Actn',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'PosMaintActionCodeSet',
        id: 2364,
        description: 'Indicates action that triggered the Position Report.',
    },
    {
        name: 'SettlForwardPoints',
        abbrName: 'SettlFwdPnts',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 2365,
        description:
            'FX forward points added to SettlPrice(730). The value is expressed in decimal form and may be a negative.\n\nAs an example, 61.99 points is expressed as 0.006199.',
    },
    {
        name: 'SettlPriceFxRateCalc',
        abbrName: 'SettlPxFxRtCalc',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'SettlCurrFxRateCalcCodeSet',
        id: 2366,
        description:
            'Specifies whether LastPx(31) [TradeCaptureReport] or SettlPrice(730) [PositionReport] should be multiplied or divided.',
    },
    {
        name: 'TotalTradeQty',
        abbrName: 'TotTrdQty',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 2367,
        description:
            'Expresses the total quantity traded over the life of the contract when LastQty(32) is repeated periodically over the term of the contract. The value is the product of LastQty(32) and TradingUnitPeriodMultiplier(2353).',
    },
    {
        name: 'LastMultipliedQty',
        abbrName: 'LastMultdQty',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 2368,
        description:
            'Expresses the quantity bought or sold when LastQty(32) is expressed in number of contracts. Used in addition to LastQty(32). It is the product of LastQty(32) and ContractMultiplier(231).',
    },
    {
        name: 'TotalGrossTradeAmt',
        abbrName: 'TotGrossTrdAmt',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 2369,
        description:
            'Expresses the full total monetary value of the traded contract. The value is the product of LastPx(31) and TotalTradeQty(2367) or TotalTradeMultipliedQty(2370), if priced in units instead of contracts.',
    },
    {
        name: 'TotalTradeMultipliedQty',
        abbrName: 'TotTrdMultdQty',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 2370,
        description:
            'Expresses the total trade quantity in units where ContractMultiplier(231) is not 1. The value is the product of TotalTradeQty(2367) and ContractMultiplier(231).',
    },
    {
        name: 'EncodedTradeContinuationText',
        abbrName: 'EncTrdContntnText',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 2371,
        lengthId: '2372',
        description:
            'Encoded (non-ASCII characters) representation of the TradeContinuationText(2374) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) representation should also be specified in the TradeContinuationText(2374) field.',
    },
    {
        name: 'EncodedTradeContinuationTextLen',
        abbrName: 'EncTrdContntnTextLen',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 2372,
        description: 'Byte length of encoded (non-ASCII characters) EncodedTradeContinuationText(2371) field.',
    },
    {
        name: 'IntraFirmTradeIndicator',
        abbrName: 'IntraFirmTrdInd',
        updated: 'FIX.5.0SP2',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        updatedEP: '193',
        id: 2373,
        description:
            'Indicates whether the trade or position was entered into as an intra-group transaction, i.e. between two units of the same parent entity having majority ownership interest in both counterparties.\n\nIn the context of EMIR this refers to Regulation (EU) 648/2012 Article 3 "intragroup transactions" section 1 which states: "In relation to a non-financial counterparty, an intragroup transaction is an OTC derivative contract entered into with another counterparty which is part of the same group provided that both counterparties are included in the same consolidation on a full basis and they are subject to an appropriate centralised risk evaluation, measurement and control procedures and that counterparty is established in the Union or, if it is established in a third country, the Commission has adopted an implementing act under Article 13(2) in respect of that third country. Canada\'s similar requirement is under Appendix A to OSC Rule 91-507."',
    },
    {
        name: 'TradeContinuationText',
        abbrName: 'TrdContntnTxt',
        updated: 'FIX.5.0SP2',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'String',
        updatedEP: '258',
        id: 2374,
        description: 'Free form text to specify additional trade continuation information or data.',
    },
    {
        name: 'TaxonomyType',
        abbrName: 'TxnmyTyp',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'TaxonomyTypeCodeSet',
        id: 2375,
        description: 'The type of identification taxonomy used to identify the security.',
    },
    {
        name: 'PartyRoleQualifier',
        abbrName: 'Qual',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'PartyDetailRoleQualifierCodeSet',
        id: 2376,
        description: 'Used to further qualify the value of PartyRole(452).',
    },
    {
        name: 'DerivativeInstrumentPartyRoleQualifier',
        abbrName: 'Qual',
        updated: 'FIX.Latest',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'PartyDetailRoleQualifierCodeSet',
        updatedEP: '271',
        id: 2377,
        description: 'Used to further qualify the value of DerivativeInstrumentPartyRole(1295).',
    },
    {
        name: 'InstrumentPartyRoleQualifier',
        abbrName: 'Qual',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'PartyDetailRoleQualifierCodeSet',
        id: 2378,
        description: 'Used to further qualify the value of InstrumentPartyRole(1051).',
    },
    {
        name: 'LegInstrumentPartyRoleQualifier',
        abbrName: 'Qual',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'PartyDetailRoleQualifierCodeSet',
        id: 2379,
        description: 'Used to further qualify the value of LegInstrumentPartyRole(2257).',
    },
    {
        name: 'LegProvisionPartyRoleQualifier',
        abbrName: 'Qual',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'PartyDetailRoleQualifierCodeSet',
        id: 2380,
        description: 'Used to further qualify the value of LegProvisionPartyRole(40536).',
    },
    {
        name: 'Nested2PartyRoleQualifier',
        abbrName: 'Qual',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'PartyDetailRoleQualifierCodeSet',
        id: 2381,
        description: 'Used to further qualify the value of Nested2PartyRole(759).',
    },
    {
        name: 'Nested3PartyRoleQualifier',
        abbrName: 'Qual',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'PartyDetailRoleQualifierCodeSet',
        id: 2382,
        description: 'Used to further qualify the value of Nested3PartyRole(951).',
    },
    {
        name: 'Nested4PartyRoleQualifier',
        abbrName: 'Qual',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'PartyDetailRoleQualifierCodeSet',
        id: 2383,
        description: 'Used to further qualify the value of Nested4PartyRole(1417).',
    },
    {
        name: 'NestedPartyRoleQualifier',
        abbrName: 'Qual',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'PartyDetailRoleQualifierCodeSet',
        id: 2384,
        description: 'Used to further qualify the value of NestedPartyRole(538).',
    },
    {
        name: 'ProvisionPartyRoleQualifier',
        abbrName: 'Qual',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'PartyDetailRoleQualifierCodeSet',
        id: 2385,
        description: 'Used to further qualify the value of ProvisionPartyRole(40177).',
    },
    {
        name: 'RequestedPartyRoleQualifier',
        abbrName: 'Qual',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'PartyDetailRoleQualifierCodeSet',
        id: 2386,
        description: 'Used to further qualify the value of RequestedPartyRole(1509).',
    },
    {
        name: 'RootPartyRoleQualifier',
        abbrName: 'Qual',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'PartyDetailRoleQualifierCodeSet',
        id: 2388,
        description: 'Used to further qualify the value of RootPartyRole(1119).',
    },
    {
        name: 'SettlPartyRoleQualifier',
        abbrName: 'Qual',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'PartyDetailRoleQualifierCodeSet',
        id: 2389,
        description: 'Used to further qualify the value of SettlPartyRole(784).',
    },
    {
        name: 'UnderlyingInstrumentPartyRoleQualifier',
        abbrName: 'Qual',
        addedEP: '179',
        added: 'FIX.5.0SP2',
        type: 'PartyDetailRoleQualifierCodeSet',
        id: 2391,
        description: 'Used to further qualify the value of UnderlyingInstrumentPartyRole(1061).',
    },
    {
        name: 'AllocRefRiskLimitCheckID',
        abbrName: 'RefRiskLmtChkID',
        addedEP: '180',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2392,
        description:
            'The reference identifier to the PartyRiskLimitCheckRequest(35=DF), or a similar out of band message, message that contained the approval or rejection for risk/credit limit check for this allocation.',
    },
    {
        name: 'AllocRefRiskLimitCheckIDType',
        abbrName: 'RefRiskLmtChkIDTyp',
        addedEP: '180',
        added: 'FIX.5.0SP2',
        type: 'RefRiskLimitCheckIDTypeCodeSet',
        id: 2393,
        description: 'Specifies which type of identifier is specified in AllocRefRiskLimitCheckID(2392) field.',
    },
    {
        name: 'LimitUtilizationAmt',
        abbrName: 'LmtUtilztnAmt',
        addedEP: '180',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 2394,
        description:
            'The total amount of the limit that has been drawn down against the counterparty. This includes the amount for prior trades. It may or may not include the amount for the given trade, specified in LastLimitAmt(1632), depending upon whether the given trade is considered pending.',
    },
    {
        name: 'LimitAmt',
        abbrName: 'LmtAmt',
        addedEP: '180',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 2395,
        description:
            'The limit for the counterparty. This represents the total limit amount, independent of any amount already utilized.',
    },
    {
        name: 'LimitRole',
        abbrName: 'LmtR',
        addedEP: '180',
        added: 'FIX.5.0SP2',
        type: 'PartyRoleCodeSet',
        id: 2396,
        description:
            'Indicates the scope of the limit by role.\n\nUsed to indicate whether this is a customer account limit, a clearing firm limit, etc.',
    },
    {
        name: 'RegulatoryTradeIDScope',
        abbrName: 'Scope',
        addedEP: '181',
        added: 'FIX.5.0SP2',
        type: 'RegulatoryTradeIDScopeCodeSet',
        id: 2397,
        description:
            'Specifies the scope to which the RegulatoryTradeID(1903) applies. Used when a trade must be assigned more than one identifier, e.g. one for the clearing member and another for the client on a cleared trade as with the principal model in Europe.',
    },
    {
        name: 'SideRegulatoryTradeIDScope',
        abbrName: 'Scope',
        addedEP: '181',
        added: 'FIX.5.0SP2',
        type: 'RegulatoryTradeIDScopeCodeSet',
        id: 2398,
        description:
            'Specifies the scope to which the SideRegulatoryTradeID(1972) applies. Used when a trade must be assigned more than one identifier, e.g. one for the clearing member and another for the client on a cleared trade as with the principal model in Europe.',
    },
    {
        name: 'AllocRegulatoryTradeIDScope',
        abbrName: 'Scope',
        addedEP: '181',
        added: 'FIX.5.0SP2',
        type: 'RegulatoryTradeIDScopeCodeSet',
        id: 2399,
        description:
            'Specifies the scope to which the AllocRegulatoryTradeID(1909) applies. Used when a trade must be assigned more than one identifier, e.g. one for the clearing member and another for the client on a cleared trade as with the principal model in Europe.',
    },
    {
        name: 'AllocRegulatoryLegRefID',
        abbrName: 'LegRefID',
        addedEP: '181',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2406,
        description: "Identifies the leg of the trade the entry applies to by referencing the leg's LegID(1788).",
    },
    {
        name: 'RegulatoryLegRefID',
        abbrName: 'LegRefID',
        addedEP: '181',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2411,
        description: "Identifies the leg of the trade the entry applies to by referencing the leg's LegID(1788).",
    },
    {
        name: 'SideRegulatoryLegRefID',
        abbrName: 'LegRefID',
        addedEP: '181',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2416,
        description: "Identifies the leg of the trade the entry applies to by referencing the leg's LegID(1788).",
    },
    {
        name: 'EffectiveBusinessDate',
        abbrName: 'EfctvBizDt',
        updated: 'FIX.5.0SP2',
        addedEP: '182',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        updatedEP: '195',
        id: 2400,
        description:
            'Specifies an explicit business date for associated reference data or transaction. Used when an implicit date is not sufficiently specific.',
    },
    {
        name: 'ListManualOrderIndicator',
        abbrName: 'ListManOrdInd',
        addedEP: '182',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2401,
        description:
            'Indicates if the list of orders was initially received manually (as opposed to electronically) or if it was entered manually (as opposed to entered by automated trading software).',
    },
    {
        name: 'EntitlementSubType',
        abbrName: 'SubTyp',
        unionDataType: 'Reserved1000Plus',
        addedEP: '183',
        added: 'FIX.5.0SP2',
        type: 'EntitlementSubTypeCodeSet',
        id: 2402,
        description: 'Subtype of an entitlement specified in EntitlementType(1775).',
    },
    {
        name: 'QuoteModelType',
        abbrName: 'QModelTyp',
        addedEP: '184',
        added: 'FIX.5.0SP2',
        type: 'QuoteModelTypeCodeSet',
        id: 2403,
        description: 'Quote model type',
    },
    {
        name: 'ComplianceText',
        abbrName: 'ComplianceTxt',
        addedEP: '185',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2404,
        description: 'Free text for compliance information required for regulatory reporting.',
    },
    {
        name: 'EncodedComplianceTextLen',
        abbrName: 'EncComplianceTxtLen',
        addedEP: '185',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 2351,
        description: 'Byte length of encoded (non-ASCII characters) EncodedComplianceText(2352) field.',
    },
    {
        name: 'EncodedComplianceText',
        abbrName: 'EncComplianceTxt',
        addedEP: '185',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 2352,
        lengthId: '2351',
        description:
            'Encoded (non-ASCII characters) representation of the ComplianceText(2404) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the ComplianceText(2404) field.',
    },
    {
        name: 'ExecMethod',
        abbrName: 'ExecMeth',
        updated: 'FIX.5.0SP2',
        addedEP: '186',
        added: 'FIX.5.0SP2',
        type: 'ExecMethodCodeSet',
        updatedEP: '201',
        id: 2405,
        description:
            'Specifies how the transaction was executed, e.g. via an automated execution platform or other method.',
    },
    {
        name: 'PricePrecision',
        abbrName: 'PxPrcsn',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2349,
        description:
            'Specifies the price decimal precision of the instrument.\n\nFor FX, this specifies the pip size in which forward points are calculated. Point (pip) size varies by currency pair. Major currencies are all traded in points of 0.0001, with the exception of JPY which has a point size of 0.01.',
    },
    {
        name: 'TradeContingency',
        abbrName: 'Cntgncy',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'TradeContingencyCodeSet',
        id: 2387,
        description:
            'Indicates the contingency attribute for a trade in an asset class that may be contingent on the clearing of a corresponding paired trade (for example Exchange for Physical (EFP), Exchange for Swap (EFS), Exchange for Related (EFR) or Exchange for Option (EFO), collectively called EFRPs). Once the paired trade clears or fails to clear, the related trade (the trade which carries this attribute) ceases to exist.',
    },
    {
        name: 'ComplexEventSpotRate',
        abbrName: 'SpotRt',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 2407,
        description: 'FX spot rate.',
    },
    {
        name: 'ComplexEventForwardPoints',
        abbrName: 'FwdPnts',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 2408,
        description: 'FX forward points added to spot rate. May be a negative value.',
    },
    {
        name: 'LegComplexEventSpotRate',
        abbrName: 'SpotRt',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 2409,
        description: 'FX spot rate.',
    },
    {
        name: 'LegComplexEventForwardPoints',
        abbrName: 'FwdPnts',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 2410,
        description: 'FX forward points added to spot rate. May be a negative value.',
    },
    {
        name: 'RateSourceReferencePageHeading',
        abbrName: 'RefHdng',
        updated: 'FIX.Latest',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        updatedEP: '293',
        id: 2412,
        description: 'Identifies the page heading from the rate source.',
    },
    {
        name: 'RelatedToSecurityID',
        abbrName: 'ReltdID',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2413,
        discriminatorId: '2414',
        description:
            'The security identifier of the instrument, instrument leg or underlying instrument with which the related instrument has correlation.',
    },
    {
        name: 'RelatedToSecurityIDSource',
        abbrName: 'ReltdIDSrc',
        unionDataType: 'Reserved100Plus',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'SecurityIDSourceCodeSet',
        id: 2414,
        description: 'Identifies class or source of the RelatedToSecurityID(2413) value.',
    },
    {
        name: 'RelatedToStreamXIDRef',
        abbrName: 'ReltdStrmXIDRef',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'XIDREF',
        id: 2415,
        description:
            'StreamXID(41303), LegStreamXID(41700) or UnderlyingStreamXID(42016) of the stream with which the related instrument has correlation.',
    },
    {
        name: 'FirmTradeEventID',
        abbrName: 'FirmTrdEvntID',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2418,
        description: 'An identifier created by the trading party for the life cycle event associated with this report.',
    },
    {
        name: 'UnderlyingComplexEventSpotRate',
        abbrName: 'SpotRt',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 2419,
        description: 'FX spot rate.',
    },
    {
        name: 'UnderlyingComplexEventForwardPoints',
        abbrName: 'FwdPnts',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 2420,
        description: 'FX forward points added to spot rate. May be a negative value.',
    },
    {
        name: 'LegMarketDisruptionValue',
        abbrName: 'Val',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40223,
        description: 'Applicable value for LegMarketDisruptionEvent(41468).',
    },
    {
        name: 'LegMarketDisruptionFallbackValue',
        abbrName: 'Val',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40990,
        description: 'Applicable value for LegMarketDisruptionFallbackType(41470).',
    },
    {
        name: 'MarketDisruptionValue',
        abbrName: 'Val',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40991,
        description: 'Applicable value for MarketDisruptionEvent(41093).',
    },
    {
        name: 'MarketDisruptionFallbackValue',
        abbrName: 'Val',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 40992,
        description: 'Applicable value for MarketDisruptionFallbackType(41095).',
    },
    {
        name: 'PaymentSubType',
        abbrName: 'SubTyp',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'PaymentSubTypeCodeSet',
        id: 40993,
        description: 'Used to further clarify the value of PaymentType(40213).',
    },
    {
        name: 'PaymentLegRefID',
        abbrName: 'LegRefID',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41304,
        description:
            "Identifies the instrument leg in which this payment applies to by referencing the leg's LegID(1788).",
    },
    {
        name: 'UnderlyingMarketDisruptionValue',
        abbrName: 'Val',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41338,
        description: 'Applicable value for UnderlyingMarketDisruptionEvent(41865).',
    },
    {
        name: 'UnderlyingMarketDisruptionFallbackValue',
        abbrName: 'Val',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41339,
        description: 'Applicable value for UnderlyingMarketDisruptionFallbackType(41867).',
    },
    {
        name: 'NoUnderlyingAdditionalTermBondRefs',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 41340,
        description: 'Number of bonds in the repeating group.',
    },
    {
        name: 'UnderlyingAdditionalTermBondSecurityID',
        abbrName: 'ID',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41341,
        discriminatorId: '41701',
        description: 'Security identifier of the bond.',
    },
    {
        name: 'UnderlyingAdditionalTermBondSecurityIDSource',
        abbrName: 'Src',
        unionDataType: 'Reserved100Plus',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'SecurityIDSourceCodeSet',
        id: 41701,
        description: 'Identifies the source scheme of the UnderlyingAdditionalTermBondSecurityID(41341) value.',
    },
    {
        name: 'UnderlyingAdditionalTermBondDesc',
        abbrName: 'Desc',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 41709,
        description: 'Description of the bond.',
    },
    {
        name: 'EncodedUnderlyingAdditionalTermBondDescLen',
        abbrName: 'EncDescLen',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 41710,
        description:
            'Byte length of encoded (non-ASCII characters) EncodedUnderlyingAdditionalTermBondDesc(41711) field.',
    },
    {
        name: 'EncodedUnderlyingAdditionalTermBondDesc',
        abbrName: 'EncDesc',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 41711,
        lengthId: '41710',
        description:
            'Encoded (non-ASCII characters) representation of the UnderlyingAdditionalTermBondDesc(41709) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the UnderlyingAdditionalTermBondDesc(41709) field.',
    },
    {
        name: 'UnderlyingAdditionalTermBondCurrency',
        abbrName: 'Ccy',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 41712,
        description: 'Specifies the currency the bond value is denominated in. Uses ISO 4217 currency codes.',
    },
    {
        name: 'UnderlyingAdditionalTermBondIssuer',
        abbrName: 'Issr',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42017,
        description: 'Issuer of the bond.',
    },
    {
        name: 'EncodedUnderlyingAdditionalTermBondIssuerLen',
        abbrName: 'EncIssrLen',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 42025,
        description:
            'Byte length of encoded (non-ASCII characters) EncodedUnderlyingAdditionalTermBondIssuer(42026) field.',
    },
    {
        name: 'EncodedUnderlyingAdditionalTermBondIssuer',
        abbrName: 'EncIssr',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 42026,
        lengthId: '42025',
        description:
            'Encoded (non-ASCII characters) representation of the UnderlyingAdditionalTermBondIssuer(42017) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the UnderlyingAdditionalTermBondIssuer(42017) field.',
    },
    {
        name: 'UnderlyingAdditionalTermBondSeniority',
        abbrName: 'Snrty',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'SeniorityCodeSet',
        id: 42027,
        description: "Specifies the bond's payment priority in the event of a default.",
    },
    {
        name: 'UnderlyingAdditionalTermBondCouponType',
        abbrName: 'CpnTyp',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'CouponTypeCodeSet',
        id: 42028,
        description: 'Coupon type of the bond.',
    },
    {
        name: 'UnderlyingAdditionalTermBondCouponRate',
        abbrName: 'CpnRt',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 42029,
        description: 'Coupon rate of the bond. See also CouponRate(223).',
    },
    {
        name: 'UnderlyingAdditionalTermBondMaturityDate',
        abbrName: 'MatDt',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42030,
        description: 'The maturity date of the bond.',
    },
    {
        name: 'UnderlyingAdditionalTermBondParValue',
        abbrName: 'Par',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 42031,
        description: 'The par value of the bond.',
    },
    {
        name: 'UnderlyingAdditionalTermBondCurrentTotalIssuedAmount',
        abbrName: 'CurTotAmt',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 42032,
        description: 'Total issued amount of the bond.',
    },
    {
        name: 'UnderlyingAdditionalTermBondCouponFrequencyPeriod',
        abbrName: 'CpnPeriod',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42033,
        description: "Time unit multiplier for the frequency of the bond's coupon payment.",
    },
    {
        name: 'UnderlyingAdditionalTermBondCouponFrequencyUnit',
        abbrName: 'CpnUnit',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'CouponFrequencyUnitCodeSet',
        id: 42034,
        description: "Time unit associated with the frequency of the bond's coupon payment.",
    },
    {
        name: 'UnderlyingAdditionalTermBondDayCount',
        abbrName: 'DayCnt',
        unionDataType: 'Reserved100Plus',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'CouponDayCountCodeSet',
        id: 42035,
        description:
            'The day count convention used in interest calculations for a bond or an interest bearing security.',
    },
    {
        name: 'NoUnderlyingAdditionalTerms',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42036,
        description: 'Number of additional terms in the repeating group.',
    },
    {
        name: 'UnderlyingAdditionalTermConditionPrecedentBondIndicator',
        abbrName: 'PrcdntInd',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42037,
        description:
            'Indicates whether the condition precedent bond is applicable. The swap contract is only valid if the bond is issued and if there is any dispute over the terms of fixed stream then the bond terms would be used.',
    },
    {
        name: 'UnderlyingAdditionalTermDiscrepancyClauseIndicator',
        abbrName: 'DscrpncyInd',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42038,
        description: 'Indicates whether the discrepancy clause is applicable.',
    },
    {
        name: 'NoUnderlyingCashSettlDealers',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42039,
        description: 'Number of dealers in the repeating group.',
    },
    {
        name: 'UnderlyingCashSettlDealer',
        abbrName: 'Dlr',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42040,
        description:
            'Identifies the dealer from whom price quotations for the reference obligation are obtained for the purpose of cash settlement valuation calculation.\n\nISDA 2003 Term: Dealer',
    },
    {
        name: 'NoUnderlyingCashSettlTerms',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42041,
        description: 'Number of elements in the repeating group.',
    },
    {
        name: 'UnderlyingCashSettlCurrency',
        abbrName: 'Ccy',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 42042,
        description:
            'Specifies the currency the UnderlyingCashSettlAmount(42054) is denominated in. Uses ISO 4217 currency codes.',
    },
    {
        name: 'UnderlyingCashSettlValuationFirstBusinessDayOffset',
        abbrName: 'BizDayOfst',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42043,
        description:
            'The number of business days after settlement conditions have been satisfied, when the calculation agent is to obtain a price quotation on the reference obligation for purposes of cash settlement.\n\nAssociated with ISDA 2003 Term: Valuation Date.',
    },
    {
        name: 'UnderlyingCashSettlValuationSubsequentBusinessDaysOffset',
        abbrName: 'SbsqntBizDayOfst',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42044,
        description:
            'The number of business days between successive valuation dates when multiple valuation dates are applicable for cash settlement.\n\nAssociated with ISDA 2003 Term: Valuation Date.',
    },
    {
        name: 'UnderlyingCashSettlNumOfValuationDates',
        abbrName: 'NumValDts',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42045,
        description:
            'Where multiple valuation dates are specified as being applicable for cash settlement, this element specifies the number of applicable valuation dates.\n\nAssociated with ISDA 2003 Term: Valuation Date.',
    },
    {
        name: 'UnderlyingCashSettlValuationTime',
        abbrName: 'ValTm',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 42046,
        description: 'Time of valuation.',
    },
    {
        name: 'UnderlyingCashSettlBusinessCenter',
        abbrName: 'BizCtr',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42047,
        description:
            'Identifies the business center calendar used at valuation time for cash settlement purposes e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'UnderlyingCashSettlQuoteMethod',
        abbrName: 'QteMeth',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'CashSettlQuoteMethodCodeSet',
        id: 42048,
        description: 'The type of quote used to determine the cash settlement price.',
    },
    {
        name: 'UnderlyingCashSettlQuoteAmount',
        abbrName: 'QteAmt',
        updated: 'FIX.Latest',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        updatedEP: '271',
        id: 42049,
        description:
            'When determining the cash settlement amount, if weighted average price quotes are to be obtained for the reference obligation, this is the upper limit to the outstanding principal balance of the reference obligation for which the quote should be obtained. If not specified, the ISDA definitions provide for a fallback amount equal to floating rate payer calculation amount.\n\nISDA 2003 Term: Quotation Amount.',
    },
    {
        name: 'UnderlyingCashSettlQuoteCurrency',
        abbrName: 'QteCcy',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 42050,
        description:
            'Specifies the currency the UnderlyingCashSettlQuoteAmount(42049) is denominated in. Uses ISO 4217 currency codes.',
    },
    {
        name: 'UnderlyingCashSettlMinimumQuoteAmount',
        abbrName: 'MinQteAmt',
        updated: 'FIX.Latest',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        updatedEP: '271',
        id: 42051,
        description:
            'When determining the cash settlement amount, if weighted average price quotes are to be obtained for the reference obligation, this is the minimum intended threshold amount of outstanding principal balance of the reference obligation for which the quote should be obtained. If not specified, the ISDA definitions provide for a fallback amount of the lower of either USD1,000,000 (or its equivalent in the relevant obligation currency) or the (minimum) quoted amount.\n\nISDA 2003 Term: Minimum Quotation Amount.',
    },
    {
        name: 'UnderlyingCashSettlMinimumQuoteCurrency',
        abbrName: 'MinQteCcy',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 42052,
        description:
            'Specifies the currency the UnderlyingCashSettlQuoteAmount(42049) is denominated in. Uses ISO 4217 currency codes.',
    },
    {
        name: 'UnderlyingCashSettlBusinessDays',
        abbrName: 'BizDays',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42053,
        description:
            'The number of business days used in the determination of the cash settlement payment date.\n\nIf a cash settlement amount is specified, the cash settlement payment date will be this number of business days following the calculation of the final price. If a cash settlement amount is not specified, the cash settlement payment date will be this number of business days after all conditions to settlement are satisfied.\n\nISDA 2003 Term: Cash Settlement Date.',
    },
    {
        name: 'UnderlyingCashSettlAmount',
        abbrName: 'Amt',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 42054,
        description:
            'The amount paid between the trade parties, seller to the buyer, for cash settlement on the cash settlement date.\n\nIf not specified this would typically be calculated as ((100 or the reference price) - reference obligation price) x floating rate payer calculation amount. Price values are all expressed as a percentage.\n\nISDA 2003 Term: Cash Settlement Amount.',
    },
    {
        name: 'UnderlyingCashSettlRecoveryFactor',
        abbrName: 'RcvryFctr',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 42055,
        description:
            'Used for fixed recovery, this specifies the recovery level as determined at contract inception, to be applied in the event of a default. The factor is used to calculate the amount paid by the seller to the buyer for cash settlement on the cash settlement date. The amount is calculated is (1 - UnderlyingCashSettlRecoveryFactor(42055)) x floating rate payer calculation amount. The currency is derived from the floating rate payer calculation amount.',
    },
    {
        name: 'UnderlyingCashSettlFixedTermIndicator',
        abbrName: 'FixedInd',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42056,
        description: 'Indicates whether fixed settlement is applicable or not applicable in a recovery lock.',
    },
    {
        name: 'UnderlyingCashSettlAccruedInterestIndicator',
        abbrName: 'AcrdIntInd',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42057,
        description:
            'Indicates whether accrued interest is included or not in the value provided in UnderlyingCashSettlAmount(42054).\n\nFor cash settlement this specifies whether quotations should be obtained inclusive or not of accrued interest.\n\nFor physical settlement this specifies whether the buyer should deliver the obligation with an outstanding principal balance that includes or excludes accrued interest.\n\nISDA 2003 Term: Include/Exclude Accrued Interest.',
    },
    {
        name: 'UnderlyingCashSettlValuationMethod',
        abbrName: 'ValMeth',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'CashSettlValuationMethodCodeSet',
        id: 42058,
        description:
            'The ISDA defined methodology for determining the final price of the reference obligation for purposes of cash settlement.\n\nISDA 2003 Term: Valuation Method',
    },
    {
        name: 'UnderlyingCashSettlTermXID',
        abbrName: 'XID',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'XID',
        id: 42059,
        description: 'Name referenced from UnderlyingSettlementTermXIDRef(41315).',
    },
    {
        name: 'NoUnderlyingPhysicalSettlTerms',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42060,
        description: 'Number of entries in the repeating group.',
    },
    {
        name: 'UnderlyingPhysicalSettlCurrency',
        abbrName: 'Ccy',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 42061,
        description: 'Currency of physical settlement. Uses ISO 4217 currency codes.',
    },
    {
        name: 'UnderlyingPhysicalSettlBusinessDays',
        abbrName: 'BizDays',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42062,
        description:
            'A number of business days. Its precise meaning is dependent on the context in which this element is used.\n\nISDA 2003 Term: Business Day.',
    },
    {
        name: 'UnderlyingPhysicalSettlMaximumBusinessDays',
        abbrName: 'MaxBizDays',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42063,
        description:
            'A maximum number of business days. Its precise meaning is dependent on the context in which this element is used. Intended to be used to limit a particular ISDA fallback provision.',
    },
    {
        name: 'UnderlyingPhysicalSettlTermXID',
        abbrName: 'XID',
        updated: 'FIX.Latest',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'XID',
        updatedEP: '271',
        id: 42064,
        description: 'A named string value referenced by UnderlyingSettlTermXIDRef(41315).',
    },
    {
        name: 'NoUnderlyingPhysicalSettlDeliverableObligations',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42065,
        description: 'Number of entries in the repeating group.',
    },
    {
        name: 'UnderlyingPhysicalSettlDeliverableObligationType',
        abbrName: 'Typ',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42066,
        description:
            'Specifies the type of delivery obligation applicable for physical settlement.\n\nSee http://www.fixtradingcommunity.org/codelists#Deliverable_Obligation_Types for code list for applicable deliverable obligation types.',
    },
    {
        name: 'UnderlyingPhysicalSettlDeliverableObligationValue',
        abbrName: 'Val',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42067,
        description:
            'Physical settlement delivery obligation value appropriate to UnderlyingPhysicalSettlDeliverableObligationType(42066).\n\nSee http://www.fixtradingcommunity.org/codelists#Deliverable_Obligation_Types for applicable obligation type values.',
    },
    {
        name: 'NoUnderlyingProtectionTerms',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42068,
        description: 'Number of protection terms in the repeating group.',
    },
    {
        name: 'UnderlyingProtectionTermNotional',
        abbrName: 'Notl',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 42069,
        description:
            'The notional amount of protection coverage for a floating rate.\n\nISDA 2003 Term: Floating Rate Payer Calculation Amount.',
    },
    {
        name: 'UnderlyingProtectionTermCurrency',
        abbrName: 'Ccy',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 42070,
        description: 'The currency of UnderlyingProtectionTermNotional(42069). Uses ISO 4217 currency codes.',
    },
    {
        name: 'UnderlyingProtectionTermSellerNotifies',
        abbrName: 'Seller',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42071,
        description:
            'The notifying party is the party that notifies the other party when a credit event has occurred by means of a credit event notice. If more than one party is referenced as being the notifying party then either party may notify the other of a credit event occurring.\n\nUnderlyingProtectionTermSellerNotifies(42071)=Y indicates that the seller notifies.\n\nISDA 2003 Term: Notifying Party.',
    },
    {
        name: 'UnderlyingProtectionTermBuyerNotifies',
        abbrName: 'Buyer',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42072,
        description:
            'The notifying party is the party that notifies the other party when a credit event has occurred by means of a credit event notice. If more than one party is referenced as being the notifying party then either party may notify the other of a credit event occurring.\n\nUnderlyingProtectionTermBuyerNotifies(42072)=Y indicates that the buyer notifies.\n\nISDA 2003 Term: Notifying Party.',
    },
    {
        name: 'UnderlyingProtectionTermEventBusinessCenter',
        abbrName: 'BizCtr',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42073,
        description:
            'When used, the business center indicates the local time of the business center that replaces the Greenwich Mean Time in Section 3.3 of the 2003 ISDA Credit Derivatives Definitions.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'UnderlyingProtectionTermStandardSources',
        abbrName: 'StdSrcs',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42074,
        description:
            'Indicates whether ISDA defined Standard Public Sources are applicable (UnderlyingProtectionTermStandardSources(42074)=Y) or not.',
    },
    {
        name: 'UnderlyingProtectionTermEventMinimumSources',
        abbrName: 'MinSrcs',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42075,
        description:
            'The minimum number of the specified public information sources that must publish information that reasonably confirms that a credit event has occurred. The market convention is two.\n\nISDA 2003 Term: Specified Number.',
    },
    {
        name: 'UnderlyingProtectionTermXID',
        abbrName: 'XID',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'XID',
        id: 42076,
        description: 'A named string value referenced by UnderlyingProtectionTermXIDRef(41314).',
    },
    {
        name: 'NoUnderlyingProtectionTermEvents',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42077,
        description: 'Number of protection term events in the repeating group.',
    },
    {
        name: 'UnderlyingProtectionTermEventType',
        abbrName: 'Typ',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42078,
        description:
            'Specifies the type of credit event applicable to the protection terms.\n\nSee http://www.fixtradingcommunity.org/codelists#Protection_Term_Event_Types for code list of applicable event types.',
    },
    {
        name: 'UnderlyingProtectionTermEventValue',
        abbrName: 'Val',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42079,
        description:
            'Protection term event value appropriate to UnderlyingProtectionTermEventType(42078).\n\nSee http://www.fixtradingcommunity.org/codelists#Protection_Term_Event_Types for applicable event type values.',
    },
    {
        name: 'UnderlyingProtectionTermEventCurrency',
        abbrName: 'Ccy',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 42080,
        description:
            'Applicable currency if UnderlyingProtectionTermEventValue(42079) is an amount. Uses ISO 4217 currency codes.',
    },
    {
        name: 'UnderlyingProtectionTermEventPeriod',
        abbrName: 'Period',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42081,
        description: 'Time unit multiplier for protection term events.',
    },
    {
        name: 'UnderlyingProtectionTermEventUnit',
        abbrName: 'Unit',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'ProtectionTermEventUnitCodeSet',
        id: 42082,
        description: 'Time unit associated with protection term events.',
    },
    {
        name: 'UnderlyingProtectionTermEventDayType',
        abbrName: 'DayTyp',
        updated: 'FIX.Latest',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'ProtectionTermEventDayTypeCodeSet',
        updatedEP: '271',
        id: 42083,
        description: 'Day type for events that specify a period and unit.',
    },
    {
        name: 'UnderlyingProtectionTermEventRateSource',
        abbrName: 'RtSrc',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42084,
        description: 'Rate source for events that specify a rate source, e.g. Floating rate interest shortfall.',
    },
    {
        name: 'NoUnderlyingProtectionTermEventQualifiers',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42085,
        description: 'Number of qualifiers in the repeating group.',
    },
    {
        name: 'UnderlyingProtectionTermEventQualifier',
        abbrName: 'Qual',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'ProtectionTermEventQualifierCodeSet',
        id: 42086,
        description:
            'Protection term event qualifier. Used to further qualify UnderlyingProtectionTermEventType(43078).',
    },
    {
        name: 'NoUnderlyingProtectionTermObligations',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42087,
        description: 'Number of obligations in the repeating group.',
    },
    {
        name: 'UnderlyingProtectionTermObligationType',
        abbrName: 'Typ',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42088,
        description:
            'Specifies the type of obligation applicable to the protection terms.\n\nSee http://www.fixtradingcommunity.org/codelists#Protection_Term_Obligation_Types for code list of applicable obligation types.',
    },
    {
        name: 'UnderlyingProtectionTermObligationValue',
        abbrName: 'Val',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42089,
        description:
            'Protection term obligation value appropriate to UnderlyingProtectionTermObligationType(42088).\n\nSee http://www.fixtradingcommunity.org/codelists#Protection_Term_Obligation_Types for applicable obligation type values.',
    },
    {
        name: 'NoUnderlyingProtectionTermEventNewsSources',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42090,
        description: 'Number of event news sources in the repeating group.',
    },
    {
        name: 'UnderlyingProtectionTermEventNewsSource',
        abbrName: 'Src',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42091,
        description:
            'Newspaper or electronic news service or source that may publish relevant information used in the determination of whether or not a credit event has occurred.',
    },
    {
        name: 'UnderlyingProvisionCashSettlPaymentDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 42092,
        description:
            "The business day convention used to adjust the provisional cash settlement payment's termination, or relative termination, date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.",
    },
    {
        name: 'UnderlyingProvisionCashSettlPaymentDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42093,
        description:
            'Specifies the anchor date when the cash settlement payment date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'UnderlyingProvisionCashSettlPaymentDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 42094,
        description: 'Time unit multiplier for the relative cash settlement payment date offset.',
    },
    {
        name: 'UnderlyingProvisionCashSettlPaymentDateOffsetUnit',
        abbrName: 'OfstUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 42095,
        description: 'Time unit associated with the relative cash settlement payment date offset.',
    },
    {
        name: 'UnderlyingProvisionCashSettlPaymentDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 42096,
        description: "Specifies the day type of the provision's relative cash settlement payment date offset.",
    },
    {
        name: 'UnderlyingProvisionCashSettlPaymentDateRangeFirst',
        abbrName: 'DtFirst',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42097,
        description: 'First date in range when a settlement date range is provided.',
    },
    {
        name: 'UnderlyingProvisionCashSettlPaymentDateRangeLast',
        abbrName: 'DtLast',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42098,
        description: 'Last date in range when a settlement date range is provided.',
    },
    {
        name: 'NoUnderlyingProvisionCashSettlPaymentDates',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42099,
        description: 'Number of UnderlyingProvision cash settlement payment dates in the repeating group.',
    },
    {
        name: 'UnderlyingProvisionCashSettlPaymentDate',
        abbrName: 'Dt',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42100,
        description:
            'The cash settlement payment date, unadjusted or adjusted depending on UnderlyingProvisionCashSettlPaymentDateType(42101).',
    },
    {
        name: 'UnderlyingProvisionCashSettlPaymentDateType',
        abbrName: 'Typ',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'ProvisionCashSettlPaymentDateTypeCodeSet',
        id: 42101,
        description: 'Specifies the type of date (e.g. adjusted for holidays).',
    },
    {
        name: 'UnderlyingProvisionCashSettlQuoteSource',
        abbrName: 'SettlQteSrc',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexSourceCodeSet',
        id: 42102,
        description: 'Identifies the source of quote information.',
    },
    {
        name: 'UnderlyingProvisionCashSettlQuoteReferencePage',
        abbrName: 'RefPg',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42103,
        description: 'Identifies the reference "page" from the quote source.',
    },
    {
        name: 'UnderlyingProvisionCashSettlValueTime',
        abbrName: 'Tm',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 42104,
        description:
            'A time specified in 24-hour format, e.g. 11am would be represented as 11:00:00. The time of the cash settlement valuation date when the cash settlement amount will be determined according to the cash settlement method if the parties have not otherwise been able to agree to the cash settlement amount.',
    },
    {
        name: 'UnderlyingProvisionCashSettlValueTimeBusinessCenter',
        abbrName: 'TmBizCtr',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42105,
        description:
            "Identifies the business center calendar used with the provision's cash settlement valuation time.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.",
    },
    {
        name: 'UnderlyingProvisionCashSettlValueDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 42106,
        description:
            'The business day convention used to adjust the cash settlement valuation date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.',
    },
    {
        name: 'UnderlyingProvisionCashSettlValueDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42107,
        description:
            'Specifies the anchor date when the cash settlement value date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'UnderlyingProvisionCashSettlValueDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 42108,
        description: 'Time unit multiplier for the relative cash settlement value date offset.',
    },
    {
        name: 'UnderlyingProvisionCashSettlValueDateOffsetUnit',
        abbrName: 'OfstUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 42109,
        description: 'Time unit associated with the relative cash settlement value date offset.',
    },
    {
        name: 'UnderlyingProvisionCashSettlValueDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 42110,
        description: "Specifies the day type of the provision's relative cash settlement value date offset.",
    },
    {
        name: 'UnderlyingProvisionCashSettlValueDateAdjusted',
        abbrName: 'Dt',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42111,
        description: 'The adjusted cash settlement value date.',
    },
    {
        name: 'NoUnderlyingProvisionOptionExerciseFixedDates',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42112,
        description: 'Number of UnderlyingProvision option exercise fixed dates in the repeating group.',
    },
    {
        name: 'UnderlyingProvisionOptionExerciseFixedDate',
        abbrName: 'Dt',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42113,
        description:
            'A predetermined option exercise date, unadjusted or adjusted depending on UnderlyingProvisionOptionExerciseFixedDateType(42114).',
    },
    {
        name: 'UnderlyingProvisionOptionExerciseFixedDateType',
        abbrName: 'Typ',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'ProvisionOptionExerciseFixedDateTypeCodeSet',
        id: 42114,
        description: 'Specifies the type of date (e.g. adjusted for holidays).',
    },
    {
        name: 'UnderlyingProvisionOptionExerciseBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 42115,
        description:
            "The business day convention used to adjust the underlying instrument's provision's option exercise date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.",
    },
    {
        name: 'UnderlyingProvisionOptionExerciseEarliestDateOffsetPeriod',
        abbrName: 'ErlstOfstPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 42116,
        description:
            'Time unit multiplier for the interval to the first (and possibly only) exercise date in the exercise period.',
    },
    {
        name: 'UnderlyingProvisionOptionExerciseEarliestDateOffsetUnit',
        abbrName: 'ErlstOfstUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'ProvisionOptionExerciseEarliestDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 42117,
        description:
            'Time unit associated with the interval to the first (and possibly only) exercise date in the exercise period.',
    },
    {
        name: 'UnderlyingProvisionOptionExerciseFrequencyPeriod',
        abbrName: 'FreqPeriod',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42118,
        description:
            'Time unit multiplier for the frequency of subsequent exercise dates in the exercise period following the earliest exercise date. An interval of 1 day should be used to indicate an American style exercise frequency.',
    },
    {
        name: 'UnderlyingProvisionOptionExerciseFrequencyUnit',
        abbrName: 'FreqUnit',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'CouponFrequencyUnitCodeSet',
        id: 42119,
        description:
            'Time unit associated with the frequency of subsequent exercise dates in the exercise period following the earliest exercise date.',
    },
    {
        name: 'UnderlyingProvisionOptionExerciseStartDateUnadjusted',
        abbrName: 'StartDtUnadj',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42120,
        description: 'The unadjusted first day of the exercise period for an American style option.',
    },
    {
        name: 'UnderlyingProvisionOptionExerciseStartDateRelativeTo',
        abbrName: 'StartDtReltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42121,
        description:
            'Specifies the anchor date when the option exercise start date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'UnderlyingProvisionOptionExerciseStartDateOffsetPeriod',
        abbrName: 'StartDtOfstPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 42122,
        description: 'Time unit multiplier for the relative option exercise start date offset.',
    },
    {
        name: 'UnderlyingProvisionOptionExerciseStartDateOffsetUnit',
        abbrName: 'StartDtOfstUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 42123,
        description: 'Time unit associated with the relative option exercise start date offset.',
    },
    {
        name: 'UnderlyingProvisionOptionExerciseStartDateOffsetDayType',
        abbrName: 'StartDtOfstDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 42124,
        description: "Specifies the day type of the provision's relative option exercise start date offset.",
    },
    {
        name: 'UnderlyingProvisionOptionExerciseStartDateAdjusted',
        abbrName: 'StartDt',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42125,
        description: 'The adjusted first day of the exercise period for an American style option.',
    },
    {
        name: 'UnderlyingProvisionOptionExercisePeriodSkip',
        abbrName: 'Skip',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42126,
        description:
            'The number of periods in the referenced date schedule that are between each date in the relative date schedule. Thus a skip of 2 would mean that dates are relative to every second date in the referenced schedule. If present this should have a value greater than 1.',
    },
    {
        name: 'UnderlyingProvisionOptionExerciseBoundsFirstDateUnadjusted',
        abbrName: 'FirstDtUnadj',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42127,
        description:
            'The unadjusted first date of a schedule. This can be used to restrict the range of exercise dates when they are relative.',
    },
    {
        name: 'UnderlyingProvisionOptionExerciseBoundsLastDateUnadjusted',
        abbrName: 'LastDtUnadj',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42128,
        description:
            'The unadjusted last date of a schedule. This can be used to restrict the range of exercise dates when they are relative.',
    },
    {
        name: 'UnderlyingProvisionOptionExerciseEarliestTime',
        abbrName: 'ErlstTm',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 42129,
        description:
            "The earliest time at which notice of exercise can be given by the buyer to the seller (or seller's agent) i) on the expriation date, in the case of a European style option, (ii) on each bermuda option exercise date and the expiration date, in the case of a Bermuda style option the commencement date to, and including, the expiration date, in the case of an American option.",
    },
    {
        name: 'UnderlyingProvisionOptionExerciseEarliestTimeBusinessCenter',
        abbrName: 'ErlstTmBizCtr',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42130,
        description:
            "Identifies the business center calendar used with the provision's earliest time for notice of exercise.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.",
    },
    {
        name: 'UnderlyingProvisionOptionExerciseLatestTime',
        abbrName: 'LtstTm',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 42131,
        description:
            "For a Bermuda or American style option, the latest time on an exercise business day (excluding the expiration date) within the exercise period that notice can be given by the buyer to the seller or seller's agent. Notice of exercise given after this time will be deemed to have been given on the next exercise business day.",
    },
    {
        name: 'UnderlyingProvisionOptionExerciseLatestTimeBusinessCenter',
        abbrName: 'LtstTmBizCtr',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42132,
        description:
            "Identifies the business center calendar used with the provision's latest time for notice of exercise.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.",
    },
    {
        name: 'UnderlyingProvisionOptionExpirationDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42133,
        description:
            'The unadjusted last day within an exercise period for an American style option. For a European style option it is the only day within the exercise period.',
    },
    {
        name: 'UnderlyingProvisionOptionExpirationDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 42134,
        description:
            "The business day convention used to adjust the underlying instrument's provision's option expiration date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.",
    },
    {
        name: 'UnderlyingProvisionOptionExpirationDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42135,
        description:
            'Specifies the anchor date when the option expiration date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'UnderlyingProvisionOptionExpirationDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 42136,
        description: 'Time unit multiplier for the relative option expiration date offset.',
    },
    {
        name: 'UnderlyingProvisionOptionExpirationDateOffsetUnit',
        abbrName: 'OfstUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 42137,
        description: 'Time unit associated with the relative option expiration date offset.',
    },
    {
        name: 'UnderlyingProvisionOptionExpirationDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 42138,
        description: "Specifies the day type of the provision's relative option expiration date offset.",
    },
    {
        name: 'UnderlyingProvisionOptionExpirationDateAdjusted',
        abbrName: 'Dt',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42139,
        description:
            'The adjusted last date within an exercise period for an American style option. For a European style option it is the only date within the exercise period.',
    },
    {
        name: 'UnderlyingProvisionOptionExpirationTime',
        abbrName: 'ExpTm',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 42140,
        description: 'The latest time for exercise on the expiration date.',
    },
    {
        name: 'UnderlyingProvisionOptionExpirationTimeBusinessCenter',
        abbrName: 'ExpTmBizCtr',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42141,
        description:
            "Identifies the business center calendar used with the provision's latest exercise time on expiration date.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.",
    },
    {
        name: 'UnderlyingProvisionOptionRelevantUnderlyingDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42142,
        description:
            'The unadjusted date on the underlying set by the exercise of an option. What this date is depends on the option (e.g. in a swaption it is the swap effective date, in an extendible/cancelable provision it is the swap termination date).',
    },
    {
        name: 'UnderlyingProvisionOptionRelevantUnderlyingDateBizDayConvention',
        abbrName: 'BizDayCnvtn',
        updated: 'FIX.Latest',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        updatedEP: '271',
        id: 42143,
        description:
            "The business day convnetion used to adjust the underlying instrument provision's option underlying date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.",
    },
    {
        name: 'UnderlyingProvisionOptionRelevantUnderlyingDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42144,
        description:
            'Specifies the anchor date when the date relevant to the underlying trade on exercise is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'UnderlyingProvisionOptionRelevantUnderlyingDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        updated: 'FIX.5.0SP2',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'int',
        updatedEP: '208',
        id: 42145,
        description: 'Time unit multiplier for the relative option relevant underlying date offset.',
    },
    {
        name: 'UnderlyingProvisionOptionRelevantUnderlyingDateOffsetUnit',
        abbrName: 'OfstUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        updatedEP: '208',
        id: 42146,
        description: 'Time unit associated with the relative option relevant underlying date offset.',
    },
    {
        name: 'UnderlyingProvisionOptionRelevantUnderlyingDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        updated: 'FIX.5.0SP2',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        updatedEP: '208',
        id: 42147,
        description: "Specifies the day type of the provision's relative option relevant underlying date offset.",
    },
    {
        name: 'UnderlyingProvisionOptionRelevantUnderlyingDateAdjusted',
        abbrName: 'Dt',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42148,
        description:
            'The adjusted date on the underlying set by the exercise of an option. What this date is depends on the option (e.g. in a swaption it is the swap effective date, in an extendible/cancelable provision it is the swap termination date).',
    },
    {
        name: 'NoUnderlyingProvisions',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42149,
        description: 'Number of provisions in the repeating group.',
    },
    {
        name: 'UnderlyingProvisionType',
        abbrName: 'Typ',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'ProvisionTypeCodeSet',
        id: 42150,
        description: 'Type of provision.',
    },
    {
        name: 'UnderlyingProvisionDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42151,
        description: 'The unadjusted date of the provision.',
    },
    {
        name: 'UnderlyingProvisionDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 42152,
        description:
            "The business day convention used to adjust the underlying instrument's provision's date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.",
    },
    {
        name: 'UnderlyingProvisionDateAdjusted',
        abbrName: 'Dt',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42153,
        description: 'The adjusted date of the provision.',
    },
    {
        name: 'UnderlyingProvisionDateTenorPeriod',
        abbrName: 'TenorPeriod',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42154,
        description: "Time unit multiplier for the provision's tenor period.",
    },
    {
        name: 'UnderlyingProvisionDateTenorUnit',
        abbrName: 'TenorUnit',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'ProvisionDateTenorUnitCodeSet',
        id: 42155,
        description: "Time unit associated with the provision's tenor period.",
    },
    {
        name: 'UnderlyingProvisionCalculationAgent',
        abbrName: 'CalcAgent',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'ProvisionCalculationAgentCodeSet',
        id: 42156,
        description:
            'Used to identify the calculation agent. The calculation agent may be identified in UnderlyingProvisionCalculationAgent(42156) or in the underlying provision parties component.',
    },
    {
        name: 'UnderlyingProvisionOptionSinglePartyBuyerSide',
        abbrName: 'BuyerSide',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'ProvisionOptionSinglePartyBuyerSideCodeSet',
        id: 42157,
        description:
            'If optional early termination is not available to both parties then this component identifies the buyer of the option through its side of the trade.',
    },
    {
        name: 'UnderlyingProvisionOptionSinglePartySellerSide',
        abbrName: 'SellerSide',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'ProvisionOptionSinglePartyBuyerSideCodeSet',
        id: 42158,
        description:
            'If optional early termination is not available to both parties then this component identifies the seller of the option through its side of the trade.',
    },
    {
        name: 'UnderlyingProvisionOptionExerciseStyle',
        abbrName: 'ExerStyle',
        unionDataType: 'Reserved100Plus',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'ExerciseStyleCodeSet',
        id: 42159,
        description: "The instrument provision's exercise style.",
    },
    {
        name: 'UnderlyingProvisionOptionExerciseMultipleNotional',
        abbrName: 'MultplNotl',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 42160,
        description:
            'A notional amount which restricts the amount of notional that can be exercised when partial exercise or multiple exercise is applicable. The integral multiple amount defines a lower limit of notional that can be exercised and also defines a unit multiple of notional that can be exercised, i.e. only integer multiples of this amount can be exercised.',
    },
    {
        name: 'UnderlyingProvisionOptionExerciseMinimumNotional',
        abbrName: 'MinNotl',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 42161,
        description: 'The minimum notional amount that can be exercised on a given exercise date.',
    },
    {
        name: 'UnderlyingProvisionOptionExerciseMaximumNotional',
        abbrName: 'MaxNotl',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 42162,
        description: 'The maximum notional amount that can be exercised on a given exercise date.',
    },
    {
        name: 'UnderlyingProvisionOptionMinimumNumber',
        abbrName: 'MinNum',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42163,
        description: 'The minimum number of options that can be exercised on a given exercise date.',
    },
    {
        name: 'UnderlyingProvisionOptionMaximumNumber',
        abbrName: 'MaxNum',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42164,
        description:
            'The maximum number of options that can be exercised on a given exercise date. If the number is not specified, it means that the maximum number of options corresponds to the remaining unexercised options.',
    },
    {
        name: 'UnderlyingProvisionOptionExerciseConfirmation',
        abbrName: 'ExerCnfm',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42165,
        description:
            "Used to indicate whether follow-up confirmation of exercise (written or electronic) is required following telephonic notice by the buyer to the seller or seller's agent.",
    },
    {
        name: 'UnderlyingProvisionCashSettlMethod',
        abbrName: 'SettlMeth',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'ProvisionCashSettlMethodCodeSet',
        id: 42166,
        description:
            'An ISDA defined cash settlement method used for the determination of the applicable cash settlement amount. The method is defined in the 2006 ISDA Definitions, Section 18.3. Cash Settlement Methods, paragraph (e).',
    },
    {
        name: 'UnderlyingProvisionCashSettlCurrency',
        abbrName: 'SettlCcy',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 42167,
        description: 'Specifies the currency of settlement. Uses ISO 4217 currency codes.',
    },
    {
        name: 'UnderlyingProvisionCashSettlCurrency2',
        abbrName: 'SettlCcy2',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 42168,
        description:
            'Specifies the currency of settlement for a cross-currency provision. Uses ISO 4217 currency codes.',
    },
    {
        name: 'UnderlyingProvisionCashSettlQuoteType',
        abbrName: 'SettlQteTyp',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'ProvisionCashSettlQuoteTypeCodeSet',
        id: 42169,
        description: 'Identifies the type of quote to be used.',
    },
    {
        name: 'UnderlyingProvisionText',
        abbrName: 'Txt',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42170,
        description:
            'Free form text to specify additional information or enumeration description when a standard value does not apply.',
    },
    {
        name: 'EncodedUnderlyingProvisionTextLen',
        abbrName: 'EncTxtLen',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 42171,
        description: 'Byte length of encoded (non-ASCII characters) EncodedUnderlyingProvisionText(42712) field.',
    },
    {
        name: 'EncodedUnderlyingProvisionText',
        abbrName: 'EncTxt',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 42172,
        lengthId: '42171',
        description:
            'Encoded (non-ASCII characters) representation of the UnderlyingProvisionText(42170) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the UnderlyingProvisionText(42170) field.',
    },
    {
        name: 'NoUnderlyingProvisionPartyIDs',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42173,
        description: 'Number of parties identified in the contract provision.',
    },
    {
        name: 'UnderlyingProvisionPartyID',
        abbrName: 'ID',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42174,
        discriminatorId: '42175',
        description: 'The party identifier for the payment settlement party.',
    },
    {
        name: 'UnderlyingProvisionPartyIDSource',
        abbrName: 'Src',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'PartyIDSourceCodeSet',
        id: 42175,
        description: 'Identifies the class or source of the UnderlyingProvisionPartyID(42174) value.',
    },
    {
        name: 'UnderlyingProvisionPartyRole',
        abbrName: 'R',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'PartyRoleCodeSet',
        id: 42176,
        description: 'Identifies the type or role of UnderlyingProvisionPartyID(42174) specified.',
    },
    {
        name: 'UnderlyingProvisionPartyRoleQualifier',
        abbrName: 'Qual',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'PartyDetailRoleQualifierCodeSet',
        id: 40918,
        description: 'Used to further qualify the value of UnderlyingProvisionPartyRole(42176).',
    },
    {
        name: 'NoUnderlyingProvisionPartySubIDs',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42177,
        description: 'Number of sub-party IDs to be reported for the party.',
    },
    {
        name: 'UnderlyingProvisionPartySubID',
        abbrName: 'ID',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42178,
        description: 'Underlying provision party sub-identifier, if applicable for UnderlyingProvisionPartyID(42174).',
    },
    {
        name: 'UnderlyingProvisionPartySubIDType',
        abbrName: 'Typ',
        unionDataType: 'Reserved4000Plus',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'PartySubIDTypeCodeSet',
        id: 42179,
        description: 'The type of UnderlyingProvisionPartySubID(42178).',
    },
    {
        name: 'NoUnderlyingProvisionCashSettlPaymentDateBusinessCenters',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42180,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'UnderlyingProvisionCashSettlPaymentDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42181,
        description:
            'The business center calendar used to adjust the provision\'s cash settlement payment\'s termination, or relative termination, date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'NoUnderlyingProvisionCashSettlValueDateBusinessCenters',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42182,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'UnderlyingProvisionCashSettlValueDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42183,
        description:
            'The business center calendar used to adjust the cash settlement valuation date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'NoUnderlyingProvisionOptionExerciseBusinessCenters',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42184,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'UnderlyingProvisionOptionExerciseBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42185,
        description:
            'The business center calendar used to adjust the underlying instrument\'s provision\'s option exercise date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'NoUnderlyingProvisionOptionExpirationDateBusinessCenters',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42186,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'UnderlyingProvisionOptionExpirationDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42187,
        description:
            'The business center calendar used to adjust the underlying instrument\'s provision\'s option expiration date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'NoUnderlyingProvisionOptionRelevantUnderlyingDateBusinessCenters',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42188,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'UnderlyingProvisionOptionRelevantUnderlyingDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42189,
        description:
            'The business center calendar used to adjust the underlying instrument\'s provision\'s option underlying date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'NoUnderlyingProvisionDateBusinessCenters',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42190,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'UnderlyingProvisionDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42191,
        description:
            'The business center calendar used to adjust the underlying instrument\'s provision\'s date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'FillRefID',
        abbrName: 'FillRefID',
        addedEP: '188',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2421,
        description:
            'A reference to either the value of the FillExecID(1363) or an implicit position of a fills instance in the FillsGrp component.',
    },
    {
        name: 'OrderRequestID',
        abbrName: 'OrdReqID',
        addedEP: '188',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2422,
        description: 'Unique message identifier for an order request as assigned by the submitter of the request.',
    },
    {
        name: 'MassOrderRequestID',
        abbrName: 'MassOrdReqID',
        addedEP: '188',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2423,
        description: 'Unique message identifier for a mass order request as assigned by the submitter of the orders.',
    },
    {
        name: 'MassOrderReportID',
        abbrName: 'MassOrdRptID',
        updated: 'FIX.Latest',
        addedEP: '188',
        added: 'FIX.5.0SP2',
        type: 'String',
        updatedEP: '271',
        id: 2424,
        description:
            'Unique message identifier for the response to a mass order request as assigned by the receiver of the orders.',
    },
    {
        name: 'MassOrderRequestStatus',
        abbrName: 'ReqStat',
        addedEP: '188',
        added: 'FIX.5.0SP2',
        type: 'MassOrderRequestStatusCodeSet',
        id: 2425,
        description: 'Status of mass order request.',
    },
    {
        name: 'MassOrderRequestResult',
        abbrName: 'ReqRslt',
        unionDataType: 'Reserved100Plus',
        addedEP: '188',
        added: 'FIX.5.0SP2',
        type: 'MassOrderRequestResultCodeSet',
        id: 2426,
        description: 'Request result of mass order request.',
    },
    {
        name: 'OrderResponseLevel',
        abbrName: 'OrdRspLvl',
        addedEP: '188',
        added: 'FIX.5.0SP2',
        type: 'OrderResponseLevelCodeSet',
        id: 2427,
        description:
            'The level of response requested from receiver of mass order messages. A default value should be bilaterally agreed.',
    },
    {
        name: 'NoOrderEntries',
        addedEP: '188',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2428,
        description: 'Number of order entries.',
    },
    {
        name: 'OrderEntryAction',
        abbrName: 'OrdEntryActn',
        addedEP: '188',
        added: 'FIX.5.0SP2',
        type: 'OrderEntryActionCodeSet',
        id: 2429,
        description: 'Specifies the action to be taken for the given order.',
    },
    {
        name: 'OrderEntryID',
        abbrName: 'OrdEntryID',
        addedEP: '188',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2430,
        description:
            'Unique identifier for an order within a single MassOrder(35=DJ) message that can be used as a reference in the MassOrderAck(35=DK) message.',
    },
    {
        name: 'ExecTypeReason',
        abbrName: 'ExecTypRsn',
        unionDataType: 'Reserved100Plus',
        addedEP: '188',
        added: 'FIX.5.0SP2',
        type: 'ExecTypeReasonCodeSet',
        id: 2431,
        description: 'The initiating event when an ExecutionReport(35=8) is sent.',
    },
    {
        name: 'TotNoOrderEntries',
        abbrName: 'TotNoOrdEntries',
        addedEP: '188',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2432,
        description:
            'Totals number of orders for a mass order or its acknowledgment being fragmented across multiple messages.',
    },
    {
        name: 'NoTargetPartySubIDs',
        addedEP: '189',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2433,
        description: 'Number of target party sub IDs in the repeating group.',
    },
    {
        name: 'TargetPartySubID',
        abbrName: 'ID',
        addedEP: '189',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2434,
        description: 'Party sub-identifier value within a target party repeating group.',
    },
    {
        name: 'TargetPartySubIDType',
        abbrName: 'Typ',
        unionDataType: 'Reserved4000Plus',
        addedEP: '189',
        added: 'FIX.5.0SP2',
        type: 'PartySubIDTypeCodeSet',
        id: 2435,
        description: 'Type of TargetPartySubID(2434) value.',
    },
    {
        name: 'TransferInstructionID',
        abbrName: 'InstID',
        addedEP: '189',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2436,
        description: 'Unique identifier for the transfer instruction assigned by the submitter.',
    },
    {
        name: 'TransferID',
        abbrName: 'XferID',
        addedEP: '189',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2437,
        description:
            'The unique identifier assigned to the transfer entity once it is received, for example, by the CCP or the party governing the transfer process. Generally this same identifier for the transfer is used by all parties involved.',
    },
    {
        name: 'TransferReportID',
        abbrName: 'RptID',
        addedEP: '189',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2438,
        description: 'Unique identifier for the transfer report message.',
    },
    {
        name: 'TransferTransType',
        abbrName: 'TransTyp',
        addedEP: '189',
        added: 'FIX.5.0SP2',
        type: 'TransferTransTypeCodeSet',
        id: 2439,
        description: 'Indicates the type of transfer transaction.',
    },
    {
        name: 'TransferType',
        abbrName: 'XferTyp',
        addedEP: '189',
        added: 'FIX.5.0SP2',
        type: 'TransferTypeCodeSet',
        id: 2440,
        description: 'Indicates the type of transfer request.',
    },
    {
        name: 'TransferScope',
        abbrName: 'XferScope',
        addedEP: '189',
        added: 'FIX.5.0SP2',
        type: 'TransferScopeCodeSet',
        id: 2441,
        description: 'Indicates the type of transfer.',
    },
    {
        name: 'TransferStatus',
        abbrName: 'XferStat',
        addedEP: '189',
        added: 'FIX.5.0SP2',
        type: 'TransferStatusCodeSet',
        id: 2442,
        description: 'Status of the transfer.',
    },
    {
        name: 'TransferRejectReason',
        abbrName: 'RejRsn',
        unionDataType: 'Reserved100Plus',
        addedEP: '189',
        added: 'FIX.5.0SP2',
        type: 'TransferRejectReasonCodeSet',
        id: 2443,
        description: 'Reason the transfer instruction was rejected.',
    },
    {
        name: 'TransferReportType',
        abbrName: 'RptTyp',
        addedEP: '189',
        added: 'FIX.5.0SP2',
        type: 'TransferReportTypeCodeSet',
        id: 2444,
        description: 'Indicates the type of transfer report.',
    },
    {
        name: 'AggressorTime',
        abbrName: 'AgrsrTm',
        addedEP: '190',
        added: 'FIX.5.0SP2',
        type: 'UTCTimestamp',
        id: 2445,
        description: 'Timestamp of aggressive order or quote resulting in match event.',
    },
    {
        name: 'AggressorSide',
        abbrName: 'AgrsrSide',
        addedEP: '190',
        added: 'FIX.5.0SP2',
        type: 'SideCodeSet',
        id: 2446,
        description: 'Side of aggressive order or quote resulting in match event.',
    },
    {
        name: 'FastMarketIndicator',
        abbrName: 'FastMktInd',
        addedEP: '190',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2447,
        description:
            'Indicates if the instrument is in "fast market" state.\n\nA "fast market" is a state in which market rules are applied to instrument(s) or entire trading session when market events causes significant price movements due to public information.',
    },
    {
        name: 'LinkageHandlingIndicator',
        abbrName: 'LnkgHandlInd',
        addedEP: '190',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2448,
        description: 'Indicate whether linkage handling is in effect for an instrument or not.',
    },
    {
        name: 'NumberOfBuyOrders',
        abbrName: 'NumOfBuyOrds',
        addedEP: '190',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2449,
        description: 'Number of buy orders involved in a trade.',
    },
    {
        name: 'NumberOfSellOrders',
        abbrName: 'NumOfSellOrds',
        addedEP: '190',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2450,
        description: 'Number of sell orders involved in a trade.',
    },
    {
        name: 'SettlPriceDeterminationMethod',
        abbrName: 'SettlPxDtrmnMeth',
        unionDataType: 'Reserved100Plus',
        addedEP: '190',
        added: 'FIX.5.0SP2',
        type: 'SettlPriceDeterminationMethodCodeSet',
        id: 2451,
        description: 'Calculation method used to determine settlement price.',
    },
    {
        name: 'MDStatisticReqID',
        abbrName: 'ReqID',
        addedEP: '191',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2452,
        description: 'Message identifier for a statistics request.',
    },
    {
        name: 'MDStatisticRptID',
        abbrName: 'RptID',
        addedEP: '191',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2453,
        description: 'Message identifier for a statistics report.',
    },
    {
        name: 'MDStatisticName',
        abbrName: 'StatsNme',
        addedEP: '191',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2454,
        description: 'The short name or acronym for a set of statistic parameters.',
    },
    {
        name: 'MDStatisticDesc',
        abbrName: 'Desc',
        addedEP: '191',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2455,
        description: 'Can be used to provide an optional textual description for a statistic.',
    },
    {
        name: 'MDStatisticType',
        abbrName: 'Typ',
        unionDataType: 'Reserved100Plus',
        addedEP: '191',
        added: 'FIX.5.0SP2',
        type: 'MDStatisticTypeCodeSet',
        id: 2456,
        description: 'Type of statistic value.',
    },
    {
        name: 'MDStatisticScope',
        abbrName: 'Scope',
        unionDataType: 'Reserved100Plus',
        addedEP: '191',
        added: 'FIX.5.0SP2',
        type: 'MDStatisticScopeCodeSet',
        id: 2457,
        description: 'Entities used as basis for the statistics.',
    },
    {
        name: 'MDStatisticSubScope',
        abbrName: 'SubScope',
        unionDataType: 'Reserved100Plus',
        addedEP: '191',
        added: 'FIX.5.0SP2',
        type: 'MDStatisticSubScopeCodeSet',
        id: 2458,
        description: 'Sub-scope of the statistics to further reduce the entities used as basis for the statistics.',
    },
    {
        name: 'MDStatisticScopeType',
        abbrName: 'ScopeTyp',
        unionDataType: 'Reserved100Plus',
        addedEP: '191',
        added: 'FIX.5.0SP2',
        type: 'MDStatisticScopeTypeCodeSet',
        id: 2459,
        description:
            'Scope details of the statistics to reduce the number of events being used as basis for the statistics.',
    },
    {
        name: 'MDStatisticFrequencyPeriod',
        abbrName: 'FreqPeriod',
        addedEP: '191',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2460,
        description:
            'Dissemination frequency of statistics.\n\nSpecial meaning for a value of zero which represents an event-driven dissemination in real time (e.g. as soon as a new trade occurs).',
    },
    {
        name: 'MDStatisticFrequencyUnit',
        abbrName: 'FreqUnit',
        addedEP: '191',
        added: 'FIX.5.0SP2',
        type: 'OrderDelayUnitCodeSet',
        id: 2461,
        description: 'Time unit for MDStatisticFrequencyPeriod(2460).',
    },
    {
        name: 'MDStatisticDelayPeriod',
        abbrName: 'DelayPeriod',
        addedEP: '191',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2462,
        description:
            'Number of time units between the calculation of the statistic and its dissemination. Can be used to defer or delay publication.',
    },
    {
        name: 'MDStatisticDelayUnit',
        abbrName: 'DelayUnit',
        addedEP: '191',
        added: 'FIX.5.0SP2',
        type: 'OrderDelayUnitCodeSet',
        id: 2463,
        description: 'Time unit for MDStatisticDelayPeriod(2462).',
    },
    {
        name: 'MDStatisticIntervalType',
        abbrName: 'IntvlTyp',
        addedEP: '191',
        added: 'FIX.5.0SP2',
        type: 'MDStatisticIntervalTypeCodeSet',
        id: 2464,
        description: 'Type of interval over which statistic is calculated.',
    },
    {
        name: 'MDStatisticIntervalTypeUnit',
        abbrName: 'IntvlTypUnit',
        addedEP: '191',
        added: 'FIX.5.0SP2',
        type: 'TimeUnitCodeSet',
        id: 2465,
        description: 'Time unit for MDStatisticIntervalType(2464).',
    },
    {
        name: 'MDStatisticIntervalPeriod',
        abbrName: 'IntvlPeriod',
        addedEP: '191',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2466,
        description:
            'Length of time over which the statistic is calculated. Special meaning for a value of zero to express that there is no aggregation over time. Can be used with other interval types expressing relative date and time ranges to combine them with sliding window peaks, e.g. highest volume across 1 minute intervals of the previous day.',
    },
    {
        name: 'MDStatisticIntervalUnit',
        abbrName: 'IntvlUnit',
        addedEP: '191',
        added: 'FIX.5.0SP2',
        type: 'OrderDelayUnitCodeSet',
        id: 2467,
        description: 'Time unit for MDStatisticIntervalPeriod(2466).',
    },
    {
        name: 'MDStatisticStartDate',
        abbrName: 'StartDt',
        addedEP: '191',
        added: 'FIX.5.0SP2',
        type: 'UTCTimestamp',
        id: 2468,
        description: 'First day of range for which statistical data is collected.',
    },
    {
        name: 'MDStatisticEndDate',
        abbrName: 'EndDt',
        addedEP: '191',
        added: 'FIX.5.0SP2',
        type: 'UTCTimestamp',
        id: 2469,
        description: 'Last day of range for which statistical data is collected.',
    },
    {
        name: 'MDStatisticStartTime',
        abbrName: 'StartTm',
        addedEP: '191',
        added: 'FIX.5.0SP2',
        type: 'UTCTimeOnly',
        id: 2470,
        description: 'Start time of the time range for which statistical data is collected.',
    },
    {
        name: 'MDStatisticEndTime',
        abbrName: 'EndTm',
        addedEP: '191',
        added: 'FIX.5.0SP2',
        type: 'UTCTimeOnly',
        id: 2471,
        description: 'End time of the time range for which statistical data is collected.',
    },
    {
        name: 'MDStatisticRatioType',
        abbrName: 'RatioTyp',
        addedEP: '191',
        added: 'FIX.5.0SP2',
        type: 'MDStatisticRatioTypeCodeSet',
        id: 2472,
        description: 'Ratios between various entities.',
    },
    {
        name: 'MDStatisticRequestResult',
        abbrName: 'ReqRslt',
        unionDataType: 'Reserved100Plus',
        addedEP: '191',
        added: 'FIX.5.0SP2',
        type: 'MDStatisticRequestResultCodeSet',
        id: 2473,
        description: 'Result returned in response to MarketDataStatisticsRequest (35=DO).',
    },
    {
        name: 'NoMDStatistics',
        addedEP: '191',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2474,
        description: 'Number of market data statistics.',
    },
    {
        name: 'MDStatisticID',
        abbrName: 'StatsID',
        addedEP: '191',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2475,
        description: 'Unique identifier for a statistic.',
    },
    {
        name: 'MDStatisticTime',
        abbrName: 'Tm',
        addedEP: '191',
        added: 'FIX.5.0SP2',
        type: 'UTCTimestamp',
        id: 2476,
        description: 'Time of calculation of a statistic.',
    },
    {
        name: 'MDStatisticStatus',
        abbrName: 'Stat',
        addedEP: '191',
        added: 'FIX.5.0SP2',
        type: 'MDStatisticStatusCodeSet',
        id: 2477,
        description: 'Status for a statistic to indicate its availability.',
    },
    {
        name: 'MDStatisticValue',
        abbrName: 'Val',
        addedEP: '191',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 2478,
        description: 'Statistical value.',
    },
];

const batch7: ISpecFields[] = [
    {
        name: 'MDStatisticValueType',
        abbrName: 'Typ',
        addedEP: '191',
        added: 'FIX.5.0SP2',
        type: 'MDStatisticValueTypeCodeSet',
        id: 2479,
        description: 'Type of statistical value.',
    },
    {
        name: 'MDStatisticValueUnit',
        abbrName: 'ValUnit',
        updated: 'FIX.5.0SP2',
        addedEP: '191',
        added: 'FIX.5.0SP2',
        type: 'OrderDelayUnitCodeSet',
        updatedEP: '208',
        id: 2480,
        description: 'Unit of time for statistical value.',
    },
    {
        name: 'EncodedMDStatisticDescLen',
        abbrName: 'EncDescLen',
        updated: 'FIX.5.0SP2',
        addedEP: '191',
        added: 'FIX.5.0SP2',
        type: 'Length',
        updatedEP: '229',
        id: 2481,
        description: 'Byte length of encoded (non-ASCII characters) EncodedMDStatisticDesc(2482) field.',
    },
    {
        name: 'EncodedMDStatisticDesc',
        abbrName: 'EncDesc',
        addedEP: '191',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 2482,
        lengthId: '2481',
        description:
            'Encoded (non-ASCII characters) representation of the MDStatisticDesc(2455) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the MDStatisticDesc(2455) field.',
    },
    {
        name: 'AllocRiskLimitCheckStatus',
        abbrName: 'RiskLmtChkStat',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'RiskLimitCheckStatusCodeSet',
        id: 2483,
        description: 'Indicates the status of the risk limit check performed on a trade for this allocation instance.',
    },
    {
        name: 'AssetGroup',
        abbrName: 'AssetGrp',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'AssetGroupCodeSet',
        id: 2210,
        description:
            'Indicates the broad product or asset classification. May be used to provide grouping for the product taxonomy (Product(460), SecurityType(167), etc.) and/or the risk taxonomy (AssetClass(1938), AssetSubClass(1939), AssetType(1940), etc.).',
    },
    {
        name: 'LegAssetGroup',
        abbrName: 'AssetGrp',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'AssetGroupCodeSet',
        id: 2348,
        description:
            'Indicates the broad product or asset classification. May be used to provide grouping for the product taxonomy (Product(460), SecurityType(167), etc.) and/or the risk taxonomy (AssetClass(1938), AssetSubClass(1939), AssetType(1940), etc.).',
    },
    {
        name: 'LegContractualDefinition',
        abbrName: 'Def',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42199,
        description:
            'Specifies which contract definition, such as those published by ISDA, will apply for the terms of the trade. See http://www.fpml.org/coding-scheme/contractual-definitions for values.',
    },
    {
        name: 'NoLegContractualDefinitions',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42198,
        description: 'Number of financing definitions in the repeating group.',
    },
    {
        name: 'LegContractualMatrixDate',
        abbrName: 'Dt',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42205,
        description:
            'Specifies the publication date of the applicable version of the contract matrix. If not specified, the ISDA Standard Terms Supplement defines rules for which version of the matrix is applicable.',
    },
    {
        name: 'LegContractualMatrixSource',
        abbrName: 'Src',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42204,
        description:
            'Identifies the applicable contract matrix. See http://www.fpml.org/coding-scheme/matrix-type-1-0.xml for values.',
    },
    {
        name: 'LegContractualMatrixTerm',
        abbrName: 'Trm',
        updated: 'FIX.Latest',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'String',
        updatedEP: '271',
        id: 42206,
        description:
            'Specifies the applicable key into the relevant contract matrix. In the case of 2000 ISDA Definitions Settlement Matrix for Early Termination and Swaptions, the LegContractualMatrixTerm(42206) is not applicable and is to be omitted. See http://www.fpml.org/coding-scheme/credit-matrix-transaction-type for values.',
    },
    {
        name: 'NoLegContractualMatrices',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42203,
        description: 'Number of contractual matrices in the repeating group.',
    },
    {
        name: 'EncodedLegDocumentationText',
        abbrName: 'EncDcmntnTxt',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 2493,
        lengthId: '2494',
        description:
            'Encoded (non-ASCII characters) representation of the LegDocumentationText(2505) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) representation should also be specified in the LegDocumentationText(2505) field.',
    },
    {
        name: 'EncodedLegDocumentationTextLen',
        abbrName: 'EncDcmntnTxtLen',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 2494,
        description: 'Byte length of encoded (non-ASCII characters) EncodedLegDocumentationText(2493) field.',
    },
    {
        name: 'LegAgreementCurrency',
        abbrName: 'AgmtCcy',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 2495,
        description:
            'Contractual currency forming the basis of a financing agreement and associated transactions. Usually, but not always, the same as the trade currency.',
    },
    {
        name: 'LegAgreementDate',
        abbrName: 'AgmtDt',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 2496,
        description:
            'A reference to the date the underlying agreement specified by LegAgreementID(2498) and LegAgreementDesc(2497) was executed.',
    },
    {
        name: 'LegAgreementDesc',
        abbrName: 'AgmtDesc',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2497,
        description:
            'The full name of the base standard agreement, annexes and amendments in place between the principals applicable to a financing transaction. See http://www.fpml.org/coding-scheme/master-agreement-type for derivative values.',
    },
    {
        name: 'LegAgreementID',
        abbrName: 'AgmtID',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2498,
        description:
            'A common reference to the applicable standing agreement between the counterparties to a financing transaction.',
    },
    {
        name: 'LegAgreementVersion',
        abbrName: 'AgmtVer',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2499,
        description: 'The version of the master agreement.',
    },
    {
        name: 'LegBrokerConfirmationDesc',
        abbrName: 'BrkrCnfmDesc',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2500,
        description:
            'Describes the type of broker confirmation executed between the parties. Can be used as an alternative to MasterConfirmationDesc(1962). See http://www.fpml.org/coding-scheme/broker-confirmation-type for values.',
    },
    {
        name: 'LegCreditSupportAgreementDate',
        abbrName: 'CrdSuprtDt',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 2501,
        description:
            'The date of the ISDA Credit Support Agreement executed between the parties and intended to govern collateral arrangements for all OTC derivatives transactions between those parties.',
    },
    {
        name: 'LegCreditSupportAgreementDesc',
        abbrName: 'CrdSuprtDesc',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2502,
        description:
            'The type of ISDA Credit Support Agreement. See http://www.fpml.org/coding-scheme/credit-support-agreement-type for values.',
    },
    {
        name: 'LegCreditSupportAgreementID',
        abbrName: 'CrdSuprtID',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2503,
        description:
            'A common reference or unique identifier to identify the ISDA Credit Support Agreement executed between the parties.',
    },
    {
        name: 'LegDeliveryType',
        abbrName: 'DlvryTyp',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'DeliveryTypeCodeSet',
        id: 2504,
        description: 'Identifies type of settlement.',
    },
    {
        name: 'LegDocumentationText',
        abbrName: 'DcmntnTxt',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2505,
        description:
            'A sentence or phrase pertinent to the trade, not a reference to an external document. E.g. "To be registered with the U.S. Environmental Protection Agency, Acid Rain Division, SO2 Allowance Tracking System".',
    },
    {
        name: 'LegEndDate',
        abbrName: 'EndDt',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 2506,
        description:
            'End date of a financing deal, i.e. the date the seller reimburses the buyer and takes back control of the collateral.',
    },
    {
        name: 'LegGoverningLaw',
        abbrName: 'Law',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2507,
        description:
            'Identification of the law governing the transaction. See http://www.fpml.org/coding-scheme/governing-law for values.',
    },
    {
        name: 'LegMarginRatio',
        abbrName: 'MgnRatio',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 2508,
        description:
            'The fraction of the cash consideration that must be collateralized, expressed as a percent. A MarginRatio of 2% indicates that the value of the collateral (after deducting for "haircut") must exceed the cash consideration by 2%.',
    },
    {
        name: 'LegMasterConfirmationAnnexDate',
        abbrName: 'CnfmAnxDt',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 2509,
        description: 'The date that an annexation to the master confirmation was executed between the parties.',
    },
    {
        name: 'LegMasterConfirmationDate',
        abbrName: 'CnfmDt',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 2510,
        description:
            'Alternative to broker confirmation. The date of the confirmation executed between the parties and intended to govern all relevant transactions between those parties.',
    },
    {
        name: 'LegMasterConfirmationDesc',
        abbrName: 'CnfmDesc',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2511,
        description:
            'The type of master confirmation executed between the parties. See http://www.fpml.org/coding-scheme/master-confirmation-type for values.',
    },
    {
        name: 'LegMasterConfirmationAnnexDesc',
        abbrName: 'CnfmAnxDesc',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2512,
        description:
            'The type of master confirmation annexation executed between the parties. See http://www.fpml.org/coding-scheme/master-confirmation-annex-type for values.',
    },
    {
        name: 'LegStartDate',
        abbrName: 'StartDt',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 2513,
        description:
            'Start date of a financing deal, i.e. the date the buyer pays the seller cash and takes control of the collateral.',
    },
    {
        name: 'LegTerminationType',
        abbrName: 'TrmTyp',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'TerminationTypeCodeSet',
        id: 2514,
        description: 'Type of financing termination.',
    },
    {
        name: 'LegFinancingTermSupplementDate',
        abbrName: 'Dt',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42202,
        description: 'Specifies the publication date of the applicable version of the contractual supplement.',
    },
    {
        name: 'LegFinancingTermSupplementDesc',
        abbrName: 'Desc',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42201,
        description:
            'Identifies the applicable contractual supplement. See http://www.fpml.org/coding-scheme/contractual-supplement for values.',
    },
    {
        name: 'NoLegFinancingTermSupplements',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42200,
        description: 'Number of financing terms supplements in the repeating group.',
    },
    {
        name: 'UnderlyingAssetGroup',
        abbrName: 'AssetGrp',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'AssetGroupCodeSet',
        id: 2491,
        description:
            'Indicates the broad product or asset classification. May be used to provide grouping for the product taxonomy (Product(460), SecurityType(167), etc.) and/or the risk taxonomy (AssetClass(1938), AssetSubClass(1939), AssetType(1940), etc.).',
    },
    {
        name: 'FirmTransactionID',
        abbrName: 'FirmTxnID',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2484,
        description: 'The unique transaction entity identifier assigned by the firm.',
    },
    {
        name: 'TransactionID',
        abbrName: 'TxnID',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2485,
        description: 'The unique transaction entity identifier.',
    },
    {
        name: 'WireReference',
        abbrName: 'WreRef',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2486,
        description:
            'The reference to a wire transfer associated with the transaction. Wire references done via wire services such as Fedwire Output Message Accountabilitty Data "OMAD" or SWIFT Output Sequence Number "OSN".',
    },
    {
        name: 'CollRptRejectReason',
        abbrName: 'RejRsn',
        unionDataType: 'Reserved100Plus',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'CollRptRejectReasonCodeSet',
        id: 2487,
        description: 'Reject reason code for rejecting the collateral report.',
    },
    {
        name: 'CollRptStatus',
        abbrName: 'RptStat',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'CollRptStatusCodeSet',
        id: 2488,
        description: 'The status of the collateral report.',
    },
    {
        name: 'PackageID',
        abbrName: 'PackageID',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2489,
        description:
            'Identifier assigned to a collection of trades so that they can be analyzed as one atomic unit for risk assessment and clearing.',
    },
    {
        name: 'TradeNumber',
        abbrName: 'TrdNum',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2490,
        description: 'Ordinal number of the trade within a series of related trades.',
    },
    {
        name: 'AllocCalculatedCcyQty',
        abbrName: 'CalcCcyQty',
        addedEP: '193',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 2515,
        description:
            'Used for the calculated quantity of the other side of the currency trade applicable to the allocation instance.',
    },
    {
        name: 'CollateralRequestInstruction',
        abbrName: 'CollReqInst',
        addedEP: '193',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2516,
        description: 'An encoded collateral request processing instruction to the receiver.',
    },
    {
        name: 'CollateralRequestLinkID',
        abbrName: 'CollReqLinkID',
        addedEP: '193',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2517,
        description: 'A unique identifier to link together a set or group of requests.',
    },
    {
        name: 'CollateralRequestNumber',
        abbrName: 'CollReqNum',
        addedEP: '193',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2518,
        description: 'Ordinal number of the request within a set or group of requests.',
    },
    {
        name: 'TotNumCollateralRequests',
        abbrName: 'TotNumCollReqs',
        addedEP: '193',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2519,
        description: 'Total number of request messages within a set or group of requests.',
    },
    {
        name: 'WarningText',
        abbrName: 'WarnTxt',
        addedEP: '193',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2520,
        description: 'Communicates the underlying condition when the request response indicates "warning".',
    },
    {
        name: 'EncodedWarningText',
        abbrName: 'EncWarnTxt',
        addedEP: '193',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 2521,
        lengthId: '2522',
        description:
            'Encoded (non-ASCII characters) representation of the WarningText(2520) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) representation should also be specified in the WarningText(2520) field.',
    },
    {
        name: 'EncodedWarningTextLen',
        abbrName: 'EncWarnTxtLen',
        addedEP: '193',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 2522,
        description: 'Byte length of encoded (non-ASCII characters) EncodedWarningtText(2521) field.',
    },
    {
        name: 'LegStreamCommodityDeliveryPricingRegion',
        abbrName: 'DlvryPxngRgn',
        addedEP: '193',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42588,
        description:
            'The delivery or pricing region associated with the commodity swap. See http://www.ecfr.gov/cgi-bin/text-idx?SID=660d6a40f836aa6ddf213cba080c5b22&node=ap17.2.43_17.e&rgn=div9 for the external code list.\n\nIn the context of CFTC Part 43 Appendix E requirement this represents the specific delivery point or pricing point associated with publically reportable commodity swap transactions.',
    },
    {
        name: 'StreamCommodityDeliveryPricingRegion',
        abbrName: 'DlvryPxngRgn',
        addedEP: '193',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42587,
        description:
            'The delivery or pricing region associated with the commodity swap. See http://www.ecfr.gov/cgi-bin/text-idx?SID=660d6a40f836aa6ddf213cba080c5b22&node=ap17.2.43_17.e&rgn=div9 for the external code list.\n\nIn the context of CFTC Part 43 Appendix E requirement this represents the specific delivery point or pricing point associated with publicly reportable commodity swap transactions.',
    },
    {
        name: 'AffiliatedFirmsTradeIndicator',
        abbrName: 'AffltdFirmsTrdInd',
        addedEP: '193',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2525,
        description:
            'Indicates whether the transaction or position was entered into between two affiliated firms. I.e. one counterparty has an ownership interest in the other counterparty but less than the majority interest.\n\nThis trade attribute was identified under and applies to the Canadian CSA trade reporting regulations.',
    },
    {
        name: 'InternationalSwapIndicator',
        abbrName: 'IntlSwapInd',
        addedEP: '193',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2526,
        description:
            'Identifies the swap trade as an "international" transaction.\n\nIn the context of CFTC Regulation 45.3(h), an international swap is required by U.S. law and the law of another jurisdiction to be reported both to a US Swaps Data Repository and to a different trade repository registered within the other jurisdiction. The additional SDRs must be identified in the appropriate Parties component with PartyRole(452) = 102 (Data repository), PartyRoleQualifier(2376) = 11 (Additional international trade repository) and PartySubIDType(803) = 70 (Location or jurisdiction).',
    },
    {
        name: 'MultiAssetSwapIndicator',
        abbrName: 'MAsstSwapInd',
        addedEP: '193',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2527,
        description:
            "Indicates a swap that does not have one easily identifiable primary underlying asset, but instead involves multiple underlying assets within one trade repository's jurisdiction that belong to different asset classes.\n\n",
    },
    {
        name: 'UnderlyingStreamCommodityDeliveryPricingRegion',
        abbrName: 'DlvryPxngRgn',
        addedEP: '193',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42589,
        description:
            'The delivery or pricing region associated with the commodity swap. See http://www.ecfr.gov/cgi-bin/text-idx?SID=660d6a40f836aa6ddf213cba080c5b22&node=ap17.2.43_17.e&rgn=div9 for the external code list.\n\nIn the context of CFTC Part 43 Appendix E requirement this represents the specific delivery point or pricing point associated with publically reportable commodity swap transactions.',
    },
    {
        name: 'NoRelativeValues',
        addedEP: '194',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2529,
        description: 'Number of relative value metrics entries in the repeating group.',
    },
    {
        name: 'RelativeValueType',
        abbrName: 'Typ',
        unionDataType: 'Reserved100Plus',
        addedEP: '194',
        added: 'FIX.5.0SP2',
        type: 'RelativeValueTypeCodeSet',
        id: 2530,
        description: 'Indicates the type of relative value measurement being specified.',
    },
    {
        name: 'RelativeValue',
        abbrName: 'Val',
        addedEP: '194',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 2531,
        description:
            'The valuation of an instrument relative to a base measurement specified in RelativeValueType(2530). This value can be negative.',
    },
    {
        name: 'RelativeValueSide',
        abbrName: 'Side',
        addedEP: '194',
        added: 'FIX.5.0SP2',
        type: 'RelativeValueSideCodeSet',
        id: 2532,
        description: 'Specifies the side of the relative value.',
    },
    {
        name: 'BidSpread',
        abbrName: 'BidSpread',
        addedEP: '194',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 2533,
        description:
            'Basis points relative to a benchmark curve on the bid side, such as LIBOR, or a known security, such as 10Y US Treasury bond. The benchmark security or curve name is specified in the SpreadOrBenchmarkCurveData component.',
    },
    {
        name: 'OfferSpread',
        abbrName: 'OfrSpread',
        addedEP: '194',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 2534,
        description:
            'Basis points relative to a benchmark curve on the offer side, such as LIBOR, or a known security, such as 10Y US Treasury bond. The benchmark security or curve name is specified in the SpreadOrBenchmarkCurveData component.',
    },
    {
        name: 'ClearingSettlPrice',
        abbrName: 'SetPx',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 2528,
        description: 'Clearing settlement price.',
    },
    {
        name: 'MDReportEvent',
        abbrName: 'MDRptEvent',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'MDReportEventCodeSet',
        id: 2535,
        description: 'Technical event within market data feed.',
    },
    {
        name: 'MDReportCount',
        abbrName: 'MDRptCnt',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2536,
        description: 'Number of reference and market data messages in-between two MarketDataReport(35=DR) messages.',
    },
    {
        name: 'TotNoMarketSegmentReports',
        abbrName: 'TotNoMktSegRpts',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2537,
        description: 'Total number of reports related to market segments.',
    },
    {
        name: 'TotNoInstrumentReports',
        abbrName: 'TotNoInstrmtRpts',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2538,
        description: 'Total number of reports related to instruments.',
    },
    {
        name: 'TotNoPartyDetailReports',
        abbrName: 'TotNoPtyDetlRpts',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2539,
        description: 'Total number of reports related to party detail information.',
    },
    {
        name: 'TotNoEntitlementReports',
        abbrName: 'TotNoEntlmntRpts',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2540,
        description: 'Total number of reports related to party entitlement information.',
    },
    {
        name: 'TotNoRiskLimitReports',
        abbrName: 'TotNoRiskLmtRpts',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2541,
        description: 'Total number of reports related to party risk limit information.',
    },
    {
        name: 'MarketSegmentStatus',
        abbrName: 'MktSegStat',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'MarketSegmentStatusCodeSet',
        id: 2542,
        description: 'Status of market segment.',
    },
    {
        name: 'MarketSegmentType',
        abbrName: 'MktSegTyp',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'MarketSegmentTypeCodeSet',
        id: 2543,
        description: 'Used to classify the type of market segment.',
    },
    {
        name: 'MarketSegmentSubType',
        abbrName: 'MktSegSubTyp',
        unionDataType: 'Reserved100Plus',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'MarketSegmentSubTypeCodeSet',
        id: 2544,
        description: 'Used to further categorize market segments within a MarketSegmentType(2543).',
    },
    {
        name: 'NoRelatedMarketSegments',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2545,
        description: 'Number of related market segments.',
    },
    {
        name: 'RelatedMarketSegmentID',
        abbrName: 'ReltdMktSegID',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2546,
        description: 'Identifies a related market segment.',
    },
    {
        name: 'MarketSegmentRelationship',
        abbrName: 'MktSegRltnshp',
        unionDataType: 'Reserved100Plus',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'MarketSegmentRelationshipCodeSet',
        id: 2547,
        description: 'Type of relationship between two or more market segments.',
    },
    {
        name: 'NoAuctionTypeRules',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2548,
        description: 'Number of auction order types.',
    },
    {
        name: 'AuctionTypeProductComplex',
        abbrName: 'AuctTypProdCmplx',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2549,
        description: 'Identifies an entire suite of products for which the auction order type rule applies.',
    },
    {
        name: 'NoPriceRangeRules',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2550,
        description: 'Number of rules related to price ranges.',
    },
    {
        name: 'StartPriceRange',
        abbrName: 'StartPxRng',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 2551,
        description: 'Lower boundary for price range.',
    },
    {
        name: 'EndPriceRange',
        abbrName: 'EndPxRng',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 2552,
        description: 'Upper boundary for price range.',
    },
    {
        name: 'PriceRangeValue',
        abbrName: 'PxRngValu',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 2553,
        description: 'Maximum range expressed as absolute value.',
    },
    {
        name: 'PriceRangePercentage',
        abbrName: 'PxRngPctage',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 2554,
        description: 'Maximum range expressed as percentage.',
    },
    {
        name: 'PriceRangeProductComplex',
        abbrName: 'PxRngProdCmplx',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2555,
        description: 'Identifies an entire suite of products in the context of trading rules related to price ranges.',
    },
    {
        name: 'PriceRangeRuleID',
        abbrName: 'PxRngRuleID',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2556,
        description: 'Identifier for a price range rule.',
    },
    {
        name: 'FastMarketPercentage',
        abbrName: 'FastMktPctage',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 2557,
        description:
            'The percentage factor to be applied to trading rule parameters (e.g. price ranges, size ranges, etc.) when fast market conditions are applicable.',
    },
    {
        name: 'NoQuoteSizeRules',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2558,
        description: 'Number of rules related to quote sizes.',
    },
    {
        name: 'QuoteSideIndicator',
        abbrName: 'QuotSideInd',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'QuoteSideIndicatorCodeSet',
        id: 2559,
        description: 'Indicates whether single sided quotes are allowed.',
    },
    {
        name: 'NoFlexProductEligibilities',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2560,
        description: 'Number of eligibility indicators for the creation of flexible securities.',
    },
    {
        name: 'FlexProductEligibilityComplex',
        abbrName: 'FlexProdEligCmplx',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2561,
        description:
            'Identifies an entire suite of products which are eligible for the creation of flexible securities.',
    },
    {
        name: 'NumOfComplexInstruments',
        abbrName: 'NumCmplxInstrmt',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2562,
        description:
            'Represents the total number of multileg securities or user defined securities that make up the security.',
    },
    {
        name: 'MarketDepthTimeInterval',
        abbrName: 'MktDepthTmIntvl',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2563,
        description: 'Specifies the time interval used for netting market data in a price depth feed.',
    },
    {
        name: 'MarketDepthTimeIntervalUnit',
        abbrName: 'MktDepthTmIntvlUnit',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'OrderDelayUnitCodeSet',
        id: 2564,
        description:
            'The time unit associated with the time interval of the netting of market data in a price depth feed.',
    },
    {
        name: 'MDRecoveryTimeInterval',
        abbrName: 'MDRcvryTmIntvl',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2565,
        description:
            'Specifies the time interval between two repetitions of the same market data for cyclic recovery feeds.',
    },
    {
        name: 'MDRecoveryTimeIntervalUnit',
        abbrName: 'MDRcvryTmIntvlUnit',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'OrderDelayUnitCodeSet',
        id: 2566,
        description:
            'The time unit associated with the time interval between two cycles of the same market data in cyclic data recovery feeds.',
    },
    {
        name: 'PrimaryServiceLocationID',
        abbrName: 'SvcLctnID1',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2567,
        description: 'Primary service location identifier.',
    },
    {
        name: 'SecondaryServiceLocationID',
        abbrName: 'SvcLctnID2',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2568,
        description: 'Secondary or alternate service location identifier.',
    },
    {
        name: 'MatchRuleProductComplex',
        abbrName: 'MtchRuleProdCmplx',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2569,
        description: 'Identifies an entire suite of products for which the matching rule applies.',
    },
    {
        name: 'CustomerPriority',
        abbrName: 'CustPri',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'CustomerPriorityCodeSet',
        id: 2570,
        description: 'Specifies the kind of priority given to customers.',
    },
    {
        name: 'TickRuleProductComplex',
        abbrName: 'TickRuleProdCmplx',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2571,
        description: 'Identifies an entire suite of products for which the price tick rule applies.',
    },
    {
        name: 'PreviousAdjustedOpenInterest',
        abbrName: 'PrevAdjOpenInt',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 2572,
        description: "Previous day's adjusted open interest.",
    },
    {
        name: 'PreviousUnadjustedOpenInterest',
        abbrName: 'PrevUnadjOpenInt',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 2573,
        description: "Previous day's unadjusted open interest.",
    },
    {
        name: 'LowExercisePriceOptionIndicator',
        abbrName: 'LowExerPxOptInd',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2574,
        description: 'Indicates if a given option instrument permits low exercise prices (LEPO).',
    },
    {
        name: 'BlockTradeEligibilityIndicator',
        abbrName: 'BlckTrdEligInd',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2575,
        description: 'Indicates if a given instrument is eligible for block trading.',
    },
    {
        name: 'InstrumentPricePrecision',
        abbrName: 'PxPrcsn',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2576,
        description: 'Specifies the number of decimal places for instrument prices.',
    },
    {
        name: 'StrikePricePrecision',
        abbrName: 'StrkPxPrcsn',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2577,
        description: 'Specifies the number of decimal places for exercise price.',
    },
    {
        name: 'OrigStrikePrice',
        abbrName: 'OrigStrkPx',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 2578,
        description: 'Original exercise price, e.g. after corporate action requiring changes.',
    },
    {
        name: 'SettlSubMethod',
        abbrName: 'SettlSubMeth',
        unionDataType: 'Reserved100Plus',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'SettlSubMethodCodeSet',
        id: 2579,
        description: 'Specifies a suitable settlement sub-method for a given settlement method.',
    },
    {
        name: 'NoClearingPriceParameters',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2580,
        description: 'Number of parameter sets for clearing prices.',
    },
    {
        name: 'BusinessDayType',
        abbrName: 'BizDayTyp',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 2581,
        description: 'Relative identification of a business day.',
    },
    {
        name: 'ClearingPriceOffset',
        abbrName: 'ClrPxOfst',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 2582,
        description: 'Constant value required for the calculation of the clearing price, e.g. for variance futures.',
    },
    {
        name: 'VegaMultiplier',
        abbrName: 'VegaMult',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 2583,
        description: 'Constant value required for the calculation of the clearing quantity, e.g. for variance futures.',
    },
    {
        name: 'AnnualTradingBusinessDays',
        abbrName: 'AnnlTrdgBizDays',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2584,
        description: 'Number of trading business days in a year.',
    },
    {
        name: 'TotalTradingBusinessDays',
        abbrName: 'TotTrdgBizDays',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2585,
        description: 'Number of trading business days over the lifetime of an instrument.',
    },
    {
        name: 'TradingBusinessDays',
        abbrName: 'TrdgBizDays',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2586,
        description: 'Number of actual trading business days of an instrument.',
    },
    {
        name: 'RealizedVariance',
        abbrName: 'RlzdVarnc',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 2587,
        description:
            'Actual or realized variance of an instrument used to calculate settlement prices, e.g. for variance futures.',
    },
    {
        name: 'StandardVariance',
        abbrName: 'StdVarnc',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 2588,
        description:
            'Standard variance (over the lifetime of an instrument) or initial variance used to calculate settlement prices, e.g. for variance futures.',
    },
    {
        name: 'RelatedClosePrice',
        abbrName: 'ReltdClsPx',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 2589,
        description: 'Closing price of the underlying required to calculate the RealizedVariance(2587).',
    },
    {
        name: 'OvernightInterestRate',
        abbrName: 'OvrNiteIntRt',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 2590,
        description: 'Overnight interest rate.',
    },
    {
        name: 'AccumulatedReturnModifiedVariationMargin',
        abbrName: 'ARMVM',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 2591,
        description: 'The economic cost of the variation margin from one trading day to the next.',
    },
    {
        name: 'CalculationMethod',
        abbrName: 'CalcMeth',
        addedEP: '195',
        added: 'FIX.5.0SP2',
        type: 'CalculationMethodCodeSet',
        id: 2592,
        description: 'Specifies how the calculation will be made.',
    },
    {
        name: 'NoMiscFeeSubTypes',
        addedEP: '196',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2633,
        description: 'Specifies the number of miscellaneous fee sub-types.',
    },
    {
        name: 'MiscFeeSubType',
        abbrName: 'Typ',
        addedEP: '196',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2634,
        description:
            'Used to provide more granular fee types related to a value of MiscFeeType(139).\n\nSee http://www.fixtradingcommunity.org/codelists#Misc_Fee_Sub_Types for code list of applicable fees. Other fee sub-types may be used by mutual agreement of the counterparties.\n\nFee sub-types may include market or country specific fee.',
    },
    {
        name: 'MiscFeeSubTypeAmt',
        abbrName: 'Amt',
        addedEP: '196',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 2635,
        description: 'The amount of the specified MiscFeeSubType(2634).',
    },
    {
        name: 'MiscFeeSubTypeDesc',
        abbrName: 'Desc',
        addedEP: '196',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2636,
        description: 'Can be used to provide an optional textual description of the fee sub-type.',
    },
    {
        name: 'EncodedMiscFeeSubTypeDescLen',
        abbrName: 'EncDescLen',
        addedEP: '196',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 2637,
        description: 'Byte length of encoded (non-ASCII characters) EncodedMiscFeeSubTypeDesc(2638) field.',
    },
    {
        name: 'EncodedMiscFeeSubTypeDesc',
        abbrName: 'EncDesc',
        addedEP: '196',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 2638,
        lengthId: '2637',
        description:
            'Encoded (non-ASCII characters) representation of the MiscFeeSubTypeDesc(2636) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the MiscFeeSubTypeDesc(2636) field.',
    },
    {
        name: 'CollateralAmountType',
        abbrName: 'AmtTyp',
        addedEP: '197',
        added: 'FIX.5.0SP2',
        type: 'CollateralAmountTypeCodeSet',
        id: 2632,
        description: 'The type of value in CurrentCollateralAmount(1704).',
    },
    {
        name: 'PositionID',
        abbrName: 'PosID',
        addedEP: '199',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2618,
        description:
            'Unique identifier for a position entity. Refer to PosMaintRptID(721) for a unique identifier of a position report message.',
    },
    {
        name: 'PaymentDesc',
        abbrName: 'Desc',
        addedEP: '203',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 43087,
        description:
            'A short descriptive name given to the payment, e.g. Premium, Upfront, etc. The description has no intrinsic meaning but should be arbitrarily chosen by the remitter as reference.',
    },
    {
        name: 'NoCommissions',
        addedEP: '204',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2639,
        description: 'Number of commissions in the repeating group.',
    },
    {
        name: 'CommissionAmount',
        abbrName: 'Amt',
        updated: 'FIX.5.0SP2',
        addedEP: '204',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        updatedEP: '223',
        id: 2640,
        description: 'The commission amount.',
    },
    {
        name: 'CommissionAmountType',
        abbrName: 'Typ',
        addedEP: '204',
        added: 'FIX.5.0SP2',
        type: 'CommissionAmountTypeCodeSet',
        id: 2641,
        description: 'Indicates what type of commission is being expressed in CommissionAmount(2640).',
    },
    {
        name: 'CommissionBasis',
        abbrName: 'Basis',
        updated: 'FIX.5.0SP2',
        addedEP: '204',
        added: 'FIX.5.0SP2',
        type: 'CommTypeCodeSet',
        updatedEP: '208',
        id: 2642,
        description: 'Specifies the basis or unit used to calculate the commission.',
    },
    {
        name: 'CommissionCurrency',
        abbrName: 'Ccy',
        updated: 'FIX.Latest',
        addedEP: '204',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        updatedEP: '273',
        id: 2643,
        description:
            "Specifies the currency denomination of the commission amount if different from the trade's currency.\n\nCommissionCurrencyCodeSource(2923) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.",
    },
    {
        name: 'CommissionUnitOfMeasure',
        abbrName: 'UOM',
        updated: 'FIX.5.0SP2',
        addedEP: '204',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        updatedEP: '223',
        id: 2644,
        description: 'The commission rate unit of measure.',
    },
    {
        name: 'CommissionUnitOfMeasureCurrency',
        abbrName: 'UOMCcy',
        addedEP: '204',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 2645,
        description:
            'Indicates the currency of the unit of measure. Conditionally required when CommissionUnitOfMeasure(2644) = Ccy (Amount of currency).',
    },
    {
        name: 'CommissionRate',
        abbrName: 'Rt',
        addedEP: '204',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 2646,
        description:
            'The commission rate when CommissionAmount(2640) is based on a percentage of quantity, amount per unit or a factor of "unit of measure". If the rate is a percentage or expressed in basis points, use the decimalized form, e.g. "0.05" for a 5% commission or "0.005" for 50 basis points.',
    },
    {
        name: 'CommissionSharedIndicator',
        abbrName: 'SharedInd',
        addedEP: '204',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2647,
        description:
            'Indicates whether the amount in CommissionAmount(2640) is to be shared with a third party, e.g. as part of a directed brokerage commission sharing arrangement.',
    },
    {
        name: 'CommissionAmountShared',
        abbrName: 'AmtShared',
        addedEP: '204',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 2648,
        description:
            'Commission amount to be shared with a third party, e.g. as part of a directed brokerage commission sharing arrangement. If specified, this amount should not exceed the amount in CommissionAmount(2640).',
    },
    {
        name: 'CommissionLegRefID',
        abbrName: 'LegRefID',
        addedEP: '204',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2649,
        description: "Identifies the leg of the trade the entry applies to by referencing the leg's LegID(1788).",
    },
    {
        name: 'CommissionDesc',
        abbrName: 'Desc',
        addedEP: '204',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2650,
        description: 'Description of the commission.',
    },
    {
        name: 'EncodedCommissionDescLen',
        abbrName: 'EncDescLen',
        addedEP: '204',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 2651,
        description: 'Byte length of the encoded (non-ASCII characters) EncodedCommissionDesc(2652) field.',
    },
    {
        name: 'EncodedCommissionDesc',
        abbrName: 'EncDesc',
        addedEP: '204',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 2652,
        lengthId: '2651',
        description:
            'Encoded (non-ASCII characters) representation of the CommissionDesc(2650) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) representation should also be specified in the CommissionDesc(2650) field.',
    },
    {
        name: 'NoAllocCommissions',
        addedEP: '204',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2653,
        description: 'Number of commissions in the repeating group.',
    },
    {
        name: 'AllocCommissionAmount',
        abbrName: 'Amt',
        addedEP: '204',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 2654,
        description: 'The commission amount.',
    },
    {
        name: 'AllocCommissionAmountType',
        abbrName: 'Typ',
        addedEP: '204',
        added: 'FIX.5.0SP2',
        type: 'CommissionAmountTypeCodeSet',
        id: 2655,
        description: 'Indicates what type of commission is being expressed in AllocCommissionAmount(2654).',
    },
    {
        name: 'AllocCommissionBasis',
        abbrName: 'Basis',
        updated: 'FIX.5.0SP2',
        addedEP: '204',
        added: 'FIX.5.0SP2',
        type: 'CommTypeCodeSet',
        updatedEP: '208',
        id: 2656,
        description: 'Specifies the basis or unit used to calculate the commission.',
    },
    {
        name: 'AllocCommissionCurrency',
        abbrName: 'Ccy',
        updated: 'FIX.Latest',
        addedEP: '204',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        updatedEP: '273',
        id: 2657,
        description:
            "Specifies the currency denomination of the commission amount if different from the trade's currency.\n\nAllocCommissionCurrencyCodeSource(2925) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.",
    },
    {
        name: 'AllocCommissionUnitOfMeasure',
        abbrName: 'UOM',
        addedEP: '204',
        added: 'FIX.5.0SP2',
        type: 'UnitOfMeasureCodeSet',
        id: 2658,
        description: 'The commission rate unit of measure.',
    },
    {
        name: 'AllocCommissionUnitOfMeasureCurrency',
        abbrName: 'UOMCcy',
        addedEP: '204',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 2659,
        description:
            'Indicates the currency of the unit of measure. Conditionally required when AllocCommissionUnitOfMeasure(2658) = Ccy (Currency).',
    },
    {
        name: 'AllocCommissionRate',
        abbrName: 'Rt',
        addedEP: '204',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 2660,
        description:
            'The commission rate when AllocCommissionAmount(2654) is based on a percentage of quantity, amount per unit or a factor of "unit of measure". If the rate is a percentage or expressed in basis points, use the decimalized form, e.g. "0.05" for a 5% commission or "0.005" for 50 basis points.',
    },
    {
        name: 'AllocCommissionSharedIndicator',
        abbrName: 'SharedInd',
        addedEP: '204',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2661,
        description:
            'Indicates whether the amount in AllocCommissionAmount(2654) is to be shared with a third party, e.g. as part of a directed brokerage commission sharing arrangement.',
    },
    {
        name: 'AllocCommissionAmountShared',
        abbrName: 'AmtShared',
        addedEP: '204',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 2662,
        description:
            'Commission amount to be shared with a third party, e.g. as part of a directed brokerage commission sharing arrangement. If specified, this amount should not exceed the amount in AllocCommissionAmount(2654).',
    },
    {
        name: 'AllocCommissionLegRefID',
        abbrName: 'LegRefID',
        addedEP: '204',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2663,
        description: "Identifies the leg of the trade the entry applies to by referencing the leg's LegID(1788).",
    },
    {
        name: 'AllocCommissionDesc',
        abbrName: 'Desc',
        addedEP: '204',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2664,
        description: 'Description of the commission.',
    },
    {
        name: 'EncodedAllocCommissionDescLen',
        abbrName: 'EncDescLen',
        updated: 'FIX.5.0SP2',
        addedEP: '204',
        added: 'FIX.5.0SP2',
        type: 'Length',
        updatedEP: '229',
        id: 2665,
        description: 'Byte length of the encoded (non-ASCII characters) EncodedAllocCommissionDesc(2666) field.',
    },
    {
        name: 'EncodedAllocCommissionDesc',
        abbrName: 'EncDesc',
        addedEP: '204',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 2666,
        lengthId: '2665',
        description:
            'Encoded (non-ASCII characters) representation of the AllocCommissionDesc(2664) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) representation should also be specified in the AllocCommissionDesc(2664) field.',
    },
    {
        name: 'DeltaCrossed',
        abbrName: 'DeltaCrssd',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2596,
        description:
            'Indicates that the party has taken a position on both a put and a call on the same underlying asset.',
    },
    {
        name: 'CashSettlDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42207,
        description: 'The unadjusted cash settlement date.',
    },
    {
        name: 'CashSettlDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 42208,
        description:
            "The business day convention used to adjust the cash settlement provision's date. Used only to override the business day convention defined in the Instrument component.",
    },
    {
        name: 'CashSettlDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42209,
        description:
            'Specifies the anchor date when the cash settlement date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'CashSettlDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42210,
        description: 'Time unit multiplier for the relative cash settlement date offset.',
    },
    {
        name: 'CashSettlDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42211,
        description: 'Time unit associated with the relative cash settlement date offset.',
    },
    {
        name: 'CashSettlDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42212,
        description: 'Specifies the day type of the relative cash settlement date offset.',
    },
    {
        name: 'CashSettlDateAdjusted',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42213,
        description: 'The adjusted cash settlement date.',
    },
    {
        name: 'NoCashSettlDateBusinessCenters',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42214,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'CashSettlDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42215,
        description:
            'The business center calendar used for date adjustment of the cash settlement unadjusted or relative date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'CashSettlPriceSource',
        abbrName: 'PxSrc',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42216,
        description:
            'The source from which the settlement price is to be obtained.\n\nSee http://www.fpml.org/coding-scheme/settlement-price-source for values.',
    },
    {
        name: 'CashSettlPriceDefault',
        abbrName: 'PxDflt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'CashSettlPriceDefaultCodeSet',
        id: 42217,
        description: 'The default election for determining settlement price.',
    },
    {
        name: 'ComplexEventFuturesPriceValuation',
        abbrName: 'FutPxVal',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2597,
        description:
            'Indicates whether the official settlement price as announced by the related exchange is applicable, in accordance with the ISDA 2002 definitions. Applicable only to futures contracts.',
    },
    {
        name: 'ComplexEventOptionsPriceValuation',
        abbrName: 'OptPxVal',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2598,
        description:
            'Indicates whether the official settlement price as announced by the related exchange is applicable, in accordance with the ISDA 2002 definitions. Applicable only to options contracts.',
    },
    {
        name: 'ComplexEventPVFinalPriceElectionFallback',
        abbrName: 'PVPxFallbck',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventPVFinalPriceElectionFallbackCodeSet',
        id: 2599,
        description:
            'Specifies the fallback provisions for the hedging party in the determination of the final settlement price.',
    },
    {
        name: 'DividendFloatingRateIndex',
        abbrName: 'Ndx',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42218,
        description: 'The dividend accrual floating rate index.',
    },
    {
        name: 'DividendFloatingRateIndexCurvePeriod',
        abbrName: 'NdxPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42219,
        description: 'Time unit multiplier for the dividend accrual floating rate index curve.',
    },
    {
        name: 'DividendFloatingRateIndexCurveUnit',
        abbrName: 'NdxUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexCurveUnitCodeSet',
        id: 42220,
        description: 'Time unit associated with the dividend accrual floating rate index curve period.',
    },
    {
        name: 'DividendFloatingRateMultiplier',
        abbrName: 'RtMult',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 42221,
        description:
            'A rate multiplier to apply to the floating rate. The multiplier can be less than or greater than 1 (one). This should only be included if the multiplier is not equal to 1 (one) for the term of the contract.',
    },
    {
        name: 'DividendFloatingRateSpread',
        abbrName: 'Spread',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 42222,
        description: 'The basis points spread from the index specified in DividendFloatingRateIndex(42218).',
    },
    {
        name: 'DividendFloatingRateSpreadPositionType',
        abbrName: 'SpreadPosTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
        id: 42223,
        description: 'Identifies whether the rate spread is applied to a long or short position.',
    },
    {
        name: 'DividendFloatingRateTreatment',
        abbrName: 'RtTrtmt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateTreatmentCodeSet',
        id: 42224,
        description: 'Specifies the yield calculation treatment for the index.',
    },
    {
        name: 'DividendCapRate',
        abbrName: 'CapRt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 42225,
        description:
            'The cap rate, if any, which applies to the floating rate. It is only required where the floating rate is capped at a certain level. The cap rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A cap rate of 5% would be represented as "0.05".',
    },
    {
        name: 'DividendCapRateBuySide',
        abbrName: 'CapRtBuy',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamCapRateBuySideCodeSet',
        id: 42226,
        description: 'Reference to the buyer of the cap rate option through its trade side.',
    },
    {
        name: 'DividendCapRateSellSide',
        abbrName: 'CapRtSell',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamCapRateBuySideCodeSet',
        id: 42227,
        description: 'Reference to the seller of the cap rate option through its trade side.',
    },
    {
        name: 'DividendFloorRate',
        abbrName: 'FlrRt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 42228,
        description:
            'The floor rate, if any, which applies to the floating rate. The floor rate (strike) is only required where the floating rate is floored at a certain strike level. The floor rate is assumed to be exclusive of any spread and is a per annum rate. The rate is expressed as a decimal, e.g. 5% is represented as "0.05".',
    },
    {
        name: 'DividendFloorRateBuySide',
        abbrName: 'FlrRtBuy',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamFloorRateBuySideCodeSet',
        id: 42229,
        description: 'Reference to the buyer of the floor rate option through its trade side.',
    },
    {
        name: 'DividendFloorRateSellSide',
        abbrName: 'FlrRtSell',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamFloorRateBuySideCodeSet',
        id: 42230,
        description: 'Reference to the seller of the floor rate option through its trade side.',
    },
    {
        name: 'DividendInitialRate',
        abbrName: 'InitRt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 42231,
        description:
            'The initial floating rate reset agreed between the principal parties involved in the trade. This is assumed to be the first required reset rate for the first regular calculation period. It should only be included when the rate is not equal to the rate published on the source implied by the floating rate index. The initial rate is expressed in decimal form, e.g. 5% is represented as "0.05".',
    },
    {
        name: 'DividendFinalRateRoundingDirection',
        abbrName: 'FnlRtRndDirctn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'RoundingDirectionCodeSet',
        id: 42232,
        description: 'Specifies the rounding direction of the final rate.',
    },
    {
        name: 'DividendFinalRatePrecision',
        abbrName: 'FnlRtPrcsn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42233,
        description:
            'Specifies the rounding precision of the final rate in terms of a number of decimal places. Note how a percentage rate rounding of 5 decimal places is expressed as a rounding precision of 7.',
    },
    {
        name: 'DividendAveragingMethod',
        abbrName: 'AvgngMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamAveragingMethodCodeSet',
        id: 42234,
        description:
            'When averaging is applicable, used to specify whether a weighted or unweighted average method of calculation is to be used.',
    },
    {
        name: 'DividendNegativeRateTreatment',
        abbrName: 'NegtvRtTrtmt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamNegativeRateTreatmentCodeSet',
        id: 42235,
        description:
            'The specification of any provisions for calculating payment obligations when a floating rate is negative (either due to a quoted negative floating rate or by operation of a spread that is subtracted from the floating rate).',
    },
    {
        name: 'NoDividendAccrualPaymentDateBusinessCenters',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42236,
        description: 'Number of entries in the DividendAccrualPaymentDateBusinessCenterGrp.',
    },
    {
        name: 'DividendAccrualPaymentDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42237,
        description:
            'The business center calendar used for date adjustment of the instrument\'s dividend accrual payment date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'DividendAccrualPaymentDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42238,
        description:
            'Specifies the anchor date when the accrual payment date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'DividendAccrualPaymentDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42239,
        description: 'Time unit multiplier for the relative accrual payment date offset.',
    },
    {
        name: 'DividendAccrualPaymentDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42240,
        description: 'Time unit associated with the relative accrual payment date offset.',
    },
    {
        name: 'DividendAccrualPaymentDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42241,
        description: 'Specifies the day type of the relative accrual payment date offset.',
    },
    {
        name: 'DividendAccrualPaymentDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42242,
        description: 'The unadjusted accrual payment date.',
    },
    {
        name: 'DividendAccrualPaymeentDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 42243,
        description: 'Accrual payment date adjustment business day convention.',
    },
    {
        name: 'DividendAccrualPaymentDateAdjusted',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42244,
        description: 'The adjusted accrual payment date.',
    },
    {
        name: 'DividendReinvestmentIndicator',
        abbrName: 'RnvstmntInd',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42245,
        description: 'Indicates whether the dividend will be reinvested.',
    },
    {
        name: 'DividendEntitlementEvent',
        abbrName: 'EntlmntEvnt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'DividendEntitlementEventCodeSet',
        id: 42246,
        description: 'Defines the contract event which the receiver of the derivative is entitled to the dividend.',
    },
    {
        name: 'DividendAmountType',
        abbrName: 'AmtTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'DividendAmountTypeCodeSet',
        id: 42247,
        description: 'Indicates how the gross cash dividend amount per share is determined.',
    },
    {
        name: 'DividendUnderlierRefID',
        abbrName: 'UndlrRefID',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42248,
        description:
            "References the dividend underlier through the instrument's UnderlyingSecurityID(309) which must be fully specified in an instance of the UnderlyingInstrument component.",
    },
    {
        name: 'ExtraordinaryDividendPartySide',
        abbrName: 'ExtrordSide',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamCapRateBuySideCodeSet',
        id: 42249,
        description:
            'Reference to the party through its side in the trade who makes the determination whether dividends are extraordinary in relation to normal levels.',
    },
    {
        name: 'ExtraordinaryDividendAmountType',
        abbrName: 'ExtrordAmtTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'DividendAmountTypeCodeSet',
        id: 42250,
        description: 'Indicates how the extraordinary gross cash dividend per share is determined.',
    },
    {
        name: 'ExtraordinaryDividendCurrency',
        abbrName: 'ExtrordCcy',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 42251,
        description: 'The currency in which the excess dividend is denominated. Uses ISO 4217 currency codes.',
    },
    {
        name: 'ExtraordinaryDividendDeterminationMethod',
        abbrName: 'ExtrordDtrmnMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42252,
        description:
            'Specifies the method in which the excess amount is determined.\n\nSee http://www.fpml.org/coding-scheme/determination-method for values.',
    },
    {
        name: 'DividendAccrualFixedRate',
        abbrName: 'AcrlFixedRt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 42253,
        description:
            'The dividend accrual fixed rate per annum expressed as a decimal.\n\nA value of 5% would be represented as "0.05".',
    },
    {
        name: 'DividendCompoundingMethod',
        abbrName: 'CmpndgMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamCompoundingMethodCodeSet',
        id: 42254,
        description:
            'The compounding method to be used when more than one dividend period contributes to a single payment.',
    },
    {
        name: 'DividendNumOfIndexUnits',
        abbrName: 'NumNdxUnits',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42255,
        description: 'The number of index units applicable to dividends.',
    },
    {
        name: 'DividendCashPercentage',
        abbrName: 'CshPctage',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 42256,
        description: 'Declared cash dividend percentage.\n\nA value of 5% would be represented as "0.05".',
    },
    {
        name: 'DividendCashEquivalentPercentage',
        abbrName: 'CshEqvlntPctage',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 42257,
        description: 'Declared cash-equivalent dividend percentage.\n\nA value of 5% would be represented as "0.05".',
    },
    {
        name: 'NonCashDividendTreatment',
        abbrName: 'NonCshTrtmt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NonCashDividendTreatmentCodeSet',
        id: 42258,
        description: 'Defines the treatment of non-cash dividends.',
    },
    {
        name: 'DividendComposition',
        abbrName: 'Cmpstn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'DividendCompositionCodeSet',
        id: 42259,
        description: 'Defines how the composition of dividends is to be determined.',
    },
    {
        name: 'SpecialDividendsIndicator',
        abbrName: 'SpeclDividendInd',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42260,
        description: 'Indicates whether special dividends are applicable.',
    },
    {
        name: 'MaterialDividendsIndicator',
        abbrName: 'MtrlDividendInd',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42261,
        description: 'Indicates whether material non-cash dividends are applicable.',
    },
    {
        name: 'OptionsExchangeDividendsIndicator',
        abbrName: 'ExchDividendInd',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42262,
        description: 'Indicates whether option exchange dividends are applicable.',
    },
    {
        name: 'AdditionalDividendsIndicator',
        abbrName: 'AddtnlDividendInd',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42263,
        description: 'Indicates whether additional dividends are applicable.',
    },
    {
        name: 'AllDividendsIndicator',
        abbrName: 'AllDividendInd',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42264,
        description:
            "Represents the European Master Confirmation value of 'All Dividends' which, when applicable, signifies that, for a given Ex-Date, the daily observed share price for that day is adjusted (reduced) by the cash dividend and/or the cash value of any non-cash dividend per share (including extraordinary dividends) declared by the issuer.",
    },
    {
        name: 'DividendFXTriggerDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42265,
        description:
            'Specifies the anchor date when the FX trigger date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'DividendFXTriggerDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42266,
        description: 'Time unit multiplier for the relative FX trigger date offset.',
    },
    {
        name: 'DividendFXTriggerDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42267,
        description: 'Time unit associated with the relative FX trigger date offset.',
    },
    {
        name: 'DividendFXTriggerDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42268,
        description: 'Specifies the day type of the relative FX trigger date offset.',
    },
    {
        name: 'DividendFXTriggerDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42269,
        description: 'The unadjusted FX trigger date.',
    },
    {
        name: 'DividendFXTriggerDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 42270,
        description: 'The business day convention used for the FX trigger date adjustment.',
    },
    {
        name: 'DividendFXTriggerDateAdjusted',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42271,
        description: 'The adjusted FX trigger date.',
    },
    {
        name: 'NoDividendFXTriggerDateBusinessCenters',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42272,
        description: 'Number of entries in the DividendFXTriggerDateBusinessCenterGrp.',
    },
    {
        name: 'DividendFXTriggerDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42273,
        description:
            'The business center calendar used for date adjustment of the instrument\'s FX trigger date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'NoDividendPeriods',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42274,
        description: 'Number of entries in the DividendPeriodGrp component.',
    },
    {
        name: 'DividendPeriodSequence',
        abbrName: 'Seq',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42275,
        description: 'Defines the ordinal dividend period. E.g. 1 = First period, 2 = Second period, etc.',
    },
    {
        name: 'DividendPeriodStartDateUnadjusted',
        abbrName: 'StartDtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42276,
        description: 'The unadjusted date on which the dividend period will begin.',
    },
    {
        name: 'DividendPeriodEndDateUnadjusted',
        abbrName: 'EndDtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42277,
        description: 'The unadjusted date on which the dividend period will end.',
    },
    {
        name: 'DividendPeriodUnderlierRefID',
        abbrName: 'UndlrRefID',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42278,
        description:
            "References the dividend underlier through the instrument's UnderlyingSecurityID(309) which must be fully specified in an instance of the UnderlyingInstrument component.",
    },
    {
        name: 'DividendPeriodStrikePrice',
        abbrName: 'StrkPx',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 42279,
        description: 'Specifies the fixed strike price of the dividend period.',
    },
    {
        name: 'DividendPeriodBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 42280,
        description: 'The dividend period dates business day convention.',
    },
    {
        name: 'DividendPeriodValuationDateUnadjusted',
        abbrName: 'ValDtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42281,
        description: 'The unadjusted dividend period valuation date.',
    },
    {
        name: 'DividendPeriodValuationDateRelativeTo',
        abbrName: 'ValDtReltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42282,
        description:
            'Specifies the anchor date when the dividend period valuation date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'DividendPeriodValuationDateOffsetPeriod',
        abbrName: 'ValDtOfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42283,
        description: 'Time unit multiplier for the relative dividend period valuation date offset.',
    },
    {
        name: 'DividendPeriodValuationDateOffsetUnit',
        abbrName: 'ValDtOfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42284,
        description: 'Time unit associated with the relative dividend period valuation date offset.',
    },
    {
        name: 'DividendPeriodValuationDateOffsetDayType',
        abbrName: 'ValDtOfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42285,
        description: 'Specifies the day type of the relative dividend period valuation date offset.',
    },
    {
        name: 'DividendPeriodValuationDateAdjusted',
        abbrName: 'ValDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42286,
        description: 'The adjusted dividend period valuation date.',
    },
    {
        name: 'DividendPeriodPaymentDateUnadjusted',
        abbrName: 'PmtDtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42287,
        description: 'The unadjusted dividend period payment date.',
    },
    {
        name: 'DividendPeriodPaymentDateRelativeTo',
        abbrName: 'PmtDtReltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42288,
        description:
            'Specifies the anchor date when the dividend period payment date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'DividendPeriodPaymentDateOffsetPeriod',
        abbrName: 'PmtDtOfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42289,
        description: 'Time unit multiplier for the relative dividend period payment date offset.',
    },
    {
        name: 'DividendPeriodPaymentDateOffsetUnit',
        abbrName: 'PmtDtOfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42290,
        description: 'Time unit associated with the relative dividend period payment date offset.',
    },
    {
        name: 'DividendPeriodPaymentDateOffsetDayType',
        abbrName: 'PmtDtOfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42291,
        description: 'Specifies the day type of the relative dividend period payment date offset.',
    },
    {
        name: 'DividendPeriodPaymentDateAdjusted',
        abbrName: 'PmtDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42292,
        description: 'The adjusted dividend period payment date.',
    },
    {
        name: 'DividendPeriodXID',
        abbrName: 'XID',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'XID',
        id: 42293,
        description:
            'Identifier for linking this stream dividend period to an underlier through an instance of RelatedInstrumentGrp.',
    },
    {
        name: 'NoDividendPeriodBusinessCenters',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42294,
        description: 'Number of entries in the DividendPeriodBusinessCenterGrp.',
    },
    {
        name: 'DividendPeriodBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42295,
        description:
            'The business center calendar used for date adjustment of the instrument\'s dividend period date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'NoExtraordinaryEvents',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42296,
        description: 'Number of extraordinary events in the repeating group.',
    },
    {
        name: 'ExtraordinaryEventType',
        abbrName: 'Typ',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42297,
        description:
            'Identifies the type of extraordinary or disruptive event applicable to the reference entity.\n\nSee http://www.fixtradingcommunity.org/codelists#Extraordinary_Event_Type for code list of extraordinary event types and values.',
    },
    {
        name: 'ExtraordinaryEventValue',
        abbrName: 'Val',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42298,
        description:
            'The extraordinary or disruptive event value appropriate to ExtraordinaryEventType(42297).\n\nSee http://www.fixtradingcommunity.org/codelists#Extraordinary_Event_Type for code list of extraordinary event types and values.',
    },
    {
        name: 'StrikeIndexCurvePoint',
        abbrName: 'StrkNdxPnt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2600,
        description:
            'The point on the floating rate index curve. Sample values:\n\nM = combination of a number between 1-12 and an "M" for month, e.g. 3M\n\nY = combination of number between 1-100 and a "Y" for year, e.g. 10Y\n\n10Y-OLD = see above, then add "-OLD" when appropriate\n\nINTERPOLATED = the point is mathematically derived\n\n2/2031 5 3/8 = the point is stated via a combination of maturity month / year and coupon.',
    },
    {
        name: 'StrikeIndexQuote',
        abbrName: 'StrkNdxQte',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'StrikeIndexQuoteCodeSet',
        id: 2601,
        description: 'The quote side from which the index price is to be determined.',
    },
    {
        name: 'ExtraordinaryEventAdjustmentMethod',
        abbrName: 'ExtrordEvntAdjMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'ExtraordinaryEventAdjustmentMethodCodeSet',
        id: 2602,
        description:
            'Defines how adjustments will be made to the contract should one or more of the extraordinary events occur.',
    },
    {
        name: 'ExchangeLookAlike',
        abbrName: 'ExchLookAlike',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2603,
        description:
            "For a share option trade, indicates whether the instrument is to be treated as an 'exchange look-alike'.\n\nThis designation has significance for how share adjustments (arising from corporate actions) will be determined for the instrument. For an 'exchange look-alike' instrument the relevant share adjustments will follow that for a corresponding designated contract listed on the related exchange (referred to as Options Exchange Adjustment (ISDA defined term)), otherwise the share adjustments will be determined by the calculation agent (referred to as Calculation Agent Adjustment (ISDA defined term)).",
    },
    {
        name: 'LegStrikeIndexCurvePoint',
        abbrName: 'StrkNdxPnt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2604,
        description:
            'The point on the floating rate index curve. Sample values:\n\nM = combination of a number between 1-12 and an "M" for month, e.g. 3M\n\nY = combination of number between 1-100 and a "Y" for year, e.g. 10Y\n\n10Y-OLD = see above, then add "-OLD" when appropriate\n\nINTERPOLATED = the point is mathematically derived\n\n2/2031 5 3/8 = the point is stated via a combination of maturity month / year and coupon.',
    },
    {
        name: 'LegStrikeIndexQuote',
        abbrName: 'StrkNdxQte',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'StrikeIndexQuoteCodeSet',
        id: 2605,
        description: 'The quote side from which the index price is to be determined.',
    },
    {
        name: 'LegExtraordinaryEventAdjustmentMethod',
        abbrName: 'ExtrordEvntAdjMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'ExtraordinaryEventAdjustmentMethodCodeSet',
        id: 2606,
        description:
            'Defines how adjustments will be made to the contract should one or more of the extraordinary events occur.',
    },
    {
        name: 'LegExchangeLookAlike',
        abbrName: 'ExchLookAlike',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2607,
        description:
            "For a share option trade, indicates whether the instrument is to be treated as an 'exchange look-alike'.\n\nThis designation has significance for how share adjustments (arising from corporate actions) will be determined for the instrument. For an 'exchange look-alike' instrument the relevant share adjustments will follow that for a corresponding designated contract listed on the related exchange (referred to as Options Exchange Adjustment (ISDA defined term)), otherwise the share adjustments will be determined by the calculation agent (referred to as Calculation Agent Adjustment (ISDA defined term)).",
    },
    {
        name: 'LegCashSettlDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42299,
        description: 'The unadjusted cash settlement date.',
    },
    {
        name: 'LegCashSettlDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 42300,
        description:
            "The business day convention used to adjust the cash settlement provision's date. Used only to override the business day convention defined in the InstrumentLeg component.",
    },
    {
        name: 'LegCashSettlDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42301,
        description:
            'Specifies the anchor date when the cash settlement date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'LegCashSettlDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42302,
        description: 'Time unit multiplier for the relative cash settlement date offset.',
    },
    {
        name: 'LegCashSettlDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42303,
        description: 'Time unit associated with the relative cash settlement date offset.',
    },
    {
        name: 'LegCashSettlDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42304,
        description: 'Specifies the day type of the relative cash settlement date offset.',
    },
    {
        name: 'LegCashSettlDateAdjusted',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42305,
        description: 'The adjusted cash settlement date.',
    },
    {
        name: 'NoLegCashSettlDateBusinessCenters',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42306,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'LegCashSettlDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42307,
        description:
            'The business center calendar used for date adjustment of the cash settlement unadjusted or relative date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegCashSettlPriceSource',
        abbrName: 'PxSrc',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42308,
        description:
            'The source from which the settlement price is to be obtained.\n\nSee http://www.fpml.org/coding-scheme/settlement-price-source for values.',
    },
    {
        name: 'LegCashSettlPriceDefault',
        abbrName: 'PxDflt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'CashSettlPriceDefaultCodeSet',
        id: 42309,
        description: 'The default election for determining settlement price.',
    },
    {
        name: 'LegComplexEventFuturesPriceValuation',
        abbrName: 'FutPxVal',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2608,
        description:
            'Indicates whether the official settlement price as announced by the related exchange is applicable, in accordance with the ISDA 2002 definitions. Applicable only to futures contracts.',
    },
    {
        name: 'LegComplexEventOptionsPriceValuation',
        abbrName: 'OptPxVal',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2609,
        description:
            'Indicates whether the official settlement price as announced by the related exchange is applicable, in accordance with the ISDA 2002 definitions. Applicable only to options contracts.',
    },
    {
        name: 'LegComplexEventPVFinalPriceElectionFallback',
        abbrName: 'PVPxFallbck',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventPVFinalPriceElectionFallbackCodeSet',
        id: 2610,
        description:
            'Specifies the fallback provisions for the hedging party in the determination of the final settlement price',
    },
    {
        name: 'NoLegDividendAccrualPaymentDateBusinessCenters',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42310,
        description: 'Number of entries in the LegDividendAccrualPaymentDateBusinessCenterGrp.',
    },
    {
        name: 'LegDividendAccrualPaymentDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42311,
        description:
            'The business center calendar used for date adjustment of the instrument\'s dividend accrual payment date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegDividendFloatingRateIndex',
        abbrName: 'Ndx',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42312,
        description: 'The dividend accrual floating rate index.',
    },
    {
        name: 'LegDividendFloatingRateIndexCurvePeriod',
        abbrName: 'NdxPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42313,
        description: 'Time unit multiplier for the dividend accrual floating rate index curve.',
    },
    {
        name: 'LegDividendFloatingRateIndexCurveUnit',
        abbrName: 'NdxUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexCurveUnitCodeSet',
        id: 42314,
        description: 'Time unit associated with the dividend accrual floating rate index curve period.',
    },
    {
        name: 'LegDividendFloatingRateMultiplier',
        abbrName: 'RtMult',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 42315,
        description:
            'A rate multiplier to apply to the floating rate. The multiplier can be less than or greater than 1 (one). This should only be included if the multiplier is not equal to 1 (one) for the term of the contract.',
    },
    {
        name: 'LegDividendFloatingRateSpread',
        abbrName: 'Spread',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 42316,
        description: 'The basis points spread from the index specified in LegDividendFloatingRateIndex(42312).',
    },
    {
        name: 'LegDividendFloatingRateSpreadPositionType',
        abbrName: 'SpreadPosTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
        id: 42317,
        description: 'Identifies whether the rate spread is applied to a long or short position.',
    },
    {
        name: 'LegDividendFloatingRateTreatment',
        abbrName: 'RtTrtmt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateTreatmentCodeSet',
        id: 42318,
        description: 'Specifies the yield calculation treatment for the index.',
    },
    {
        name: 'LegDividendCapRate',
        abbrName: 'CapRt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 42319,
        description:
            'The cap rate, if any, which applies to the floating rate. It is only required where the floating rate is capped at a certain level. The cap rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A cap rate of 5% would be represented as "0.05".',
    },
    {
        name: 'LegDividendCapRateBuySide',
        abbrName: 'CapRtBuy',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamCapRateBuySideCodeSet',
        id: 42320,
        description: 'Reference to the buyer of the cap rate option through its trade side.',
    },
    {
        name: 'LegDividendCapRateSellSide',
        abbrName: 'CapRtSell',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamCapRateBuySideCodeSet',
        id: 42321,
        description: 'Reference to the seller of the cap rate option through its trade side.',
    },
    {
        name: 'LegDividendFloorRate',
        abbrName: 'FlrRt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 42322,
        description:
            'The floor rate, if any, which applies to the floating rate. The floor rate (strike) is only required where the floating rate is floored at a certain strike level. The floor rate is assumed to be exclusive of any spread and is a per annum rate. The rate is expressed as a decimal, e.g. 5% is represented as "0.05".',
    },
    {
        name: 'LegDividendFloorRateBuySide',
        abbrName: 'FlrRtBuy',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamFloorRateBuySideCodeSet',
        id: 42323,
        description: 'Reference to the buyer of the floor rate option through its trade side.',
    },
    {
        name: 'LegDividendFloorRateSellSide',
        abbrName: 'FlrRtSell',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamFloorRateBuySideCodeSet',
        id: 42324,
        description: 'Reference to the seller of the floor rate option through its trade side.',
    },
    {
        name: 'LegDividendInitialRate',
        abbrName: 'InitRt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 42325,
        description:
            'The initial floating rate reset agreed between the principal parties involved in the trade. This is assumed to be the first required reset rate for the first regular calculation period. It should only be included when the rate is not equal to the rate published on the source implied by the floating rate index. The initial rate is expressed in decimal form, e.g. 5% is represented as "0.05".',
    },
    {
        name: 'LegDividendFinalRateRoundingDirection',
        abbrName: 'FnlRtRndDirctn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'RoundingDirectionCodeSet',
        id: 42326,
        description: 'Specifies the rounding direction of the final rate.',
    },
    {
        name: 'LegDividendFinalRatePrecision',
        abbrName: 'FnlRtPrcsn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42327,
        description:
            'Specifies the rounding precision of the final rate in terms of a number of decimal places. Note how a percentage rate rounding of 5 decimal places is expressed as a rounding precision of 7.',
    },
    {
        name: 'LegDividendAveragingMethod',
        abbrName: 'AvgngMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamAveragingMethodCodeSet',
        id: 42328,
        description:
            'When averaging is applicable, used to specify whether a weighted or unweighted average method of calculation is to be used.',
    },
    {
        name: 'LegDividendNegativeRateTreatment',
        abbrName: 'NegtvRtTrtmt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamNegativeRateTreatmentCodeSet',
        id: 42329,
        description:
            'The specification of any provisions for calculating payment obligations when a floating rate is negative (either due to a quoted negative floating rate or by operation of a spread that is subtracted from the floating rate).',
    },
    {
        name: 'LegDividendAccrualPaymentDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42330,
        description:
            'Specifies the anchor date when the accrual payment date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'LegDividendAccrualPaymentDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42331,
        description: 'Time unit multiplier for the relative accrual payment date offset.',
    },
    {
        name: 'LegDividendAccrualPaymentDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42332,
        description: 'Time unit associated with the relative accrual payment date offset.',
    },
    {
        name: 'LegDividendAccrualPaymentDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42333,
        description: 'Specifies the day type of the relative accrual payment date offset.',
    },
    {
        name: 'LegDividendAccrualPaymentDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42334,
        description: 'The unadjusted accrual payment date.',
    },
    {
        name: 'LegDividendAccrualPaymentDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 42335,
        description: 'Accrual payment date adjustment business day convention.',
    },
    {
        name: 'LegDividendAccrualPaymentDateAdjusted',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42336,
        description: 'The adjusted accrual payment date.',
    },
    {
        name: 'LegDividendReinvestmentIndicator',
        abbrName: 'RnvstmntInd',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42337,
        description: 'Indicates whether the dividend will be reinvested.',
    },
    {
        name: 'LegDividendEntitlementEvent',
        abbrName: 'EntlmntEvnt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'DividendEntitlementEventCodeSet',
        id: 42338,
        description: 'Defines the contract event which the receiver of the derivative is entitled to the dividend.',
    },
    {
        name: 'LegDividendAmountType',
        abbrName: 'AmtTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'DividendAmountTypeCodeSet',
        id: 42339,
        description: 'Indicates how the gross cash dividend amount per share is determined.',
    },
    {
        name: 'LegDividendUnderlierRefID',
        abbrName: 'UndlrRefID',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42340,
        description:
            "References the dividend underlier through the instrument's UnderlyingSecurityID(309) which must be fully specified in an instance of the UnderlyingInstrument component.",
    },
    {
        name: 'LegExtraordinaryDividendPartySide',
        abbrName: 'ExtrordSide',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamCapRateBuySideCodeSet',
        id: 42341,
        description:
            'Reference to the party through its side in the trade who makes the determination whether dividends are extraordinary in relation to normal levels.',
    },
    {
        name: 'LegExtraordinaryDividendAmountType',
        abbrName: 'ExtrordAmtTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'DividendAmountTypeCodeSet',
        id: 42342,
        description: 'Indicates how the extraordinary gross cash dividend per share is determined.',
    },
    {
        name: 'LegExtraordinaryDividendCurrency',
        abbrName: 'ExtrordCcy',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 42343,
        description: 'The currency in which the excess dividend is denominated. Uses ISO 4217 currency codes.',
    },
    {
        name: 'LegExtraordinaryDividendDeterminationMethod',
        abbrName: 'ExtrordDtrmnMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42344,
        description:
            'Specifies the method in which the excess amount is determined.\n\nSee http://www.fpml.org/coding-scheme/determination-method for values.',
    },
    {
        name: 'LegDividendAccrualFixedRate',
        abbrName: 'AcrlFixedRt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 42345,
        description:
            'The dividend accrual fixed rate per annum expressed as a decimal.\n\nA value of 5% would be represented as "0.05".',
    },
    {
        name: 'LegDividendCompoundingMethod',
        abbrName: 'CmpndgMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamCompoundingMethodCodeSet',
        id: 42346,
        description:
            'The compounding method to be used when more than one dividend period contributes to a single payment.',
    },
    {
        name: 'LegDividendNumOfIndexUnits',
        abbrName: 'NumNdxUnits',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42347,
        description: 'The number of index units applicable to dividends.',
    },
    {
        name: 'LegDividendCashPercentage',
        abbrName: 'CshPctage',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 42348,
        description: 'Declared cash dividend percentage.\n\nA value of 5% would be represented as "0.05".',
    },
    {
        name: 'LegDividendCashEquivalentPercentage',
        abbrName: 'CshEqvlntPctage',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 42349,
        description: 'Declared cash-equivalent dividend percentage.\n\nA value of 5% would be represented as "0.05".',
    },
    {
        name: 'LegNonCashDividendTreatment',
        abbrName: 'NonCshTrtmt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NonCashDividendTreatmentCodeSet',
        id: 42350,
        description: 'Defines the treatment of non-cash dividends.',
    },
    {
        name: 'LegDividendComposition',
        abbrName: 'Cmpstn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'DividendCompositionCodeSet',
        id: 42351,
        description: 'Defines how the composition of dividends is to be determined.',
    },
    {
        name: 'LegSpecialDividendsIndicator',
        abbrName: 'SpeclDividendInd',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42352,
        description: 'Indicates whether special dividends are applicable.',
    },
    {
        name: 'LegMaterialDividendsIndicator',
        abbrName: 'MtrlDividendInd',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42353,
        description: 'Indicates whether material non-cash dividends are applicable.',
    },
    {
        name: 'LegOptionsExchangeDividendsIndicator',
        abbrName: 'ExchDividendInd',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42354,
        description: 'Indicates whether option exchange dividends are applicable.',
    },
    {
        name: 'LegAdditionalDividendsIndicator',
        abbrName: 'AddtnlDividendInd',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42355,
        description: 'Indicates whether additional dividends are applicable.',
    },
    {
        name: 'LegAllDividendsIndicator',
        abbrName: 'AllDividendInd',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42356,
        description:
            "Represents the European Master Confirmation value of 'All Dividends' which, when applicable, signifies that, for a given Ex-Date, the daily observed share price for that day is adjusted (reduced) by the cash dividend and/or the cash value of any non-cash dividend per share (including extraordinary dividends) declared by the issuer.",
    },
    {
        name: 'LegDividendFXTriggerDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42357,
        description:
            'Specifies the anchor date when the FX trigger date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'LegDividendFXTriggerDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42358,
        description: 'Time unit multiplier for the relative FX trigger date offset.',
    },
    {
        name: 'LegDividendFXTriggerDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42359,
        description: 'Time unit associated with the relative FX trigger date offset.',
    },
    {
        name: 'LegDividendFXTriggerDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42360,
        description: 'Specifies the day type of the relative FX trigger date offset.',
    },
    {
        name: 'LegDividendFXTriggerDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42361,
        description: 'The unadjusted FX trigger date.',
    },
    {
        name: 'LegDividendFXTriggerDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 42362,
        description: 'The business day convention used for the FX trigger date adjustment.',
    },
    {
        name: 'LegDividendFXTriggerDateAdjusted',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42363,
        description: 'The adjusted FX trigger date.',
    },
    {
        name: 'NoLegDividendFXTriggerDateBusinessCenters',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42364,
        description: 'Number of entries in the LegDividendFXTriggerDateBusinessCenterGrp.',
    },
    {
        name: 'LegDividendFXTriggerDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42365,
        description:
            'The business center calendar used for date adjustment of the instrument\'s FX trigger date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'NoLegDividendPeriods',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42366,
        description: 'Number of entries in the LegDividendPeriodGrp component.',
    },
    {
        name: 'LegDividendPeriodSequence',
        abbrName: 'Seq',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42367,
        description: 'Defines the ordinal dividend period. E.g. 1 = First period, 2 = Second period, etc.',
    },
    {
        name: 'LegDividendPeriodStartDateUnadjusted',
        abbrName: 'StartDtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42368,
        description: 'The unadjusted date on which the dividend period will begin.',
    },
    {
        name: 'LegDividendPeriodEndDateUnadjusted',
        abbrName: 'EndDtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42369,
        description: 'The unadjusted date on which the dividend period will end.',
    },
    {
        name: 'LegDividendPeriodUnderlierRefID',
        abbrName: 'UndlrRefID',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42370,
        description:
            "References the dividend underlier through the instrument's UnderlyingSecurityID(309) which must be fully specified in an instance of the UnderlyingInstrument component.",
    },
    {
        name: 'LegDividendPeriodStrikePrice',
        abbrName: 'StrkPx',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 42371,
        description: 'Specifies the fixed strike price of the dividend period.',
    },
    {
        name: 'LegDividendPeriodBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 42372,
        description: 'The dividend period dates business day convention.',
    },
    {
        name: 'LegDividendPeriodValuationDateUnadjusted',
        abbrName: 'ValDtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42373,
        description: 'The unadjusted dividend period valuation date.',
    },
    {
        name: 'LegDividendPeriodValuationDateRelativeTo',
        abbrName: 'ValDtReltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42374,
        description:
            'Specifies the anchor date when the dividend period valuation date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'LegDividendPeriodValuationDateOffsetPeriod',
        abbrName: 'ValDtOfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42375,
        description: 'Time unit multiplier for the relative dividend period valuation date offset.',
    },
    {
        name: 'LegDividendPeriodValuationDateOffsetUnit',
        abbrName: 'ValDtOfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42376,
        description: 'Time unit associated with the relative dividend period valuation date offset.',
    },
    {
        name: 'LegDividendPeriodValuationDateOffsetDayType',
        abbrName: 'ValDtOfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42377,
        description: 'Specifies the day type of the relative dividend period valuation date offset.',
    },
    {
        name: 'LegDividendPeriodValuationDateAdjusted',
        abbrName: 'ValDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42378,
        description: 'The adjusted dividend period valuation date.',
    },
    {
        name: 'LegDividendPeriodPaymentDateUnadjusted',
        abbrName: 'PmtDtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42379,
        description: 'The unadjusted dividend period payment date.',
    },
    {
        name: 'LegDividendPeriodPaymentDateRelativeTo',
        abbrName: 'PmtDtReltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42380,
        description:
            'Specifies the anchor date when the dividend period payment date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'LegDividendPeriodPaymentDateOffsetPeriod',
        abbrName: 'PmtDtOfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42381,
        description: 'Time unit multiplier for the relative dividend period payment date offset.',
    },
    {
        name: 'LegDividendPeriodPaymentDateOffsetUnit',
        abbrName: 'PmtDtOfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42382,
        description: 'Time unit associated with the relative dividend period payment date offset.',
    },
    {
        name: 'LegDividendPeriodPaymentDateOffsetDayType',
        abbrName: 'PmtDtOfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42383,
        description: 'Specifies the day type of the relative dividend period payment date offset.',
    },
    {
        name: 'LegDividendPeriodPaymentDateAdjusted',
        abbrName: 'PmtDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42384,
        description: 'The adjusted dividend period payment date.',
    },
    {
        name: 'LegDividendPeriodXID',
        abbrName: 'XID',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'XID',
        id: 42385,
        description:
            'Identifier for linking this stream dividend period to an underlier through an instance of RelatedInstrumentGrp.',
    },
    {
        name: 'NoLegDividendPeriodBusinessCenters',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42386,
        description: 'The number of entries in the LegDividendPeriodBusinessCentersGrp component.',
    },
    {
        name: 'LegDividendPeriodBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42387,
        description:
            'The business center calendar used for date adjustment of the instrument\'s dividend period date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'NoLegExtraordinaryEvents',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42388,
        description: 'Number of extraordinary events in the repeating group.',
    },
    {
        name: 'LegExtraordinaryEventType',
        abbrName: 'Typ',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42389,
        description:
            'Identifies the type of extraordinary or disruptive event applicable to the reference entity.\n\nSee http://www.fixtradingcommunity.org/codelists#Extraordinary_Event_Type for code list of extraordinary event types and values.',
    },
    {
        name: 'LegExtraordinaryEventValue',
        abbrName: 'Val',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42390,
        description:
            'The extraordinary or disruptive event value appropriate to LegExtraordinaryEventType(42389).\n\nSee http://www.fixtradingcommunity.org/codelists#Extraordinary_Event_Type for code list of extraordinary event types and values.',
    },
    {
        name: 'LegSettlMethodElectingPartySide',
        abbrName: 'SettlMethElctngSide',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentPaySideCodeSet',
        id: 42391,
        description: 'Side value of the party electing the settlement method.',
    },
    {
        name: 'LegMakeWholeDate',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42392,
        description: 'The date through which option cannot be exercised without penalty.',
    },
    {
        name: 'LegMakeWholeAmount',
        abbrName: 'Amt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 42393,
        description:
            'Amount to be paid by the buyer of the option if the option is exercised prior to the LegMakeWholeDate(42392).',
    },
    {
        name: 'LegMakeWholeBenchmarkCurveName',
        abbrName: 'Name',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42394,
        description: 'Identifies the benchmark floating rate index.',
    },
    {
        name: 'LegMakeWholeBenchmarkCurvePoint',
        abbrName: 'Point',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42395,
        description:
            'The point on the floating rate index curve.\n\nSample values:\n\nM = combination of a number between 1-12 and an "M" for month, e.g. 3M\n\nY = combination of number between 1-100 and a "Y" for year, e.g. 10Y\n\n10Y-OLD = see above, then add "-OLD" when appropriate\n\nINTERPOLATED = the point is mathematically derived\n\n2/2031 5 3/8 = the point is stated via a combination of maturity month / year and coupon.',
    },
    {
        name: 'LegMakeWholeRecallSpread',
        abbrName: 'Spread',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 42396,
        description: 'Spread over the floating rate index.',
    },
    {
        name: 'LegMakeWholeBenchmarkQuote',
        abbrName: 'Qte',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'StrikeIndexQuoteCodeSet',
        id: 42397,
        description: 'The quote side of the benchmark to be used for calculating the "make whole" amount.',
    },
    {
        name: 'LegMakeWholeInterpolationMethod',
        abbrName: 'IntrpltnMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamInflationInterpolationMethodCodeSet',
        id: 42398,
        description: 'The method used when calculating the "make whole" amount. The most common is linear method.',
    },
    {
        name: 'LegPaymentStreamCashSettlIndicator',
        abbrName: 'CshSettlInd',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42399,
        description: 'Indicates whether cash settlement is applicable.',
    },
    {
        name: 'LegPaymentStreamCompoundingXIDRef',
        abbrName: 'CmpndgXIDRef',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'XIDREF',
        id: 42400,
        description: 'Reference to the stream which details the compounding fixed or floating rate.',
    },
    {
        name: 'LegPaymentStreamCompoundingSpread',
        abbrName: 'CmpndgSpread',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 42401,
        description:
            'The spread to be used for compounding. Used in scenarios where the interest payment is based on a compounding formula that uses a compounding spread in addition to the regular spread.',
    },
    {
        name: 'LegPaymentStreamInterpolationMethod',
        abbrName: 'IntrpltnMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamInflationInterpolationMethodCodeSet',
        id: 42402,
        description:
            'The method used when calculating the index rate from multiple points on the curve. The most common is linear method.',
    },
    {
        name: 'LegPaymentStreamInterpolationPeriod',
        abbrName: 'IntrpltnPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamInterpolationPeriodCodeSet',
        id: 42403,
        description: 'Defines applicable periods for interpolation.',
    },
    {
        name: 'LegPaymentStreamCompoundingFixedRate',
        abbrName: 'CmpndgFixedRt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 42404,
        description: 'The compounding fixed rate applicable to the payment stream.',
    },
    {
        name: 'NoLegPaymentStreamCompoundingDates',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42405,
        description: 'Number of dates in the repeating group.',
    },
    {
        name: 'LegPaymentStreamCompoundingDate',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42406,
        description: 'The compounding date. Type of date is specified in LegPaymentStreamCompoundingDateType(42407).',
    },
    {
        name: 'LegPaymentStreamCompoundingDateType',
        abbrName: 'Typ',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NonDeliverableFixingDateTypeCodeSet',
        id: 42407,
        description: 'Specifies the type of payment compounding date (e.g. adjusted for holidays).',
    },
    {
        name: 'LegPaymentStreamCompoundingDatesBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 42408,
        description: 'The compounding dates business day convention.',
    },
    {
        name: 'LegPaymentStreamCompoundingDatesRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42409,
        description:
            'Specifies the anchor date when the compounding dates are relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'LegPaymentStreamCompoundingDatesOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42410,
        description: 'Time unit multiplier for the relative compounding date offset.',
    },
    {
        name: 'LegPaymentStreamCompoundingDatesOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42411,
        description: 'Time unit associated with the relative compounding date offset.',
    },
    {
        name: 'LegPaymentStreamCompoundingDatesOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42412,
        description: 'Specifies the day type of the relative compounding date offset.',
    },
    {
        name: 'LegPaymentStreamCompoundingPeriodSkip',
        abbrName: 'Skip',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42413,
        description:
            'The number of periods in the "RelativeTo" schedule that are between each date in the compounding schedule. A skip of 2 would mean that compounding dates are relative to every second date in the "RelativeTo" schedule. If present this should have a value greater than 1.',
    },
    {
        name: 'LegPaymentStreamCompoundingFrequencyPeriod',
        abbrName: 'FreqPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42414,
        description: 'Time unit multiplier for the frequency at which compounding dates occur.',
    },
    {
        name: 'LegPaymentStreamCompoundingFrequencyUnit',
        abbrName: 'FreqUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'CouponFrequencyUnitCodeSet',
        id: 42415,
        description: 'Time unit associated with the frequency at which compounding dates occur.',
    },
    {
        name: 'LegPaymentStreamCompoundingRollConvention',
        abbrName: 'Roll',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'DateRollConventionCodeSet',
        id: 42416,
        description:
            'The convention for determining the sequence of compounding dates. It is used in conjunction with a specified frequency.',
    },
    {
        name: 'LegPaymentStreamBoundsFirstDateUnadjusted',
        abbrName: 'FirstDtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42417,
        description:
            'The unadjusted first date of the compounding schedule. This can be used to restrict the range of dates when they are relative.',
    },
    {
        name: 'LegPaymentStreamBoundsLastDateUnadjusted',
        abbrName: 'LastDtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42418,
        description:
            'The unadjusted last date of the compounding schedule. This can be used to restrict the range of dates when they are relative.',
    },
    {
        name: 'NoLegPaymentStreamCompoundingDatesBusinessCenters',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42419,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'LegPaymentStreamCompoundingDatesBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42420,
        description:
            'The business center calendar used for date adjustment of the payment stream compounding dates, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegPaymentStreamCompoundingEndDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42421,
        description: 'The unadjusted compounding end date.',
    },
    {
        name: 'LegPaymentStreamCompoundingEndDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42422,
        description:
            'Specifies the anchor date when the compounding end date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'LegPaymentStreamCompoundingEndDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42423,
        description: 'Time unit multiplier for the relative compounding end date offset.',
    },
    {
        name: 'LegPaymentStreamCompoundingEndDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42424,
        description: 'Time unit associated with the relative compounding end date offset.',
    },
    {
        name: 'LegPaymentStreamCompoundingEndDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42425,
        description: 'Specifies the day type of the relative compounding end date offset.',
    },
    {
        name: 'LegPaymentStreamCompoundingEndDateAdjusted',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42426,
        description: 'The adjusted compounding end date.',
    },
    {
        name: 'LegPaymentStreamCompoundingRateIndex',
        abbrName: 'Ndx',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42427,
        description: "The payment stream's compounding floating rate index.",
    },
    {
        name: 'LegPaymentStreamCompoundingRateIndexCurvePeriod',
        abbrName: 'NdxPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42428,
        description: "Time unit multiplier for the payment stream's compounding floating rate index curve period.",
    },
    {
        name: 'LegPaymentStreamCompoundingRateIndexCurveUnit',
        abbrName: 'NdxUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexCurveUnitCodeSet',
        id: 42429,
        description: "Time unit associated with the payment stream's compounding floating rate index curve period.",
    },
    {
        name: 'LegPaymentStreamCompoundingRateMultiplier',
        abbrName: 'RtMult',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 42430,
        description:
            'A rate multiplier to apply to the compounding floating rate. The multiplier can be less than or greater than 1 (one). This should only be included if the multiplier is not equal to 1 (one) for the term of the stream.',
    },
    {
        name: 'LegPaymentStreamCompoundingRateSpread',
        abbrName: 'Spread',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 42431,
        description: 'The basis points spread from the index specified in LegPaymentStreamCompoundingRateIndex(42427).',
    },
    {
        name: 'LegPaymentStreamCompoundingRateSpreadPositionType',
        abbrName: 'SpreadPosTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
        id: 42432,
        description: 'Identifies whether the rate spread is applied to a long or short position.',
    },
    {
        name: 'LegPaymentStreamCompoundingRateTreatment',
        abbrName: 'RtTrtmt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateTreatmentCodeSet',
        id: 42433,
        description: 'Specifies the yield calculation treatment for the index.',
    },
    {
        name: 'LegPaymentStreamCompoundingCapRate',
        abbrName: 'CapRt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 42434,
        description:
            'The cap rate, if any, which applies to the compounding floating rate. It is only required where the compounding floating rate on a swap stream is capped at a certain level. The cap rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A cap rate of 5% would be represented as "0.05".',
    },
    {
        name: 'LegPaymentStreamCompoundingCapRateBuySide',
        abbrName: 'CapRtBuy',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamCapRateBuySideCodeSet',
        id: 42435,
        description: 'Reference to the buyer of the compounding cap rate option through its trade side.',
    },
    {
        name: 'LegPaymentStreamCompoundingCapRateSellSide',
        abbrName: 'CapRtSell',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamCapRateBuySideCodeSet',
        id: 42436,
        description: 'Reference to the seller of the compounding cap rate option through its trade side.',
    },
    {
        name: 'LegPaymentStreamCompoundingFloorRate',
        abbrName: 'FlrRt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 42437,
        description:
            'The floor rate, if any, which applies to the compounding floating rate. The floor rate (strike) is only required where the compounding floating rate on a swap stream is floored at a certain strike level. The floor rate is assumed to be exclusive of any spread and is a per annum rate. The rate is expressed as a decimal, e.g. 5% is represented as "0.05".',
    },
    {
        name: 'LegPaymentStreamCompoundingFloorRateBuySide',
        abbrName: 'FlrRtBuy',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamFloorRateBuySideCodeSet',
        id: 42438,
        description: 'Reference to the buyer of the compounding floor rate option through its trade side.',
    },
    {
        name: 'LegPaymentStreamCompoundingFloorRateSellSide',
        abbrName: 'FlrRtSell',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamFloorRateBuySideCodeSet',
        id: 42439,
        description: 'Reference to the seller of the floor rate option through its trade side.',
    },
    {
        name: 'LegPaymentStreamCompoundingInitialRate',
        abbrName: 'InitRt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 42440,
        description:
            'The initial compounding floating rate reset agreed between the principal parties involved in the trade. It should only be included when the rate is not equal to the rate published on the source implied by the floating rate index. The initial rate is expressed in decimal form, e.g. 5% is represented as "0.05".',
    },
    {
        name: 'LegPaymentStreamCompoundingFinalRateRoundingDirection',
        abbrName: 'FnlRtRndDirctn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'RoundingDirectionCodeSet',
        id: 42441,
        description: 'Specifies the rounding direction for the compounding floating rate.',
    },
    {
        name: 'LegPaymentStreamCompoundingFinalRatePrecision',
        abbrName: 'FnlRtPrcsn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42442,
        description:
            'Specifies the compounding floating rate rounding precision in terms of a number of decimal places. Note how a percentage rate rounding of 5 decimal places is expressed as a rounding precision of 7.',
    },
    {
        name: 'LegPaymentStreamCompoundingAveragingMethod',
        abbrName: 'AvgngMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamAveragingMethodCodeSet',
        id: 42443,
        description:
            'Specifies the averaging method when compounding floating rate averaging is applicable (e.g. weighted or unweighted).',
    },
    {
        name: 'LegPaymentStreamCompoundingNegativeRateTreatment',
        abbrName: 'NegtvRtTrtmt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamNegativeRateTreatmentCodeSet',
        id: 42444,
        description:
            'Specifies the method for calculating payment obligations when a compounding floating rate is negative (either due to a quoted negative floating rate or by operation of a spread that is subtracted from the floating rate).',
    },
    {
        name: 'LegPaymentStreamCompoundingStartDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42445,
        description: 'The unadjusted compounding start date.',
    },
    {
        name: 'LegPaymentStreamCompoundingStartDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42446,
        description:
            'Specifies the anchor date when the compounding start date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'LegPaymentStreamCompoundingStartDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42447,
        description: 'Time unit multiplier for the relative compounding start date offset.',
    },
    {
        name: 'LegPaymentStreamCompoundingStartDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42448,
        description: 'Time unit associated with the relative compounding start date offset.',
    },
    {
        name: 'LegPaymentStreamCompoundingStartDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42449,
        description: 'Specifies the day type of the relative compounding start date offset.',
    },
    {
        name: 'LegPaymentStreamCompoundingStartDateAdjusted',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42450,
        description: 'The adjusted compounding start date.',
    },
    {
        name: 'LegPaymentStreamFormulaImageLength',
        abbrName: 'FrmlaImgLen',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 42451,
        description: 'Length in bytes of the LegPaymentStreamFormulaImage(42452) field.',
    },
    {
        name: 'LegPaymentStreamFormulaImage',
        abbrName: 'FrmlaImg',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 42452,
        lengthId: '42451',
        description: 'Image of the formula image when represented through an encoded clip in base64Binary.',
    },
    {
        name: 'LegPaymentStreamFinalPricePaymentDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42453,
        description: 'The unadjusted final price payment date.',
    },
    {
        name: 'LegPaymentStreamFinalPricePaymentDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42454,
        description:
            'Specifies the anchor date when the final price payment date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'LegPaymentStreamFinalPricePaymentDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42455,
        description: 'Time unit multiplier for the relative final price payment date offset.',
    },
    {
        name: 'LegPaymentStreamFinalPricePaymentDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42456,
        description: 'Time unit associated with the relative final price payment date offset.',
    },
    {
        name: 'LegPaymentStreamFinalPricePaymentDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42457,
        description: 'Specifies the day type of the relative final price payment date offset.',
    },
    {
        name: 'LegPaymentStreamFinalPricePaymentDateAdjusted',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42458,
        description: 'The adjusted final price payment date.',
    },
    {
        name: 'NoLegPaymentStreamFixingDates',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42459,
        description: 'Number of fixing dates in the repeating group.',
    },
    {
        name: 'LegPaymentStreamFixingDate',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42460,
        description: 'The fixing date. Type of date is specified in LegPaymentStreamFixingDateType(42461).',
    },
    {
        name: 'LegPaymentStreamFixingDateType',
        abbrName: 'Typ',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NonDeliverableFixingDateTypeCodeSet',
        id: 42461,
        description: 'Specifies the type of fixing date (e.g. adjusted for holidays).',
    },
    {
        name: 'LegPaymentStreamFirstObservationDateUnadjusted',
        abbrName: 'FirstObsvtnDtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42462,
        description: 'The unadjusted initial price observation date.',
    },
    {
        name: 'LegPaymentStreamFirstObservationDateRelativeTo',
        abbrName: 'FirstObsvtnReltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42463,
        description:
            'Specifies the anchor date when the initial price observation date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'LegPaymentStreamFirstObservationDateOffsetDayType',
        abbrName: 'FirstObsvtnOfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42464,
        description: 'Specifies the day type of the initial price observation date offset.',
    },
    {
        name: 'LegPaymentStreamFirstObservationDateAdjusted',
        abbrName: 'FirstObsvtnDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42465,
        description: 'The adjusted initial price observation date.',
    },
    {
        name: 'LegPaymentStreamUnderlierRefID',
        abbrName: 'UndlrRefID',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42466,
        description:
            "References the dividend underlier through the instrument's UnderlyingSecurityID(309) which must be fully specified in an instance of the UnderlyingInstrument component.",
    },
    {
        name: 'LegReturnRateNotionalReset',
        abbrName: 'RtnRtNotlReset',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42467,
        description:
            'Indicates whether the term "Equity Notional Reset" as defined in the ISDA 2002 Equity Derivatives Definitions is applicable ("Y") or not.',
    },
    {
        name: 'LegPaymentStreamLinkInitialLevel',
        abbrName: 'LinkInitLvl',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 42468,
        description: 'Price level at which the correlation or variance swap contract will strike.',
    },
    {
        name: 'LegPaymentStreamLinkClosingLevelIndicator',
        abbrName: 'LinkFClsngLvl',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42469,
        description:
            'Indicates whether the correlation or variance swap contract will ("Y") strike off the closing level of the default exchange traded contract or not.',
    },
    {
        name: 'LegPaymentStreamLinkExpiringLevelIndicator',
        abbrName: 'LinkExpngLvl',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42470,
        description:
            'Indicates whether the correlation or variance swap contract will ("Y") strike off the expiring level of the default exchange traded contract or not.',
    },
    {
        name: 'LegPaymentStreamLinkEstimatedTradingDays',
        abbrName: 'LinkEstTrdgDays',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42471,
        description: 'The expected number of trading days in the variance or correlation swap stream.',
    },
    {
        name: 'LegPaymentStreamLinkStrikePrice',
        abbrName: 'LinkStrkPx',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 42472,
        description: 'The strike price of a correlation or variance swap stream.',
    },
    {
        name: 'LegPaymentStreamLinkStrikePriceType',
        abbrName: 'LinkStrkPxTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamLinkStrikePriceTypeCodeSet',
        id: 42473,
        description: 'For a variance swap specifies how LegPaymentStreamLinkStrikePrice(42472) is expressed.',
    },
    {
        name: 'LegPaymentStreamLinkMaximumBoundary',
        abbrName: 'LinkMaxBndry',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 42474,
        description:
            'Specifies the maximum or upper boundary for variance or strike determination.\n\nFor a variation swap stream all observations above this price level will be excluded from the variance calculation.\n\nFor a correlation swap stream the maximum boundary is a percentage of the strike price.',
    },
    {
        name: 'LegPaymentStreamLinkMinimumBoundary',
        abbrName: 'LinkMinBndry',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 42475,
        description:
            'Specifies the minimum or lower boundary for variance or strike determination.\n\nFor a variation swap stream all observations below this price level will be excluded from the variance calculation.\n\nFor a correlation swap stream the minimum boundary is a percentage of the strike price.',
    },
    {
        name: 'LegPaymentStreamLinkNumberOfDataSeries',
        abbrName: 'LinkNumDataSeries',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42476,
        description:
            'Number of data series for a correlation swap. Normal market practice is that correlation data sets are drawn from geographic market areas, such as America, Europe and Asia Pacific. Each of these geographic areas will have its own data series to avoid contagion.',
    },
    {
        name: 'LegPaymentStreamVarianceUnadjustedCap',
        abbrName: 'VarncCap',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 42477,
        description:
            'Indicates the scaling factor to be multiplied by the variance strike price thereby making variance cap applicable.',
    },
    {
        name: 'LegPaymentStreamRealizedVarianceMethod',
        abbrName: 'RlzdVarncMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRealizedVarianceMethodCodeSet',
        id: 42478,
        description: 'Indicates which price to use to satisfy the boundary condition.',
    },
    {
        name: 'LegPaymentStreamDaysAdjustmentIndicator',
        abbrName: 'DaysAdjmt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42479,
        description:
            'Indicates whether the contract specifies that the notional should be scaled by the number of days in range divided by the estimate trading days or not. The number of "days in range" refers to the number of returns that contribute to the realized volatility.',
    },
    {
        name: 'LegPaymentStreamNearestExchangeContractRefID',
        abbrName: 'ExchCtrctRefID',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42480,
        description:
            "References a contract listed on an exchange through the instrument's UnderlyingSecurityID(309) which must be fully specified in an instance of the UnderlyingInstrument component.",
    },
    {
        name: 'LegPaymentStreamVegaNotionalAmount',
        abbrName: 'VegaNotlAmt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 42481,
        description:
            'Vega Notional represents the approximate gain/loss at maturity for a 1% difference between RVol (realized volatility) and KVol (strike volatility). It does not necessarily represent the Vega risk of the trade.',
    },
    {
        name: 'LegPaymentStreamFormulaCurrency',
        abbrName: 'Ccy',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 42482,
        description: 'The currency in which the formula amount is denominated. Uses ISO 4217 currency codes.',
    },
    {
        name: 'LegPaymentStreamFormulaCurrencyDeterminationMethod',
        abbrName: 'CcyDtrmnMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42483,
        description:
            'Specifies the method according to which the formula amount currency is determined.\n\nSee http://www.fpml.org/coding-scheme/determination-method for values.',
    },
    {
        name: 'LegPaymentStreamFormulaReferenceAmount',
        abbrName: 'RefAmt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42484,
        description:
            'Specifies the reference amount when this term either corresponds to the standard ISDA Definition (either the 2002 Equity Definition for the Equity Amount, or the 2000 Definition for the Interest Amount), or refers to a term defined elsewhere in the swap document.\n\nSee http://www.fixtradingcommunity.org/codelists#Payment_Amount_Relative_To for code list of reference amounts.',
    },
    {
        name: 'NoLegPaymentStreamFormulas',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42485,
        description: 'Number of formulas in the repeating group.',
    },
    {
        name: 'LegPaymentStreamFormula',
        abbrName: 'Frmla',
        updated: 'FIX.5.0SP2',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'XMLData',
        updatedEP: '259',
        id: 42486,
        lengthId: '43110',
        description:
            'Contains an XML representation of the formula. Defined for flexibility in choice of language (MathML, OpenMath or text).',
    },
    {
        name: 'LegPaymentStreamFormulaDesc',
        abbrName: 'Desc',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42487,
        description: 'A description of the math formula in LegPaymentStreamFormula(42486).',
    },
    {
        name: 'LegPaymentStubEndDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42488,
        description: 'The unadjusted stub end date.',
    },
    {
        name: 'LegPaymentStubEndDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 42489,
        description: 'The stub end date business day convention.',
    },
    {
        name: 'LegPaymentStubEndDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42490,
        description:
            'Specifies the anchor date when the stub end date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'LegPaymentStubEndDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42491,
        description: 'Time unit multiplier for the relative stub end date offset.',
    },
    {
        name: 'LegPaymentStubEndDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42492,
        description: 'Time unit associated with the relative stub end date offset.',
    },
    {
        name: 'LegPaymentStubEndDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42493,
        description: 'Specifies the day type of the relative stub end date offset.',
    },
    {
        name: 'LegPaymentStubEndDateAdjusted',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42494,
        description: 'The adjusted stub end date.',
    },
    {
        name: 'NoLegPaymentStubEndDateBusinessCenters',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42495,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'LegPaymentStubEndDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42496,
        description:
            'The business center calendar used for date adjustment of the payment stub end date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegPaymentStubStartDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42497,
        description: 'The unadjusted stub start date.',
    },
    {
        name: 'LegPaymentStubStartDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 42498,
        description: 'The stub start date business day convention.',
    },
    {
        name: 'LegPaymentStubStartDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42499,
        description:
            'Specifies the anchor date when the stub start date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'LegPaymentStubStartDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42500,
        description: 'Time unit multiplier for the relative stub start date offset.',
    },
    {
        name: 'LegPaymentStubStartDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42501,
        description: 'Time unit associated with the relative stub start date offset.',
    },
    {
        name: 'LegPaymentStubStartDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42502,
        description: 'Specifies the day type of the relative stub start date offset.',
    },
    {
        name: 'LegPaymentStubStartDateAdjusted',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42503,
        description: 'The adjusted stub start date.',
    },
    {
        name: 'NoLegPaymentStubStartDateBusinessCenters',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42504,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'LegPaymentStubStartDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42505,
        description:
            'The business center calendar used for date adjustment of the payment stub start date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegProvisionBreakFeeElection',
        abbrName: 'BrkFeeElctn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'ProvisionBreakFeeElectionCodeSet',
        id: 42506,
        description: 'Type of fee elected for the break provision.',
    },
    {
        name: 'LegProvisionBreakFeeRate',
        abbrName: 'BrkFeeRt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 42507,
        description:
            'Break fee election rate when the break fee is proportional to the notional. A fee rate of 5% would be represented as "0.05".',
    },
    {
        name: 'NoLegReturnRateDates',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42508,
        description: 'Number of iterations in the return rate date repeating group.',
    },
    {
        name: 'LegReturnRateDateMode',
        abbrName: 'Mode',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'ReturnRateDateModeCodeSet',
        id: 42509,
        description: 'Specifies the valuation type applicable to the return rate date.',
    },
    {
        name: 'LegReturnRateValuationDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42510,
        description:
            'Specifies the anchor date when the return rate valuation dates are relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'LegReturnRateValuationDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42511,
        description: 'Time unit multiplier for the relative return rate valuation date offset.',
    },
    {
        name: 'LegReturnRateValuationDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42512,
        description: 'Time unit associated with the relative return rate valuation date offset.',
    },
    {
        name: 'LegReturnRateValuationDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42513,
        description: 'Specifies the day type of the relative return rate valuation date offset.',
    },
    {
        name: 'LegReturnRateValuationStartDateUnadjusted',
        abbrName: 'StartDtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42514,
        description:
            'The unadjusted start date for return rate valuation. This can be used to restrict the range of dates when they are relative.',
    },
    {
        name: 'LegReturnRateValuationStartDateRelativeTo',
        abbrName: 'StartDtReltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42515,
        description:
            'Specifies the anchor date when the return rate valuation start date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'LegReturnRateValuationStartDateOffsetPeriod',
        abbrName: 'StartDtOfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42516,
        description: 'Time unit multiplier for the relative return rate valuation start date offset.',
    },
    {
        name: 'LegReturnRateValuationStartDateOffsetUnit',
        abbrName: 'StartDtOfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42517,
        description: 'Time unit associated with the relative return rate valuation start date offset.',
    },
    {
        name: 'LegReturnRateValuationStartDateOffsetDayType',
        abbrName: 'StartDtOfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42518,
        description: 'Specifies the day type of the relative return rate valuation start date offset.',
    },
    {
        name: 'LegReturnRateValuationStartDateAdjusted',
        abbrName: 'StartDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42519,
        description:
            'The adjusted start date for return rate valuation. This can be used to restrict the range of dates when they are relative.',
    },
    {
        name: 'LegReturnRateValuationEndDateUnadjusted',
        abbrName: 'EndDtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42520,
        description:
            'The unadjusted end date for return rate valuation. This can be used to restrict the range of dates when they are relative.',
    },
    {
        name: 'LegReturnRateValuationEndDateRelativeTo',
        abbrName: 'EndDtReltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42521,
        description:
            'Specifies the anchor date when the return rate valuation end date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'LegReturnRateValuationEndDateOffsetPeriod',
        abbrName: 'EndDtOfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42522,
        description: 'Time unit multiplier for the relative return rate valuation end date offset.',
    },
    {
        name: 'LegReturnRateValuationEndDateOffsetUnit',
        abbrName: 'EndDtOfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42523,
        description: 'Time unit associated with the relative return rate valuation end date offset.',
    },
    {
        name: 'LegReturnRateValuationEndDateOffsetDayType',
        abbrName: 'EndDtOfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42524,
        description: 'Specifies the day type of the relative return rate valuation end date offset.',
    },
    {
        name: 'LegReturnRateValuationEndDateAdjusted',
        abbrName: 'EndDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42525,
        description:
            'The adjusted end date for return rate valuation. This can be used to restrict the range of dates when they are relative.',
    },
    {
        name: 'LegReturnRateValuationFrequencyPeriod',
        abbrName: 'FreqPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42526,
        description: 'Time unit multiplier for the frequency at which return rate valuation dates occur.',
    },
    {
        name: 'LegReturnRateValuationFrequencyUnit',
        abbrName: 'FreqUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'CouponFrequencyUnitCodeSet',
        id: 42527,
        description: 'Time unit associated with the frequency at which return rate valuation dates occur.',
    },
    {
        name: 'LegReturnRateValuationFrequencyRollConvention',
        abbrName: 'Roll',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'DateRollConventionCodeSet',
        id: 42528,
        description:
            'The convention for determining the sequence of return rate valuation dates. It is used in conjunction with a specified frequency.',
    },
    {
        name: 'LegReturnRateValuationDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 42529,
        description: 'The return rate valuation dates business day convention.',
    },
    {
        name: 'NoLegReturnRateFXConversions',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42530,
        description: 'Number of iterations in the return rate FX conversion repeating group.',
    },
    {
        name: 'LegReturnRateFXCurrencySymbol',
        abbrName: 'CcySym',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42531,
        description:
            'Specifies the currency pair for the FX conversion expressed using the CCY1/CCY2 convention. Uses ISO 4217 currency codes.',
    },
    {
        name: 'LegReturnRateFXRate',
        abbrName: 'FxRt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 42532,
        description:
            'The rate of exchange between the two currencies specified in LegReturnRateFXCurrencySymbol(42531).',
    },
    {
        name: 'LegReturnRateFXRateCalc',
        abbrName: 'FxRtCalc',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'SettlCurrFxRateCalcCodeSet',
        id: 42533,
        description:
            'The rate of exchange between the two currencies specified in LegReturnRateFXCurrencySymbol(42531).',
    },
    {
        name: 'NoLegReturnRates',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42534,
        description: 'Number of iterations in the return rate repeating group.',
    },
    {
        name: 'LegReturnRatePriceSequence',
        abbrName: 'PxSeq',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'ReturnRatePriceSequenceCodeSet',
        id: 42535,
        description: 'Specifies the type of price sequence of the return rate.',
    },
    {
        name: 'LegReturnRateCommissionBasis',
        abbrName: 'CommBasis',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'CommTypeCodeSet',
        id: 42536,
        description: 'Specifies the basis or unit used to calculate the commission.',
    },
    {
        name: 'LegReturnRateCommissionAmount',
        abbrName: 'CommAmt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 42537,
        description: 'The commission amount.',
    },
    {
        name: 'LegReturnRateCommissionCurrency',
        abbrName: 'CommCcy',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 42538,
        description: 'Specifies the currency the commission amount is denominated in. Uses ISO 4217 currency codes.',
    },
    {
        name: 'LegReturnRateTotalCommissionPerTrade',
        abbrName: 'TotCommPerTrd',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 42539,
        description: 'The total commission per trade.',
    },
    {
        name: 'LegReturnRateDeterminationMethod',
        abbrName: 'DtrmnMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42540,
        description:
            'Specifies the method by which the underlier prices are determined.\n\nSee http://www.fpml.org/coding-scheme/determination-method for values.',
    },
    {
        name: 'LegReturnRateAmountRelativeTo',
        abbrName: 'AmtReltv',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42541,
        description:
            'Specifies the reference amount when the return rate amount is relative to another amount in the trade.\n\nSee http://www.fixtradingcommunity.org/codelists#Amount_Relative_To for code list of relative amounts.',
    },
    {
        name: 'LegReturnRateQuoteMeasureType',
        abbrName: 'QteTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42542,
        description:
            "Specifies the type of the measure applied to the return rate's asset, e.g. valuation, sensitivity risk. This could be an NPV, a cash flow, a clean price, etc.\n\nSee http://www.fpml.org/coding-scheme/asset-measure for values.",
    },
    {
        name: 'LegReturnRateQuoteUnits',
        abbrName: 'QteUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42543,
        description:
            'Specifies the units that the measure is expressed in. If not specified, the default is a price/value in currency units.\n\nSee http://www.fpml.org/coding-scheme/price-quote-units for values.',
    },
    {
        name: 'LegReturnRateQuoteMethod',
        abbrName: 'QteMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'CashSettlQuoteMethodCodeSet',
        id: 42544,
        description: 'Specifies the type of quote used to determine the return rate of the swap.',
    },
    {
        name: 'LegReturnRateQuoteCurrency',
        abbrName: 'QteCcy',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 42545,
        description: 'Specifies the currency the return rate quote is denominated in. Uses ISO 4217 Currency Code.',
    },
    {
        name: 'LegReturnRateQuoteCurrencyType',
        abbrName: 'QteCcyTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42546,
        description:
            'Specifies the type of currency, e.g. settlement currency, base currency, etc., that the quote is reported in.\n\nSee http://www.fpml.org/coding-scheme/reporting-currency-type for values.',
    },
    {
        name: 'LegReturnRateQuoteTimeType',
        abbrName: 'QteTmTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'ReturnRateQuoteTimeTypeCodeSet',
        id: 42547,
        description: 'Specifies how or the timing when the quote is to be obtained.',
    },
    {
        name: 'LegReturnRateQuoteTime',
        abbrName: 'QteTm',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 42548,
        description: 'The time when the quote is to be generated.',
    },
    {
        name: 'LegReturnRateQuoteDate',
        abbrName: 'QteDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42549,
        description: 'The date when the quote is to be generated.',
    },
    {
        name: 'LegReturnRateQuoteExpirationTime',
        abbrName: 'QteExpTm',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 42550,
        description: 'The time when the quote ceases to be valid.',
    },
    {
        name: 'LegReturnRateQuoteBusinessCenter',
        abbrName: 'QteBizCtr',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42551,
        description:
            'The business center calendar used for adjustments associated with LegReturnRateQuoteTimeType(42547) or LegReturnRateQuoteTime(42548) and LegReturnRateQuoteDate(42549), e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegReturnRateQuoteExchange',
        abbrName: 'QteExch',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Exchange',
        id: 42552,
        description:
            'Specifies the exchange (e.g. stock or listed futures/options exchange) from which the quote is obtained.',
    },
    {
        name: 'LegReturnRateQuotePricingModel',
        abbrName: 'QteModel',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42553,
        description:
            'Specifies the pricing model used to evaluate the underlying asset price.\n\nSee http://www.fpml.org/coding-scheme/pricing-model for values.',
    },
    {
        name: 'LegReturnRateCashFlowType',
        abbrName: 'CshFlow',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42554,
        description:
            'Specifies the type of cash flows, e.g. coupon payment, premium fee, settlement fee, etc.\n\nSee http://www.fpml.org/coding-scheme/cashflow-type for values.',
    },
    {
        name: 'LegReturnRateValuationTimeType',
        abbrName: 'ValTmTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'ReturnRateQuoteTimeTypeCodeSet',
        id: 42555,
        description: 'Specifies the timing at which the calculation agent values the underlying.',
    },
    {
        name: 'LegReturnRateValuationTime',
        abbrName: 'ValTm',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 42556,
        description: 'The time at which the calculation agent values the underlying asset.',
    },
    {
        name: 'LegReturnRateValuationTimeBusinessCenter',
        abbrName: 'ValTmBizCtr',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42557,
        description:
            'The business center calendar used for adjustments associated with LegReturnRateValuationTimeType(42555) or LegReturnRateValuationTime(42556), e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegReturnRateValuationPriceOption',
        abbrName: 'ValPxOpt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'ReturnRateValuationPriceOptionCodeSet',
        id: 42558,
        description: 'Indicates whether an ISDA price option applies, and if applicable which type of price.',
    },
    {
        name: 'LegReturnRateFinalPriceFallback',
        abbrName: 'FnlPxFallbck',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventPVFinalPriceElectionFallbackCodeSet',
        id: 42559,
        description: 'Specifies the fallback provision for the hedging party in the determination of the final price.',
    },
    {
        name: 'NoLegReturnRateInformationSources',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42560,
        description: 'Number of iterations in the return rate information source repeating group.',
    },
    {
        name: 'LegReturnRateInformationSource',
        abbrName: 'RtSrc',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'RateSourceCodeSet',
        id: 42561,
        description:
            'Identifies the source of rate information. For FX the references source to be used for the FX spot rate.',
    },
    {
        name: 'LegReturnRateReferencePage',
        abbrName: 'RefPg',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42562,
        description:
            'Identifies the reference "page" from the rate source.\n\nFor FX, the reference page to the spot rate to be used for the reference FX spot rate.\n\nWhen LegReturnRateInformationSource(42561) = 3 (ISDA Settlement Rate Option) this contains the value from the scheme that reflects the terms of the Annex A to the ISDA 1998 FX and Currency Option Definitions.\n\nSee: http://www.fpml.org/coding-scheme/settlement-rate-option.',
    },
    {
        name: 'LegReturnRateReferencePageHeading',
        abbrName: 'RefHdng',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42563,
        description: 'Identifies the page heading from the rate source.',
    },
    {
        name: 'NoLegReturnRatePrices',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42564,
        description: 'Number of iterations in the return rate price repeating group.',
    },
    {
        name: 'LegReturnRatePriceBasis',
        abbrName: 'PxBasis',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'ReturnRatePriceBasisCodeSet',
        id: 42565,
        description: 'The basis of the return price.',
    },
    {
        name: 'LegReturnRatePrice',
        abbrName: 'Px',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 42566,
        description: 'Specifies the price of the underlying swap asset.',
    },
    {
        name: 'LegReturnRatePriceCurrency',
        abbrName: 'Ccy',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 42567,
        description: 'Specifies the currency of the price of the leg swap asset. Uses ISO 4217 currency codes.',
    },
    {
        name: 'LegReturnRatePriceType',
        abbrName: 'PxTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'ReturnRatePriceTypeCodeSet',
        id: 42568,
        description: 'Specifies whether the LegReturnRatePrice(42566) is expressed in absolute or relative terms.',
    },
    {
        name: 'NoLegReturnRateValuationDateBusinessCenters',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42569,
        description: 'Number of iterations in the return rate valuation date business center repeating group.',
    },
    {
        name: 'LegReturnRateValuationDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42570,
        description:
            'The business center calendar used for date adjustment of the return rate valuation unadjusted or relative dates, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'NoLegReturnRateValuationDates',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42571,
        description: 'Number of iterations in the return rate valuation date repeating group.',
    },
    {
        name: 'LegReturnRateValuationDate',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42572,
        description:
            'The return rate valuation date. The type of date is specified in LegReturnRateValuationDateType(42573).',
    },
    {
        name: 'LegReturnRateValuationDateType',
        abbrName: 'Typ',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NonDeliverableFixingDateTypeCodeSet',
        id: 42573,
        description: 'Specifies the type of return rate valuation date (e.g. adjusted for holidays).',
    },
    {
        name: 'LegSettlMethodElectionDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42574,
        description: 'The unadjusted settlement method election date.',
    },
    {
        name: 'LegSettlMethodElectionDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 42575,
        description: 'The settlement method election date adjustment business day convention.',
    },
    {
        name: 'LegSettlMethodElectionDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42576,
        description:
            'Specifies the anchor date when the settlement method election date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'LegSettlMethodElectionDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42577,
        description: 'Time unit multiplier for the relative settlement method election date offset.',
    },
    {
        name: 'LegSettlMethodElectionDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42578,
        description: 'Time unit associated with the relative settlement method election date offset.',
    },
    {
        name: 'LegSettlMethodElectionDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42579,
        description: 'Specifies the day type of the relative settlement method election date offset.',
    },
    {
        name: 'LegSettlMethodElectionDateAdjusted',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42580,
        description: 'The adjusted settlement method election date.',
    },
    {
        name: 'NoLegSettlMethodElectionDateBusinessCenters',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42581,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'LegSettlMethodElectionDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42582,
        description:
            'The business center calendar used for date adjustment of the settlement method election unadjusted or relative date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'LegStreamVersion',
        abbrName: 'Ver',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42583,
        description:
            'The stream version identifier when there have been modifications to the contract over time. Helps signal when there are embedded changes.',
    },
    {
        name: 'LegStreamVersionEffectiveDate',
        abbrName: 'VerEfctvDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42584,
        description: 'The effective date of the LegStreamVersion(42583).',
    },
    {
        name: 'LegStreamNotionalDeterminationMethod',
        abbrName: 'NotlDtrmnMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42585,
        description:
            'Specifies the method for determining the floating notional value for equity swaps.\n\nSee http://www.fpml.org/coding-scheme/determination-method for values.',
    },
    {
        name: 'LegStreamNotionalAdjustments',
        abbrName: 'NotlAdjmts',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'StreamNotionalAdjustmentsCodeSet',
        id: 42586,
        description:
            'For equity swaps this specifies the conditions that govern the adjustment to the number of units of the swap.',
    },
    {
        name: 'SettlMethodElectingPartySide',
        abbrName: 'SettlMethElctngSide',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentPaySideCodeSet',
        id: 42590,
        description: 'Side value of the party electing the settlement method.',
    },
    {
        name: 'MakeWholeDate',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42591,
        description: 'The date through which option cannot be exercised without penalty.',
    },
    {
        name: 'MakeWholeAmount',
        abbrName: 'Amt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 42592,
        description:
            'Amount to be paid by the buyer of the option if the option is exercised prior to the MakeWholeDate(42591).',
    },
    {
        name: 'MakeWholeBenchmarkCurveName',
        abbrName: 'Name',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42593,
        description: 'Identifies the benchmark floating rate index.',
    },
    {
        name: 'MakeWholeBenchmarkCurvePoint',
        abbrName: 'Point',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42594,
        description:
            'The point on the floating rate index curve.\n\nSample values:\n\nM = combination of a number between 1-12 and an "M" for month, e.g. 3M\n\nY = combination of number between 1-100 and a "Y" for year, e.g. 10Y\n\n10Y-OLD = see above, then add "-OLD" when appropriate\n\nINTERPOLATED = the point is mathematically derived\n\n2/2031 5 3/8 = the point is stated via a combination of maturity month / year and coupon.',
    },
    {
        name: 'MakeWholeRecallSpread',
        abbrName: 'Spread',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 42595,
        description: 'Spread over the floating rate index.',
    },
    {
        name: 'MakeWholeBenchmarkQuote',
        abbrName: 'Qte',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'StrikeIndexQuoteCodeSet',
        id: 42596,
        description: 'The quote side of the benchmark to be used for calculating the "make whole" amount.',
    },
    {
        name: 'MakeWholeInterpolationMethod',
        abbrName: 'IntrpltnMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamInflationInterpolationMethodCodeSet',
        id: 42597,
        description: 'The method used when calculating the "make whole" amount. The most common is linear method.',
    },
    {
        name: 'PaymentAmountRelativeTo',
        abbrName: 'AmtReltv',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42598,
        description:
            'Specifies the reference amount when the payment amount is relative to another amount in the message.\n\nSee http://www.fixtradingcommunity.org/codelists#Payment_Amount_Relative_To for code list of relative amounts.',
    },
    {
        name: 'PaymentAmountDeterminationMethod',
        abbrName: 'AmtDtrmnMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42599,
        description:
            'Specifies the method by which a payment amount is determined.\n\nSee http://www.fpml.org/coding-scheme/determination-method for values.',
    },
    {
        name: 'PaymentStreamCashSettlIndicator',
        abbrName: 'CshSettlInd',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42600,
        description: 'Indicates whether cash settlement is applicable.',
    },
    {
        name: 'PaymentStreamCompoundingXIDRef',
        abbrName: 'CmpndgXIDRef',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'XIDREF',
        id: 42601,
        description: 'Reference to the stream which details the compounding fixed or floating rate.',
    },
    {
        name: 'PaymentStreamCompoundingSpread',
        abbrName: 'CmpndgSpread',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 42602,
        description:
            'The spread to be used for compounding. Used in scenarios where the interest payment is based on a compounding formula that uses a compounding spread in addition to the regular spread.',
    },
    {
        name: 'PaymentStreamInterpolationMethod',
        abbrName: 'IntrpltnMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamInflationInterpolationMethodCodeSet',
        id: 42603,
        description:
            'The method used when calculating the index rate from multiple points on the curve. The most common is linear method.',
    },
    {
        name: 'PaymentStreamInterpolationPeriod',
        abbrName: 'IntrpltnPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamInterpolationPeriodCodeSet',
        id: 42604,
        description: 'Defines applicable periods for interpolation.',
    },
    {
        name: 'PaymentStreamCompoundingFixedRate',
        abbrName: 'CmpndgFixedRt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 42605,
        description: 'The compounding fixed rate applicable to the payment stream.',
    },
    {
        name: 'NoPaymentStreamCompoundingDates',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42606,
        description: 'Number of dates in the repeating group.',
    },
    {
        name: 'PaymentStreamCompoundingDate',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42607,
        description: 'The compounding date. The type of date is specified in PaymentStreamCompoundingDateType(42608).',
    },
    {
        name: 'PaymentStreamCompoundingDateType',
        abbrName: 'Typ',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NonDeliverableFixingDateTypeCodeSet',
        id: 42608,
        description: 'Specifies the type of payment compounding date (e.g. adjusted for holidays).',
    },
    {
        name: 'PaymentStreamCompoundingDatesBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 42609,
        description: 'The compounding dates business day convention.',
    },
    {
        name: 'PaymentStreamCompoundingDatesRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42610,
        description:
            'Specifies the anchor date when the compounding dates are relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'PaymentStreamCompoundingDatesOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42611,
        description: 'Time unit multiplier for the relative compounding date offset.',
    },
    {
        name: 'PaymentStreamCompoundingDatesOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42612,
        description: 'Time unit associated with the relative compounding date offset.',
    },
    {
        name: 'PaymentStreamCompoundingDatesOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42613,
        description: 'Specifies the day type of the relative compounding date offset.',
    },
    {
        name: 'PaymentStreamCompoundingPeriodSkip',
        abbrName: 'Skip',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42614,
        description:
            'The number of periods in the "RelativeTo" schedule that are between each date in the compounding schedule. A skip of 2 would mean that compounding dates are relative to every second date in the "RelativeTo" schedule. If present this should have a value greater than 1.',
    },
    {
        name: 'PaymentStreamCompoundingFrequencyPeriod',
        abbrName: 'FreqPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42615,
        description: 'Time unit multiplier for the frequency at which compounding dates occur.',
    },
    {
        name: 'PaymentStreamCompoundingFrequencyUnit',
        abbrName: 'FreqUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'CouponFrequencyUnitCodeSet',
        id: 42616,
        description: 'Time unit associated with the frequency at which compounding dates occur.',
    },
    {
        name: 'PaymentStreamCompoundingRollConvention',
        abbrName: 'Roll',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'DateRollConventionCodeSet',
        id: 42617,
        description:
            'The convention for determining the sequence of compounding dates. It is used in conjunction with a specified frequency.',
    },
    {
        name: 'PaymentStreamBoundsFirstDateUnadjusted',
        abbrName: 'FirstDtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42618,
        description:
            'The unadjusted first date of the compounding schedule. This can be used to restrict the range of dates when they are relative.',
    },
    {
        name: 'PaymentStreamBoundsLastDateUnadjusted',
        abbrName: 'LastDtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42619,
        description:
            'The unadjusted last date of the compounding schedule. This can be used to restrict the range of dates when they are relative.',
    },
    {
        name: 'NoPaymentStreamCompoundingDatesBusinessCenters',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42620,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'PaymentStreamCompoundingDatesBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42621,
        description:
            'The business center calendar used for date adjustment of the payment stream compounding dates, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'PaymentStreamCompoundingEndDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42622,
        description: 'The unadjusted compounding end date.',
    },
    {
        name: 'PaymentStreamCompoundingEndDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42623,
        description:
            'Specifies the anchor date when the compounding end date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'PaymentStreamCompoundingEndDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42624,
        description: 'Time unit multiplier for the relative compounding end date offset.',
    },
    {
        name: 'PaymentStreamCompoundingEndDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42625,
        description: 'Time unit associated with the relative compounding end date offset.',
    },
    {
        name: 'PaymentStreamCompoundingEndDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42626,
        description: 'Specifies the day type of the relative compounding end date offset.',
    },
    {
        name: 'PaymentStreamCompoundingEndDateAdjusted',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42627,
        description: 'The adjusted compounding end date.',
    },
    {
        name: 'PaymentStreamCompoundingRateIndex',
        abbrName: 'Ndx',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42628,
        description: "The payment stream's compounding floating rate index.",
    },
    {
        name: 'PaymentStreamCompoundingRateIndexCurvePeriod',
        abbrName: 'NdxPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42629,
        description: "Time unit multiplier for the payment stream's compounding floating rate index curve period.",
    },
    {
        name: 'PaymentStreamCompoundingRateIndexCurveUnit',
        abbrName: 'NdxUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexCurveUnitCodeSet',
        id: 42630,
        description: "Time unit associated with the payment stream's compounding floating rate index curve period.",
    },
    {
        name: 'PaymentStreamCompoundingRateMultiplier',
        abbrName: 'RtMult',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 42631,
        description:
            'A rate multiplier to apply to the compounding floating rate. The multiplier can be less than or greater than 1 (one). This should only be included if the multiplier is not equal to 1 (one) for the term of the stream.',
    },
    {
        name: 'PaymentStreamCompoundingRateSpread',
        abbrName: 'Spread',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 42632,
        description: 'The basis points spread from the index specified in PaymentStreamCompoundingRateIndex(42628).',
    },
    {
        name: 'PaymentStreamCompoundingRateSpreadPositionType',
        abbrName: 'SpreadPosTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
        id: 42633,
        description: 'Identifies whether the rate spread is applied to a long or short position.',
    },
    {
        name: 'PaymentStreamCompoundingRateTreatment',
        abbrName: 'RtTrtmt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateTreatmentCodeSet',
        id: 42634,
        description: 'Specifies the yield calculation treatment for the index.',
    },
    {
        name: 'PaymentStreamCompoundingCapRate',
        abbrName: 'CapRt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 42635,
        description:
            'The cap rate, if any, which applies to the compounding floating rate. It is only required where the compounding floating rate on a swap stream is capped at a certain level. The cap rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A cap rate of 5% would be represented as "0.05".',
    },
    {
        name: 'PaymentStreamCompoundingCapRateBuySide',
        abbrName: 'CapRtBuy',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamCapRateBuySideCodeSet',
        id: 42636,
        description: 'Reference to the buyer of the compounding cap rate option through its trade side.',
    },
    {
        name: 'PaymentStreamCompoundingCapRateSellSide',
        abbrName: 'CapRtSell',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamCapRateBuySideCodeSet',
        id: 42637,
        description: 'Reference to the seller of the compounding cap rate option through its trade side.',
    },
    {
        name: 'PaymentStreamCompoundingFloorRate',
        abbrName: 'FlrRt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 42638,
        description:
            'The floor rate, if any, which applies to the compounding floating rate. The floor rate (strike) is only required where the compounding floating rate on a swap stream is floored at a certain strike level. The floor rate is assumed to be exclusive of any spread and is a per annum rate. The rate is expressed as a decimal, e.g. 5% is represented as "0.05".',
    },
    {
        name: 'PaymentStreamCompoundingFloorRateBuySide',
        abbrName: 'FlrRtBuy',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamFloorRateBuySideCodeSet',
        id: 42639,
        description: 'Reference to the buyer of the compounding floor rate option through its trade side.',
    },
    {
        name: 'PaymentStreamCompoundingFloorRateSellSide',
        abbrName: 'FlrRtSell',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamFloorRateBuySideCodeSet',
        id: 42640,
        description: 'Reference to the seller of the floor rate option through its trade side.',
    },
    {
        name: 'PaymentStreamCompoundingInitialRate',
        abbrName: 'InitRt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 42641,
        description:
            'The initial compounding floating rate reset agreed between the principal parties involved in the trade. It should only be included when the rate is not equal to the rate published on the source implied by the floating rate index. The initial rate is expressed in decimal form, e.g. 5% is represented as "0.05".',
    },
    {
        name: 'PaymentStreamCompoundingFinalRateRoundingDirection',
        abbrName: 'FnlRtRndDirctn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'RoundingDirectionCodeSet',
        id: 42642,
        description: 'Specifies the rounding direction for the compounding floating rate.',
    },
    {
        name: 'PaymentStreamCompoundingFinalRatePrecision',
        abbrName: 'FnlRtPrcsn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42643,
        description:
            'Specifies the compounding floating rate rounding precision in terms of a number of decimal places. Note how a percentage rate rounding of 5 decimal places is expressed as a rounding precision of 7.',
    },
    {
        name: 'PaymentStreamCompoundingAveragingMethod',
        abbrName: 'AvgngMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamAveragingMethodCodeSet',
        id: 42644,
        description:
            'Specifies the averaging method when compounding floating rate averaging is applicable (e.g. weighted or unweighted).',
    },
    {
        name: 'PaymentStreamCompoundingNegativeRateTreatment',
        abbrName: 'NegtvRtTrtmt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamNegativeRateTreatmentCodeSet',
        id: 42645,
        description:
            'Specifies the method for calculating payment obligations when a compounding floating rate is negative (either due to a quoted negative floating rate or by operation of a spread that is subtracted from the floating rate).',
    },
    {
        name: 'PaymentStreamCompoundingStartDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42646,
        description: 'The unadjusted compounding start date.',
    },
    {
        name: 'PaymentStreamCompoundingStartDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42647,
        description:
            'Specifies the anchor date when the compounding start date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'PaymentStreamCompoundingStartDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42648,
        description: 'Time unit multiplier for the relative compounding start date offset.',
    },
    {
        name: 'PaymentStreamCompoundingStartDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42649,
        description: 'Time unit associated with the relative compounding start date offset.',
    },
    {
        name: 'PaymentStreamCompoundingStartDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42650,
        description: 'Specifies the day type of the relative compounding start date offset.',
    },
    {
        name: 'PaymentStreamCompoundingStartDateAdjusted',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42651,
        description: 'The adjusted compounding start date.',
    },
    {
        name: 'PaymentStreamFormulaImageLength',
        abbrName: 'FrmlaImgLen',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 42652,
        description: 'Length in bytes of the PaymentStreamFormulaImage(42563) field.',
    },
    {
        name: 'PaymentStreamFormulaImage',
        abbrName: 'FrmlaImg',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 42653,
        lengthId: '42652',
        description: 'Image of the formula image when represented through an encoded clip in base64Binary.',
    },
    {
        name: 'PaymentStreamFinalPricePaymentDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42654,
        description: 'The unadjusted final price payment date.',
    },
    {
        name: 'PaymentStreamFinalPricePaymentDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42655,
        description:
            'Specifies the anchor date when the final price payment date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'PaymentStreamFinalPricePaymentDateOffsetfPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42656,
        description: 'Time unit multiplier for the relative final price payment date offset.',
    },
    {
        name: 'PaymentStreamFinalPricePaymentDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42657,
        description: 'Time unit associated with the relative final price payment date offset.',
    },
    {
        name: 'PaymentStreamFinalPricePaymentDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42658,
        description: 'Specifies the day type of the relative final price payment date offset.',
    },
    {
        name: 'PaymentStreamFinalPricePaymentDateAdjusted',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42659,
        description: 'The adjusted final price payment date.',
    },
    {
        name: 'NoPaymentStreamFixingDates',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42660,
        description: 'Number of fixing dates in the repeating group.',
    },
    {
        name: 'PaymentStreamFixingDate',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42661,
        description: 'The fixing date. The type of date is specified in PaymentStreamFixingDateType(42662).',
    },
    {
        name: 'PaymentStreamFixingDateType',
        abbrName: 'Typ',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NonDeliverableFixingDateTypeCodeSet',
        id: 42662,
        description: 'Specifies the type of fixing date (e.g. adjusted for holidays).',
    },
    {
        name: 'PaymentStreamFirstObservationDateUnadjusted',
        abbrName: 'FirstObsvtnDtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42663,
        description: 'The unadjusted initial price observation date.',
    },
    {
        name: 'PaymentStreamFirstObservationDateRelativeTo',
        abbrName: 'FirstObsvtnReltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42664,
        description:
            'Specifies the anchor date when the initial price observation date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'PaymentStreamFirstObservationDateOffsetDayType',
        abbrName: 'FirstObsvtnOfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42665,
        description: 'Specifies the day type of the initial price observation date offset.',
    },
    {
        name: 'PaymentStreamFirstObservationDateAdjusted',
        abbrName: 'FirstObsvtnDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42666,
        description: 'The adjusted initial price observation date.',
    },
    {
        name: 'PaymentStreamUnderlierRefID',
        abbrName: 'UndlrRefID',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42667,
        description:
            "References the dividend underlier through the instrument's UnderlyingSecurityID(309) which must be fully specified in an instance of the UnderlyingInstrument component.",
    },
    {
        name: 'ReturnRateNotionalReset',
        abbrName: 'RtnRtNotlReset',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42668,
        description:
            'Indicates whether the term "Equity Notional Reset" as defined in the ISDA 2002 Equity Derivatives Definitions is applicable ("Y") or not.',
    },
    {
        name: 'PaymentStreamLinkInitialLevel',
        abbrName: 'LinkInitLvl',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 42669,
        description: 'Price level at which the correlation or variance swap contract will strike.',
    },
    {
        name: 'PaymentStreamLinkClosingLevelIndicator',
        abbrName: 'LinkClsngLvl',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42670,
        description:
            'Indicates whether the correlation or variance swap contract will ("Y") strike off the closing level of the default exchange traded contract or not.',
    },
    {
        name: 'PaymentStreamLinkExpiringLevelIndicator',
        abbrName: 'LinkExpngLvl',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42671,
        description:
            'Indicates whether the correlation or variance swap contract will ("Y") strike off the expiring level of the default exchange traded contract or not.',
    },
    {
        name: 'PaymentStreamLinkEstimatedTradingDays',
        abbrName: 'LinkEstTrdgDays',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42672,
        description: 'The expected number of trading days in the variance or correlation swap stream.',
    },
    {
        name: 'PaymentStreamLinkStrikePrice',
        abbrName: 'LinkStrkPx',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 42673,
        description: 'The strike price of a correlation or variance swap stream.',
    },
    {
        name: 'PaymentStreamLinkStrikePriceType',
        abbrName: 'LinkStrkPxTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamLinkStrikePriceTypeCodeSet',
        id: 42674,
        description: 'For a variance swap specifies how PaymentStreamLinkStrikePrice(42673) is expressed.',
    },
    {
        name: 'PaymentStreamLinkMaximumBoundary',
        abbrName: 'LinkMaxBndry',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 42675,
        description:
            'Specifies the maximum or upper boundary for variance or strike determination.\n\nFor a variation swap stream all observations above this price level will be excluded from the variance calculation.\n\nFor a correlation swap stream the maximum boundary is a percentage of the strike price.',
    },
    {
        name: 'PaymentStreamLinkMinimumBoundary',
        abbrName: 'LinkMinBndry',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 42676,
        description:
            'Specifies the minimum or lower boundary for variance or strike determination.\n\nFor a variation swap stream all observations below this price level will be excluded from the variance calculation.\n\nFor a correlation swap stream the minimum boundary is a percentage of the strike price.',
    },
    {
        name: 'PaymentStreamLinkNumberOfDataSeries',
        abbrName: 'LinkNumDataSeries',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42677,
        description:
            'Number of data series for a correlation swap. Normal market practice is that correlation data sets are drawn from geographic market areas, such as America, Europe and Asia Pacific. Each of these geographic areas will have its own data series to avoid contagion.',
    },
    {
        name: 'PaymentStreamVarianceUnadjustedCap',
        abbrName: 'VarncCap',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 42678,
        description:
            'Indicates the scaling factor to be multiplied by the variance strike price thereby making variance cap applicable.',
    },
    {
        name: 'PaymentStreamRealizedVarianceMethod',
        abbrName: 'RlzdVarncMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRealizedVarianceMethodCodeSet',
        id: 42679,
        description: 'Indicates which price to use to satisfy the boundary condition.',
    },
    {
        name: 'PaymentStreamDaysAdjustmentIndicator',
        abbrName: 'DaysAdjmt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42680,
        description:
            'Indicates whether the contract specifies that the notional should be scaled by the number of days in range divided by the estimate trading days or not. The number of "days in range" refers to the number of returns that contribute to the realized volatility.',
    },
    {
        name: 'PaymentStreamNearestExchangeContractRefID',
        abbrName: 'ExchCtrctRefID',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42681,
        description:
            "References a contract listed on an exchange through the instrument's UnderlyingSecurityID(309) which must be fully specified in an instance of the UnderlyingInstrument component.",
    },
    {
        name: 'PaymentStreamVegaNotionalAmount',
        abbrName: 'VegaNotlAmt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 42682,
        description:
            '"Vega Notional" represents the approximate gain/loss at maturity for a 1% difference between RVol (realised volatility) and KVol (strike volatility). It does not necessarily represent the Vega risk of the trade.',
    },
    {
        name: 'NoPaymentStreamFormulas',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42683,
        description: 'Number of formulas in the repeating group.',
    },
    {
        name: 'PaymentStreamFormula',
        abbrName: 'Frmla',
        updated: 'FIX.5.0SP2',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'XMLData',
        updatedEP: '259',
        id: 42684,
        lengthId: '43109',
        description:
            'Contains an XML representation of the formula. Defined for flexibility in choice of language (MathML, OpenMath or text).',
    },
    {
        name: 'PaymentStreamFormulaDesc',
        abbrName: 'Desc',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42685,
        description: 'A description of the math formula in PaymentStreamFormula(42684).',
    },
    {
        name: 'PaymentStreamFormulaCurrency',
        abbrName: 'Ccy',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 42686,
        description: 'The currency in which the formula amount is denominated. Uses ISO 4217 currency codes.',
    },
    {
        name: 'PaymentStreamFormulaCurrencyDeterminationMethod',
        abbrName: 'CcyDtrmnMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42687,
        description:
            'Specifies the method according to which the formula amount currency is determined.\n\nSee http://www.fpml.org/coding-scheme/determination-method for values.',
    },
    {
        name: 'PaymentStreamFormulaReferenceAmount',
        abbrName: 'RefAmt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42688,
        description:
            'Specifies the reference amount when this term either corresponds to the standard ISDA Definition (either the 2002 Equity Definition for the Equity Amount, or the 2000 Definition for the Interest Amount), or refers to a term defined elsewhere in the swap document.\n\nSee http://www.fixtradingcommunity.org/codelists#Payment_Amount_Relative_To for code list of reference amounts.',
    },
    {
        name: 'PaymentStubEndDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42689,
        description: 'The unadjusted stub end date.',
    },
    {
        name: 'PaymentStubEndDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 42690,
        description: 'The stub end date business day convention.',
    },
    {
        name: 'PaymentStubEndDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42691,
        description:
            'Specifies the anchor date when the stub end date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'PaymentStubEndDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42692,
        description: 'Time unit multiplier for the relative stub end date offset.',
    },
    {
        name: 'PaymentStubEndDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42693,
        description: 'Time unit associated with the relative stub end date offset.',
    },
    {
        name: 'PaymentStubEndDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42694,
        description: 'Specifies the day type of the relative stub end date offset.',
    },
    {
        name: 'PaymentStubEndDateAdjusted',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42695,
        description: 'The adjusted stub end date.',
    },
    {
        name: 'NoPaymentStubEndDateBusinessCenters',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42696,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'PaymentStubEndDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42697,
        description:
            'The business center calendar used for date adjustment of the payment stub end date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'PaymentStubStartDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42698,
        description: 'The unadjusted stub start date.',
    },
    {
        name: 'PaymentStubStartDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 42699,
        description: 'The stub start date business day convention.',
    },
    {
        name: 'PaymentStubStartDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42700,
        description:
            'Specifies the anchor date when the stub start date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'PaymentStubStartDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42701,
        description: 'Time unit multiplier for the relative stub start date offset.',
    },
    {
        name: 'PaymentStubStartDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42702,
        description: 'Time unit associated with the relative stub start date offset.',
    },
    {
        name: 'PaymentStubStartDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42703,
        description: 'Specifies the day type of the relative stub start date offset.',
    },
    {
        name: 'PaymentStubStartDateAdjusted',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42704,
        description: 'The adjusted stub start date.',
    },
    {
        name: 'NoPaymentStubStartDateBusinessCenters',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42705,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'PaymentStubStartDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42706,
        description:
            'The business center calendar used for date adjustment of the payment stub start date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'ProvisionBreakFeeElection',
        abbrName: 'BrkFeeElctn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'ProvisionBreakFeeElectionCodeSet',
        id: 42707,
        description: 'Type of fee elected for the break provision.',
    },
    {
        name: 'ProvisionBreakFeeRate',
        abbrName: 'BrkFeeRt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 42708,
        description:
            'Break fee election rate when the break fee is proportional to the notional. A fee rate of 5% would be represented as "0.05".',
    },
    {
        name: 'RelatedToDividendPeriodXIDRef',
        abbrName: 'XIDRef',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'XIDREF',
        id: 2417,
        description:
            'The DividendPeriodXID(42293) of the stream dividend period with which the related instrument has correlation.',
    },
    {
        name: 'NoReturnRateDates',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42709,
        description: 'Number of iterations in the return rate date repeating group.',
    },
    {
        name: 'ReturnRateDateMode',
        abbrName: 'Mode',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'ReturnRateDateModeCodeSet',
        id: 42710,
        description: 'Specifies the valuation type applicable to the return rate date.',
    },
    {
        name: 'ReturnRateValuationDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42711,
        description:
            'Specifies the anchor date when the return rate valuation dates are relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'ReturnRateValuationDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42712,
        description: 'Time unit multiplier for the relative return rate valuation date offset.',
    },
    {
        name: 'ReturnRateValuationDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42713,
        description: 'Time unit associated with the relative return rate valuation date offset.',
    },
    {
        name: 'ReturnRateValuationDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42714,
        description: 'Specifies the day type of the relative return rate valuation date offset.',
    },
    {
        name: 'ReturnRateValuationStartDateUnadjusted',
        abbrName: 'StartDtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42715,
        description:
            'The unadjusted start date for return rate valuation. This can be used to restrict the range of dates when they are relative.',
    },
    {
        name: 'ReturnRateValuationStartDateRelativeTo',
        abbrName: 'StartDtReltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42716,
        description:
            'Specifies the anchor date when the return rate valuation start date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'ReturnRateValuationStartDateOffsetPeriod',
        abbrName: 'StartDtOfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42717,
        description: 'Time unit multiplier for the relative return rate valuation start date offset.',
    },
    {
        name: 'ReturnRateValuationStartDateOffsetUnit',
        abbrName: 'StartDtOfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42718,
        description: 'Time unit associated with the relative return rate valuation start date offset.',
    },
    {
        name: 'ReturnRateValuationStartDateOffsetDayType',
        abbrName: 'StartDtOfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42719,
        description: 'Specifies the day type of the relative return rate valuation start date offset.',
    },
    {
        name: 'ReturnRateValuationStartDateAdjusted',
        abbrName: 'StartDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42720,
        description:
            'The adjusted start date for return rate valuation. This can be used to restrict the range of dates when they are relative.',
    },
    {
        name: 'ReturnRateValuationEndDateUnadjusted',
        abbrName: 'EndDtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42721,
        description:
            'The unadjusted end date for return rate valuation. This can be used to restrict the range of dates when they are relative.',
    },
    {
        name: 'ReturnRateValuationEndDateRelativeTo',
        abbrName: 'EndDtReltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42722,
        description:
            'Specifies the anchor date when the return rate valuation end date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'ReturnRateValuationEndDateOffsetPeriod',
        abbrName: 'EndDtOfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42723,
        description: 'Time unit multiplier for the relative return rate valuation end date offset.',
    },
    {
        name: 'ReturnRateValuationEndDateOffsetUnit',
        abbrName: 'EndDtOfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42724,
        description: 'Time unit associated with the relative return rate valuation end date offset.',
    },
    {
        name: 'ReturnRateValuationEndDateOffsetDayType',
        abbrName: 'EndDtOfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42725,
        description: 'Specifies the day type of the relative return rate valuation end date offset.',
    },
    {
        name: 'ReturnRateValuationEndDateAdjusted',
        abbrName: 'EndDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42726,
        description:
            'The adjusted end date for return rate valuation. This can be used to restrict the range of dates when they are relative.',
    },
    {
        name: 'ReturnRateValuationFrequencyPeriod',
        abbrName: 'FreqPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42727,
        description: 'Time unit multiplier for the frequency at which return rate valuation dates occur.',
    },
    {
        name: 'ReturnRateValuationFrequencyUnit',
        abbrName: 'FreqUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'CouponFrequencyUnitCodeSet',
        id: 42728,
        description: 'Time unit associated with the frequency at which return rate valuation dates occur.',
    },
    {
        name: 'ReturnRateValuationFrequencyRollConvention',
        abbrName: 'Roll',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'DateRollConventionCodeSet',
        id: 42729,
        description:
            'The convention for determining the sequence of return rate valuation dates. It is used in conjunction with a specified frequency.',
    },
    {
        name: 'ReturnRateValuationDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 42730,
        description: 'The return rate valuation dates business day convention.',
    },
    {
        name: 'NoReturnRateFXConversions',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42731,
        description: 'Number of iterations in the return rate FX conversion repeating group.',
    },
    {
        name: 'ReturnRateFXCurrencySymbol',
        abbrName: 'CcySym',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42732,
        description:
            'Specifies the currency pair for the FX conversion expressed using the CCY1/CCY2 convention. Uses ISO 4217 currency codes.',
    },
    {
        name: 'ReturnRateFXRate',
        abbrName: 'FxRt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 42733,
        description: 'The rate of exchange between the two currencies specified in ReturnRateFXCurrencySymbol(42732).',
    },
    {
        name: 'ReturnRateFXRateCalc',
        abbrName: 'FxRtCalc',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'SettlCurrFxRateCalcCodeSet',
        id: 42734,
        description: 'Specifies whether ReturnRateFXRate(42733) should be multiplied or divided.',
    },
    {
        name: 'NoReturnRates',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42735,
        description: 'Number of iterations in the return rate repeating group.',
    },
    {
        name: 'ReturnRatePriceSequence',
        abbrName: 'PxSeq',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'ReturnRatePriceSequenceCodeSet',
        id: 42736,
        description: 'Specifies the type of price sequence of the return rate.',
    },
    {
        name: 'ReturnRateCommissionBasis',
        abbrName: 'CommBasis',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'CommTypeCodeSet',
        id: 42737,
        description: 'Specifies the basis or unit used to calculate the commission.',
    },
    {
        name: 'ReturnRateCommissionAmount',
        abbrName: 'CommAmt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 42738,
        description: 'The commission amount.',
    },
    {
        name: 'ReturnRateCommissionCurrency',
        abbrName: 'CommCcy',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 42739,
        description: 'Specifies the currency the commission amount is denominated in. Uses ISO 4217 currency codes.',
    },
    {
        name: 'ReturnRateTotalCommissionPerTrade',
        abbrName: 'TotCommPerTrd',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 42740,
        description: 'The total commission per trade.',
    },
    {
        name: 'ReturnRateDeterminationMethod',
        abbrName: 'DtrmnMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42741,
        description:
            'Specifies the method by which the underlier prices are determined.\n\nSee http://www.fpml.org/coding-scheme/determination-method for values.',
    },
    {
        name: 'ReturnRateAmountRelativeTo',
        abbrName: 'AmtReltv',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42742,
        description:
            'Specifies the reference amount when the return rate amount is relative to another amount in the trade.\n\nSee http://www.fixtradingcommunity.org/codelists#Payment_Amount_Relative_To for code list of relative amounts.',
    },
    {
        name: 'ReturnRateQuoteMeasureType',
        abbrName: 'QteTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42743,
        description:
            "Specifies the type of the measure applied to the return rate's asset, e.g. valuation, sensitivity risk. This could be an NPV, a cash flow, a clean price, etc.\n\nSee http://www.fpml.org/coding-scheme/asset-measure for values.",
    },
    {
        name: 'ReturnRateQuoteUnits',
        abbrName: 'QteUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42744,
        description:
            'Specifies the units that the measure is expressed in. If not specified, the default is a price/value in currency units.\n\nSee http://www.fpml.org/coding-scheme/price-quote-units for values.',
    },
    {
        name: 'ReturnRateQuoteMethod',
        abbrName: 'QteMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'CashSettlQuoteMethodCodeSet',
        id: 42745,
        description: 'Specifies the type of quote used to determine the return rate of the swap.',
    },
    {
        name: 'ReturnRateQuoteCurrency',
        abbrName: 'QteCcy',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 42746,
        description: 'Specifies the currency the return rate quote is denominated in. Uses ISO 4217 Currency Code.',
    },
    {
        name: 'ReturnRateQuoteCurrencyType',
        abbrName: 'QteCcyTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42747,
        description:
            'Specifies the type of currency, e.g. settlement currency, base currency, etc., that the quote is reported in.\n\nSee http://www.fpml.org/coding-scheme/reporting-currency-type for values.',
    },
    {
        name: 'ReturnRateQuoteTimeType',
        abbrName: 'QteTmTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'ReturnRateQuoteTimeTypeCodeSet',
        id: 42748,
        description: 'Specifies how or the timing when the quote is to be obtained.',
    },
    {
        name: 'ReturnRateQuoteTime',
        abbrName: 'QteTm',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 42749,
        description: 'The time when the quote is to be generated.',
    },
    {
        name: 'ReturnRateQuoteDate',
        abbrName: 'QteDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42750,
        description: 'The date when the quote is to be generated.',
    },
    {
        name: 'ReturnRateQuoteExpirationTime',
        abbrName: 'QteExpTm',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 42751,
        description: 'The time when the quote ceases to be valid.',
    },
    {
        name: 'ReturnRateQuoteBusinessCenter',
        abbrName: 'QteBizCtr',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42752,
        description:
            'The business center calendar used for adjustments associated with ReturnRateQuoteTimeType(42748) or ReturnRateQuoteTime(42749) and ReturnRateQuoteDate(42750), e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'ReturnRateQuoteExchange',
        abbrName: 'QteExch',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Exchange',
        id: 42753,
        description:
            'Specifies the exchange (e.g. stock or listed futures/options exchange) from which the quote is obtained.',
    },
    {
        name: 'ReturnRateQuotePricingModel',
        abbrName: 'QteModel',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42754,
        description:
            'Specifies the pricing model used to evaluate the underlying asset price.\n\nSee http://www.fpml.org/coding-scheme/pricing-model for values.',
    },
    {
        name: 'ReturnRateCashFlowType',
        abbrName: 'CshFlow',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42755,
        description:
            'Specifies the type of cash flows, e.g. coupon payment, premium fee, settlement fee, etc.\n\nSee http://www.fpml.org/coding-scheme/cashflow-type for values.',
    },
    {
        name: 'ReturnRateValuationTimeType',
        abbrName: 'ValTmTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'ReturnRateQuoteTimeTypeCodeSet',
        id: 42756,
        description: 'Specifies the timing at which the calculation agent values the underlying.',
    },
    {
        name: 'ReturnRateValuationTime',
        abbrName: 'ValTm',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 42757,
        description: 'The time at which the calculation agent values the underlying asset.',
    },
    {
        name: 'ReturnRateValuationTimeBusinessCenter',
        abbrName: 'ValTmBizCtr',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42758,
        description:
            'The business center calendar used for adjustments associated with ReturnRateValuationTimeType(42756) or ReturnRateValuationTime(42757), e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'ReturnRateValuationPriceOption',
        abbrName: 'ValPxOpt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'ReturnRateValuationPriceOptionCodeSet',
        id: 42759,
        description: 'Indicates whether an ISDA price option applies, and if applicable which type of price.',
    },
    {
        name: 'ReturnRateFinalPriceFallback',
        abbrName: 'FnlPxFallbck',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventPVFinalPriceElectionFallbackCodeSet',
        id: 42760,
        description: 'Specifies the fallback provision for the hedging party in the determination of the final price.',
    },
    {
        name: 'NoReturnRateInformationSources',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42761,
        description: 'Number of iterations in the return rate information source repeating group.',
    },
    {
        name: 'ReturnRateInformationSource',
        abbrName: 'RtSrc',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'RateSourceCodeSet',
        id: 42762,
        description:
            'Identifies the source of rate information. For FX the references source to be used for the FX spot rate.',
    },
    {
        name: 'ReturnRateReferencePage',
        abbrName: 'RefPg',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42763,
        description:
            'Identifies the reference "page" from the rate source.\n\nFor FX, the reference page to the spot rate to be used for the reference FX spot rate.\n\nWhen ReturnRateInformationSource(42762) = 3 (ISDA Settlement Rate Option) this contains the value from the scheme that reflects the terms of the Annex A to the ISDA 1998 FX and Currency Option Definitions.\n\nSee: http://www.fpml.org/coding-scheme/settlement-rate-option',
    },
    {
        name: 'ReturnRateReferencePageHeading',
        abbrName: 'RefHdng',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42764,
        description: 'Identifies the page heading from the rate source.',
    },
    {
        name: 'NoReturnRatePrices',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42765,
        description: 'Number of iterations in the return rate price repeating group.',
    },
    {
        name: 'ReturnRatePriceBasis',
        abbrName: 'PxBasis',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'ReturnRatePriceBasisCodeSet',
        id: 42766,
        description: 'The basis of the return price.',
    },
    {
        name: 'ReturnRatePrice',
        abbrName: 'Px',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 42767,
        description: 'Specifies the price of the underlying swap asset.',
    },
    {
        name: 'ReturnRatePriceCurrency',
        abbrName: 'Ccy',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 42768,
        description: 'Specifies the currency of the price of the underlying swap asset. Uses ISO 4217 currency codes.',
    },
    {
        name: 'ReturnRatePriceType',
        abbrName: 'PxTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'ReturnRatePriceTypeCodeSet',
        id: 42769,
        description: 'Specifies whether the ReturnRatePrice(42767) is expressed in absolute or relative terms.',
    },
    {
        name: 'NoReturnRateValuationDateBusinessCenters',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42770,
        description: 'Number of iterations in the return rate valuation date business center repeating group.',
    },
    {
        name: 'ReturnRateValuationDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42771,
        description:
            'The business center calendar used for date adjustment of the return rate valuation unadjusted or relative dates, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'NoReturnRateValuationDates',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42772,
        description: 'Number of iterations in the return rate valuation date repeating group.',
    },
    {
        name: 'ReturnRateValuationDate',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42773,
        description: 'The return rate valuation date. Type of date is specified in ReturnRateValuationDateType(42774).',
    },
    {
        name: 'ReturnRateValuationDateType',
        abbrName: 'Typ',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NonDeliverableFixingDateTypeCodeSet',
        id: 42774,
        description: 'Specifies the type of return rate valuation date (e.g. adjusted for holidays).',
    },
    {
        name: 'NoSettlMethodElectionDateBusinessCenters',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42775,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'SettlMethodElectionDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42776,
        description:
            'The business center calendar used for date adjustment of the settlement method election unadjusted or relative date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'SettlMethodElectionDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42777,
        description: 'The unadjusted settlement method election date.',
    },
    {
        name: 'SettlMethodElectionDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 42778,
        description: 'The settlement method election date adjustment business day convention.',
    },
    {
        name: 'SettlMethodElectionDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42779,
        description:
            'Specifies the anchor date when the settlement method election date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'SettlMethodElectionDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42780,
        description: 'Time unit multiplier for the relative settlement method election date offset.',
    },
    {
        name: 'SettlMethodElectionDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42781,
        description: 'Time unit associated with the relative settlement method election date offset.',
    },
    {
        name: 'SettlMethodElectionDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42782,
        description: 'Specifies the day type of the relative settlement method election date offset.',
    },
    {
        name: 'SettlMethodElectionDateAdjusted',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42783,
        description: 'The adjusted settlement method election date.',
    },
    {
        name: 'StreamVersion',
        abbrName: 'Ver',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42784,
        description:
            'The stream version identifier when there have been modifications to the contract over time. Helps signal when there are embedded changes.',
    },
    {
        name: 'StreamVersionEffectiveDate',
        abbrName: 'VerEfctvDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42785,
        description: 'The effective date of the StreamVersion(42784).',
    },
    {
        name: 'StreamNotionalDeterminationMethod',
        abbrName: 'NotlDtrmnMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42786,
        description:
            'Specifies the method for determining the floating notional value for equity swaps.\n\nSee http://www.fpml.org/coding-scheme/determination-method for values.',
    },
    {
        name: 'StreamNotionalAdjustments',
        abbrName: 'NotlAdjmts',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'StreamNotionalAdjustmentsCodeSet',
        id: 42787,
        description:
            'For equity swaps this specifies the conditions that govern the adjustment to the number of units of the swap.',
    },
    {
        name: 'NoUnderlyingCashSettlDateBusinessCenters',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42788,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'UnderlyingCashSettlDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42789,
        description:
            'The business center calendar used for date adjustment of the cash settlement unadjusted or relative date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'UnderlyingCashSettlDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42790,
        description: 'The unadjusted cash settlement date.',
    },
    {
        name: 'UnderlyingCashSettlDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 42791,
        description:
            "The business day convention used to adjust the cash settlement provision's date. Used only to override the business day convention defined in the UnderlyingInstrument component.",
    },
    {
        name: 'UnderlyingCashSettlDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42792,
        description:
            'Specifies the anchor date when the cash settlement date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'UnderlyingCashSettlDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42793,
        description: 'Time unit multiplier for the relative cash settlement date offset.',
    },
    {
        name: 'UnderlyingCashSettlDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42794,
        description: 'Time unit associated with the relative cash settlement date offset.',
    },
    {
        name: 'UnderlyingCashSettlDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42795,
        description: 'Specifies the day type of the relative cash settlement date offset.',
    },
    {
        name: 'UnderlyingCashSettlDateAdjusted',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42796,
        description: 'The adjusted cash settlement date.',
    },
    {
        name: 'UnderlyingCashSettlPriceSource',
        abbrName: 'PxSrc',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42797,
        description:
            'The source from which the settlement price is to be obtained.\n\nSee http://www.fpml.org/coding-scheme/settlement-price-source for values.',
    },
    {
        name: 'UnderlyingCashSettlPriceDefault',
        abbrName: 'PxDflt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'CashSettlPriceDefaultCodeSet',
        id: 42798,
        description: 'The default election for determining settlement price.',
    },
    {
        name: 'UnderlyingComplexEventFuturesPriceValuation',
        abbrName: 'FutPxVal',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2611,
        description:
            'Indicates whether the official settlement price as announced by the related exchange is applicable, in accordance with the ISDA 2002 definitions. Applicable only to futures contracts.',
    },
    {
        name: 'UnderlyingComplexEventOptionsPriceValuation',
        abbrName: 'OptPxVal',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2612,
        description:
            'Indicates whether the official settlement price as announced by the related exchange is applicable, in accordance with the ISDA 2002 definitions. Applicable only to options contracts.',
    },
    {
        name: 'UnderlyingComplexEventPVFinalPriceElectionFallback',
        abbrName: 'PVPxFallbck',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventPVFinalPriceElectionFallbackCodeSet',
        id: 2613,
        description:
            'Specifies the fallback provisions for the hedging party in the determination of the final settlement price',
    },
];

const batch8: ISpecFields[] = [
    {
        name: 'NoUnderlyingDividendAccrualPaymentDateBusinessCenters',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42799,
        description: 'Number of entries in the UnderlyingDividendAccrualPaymentDateBusinessCenterGrp.',
    },
    {
        name: 'UnderlyingDividendAccrualPaymentDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42800,
        description:
            'The business center calendar used for date adjustment of the instrument\'s dividend accrual payment date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'UnderlyingDividendFloatingRateIndex',
        abbrName: 'Ndx',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42801,
        description: 'The dividend accrual floating rate index.',
    },
    {
        name: 'UnderlyingDividendFloatingRateIndexCurvePeriod',
        abbrName: 'NdxPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42802,
        description: 'Time unit multiplier for the dividend accrual floating rate index curve.',
    },
    {
        name: 'UnderlyingDividendFloatingRateIndexCurveUnit',
        abbrName: 'NdxUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexCurveUnitCodeSet',
        id: 42803,
        description: 'Time unit associated with the dividend accrual floating rate index curve period.',
    },
    {
        name: 'UnderlyingDividendFloatingRateMultiplier',
        abbrName: 'RtMult',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 42804,
        description:
            'A rate multiplier to apply to the floating rate. The multiplier can be less than or greater than 1 (one). This should only be included if the multiplier is not equal to 1 (one) for the term of the contract.',
    },
    {
        name: 'UnderlyingDividendFloatingRateSpread',
        abbrName: 'Spread',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 42805,
        description: 'The basis points spread from the index specified in UnderlyingDividendFloatingRateIndex(42801).',
    },
    {
        name: 'UnderlyingDividendFloatingRateSpreadPositionType',
        abbrName: 'SpreadPosTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
        id: 42806,
        description: 'Identifies whether the rate spread is applied to a long or short position.',
    },
    {
        name: 'UnderlyingDividendFloatingRateTreatment',
        abbrName: 'RtTrtmt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateTreatmentCodeSet',
        id: 42807,
        description: 'Specifies the yield calculation treatment for the index.',
    },
    {
        name: 'UnderlyingDividendCapRate',
        abbrName: 'CapRt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 42808,
        description:
            'The cap rate, if any, which applies to the floating rate. It is only required where the floating rate is capped at a certain level. The cap rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A cap rate of 5% would be represented as "0.05".',
    },
    {
        name: 'UnderlyingDividendCapRateBuySide',
        abbrName: 'CapRtBuy',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamCapRateBuySideCodeSet',
        id: 42809,
        description: 'Reference to the buyer of the cap rate option through its trade side.',
    },
    {
        name: 'UnderlyingDividendCapRateSellSide',
        abbrName: 'CapRtSell',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamCapRateBuySideCodeSet',
        id: 42810,
        description: 'Reference to the seller of the cap rate option through its trade side.',
    },
    {
        name: 'UnderlyingDividendFloorRate',
        abbrName: 'FlrRt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 42811,
        description:
            'The floor rate, if any, which applies to the floating rate. The floor rate (strike) is only required where the floating rate is floored at a certain strike level. The floor rate is assumed to be exclusive of any spread and is a per annum rate. The rate is expressed as a decimal, e.g. 5% is represented as "0.05".',
    },
    {
        name: 'UnderlyingDividendFloorRateBuySide',
        abbrName: 'FlrRtBuy',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamFloorRateBuySideCodeSet',
        id: 42812,
        description: 'Reference to the buyer of the floor rate option through its trade side.',
    },
    {
        name: 'UnderlyingDividendFloorRateSellSide',
        abbrName: 'FlrRtSell',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamFloorRateBuySideCodeSet',
        id: 42813,
        description: 'Reference to the seller of the floor rate option through its trade side.',
    },
    {
        name: 'UnderlyingDividendInitialRate',
        abbrName: 'InitRt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 42814,
        description:
            'The initial floating rate reset agreed between the principal parties involved in the trade. This is assumed to be the first required reset rate for the first regular calculation period. It should only be included when the rate is not equal to the rate published on the source implied by the floating rate index. The initial rate is expressed in decimal form, e.g. 5% is represented as "0.05".',
    },
    {
        name: 'UnderlyingDividendFinalRateRoundingDirection',
        abbrName: 'FnlRtRndDirctn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'RoundingDirectionCodeSet',
        id: 42815,
        description: 'Specifies the rounding direction of the final rate.',
    },
    {
        name: 'UnderlyingDividendFinalRatePrecision',
        abbrName: 'FnlRtPrcsn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42816,
        description:
            'Specifies the rounding precision of the final rate in terms of a number of decimal places. Note how a percentage rate rounding of 5 decimal places is expressed as a rounding precision of 7.',
    },
    {
        name: 'UnderlyingDividendAveragingMethod',
        abbrName: 'AvgngMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamAveragingMethodCodeSet',
        id: 42817,
        description:
            'When averaging is applicable, used to specify whether a weighted or unweighted average method of calculation is to be used.',
    },
    {
        name: 'UnderlyingDividendNegativeRateTreatment',
        abbrName: 'NegtvRtTrtmt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamNegativeRateTreatmentCodeSet',
        id: 42818,
        description:
            'The specification of any provisions for calculating payment obligations when a floating rate is negative (either due to a quoted negative floating rate or by operation of a spread that is subtracted from the floating rate).',
    },
    {
        name: 'UnderlyingDividendAccrualPaymentDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42819,
        description:
            'Specifies the anchor date when the accrual payment date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'UnderlyingDividendAccrualPaymentDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42820,
        description: 'Time unit multiplier for the relative accrual payment date offset.',
    },
    {
        name: 'UnderlyingDividendAccrualPaymentDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42821,
        description: 'Time unit associated with the relative accrual payment date offset.',
    },
    {
        name: 'UnderlyingDividendAccrualPaymentDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42822,
        description: 'Specifies the day type of the relative accrual payment date offset.',
    },
    {
        name: 'UnderlyingDividendAccrualPaymentDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42823,
        description: 'The unadjusted accrual payment date.',
    },
    {
        name: 'UnderlyingDividendAccrualPaymentDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 42824,
        description: 'Accrual payment date adjustment business day convention.',
    },
    {
        name: 'UnderlyingDividendAccrualPaymentDateAdjusted',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42825,
        description: 'The adjusted accrual payment date.',
    },
    {
        name: 'UnderlyingDividendReinvestmentIndicator',
        abbrName: 'RnvstmntInd',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42826,
        description: 'Indicates whether the dividend will be reinvested.',
    },
    {
        name: 'UnderlyingDividendEntitlementEvent',
        abbrName: 'EntlmntEvnt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'DividendEntitlementEventCodeSet',
        id: 42827,
        description: 'Defines the contract event which the receiver of the derivative is entitled to the dividend.',
    },
    {
        name: 'UnderlyingDividendAmountType',
        abbrName: 'AmtTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'DividendAmountTypeCodeSet',
        id: 42828,
        description: 'Indicates how the gross cash dividend amount per share is determined.',
    },
    {
        name: 'UnderlyingDividendUnderlierRefID',
        abbrName: 'UndlrRefID',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42829,
        description:
            "References the dividend underlier through the instrument's UnderlyingSecurityID(309) which must be fully specified in a separate instance of the UnderlyingInstrument component.",
    },
    {
        name: 'UnderlyingExtraordinaryDividendPartySide',
        abbrName: 'ExtrordSide',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamCapRateBuySideCodeSet',
        id: 42830,
        description:
            'Reference to the party through its side in the trade who makes the determination whether dividends are extraordinary in relation to normal levels.',
    },
    {
        name: 'UnderlyingExtraordinaryDividendAmountType',
        abbrName: 'ExtrordAmtTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'DividendAmountTypeCodeSet',
        id: 42831,
        description: 'Indicates how the extraordinary gross cash dividend per share is determined.',
    },
    {
        name: 'UnderlyingExtraordinaryDividendCurrency',
        abbrName: 'ExtrordCcy',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 42832,
        description: 'The currency in which the excess dividend is denominated. Uses ISO 4217 currency codes.',
    },
    {
        name: 'UnderlyingExtraordinaryDividendDeterminationMethod',
        abbrName: 'ExtrordDtrmnMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42833,
        description:
            'Specifies the method in which the excess amount is determined.\n\nSee http://www.fpml.org/coding-scheme/determination-method for values.',
    },
    {
        name: 'UnderlyingDividendAccrualFixedRate',
        abbrName: 'AcrlFixedRt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 42834,
        description:
            'The dividend accrual fixed rate per annum expressed as a decimal.\n\nA value of 5% would be represented as "0.05".',
    },
    {
        name: 'UnderlyingDividendCompoundingMethod',
        abbrName: 'CmpndgMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamCompoundingMethodCodeSet',
        id: 42835,
        description:
            'The compounding method to be used when more than one dividend period contributes to a single payment.',
    },
    {
        name: 'UnderlyingDividendNumOfIndexUnits',
        abbrName: 'NumNdxUnits',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42836,
        description: 'The number of index units applicable to dividends.',
    },
    {
        name: 'UnderlyingDividendCashPercentage',
        abbrName: 'CshPctage',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 42837,
        description: 'Declared cash dividend percentage.\n\nA value of 5% would be represented as "0.05".',
    },
    {
        name: 'UnderlyingDividendCashEquivalentPercentage',
        abbrName: 'CshEqvlntPctage',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 42838,
        description: 'Declared cash-equivalent dividend percentage. A value of 5% would be represented as "0.05".',
    },
    {
        name: 'UnderlyingNonCashDividendTreatment',
        abbrName: 'NonCshTrtmt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NonCashDividendTreatmentCodeSet',
        id: 42839,
        description: 'Defines the treatment of non-cash dividends.',
    },
    {
        name: 'UnderlyingDividendComposition',
        abbrName: 'Cmpstn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'DividendCompositionCodeSet',
        id: 42840,
        description: 'Defines how the composition of dividends is to be determined.',
    },
    {
        name: 'UnderlyingSpecialDividendsIndicator',
        abbrName: 'SpeclDividendInd',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42841,
        description: 'Indicates whether special dividends are applicable.',
    },
    {
        name: 'UnderlyingMaterialDividendsIndicator',
        abbrName: 'MtrlDividendInd',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42842,
        description: 'Indicates whether material non-cash dividends are applicable.',
    },
    {
        name: 'UnderlyingOptionsExchangeDividendsIndicator',
        abbrName: 'ExchDividendInd',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42843,
        description: 'Indicates whether option exchange dividends are applicable.',
    },
    {
        name: 'UnderlyingAdditionalDividendsIndicator',
        abbrName: 'AddtnlDividendInd',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42844,
        description: 'Indicates whether additional dividends are applicable.',
    },
    {
        name: 'UnderlyingAllDividendsIndicator',
        abbrName: 'AllDividendInd',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42845,
        description:
            "Represents the European Master Confirmation value of 'All Dividends' which, when applicable, signifies that, for a given Ex-Date, the daily observed share price for that day is adjusted (reduced) by the cash dividend and/or the cash value of any non-cash dividend per share (including extraordinary dividends) declared by the issuer.",
    },
    {
        name: 'UnderlyingDividendFXTriggerDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42846,
        description:
            'Specifies the anchor date when the FX trigger date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'UnderlyingDividendFXTriggerDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42847,
        description: 'Time unit multiplier for the relative FX trigger date offset.',
    },
    {
        name: 'UnderlyingDividendFXTriggerDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42848,
        description: 'Time unit associated with the relative FX trigger date offset.',
    },
    {
        name: 'UnderlyingDividendFXTriggerDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42849,
        description: 'Specifies the day type of the relative FX trigger date offset.',
    },
    {
        name: 'UnderlyingDividendFXTriggerDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42850,
        description: 'The unadjusted FX trigger date.',
    },
    {
        name: 'UnderlyingDividendFXTriggerDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 42851,
        description: 'The business day convention used for the FX trigger date adjustment.',
    },
    {
        name: 'UnderlyingDividendFXTriggerDateAdjusted',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42852,
        description: 'The adjusted FX trigger date.',
    },
    {
        name: 'NoUnderlyingDividendFXTriggerDateBusinessCenters',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42853,
        description: 'Number of entries in the UnderlyingDividendFXTriggerDateBusinessCenterGrp.',
    },
    {
        name: 'UnderlyingDividendFXTriggerDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42854,
        description:
            'The business center calendar used for date adjustment of the instrument\'s FX trigger date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'NoUnderlyingDividendPayments',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42855,
        description: 'Number of entries in the repeating group.',
    },
    {
        name: 'UnderlyingDividendPaymentDate',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42856,
        description: 'Specifies the date that the dividend or coupon payment is due.',
    },
    {
        name: 'UnderlyingDividendPaymentAmount',
        abbrName: 'Amt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 42857,
        description: 'The amount of the dividend or coupon payment.',
    },
    {
        name: 'UnderlyingDividendPaymentCurrency',
        abbrName: 'Ccy',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 42858,
        description:
            'Specifies the currency the UnderlyingDividendPaymentAmount(42857) is denominated in. Uses ISO 4217 currency codes.',
    },
    {
        name: 'UnderlyingDividendAccruedInterest',
        abbrName: 'AcrdInt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 42859,
        description: 'Accrued interest on the dividend or coupon payment.',
    },
    {
        name: 'UnderlyingDividendPayoutRatio',
        abbrName: 'Ratio',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 42860,
        description: 'Specifies the actual dividend payout ratio associated with the equity or bond underlier.',
    },
    {
        name: 'UnderlyingDividendPayoutConditions',
        abbrName: 'Conds',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42861,
        description:
            'Specifies the dividend payout conditions that will be applied in the case where the actual ratio is not known, typically because of regulatory or legal uncertainties.',
    },
    {
        name: 'NoUnderlyingDividendPeriods',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42862,
        description: 'Number of entries in the UnderlyingDividendPeriodGrp component.',
    },
    {
        name: 'UnderlyingDividendPeriodSequence',
        abbrName: 'Seq',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42863,
        description: 'Defines the ordinal dividend period. E.g. 1 = First period, 2 = Second period, etc.',
    },
    {
        name: 'UnderlyingDividendPeriodStartDateUnadjusted',
        abbrName: 'StartDtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42864,
        description: 'The unadjusted date on which the dividend period will begin.',
    },
    {
        name: 'UnderlyingDividendPeriodEndDateUnadjusted',
        abbrName: 'EndDtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42865,
        description: 'The unadjusted date on which the dividend period will end.',
    },
    {
        name: 'UnderlyingDividendPeriodUnderlierRefID',
        abbrName: 'UndlrRefID',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42866,
        description:
            "References the dividend underlier through the instrument's UnderlyingSecurityID(309) which must be fully specified in an instance of the UnderlyingInstrument component.",
    },
    {
        name: 'UnderlyingDividendPeriodStrikePrice',
        abbrName: 'StrkPx',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 42867,
        description: 'Specifies the fixed strike price of the dividend period.',
    },
    {
        name: 'UnderlyingDividendPeriodBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 42868,
        description: 'The dividend period dates business day convention.',
    },
    {
        name: 'UnderlyingDividendPeriodValuationDateUnadjusted',
        abbrName: 'ValDtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42869,
        description: 'The unadjusted dividend period valuation date.',
    },
    {
        name: 'UnderlyingDividendPeriodValuationDateRelativeTo',
        abbrName: 'ValDtReltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42870,
        description:
            'Specifies the anchor date when the dividend period valuation date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'UnderlyingDividendPeriodValuationDateOffsetPeriod',
        abbrName: 'ValDtOfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42871,
        description: 'Time unit multiplier for the relative dividend period valuation date offset.',
    },
    {
        name: 'UnderlyingDividendPeriodValuationDateOffsetUnit',
        abbrName: 'ValDtOfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42872,
        description: 'Time unit associated with the relative dividend period valuation date offset.',
    },
    {
        name: 'UnderlyingDividendPeriodValuationDateOffsetDayType',
        abbrName: 'ValDtOfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42873,
        description: 'Specifies the day type of the relative dividend period valuation date offset.',
    },
    {
        name: 'UnderlyingDividendPeriodValuationDateAdjusted',
        abbrName: 'ValDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42874,
        description: 'The adjusted dividend period valuation date.',
    },
    {
        name: 'UnderlyingDividendPeriodPaymentDateUnadjusted',
        abbrName: 'PmtDtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42875,
        description: 'The unadjusted dividend period payment date.',
    },
    {
        name: 'UnderlyingDividendPeriodPaymentDateRelativeTo',
        abbrName: 'PmtDtReltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42876,
        description:
            'Specifies the anchor date when the dividend period payment date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'UnderlyingDividendPeriodPaymentDateOffsetPeriod',
        abbrName: 'PmtDtOfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42877,
        description: 'Time unit multiplier for the relative dividend period payment date offset.',
    },
    {
        name: 'UnderlyingDividendPeriodPaymentDateOffsetUnit',
        abbrName: 'PmtDtOfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42878,
        description: 'Time unit associated with the relative dividend period payment date offset.',
    },
    {
        name: 'UnderlyingDividendPeriodPaymentDateOffsetDayType',
        abbrName: 'PmtDtOfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42879,
        description: 'Specifies the day type of the relative dividend period payment date offset.',
    },
    {
        name: 'UnderlyingDividendPeriodPaymentDateAdjusted',
        abbrName: 'PmtDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42880,
        description: 'The adjusted dividend period payment date.',
    },
    {
        name: 'UnderlyingDividendPeriodXID',
        abbrName: 'XID',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'XID',
        id: 42881,
        description:
            'Identifier for linking this stream dividend period to an underlier through an instance of RelatedInstrumentGrp.',
    },
    {
        name: 'NoUnderlyingDividendPeriodBusinessCenters',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42882,
        description: 'Number of entries in UnderlyingDividendPeriodBusinessCenterGrp.',
    },
    {
        name: 'UnderlyingDividendPeriodBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42883,
        description:
            'The business center calendar used for date adjustment of the instrument\'s dividend period date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'NoUnderlyingExtraordinaryEvents',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42884,
        description: 'Number of extraordinary events in the repeating group.',
    },
    {
        name: 'UnderlyingExtraordinaryEventType',
        abbrName: 'Typ',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42885,
        description:
            'Identifies the type of extraordinary or disruptive event applicable to UnderlyingExtraordinaryEventType(42885).\n\nSee http://www.fixtradingcommunity.org/codelists#Extraordinary_Event_Type for code list of extraordinary event types and values.',
    },
    {
        name: 'UnderlyingExtraordinaryEventValue',
        abbrName: 'Val',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42886,
        description:
            'The extraordinary or disruptive event value appropriate to UnderlyingExtraordinaryEventType(42885).\n\nSee http://www.fixtradingcommunity.org/codelists#Extraordinary_Event_Type for code list of extraordinary event types and values.',
    },
    {
        name: 'UnderlyingNotional',
        abbrName: 'Notl',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 2614,
        description: 'Notional value for the equity or bond underlier.',
    },
    {
        name: 'UnderlyingNotionalCurrency',
        abbrName: 'NotlCcy',
        updated: 'FIX.Latest',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        updatedEP: '273',
        id: 2615,
        description:
            'Specifies the currency denomination of the notional value.\n\nUnderlyingNotionalCurrencyCodeSource(2921) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.',
    },
    {
        name: 'UnderlyingNotionalDeterminationMethod',
        abbrName: 'NotlDtrmnMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2616,
        description:
            'Specifies the method of determining the notional amount.\n\nSee: http://www.fpml.org/coding-scheme/determination-method for values.',
    },
    {
        name: 'UnderlyingNotionalAdjustments',
        abbrName: 'NotlAdjmts',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'UnderlyingNotionalAdjustmentsCodeSet',
        id: 2617,
        description: 'Specifies the conditions that govern the adjustment to the number of units of the return swap.',
    },
    {
        name: 'UnderlyingNotionalXIDRef',
        abbrName: 'NotlXIDRef',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'XIDREF',
        id: 2619,
        description: 'Cross reference to another notional amount for duplicating its properties.',
    },
    {
        name: 'UnderlyingFutureID',
        abbrName: 'FutID',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2620,
        discriminatorId: '2621',
        description:
            'In the case of an index underlier specifies the unique identifier for the referenced futures contract.',
    },
    {
        name: 'UnderlyingFutureIDSource',
        abbrName: 'FutIDSrc',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.Latest',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'SecurityIDSourceCodeSet',
        updatedEP: '294',
        id: 2621,
        description: 'Identifies the source of the UnderlyingFutureID(2620).',
    },
    {
        name: 'UnderlyingStrikeIndexCurvePoint',
        abbrName: 'StrkNdxPnt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2622,
        description:
            'The point on the floating rate index curve. Sample values:\n\nM = combination of a number between 1-12 and an "M" for month, e.g. 3M\n\nY = combination of number between 1-100 and a "Y" for year, e.g. 10Y\n\n10Y-OLD = see above, then add "-OLD" when appropriate\n\nINTERPOLATED = the point is mathematically derived\n\n2/2031 5 3/8 = the point is stated via a combination of maturity month / year and coupon.',
    },
    {
        name: 'UnderlyingStrikeIndexQuote',
        abbrName: 'StrkNdxQte',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'StrikeIndexQuoteCodeSet',
        id: 2623,
        description: 'The quote side from which the index price is to be determined.',
    },
    {
        name: 'UnderlyingExtraordinaryEventAdjustmentMethod',
        abbrName: 'ExtrordEvntAdjMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'ExtraordinaryEventAdjustmentMethodCodeSet',
        id: 2624,
        description:
            'Defines how adjustments will be made to the contract should one or more of the extraordinary events occur.',
    },
    {
        name: 'UnderlyingExchangeLookAlike',
        abbrName: 'ExchLookAlike',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2625,
        description:
            "For a share option trade, indicates whether the instrument is to be treated as an 'exchange look-alike'.\n\nThis designation has significance for how share adjustments (arising from corporate actions) will be determined for the instrument. For an 'exchange look-alike' instrument the relevant share adjustments will follow that for a corresponding designated contract listed on the related exchange (referred to as Options Exchange Adjustment (ISDA defined term)), otherwise the share adjustments will be determined by the calculation agent (referred to as Calculation Agent Adjustment (ISDA defined term)).",
    },
    {
        name: 'UnderlyingAverageVolumeLimitationPercentage',
        abbrName: 'AvgLmtPctg',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 2626,
        description: 'The limit of average percentage of individual securities traded in a day or a number of days.',
    },
    {
        name: 'UnderlyingAverageVolumeLimitationPeriodDays',
        abbrName: 'AvgLmtDys',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2627,
        description: 'Specifies the limitation period for average daily trading volume in number of days.',
    },
    {
        name: 'UnderlyingDepositoryReceiptIndicator',
        abbrName: 'DpstryRcptInd',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2628,
        description:
            'Indicates whether the underlier is a depository receipt.\n\nA depository receipt is a negotiable certificate issued by a trust company or security depository.',
    },
    {
        name: 'UnderlyingOpenUnits',
        abbrName: 'OpnUnits',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 2629,
        description:
            'The number of units (units of the index or number of securities, par amount of a bond) that constitute the underlier. In the case of a basket swap, this is used to reference both the number of basket units, and the number of each asset components of the basket when these are expressed in absolute terms.',
    },
    {
        name: 'UnderlyingBasketDivisor',
        abbrName: 'BsktDvsr',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 2630,
        description:
            'Specifies the basket divisor amount. This value is normally used to adjust the constituent weight for pricing or to adjust for dividends, or other corporate actions.',
    },
    {
        name: 'UnderlyingInstrumentXID',
        abbrName: 'XID',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'XID',
        id: 2631,
        description:
            'Identifier for referencing this UnderlyingInstrument from a parent instrument or a convertible instrument.',
    },
    {
        name: 'UnderlyingSettlMethodElectingPartySide',
        abbrName: 'SettlMethElctngSide',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentPaySideCodeSet',
        id: 42887,
        description: 'Side value of the party electing the settlement method.',
    },
    {
        name: 'UnderlyingMakeWholeDate',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42888,
        description: 'The date through which the option cannot be exercised without penalty.',
    },
    {
        name: 'UnderlyingMakeWholeAmount',
        abbrName: 'Amt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 42889,
        description:
            'Amount to be paid by the buyer of the option if the option is exercised prior to the UnderlyingMakeWholeDate(42888).',
    },
    {
        name: 'UnderlyingMakeWholeBenchmarkCurveName',
        abbrName: 'Name',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42890,
        description: 'Identifies the benchmark floating rate index.',
    },
    {
        name: 'UnderlyingMakeWholeBenchmarkCurvePoint',
        abbrName: 'Point',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42891,
        description:
            'The point on the floating rate index curve.\n\nSample values:\n\nM = combination of a number between 1-12 and an "M" for month, e.g. 3M\n\nY = combination of number between 1-100 and a "Y" for year, e.g. 10Y\n\n10Y-OLD = see above, then add "-OLD" when appropriate\n\nINTERPOLATED = the point is mathematically derived\n\n2/2031 5 3/8 = the point is stated via a combination of maturity month / year and coupon.',
    },
    {
        name: 'UnderlyingMakeWholeRecallSpread',
        abbrName: 'Spread',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 42892,
        description: 'Spread over the floating rate index.',
    },
    {
        name: 'UnderlyingMakeWholeBenchmarkQuote',
        abbrName: 'Qte',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'StrikeIndexQuoteCodeSet',
        id: 42893,
        description: 'The quote side of the benchmark to be used for calculating the "make whole" amount.',
    },
    {
        name: 'UnderlyingMakeWholeInterpolationMethod',
        abbrName: 'IntrpltnMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamInflationInterpolationMethodCodeSet',
        id: 42894,
        description: 'The method used when calculating the "make whole" amount. The most common is linear method.',
    },
    {
        name: 'UnderlyingPaymentStreamCashSettlIndicator',
        abbrName: 'CshSettlInd',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42895,
        description: 'Indicates whether cash settlement is applicable.',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingXIDRef',
        abbrName: 'CmpndgXIDRef',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'XIDREF',
        id: 42896,
        description: 'Reference to the stream which details the compounding fixed or floating rate.',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingSpread',
        abbrName: 'CmpndgSpread',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 42897,
        description:
            'The spread to be used for compounding. Used in scenarios where the interest payment is based on a compounding formula that uses a compounding spread in addition to the regular spread.',
    },
    {
        name: 'UnderlyingPaymentStreamInterpolationMethod',
        abbrName: 'IntrpltnMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamInflationInterpolationMethodCodeSet',
        id: 42898,
        description:
            'The method used when calculating the index rate from multiple points on the curve. The most common is linear method.',
    },
    {
        name: 'UnderlyingPaymentStreamInterpolationPeriod',
        abbrName: 'IntrpltnPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamInterpolationPeriodCodeSet',
        id: 42899,
        description: 'Defines applicable periods for interpolation.',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingFixedRate',
        abbrName: 'CmpndgFixedRt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 42900,
        description: 'The compounding fixed rate applicable to the payment stream.',
    },
    {
        name: 'NoUnderlyingPaymentStreamCompoundingDates',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42901,
        description: 'Number of dates in the repeating group.',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingDate',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42902,
        description:
            'The compounding date. Type of date is specified in UnderlyingPaymentStreamCompoundingDateType(42903).',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingDateType',
        abbrName: 'Typ',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NonDeliverableFixingDateTypeCodeSet',
        id: 42903,
        description: 'Specifies the type of payment compounding date (e.g. adjusted for holidays).',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingDatesBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 42904,
        description: 'The compounding dates business day convention.',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingDatesRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42905,
        description:
            'Specifies the anchor date when the compounding dates are relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingDatesOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42906,
        description: 'Time unit multiplier for the relative compounding date offset.',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingDatesOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42907,
        description: 'Time unit associated with the relative compounding date offset.',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingDatesOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42908,
        description: 'Specifies the day type of the relative compounding date offset.',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingPeriodSkip',
        abbrName: 'Skip',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42909,
        description:
            'The number of periods in the "RelativeTo" schedule that are between each date in the compounding schedule. A skip of 2 would mean that compounding dates are relative to every second date in the "RelativeTo" schedule. If present this should have a value greater than 1.',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingFrequencyPeriod',
        abbrName: 'FreqPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42910,
        description: 'Time unit multiplier for the frequency at which compounding dates occur.',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingFrequencyUnit',
        abbrName: 'FreqUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'CouponFrequencyUnitCodeSet',
        id: 42911,
        description: 'Time unit associated with the frequency at which compounding dates occur.',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingRollConvention',
        abbrName: 'Roll',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'DateRollConventionCodeSet',
        id: 42912,
        description:
            'The convention for determining the sequence of compounding dates. It is used in conjunction with a specified frequency.',
    },
    {
        name: 'UnderlyingPaymentStreamBoundsFirstDateUnadjusted',
        abbrName: 'FirstDtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42913,
        description:
            'The unadjusted first date of the compounding schedule. This can be used to restrict the range of dates when they are relative.',
    },
    {
        name: 'UnderlyingPaymentStreamBoundsLastDateUnadjusted',
        abbrName: 'LastDtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42914,
        description:
            'The unadjusted last date of the compounding schedule. This can be used to restrict the range of dates when they are relative.',
    },
    {
        name: 'NoUnderlyingPaymentStreamCompoundingDatesBusinessCenters',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42915,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingDatesBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42916,
        description:
            'The business center calendar used for date adjustment of the payment stream compounding dates, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingEndDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42917,
        description: 'The unadjusted compounding end date.',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingEndDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42918,
        description:
            'Specifies the anchor date when the compounding end date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingEndDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42919,
        description: 'Time unit multiplier for the relative compounding end date offset.',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingEndDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42920,
        description: 'Time unit associated with the relative compounding end date offset.',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingEndDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42921,
        description: 'Specifies the day type of the relative compounding end date offset.',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingEndDateAdjusted',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42922,
        description: 'The adjusted compounding end date.',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingRateIndex',
        abbrName: 'Ndx',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42923,
        description: "The payment stream's compounding floating rate index.",
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingRateIndexCurvePeriod',
        abbrName: 'NdxPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42924,
        description: "Time unit multiplier for the payment stream's compounding floating rate index curve period.",
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingRateIndexCurveUnit',
        abbrName: 'NdxUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexCurveUnitCodeSet',
        id: 42925,
        description: "Time unit associated with the payment stream's compounding floating rate index curve period.",
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingRateMultiplier',
        abbrName: 'RtMult',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 42926,
        description:
            'A rate multiplier to apply to the compounding floating rate. The multiplier can be less than or greater than 1 (one). This should only be included if the multiplier is not equal to 1 (one) for the term of the stream.',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingRateSpread',
        abbrName: 'Spread',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 42927,
        description:
            'The basis points spread from the index specified in UnderlyingPaymentStreamCompoundingRateIndex(42923).',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingRateSpreadPositionType',
        abbrName: 'SpreadPosTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
        id: 42928,
        description: 'Identifies whether the rate spread is applied to a long or short position.',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingRateTreatment',
        abbrName: 'RtTrtmt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateTreatmentCodeSet',
        id: 42929,
        description: 'Specifies the yield calculation treatment for the index.',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingCapRate',
        abbrName: 'CapRt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 42930,
        description:
            'The cap rate, if any, which applies to the compounding floating rate. It is only required where the compounding floating rate on a swap stream is capped at a certain level. The cap rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A cap rate of 5% would be represented as "0.05".',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingCapRateBuySide',
        abbrName: 'CapRtBuy',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamCapRateBuySideCodeSet',
        id: 42931,
        description: 'Reference to the buyer of the compounding cap rate option through its trade side.',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingCapRateSellSide',
        abbrName: 'CapRtSell',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamCapRateBuySideCodeSet',
        id: 42932,
        description: 'Reference to the seller of the compounding cap rate option through its trade side.',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingFloorRate',
        abbrName: 'FlrRt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 42933,
        description:
            'The floor rate, if any, which applies to the compounding floating rate. The floor rate (strike) is only required where the compounding floating rate on a swap stream is floored at a certain strike level. The floor rate is assumed to be exclusive of any spread and is a per annum rate. The rate is expressed as a decimal, e.g. 5% is represented as "0.05".',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingFloorRateBuySide',
        abbrName: 'FlrRtBuy',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamFloorRateBuySideCodeSet',
        id: 42934,
        description: 'Reference to the buyer of the compounding floor rate option through its trade side.',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingFloorRateSellSide',
        abbrName: 'FlrRtSell',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamFloorRateBuySideCodeSet',
        id: 42935,
        description: 'Reference to the seller of the floor rate option through its trade side.',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingInitialRate',
        abbrName: 'InitRt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 42936,
        description:
            'The initial compounding floating rate reset agreed between the principal parties involved in the trade. It should only be included when the rate is not equal to the rate published on the source implied by the floating rate index. The initial rate is expressed in decimal form, e.g. 5% is represented as "0.05".',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingFinalRateRoundingDirection',
        abbrName: 'FnlRtRndDirctn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'RoundingDirectionCodeSet',
        id: 42937,
        description: 'Specifies the rounding direction for the compounding floating rate.',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingFinalRatePrecision',
        abbrName: 'FnlRtPrcsn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42938,
        description:
            'Specifies the compounding floating rate rounding precision in terms of a number of decimal places. Note how a percentage rate rounding of 5 decimal places is expressed as a rounding precision of 7.',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingAveragingMethod',
        abbrName: 'AvgngMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamAveragingMethodCodeSet',
        id: 42939,
        description:
            'Specifies the averaging method when compounding floating rate averaging is applicable (e.g. weighted or unweighted).',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingNegativeRateTreatment',
        abbrName: 'NegtvRtTrtmt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamNegativeRateTreatmentCodeSet',
        id: 42940,
        description:
            'Specifies the method for calculating payment obligations when a compounding floating rate is negative (either due to a quoted negative floating rate or by operation of a spread that is subtracted from the floating rate).',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingStartDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42941,
        description: 'The unadjusted compounding start date.',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingStartDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42942,
        description:
            'Specifies the anchor date when the compounding start date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingStartDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42943,
        description: 'Time unit multiplier for the relative compounding start date offset.',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingStartDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42944,
        description: 'Time unit associated with the relative compounding start date offset.',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingStartDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42945,
        description: 'Specifies the day type of the relative compounding start date offset.',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingStartDateAdjusted',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42946,
        description: 'The adjusted compounding start date.',
    },
    {
        name: 'UnderlyingPaymentStreamFormulaImageLength',
        abbrName: 'FrmlaImgLen',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 42947,
        description: 'Length in bytes of the UnderlyingPaymentStreamFormulaImage(42948) field.',
    },
    {
        name: 'UnderlyingPaymentStreamFormulaImage',
        abbrName: 'FrmlaImg',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 42948,
        lengthId: '42947',
        description: 'Image of the formula image when represented through an encoded clip in base64Binary.',
    },
    {
        name: 'UnderlyingPaymentStreamFinalPricePaymentDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42949,
        description: 'The unadjusted final price payment date.',
    },
    {
        name: 'UnderlyingPaymentStreamFinalPricePaymentDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42950,
        description:
            'Specifies the anchor date when the final price payment date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'UnderlyingPaymentStreamFinalPricePaymentDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42951,
        description: 'Time unit multiplier for the relative final price payment date offset.',
    },
    {
        name: 'UnderlyingPaymentStreamFinalPricePaymentDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42952,
        description: 'Time unit associated with the relative final price payment date offset.',
    },
    {
        name: 'UnderlyingPaymentStreamFinalPricePaymentDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42953,
        description: 'Specifies the day type of the relative final price payment date offset.',
    },
    {
        name: 'UnderlyingPaymentStreamFinalPricePaymentDateAdjusted',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42954,
        description: 'The adjusted final price payment date.',
    },
    {
        name: 'NoUnderlyingPaymentStreamFixingDates',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42955,
        description: 'Number of fixing dates in the repeating group.',
    },
    {
        name: 'UnderlyingPaymentStreamFixingDate',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42956,
        description: 'The fixing date. Type of date is specified in UnderlyingPaymentStreamFixingDateType(42957).',
    },
    {
        name: 'UnderlyingPaymentStreamFixingDateType',
        abbrName: 'Typ',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NonDeliverableFixingDateTypeCodeSet',
        id: 42957,
        description: 'Specifies the type of fixing date (e.g. adjusted for holidays).',
    },
    {
        name: 'UnderlyingPaymentStreamFirstObservationDateUnadjusted',
        abbrName: 'FirstObsvtnDtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42958,
        description: 'The unadjusted initial price observation date.',
    },
    {
        name: 'UnderlyingPaymentStreamFirstObservationDateRelativeTo',
        abbrName: 'FirstObsvtnReltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42959,
        description:
            'Specifies the anchor date when the initial price observation date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'UnderlyingPaymentStreamFirstObservationDateOffsetDayType',
        abbrName: 'FirstObsvtnOfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42960,
        description: 'Specifies the day type of the initial price observation date offset.',
    },
    {
        name: 'UnderlyingPaymentStreamFirstObservationDateAdjusted',
        abbrName: 'FirstObsvtnDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42961,
        description: 'The adjusted initial price observation date.',
    },
    {
        name: 'UnderlyingPaymentStreamUnderlierRefID',
        abbrName: 'UndlrRefID',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42962,
        description:
            "References the dividend underlier through the instrument's UnderlyingSecurityID(309) which must be fully specified in an instance of the UnderlyingInstrument component.",
    },
    {
        name: 'UnderlyingReturnRateNotionalReset',
        abbrName: 'RtnRtNotlReset',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42963,
        description:
            'Indicates whether the term "Equity Notional Reset" as defined in the ISDA 2002 Equity Derivatives Definitions is applicable ("Y") or not.',
    },
    {
        name: 'UnderlyingPaymentStreamLinkInitialLevel',
        abbrName: 'LinkInitLvl',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 42964,
        description: 'Price level at which the correlation or variance swap contract will strike.',
    },
    {
        name: 'UnderlyingPaymentStreamLinkClosingLevelIndicator',
        abbrName: 'LinkClsngLvl',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42965,
        description:
            'Indicates whether the correlation or variance swap contract will ("Y") strike off the closing level of the default exchange traded contract or not.',
    },
    {
        name: 'UnderlyingPaymentStreamLinkExpiringLevelIndicator',
        abbrName: 'LinkExpngLvl',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42966,
        description:
            'Indicates whether the correlation or variance swap contract will ("Y") strike off the expiring level of the default exchange traded contract or not.',
    },
    {
        name: 'UnderlyingPaymentStreamLinkEstimatedTradingDays',
        abbrName: 'LinkEstTrdgDays',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42967,
        description: 'The expected number of trading days in the variance or correlation swap stream.',
    },
    {
        name: 'UnderlyingPaymentStreamLinkStrikePrice',
        abbrName: 'LinkStrkPx',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 42968,
        description: 'The strike price of a correlation or variance swap stream.',
    },
    {
        name: 'UnderlyingPaymentStreamLinkStrikePriceType',
        abbrName: 'LinkStrkPxTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamLinkStrikePriceTypeCodeSet',
        id: 42969,
        description: 'For a variance swap specifies how UnderlyingPaymentStreamLinkStrikePrice(42968) is expressed.',
    },
    {
        name: 'UnderlyingPaymentStreamLinkMaximumBoundary',
        abbrName: 'LinkMaxBndry',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 42970,
        description:
            'Specifies the maximum or upper boundary for variance or strike determination.\n\nFor a variation swap stream all observations above this price level will be excluded from the variance calculation.\n\nFor a correlation swap stream the maximum boundary is a percentage of the strike price.',
    },
    {
        name: 'UnderlyingPaymentStreamLinkMinimumBoundary',
        abbrName: 'LinkMinBndry',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 42971,
        description:
            'Specifies the minimum or lower boundary for variance or strike determination.\n\nFor a variation swap stream all observations below this price level will be excluded from the variance calculation.\n\nFor a correlation swap stream the minimum boundary is a percentage of the strike price.',
    },
    {
        name: 'UnderlyingPaymentStreamLinkNumberOfDataSeries',
        abbrName: 'LinkNumDataSeries',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42972,
        description:
            'Number of data series for a correlation swap. Normal market practice is that correlation data sets are drawn from geographic market areas, such as America, Europe and Asia Pacific. Each of these geographic areas will have its own data series to avoid contagion.',
    },
    {
        name: 'UnderlyingPaymentStreamVarianceUnadjustedCap',
        abbrName: 'VarncCap',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 42973,
        description:
            'Indicates the scaling factor to be multiplied by the variance strike price thereby making variance cap applicable.',
    },
    {
        name: 'UnderlyingPaymentStreamRealizedVarianceMethod',
        abbrName: 'RlzdVarncMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRealizedVarianceMethodCodeSet',
        id: 42974,
        description: 'Indicates which price to use to satisfy the boundary condition.',
    },
    {
        name: 'UnderlyingPaymentStreamDaysAdjustmentIndicator',
        abbrName: 'DaysAdjmt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 42975,
        description:
            'Indicates whether the contract specifies that the notional should be scaled by the number of days in range divided by the estimate trading days or not. The number of "days in range" refers to the number of returns that contribute to the realized volatility.',
    },
    {
        name: 'UnderlyingPaymentStreamNearestExchangeContractRefID',
        abbrName: 'ExchCtrctRefID',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42976,
        description:
            "References a contract listed on an exchange through the instrument's UnderlyingSecurityID(309) which must be fully specified in an instance of the UnderlyingInstrument component.",
    },
    {
        name: 'UnderlyingPaymentStreamVegaNotionalAmount',
        abbrName: 'VegaNotlAmt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 42977,
        description:
            'Vega Notional represents the approximate gain/loss at maturity for a 1% difference between RVol (realised volatility) and KVol (strike volatility). It does not necessarily represent the Vega risk of the trade.',
    },
    {
        name: 'UnderlyingPaymentStreamFormulaCurrency',
        abbrName: 'Ccy',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 42978,
        description: 'The currency in which the formula amount is denominated. Uses ISO 4217 currency codes.',
    },
    {
        name: 'UnderlyingPaymentStreamFormulaCurrencyDeterminationMethod',
        abbrName: 'CcyDtrmnMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42979,
        description:
            'Specifies the method according to which the formula amount currency is determined.\n\nSee http://www.fpml.org/coding-scheme/determination-method for values.',
    },
    {
        name: 'UnderlyingPaymentStreamFormulaReferenceAmount',
        abbrName: 'RefAmt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42980,
        description:
            'Specifies the reference amount when this term either corresponds to the standard ISDA Definition (either the 2002 Equity Definition for the Equity Amount, or the 2000 Definition for the Interest Amount), or refers to a term defined elsewhere in the swap document.\n\nSee http://www.fixtradingcommunity.org/codelists#Payment_Amount_Relative_To for code list of reference amounts.',
    },
    {
        name: 'NoUnderlyingPaymentStreamFormulas',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42981,
        description: 'Number of formulas in the repeating group.',
    },
    {
        name: 'UnderlyingPaymentStreamFormula',
        abbrName: 'Frmla',
        updated: 'FIX.5.0SP2',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'XMLData',
        updatedEP: '259',
        id: 42982,
        lengthId: '43111',
        description:
            'Contains an XML representation of the formula. Defined for flexibility in choice of language (MathML, OpenMath or text).',
    },
    {
        name: 'UnderlyingPaymentStreamFormulaDesc',
        abbrName: 'Desc',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42983,
        description: 'A description of the math formula in UnderlyingPaymentStreamFormula(42982).',
    },
    {
        name: 'UnderlyingPaymentStubEndDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42984,
        description: 'The unadjusted stub end date.',
    },
    {
        name: 'UnderlyingPaymentStubEndDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 42985,
        description: 'The stub end date business day convention.',
    },
    {
        name: 'UnderlyingPaymentStubEndDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42986,
        description:
            'Specifies the anchor date when the stub end date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'UnderlyingPaymentStubEndDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42987,
        description: 'Time unit multiplier for the relative stub end date offset.',
    },
    {
        name: 'UnderlyingPaymentStubEndDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42988,
        description: 'Time unit associated with the relative stub end date offset.',
    },
    {
        name: 'UnderlyingPaymentStubEndDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42989,
        description: 'Specifies the day type of the relative stub end date offset.',
    },
    {
        name: 'UnderlyingPaymentStubEndDateAdjusted',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42990,
        description: 'The adjusted stub end date.',
    },
    {
        name: 'NoUnderlyingPaymentStubEndDateBusinessCenters',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 42991,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'UnderlyingPaymentStubEndDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 42992,
        description:
            'The business center calendar used for date adjustment of the payment stub end date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'UnderlyingPaymentStubStartDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42993,
        description: 'The unadjusted stub start date.',
    },
    {
        name: 'UnderlyingPaymentStubStartDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 42994,
        description: 'The stub start date business day convention.',
    },
    {
        name: 'UnderlyingPaymentStubStartDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42995,
        description:
            'Specifies the anchor date when the stub start date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'UnderlyingPaymentStubStartDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 42996,
        description: 'Time unit multiplier for the relative stub start date offset.',
    },
    {
        name: 'UnderlyingPaymentStubStartDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 42997,
        description: 'Time unit associated with the relative stub start date offset.',
    },
    {
        name: 'UnderlyingPaymentStubStartDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 42998,
        description: 'Specifies the day type of the relative stub start date offset.',
    },
    {
        name: 'UnderlyingPaymentStubStartDateAdjusted',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 42999,
        description: 'The adjusted stub start date.',
    },
    {
        name: 'NoUnderlyingPaymentStubStartDateBusinessCenters',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 43000,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'UnderlyingPaymentStubStartDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 43001,
        description:
            'The business center calendar used for date adjustment of the payment stub start date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'UnderlyingProvisionBreakFeeElection',
        abbrName: 'BrkFeeElctn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'ProvisionBreakFeeElectionCodeSet',
        id: 43002,
        description: 'Type of fee elected for the break provision.',
    },
    {
        name: 'UnderlyingProvisionBreakFeeRate',
        abbrName: 'BrkFeeRt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 43003,
        description:
            'Break fee election rate when the break fee is proportional to the notional. A fee rate of 5% would be represented as "0.05".',
    },
    {
        name: 'UnderlyingRateSpreadInitialValue',
        abbrName: 'InitVal',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 43004,
        description: 'Specifies the initial rate spread for a basket underlier.',
    },
    {
        name: 'NoUnderlyingRateSpreadSteps',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 43005,
        description: 'Number of entries in the repeating group.',
    },
    {
        name: 'UnderlyingRateSpreadStepDate',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 43006,
        description: 'The date that the rate spread step takes affect.',
    },
    {
        name: 'UnderlyingRateSpreadStepValue',
        abbrName: 'Val',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 43007,
        description: 'The the value of the new rate spread as of the UnderlyingRateSpreadStepDate(43006).',
    },
    {
        name: 'NoUnderlyingReturnRateDates',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 43008,
        description: 'Number of iterations in the return rate date repeating group.',
    },
    {
        name: 'UnderlyingReturnRateDateMode',
        abbrName: 'Mode',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'ReturnRateDateModeCodeSet',
        id: 43009,
        description: 'Specifies the valuation type applicable to the return rate date.',
    },
    {
        name: 'UnderlyingReturnRateValuationDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 43010,
        description:
            'Specifies the anchor date when the return rate valuation dates are relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'UnderlyingReturnRateValuationDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 43011,
        description: 'Time unit multiplier for the relative return rate valuation date offset.',
    },
    {
        name: 'UnderlyingReturnRateValuationDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 43012,
        description: 'Time unit associated with the relative return rate valuation date offset.',
    },
    {
        name: 'UnderlyingReturnRateValuationDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 43013,
        description: 'Specifies the day type of the relative return rate valuation date offset.',
    },
    {
        name: 'UnderlyingReturnRateValuationStartDateUnadjusted',
        abbrName: 'StartDtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 43014,
        description:
            'The unadjusted start date for return rate valuation. This can be used to restrict the range of dates when they are relative.',
    },
    {
        name: 'UnderlyingReturnRateValuationStartDateRelativeTo',
        abbrName: 'StartDtReltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 43015,
        description:
            'Specifies the anchor date when the return rate valuation start date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'UnderlyingReturnRateValuationStartDateOffsetPeriod',
        abbrName: 'StartDtOfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 43016,
        description: 'Time unit multiplier for the relative return rate valuation start date offset.',
    },
    {
        name: 'UnderlyingReturnRateValuationStartDateOffsetUnit',
        abbrName: 'StartDtOfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 43017,
        description: 'Time unit associated with the relative return rate valuation start date offset.',
    },
    {
        name: 'UnderlyingReturnRateValuationStartDateOffsetDayType',
        abbrName: 'StartDtOfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 43018,
        description: 'Specifies the day type of the relative return rate valuation start date offset.',
    },
    {
        name: 'UnderlyingReturnRateValuationStartDateAdjusted',
        abbrName: 'StartDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 43019,
        description:
            'The adjusted start date for return rate valuation. This can be used to restrict the range of dates when they are relative.',
    },
    {
        name: 'UnderlyingReturnRateValuationEndDateUnadjusted',
        abbrName: 'EndDtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 43020,
        description:
            'The unadjusted end date for return rate valuation. This can be used to restrict the range of dates when they are relative.',
    },
    {
        name: 'UnderlyingReturnRateValuationEndDateRelativeTo',
        abbrName: 'EndDtReltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 43021,
        description:
            'Specifies the anchor date when the return rate valuation end date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'UnderlyingReturnRateValuationEndDateOffsetPeriod',
        abbrName: 'EndDtOfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 43022,
        description: 'Time unit multiplier for the relative return rate valuation end date offset.',
    },
    {
        name: 'UnderlyingReturnRateValuationEndDateOffsetUnit',
        abbrName: 'EndDtOfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 43023,
        description: 'Time unit associated with the relative return rate valuation end date offset.',
    },
    {
        name: 'UnderlyingReturnRateValuationEndDateOffsetDayType',
        abbrName: 'EndDtOfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 43024,
        description: 'Specifies the day type of the relative return rate valuation end date offset.',
    },
    {
        name: 'UnderlyingReturnRateValuationEndDateAdjusted',
        abbrName: 'EndDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 43025,
        description:
            'The adjusted end date for return rate valuation. This can be used to restrict the range of dates when they are relative.',
    },
    {
        name: 'UnderlyingReturnRateValuationFrequencyPeriod',
        abbrName: 'FreqPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 43026,
        description: 'Time unit multiplier for the frequency at which return rate valuation dates occur.',
    },
    {
        name: 'UnderlyingReturnRateValuationFrequencyUnit',
        abbrName: 'FreqUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'CouponFrequencyUnitCodeSet',
        id: 43027,
        description: 'Time unit associated with the frequency at which return rate valuation dates occur.',
    },
    {
        name: 'UnderlyingReturnRateValuationFrequencyRollConvention',
        abbrName: 'Roll',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'DateRollConventionCodeSet',
        id: 43028,
        description:
            'The convention for determining the sequence of return rate valuation dates. It is used in conjunction with a specified frequency.',
    },
    {
        name: 'UnderlyingReturnRateValuationDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 43029,
        description: 'The return rate valuation dates business day convention.',
    },
    {
        name: 'NoUnderlyingReturnRateFXConversions',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 43030,
        description: 'Number of iterations in the return rate FX conversion repeating group.',
    },
    {
        name: 'UnderlyingReturnRateFXCurrencySymbol',
        abbrName: 'CcySym',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 43031,
        description:
            'Specifies the currency pair for the FX conversion expressed using the CCY1/CCY2 convention. Uses ISO 4217 currency codes.',
    },
    {
        name: 'UnderlyingReturnRateFXRate',
        abbrName: 'FxRt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 43032,
        description:
            'The rate of exchange between the two currencies specified in UnderlyingReturnRateFXCurrencySymbol(43031).',
    },
    {
        name: 'UnderlyingReturnRateFXRateCalc',
        abbrName: 'FxRtCalc',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'SettlCurrFxRateCalcCodeSet',
        id: 43033,
        description: 'Specifies whether UnderlyingReturnRateFXRate(43032) should be multiplied or divided.',
    },
    {
        name: 'NoUnderlyingReturnRates',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 43034,
        description: 'Number of iterations in the return rate repeating group.',
    },
    {
        name: 'UnderlyingReturnRatePriceSequence',
        abbrName: 'PxSeq',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'ReturnRatePriceSequenceCodeSet',
        id: 43035,
        description: 'Specifies the type of price sequence of the return rate.',
    },
    {
        name: 'UnderlyingReturnRateCommissionBasis',
        abbrName: 'CommBasis',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'CommTypeCodeSet',
        id: 43036,
        description: 'Specifies the basis or unit used to calculate the commission.',
    },
    {
        name: 'UnderlyingReturnRateCommissionAmount',
        abbrName: 'CommAmt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 43037,
        description: 'The commission amount.',
    },
    {
        name: 'UnderlyingReturnRateCommissionCurrency',
        abbrName: 'CommCcy',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 43038,
        description: 'Specifies the currency the commission amount is denominated in. Uses ISO 4217 currency codes.',
    },
    {
        name: 'UnderlyingReturnRateTotalCommissionPerTrade',
        abbrName: 'TotCommPerTrd',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 43039,
        description: 'The total commission per trade.',
    },
    {
        name: 'UnderlyingReturnRateDeterminationMethod',
        abbrName: 'DtrmnMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 43040,
        description:
            'Specifies the method by which the underlier prices are determined.\n\nSee http://www.fpml.org/coding-scheme/determination-method for values.',
    },
    {
        name: 'UnderlyingReturnRateAmountRelativeTo',
        abbrName: 'AmtReltv',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 43041,
        description:
            'Specifies the reference amount when the return rate amount is relative to another amount in the trade.\n\nSee http://www.fixtradingcommunity.org/codelists#Payment_Amount_Relative_To for code list of relative amounts.',
    },
    {
        name: 'UnderlyingReturnRateQuoteMeasureType',
        abbrName: 'QteTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 43042,
        description:
            "Specifies the type of the measure applied to the return rate's asset, e.g. valuation, sensitivity risk. This could be an NPV, a cash flow, a clean price, etc.\n\nSee http://www.fpml.org/coding-scheme/asset-measure for values.",
    },
    {
        name: 'UnderlyingReturnRateQuoteUnits',
        abbrName: 'QteUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 43043,
        description:
            'Specifies the units that the measure is expressed in. If not specified, the default is a price/value in currency units.\n\nSee http://www.fpml.org/coding-scheme/price-quote-units for values.',
    },
    {
        name: 'UnderlyingReturnRateQuoteMethod',
        abbrName: 'QteMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'CashSettlQuoteMethodCodeSet',
        id: 43044,
        description: 'Specifies the type of quote used to determine the return rate of the swap.',
    },
    {
        name: 'UnderlyingReturnRateQuoteCurrency',
        abbrName: 'QteCcy',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 43045,
        description: 'Specifies the currency the return rate quote is denominated in. Uses ISO 4217 Currency Code.',
    },
    {
        name: 'UnderlyingReturnRateQuoteCurrencyType',
        abbrName: 'QteCcyTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 43046,
        description:
            'Specifies the type of currency, e.g. settlement currency, base currency, etc., that the quote is reported in.\n\nSee http://www.fpml.org/coding-scheme/reporting-currency-type for values.',
    },
    {
        name: 'UnderlyingReturnRateQuoteTimeType',
        abbrName: 'QteTmTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'ReturnRateQuoteTimeTypeCodeSet',
        id: 43047,
        description: 'Specifies how or the timing when the quote is to be obtained.',
    },
    {
        name: 'UnderlyingReturnRateQuoteTime',
        abbrName: 'QteTm',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 43048,
        description: 'The time when the quote is to be generated.',
    },
    {
        name: 'UnderlyingReturnRateQuoteDate',
        abbrName: 'QteDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 43049,
        description: 'The date when the quote is to be generated.',
    },
    {
        name: 'UnderlyingReturnRateQuoteExpirationTime',
        abbrName: 'QteExpTm',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 43050,
        description: 'The time when the quote ceases to be valid.',
    },
    {
        name: 'UnderlyingReturnRateQuoteBusinessCenter',
        abbrName: 'QteBizCtr',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 43051,
        description:
            'The business center calendar used for adjustments associated with UnderlyingReturnRateQuoteTimeType(43047) or UnderlyingReturnRateQuoteTime(43048) and UnderlyingReturnRateQuoteDate(43049), e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'UnderlyingReturnRateQuoteExchange',
        abbrName: 'QteExch',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Exchange',
        id: 43052,
        description:
            'Specifies the exchange (e.g. stock or listed futures/options exchange) from which the quote is obtained.',
    },
    {
        name: 'UnderlyingReturnRateQuotePricingModel',
        abbrName: 'QteModel',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 43053,
        description:
            'Specifies the pricing model used to evaluate the underlying asset price.\n\nSee http://www.fpml.org/coding-scheme/pricing-model for values.',
    },
    {
        name: 'UnderlyingReturnRateCashFlowType',
        abbrName: 'CshFlow',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 43054,
        description:
            'Specifies the type of cash flows, e.g. coupon payment, premium fee, settlement fee, etc.\n\nSee http://www.fpml.org/coding-scheme/cashflow-type for values.',
    },
    {
        name: 'UnderlyingReturnRateValuationTimeType',
        abbrName: 'ValTmTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'ReturnRateQuoteTimeTypeCodeSet',
        id: 43055,
        description: 'Specifies the timing at which the calculation agent values the underlying.',
    },
    {
        name: 'UnderlyingReturnRateValuationTime',
        abbrName: 'ValTm',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktTime',
        id: 43056,
        description: 'The time at which the calculation agent values the underlying asset.',
    },
    {
        name: 'UnderlyingReturnRateValuationTimeBusinessCenter',
        abbrName: 'ValTmBizCtr',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 43057,
        description:
            'The business center calendar used for adjustments associated with UnderlyingReturnRateValuationTimeType(43055) or UnderlyingReturnRateValuationTime(43056) , e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'UnderlyingReturnRateValuationPriceOption',
        abbrName: 'ValPxOpt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'ReturnRateValuationPriceOptionCodeSet',
        id: 43058,
        description: 'Indicates whether an ISDA price option applies, and if applicable which type of price.',
    },
    {
        name: 'UnderlyingReturnRateFinalPriceFallback',
        abbrName: 'FnlPxFallbck',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'ComplexEventPVFinalPriceElectionFallbackCodeSet',
        id: 43059,
        description: 'Specifies the fallback provision for the hedging party in the determination of the final price.',
    },
    {
        name: 'NoUnderlyingReturnRateInformationSources',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 43060,
        description: 'Number of iterations in the return rate information source repeating group.',
    },
    {
        name: 'UnderlyingReturnRateInformationSource',
        abbrName: 'RtSrc',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'RateSourceCodeSet',
        id: 43061,
        description:
            'Identifies the source of rate information. For FX the references source to be used for the FX spot rate.',
    },
    {
        name: 'UnderlyingReturnRateReferencePage',
        abbrName: 'RefPg',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 43062,
        description:
            'Identifies the reference "page" from the rate source.\n\nFor FX, the reference page to the spot rate to be used for the reference FX spot rate.\n\nWhen UnderlyingReturnRateInformationSource(43061) = 3 (ISDA Settlement Rate Option) this contains the value from the scheme that reflects the terms of the Annex A to the ISDA 1998 FX and Currency Option Definitions.\n\nSee: http://www.fpml.org/coding-scheme/settlement-rate-option',
    },
    {
        name: 'UnderlyingReturnRateReferencePageHeading',
        abbrName: 'RefHdng',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 43063,
        description: 'Identifies the page heading from the rate source.',
    },
    {
        name: 'NoUnderlyingReturnRatePrices',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 43064,
        description: 'Number of iterations in the return rate price repeating group.',
    },
    {
        name: 'UnderlyingReturnRatePriceBasis',
        abbrName: 'PxBasis',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'ReturnRatePriceBasisCodeSet',
        id: 43065,
        description: 'The basis of the return price.',
    },
    {
        name: 'UnderlyingReturnRatePrice',
        abbrName: 'Px',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 43066,
        description: 'Specifies the price of the underlying swap asset.',
    },
    {
        name: 'UnderlyingReturnRatePriceCurrency',
        abbrName: 'Ccy',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        id: 43067,
        description: 'Specifies the currency of the price of the underlying swap asset. Uses ISO 4217 currency codes.',
    },
    {
        name: 'UnderlyingReturnRatePriceType',
        abbrName: 'PxTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'ReturnRatePriceTypeCodeSet',
        id: 43068,
        description:
            'Specifies whether the UnderlyingReturnRatePrice(43066) is expressed in absolute or relative terms.',
    },
    {
        name: 'NoUnderlyingReturnRateValuationDateBusinessCenters',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 43069,
        description: 'Number of iterations in the return rate valuation date business center repeating group.',
    },
    {
        name: 'UnderlyingReturnRateValuationDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 43070,
        description:
            'The business center calendar used for date adjustment of the return rate valuation unadjusted or relative dates, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'NoUnderlyingReturnRateValuationDates',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 43071,
        description: 'Number of iterations in the return rate valuation date repeating group.',
    },
    {
        name: 'UnderlyingReturnRateValuationDate',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 43072,
        description:
            'The return rate valuation date. Type of date is specified in UnderlyingReturnRateValuationDateType(43073).',
    },
    {
        name: 'UnderlyingReturnRateValuationDateType',
        abbrName: 'Typ',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NonDeliverableFixingDateTypeCodeSet',
        id: 43073,
        description: 'Specifies the type of return rate valuation date (e.g. adjusted for holidays).',
    },
    {
        name: 'NoUnderlyingSettlMethodElectionDateBusinessCenters',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 43074,
        description: 'Number of business centers in the repeating group.',
    },
    {
        name: 'UnderlyingSettlMethodElectionDateBusinessCenter',
        abbrName: 'Ctr',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 43075,
        description:
            'The business center calendar used for date adjustment of the settlement method election unadjusted or relative date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
    },
    {
        name: 'UnderlyingSettlMethodElectionDateUnadjusted',
        abbrName: 'DtUnadj',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 43076,
        description: 'The unadjusted settlement method election date.',
    },
    {
        name: 'UnderlyingSettlMethodElectionDateBusinessDayConvention',
        abbrName: 'BizDayCnvtn',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'BusinessDayConventionCodeSet',
        id: 43077,
        description: 'The settlement method election date adjustment business day convention.',
    },
    {
        name: 'UnderlyingSettlMethodElectionDateRelativeTo',
        abbrName: 'Reltv',
        unionDataType: 'Reserved1000Plus',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 43078,
        description:
            'Specifies the anchor date when the settlement method election date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
    },
    {
        name: 'UnderlyingSettlMethodElectionDateOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 43079,
        description: 'Time unit multiplier for the relative settlement method election date offset.',
    },
    {
        name: 'UnderlyingSettlMethodElectionDateOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
        id: 43080,
        description: 'Time unit associated with the relative settlement method election date offset.',
    },
    {
        name: 'UnderlyingSettlMethodElectionDateOffsetDayType',
        abbrName: 'OfstDayTyp',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
        id: 43081,
        description: 'Specifies the day type of the relative settlement method election date offset.',
    },
    {
        name: 'UnderlyingSettlMethodElectionDateAdjusted',
        abbrName: 'Dt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 43082,
        description: 'The adjusted settlement method election date.',
    },
    {
        name: 'UnderlyingStreamVersion',
        abbrName: 'Ver',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 43083,
        description:
            'The stream version identifier when there have been modifications to the contract over time. Helps signal when there are embedded changes.',
    },
    {
        name: 'UnderlyingStreamVersionEffectiveDate',
        abbrName: 'VerEfctvDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 43084,
        description: 'The effective date of the UnderlyingStreamVersion(43083).',
    },
    {
        name: 'UnderlyingStreamNotionalDeterminationMethod',
        abbrName: 'NotlDtrmnMeth',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 43085,
        description:
            'Specifies the method for determining the floating notional value for equity swaps.\n\nSee http://www.fpml.org/coding-scheme/determination-method for values.',
    },
    {
        name: 'UnderlyingStreamNotionalAdjustments',
        abbrName: 'NotlAdjmts',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        type: 'StreamNotionalAdjustmentsCodeSet',
        id: 43086,
        description:
            'For equity swaps this specifies the conditions that govern the adjustment to the number of units of the swap.',
    },
    {
        name: 'RemunerationIndicator',
        abbrName: 'RmntnInd',
        addedEP: '209',
        added: 'FIX.5.0SP2',
        type: 'RemunerationIndicatorCodeSet',
        id: 2356,
        description:
            'Indicates whether the trade price was adjusted for compensation (i.e. includes a mark-up, mark-down or commission) in the price paid.\n\nIn the context of MSRB and FINRA TRACE reporting requirements, this is used among firms to indicate trade remuneration.',
    },
    {
        name: 'CompressionGroupID',
        abbrName: 'CmprsnGrpID',
        addedEP: '211',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2361,
        description:
            'Use to identify a netting or compression group where trades in the group were netted or compressed. This includes both terminating trades and any remnant trades that result from the operation.',
    },
    {
        name: 'SelfMatchPreventionID',
        abbrName: 'SlfMtchPrvntnID',
        addedEP: '211',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2362,
        description:
            'Identifies an order or trade that should not be matched to an opposite order or trade if both buy and sell orders for the same asset contain the same SelfMatchPreventionID(2362) and submitted by the same firm.',
    },
    {
        name: 'PartyRiskLimitStatus',
        abbrName: 'PtyRiskLmtStat',
        addedEP: '214',
        added: 'FIX.5.0SP2',
        type: 'PartyRiskLimitStatusCodeSet',
        id: 2355,
        description: 'The status of risk limits for a party.',
    },
    {
        name: 'TradeConfirmationReferenceID',
        abbrName: 'TrdCnfmRefID',
        addedEP: '215',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2390,
        description:
            'A reference or control identifier or number used as a trade confirmation key.\n\nAn example of a control identifier is the DTC ID Control Number.',
    },
    {
        name: 'AlgorithmicTradeIndicator',
        abbrName: 'AlgoTrdInd',
        addedEP: '216',
        added: 'FIX.5.0SP2',
        type: 'AlgorithmicTradeIndicatorCodeSet',
        id: 2667,
        description:
            'Indicates that the order or trade originates from a computer program or algorithm requiring little-to-no human intervention.',
    },
    {
        name: 'NoTrdRegPublications',
        addedEP: '216',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2668,
        description: 'Number of regulatory publication rules in repeating group.',
    },
    {
        name: 'TrdRegPublicationType',
        abbrName: 'Typ',
        addedEP: '216',
        added: 'FIX.5.0SP2',
        type: 'TrdRegPublicationTypeCodeSet',
        id: 2669,
        description:
            'Specifies the type of regulatory trade publication.\n\nAdditional reasons for the publication type may be specified in TrdRegPublicationReason(2670).',
    },
    {
        name: 'TrdRegPublicationReason',
        abbrName: 'Rsn',
        updated: 'FIX.Latest',
        addedEP: '216',
        added: 'FIX.5.0SP2',
        type: 'TrdRegPublicationReasonCodeSet',
        updatedEP: '283',
        id: 2670,
        description:
            'Additional reason for trade publication type specified in TrdRegPublicationType(2669).\n\nReasons may be specific to regulatory trade publication rules.\n\nFor ESMA RTS 1, RTS 6 and RTS 22 this is the OILQ flag.',
    },
    {
        name: 'LegDifferentialPrice',
        abbrName: 'DiffPx',
        addedEP: '217',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 2492,
        description:
            'Used in pricing a group of individual Trade at Settlement (TAS) and Trade At Marker (TAM) contracts as an atomic unit. The value is the negotiated currency offset either at settlement (TAS) or at the time specified in the product definition (TAM). The final contract price is reported in LegLastPx(637).',
    },
    {
        name: 'CrossedIndicator',
        abbrName: 'CrssdInd',
        addedEP: '218',
        added: 'FIX.5.0SP2',
        type: 'CrossedIndicatorCodeSet',
        id: 2523,
        description:
            'Indicates whether the order or quote was crossed with another order or quote having the same context, e.g. having accounts with a common ownership.',
    },
    {
        name: 'NoOrderAttributes',
        addedEP: '222',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2593,
        description: 'Number of order attribute entries.',
    },
    {
        name: 'OrderAttributeType',
        abbrName: 'Typ',
        unionDataType: 'Reserved1000Plus',
        addedEP: '222',
        added: 'FIX.5.0SP2',
        type: 'OrderAttributeTypeCodeSet',
        id: 2594,
        description: 'The type of order attribute.',
    },
    {
        name: 'OrderAttributeValue',
        abbrName: 'Val',
        addedEP: '222',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2595,
        description: 'The value associated with the order attribute type specified in OrderAttributeType(2594).',
    },
    {
        name: 'TradeReportingIndicator',
        abbrName: 'TrdRptngInd',
        updated: 'FIX.Latest',
        addedEP: '222',
        added: 'FIX.5.0SP2',
        type: 'TradeReportingIndicatorCodeSet',
        updatedEP: '283',
        id: 2524,
        description:
            'Used between parties to convey trade reporting status.\n\nIn the context of regulatory reporting, this field may be used by the reporting party (e.g. party obligated to report to regulators) to inform their trading counterparty or other interested parties the trade reporting status.\n\nThe term “authorised reporter” represents the appropriate reporting firm under applicable regulation. In the context of ESMA reporting, this is the "Systematic Internaliser". In the context of FCA reporting, this is the "Designated Reporter".',
    },
    {
        name: 'SideTradeReportingIndicator',
        abbrName: 'TrdRptngInd',
        addedEP: '222',
        added: 'FIX.5.0SP2',
        type: 'TradeReportingIndicatorCodeSet',
        id: 2671,
        description:
            'Used between parties to convey trade reporting status.\n\nIn the context of regulatory reporting, this field may be used by the reporting party (e.g. party obligated to report to regulators) to inform their trading counterparty or other interested parties the trade reporting status.',
    },
    {
        name: 'CrossRequestID',
        abbrName: 'CrssReqID',
        addedEP: '223',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2672,
        description: 'Unique message identifier for a cross request as assigned by the submitter of the request.',
    },
    {
        name: 'FillMatchID',
        abbrName: 'MtchID',
        addedEP: '223',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2673,
        description: 'Identifier assigned by a matching system to a match event containing multiple executions.',
    },
    {
        name: 'FillMatchSubID',
        abbrName: 'MtchSubID',
        addedEP: '223',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2674,
        description:
            'Identifier assigned by a matching system to a price level (e.g. match step, clip) within a match event containing multiple executions.',
    },
    {
        name: 'MassActionReason',
        abbrName: 'MassActnRsn',
        unionDataType: 'Reserved100Plus',
        addedEP: '223',
        added: 'FIX.5.0SP2',
        type: 'MassActionReasonCodeSet',
        id: 2675,
        description: 'Reason for submission of mass action.',
    },
    {
        name: 'MaximumPriceDeviation',
        abbrName: 'MaxPxDeviatn',
        updated: 'FIX.Latest',
        addedEP: '223',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        updatedEP: '271',
        id: 2676,
        description:
            'Maximum deviation, in percentage terms, of an execution price from a reference price, e.g. the initial price of a match event.',
    },
    {
        name: 'NotAffectedReason',
        abbrName: 'Rsn',
        unionDataType: 'Reserved100Plus',
        addedEP: '223',
        added: 'FIX.5.0SP2',
        type: 'NotAffectedReasonCodeSet',
        id: 2677,
        description:
            'Reason for order being unaffected by mass action even though it belongs to the orders covered by MassActionScope(1374).',
    },
    {
        name: 'TotalNotAffectedOrders',
        abbrName: 'TotNotAffctdOrds',
        addedEP: '223',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2678,
        description:
            'Total number of orders unaffected by either the OrderMassActionRequest(35=CA) or OrderMassCancelRequest(35=Q).',
    },
    {
        name: 'OrderOwnershipIndicator',
        abbrName: 'OrdOwnershipInd',
        addedEP: '223',
        added: 'FIX.5.0SP2',
        type: 'OrderOwnershipIndicatorCodeSet',
        id: 2679,
        description: 'Change of ownership of an order to a specific party.',
    },
    {
        name: 'LegAccount',
        abbrName: 'Acct',
        addedEP: '223',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2680,
        description:
            'Account mnemonic as agreed between buy and sell sides, e.g. broker and institution or investor/intermediary and fund manager.',
    },
    {
        name: 'InTheMoneyCondition',
        abbrName: 'ITMCond',
        addedEP: '224',
        added: 'FIX.5.0SP2',
        type: 'InTheMoneyConditionCodeSet',
        id: 2681,
        description: 'Specifies an option instrument\'s "in the money" condition.',
    },
    {
        name: 'LegInTheMoneyCondition',
        abbrName: 'ITMCond',
        addedEP: '224',
        added: 'FIX.5.0SP2',
        type: 'InTheMoneyConditionCodeSet',
        id: 2682,
        description: 'Specifies an option instrument\'s "in the money" condition in general terms.',
    },
    {
        name: 'UnderlyingInTheMoneyCondition',
        abbrName: 'ITMCond',
        addedEP: '224',
        added: 'FIX.5.0SP2',
        type: 'InTheMoneyConditionCodeSet',
        id: 2683,
        description: 'Specifies an option instrument\'s "in the money" condition in general terms.',
    },
    {
        name: 'DerivativeInTheMoneyCondition',
        abbrName: 'ITMCond',
        updated: 'FIX.Latest',
        addedEP: '224',
        added: 'FIX.5.0SP2',
        type: 'InTheMoneyConditionCodeSet',
        updatedEP: '271',
        id: 2684,
        description:
            'Specifies an option instrument\'s "in the money" condition in general terms.\n\nSee InTheMoneyCondition(2681) for complete definition.',
    },
    {
        name: 'ContraryInstructionEligibilityIndicator',
        abbrName: 'CntraryInstEligInd',
        addedEP: '224',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2685,
        description:
            'Identifies whether the option instrument is eligible for contrary instructions at the time of exercise. The contrariness of an instruction will be determined in the context of InTheMoneyCondition(2681). When not specified, the eligibility is undefined or not applicable.',
    },
    {
        name: 'LegContraryInstructionEligibilityIndicator',
        abbrName: 'CntraryInstEligInd',
        addedEP: '224',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2686,
        description:
            'Identifies whether the option instrument is eligible for contrary instructions at the time of exercise. The contrariness of an instruction will be determined in the context of LegInTheMoneyCondition(2682). When not specified, the eligibility is undefined or not applicable.',
    },
    {
        name: 'UnderlyingContraryInstructionEligibilityIndicator',
        abbrName: 'CntraryInstEligInd',
        addedEP: '224',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2687,
        description:
            'Identifies whether the option instrument is eligible for contrary instructions at the time of exercise. The contrariness of an instruction will be determined in the context of UnderlyingInTheMoneyCondition(2683). When not specified, the eligibility is undefined or not applicable.',
    },
    {
        name: 'DerivativeContraryInstructionEligibilityIndicator',
        abbrName: 'CntraryInstEligInd',
        updated: 'FIX.Latest',
        addedEP: '224',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        updatedEP: '271',
        id: 2688,
        description:
            'Identifies whether the option instrument is eligible for contrary instructions at the time of exercise. The contrariness of an instruction will be determined in the context of DerivativeInTheMoneyCondition(2684). When not specified, the eligibility is undefined or not applicable.\n\nSee ContraryInstructionEligibilityIndicator(2685) for complete definition.',
    },
    {
        name: 'CollateralMarketPrice',
        abbrName: 'MktPx',
        addedEP: '227',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 2689,
        description: 'Market price of the collateral, either from market sources or pre-agreed by the counterparties.',
    },
    {
        name: 'CollateralPercentOverage',
        abbrName: 'PctOvrg',
        addedEP: '227',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 2690,
        description:
            'Percentage of over-collateralization particularly when CollateralAmountType(2632) = 4 (Additional collateral value)',
    },
    {
        name: 'NoSideCollateralAmounts',
        addedEP: '227',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2691,
        description: 'Number of side collateral amount entries.',
    },
    {
        name: 'SideCollateralAmountMarketID',
        abbrName: 'MktID',
        addedEP: '227',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2692,
        description: 'Market associated with the collateral amount.',
    },
    {
        name: 'SideCollateralAmountMarketSegmentID',
        abbrName: 'MktSegID',
        addedEP: '227',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2693,
        description: 'Market segment associated with the collateral amount.',
    },
    {
        name: 'SideCollateralAmountType',
        abbrName: 'AmtTyp',
        addedEP: '227',
        added: 'FIX.5.0SP2',
        type: 'CollateralAmountTypeCodeSet',
        id: 2694,
        description: 'The type of value in CurrentCollateralAmount(1704).',
    },
    {
        name: 'SideCollateralCurrency',
        abbrName: 'Ccy',
        updated: 'FIX.Latest',
        addedEP: '227',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        updatedEP: '273',
        id: 2695,
        description:
            'Specifies the currency of the collateral; optional, defaults to settlement currency if not specified.\n\nSideCollateralCurrencyCodeSource(2930) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.',
    },
    {
        name: 'SideCollateralFXRate',
        abbrName: 'FxRt',
        addedEP: '227',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 2696,
        description:
            'Foreign exchange rate used to compute the SideCurrentCollateralAmount(2702) from the SideCollateralCurrency(2695) and the Currency(15).',
    },
    {
        name: 'SideCollateralFXRateCalc',
        abbrName: 'FxRtCalc',
        addedEP: '227',
        added: 'FIX.5.0SP2',
        type: 'UnderlyingFXRateCalcCodeSet',
        id: 2697,
        description: 'Specifies whether or not SideCollateralFXRate(2696) should be multiplied or divided.',
    },
    {
        name: 'SideCollateralMarketPrice',
        abbrName: 'MktPx',
        addedEP: '227',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 2698,
        description: 'Market price of the collateral, either from market sources or pre-agreed by the counterparties.',
    },
    {
        name: 'SideCollateralPercentOverage',
        abbrName: 'PctOvrg',
        addedEP: '227',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 2699,
        description:
            'Percentage of over-collateralization particularly when SideCollateralAmountType(2694) = 4 (Additional collateral value).',
    },
    {
        name: 'SideCollateralPortfolioID',
        abbrName: 'PrtflioID',
        addedEP: '227',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2700,
        description: 'Identifier of the collateral portfolio when reporting on a portfolio basis.',
    },
    {
        name: 'SideCollateralType',
        abbrName: 'Typ',
        addedEP: '227',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2701,
        description: 'Type of collateral on deposit being reported.',
    },
    {
        name: 'SideCurrentCollateralAmount',
        abbrName: 'Amt',
        addedEP: '227',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 2702,
        description: 'Currency value currently attributed to the collateral.',
    },
    {
        name: 'SideHaircutIndicator',
        abbrName: 'HrctInd',
        addedEP: '227',
        added: 'FIX.5.0SP2',
        type: 'Boolean',
        id: 2703,
        description:
            'Indicates, if "Y", that a stated valuation includes a haircut, e.g. that the stated value reflects the subtraction of the haircut. Note that a value of "N" does not imply a haircut is not applicable, only that the haircut (if any) is not reflected in the stated valuation.',
    },
    {
        name: 'ExDestinationType',
        abbrName: 'ExDestTyp',
        addedEP: '228',
        added: 'FIX.5.0SP2',
        type: 'ExDestinationTypeCodeSet',
        id: 2704,
        description: 'Identifies the type of execution destination for the order.',
    },
    {
        name: 'MarketCondition',
        abbrName: 'MktCond',
        addedEP: '229',
        added: 'FIX.5.0SP2',
        type: 'MarketConditionCodeSet',
        id: 2705,
        description:
            'Market condition. In the context of ESMA RTS 8 it is important that trading venues communicate the condition of the market, particularly "stressed" and "exceptional", in order to provide incentives for firms contributing to liquidity.',
    },
    {
        name: 'NoQuoteAttributes',
        addedEP: '229',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2706,
        description: 'Number of quote attributes entries.',
    },
    {
        name: 'QuoteAttributeType',
        abbrName: 'Typ',
        addedEP: '229',
        added: 'FIX.5.0SP2',
        type: 'QuoteAttributeTypeCodeSet',
        id: 2707,
        description: 'The type of attribute for the quote.',
    },
    {
        name: 'QuoteAttributeValue',
        abbrName: 'Val',
        addedEP: '229',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2708,
        description: 'The value associated with the quote attribute type specified in QuoteAttributeType(2707).',
    },
    {
        name: 'NoPriceQualifiers',
        addedEP: '230',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2709,
        description: 'Number of price qualifiers in the repeating group.',
    },
    {
        name: 'PriceQualifier',
        abbrName: 'Qual',
        addedEP: '230',
        added: 'FIX.5.0SP2',
        type: 'PriceQualifierCodeSet',
        id: 2710,
        description: 'Qualifier for price. May be used when the price needs to be explicitly qualified.',
    },
    {
        name: 'MDValueTier',
        abbrName: 'Tier',
        addedEP: '231',
        added: 'FIX.5.0SP2',
        type: 'MDValueTierCodeSet',
        id: 2711,
        description:
            'Describes the reporting ranges for executed transactions.\n\nIn context of ESMA RTS 27 Article 9, the execution venue is required to report on transactions within several size ranges (in terms of a value and currency). The thresholds for these ranges are dependent on the type of financial instrument.',
    },
    {
        name: 'MiscFeeQualifier',
        abbrName: 'Qual',
        addedEP: '231',
        added: 'FIX.5.0SP2',
        type: 'MiscFeeQualifierCodeSet',
        id: 2712,
        description:
            'Identifies whether the current entry contributes to the trade or transaction economics, i.e. affects NetMoney(118).',
    },
    {
        name: 'MiscFeeDesc',
        abbrName: 'Desc',
        addedEP: '231',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2713,
        description: 'Can be used to provide a textual description of the fee type.',
    },
    {
        name: 'FinancialInstrumentFullName',
        abbrName: 'FullName',
        updated: 'FIX.5.0SP2',
        addedEP: '232',
        added: 'FIX.5.0SP2',
        type: 'String',
        updatedEP: '236',
        id: 2714,
        description:
            'The full normative name of the financial instrument.\n\nIn the context of ESMA reference data, this is used to provide the full name of the instrument as defined by the Derivatives Service Bureau (DSB).',
    },
    {
        name: 'EncodedFinancialInstrumentFullNameLen',
        abbrName: 'EncFullNameLen',
        updated: 'FIX.5.0SP2',
        addedEP: '232',
        added: 'FIX.5.0SP2',
        type: 'Length',
        updatedEP: '236',
        id: 2715,
        description: 'Byte length of encoded (non-ASCII characters) EncodedFinancialInstrumentFullName(2716) field.',
    },
    {
        name: 'EncodedFinancialInstrumentFullName',
        abbrName: 'EncFullName',
        updated: 'FIX.5.0SP2',
        addedEP: '232',
        added: 'FIX.5.0SP2',
        type: 'data',
        updatedEP: '236',
        id: 2716,
        lengthId: '2715',
        description:
            'Encoded (non-ASCII characters) representation of the FinancialInstrumentFullName(2714) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) representation should also be specified in the FinancialInstrumentFullName(2714) field.',
    },
    {
        name: 'LegFinancialInstrumentFullName',
        abbrName: 'FullName',
        updated: 'FIX.5.0SP2',
        addedEP: '232',
        added: 'FIX.5.0SP2',
        type: 'String',
        updatedEP: '236',
        id: 2717,
        description:
            "The full normative name of the multileg's financial instrument.\n\nIn the context of ESMA reference data, this is used to provide the full name of the instrument as defined by the Derivatives Service Bureau (DSB).",
    },
    {
        name: 'EncodedLegFinancialInstrumentFullNameLen',
        abbrName: 'EncFullNameLen',
        updated: 'FIX.5.0SP2',
        addedEP: '232',
        added: 'FIX.5.0SP2',
        type: 'Length',
        updatedEP: '236',
        id: 2718,
        description:
            "Byte length of encoded (non-ASCII characters) individual multileg instrument's EncodedLegFinancialInstrumentFullName(2719).",
    },
    {
        name: 'EncodedLegFinancialInstrumentFullName',
        abbrName: 'EncFullName',
        updated: 'FIX.5.0SP2',
        addedEP: '232',
        added: 'FIX.5.0SP2',
        type: 'data',
        updatedEP: '236',
        id: 2719,
        lengthId: '2718',
        description:
            'Encoded (non-ASCII characters) representation of the LegFinancialInstrumentFullName(2717) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) representation should also be specified in the LegFinancialInstrumentFullName(2717) field.',
    },
    {
        name: 'UnderlyingFinancialInstrumentFullName',
        abbrName: 'FullName',
        updated: 'FIX.5.0SP2',
        addedEP: '232',
        added: 'FIX.5.0SP2',
        type: 'String',
        updatedEP: '236',
        id: 2720,
        description:
            'The full normative name of the underlying financial instrument.\n\nIn the context of ESMA reference data, this is used to provide the full name of the instrument as defined by the Derivatives Service Bureau (DSB).',
    },
    {
        name: 'EncodedUnderlyingFinancialInstrumentFullNameLen',
        abbrName: 'EncFullNameLen',
        updated: 'FIX.5.0SP2',
        addedEP: '232',
        added: 'FIX.5.0SP2',
        type: 'Length',
        updatedEP: '236',
        id: 2721,
        description:
            "Byte length of encoded (non-ASCII characters) underlying instrument's EncodedUnderlyingFinancialInstrumentFullName(2722).",
    },
    {
        name: 'EncodedUnderlyingFinancialInstrumentFullName',
        abbrName: 'EncFullName',
        updated: 'FIX.5.0SP2',
        addedEP: '232',
        added: 'FIX.5.0SP2',
        type: 'data',
        updatedEP: '236',
        id: 2722,
        lengthId: '2721',
        description:
            'Encoded (non-ASCII characters) representation of the UnderlyingFinancialInstrumentFullName(2720) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) representation should also be specified in the UnderlyingFinancialInstrumentFullName(2720) field.',
    },
    {
        name: 'UnderlyingIndexCurveUnit',
        abbrName: 'NdxUnit',
        addedEP: '232',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexCurveUnitCodeSet',
        id: 2723,
        description: 'Curve time unit associated with the underlying index.',
    },
    {
        name: 'UnderlyingIndexCurvePeriod',
        abbrName: 'NdxPeriod',
        addedEP: '232',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2724,
        description: 'Curve time multiplier for the underlying index.',
    },
    {
        name: 'CommissionAmountSubType',
        abbrName: 'SubTyp',
        addedEP: '233',
        added: 'FIX.5.0SP2',
        type: 'CommissionAmountSubTypeCodeSet',
        id: 2725,
        description: 'Further sub classification of the CommissionAmountType(2641).',
    },
    {
        name: 'AllocCommissionAmountSubType',
        abbrName: 'SubTyp',
        addedEP: '233',
        added: 'FIX.5.0SP2',
        type: 'CommissionAmountSubTypeCodeSet',
        id: 2726,
        description: 'Further sub classification of the AllocCommissionAmountType(2655).',
    },
    {
        name: 'AllocLegRefID',
        abbrName: 'LegRefID',
        updated: 'FIX.5.0SP2',
        addedEP: '234',
        added: 'FIX.5.0SP2',
        type: 'String',
        updatedEP: '259',
        id: 2727,
        description:
            'Unique identifier for a specific leg (uniqueness not defined as part of the FIX specification). AllocLegRefID(2727) references the value from LegID(1788) in the current multileg order or trade message specifying to which leg the allocation instance applies.',
    },
    {
        name: 'FloatingRateIndexCurvePeriod',
        abbrName: 'Period',
        addedEP: '235',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2728,
        description: 'Time unit multiplier for the floating rate index identified in FloatingRateIndexID(2731).',
    },
    {
        name: 'FloatingRateIndexCurveSpread',
        abbrName: 'Spread',
        addedEP: '235',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 2729,
        description: 'Spread from the floating rate index.',
    },
    {
        name: 'FloatingRateIndexCurveUnit',
        abbrName: 'Unit',
        addedEP: '235',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexCurveUnitCodeSet',
        id: 2730,
        description: 'Time unit associated with the floating rate index identified in FloatingRateIndexID(2731).',
    },
    {
        name: 'FloatingRateIndexID',
        abbrName: 'ID',
        addedEP: '235',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2731,
        discriminatorId: '2732',
        description: 'Security identifier of the floating rate index.',
    },
    {
        name: 'FloatingRateIndexIDSource',
        abbrName: 'Src',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.Latest',
        addedEP: '235',
        added: 'FIX.5.0SP2',
        type: 'SecurityIDSourceCodeSet',
        updatedEP: '294',
        id: 2732,
        description: 'Source for the floating rate index identified in FloatingRateIndexID(2731).',
    },
    {
        name: 'IndexRollMonth',
        abbrName: 'Mo',
        addedEP: '235',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2733,
        description: 'Month identified in the index roll.\n\nUse "1" for January, "2" for February, etc.',
    },
    {
        name: 'NoIndexRollMonths',
        addedEP: '235',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2734,
        description: 'Number of instances of the index roll month.',
    },
    {
        name: 'AssetSubType',
        abbrName: 'AsstSubTyp',
        addedEP: '235',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2735,
        description:
            "Used to provide a more specific description of the asset specified in AssetType(1940).\n\nSee https://www.fixtrading.org/codelists/AssetSubType for code list of applicable values.\n\nIn the context of MiFID II, ESMA RTS 23 Annex I Table 2, this may indicate the 'Further sub product' or equity 'Parameter' fields.",
    },
    {
        name: 'CommodityFinalPriceType',
        abbrName: 'CmdtyFnlPxTyp',
        addedEP: '235',
        added: 'FIX.5.0SP2',
        type: 'CommodityFinalPriceTypeCodeSet',
        id: 2736,
        description: 'Final price type of the commodity as specified by the trading venue.',
    },
    {
        name: 'FinancialInstrumentShortName',
        abbrName: 'ShrtName',
        addedEP: '235',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2737,
        description:
            'Short name of the financial instrument. Uses ISO 18774 (FINS) values.\n\nIn the context of MiFID II this maps to ESMA RTS 23 Annex I Table 3 Field 7 and may be used in other RTS that requires a similar field.',
    },
    {
        name: 'NextIndexRollDate',
        abbrName: 'NxtNdxRollDt',
        addedEP: '235',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 2738,
        description: 'Next index roll date.',
    },
    {
        name: 'LegAssetSubType',
        abbrName: 'AsstSubTyp',
        addedEP: '235',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2739,
        description:
            "Used to provide a more specific description of the asset specified in LegAssetType(2069).\n\nSee https://www.fixtrading.org/codelists/AssetSubType for code list of applicable values.\n\nIn the context of MiFID II, ESMA RTS 23 Annex I Table 2, this may indicate the 'Further sub product' or equity 'Parameter' fields.",
    },
    {
        name: 'LegFinancialInstrumentShortName',
        abbrName: 'ShrtName',
        addedEP: '235',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2740,
        description:
            'Short name of the financial instrument. Uses ISO 18774 (FISN) values.\n\nIn the context of MiFID II this maps to ESMA RTS 23 Annex I Table 3 Field 7 and may be used in other RTS that requires a similar field.',
    },
    {
        name: 'LegPaymentStreamRateIndexID',
        abbrName: 'NdxID',
        addedEP: '235',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 43088,
        discriminatorId: '43089',
        description: 'Security identifier of the floating rate index.',
    },
    {
        name: 'LegPaymentStreamRateIndexIDSource',
        abbrName: 'NdxIDSrc',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.Latest',
        addedEP: '235',
        added: 'FIX.5.0SP2',
        type: 'SecurityIDSourceCodeSet',
        updatedEP: '294',
        id: 43089,
        description: 'Source for the floating rate index identified in LegPaymentStreamRateIndexID(43088).',
    },
    {
        name: 'LegSecondaryAssetSubType',
        abbrName: 'SubTyp',
        addedEP: '235',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2743,
        description:
            "Used to provide a more specific description of the asset specified in LegSecondaryAssetType(2079).\n\nSee https://www.fixtrading.org/codelists/AssetSubType for code list of applicable values.\n\nIn the context of MiFID II RTS 23 Annex I Table 2, this may indicate the 'Further sub product' or equity 'Parameter' fields.",
    },
    {
        name: 'PaymentStreamRateIndexID',
        abbrName: 'NdxID',
        addedEP: '235',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 43090,
        discriminatorId: '43091',
        description: 'Security identifier of the floating rate index.',
    },
    {
        name: 'PaymentStreamRateIndexIDSource',
        abbrName: 'NdxIDSrc',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.Latest',
        addedEP: '235',
        added: 'FIX.5.0SP2',
        type: 'SecurityIDSourceCodeSet',
        updatedEP: '294',
        id: 43091,
        description: 'Source for the floating rate index identified in PaymentStreamRateIndexID(43090).',
    },
    {
        name: 'NoReferenceDataDates',
        addedEP: '235',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2746,
        description: 'Number of instances of reference data dates.',
    },
    {
        name: 'ReferenceDataDate',
        abbrName: 'Dt',
        addedEP: '235',
        added: 'FIX.5.0SP2',
        type: 'UTCTimestamp',
        id: 2747,
        description: "Reference data entry's date-time of the type specified in ReferenceDataDateType(2748).",
    },
    {
        name: 'ReferenceDataDateType',
        abbrName: 'Typ',
        addedEP: '235',
        added: 'FIX.5.0SP2',
        type: 'ReferenceDataDateTypeCodeSet',
        id: 2748,
        description: "Reference data entry's date-time type.",
    },
    {
        name: 'SecondaryAssetSubType',
        abbrName: 'SubTyp',
        addedEP: '235',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2741,
        description:
            "Used to provide a more specific description of the asset specified in SecondaryAssetType(1979).\n\nSee https://www.fixtrading.org/codelists/AssetSubType for code list of applicable values.\n\nIn the context of MiFID II, ESMA RTS 23 Annex I Table 2, this may indicate the 'Further sub product' or equity 'Parameter' fields.",
    },
    {
        name: 'UnderlyingFinancialInstrumentShortName',
        abbrName: 'ShrtName',
        addedEP: '235',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2742,
        description:
            'Short name of the financial instrument. Uses ISO 18774 (FINS) values.\n\nIn the context of MiFID II this maps to ESMA RTS 23 Annex I Table 3 Field 7 and may be used in other RTS that requires a similar field.',
    },
    {
        name: 'UnderlyingAssetSubType',
        abbrName: 'AsstSubTyp',
        addedEP: '235',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2744,
        description:
            "Used to provide a more specific description of the asset specified in UnderlyingAssetType(2015).\n\nSee https://www.fixtrading.org/codelists/AssetSubType for code list of applicable values.\n\nIn the context of MiFID II, ESMA RTS 23 Annex I Table 2, this may indicate the 'Further sub product' or equity 'Parameter' fields.",
    },
    {
        name: 'UnderlyingPaymentStreamRateIndexID',
        abbrName: 'NdxID',
        addedEP: '235',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 43092,
        discriminatorId: '43093',
        description: 'Security identifier of the floating rate index.',
    },
    {
        name: 'UnderlyingPaymentStreamRateIndexIDSource',
        abbrName: 'NdxIDSrc',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.Latest',
        addedEP: '235',
        added: 'FIX.5.0SP2',
        type: 'SecurityIDSourceCodeSet',
        updatedEP: '294',
        id: 43093,
        description: 'Source for the floating rate index identified in UnderlyingPaymentStreamRateIndexID(43092).',
    },
    {
        name: 'UnderlyingSecondaryAssetSubType',
        abbrName: 'SubTyp',
        addedEP: '235',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2745,
        description:
            "May be used to provide a more specific description of the asset specified in UnderlyingSecondaryAssetType(2083).\n\nSee https://www.fixtrading.org/codelists/AssetSubType for code list of applicable values.\n\nIn the context of MiFID II, ESMA RTS 23 Annex I Table 2, this may indicate the 'Further sub product' or equity 'Parameter' fields.",
    },
    {
        name: 'DeliveryStreamRouteOrCharter',
        abbrName: 'RteChrtr',
        addedEP: '235',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 43094,
        description: 'Specific delivery route or time charter average. Applicable to commodity freight swaps.',
    },
    {
        name: 'LegDeliveryStreamRouteOrCharter',
        abbrName: 'RteChrtr',
        addedEP: '235',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 43095,
        description: 'Specific delivery route or time charter average. Applicable to commodity freight swaps.',
    },
    {
        name: 'UnderlyingDeliveryStreamRouteOrCharter',
        abbrName: 'RteChrtr',
        addedEP: '235',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 43096,
        description: 'Specific delivery route or time charter average. Applicable to commodity freight swaps.',
    },
    {
        name: 'ExecutionTimestamp',
        abbrName: 'ExecTS',
        addedEP: '237',
        added: 'FIX.5.0SP2',
        type: 'UTCTimestamp',
        id: 2749,
        description: 'Time of the individual execution.',
    },
    {
        name: 'ReportingPx',
        abbrName: 'RptngPx',
        addedEP: '237',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 2750,
        description:
            'Represents the reportable price on fill when an instance of the Parties component with PartyRole(452) = 73 (Execution Venue) is present to prevent having to compute running totals.',
    },
    {
        name: 'ReportingQty',
        abbrName: 'RptngQty',
        addedEP: '237',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 2751,
        description:
            'Represents the reportable quantity on fill when an instance of the Parties component with PartyRole(452) = 73 (Execution Venue) is present to prevent having to compute running totals.',
    },
    {
        name: 'DeliveryRouteOrCharter',
        abbrName: 'RteChrtr',
        addedEP: '238',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2752,
        description: 'Specific delivery route or time charter average. Applicable to commodity freight contracts.',
    },
    {
        name: 'ReturnTrigger',
        abbrName: 'RtnTrgr',
        addedEP: '238',
        added: 'FIX.5.0SP2',
        type: 'ReturnTriggerCodeSet',
        id: 2753,
        description: 'Indicates the type of return or payout trigger for the swap or forward.',
    },
    {
        name: 'LegDeliveryRouteOrCharter',
        abbrName: 'RteChrtr',
        addedEP: '238',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2754,
        description: 'Specific delivery route or time charter average. Applicable to commodity freight contracts.',
    },
    {
        name: 'LegReturnTrigger',
        abbrName: 'RtnTrgr',
        addedEP: '238',
        added: 'FIX.5.0SP2',
        type: 'ReturnTriggerCodeSet',
        id: 2755,
        description: 'Indicates the type of return or payout trigger for the swap or forward.',
    },
    {
        name: 'UnderlyingDeliveryRouteOrCharter',
        abbrName: 'RteChrtr',
        addedEP: '238',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2756,
        description: 'Specific delivery route or time charter average. Applicable to commodity freight contracts.',
    },
    {
        name: 'UnderlyingReturnTrigger',
        abbrName: 'RtnTrgr',
        addedEP: '238',
        added: 'FIX.5.0SP2',
        type: 'ReturnTriggerCodeSet',
        id: 2757,
        description: 'Indicates the type of return or payout trigger for the swap or forward.',
    },
    {
        name: 'AllocRequestID',
        abbrName: 'ReqID',
        addedEP: '239',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2758,
        description: 'Unique identifier for the request message.',
    },
    {
        name: 'GroupAmount',
        abbrName: 'GrpAmt',
        addedEP: '239',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 2759,
        description:
            "Indicates the total notional units or amount of an allocation group. Includes any allocated units or amount.\n\nWhether notional units or amount is used depends on the type of listed derivative contract and the clearinghouse. A notional unit is (price x quantity) without the derivative's contract value factor.",
    },
    {
        name: 'GroupRemainingAmount',
        abbrName: 'GrpRemAmt',
        addedEP: '239',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 2760,
        description:
            "Indicates the remaining notional units or amount of an allocation group that has not yet been allocated.\n\nWhether notional units or amount is used depends on the type of listed derivative contract and the clearinghouse. A notional unit is (price x quantity) without the derivative's contract value factor.",
    },
    {
        name: 'AllocGroupAmount',
        abbrName: 'GrpAmt',
        addedEP: '239',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 2761,
        description:
            "Indicates the notional units or amount being allocated.\n\nWhether notional units or amount is used depends on the type of listed derivative contract and the clearinghouse. A notional unit is (price x quantity) without the derivative's contract value factor.",
    },
    {
        name: 'PriceMarkup',
        abbrName: 'PxMrkup',
        addedEP: '240',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 2762,
        description:
            'Price offset of the markup denominated in the price type of the trade.\n\nThe field is expressed in a value that can simply be added to or subtracted from the (clean) price to reach the marked- up price. E.g., a percent of par price of 98 marked up to 98.5 should be 0.5, an FX rate of 1.17936 marked up to 1.19 should be 0.01064, a stock price of 22.75 marked up to 22.9 should be 0.15, etc.',
    },
    {
        name: 'AveragePriceType',
        abbrName: 'Typ',
        addedEP: '240',
        added: 'FIX.5.0SP2',
        type: 'AveragePriceTypeCodeSet',
        id: 2763,
        description: 'The average pricing model used for block trades.',
    },
    {
        name: 'AveragePriceStartTime',
        abbrName: 'StartTm',
        addedEP: '240',
        added: 'FIX.5.0SP2',
        type: 'UTCTimestamp',
        id: 2764,
        description: 'Start of the time period during which price averaging occurred.',
    },
    {
        name: 'AveragePriceEndTime',
        abbrName: 'EndTm',
        addedEP: '240',
        added: 'FIX.5.0SP2',
        type: 'UTCTimestamp',
        id: 2765,
        description: 'End of the time period during which price averaging occurred.',
    },
    {
        name: 'OrderPercentOfTotalVolume',
        abbrName: 'TotVolPct',
        addedEP: '240',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 2766,
        description:
            'For Percent-of-volume (POV) average pricing this is the target percentage this order quantity represents of the total trading volume of an instrument during the specified time period. This provides the data needed to ensure that the average price is fair based on the total sum of grouped POV trades.\n\nFor example, if during the POV time period there are 5 trades including this one with a total volume of 5000 and this trade has a quantity of 1000 then the OrderPercentOfTotalVolume(2766) of this trade is 20 percent expressed as "0.20".',
    },
    {
        name: 'AllocGroupStatus',
        abbrName: 'GrpStat',
        addedEP: '240',
        added: 'FIX.5.0SP2',
        type: 'AllocGroupStatusCodeSet',
        id: 2767,
        description: 'Status of the trade give-up relative to the group identified in AllocGroupID(1730).',
    },
    {
        name: 'AllocRequestStatus',
        abbrName: 'ReqStat',
        addedEP: '241',
        added: 'FIX.5.0SP2',
        type: 'AllocRequestStatusCodeSet',
        id: 2768,
        description: 'Status of the AllocationInstructionAlertRequest(35=DU).',
    },
    {
        name: 'AllocAvgPxIndicator',
        abbrName: 'AvgPxInd',
        addedEP: '241',
        added: 'FIX.5.0SP2',
        type: 'AvgPxIndicatorCodeSet',
        id: 2769,
        description: 'Average pricing indicator at the allocation level.',
    },
    {
        name: 'AllocAvgPxGroupID',
        abbrName: 'AvgPxGrpID',
        addedEP: '241',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2770,
        description:
            'Used by submitting firm to group trades being sub-allocated into an average price group. The trades in the average price group will be used to calculate an average price for the group.',
    },
    {
        name: 'PreviousAllocGroupID',
        abbrName: 'PrevGrpID',
        addedEP: '241',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2771,
        description:
            'When reporting a group change by the central counterparty to allocations of trades for the same instrument traded at the same price this identifies the previous group identifier.',
    },
    {
        name: 'NoMatchExceptions',
        addedEP: '246',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2772,
        description: 'Number of match exceptions in the repeating group.',
    },
    {
        name: 'MatchExceptionType',
        abbrName: 'Typ',
        unionDataType: 'Reserved100Plus',
        addedEP: '246',
        added: 'FIX.5.0SP2',
        type: 'MatchExceptionTypeCodeSet',
        id: 2773,
        description: 'Type of matching exception.',
    },
    {
        name: 'MatchExceptionElementType',
        abbrName: 'ID',
        unionDataType: 'Reserved100Plus',
        addedEP: '246',
        added: 'FIX.5.0SP2',
        type: 'MatchExceptionElementTypeCodeSet',
        id: 2774,
        description: 'Identifies the data point used in the matching operation which resulted in an exception.',
    },
    {
        name: 'MatchExceptionElementName',
        abbrName: 'Name',
        addedEP: '246',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2775,
        description:
            'The matching exception data point name, for example: "Trade currency". This may be used for display purposes, providing a corresponding description for the value in MatchExceptionElementType(2774).',
    },
    {
        name: 'MatchExceptionAllocValue',
        abbrName: 'AllocVal',
        addedEP: '246',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2776,
        description: "The allocating party's data value used in the match operation.",
    },
    {
        name: 'MatchExceptionConfirmValue',
        abbrName: 'CnfmVal',
        addedEP: '246',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2777,
        description: "The confirming party's data value used in the match operation.",
    },
    {
        name: 'MatchExceptionToleranceValue',
        abbrName: 'TlrncVal',
        addedEP: '246',
        added: 'FIX.5.0SP2',
        type: 'float',
        id: 2778,
        description: "The data element's tolerance value. Omitted if no tolerance is allowed or not applicable.",
    },
    {
        name: 'MatchExceptionToleranceValueType',
        abbrName: 'TlrncValTyp',
        addedEP: '246',
        added: 'FIX.5.0SP2',
        type: 'MatchExceptionToleranceValueTypeCodeSet',
        id: 2779,
        description:
            'The type of value in MatchExceptionToleranceValue(2778). Omitted if no tolerance is allowed or not applicable.\n\nFor example, if the tolerance for accrued interest is 0.01% of total accrued interest then MatchExceptionElementType(2774)=1 (Accrued interest), MatchExceptionToleranceValueType(2779)=2 (Percentage) and MatchExcecptionToleranceValue(2778)=0.0001. If tolerance for the exchange rate of an FX trade is "0.001" then MatchExceptionElementType(2774)=2 (Deal pPrice), MatchExceptionToleranceValueType(2779)=1 (Fixed amount) and MatchExcecptionToleranceValue(2778)=0.001.',
    },
    {
        name: 'MatchExceptionText',
        abbrName: 'Txt',
        addedEP: '246',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2780,
        description: 'Description of the exception.',
    },
    {
        name: 'NoMatchingDataPoints',
        addedEP: '246',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2781,
        description: 'Number of matching data points in the repeating group.',
    },
    {
        name: 'MatchingDataPointIndicator',
        abbrName: 'Typ',
        addedEP: '246',
        added: 'FIX.5.0SP2',
        type: 'MatchingDataPointIndicatorCodeSet',
        id: 2782,
        description: "Data point's matching type.",
    },
    {
        name: 'MatchingDataPointValue',
        abbrName: 'Val',
        addedEP: '246',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2783,
        description: 'Value of the matching data point.',
    },
    {
        name: 'MatchingDataPointType',
        abbrName: 'ID',
        unionDataType: 'Reserved100Plus',
        addedEP: '246',
        added: 'FIX.5.0SP2',
        type: 'MatchExceptionElementTypeCodeSet',
        id: 2784,
        description:
            'Identifies the data point used in the matching operation.\n\nValues may not have applicable tolerance values, in this case this means the data point was used for matching but did not match.',
    },
    {
        name: 'MatchingDataPointName',
        abbrName: 'Name',
        addedEP: '246',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2785,
        description:
            'The matching data point name, for example: "Trade currency". This may be used for display purposes, providing a corresponding description for the value in MatchingDataPointType(2784).',
    },
    {
        name: 'EncodedMatchExceptionTextLen',
        abbrName: 'EncTxtLen',
        addedEP: '246',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 2797,
        description: 'Byte length of encoded (non-ASCII characters) EncodedMatchExceptionText(2798) field.',
    },
    {
        name: 'EncodedMatchExceptionText',
        abbrName: 'EncTxt',
        updated: 'FIX.Latest',
        addedEP: '246',
        added: 'FIX.5.0SP2',
        type: 'data',
        updatedEP: '271',
        id: 2798,
        lengthId: '2797',
        description:
            'Encoded (non-ASCII characters) representation of the MatchExceptionText(2780) field in the encoded format specified via the MessageEncoding(347) field.\n\nIf used, the ASCII (English) representation should also be specified in the MatchExceptionText(2780) field.',
    },
    {
        name: 'TradeAggregationRequestID',
        abbrName: 'ReqID',
        addedEP: '247',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2786,
        description: 'The message identifier for the trade aggregation request.',
    },
    {
        name: 'TradeAggregationRequestRefID',
        abbrName: 'RefID',
        addedEP: '247',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2787,
        description: 'Reference identifier to a previously sent trade aggregation message being cancelled or replaced.',
    },
    {
        name: 'TradeAggregationTransType',
        abbrName: 'TransTyp',
        addedEP: '247',
        added: 'FIX.5.0SP2',
        type: 'TradeAggregationTransTypeCodeSet',
        id: 2788,
        description: 'Identifies the trade aggregation transaction type.',
    },
    {
        name: 'AggregatedQty',
        abbrName: 'AggQty',
        addedEP: '247',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 2789,
        description: 'Total quantity of orders or fills quantity aggregated.',
    },
    {
        name: 'TradeAggregationRequestStatus',
        abbrName: 'ReqStat',
        addedEP: '247',
        added: 'FIX.5.0SP2',
        type: 'TradeAggregationRequestStatusCodeSet',
        id: 2790,
        description: 'Status of the trade aggregation request.',
    },
    {
        name: 'TradeAggregationRejectReason',
        abbrName: 'RejRsn',
        unionDataType: 'Reserved100Plus',
        addedEP: '247',
        added: 'FIX.5.0SP2',
        type: 'TradeAggregationRejectReasonCodeSet',
        id: 2791,
        description: 'Reason for trade aggregation request being rejected.',
    },
    {
        name: 'TradeAggregationReportID',
        abbrName: 'RptID',
        addedEP: '247',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2792,
        description: 'Unique identifier for the TradeAggregationReport(35=DX).',
    },
    {
        name: 'AvgSpotRate',
        abbrName: 'AvgSpotRt',
        addedEP: '247',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 2793,
        description: 'The average FX spot rate.',
    },
    {
        name: 'AvgForwardPoints',
        abbrName: 'AvgFwdPnts',
        addedEP: '247',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 2794,
        description: 'The average forward points. May be a negative value.',
    },
    {
        name: 'OffshoreIndicator',
        abbrName: 'OffshrInd',
        addedEP: '247',
        added: 'FIX.5.0SP2',
        type: 'OffshoreIndicatorCodeSet',
        id: 2795,
        description:
            'Indicates the type of the currency rate being used. This is relevant for currencies that have offshore rate that different from onshore rate.',
    },
    {
        deprecatedEP: '293',
        name: 'FXBenchmarkRateFix',
        abbrName: 'BnchmkRtFix',
        addedEP: '247',
        added: 'FIX.5.0SP2',
        type: 'String',
        deprecated: 'FIX.Latest',
        id: 2796,
        description:
            'Specifies the foreign exchange benchmark rate fixing to be used in valuing the transaction. For example "London 4 p.m." or "Tokyo 3 p.m."',
    },
    {
        name: 'PayReportID',
        abbrName: 'RptID',
        addedEP: '249',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2799,
        description: 'Unique ID of the PayManagementReport(35=EA) message.',
    },
    {
        name: 'PayDisputeReason',
        abbrName: 'DsptRsn',
        unionDataType: 'Reserved100Plus',
        addedEP: '249',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2800,
        description:
            'Used to provide the reason for disputing a request or report.\n\nSee https://www.fixtrading.org/packages/PayDisputeReason for the list of applicable values.',
    },
    {
        name: 'EncodedReplaceText',
        abbrName: 'EncRplcTxt',
        addedEP: '249',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 2801,
        lengthId: '2802',
        description:
            'Encoded (non-ASCII characters) representation of the ReplaceText(2805) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) representation should also be specified in the ReplaceText(2805) field.',
    },
    {
        name: 'EncodedReplaceTextLen',
        abbrName: 'EncRplcTxtLen',
        addedEP: '249',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 2802,
        description: 'Byte length of encoded (non-ASCII characters) EncodedReplaceText(2801) field.',
    },
    {
        name: 'PayReportRefID',
        abbrName: 'RptRefID',
        addedEP: '249',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2803,
        description:
            'Reference identifier of the PayManagementReport(35=EA). To be used with PayReportTransType(2804)=1 (Replace).',
    },
    {
        name: 'PayReportTransType',
        abbrName: 'TxnTyp',
        addedEP: '249',
        added: 'FIX.5.0SP2',
        type: 'PayReportTransTypeCodeSet',
        id: 2804,
        description: 'Identifies the message transaction type.',
    },
    {
        name: 'ReplaceText',
        abbrName: 'RplcTxt',
        addedEP: '249',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2805,
        description: 'Identifies the reason for amendment.',
    },
    {
        name: 'PayReportStatus',
        abbrName: 'RptStat',
        addedEP: '249',
        added: 'FIX.5.0SP2',
        type: 'PayReportStatusCodeSet',
        id: 2806,
        description: 'Identifies status of the payment report.',
    },
    {
        name: 'CancelText',
        abbrName: 'CxlTxt',
        addedEP: '249',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2807,
        description: 'Identifies the reason for cancelation.',
    },
    {
        name: 'EncodedCancelText',
        abbrName: 'EncCxlTxt',
        addedEP: '249',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 2808,
        lengthId: '2809',
        description:
            'Encoded (non-ASCII characters) representation of the CancelText(2807) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) representation should also be specified in the CancelText(2807) field.',
    },
    {
        name: 'EncodedCancelTextLen',
        abbrName: 'EncCxlTxtLen',
        addedEP: '249',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 2809,
        description: 'Byte length of encoded (non-ASCII characters) EncodedCancelText(2808) field.',
    },
    {
        name: 'PayRequestRefID',
        abbrName: 'ReqRefID',
        addedEP: '249',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2810,
        description:
            'Reference identifier of the PayManagementRequest(35=DY). To be used with PayRequestTransType(2811)=1 (Cancel).',
    },
    {
        name: 'PayRequestTransType',
        abbrName: 'TxnTyp',
        addedEP: '249',
        added: 'FIX.5.0SP2',
        type: 'PayRequestTransTypeCodeSet',
        id: 2811,
        description: 'Identifies the message transaction type.',
    },
    {
        name: 'PayRequestID',
        abbrName: 'ReqID',
        addedEP: '249',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2812,
        description: 'Unique ID of the PayManagementRequest(35=DY) message.',
    },
    {
        name: 'PayRequestStatus',
        abbrName: 'ReqStat',
        addedEP: '249',
        added: 'FIX.5.0SP2',
        type: 'PayRequestStatusCodeSet',
        id: 2813,
        description: 'Identifies status of the request being responded to.',
    },
    {
        name: 'EncodedPostTradePaymentDesc',
        abbrName: 'EncDesc',
        addedEP: '249',
        added: 'FIX.5.0SP2',
        type: 'data',
        id: 2814,
        lengthId: '2815',
        description:
            'Encoded (non-ASCII characters) representation of the PostTradePaymentDesc(2820) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) representation should also be specified in the PostTradePaymentDesc(2820) field.',
    },
    {
        name: 'EncodedPostTradePaymentDescLen',
        abbrName: 'EncDescLen',
        addedEP: '249',
        added: 'FIX.5.0SP2',
        type: 'Length',
        id: 2815,
        description: 'Byte length of encoded (non-ASCII characters) EncodedPostTradePaymentDesc(2814) field.',
    },
    {
        name: 'PostTradePaymentAccount',
        abbrName: 'Acct',
        addedEP: '249',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2816,
        description:
            'The cash account on the books of the receiver of the request or the sender of the report to be debited or credited.',
    },
    {
        name: 'PostTradePaymentAmount',
        abbrName: 'Amt',
        addedEP: '249',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 2817,
        description: 'The payment amount for the specified PostTradePaymentType(2824).',
    },
    {
        name: 'PostTradePaymentCurrency',
        abbrName: 'Ccy',
        updated: 'FIX.Latest',
        addedEP: '249',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        updatedEP: '273',
        id: 2818,
        description:
            'Specifies the currency in which PostTradePaymentAmount(2817) is denominated.\n\nPostTradePaymentCurrencyCodeSource(2956) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.',
    },
    {
        name: 'PostTradePaymentDebitOrCredit',
        abbrName: 'DbtCrd',
        addedEP: '249',
        added: 'FIX.5.0SP2',
        type: 'PostTradePaymentDebitOrCreditCodeSet',
        id: 2819,
        description: "Payment side of this individual payment from the requesting firm's perspective.",
    },
    {
        name: 'PostTradePaymentDesc',
        abbrName: 'Desc',
        addedEP: '249',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2820,
        description:
            'A short descriptive name given to the payment, e.g. Premium, Upfront, etc. The description may be used as reference.',
    },
    {
        name: 'PostTradePaymentID',
        abbrName: 'ID',
        addedEP: '249',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2821,
        description: 'The identifier for the individual payment.',
    },
    {
        name: 'PostTradePaymentLinkID',
        abbrName: 'LinkID',
        addedEP: '249',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2822,
        description: 'Used to link a group of payments together, e.g. cross-currency payments associated with a swap.',
    },
    {
        name: 'PostTradePaymentStatus',
        abbrName: 'Stat',
        addedEP: '249',
        added: 'FIX.5.0SP2',
        type: 'PostTradePaymentStatusCodeSet',
        id: 2823,
        description: 'Used to indicate the status of a post-trade payment.',
    },
    {
        name: 'PostTradePaymentType',
        abbrName: 'Typ',
        addedEP: '249',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2824,
        description:
            'Type of post-trade payment.\n\nSee ISITC "Payments Cash Purpose Codes" for list of payment type codes to use available at https://isitc.org/market-practices/reference-data-and-standards-market-practice and select "ISITC Classification Code List".',
    },
    {
        name: 'PostTradePaymentCalculationDate',
        abbrName: 'CalcDt',
        addedEP: '249',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 2825,
        description: 'The (actual) date the periodic payments calculations are made.',
    },
    {
        name: 'PostTradePaymentValueDate',
        abbrName: 'ValuDt',
        addedEP: '249',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 2826,
        description:
            'The adjusted (for holidays and other non-business days) payment date on which the payment is expected to settle.',
    },
    {
        name: 'PostTradePaymentFinalValueDate',
        abbrName: 'FnlValuDt',
        addedEP: '249',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 2827,
        description: 'The actual or final payment date on which the payment was made.',
    },
    {
        name: 'CurrentDisplayPrice',
        abbrName: 'CurDspPx',
        addedEP: '253',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 2828,
        description:
            'Price at which the order is currently displayed to the market. Can be used on order messages, e.g. NewOrderSingle(35=D), to provide the current displayed price of a parent order when splitting it into smaller child orders.\n\nIn the context of US CAT this is used when reporting new child orders.',
    },
    {
        name: 'DuplicateClOrdIDIndicator',
        abbrName: 'DupClOrdIDInd',
        addedEP: '253',
        added: 'FIX.5.0SP2',
        type: 'DuplicateClOrdIDIndicatorCodeSet',
        id: 2829,
        description:
            'Used to indicate that a ClOrdID(11) value is an intentional duplicate of a previously sent value. Allows to avoid the rejection of an order with OrdRejReason(103) = 6 (Duplicate Order).\n\nIn the context of US CAT this can be used when the recipient of a previously routed order requires the same identifier to be re-used for a new route.',
    },
    {
        name: 'EventInitiatorType',
        abbrName: 'EvntInitrTyp',
        addedEP: '253',
        added: 'FIX.5.0SP2',
        type: 'EventInitiatorTypeCodeSet',
        id: 2830,
        description:
            'Indicates the type of entity who initiated an event, e.g. modification or cancellation of an order or quote.',
    },
    {
        name: 'NBBOEntryType',
        abbrName: 'NBBOTyp',
        addedEP: '253',
        added: 'FIX.5.0SP2',
        type: 'NBBOEntryTypeCodeSet',
        id: 2831,
        description: 'Type of NBBO information.',
    },
    {
        name: 'NBBOPrice',
        abbrName: 'NBBOPx',
        addedEP: '253',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 2832,
        description:
            'Price related to NBBO. NBBOEntryType(2831) may be used to indicate entry type, e.g. bid or offer.',
    },
    {
        name: 'NBBOQty',
        abbrName: 'NBBOQty',
        addedEP: '253',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 2833,
        description:
            'Quantity related to NBBO. NBBOEntryType(2831) may be used to indicte entry type, e.g. bid or offer.',
    },
    {
        name: 'NBBOSource',
        abbrName: 'NBBOSrc',
        addedEP: '253',
        added: 'FIX.5.0SP2',
        type: 'NBBOSourceCodeSet',
        id: 2834,
        description: 'Source of NBBO information.',
    },
    {
        name: 'OrderOriginationFirmID',
        abbrName: 'OrigntnFirmID',
        updated: 'FIX.5.0SP2',
        addedEP: '253',
        added: 'FIX.5.0SP2',
        type: 'String',
        updatedEP: '259',
        id: 2835,
        description:
            'Identifier for the original owner of an order as part of the RelatedOrderGrp component. Use the Parties component with PartyRole(452) = 13 (Order Origination Firm) to identify the original owner of an individual order.',
    },
    {
        name: 'RelatedOrderTime',
        abbrName: 'Tm',
        updated: 'FIX.5.0SP2',
        addedEP: '253',
        added: 'FIX.5.0SP2',
        type: 'UTCTimestamp',
        updatedEP: '259',
        id: 2836,
        description: 'Timestamp for the assignment of a (unique) identifier to an order.',
    },
    {
        name: 'SingleQuoteIndicator',
        abbrName: 'SnglQteInd',
        addedEP: '253',
        added: 'FIX.5.0SP2',
        type: 'SingleQuoteIndicatorCodeSet',
        id: 2837,
        description:
            'Used to indicate whether the quoting system allows only one quote to be active at a time for the quote issuer or market maker.',
    },
    {
        name: 'CurrentWorkingPrice',
        abbrName: 'CurWrkngPx',
        addedEP: '253',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 2838,
        description:
            'Current working price of the order relative to the state of the order.\n\nIn the context of US CAT this can be used for the current price of the parent order when reporting a split into new (child) orders.',
    },
    {
        name: 'TrdRegTimestampManualIndicator',
        abbrName: 'ManInd',
        addedEP: '253',
        added: 'FIX.5.0SP2',
        type: 'TrdRegTimestampManualIndicatorCodeSet',
        id: 2839,
        description: 'Indicates whether a given timestamp was manually captured.',
    },
    {
        name: 'CollateralReinvestmentRate',
        abbrName: 'RnvstmntRt',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 2840,
        description:
            'Interest rate received for collateral reinvestment.\n\nIn the context of EU SFTR this is the reinvestment interest rate received from cash collateral made by the lender. If there are multiple reinvestment types, this is an average rate.',
    },
    {
        name: 'UnderlyingRefID',
        abbrName: 'UndlyRefID',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2841,
        description:
            "Identifies the underlying instrument the entity applies to by referencing the underlying instrument's UnderlyingID(2874).",
    },
    {
        name: 'CollateralReinvestmentAmount',
        abbrName: 'Amt',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 2842,
        description: 'The cash amount of the specified re-investment type.',
    },
    {
        name: 'CollateralReinvestmentCurrency',
        abbrName: 'Ccy',
        updated: 'FIX.Latest',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        updatedEP: '273',
        id: 2843,
        description:
            'The currency denomination of the re-invested cash amount.\n\nCollateralReinvestmentCurrencyCodeSource(2931) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.',
    },
    {
        name: 'CollateralReinvestmentType',
        abbrName: 'Typ',
        unionDataType: 'Reserved100Plus',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'CollateralReinvestmentTypeCodeSet',
        id: 2844,
        description: 'Indicates the type of investment the cash collateral is re-invested in.',
    },
    {
        name: 'NoCollateralReinvestments',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2845,
        description: 'Number of instances of CollateralReinvestmentType(2844) in the repeating group.',
    },
    {
        name: 'FundingSource',
        abbrName: 'Src',
        unionDataType: 'Reserved100Plus',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'FundingSourceCodeSet',
        id: 2846,
        description: 'Specifies the funding source used to finance margin or collateralized loan.',
    },
    {
        name: 'FundingSourceCurrency',
        abbrName: 'Ccy',
        updated: 'FIX.Latest',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        updatedEP: '273',
        id: 2847,
        description:
            'Currency denomination of the market value of the funding source.\n\nFundingSourceCurrencyCodeSource(2954) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.',
    },
    {
        name: 'FundingSourceMarketValue',
        abbrName: 'MktValu',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 2848,
        description: 'Market value of the funding source.',
    },
    {
        name: 'NoFundingSources',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2849,
        description: 'Number of instances of FundingSource(2846) in the repeating group.',
    },
    {
        name: 'LegPaymentStreamOtherDayCount',
        abbrName: 'OtherDayCnt',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 43108,
        description: 'The industry name of the day count convention not listed in LegPaymentStreamDayCount(40283).',
    },
    {
        name: 'MarginDirection',
        abbrName: 'Dirctn',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'MarginDirectionCodeSet',
        id: 2851,
        description: 'Indicates whether the margin described is posted or received.',
    },
    {
        name: 'PaymentFixedRate',
        abbrName: 'Rt',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 43097,
        description: 'The rate applicable to the fixed rate payment.',
    },
    {
        name: 'PaymentFloatingRateIndex',
        abbrName: 'Ndx',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 43098,
        description: 'The payment floating rate index. See SpreadOrBenchmarkCurveData(221) for suggested values.',
    },
    {
        name: 'PaymentFloatingRateIndexCurvePeriod',
        abbrName: 'NdxPeriod',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 43099,
        description: 'Time unit multiplier for the floating rate index.',
    },
    {
        name: 'PaymentFloatingRateIndexCurveUnit',
        abbrName: 'NdxUnit',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexCurveUnitCodeSet',
        id: 43100,
        description: 'Time unit associated with the floating rate index.',
    },
    {
        name: 'PaymentFloatingRateSpread',
        abbrName: 'Spread',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'PriceOffset',
        id: 43101,
        description: 'Spread from floating rate index.',
    },
    {
        name: 'PaymentFrequencyPeriod',
        abbrName: 'FreqPeriod',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 43102,
        description: 'Time unit multiplier for the payment frequency.',
    },
    {
        name: 'PaymentFrequencyUnit',
        abbrName: 'FreqUnit',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexCurveUnitCodeSet',
        id: 43103,
        description: 'Time unit associated with the payment frequency.',
    },
    {
        name: 'PaymentRateResetFrequencyPeriod',
        abbrName: 'ResetFreqPeriod',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 43104,
        description: 'Time unit multiplier for the floating rate reset frequency.',
    },
    {
        name: 'PaymentRateResetFrequencyUnit',
        abbrName: 'ResetFreqUnit',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'PaymentStreamRateIndexCurveUnitCodeSet',
        id: 43105,
        description: 'Time unit associated with the floating rate reset frequency.',
    },
    {
        name: 'PaymentStreamOtherDayCount',
        abbrName: 'OtherDayCnt',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 43106,
        description: 'The industry name of the day count convention not listed in PaymentStreamDayCount(40742).',
    },
    {
        name: 'SideCollateralReinvestmentRate',
        abbrName: 'RnvstmntRt',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'Percentage',
        id: 2862,
        description:
            'Interest rate received for collateral reinvestment.\n\nIn the context of EU SFTR this is the reinvestment interest rate received from cash collateral made by the lender. If there are multiple reinvestment types, this is an average rate.',
    },
    {
        name: 'SideUnderlyingRefID',
        abbrName: 'UndlyRefID',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2863,
        description:
            "Identifies the underlying instrument the entity applies to by referencing the underlying instrument's UnderlyingID(2874).",
    },
    {
        name: 'NoSideCollateralReinvestments',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2864,
        description: 'Number of instances of SideCollateralReinvestmentType(2867) in the repeating group.',
    },
    {
        name: 'SideCollateralReinvestmentAmount',
        abbrName: 'Amt',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 2865,
        description: 'The cash amount of the specified re-investment type.',
    },
    {
        name: 'SideCollateralReinvestmentCurrency',
        abbrName: 'Ccy',
        updated: 'FIX.Latest',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'Currency',
        updatedEP: '273',
        id: 2866,
        description:
            'The currency denomination of the re-invested cash amount.\n\nSideCollateralReinvestmentCurrencyCodeSource(2932) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.',
    },
    {
        name: 'SideCollateralReinvestmentType',
        abbrName: 'Typ',
        unionDataType: 'Reserved100Plus',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'CollateralReinvestmentTypeCodeSet',
        id: 2867,
        description: 'Indicates the type of investment the cash collateral is re-invested in.',
    },
    {
        name: 'CollateralizationValueDate',
        abbrName: 'CollztnValuDt',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 2868,
        description: 'Date when the collateral is to be assessed or assigned.',
    },
    {
        name: 'RegulatoryReportTypeBusinessDate',
        abbrName: 'RegRptTypBizDt',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 2869,
        description:
            'The business date on which the event identified in RegulatoryReportType(1934) took place.\n\nIn the context of EU SFTR reports with a RegulatoryReportType(1934) value 7 (Post-trade valuation), 31 (Collateral update) or 32 (Margin update), the business date on which the business event took place, which results in the information contained in the report.',
    },
    {
        name: 'ClearingPortfolioID',
        abbrName: 'ClrPrtflioID',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2870,
        description:
            'When the transaction is cleared and included in a portfolio of transactions this identifies the portfolio by its unique identifier.\n\nIn the context of EU SFTR reporting this applies to cleared transactions grouped in a portfolio for which margins are exchanged.',
    },
    {
        name: 'NoTransactionAttributes',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'NumInGroup',
        id: 2871,
        description: 'Number of instances of TransactionAttributeType(2872) in the repeating group.',
    },
    {
        name: 'TransactionAttributeType',
        abbrName: 'Typ',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'TransactionAttributeTypeCodeSet',
        id: 2872,
        description: 'Type of attribute(s) or characteristic(s) associated with the transaction.',
    },
    {
        name: 'TransactionAttributeValue',
        abbrName: 'Valu',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2873,
        description: 'Value associated with the specificed TransactionAttributeType(2872).',
    },
    {
        name: 'UnderlyingID',
        abbrName: 'UdlyID',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2874,
        description:
            'Unique identifier for the underlying instrument within the context of a message.\n\nThe UnderlyingID(2874) can be referenced by other fields, for example UnderlyingRefID(tbd2841) and SideUnderlyingRefID(2863), from other components . The scope of uniqueness is agreed upon between counterparties.',
    },
    {
        name: 'UnderlyingPaymentStreamOtherDayCount',
        abbrName: 'OtherDayCnt',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 43107,
        description:
            'The industry name of the day count convention not listed in UnderlyingPaymentStreamDayCount(40572).',
    },
    {
        name: 'PosAmtPrice',
        abbrName: 'Px',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'Price',
        id: 2876,
        description:
            "The price used to calculate the PosAmt(708).\n\nThis may be used for certain PosAmtType(707) values where the PosAmt(708) is based on the current price of the position's security. In the context of EU SFTR reporting, this is the price used to calculate the loan value for securities loan and borrowing, and buy-sell back. The price may be expressed in units or percentage of the underlying security, yield or an absolute amount that ignores netting. For Buy/Sellback it expresses the initial spot price.",
    },
    {
        name: 'PosAmtPriceType',
        abbrName: 'PxTyp',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'PriceTypeCodeSet',
        id: 2877,
        description: 'Specifies the type of price for PosAmtPrice(2876).',
    },
    {
        name: 'TerminationDate',
        abbrName: 'TmntnDt',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'LocalMktDate',
        id: 2878,
        description:
            "The date of a contract's early termination or other post-trade event when the event is prior to the contract natural end or maturity not defined as part of the security's reference data or contractual terms/agreement.",
    },
    {
        name: 'CouponOtherDayCount',
        abbrName: 'CpnOtherDayCnt',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2879,
        description: 'The industry name of the day count convention not listed in CouponDayCount(1950).',
    },
    {
        name: 'LegCouponOtherDayCount',
        abbrName: 'CpnOtherDayCnt',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2880,
        description: 'The industry name of the day count convention not listed in LegCouponDayCount(2165).',
    },
    {
        name: 'UnderlyingCouponOtherDayCount',
        abbrName: 'CpnOtherDayCnt',
        addedEP: '254',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2881,
        description: 'The industry name of the day count convention not listed in UnderlyingCouponDayCount(1993).',
    },
    {
        name: 'ContraOrderOrigination',
        abbrName: 'CntraOrdOrigntn',
        addedEP: '256',
        added: 'FIX.5.0SP2',
        type: 'OrderOriginationCodeSet',
        id: 2882,
        description: 'Identifies the origin of the order from the counterparty of the execution or trade.',
    },
    {
        name: 'RoutingArrangementIndicator',
        abbrName: 'RtgArngmntInd',
        updated: 'FIX.Latest',
        addedEP: '256',
        added: 'FIX.5.0SP2',
        type: 'RoutingArrangementIndicatorCodeSet',
        updatedEP: '294',
        id: 2883,
        description:
            'Indicates whether a routing arrangement is in place, e.g. between two brokers. May be used together with OrderOrigination(1724) to further describe the origin of an order.\n\nAn arrangement under which a participant of a marketplace permits a broker to electronically transmit orders containing the identifier of the participant. This can be either through the systems of the participant for automatic onward transmission to a marketplace or directly to a marketplace without being electronically transmitted through the systems of the participant.',
    },
    {
        name: 'ContraRoutingArrangementIndicator',
        abbrName: 'CntraRtgArngmntInd',
        updated: 'FIX.Latest',
        addedEP: '256',
        added: 'FIX.5.0SP2',
        type: 'RoutingArrangementIndicatorCodeSet',
        updatedEP: '294',
        id: 2884,
        description:
            'Indicates whether a routing arrangement is in place, e.g. between two brokers. May be used together with ContraOrderOrigination(2882) to further describe the origin of an order.',
    },
    {
        name: 'PaymentStreamFormulaLength',
        abbrName: 'FrmlaLen',
        updated: 'FIX.Latest',
        addedEP: '257',
        added: 'FIX.5.0SP2',
        type: 'Length',
        updatedEP: '275',
        id: 43109,
        description: 'Byte length of encoded (non-ASCII characters) PaymentStreamFormula(42648) field.',
    },
    {
        name: 'LegPaymentStreamFormulaLength',
        abbrName: 'FrmlaLen',
        updated: 'FIX.Latest',
        addedEP: '257',
        added: 'FIX.5.0SP2',
        type: 'Length',
        updatedEP: '275',
        id: 43110,
        description: 'Byte length of encoded (non-ASCII characters) LegPaymentStreamFormula(42486) field.',
    },
    {
        name: 'UnderlyingPaymentStreamFormulaLength',
        abbrName: 'FrmlaLen',
        updated: 'FIX.Latest',
        addedEP: '257',
        added: 'FIX.5.0SP2',
        type: 'Length',
        updatedEP: '275',
        id: 43111,
        description: 'Byte length of encoded (non-ASCII characters) UnderlyingPaymentStreamFormula(42982) field.',
    },
    {
        name: 'UnderlyingAccruedInterestAmt',
        abbrName: 'AcrdIntAmt',
        addedEP: '258',
        added: 'FIX.5.0SP2',
        type: 'Amt',
        id: 2885,
        description: 'Amount of accrued interest of underlying security.',
    },
    {
        name: 'UnderlyingNumDaysInterest',
        abbrName: 'NumDaysInt',
        addedEP: '258',
        added: 'FIX.5.0SP2',
        type: 'int',
        id: 2886,
        description: 'Number of days of interest for underlying security.',
    },
    {
        name: 'RelatedOrderID',
        abbrName: 'ID',
        addedEP: '259',
        added: 'FIX.5.0SP2',
        type: 'String',
        id: 2887,
        discriminatorId: '2888',
        description: 'Identifier of a related order.',
    },
    {
        name: 'RelatedOrderIDSource',
        abbrName: 'Src',
        addedEP: '259',
        added: 'FIX.5.0SP2',
        type: 'RelatedOrderIDSourceCodeSet',
        id: 2888,
        description: 'Describes the source of the identifier that RelatedOrderID(2887) represents.',
    },
    {
        name: 'RelatedOrderQty',
        abbrName: 'Qty',
        addedEP: '259',
        added: 'FIX.5.0SP2',
        type: 'Qty',
        id: 2889,
        description:
            'Quantity of the related order which can be less than its total quantity. For example, when only parts of an order contribute to an aggregated order.',
    },
    {
        name: 'OrderRelationship',
        abbrName: 'Rltnshp',
        addedEP: '259',
        added: 'FIX.5.0SP2',
        type: 'OrderRelationshipCodeSet',
        id: 2890,
        description:
            'Describes the type of relationship between the order identified by RelatedOrderID(2887) and the order outside of the RelatedOrderGrp component.',
    },
    {
        name: 'UPICode',
        abbrName: 'UPI',
        addedEP: '266',
        added: 'FIX.Latest',
        type: 'String',
        id: 2891,
        description:
            'Uniquely identifies the product of a security using ISO 4914 standard, Unique Product Identifier (UPI). The DSB (Derivative Service Bureau Ltd) is acting as designated service provider for UPI System.',
    },
    {
        name: 'DerivativeUPICode',
        abbrName: 'UPI',
        updated: 'FIX.Latest',
        addedEP: '266',
        added: 'FIX.Latest',
        type: 'String',
        updatedEP: '271',
        id: 2892,
        description:
            'Uniquely identifies the product of a derivative instrument using ISO 4914. See UPICode(2891) for complete definition.',
    },
    {
        name: 'LegUPICode',
        abbrName: 'UPI',
        addedEP: '266',
        added: 'FIX.Latest',
        type: 'String',
        id: 2893,
        description:
            'Uniquely identifies the product of a leg instrument using ISO 4914. See UPICode(2891) for further detail.',
    },
    {
        name: 'UnderlyingUPICode',
        abbrName: 'UPI',
        addedEP: '266',
        added: 'FIX.Latest',
        type: 'String',
        id: 2894,
        description:
            'Uniquely identifies the product of an underlying instrument using ISO 4914. See UPICode(2891) for further detail.',
    },
    {
        name: 'InstrumentScopeUPICode',
        abbrName: 'UPI',
        addedEP: '266',
        added: 'FIX.Latest',
        type: 'String',
        id: 2895,
        description:
            'Uniquely identifies the product of a security using ISO 4914 as filter criteria. See UPICode(2891) for further detail.',
    },
    {
        name: 'TertiaryTrdType',
        abbrName: 'TrdTyp3',
        unionDataType: 'Reserved1000Plus',
        addedEP: '268',
        added: 'FIX.Latest',
        type: 'TrdTypeCodeSet',
        id: 2896,
        description:
            'Type of trade assigned to a trade. Used in addition to TrdType(828) and SecondaryTrdType(855). Must not be used when only one additional trade type needs to be assigned.',
    },
    {
        name: 'PaymentStreamRateIndex2',
        abbrName: 'Ndx2',
        addedEP: '271',
        added: 'FIX.Latest',
        type: 'String',
        id: 43112,
        discriminatorId: '43113',
        description: "The payment stream's second floating rate index.",
    },
    {
        name: 'PaymentStreamRateIndex2Source',
        abbrName: 'Ndx2Src',
        addedEP: '271',
        added: 'FIX.Latest',
        type: 'PaymentStreamRateIndexSourceCodeSet',
        id: 43113,
        description: "The source of the payment stream's second floating rate index.",
    },
    {
        name: 'PaymentStreamRateIndex2ID',
        abbrName: 'Ndx2ID',
        addedEP: '271',
        added: 'FIX.Latest',
        type: 'String',
        id: 43114,
        discriminatorId: '43115',
        description: 'Security identifier of the second floating rate index.',
    },
    {
        name: 'PaymentStreamRateIndex2IDSource',
        abbrName: 'Ndx2IDSrc',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.Latest',
        addedEP: '271',
        added: 'FIX.Latest',
        type: 'SecurityIDSourceCodeSet',
        updatedEP: '294',
        id: 43115,
        description: 'Source for the second floating rate index identified in PaymentStreamRateIndex2ID(43114).',
    },
    {
        name: 'LegPaymentStreamRateIndex2',
        abbrName: 'Ndx2',
        addedEP: '271',
        added: 'FIX.Latest',
        type: 'String',
        id: 43116,
        discriminatorId: '43117',
        description: "The payment stream's second floating rate index.",
    },
    {
        name: 'LegPaymentStreamRateIndex2Source',
        abbrName: 'Ndx2Src',
        addedEP: '271',
        added: 'FIX.Latest',
        type: 'PaymentStreamRateIndexSourceCodeSet',
        id: 43117,
        description: "The source of the payment stream's second floating rate index.",
    },
    {
        name: 'LegPaymentStreamRateIndex2ID',
        abbrName: 'Ndx2ID',
        addedEP: '271',
        added: 'FIX.Latest',
        type: 'String',
        id: 43118,
        discriminatorId: '43119',
        description: 'Security identifier of the second floating rate index.',
    },
    {
        name: 'LegPaymentStreamRateIndex2IDSource',
        abbrName: 'Ndx2IDSrc',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.Latest',
        addedEP: '271',
        added: 'FIX.Latest',
        type: 'SecurityIDSourceCodeSet',
        updatedEP: '294',
        id: 43119,
        description: 'Source for the second floating rate index identified in LegPaymentStreamRateIndex2ID(43118).',
    },
    {
        name: 'UnderlyingPaymentStreamRateIndex2',
        abbrName: 'Ndx2',
        addedEP: '271',
        added: 'FIX.Latest',
        type: 'String',
        id: 43120,
        discriminatorId: '43121',
        description: "The payment stream's second floating rate index.",
    },
    {
        name: 'UnderlyingPaymentStreamRateIndex2Source',
        abbrName: 'Ndx2Src',
        addedEP: '271',
        added: 'FIX.Latest',
        type: 'PaymentStreamRateIndexSourceCodeSet',
        id: 43121,
        description: "The source of the payment stream's second floating rate index.",
    },
    {
        name: 'UnderlyingPaymentStreamRateIndex2ID',
        abbrName: 'Ndx2ID',
        addedEP: '271',
        added: 'FIX.Latest',
        type: 'String',
        id: 43122,
        discriminatorId: '43123',
        description: 'Security identifier of the second floating rate index.',
    },
    {
        name: 'UnderlyingPaymentStreamRateIndex2IDSource',
        abbrName: 'Ndx2IDSrc',
        unionDataType: 'Reserved100Plus',
        updated: 'FIX.Latest',
        addedEP: '271',
        added: 'FIX.Latest',
        type: 'SecurityIDSourceCodeSet',
        updatedEP: '294',
        id: 43123,
        description:
            'Source for the second floating rate index identified in UnderlyingPaymentStreamRateIndex2ID(43122).',
    },
    {
        name: 'CurrencyCodeSource',
        abbrName: 'CcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2897,
        description: 'Identifies class or source of the Currency(15) value.',
    },
    {
        name: 'LegCurrencyCodeSource',
        abbrName: 'CcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2898,
        description: 'Identifies class or source of the LegCurrency(556) value.',
    },
    {
        name: 'SettlCurrencyCodeSource',
        abbrName: 'SettlCcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2899,
        description: 'Identifies class or source of the SettlCurrency(120) value.',
    },
    {
        name: 'LegSettlCurrencyCodeSource',
        abbrName: 'SettlCcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2900,
        description: 'Identifies class or source of the LegSettlCurrency(675) value.',
    },
    {
        name: 'SideCurrencyCodeSource',
        abbrName: 'CcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2901,
        description: 'Identifies class or source of the SideCurrency(1154) value.',
    },
    {
        name: 'SideSettlCurrencyCodeSource',
        abbrName: 'SettlCcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2902,
        description: 'Identifies class or source of the SideSettlCurrency(1155) value.',
    },
    {
        name: 'SettlementAmountCurrencyCodeSource',
        abbrName: 'CcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2903,
        description: 'Identifies class or source of the SettlementAmountCurrency(1702) value.',
    },
    {
        name: 'StrikeCurrencyCodeSource',
        abbrName: 'StrkCcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2904,
        description: 'Identifies class or source of the StrikeCurrency(947) value.',
    },
    {
        name: 'UnitOfMeasureCurrencyCodeSource',
        abbrName: 'UOMCcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2905,
        description: 'Identifies class or source of the UnitOfMeasureCurrency(1716) value.',
    },
    {
        name: 'PriceUnitOfMeasureCurrencyCodeSource',
        abbrName: 'PxUOMCcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2906,
        description: 'Identifies class or source of the PriceUnitOfMeasureCurrency(1717) value.',
    },
    {
        name: 'PriceQuoteCurrencyCodeSource',
        abbrName: 'PxQteCcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2907,
        description: 'Identifies class or source of the PriceQuoteCurrency(1524) value.',
    },
    {
        name: 'LegStrikeCurrencyCodeSource',
        abbrName: 'StrkCcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2908,
        description: 'Identifies class or source of the LegStrikeCurrency(942) value.',
    },
    {
        name: 'LegUnitOfMeasureCurrencyCodeSource',
        abbrName: 'UOMCcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2909,
        description: 'Identifies class or source of the LegUnitOfMeasureCurrency(1720) value.',
    },
    {
        name: 'LegPriceUnitOfMeasureCurrencyCodeSource',
        abbrName: 'PxUOMCcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2910,
        description: 'Identifies class or source of the LegPriceUnitOfMeasureCurrency(1721) value.',
    },
    {
        name: 'LegPriceQuoteCurrencyCodeSource',
        abbrName: 'PxQteCcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2911,
        description: 'Identifies class or source of the LegPriceQuoteCurrency(1528) value.',
    },
    {
        name: 'DerivativeStrikeCurrencyCodeSource',
        abbrName: 'StrkCcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2912,
        description: 'Identifies class or source of the DerivativeStrikeCurrency(1262) value.',
    },
    {
        name: 'DerivativeUnitOfMeasureCurrencyCodeSource',
        abbrName: 'UOMCcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2913,
        description: 'Identifies class or source of the DerivativeUnitOfMeasureCurrency(1722) value.',
    },
    {
        name: 'DerivativePriceUnitOfMeasureCurrencyCodeSource',
        abbrName: 'PxUOMCcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2914,
        description: 'Identifies class or source of the DerivativePriceUnitOfMeasureCurrency(1723) value.',
    },
    {
        name: 'DerivativePriceQuoteCurrencyCodeSource',
        abbrName: 'PxQteCcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2915,
        description: 'Identifies class or source of the DerivativePriceQuoteCurrency(1576) value.',
    },
    {
        name: 'UnderlyingCurrencyCodeSource',
        abbrName: 'CcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2916,
        description: 'Identifies class or source of the UnderlyingCurrency(318) value.',
    },
    {
        name: 'UnderlyingStrikeCurrencyCodeSource',
        abbrName: 'StrkCcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2917,
        description: 'Identifies class or source of the UnderlyingStrikeCurrency(941) value.',
    },
    {
        name: 'UnderlyingUnitOfMeasureCurrencyCodeSource',
        abbrName: 'UOMCcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2918,
        description: 'Identifies class or source of the UnderlyingUnitOfMeasureCurrency(1718) value.',
    },
    {
        name: 'UnderlyingPriceUnitOfMeasureCurrencyCodeSource',
        abbrName: 'PxUOMCcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2919,
        description: 'Identifies class or source of the UnderlyingPriceUnitOfMeasureCurrency(1719) value.',
    },
    {
        name: 'UnderlyingPriceQuoteCurrencyCodeSource',
        abbrName: 'PxQteCcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2920,
        description: 'Identifies class or source of the UnderlyingPriceQuoteCurrency(1526) value.',
    },
    {
        name: 'UnderlyingNotionalCurrencyCodeSource',
        abbrName: 'NotlCcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2921,
        description: 'Identifies class or source of the UnderlyingNotionalCurrency(2615) value.',
    },
    {
        name: 'CommCurrencyCodeSource',
        abbrName: 'CcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2922,
        description: 'Identifies class or source of the CommCurrency(479) value.',
    },
    {
        name: 'CommissionCurrencyCodeSource',
        abbrName: 'CcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2923,
        description: 'Identifies class or source of the CommissionCurrency(2643) value.',
    },
    {
        name: 'CommissionUnitOfMeasureCurrencyCodeSource',
        abbrName: 'UOMCcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2924,
        description: 'Identifies class or source of the CommissionUnitOfMeasureCurrency(2645) value.',
    },
    {
        name: 'AllocCommissionCurrencyCodeSource',
        abbrName: 'CcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2925,
        description: 'Identifies class or source of the AllocCommissionCurrency(2657) value.',
    },
    {
        name: 'AllocCommissionUnitOfMeasureCurrencyCodeSource',
        abbrName: 'UOMCcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2926,
        description: 'Identifies class or source of the AllocCommissionUnitOfMeasureCurrency(2659) value.',
    },
    {
        name: 'AllocSettlCurrencyCodeSource',
        abbrName: 'AllocSettlCcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2927,
        description: 'Identifies class or source of the AllocSettlCurrency(736) value.',
    },
    {
        name: 'LegAllocSettlCurrencyCodeSource',
        abbrName: 'AllocSettlCcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2928,
        description: 'Identifies class or source of the LegAllocSettlCurrency(1367) value.',
    },
    {
        name: 'CollateralCurrencyCodeSource',
        abbrName: 'CcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2929,
        description: 'Identifies class or source of the CollateralCurrency(1705) value.',
    },
    {
        name: 'SideCollateralCurrencyCodeSource',
        abbrName: 'CcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2930,
        description: 'Identifies class or source of the SideCollateralCurrency(2695) value.',
    },
    {
        name: 'CollateralReinvestmentCurrencyCodeSource',
        abbrName: 'CcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2931,
        description: 'Identifies class or source of the CollateralReinvestmentCurrency(2843) value.',
    },
    {
        name: 'SideCollateralReinvestmentCurrencyCodeSource',
        abbrName: 'CcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2932,
        description: 'Identifies class or source of the SideCollateralReinvestmentCurrency(2866) value.',
    },
    {
        name: 'TradeAllocCurrencyCodeSource',
        abbrName: 'CcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2933,
        description: 'Identifies class or source of the TradeAllocCurrency(1847) value.',
    },
    {
        name: 'TradingCurrencyCodeSource',
        abbrName: 'TrdCcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2934,
        description: 'Identifies class or source of the TradingCurrency(1245) value.',
    },
    {
        name: 'LimitAmtCurrencyCodeSource',
        abbrName: 'LmtAmtCcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2935,
        description: 'Identifies class or source of the LimitAmtCurrency(1634) value.',
    },
    {
        name: 'PosQtyUnitOfMeasureCurrencyCodeSource',
        abbrName: 'UOMCcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2936,
        description: 'Identifies class or source of the PosQtyUnitOfMeasureCurrency(1835) value.',
    },
    {
        name: 'PositionCurrencyCodeSource',
        abbrName: 'CcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2937,
        description: 'Identifies class or source of the PositionCurrency(1055) value.',
    },
    {
        name: 'LegPosCurrencyCodeSource',
        abbrName: 'CcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2938,
        description: 'Identifies class or source of the LegPosCurrency(1589) value.',
    },
    {
        name: 'RiskLimitCurrencyCodeSource',
        abbrName: 'CcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2939,
        description: 'Identifies class or source of the RiskLimitCurrency(1532) value.',
    },
    {
        name: 'EntitlementAttribCurrencyCodeSource',
        abbrName: 'CcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2940,
        description: 'Identifies class or source of the EntitlementAttribCurrency(1781) value.',
    },
    {
        name: 'ComplexOptPayoutCurrencyCodeSource',
        abbrName: 'OptCcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2941,
        description: 'Identifies class or source of the ComplexOptPayoutCurrency(2122) value.',
    },
    {
        name: 'ComplexEventCurrencyOneCodeSource',
        abbrName: 'Ccy1Src',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2942,
        description: 'Identifies class or source of the ComplexEventCurrencyOne(2124) value.',
    },
    {
        name: 'ComplexEventCurrencyTwoCodeSource',
        abbrName: 'Ccy2Src',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2943,
        description: 'Identifies class or source of the ComplexEventCurrencyTwo(2125) value.',
    },
    {
        name: 'LegComplexOptPayoutCurrencyCodeSource',
        abbrName: 'OptCcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2944,
        description: 'Identifies class or source of the LegComplexOptPayoutCurrency(2226) value.',
    },
    {
        name: 'LegComplexEventCurrencyOneCodeSource',
        abbrName: 'Ccy1Src',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2945,
        description: 'Identifies class or source of the LegComplexEventCurrencyOne(2233) value.',
    },
    {
        name: 'LegComplexEventCurrencyTwoCodeSource',
        abbrName: 'Ccy2Src',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2946,
        description: 'Identifies class or source of the LegComplexEventCurrencyTwo(2234) value.',
    },
    {
        name: 'UnderlyingComplexOptPayoutCurrencyCodeSource',
        abbrName: 'OptCcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2947,
        description: 'Identifies class or source of the UnderlyingComplexOptPayoutCurrency(2266) value.',
    },
    {
        name: 'UnderlyingComplexEventCurrencyOneCodeSource',
        abbrName: 'Ccy1Src',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2948,
        description: 'Identifies class or source of the UnderlyingComplexEventCurrencyOne(2268) value.',
    },
    {
        name: 'UnderlyingComplexEventCurrencyTwoCodeSource',
        abbrName: 'Ccy2Src',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2949,
        description: 'Identifies class or source of the UnderlyingComplexEventCurrencyTwo(2269) value.',
    },
    {
        name: 'BenchmarkCurveCurrencyCodeSource',
        abbrName: 'CcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2950,
        description: 'Identifies class or source of the BenchmarkCurveCurrency(220) value.',
    },
    {
        name: 'LegBenchmarkCurveCurrencyCodeSource',
        abbrName: 'CcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2951,
        description: 'Identifies class or source of the LegBenchmarkCurveCurrency(676) value.',
    },
    {
        name: 'AgreementCurrencyCodeSource',
        abbrName: 'AgmtCcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2952,
        description: 'Identifies class or source of the AgreementCurrency(918) value.',
    },
    {
        name: 'LegAgreementCurrencyCodeSource',
        abbrName: 'AgmtCcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2953,
        description: 'Identifies class or source of the LegAgreementCurrency(2495) value.',
    },
    {
        name: 'FundingSourceCurrencyCodeSource',
        abbrName: 'CcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2954,
        description: 'Identifies class or source of the FundingSourceCurrency(2847) value.',
    },
    {
        name: 'PayCollectCurrencyCodeSource',
        abbrName: 'CcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2955,
        description: 'Identifies class or source of the PayCollectCurrency(1709) value.',
    },
    {
        name: 'PostTradePaymentCurrencyCodeSource',
        abbrName: 'CcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2956,
        description: 'Identifies class or source of the PostTradePaymentCurrency(2818) value.',
    },
    {
        name: 'SymbolPositionNumber',
        abbrName: 'SymPosNum',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'int',
        id: 2957,
        description:
            'Reference to the first or second currency or digital asset in Symbol(55) for FX-style trading.\n\nConditionally required when one or both symbols in Symbol(55) represent a digital asset.',
    },
    {
        name: 'LegSymbolPositionNumber',
        abbrName: 'SymPosNum',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'int',
        id: 2958,
        description:
            'Reference to the first or second currency or digital asset in LegSymbol(600) for FX-style trading.\n\nConditionally required when one or both symbols in LegSymbol(600) represent a digital asset.',
    },
    {
        name: 'UnderlyingSymbolPositionNumber',
        abbrName: 'SymPosNum',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'int',
        id: 2959,
        description:
            'Reference to the first or second currency or digital asset in UnderlyingSymbol(311) for FX-style trading.\n\nConditionally required when one or both symbols in UnderlyingSymbol(311) represent a digital asset.',
    },
    {
        name: 'SettlPriceUnitOfMeasureCurrencyCodeSource',
        abbrName: 'SetPxUOMCcySrc',
        addedEP: '273',
        added: 'FIX.Latest',
        type: 'CurrencyCodeSourceCodeSet',
        id: 2960,
        description: 'Identifies the class or source of the SettlPriceUnitOfMeasureCurrency(1887) value.',
    },
    {
        name: 'AnonymousTradeIndicator',
        abbrName: 'AnonymsTrdInd',
        addedEP: '274',
        added: 'FIX.Latest',
        type: 'Boolean',
        id: 2961,
        description: 'Indicates whether the trade or transaction was executed anonymously.',
    },
    {
        name: 'SecurityReferenceDataSupplement',
        abbrName: 'SecRefDataSupplmnt',
        addedEP: '276',
        added: 'FIX.Latest',
        type: 'String',
        id: 2962,
        description:
            'May be used to generically assist in disambiguating an instrument where the security identifier and core reference data attributes are not sufficient to uniquely identify the instrument. The values used are bilaterally agreed.\n\nThe data used for disambiguation can be of synthetic nature (e.g. 1, 2, 3,... or A, B, C,...) or based on other characteristic of the instrument. An example of the latter is an energy futures or options contract which may have the same expiration date with different delivery dates that fall on a non-business day; in such a use case the first day of delivery date may be used to disambiguate such contract (date expression used should be bilaterally agreed).',
    },
    {
        name: 'MultiJurisdictionReportingIndicator',
        abbrName: 'MultiJrsdctnRptInd',
        addedEP: '277',
        added: 'FIX.Latest',
        type: 'MultiJurisdictionReportingIndicatorCodeSet',
        id: 2963,
        description:
            'Indicate whether a trade is eligible to be reported to more than one regulatory jurisdictions, e.g. due to overlapping reporting rules that require reporting to different jurisdictions.',
    },
    {
        name: 'SelfMatchPreventionInstruction',
        abbrName: 'SlfMtchPrvntnInst',
        addedEP: '280',
        added: 'FIX.Latest',
        type: 'SelfMatchPreventionInstructionCodeSet',
        id: 2964,
        description:
            'Indicate the instruction for self-match prevention when the incoming (aggressive) order has the same SelfMatchPreventionID(2362) as a resting (passive) order.',
    },
    {
        name: 'SettlStatusRequestID',
        abbrName: 'ReqID',
        addedEP: '281',
        added: 'FIX.Latest',
        type: 'String',
        id: 2965,
        description: 'Unique identifier of the SettlementStatusRequest(35=EC).',
    },
    {
        name: 'SettlStatusRequestStatus',
        abbrName: 'ReqStat',
        addedEP: '281',
        added: 'FIX.Latest',
        type: 'SettlStatusRequestStatusCodeSet',
        id: 2966,
        description: 'Status of the SettlementStatusRequest(35=EC) message being responded to.',
    },
    {
        name: 'SettlStatusReportID',
        abbrName: 'RptID',
        addedEP: '281',
        added: 'FIX.Latest',
        type: 'String',
        id: 2967,
        description: 'Unique identifier of the SettlementStatusReport(35=EE).',
    },
    {
        name: 'SettlStatus',
        abbrName: 'SettlStat',
        addedEP: '281',
        added: 'FIX.Latest',
        type: 'String',
        id: 2968,
        description:
            'The settlement status of the identified trade.\n\nThis field mirrors MT548 subsequence A2 field 25D Status Code. See https://www.iso20022.org/15022/uhb/mt548-10-field-25d.htm for MT548 code values.',
    },
    {
        name: 'SettlStatusReason',
        abbrName: 'SettlStatRsn',
        addedEP: '281',
        added: 'FIX.Latest',
        type: 'String',
        id: 2969,
        description:
            'Used to provide additional reason or qualify the reason for the settlement status specified in SettlStatus(2968).\n\nThis field mirrors MT548 subsequence A2a field 24B Reason Code. See https://www.iso20022.org/15022/uhb/mt548-12-field-24b.htm for MT548 code values.',
    },
    {
        name: 'SettlStatusReasonText',
        abbrName: 'SettlStatRsnTxt',
        addedEP: '281',
        added: 'FIX.Latest',
        type: 'String',
        id: 2970,
        description:
            'Text description associated with SettlStatusReason(2969).\n\nThis field mirrors MT548 subsequence A2a field 70D Narrative.',
    },
    {
        name: 'EncodedSettlStatusReasonTextLen',
        abbrName: 'EncSettlStatRsnTxtLen',
        addedEP: '281',
        added: 'FIX.Latest',
        type: 'Length',
        id: 2971,
        description: 'Byte length of encoded (non-ASCII characters) EncodedSettlStatusReasonText(2972) field.',
    },
    {
        name: 'EncodedSettlStatusReasonText',
        abbrName: 'EncSettlStatRsnTxt',
        addedEP: '281',
        added: 'FIX.Latest',
        type: 'data',
        id: 2972,
        lengthId: '2971',
        description:
            'Encoded (non-ASCII characters) representation of the SettlStatusReasonText(2970) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) representation should also be specified in the SettlStatusReasonText(2970) field.',
    },
    {
        name: 'SettlStatusReportStatus',
        abbrName: 'Stat',
        addedEP: '281',
        added: 'FIX.Latest',
        type: 'SettlStatusReportStatusCodeSet',
        id: 2973,
        description: 'Status of the report being responded to.',
    },
    {
        name: 'AllocGroupSubQtyID',
        abbrName: 'GrpSubQtyID',
        addedEP: '285',
        added: 'FIX.Latest',
        type: 'String',
        id: 2974,
        description: 'Identifier for quantity subgroup assigned by the clearinghouse.',
    },
    {
        name: 'NoAllocGroupSubQtys',
        addedEP: '285',
        added: 'FIX.Latest',
        type: 'NumInGroup',
        id: 2975,
        description: 'Indicates number of subgroups in an allocation group.',
    },
    {
        name: 'AllocGroupSubQty',
        abbrName: 'Qty',
        addedEP: '285',
        added: 'FIX.Latest',
        type: 'Qty',
        id: 2976,
        description: 'Total quantity in the subgroup of an allocation group.',
    },
    {
        name: 'AllocGroupSubQtyOffset',
        abbrName: 'QtyOfst',
        addedEP: '285',
        added: 'FIX.Latest',
        type: 'Qty',
        id: 2977,
        description: 'Change in quantity in the subgroup of an allocation group.',
    },
    {
        name: 'AllocGroupRemainingSubQty',
        abbrName: 'RemQty',
        addedEP: '285',
        added: 'FIX.Latest',
        type: 'Qty',
        id: 2978,
        description: 'Remaining quantity in the subgroup of an allocation group.',
    },
    {
        name: 'NoAllocGroupSubQtyAttributes',
        addedEP: '285',
        added: 'FIX.Latest',
        type: 'NumInGroup',
        id: 2979,
        description: 'Indicates number of trade attributes used to define a subgroup in an allocation group.',
    },
    {
        name: 'AllocGroupSubQtyType',
        abbrName: 'Typ',
        unionDataType: 'Reserved100Plus',
        addedEP: '285',
        added: 'FIX.Latest',
        type: 'AllocGroupSubQtyTypeCodeSet',
        id: 2980,
        description: 'Type of trade attribute defining a subgroup in an allocation group.',
    },
    {
        name: 'AllocGroupSubQtyValue',
        abbrName: 'Val',
        addedEP: '285',
        added: 'FIX.Latest',
        type: 'String',
        id: 2981,
        description: 'Value of the trade attribute defining a subgroup in an allocation group.',
    },
    {
        name: 'MaturityFrequencyUnit',
        abbrName: 'MatFreqUnit',
        addedEP: '287',
        added: 'FIX.Latest',
        type: 'TimeUnitCodeSet',
        id: 2982,
        description:
            'Time unit associated with the minimum frequency of the instrument maturity intervals.\n\nUsage note: When FlexibleIndicator(1244)=Y and the maturity date is user-defined, set MaturityFrequencyUnit(2982)=F (Flexible).',
    },
    {
        name: 'MaturityFrequencyPeriod',
        abbrName: 'MatFreqPeriod',
        addedEP: '287',
        added: 'FIX.Latest',
        type: 'int',
        id: 2983,
        description: 'Time unit multiplier for the minimum frequency of the instrument maturity intervals.',
    },
    {
        name: 'UnderlyingMaturityFrequencyUnit',
        abbrName: 'MatFreqUnit',
        addedEP: '287',
        added: 'FIX.Latest',
        type: 'TimeUnitCodeSet',
        id: 2984,
        description:
            'Time unit associated with the minimum frequency of the instrument maturity intervals.\n\nUsage note: When UnderlyingFlexibleIndicator(2035)=Y and the underlying maturity is user-defined, set UnderlyingMaturityFrequencyUnit(2984)=F (Flexible).',
    },
    {
        name: 'UnderlyingMaturityFrequencyPeriod',
        abbrName: 'MatFreqPeriod',
        addedEP: '287',
        added: 'FIX.Latest',
        type: 'int',
        id: 2985,
        description: 'Time unit multiplier for the minimum frequency of the instrument maturity intervals.',
    },
    {
        name: 'LegMaturityFrequencyUnit',
        abbrName: 'MatFreqUnit',
        addedEP: '287',
        added: 'FIX.Latest',
        type: 'TimeUnitCodeSet',
        id: 2986,
        description:
            'Time unit associated with the minimum frequency of the instrument maturity intervals.\n\nUsage note: When LegFlexibleIndicator(2202)=Y and the leg maturity is user-defined, set LegMaturityFrequencyUnit(2986)=F (Flexible).',
    },
    {
        name: 'LegMaturityFrequencyPeriod',
        abbrName: 'MatFreqPeriod',
        addedEP: '287',
        added: 'FIX.Latest',
        type: 'int',
        id: 2987,
        description: 'Time unit multiplier for the minimum frequency of the instrument maturity intervals.',
    },
    {
        name: 'SecurityRiskMetricsReportID',
        abbrName: 'RptID',
        addedEP: '288',
        added: 'FIX.Latest',
        type: 'String',
        id: 2988,
        description: 'Unique identifier for the SecurityRiskMetricsReport(35=EG) message.',
    },
    {
        name: 'RiskMetricsSecurityGroup',
        abbrName: 'MtrcsSecGrp',
        addedEP: '288',
        added: 'FIX.Latest',
        type: 'String',
        id: 2989,
        description: 'Describes a group of related instruments for which risk metrics are provided.',
    },
    {
        name: 'RiskMetricsSecuritySubGroup',
        abbrName: 'MtrcsSecSubGrp',
        addedEP: '288',
        added: 'FIX.Latest',
        type: 'String',
        id: 2990,
        description: 'Describes a sub-group of a group identified by RiskMetricsSecurityGroup(2989).',
    },
    {
        name: 'MetricsCalculationPriceSource',
        abbrName: 'MtrcsCalcPxSrc',
        addedEP: '288',
        added: 'FIX.Latest',
        type: 'MetricsCalculationPriceSourceCodeSet',
        id: 2993,
        description:
            'Specifies the source of the price(s) of the security used in the calculation of the metrics or analytics data.',
    },
    {
        name: 'AssetValuationModel',
        abbrName: 'AssetValModel',
        addedEP: '288',
        added: 'FIX.Latest',
        type: 'AssetValuationModelCodeSet',
        id: 2994,
        description: 'Identifies the model used for asset valuation or pricing calculations.',
    },
    {
        name: 'NoSecurityRiskMetrics',
        addedEP: '288',
        added: 'FIX.Latest',
        type: 'NumInGroup',
        id: 2995,
        description: 'Number of instruments with security risk metrics data.',
    },
    {
        name: 'Gamma',
        abbrName: 'Gamma',
        addedEP: '288',
        added: 'FIX.Latest',
        type: 'float',
        id: 2996,
        description: 'The rate of change of Delta over time.',
    },
    {
        name: 'Rho',
        abbrName: 'Rho',
        addedEP: '288',
        added: 'FIX.Latest',
        type: 'float',
        id: 2997,
        description:
            "The security's value rate of change in response to a 1% change in (risk-free) interest rate. Measures the security's sensitivity to interest rate change.",
    },
    {
        name: 'Theta',
        abbrName: 'Theta',
        addedEP: '288',
        added: 'FIX.Latest',
        type: 'float',
        id: 2998,
        description: 'The security\'s price rate of change in relation to passage of time. Also known as "time decay".',
    },
    {
        name: 'Vega',
        abbrName: 'Vega',
        addedEP: '288',
        added: 'FIX.Latest',
        type: 'float',
        id: 2999,
        description: "The security's price sensitivity to change in volatility of the underlying asset price.",
    },
    {
        name: 'UnderlyingBidPx',
        abbrName: 'UndBidPx',
        addedEP: '288',
        added: 'FIX.Latest',
        type: 'Price',
        id: 2991,
        description: 'Bid price of the underlying instrument.',
    },
    {
        name: 'UnderlyingOfferPx',
        abbrName: 'UndOfrPx',
        addedEP: '288',
        added: 'FIX.Latest',
        type: 'Price',
        id: 2992,
        description: 'Offer price of the underlying instrument.',
    },
    {
        name: 'VolatilityTime',
        abbrName: 'VolTS',
        addedEP: '288',
        added: 'FIX.Latest',
        type: 'UTCTimestamp',
        id: 3000,
        description: 'Time at which volatility was computed.',
    },
    {
        name: 'BidVolatility',
        abbrName: 'BidVol',
        addedEP: '288',
        added: 'FIX.Latest',
        type: 'float',
        id: 3001,
        description: 'Volatility based on bid prices.',
    },
    {
        name: 'OfferVolatility',
        abbrName: 'OfrVol',
        addedEP: '288',
        added: 'FIX.Latest',
        type: 'float',
        id: 3002,
        description: 'Volatility based on offer prices.',
    },
    {
        name: 'MidVolatility',
        abbrName: 'MidVol',
        addedEP: '288',
        added: 'FIX.Latest',
        type: 'float',
        id: 3003,
        description: 'Volatility based on mid prices.',
    },
    {
        name: 'RelativeValueTimestamp',
        abbrName: 'TS',
        addedEP: '288',
        added: 'FIX.Latest',
        type: 'UTCTimestamp',
        id: 3004,
        description: 'Timestamp at which the relative valuation metric or analytic is calculated or captured.',
    },
    {
        name: 'NoTradeTypes',
        addedEP: '289',
        added: 'FIX.Latest',
        type: 'NumInGroup',
        id: 3005,
        description: 'Number of trade types in repeating group.',
    },
    {
        name: 'TradeType',
        abbrName: 'TrdTyp',
        unionDataType: 'Reserved1000Plus',
        addedEP: '289',
        added: 'FIX.Latest',
        type: 'TrdTypeCodeSet',
        id: 3006,
        description:
            'Type of trade assigned to a trade.\n\nNote: several enumerations of this field duplicate the enumerations in TradePriceCondition(1839) field. These may be deprecated from TradeType(3006) in the future. TradePriceCondition(1839) is preferred in messages that support it.',
    },
    {
        name: 'TradeSubType',
        abbrName: 'TrdSubTyp',
        unionDataType: 'Reserved1000Plus',
        addedEP: '289',
        added: 'FIX.Latest',
        type: 'TrdSubTypeCodeSet',
        id: 3007,
        description: 'Further qualification to the trade type defined in TradeType(3006).',
    },
    {
        name: 'NoAllocTrdRegTimestamps',
        addedEP: '291',
        added: 'FIX.Latest',
        type: 'NumInGroup',
        id: 3008,
        description: 'Number of allocation timestamps.',
    },
    {
        name: 'AllocTrdRegTimestamp',
        abbrName: 'TS',
        addedEP: '291',
        added: 'FIX.Latest',
        type: 'UTCTimestamp',
        id: 3009,
        description: 'Same as TrdRegTimestamp(769). Used to provide relevant timestamp for the allocation account.',
    },
    {
        name: 'AllocTrdRegTimestampType',
        abbrName: 'Typ',
        addedEP: '291',
        added: 'FIX.Latest',
        type: 'TrdRegTimestampTypeCodeSet',
        id: 3010,
        description:
            'Same as TrdRegTimestampType(770). Used to indicate the timestamp type relevant for the allocation account.',
    },
    {
        name: 'AllocTrdRegTimestampSrc',
        abbrName: 'Src',
        addedEP: '291',
        added: 'FIX.Latest',
        type: 'String',
        id: 3011,
        description:
            'Same as TrdRegTimestampOrigin(771). Used to indicate the "origin" or source of the timestamp relevant for the allocation account.',
    },
    {
        name: 'AlgoCertificateID',
        abbrName: 'CertID',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'String',
        id: 3012,
        description: 'Unique identifier for a certificate issued by an algorithmic trading firm.',
    },
    {
        name: 'AlgoCertificateDesc',
        abbrName: 'CertDesc',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'String',
        id: 3013,
        description: 'Description of a certificate issued by an algorithmic trading firm.',
    },
    {
        name: 'AlgoCertificateRequestID',
        abbrName: 'CertReqID',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'String',
        id: 3014,
        description: 'Unique identifier of the AlgoCertificateRequest(35=EH).',
    },
    {
        name: 'AlgoCertificateRequestRefID',
        abbrName: 'CertReqRefID',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'String',
        id: 3015,
        description: 'Reference identifier of the AlgoCertificateRequest(35=EH).',
    },
    {
        name: 'AlgoCertificateRequestTransType',
        abbrName: 'TxnTyp',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'AlgoCertificateRequestTransTypeCodeSet',
        id: 3016,
        description: 'Identifies the message transaction type.',
    },
    {
        name: 'AlgoCertificateRequestStatus',
        abbrName: 'ReqStat',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'AlgoCertificateRequestStatusCodeSet',
        id: 3017,
        description: 'Status of the AlgoCertificateRequest(35=EH) message being responded to.',
    },
    {
        name: 'AlgoCertificateReportID',
        abbrName: 'CertRptID',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'String',
        id: 3018,
        description: 'Unique identifier of the AlgoCertificateReport(35=EJ).',
    },
    {
        name: 'AlgoCertificateReportRefID',
        abbrName: 'CertRptRefID',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'String',
        id: 3019,
        description: 'Reference identifier of the AlgoCertificateReport(35=EJ).',
    },
    {
        name: 'AlgoCertificateReportTransType',
        abbrName: 'TxnTyp',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'AlgoCertificateReportTransTypeCodeSet',
        id: 3020,
        description: 'Identifies the message transaction type.',
    },
    {
        name: 'AlgoCertificateReportStatus',
        abbrName: 'RptStat',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'AlgoCertificateReportStatusCodeSet',
        id: 3021,
        description: 'Status of the report being responded to.',
    },
    {
        name: 'AlgoCertificateStatus',
        abbrName: 'CertStat',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'AlgoCertificateStatusCodeSet',
        id: 3022,
        description: 'Status of the certification as provided by the regulatory authority.',
    },
    {
        name: 'ApprovalTime',
        abbrName: 'AprvlTm',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'UTCTimestamp',
        id: 3023,
        description: 'Date and time the details within the message have been approved.',
    },
    {
        name: 'AlgoTestDesc',
        abbrName: 'TstDesc',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'String',
        id: 3024,
        description: 'Description of means of testing for an algorithm.',
    },
    {
        name: 'NoAlgoSystemModules',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'NumInGroup',
        id: 3025,
        description: 'Number of components making up a system for algorithmic trading.',
    },
    {
        name: 'AlgoSystemModuleName',
        abbrName: 'Name',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'String',
        id: 3026,
        description: 'Name of the component of a system for algorithmic trading.',
    },
    {
        name: 'AlgoSystemModuleVersion',
        abbrName: 'Ver',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'String',
        id: 3027,
        description: 'Version (e.g. build or commit number) of the component of a system for algorithmic trading.',
    },
    {
        name: 'NoTestScenarios',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'NumInGroup',
        id: 3028,
        description: 'Number of test scenarios for an algorithmic trading system.',
    },
    {
        name: 'TestScenarioID',
        abbrName: 'ID',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'String',
        id: 3029,
        description: 'Unique identifier of a test scenario for a software system.',
    },
    {
        name: 'TestScenarioStatus',
        abbrName: 'Stat',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'TestSuiteStatusCodeSet',
        id: 3030,
        description: 'Identifies the overall result of a test scenario identified by TestScenarioID(3029).',
    },
    {
        name: 'TestScenarioStartTime',
        abbrName: 'StartTm',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'UTCTimestamp',
        id: 3031,
        description: 'Starting date and time of test scenario execution for a software system.',
    },
    {
        name: 'TestScenarioEndTime',
        abbrName: 'EndTm',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'UTCTimestamp',
        id: 3032,
        description: 'Ending date and time of test scenario execution for a software system.',
    },
    {
        name: 'MDOriginDesc',
        abbrName: 'MDOrigDesc',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'String',
        id: 3033,
        description: 'Description of the origin of the market data.',
    },
    {
        name: 'MDOriginTime',
        abbrName: 'MDOrigTm',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'UTCTimestamp',
        id: 3034,
        description: 'Date and time of the market data.',
    },
    {
        name: 'TestStepGroupID',
        abbrName: 'TstStepGrpID',
        updated: 'FIX.Latest',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'String',
        updatedEP: '295',
        id: 3035,
        description: 'Unique identifier for the group of test steps constituting a test scenario.',
    },
    {
        name: 'NoTestSteps',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'NumInGroup',
        id: 3036,
        description: 'Number of test steps.',
    },
    {
        name: 'TestStepID',
        abbrName: 'ID',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'String',
        id: 3037,
        description: 'Unique identifier of a test step.',
    },
    {
        name: 'TestStepDesc',
        abbrName: 'Desc',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'String',
        id: 3038,
        description: 'Description of a test step.',
    },
    {
        name: 'TestStepStartTime',
        abbrName: 'StartTm',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'UTCTimestamp',
        id: 3039,
        description: 'Starting time of a test step.',
    },
    {
        name: 'TestStepStartOffsetPeriod',
        abbrName: 'StartOfstPeriod',
        updated: 'FIX.Latest',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'int',
        updatedEP: '295',
        id: 3040,
        description:
            'Time unit multiplier for the starting time of a test step relative to the starting time of a test scenario.',
    },
    {
        name: 'TestStepStartOffsetUnit',
        abbrName: 'StartOfstUnit',
        updated: 'FIX.Latest',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'OrderDelayUnitCodeSet',
        updatedEP: '295',
        id: 3041,
        description:
            'Time unit associated with the starting time of a test step relative to the starting time of a test scenario.',
    },
    {
        name: 'TestStepEndTime',
        abbrName: 'EndTm',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'UTCTimestamp',
        id: 3042,
        description: 'Ending time of a test step.',
    },
    {
        name: 'TestStepEndOffsetPeriod',
        abbrName: 'EndOfstPeriod',
        updated: 'FIX.Latest',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'int',
        updatedEP: '295',
        id: 3043,
        description:
            'Time unit multiplier for the ending time of a test step relative to the starting time of a test scenario.',
    },
    {
        name: 'TestStepEndOffsetUnit',
        abbrName: 'EndOfstUnit',
        updated: 'FIX.Latest',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'OrderDelayUnitCodeSet',
        updatedEP: '295',
        id: 3044,
        description:
            'Time unit associated with the starting time of a test step relative to the ending time of a test scenario.',
    },
    {
        name: 'NoTestStepParameters',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'NumInGroup',
        id: 3045,
        description: 'Number of test step parameters.',
    },
    {
        name: 'TestStepParameterName',
        abbrName: 'PrmName',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'String',
        id: 3046,
        description: 'Name of the test step parameter.',
    },
    {
        name: 'TestStepParameterType',
        abbrName: 'PrmTyp',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'StrategyParameterTypeCodeSet',
        id: 3047,
        description: 'Datatype of the test step parameter.',
    },
    {
        name: 'TestStepParameterValue',
        abbrName: 'PrmVal',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'String',
        id: 3048,
        description: 'Value of the test step parameter.',
    },
    {
        name: 'NoTestSystemModules',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'NumInGroup',
        id: 3049,
        description: 'Number of components making up a testing system.',
    },
    {
        name: 'TestSystemModuleName',
        abbrName: 'Name',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'String',
        id: 3050,
        description: 'Name of the component of a testing system.',
    },
    {
        name: 'TestSystemModuleVersion',
        abbrName: 'Ver',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'String',
        id: 3051,
        description: 'Version (e.g. build or commit number) of the component of a testing system.',
    },
    {
        name: 'NoTestMeasures',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'NumInGroup',
        id: 3052,
        description: 'Number of results for a test scenario.',
    },
    {
        name: 'TestMeasureName',
        abbrName: 'Name',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'String',
        id: 3053,
        description: 'Name of a test measure.',
    },
    {
        name: 'TestMeasureDesc',
        abbrName: 'Desc',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'String',
        id: 3054,
        description: 'Description of a test measure.',
    },
    {
        name: 'TestMeasureType',
        abbrName: 'Typ',
        unionDataType: 'Reserved100Plus',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'StrategyParameterTypeCodeSet',
        id: 3055,
        description: 'Datatype of the metric being used for a test.',
    },
    {
        name: 'TestMeasurePrecision',
        abbrName: 'Prcsn',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'int',
        id: 3056,
        description: 'Number of decimal places for TestMeasureType(3055).',
    },
    {
        name: 'TestMeasureResult',
        abbrName: 'Rslt',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'TestSuiteStatusCodeSet',
        id: 3057,
        description: 'Identifies the result of an individual test based on a measure.',
    },
    {
        name: 'TestThresholdType',
        abbrName: 'ThresholdTyp',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'TestThresholdTypeCodeSet',
        id: 3058,
        description:
            'Identifies whether the value of a measure needs to be over or under a specific threshold to be successful.',
    },
    {
        name: 'TestWarningLevelValue',
        abbrName: 'WarnLvlVal',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'float',
        id: 3059,
        description: 'Value of the measure upon which a warning is issued for the test.',
    },
    {
        name: 'TestFailLevelValue',
        abbrName: 'FailLvlVal',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'float',
        id: 3060,
        description: 'Value of the measure upon which the test is considered to have failed.',
    },
    {
        name: 'TestPeakLevelValue',
        abbrName: 'PeakLvlVal',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'float',
        id: 3061,
        description: 'Peak value of the measure achieved in testing.',
    },
    {
        name: 'TestSuiteRequestID',
        abbrName: 'TstSteReqID',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'String',
        id: 3062,
        description: 'Unique identifier of the TestSuiteDefinitionRequest(35=EL).',
    },
    {
        name: 'TestSuiteRequestRefID',
        abbrName: 'TstSteReqRefID',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'String',
        id: 3063,
        description: 'Reference identifier of the TestSuiteDefinitionRequest(35=EL).',
    },
    {
        name: 'TestSuiteRequestTransType',
        abbrName: 'TxnTyp',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'TestSuiteRequestTransTypeCodeSet',
        id: 3064,
        description: 'Identifies the message transaction type.',
    },
    {
        name: 'TestSuiteRequestStatus',
        abbrName: 'ReqStat',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'TestSuiteRequestStatusCodeSet',
        id: 3065,
        description: 'Status of the TestSuiteDefinitionRequest(35=EL) message being responded to.',
    },
    {
        name: 'TestActionRequestID',
        abbrName: 'ReqID',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'String',
        id: 3066,
        description: 'Unique identifier of the TestActionRequest(35=EN).',
    },
    {
        name: 'TestActionType',
        abbrName: 'ActnTyp',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'TestActionTypeCodeSet',
        id: 3067,
        description: 'Specifies the type of action to take or that was taken for a given test suite.',
    },
    {
        name: 'TestActionRequestStatus',
        abbrName: 'ReqStat',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'TestActionRequestStatusCodeSet',
        id: 3068,
        description: 'Status of the TestActionRequest(35=EN) message being responded to.',
    },
    {
        name: 'TestSuiteActivityState',
        abbrName: 'TstSteActvtySt',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'TestSuiteActivityStateCodeSet',
        id: 3069,
        description: 'Specifies the activity state the test suite is in.',
    },
    {
        name: 'TestSuiteStatus',
        abbrName: 'TstSteStat',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'TestSuiteStatusCodeSet',
        id: 3070,
        description: 'Identifies the overall test result of a group of individual test scenarios.',
    },
    {
        name: 'TestActionReportID',
        abbrName: 'RptID',
        addedEP: '292',
        added: 'FIX.Latest',
        type: 'String',
        id: 3071,
        description: 'Identifier of the test action report.',
    },
    {
        name: 'RateSourceSymbol',
        abbrName: 'Sym',
        addedEP: '293',
        added: 'FIX.Latest',
        type: 'String',
        id: 3072,
        description:
            'Identifies the currency pair/symbol that the instance of the rate source information is applicable for the fixing.',
    },
    {
        name: 'FXBenchmark',
        abbrName: 'FxBnchmk',
        addedEP: '293',
        added: 'FIX.Latest',
        type: 'FXBenchmarkCodeSet',
        id: 3073,
        description:
            'The source of where to obtain the FX benchmark rate to use for fixing the rate.\n\nThe value in this field can be different from RateSource(1446). For example, "Bloomberg" can be the reference source identified in RateSource(1446), and FXBenchmark(3073) can be "central bank" - what this says is to use Bloomberg to look up/reference the published central bank rate. Likewise, the BFIX rate for fixing (FXBenchmark(3073)=1 (Bloomberg)) can be sourced from Reuters (RateSource(1446)=1 (Reuters)). If the source for benchmark fixing rate is the same as the reference source (RateSource(1446)), this field, FXBenchmark(3073), can be omitted.',
    },
    {
        name: 'FXBenchmarkDate',
        abbrName: 'FxBnchmkDt',
        addedEP: '293',
        added: 'FIX.Latest',
        type: 'LocalMktDate',
        id: 3074,
        description:
            'The local date of the FX rate fixing. The time applicable on the fixing date is specified in FXBenchmarkTime(3075).',
    },
    {
        name: 'FXBenchmarkTime',
        abbrName: 'FxBnchmkTm',
        addedEP: '293',
        added: 'FIX.Latest',
        type: 'LocalMktTime',
        id: 3075,
        description:
            'The local time of the FX rate fixing. The date applicable for the fixing time is specified in FXBenchmarkDate(3074).',
    },
    {
        name: 'FXBenchmarkBusinessCenter',
        abbrName: 'FxBnchmkCtr',
        addedEP: '293',
        added: 'FIX.Latest',
        type: 'String',
        id: 3076,
        description:
            'A business center whose calendar is used for date/time adjustment. See https://www.fpml.org/coding-scheme/business-center to download the current (ISDA/FpML) standard 4-character code values for business center identification.',
    },
    {
        name: 'AlgoCertificateRequestType',
        abbrName: 'ReqTyp',
        addedEP: '295',
        added: 'FIX.Latest',
        type: 'AlgoCertificateRequestTypeCodeSet',
        id: 3077,
        description: 'Specifies the type of business event related to an algo certification request.',
    },
    {
        name: 'AlgoCertificateReportType',
        abbrName: 'RptTyp',
        addedEP: '295',
        added: 'FIX.Latest',
        type: 'AlgoCertificateReportTypeCodeSet',
        id: 3078,
        description: 'Specifies the type of business event related to an algo certification report.',
    },
    {
        name: 'TestScenarioGroupID',
        abbrName: 'TstScnroGrpID',
        addedEP: '295',
        added: 'FIX.Latest',
        type: 'String',
        id: 3079,
        description: 'Unique identifier for the group of test scenarios constituting a test suite.',
    },
    {
        name: 'AlgoSystemModuleLastUpdateTime',
        abbrName: 'LastUpdateTm',
        addedEP: '295',
        added: 'FIX.Latest',
        type: 'UTCTimestamp',
        id: 3080,
        description: 'Support Timestamp of last update to Algo System Module.',
    },
    {
        name: 'TestSystemModuleLastUpdateTime',
        abbrName: 'LastUpdateTm',
        addedEP: '295',
        added: 'FIX.Latest',
        type: 'UTCTimestamp',
        id: 3081,
        description: 'Support Timestamp of last update to Algo Test System Module.',
    },
    {
        name: 'NoTestOrders',
        addedEP: '295',
        added: 'FIX.Latest',
        type: 'NumInGroup',
        id: 3082,
        description: 'Number of orders for testing.',
    },
    {
        name: 'TestOrderID',
        abbrName: 'ID',
        addedEP: '295',
        added: 'FIX.Latest',
        type: 'String',
        id: 3083,
        description: 'Identifier of a test order.',
    },
    {
        name: 'TestOrderSymbol',
        abbrName: 'Sym',
        addedEP: '295',
        added: 'FIX.Latest',
        type: 'String',
        id: 3084,
        description: 'Used for the security symbol of a test order.\n\nSee Symbol(55) field for description.',
    },
    {
        name: 'TestOrderSecurityID',
        abbrName: 'SecID',
        addedEP: '295',
        added: 'FIX.Latest',
        type: 'String',
        id: 3085,
        discriminatorId: '3086',
        description: 'Used for the security identifier of a test order.\n\nSee Security(48) field for description.',
    },
    {
        name: 'TestOrderSecurityIDSource',
        abbrName: 'SecIDSrc',
        unionDataType: 'Reserved100Plus',
        addedEP: '295',
        added: 'FIX.Latest',
        type: 'String',
        id: 3086,
        description:
            'Used for the source of the security identifier of a test order.\n\nSee SecurityIDSource(22) field for description.',
    },
    {
        name: 'TestOrderPrice',
        abbrName: 'Px',
        addedEP: '295',
        added: 'FIX.Latest',
        type: 'Price',
        id: 3087,
        description: 'Used for the price of a test order.\n\nSee Price(44) field for description.',
    },
    {
        name: 'TestOrderPriceType',
        abbrName: 'PxTyp',
        addedEP: '295',
        added: 'FIX.Latest',
        type: 'PriceTypeCodeSet',
        id: 3088,
        description: 'Type of price of TestOrderPrice(3087).',
    },
    {
        name: 'TestOrderQty',
        abbrName: 'Qty',
        addedEP: '295',
        added: 'FIX.Latest',
        type: 'Qty',
        id: 3089,
        description: 'Used for the quantity of a test order.\n\nSee OrderQty(80) field for description.',
    },
    {
        name: 'TestOrderOffsetPeriod',
        abbrName: 'OfstPeriod',
        addedEP: '295',
        added: 'FIX.Latest',
        type: 'int',
        id: 3090,
        description:
            'Time unit multiplier for the effective time of an order relative to the starting time of a test scenario.',
    },
    {
        name: 'TestOrderOffsetUnit',
        abbrName: 'OfstUnit',
        addedEP: '295',
        added: 'FIX.Latest',
        type: 'OrderDelayUnitCodeSet',
        id: 3091,
        description:
            'Time unit associated with the effective time of an order relative to the starting time of a test scenario.',
    },
    {
        name: 'NoTestGatewayDetails',
        addedEP: '295',
        added: 'FIX.Latest',
        type: 'NumInGroup',
        id: 3092,
        description: 'Number of test gateway details.',
    },
    {
        name: 'TestGatewayDetailName',
        abbrName: 'Name',
        addedEP: '295',
        added: 'FIX.Latest',
        type: 'String',
        id: 3093,
        description: 'Name of test gateway information.',
    },
    {
        name: 'TestGatewayDetailType',
        abbrName: 'Typ',
        unionDataType: 'Reserved100Plus',
        addedEP: '295',
        added: 'FIX.Latest',
        type: 'TestGatewayDetailTypeCodeSet',
        id: 3094,
        description: 'Type of test gateway information.',
    },
    {
        name: 'TestGatewayDetailValue',
        abbrName: 'Val',
        addedEP: '295',
        added: 'FIX.Latest',
        type: 'String',
        id: 3095,
        description: 'Value of test gateway information.',
    },
    {
        name: 'TestGatewayMarketID',
        abbrName: 'MktID',
        addedEP: '295',
        added: 'FIX.Latest',
        type: 'Exchange',
        id: 3096,
        description: 'Execution venue of test system.',
    },
];

export const FIELDS: ISpecFields[] = batch1.concat(batch2, batch3, batch4, batch5, batch6, batch7, batch8);
